webpackJsonp([9],{

/***/ "+9s1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eps_vue__ = __webpack_require__("GTEX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cb4f134_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eps_vue__ = __webpack_require__("8FxQ");
function injectStyle (ssrContext) {
  __webpack_require__("2Af4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8cb4f134"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cb4f134_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+CoK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_json_excel__ = __webpack_require__("+Rp4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__global_services_formatear_pesos__ = __webpack_require__("1byD");























__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_16_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  data: function data() {
    return {
      paciente: "",
      ip: "https://avanti-erp.com/",
      pacienteSelect: [],
      searchQuery: "",
      fechaInicial: "",
      fechaFinal: "",
      listUsers: [],
      arrayEps: [],
      categoria: "Todas",
      queriedData2: [],
      form: {
        fecha: "",
        monto: "",
        categoria: "Prestamo",
        comentario: "",
        usuario: "",
        eps: "",
        tipo: ""
      },
      fechaActual: "",
      tableColumns: [{
        prop: "entrega",
        label: "Usuario que entrega",
        minWidth: 100
      }, {
        prop: "tipo",
        label: "Tipo de informe",
        minWidth: 100
      }, {
        prop: "creado",
        label: "Fecha y hora de exportación",
        minWidth: 100
      }, {
        prop: "resumen",
        label: "Resumen",
        minWidth: 100
      }, {
        prop: "concepto",
        label: "Concepto",
        minWidth: 100
      }, {
        prop: "recomendacion",
        label: "Recomendaciones",
        minWidth: 100
      }],
      json_fields: {
        paciente: "nombrePaciente",
        terapeuta: "terapeuta",
        fecha: "fecha"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      SedesProgramacion: [],
      sede: "Sede Principal",
      rol: "",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  methods: {
    formatearPesosColombianos: __WEBPACK_IMPORTED_MODULE_18__global_services_formatear_pesos__["a" /* default */],
    prepararRegistrar: function prepararRegistrar() {
      this.$modal.show("registrar-gasto");
    },
    obtenerInformacionDeEvoluciones: function obtenerInformacionDeEvoluciones(fechaInicial, fechaFinal) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sede, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.$modal.show("carga");
                sede = localStorage.getItem("sede");
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_13_src_global_services_axiosInstance__["a" /* default */].get("api/obtener-log-informe/" + _this2.paciente + "/" + fechaInicial + "/" + fechaFinal);

              case 5:
                response = _context.sent;

                _this2.queriedData2 = response.data.data;
                _this2.json_data = response.data.data;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.log("Error al obtener los datos:" + _context.t0);

              case 13:
                _context.prev = 13;

                _this2.$modal.hide("carga");
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10, 13, 16]]);
      }))();
    },
    getClass: function getClass(column, row) {
      if (column.prop === "valor") {
        if (row.tipo === "Efectivo") {
          return "low-percentage";
        }

        if (row.tipo === "Transferencia") {
          return "medium-percentage";
        }
      }
      return "";
    },
    getInformacion: function getInformacion() {
      var _this3 = this;

      var BASE_URL = this.ip + "api/pacientesSelect";
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get(BASE_URL).then(function (res) {
        _this3.pacienteSelect = res.data.data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    this.getInformacion();
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de evoluciones sin logro de objetivo";
  }
});

/***/ }),

/***/ "+Hhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Programacion_vue__ = __webpack_require__("U4cv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a5de42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Programacion_vue__ = __webpack_require__("w7CO");
function injectStyle (ssrContext) {
  __webpack_require__("91v4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27a5de42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Programacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a5de42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Programacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+L4t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            codigo: '',
            ip: 'https://avanti-erp.com/',
            numeroAutorizacion: 0,
            pacienteAutorizacion: '',
            entidadAutorizacion: '',
            fechaAutorizacion: '',
            fechaVencimientoAutorizacion: '',
            id: 0,
            tipo: 0,
            bolsa: 0
        };
    },
    methods: {
        buscarAutorizacion: function buscarAutorizacion() {
            var _this = this;

            var BASE_URL = this.ip + 'api/buscarAutorizacion/' + this.codigo;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(BASE_URL).then(function (res) {
                if (res.data.mensaje == 'Cargada') {
                    console.log('data', res.data.data);
                    _this.numeroAutorizacion = res.data.data[0].OrdCod;
                    _this.pacienteAutorizacion = res.data.data[0].PacApe1 + ' ' + res.data.data[0].PacNom1;
                    _this.entidadAutorizacion = res.data.data[0].EpsNom;
                    _this.fechaAutorizacion = res.data.data[0].OrdFec;
                    _this.fechaVencimientoAutorizacion = res.data.data[0].OrdVen;
                    _this.bolsa = res.data.data[0].OrdBol;
                    _this.id = res.data.data[0].OrdIde;
                    _this.tipo = res.data.data[0].OrdFor;
                } else {
                    alert('No se encontró una Autorización con este código');
                }
            });
        },
        cancelarOrden: function cancelarOrden() {
            var _this2 = this;

            var BASE_URL = this.ip + 'api/cancelarOrdenMedica/' + this.numeroAutorizacion + '/' + this.id;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(BASE_URL).then(function (res) {
                if (res.data.mensaje == 'No se puede cancelar') {
                    alert('Esta orden no se puede cancelar porque tiene autorizaciones cargadas');
                } else if (res.data.mensaje == 'Cancelado con éxito') {
                    alert('Cancelada con éxito');
                    _this2.numeroAutorizacion = 0;
                }
            }).catch(function (err) {
                console.log(err);
            });
        },

        ajustar: function ajustar() {
            var _this3 = this;

            var BASE_URL = this.ip + 'api/ajustar';
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(BASE_URL, {

                bolsa: this.bolsa,
                vencimiento: this.fechaVencimientoAutorizacion,
                id: this.id

            }).then(function (res) {
                if (res.data.mensaje == 'Ajustado con éxito') {
                    alert('Ajustado con éxito');
                    _this3.buscarAutorizacion();
                } else {
                    alert('Error al ajustar');
                }
            }).catch(function (err) {
                console.log(err);
            });
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "+M8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',{attrs:{"type":"sidebar","sidebar-links":_vm.$sidebar.sidebarLinks}},[_c('user-menu')],1),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar.apply(null, arguments)}}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+g8l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('center',[_c('h3',[_vm._v("\n          Reporte de órdenes médicas\n          "),_c('i',{staticClass:"fa fa-folder"})])]),_vm._v(" "),_c('hr')],1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fecha_inicial),expression:"fecha_inicial"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fecha_inicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fecha_inicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Fecha final:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fecha_final),expression:"fecha_final"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fecha_final)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fecha_final=$event.target.value}}})]),_vm._v(" "),(_vm.rol == 1)?_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Sede:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sede),expression:"sede"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sede=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.SedesProgramacion),function(sede){return _c('option',{key:sede.sede,domProps:{"value":sede.sede}},[_vm._v("\n                "+_vm._s(sede.sede)+"\n              ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("d")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.getAutorizaciones()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Buscar\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("d")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.json_data!='')?_c('download-excel',{staticClass:"btn btn-primary btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"My Worksheet","name":'Reporte-ordenes'+'-'+_vm.fecha_inicial+'-'+_vm.fecha_final}},[_vm._v("\n              Exportar a excel\n              ")]):_vm._e()],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.autorizaciones,"border":""}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"else":""}})}),1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+jLu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card",staticStyle:{"padding":"5px 10px 5px","border-radius":"10px"}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('strong',{staticStyle:{"font-size":"20px"}},[_vm._v("Información de pagos a terapeutas")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"darkgray"}},[_vm._v("Información por terapeuta")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"darkgray"}},[_vm._v("Resumen: "),_c('span',{staticStyle:{"color":"green"}},[_c('i',{staticClass:"fa fa-arrow-up",staticStyle:{"color":"green"}}),_vm._v(" "+_vm._s(_vm.resumenGanancias))]),_vm._v(" || "),_c('span',{staticStyle:{"color":"red"}},[_c('i',{staticClass:"fa fa-arrow-down",staticStyle:{"color":"red"}}),_vm._v(" "+_vm._s(_vm.resumenDeucciones))])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"max-height":"400px","overflow":"scroll","overflow-x":"hidden"}},[_c('div',{staticClass:"row"},_vm._l((_vm.informacionNomina),function(persona){return _c('div',{key:persona.nombre,staticClass:"col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"border":"1px darkgray solid"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v(_vm._s(persona.nombre))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("NOMBRE COMPLETO")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('i',{staticClass:"fa fa-arrow-up",staticStyle:{"color":"green"}}),_vm._v(" "),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(persona.ingreso))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("SESIONES REALIZADAS")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('i',{staticClass:"fa fa-arrow-up",staticStyle:{"color":"green"}}),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(persona.adicional))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("INGRESOS ADICIONALES")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('i',{staticClass:"fa fa-arrow-down",staticStyle:{"color":"red"}}),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(persona.deducciones))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("DEDUCCIONES")])])])])])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+tMB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programacion_vue__ = __webpack_require__("CEqL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22dd463d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_programacion_vue__ = __webpack_require__("V6+9");
function injectStyle (ssrContext) {
  __webpack_require__("Twpb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22dd463d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_programacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22dd463d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_programacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/W7v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",staticStyle:{"padding":"2%"}},[_c('HeaderCard',{attrs:{"icon":"fa fa-file","title":"Reporte maestro de operaciones"}}),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('form',{attrs:{"action":""},on:{"submit":function($event){$event.preventDefault();return _vm.buscarInformacion()}}},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"Finicial"}},[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.fechaInicial),expression:"form.fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","id":"Finicial","required":""},domProps:{"value":(_vm.form.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "fechaInicial", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"Ffinal"}},[_vm._v("Fecha final:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.fechaFinal),expression:"form.fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","id":"Ffinal","required":""},domProps:{"value":(_vm.form.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "fechaFinal", $event.target.value)}}})]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill pull-right",staticStyle:{"border-radius":"5px"},attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"Reporte maestro de avanza","name":("reporte-maestro-de-operaciones-" + (_vm.form.fechaInicial) + "-" + (_vm.form.fechaFinal))}},[_vm._v("\n            Exportar a excel\n          ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('TableData',{attrs:{"dataRows":_vm.data,"colums":_vm.tableColumns}})],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("k")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-fill btn-success",staticStyle:{"border-radius":"5px"},attrs:{"type":"submit","value":"Buscar datos"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/icc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.abrirModal()}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Nuevo Material")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",staticStyle:{"width":"220%"},attrs:{"type":"search","placeholder":"Buscar material...","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped table-responsive",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":"","max-height":"400"}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"else":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":50,"label":"Estado"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.DomEst==1)?_c('p',{staticClass:"label label-success",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n                    activa\n                ")]):_c('p',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("Inactiva")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"fixed":"right","label":"Acc"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.DomEst==2)?_c('button',{staticClass:"btn btn-simple btn-xs btn-info btn-icon check",on:{"click":function($event){return _vm.activar(props.row)}}},[_c('i',{staticClass:"ti-check"})]):_c('button',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit",on:{"click":function($event){return _vm.desactivar(props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Mostrando del "+_vm._s(_vm.from + 1)+" al "+_vm._s(_vm.to)+" de "+_vm._s(_vm.total)+" registros")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"modal fade",class:{'mostrar' : _vm.modalRegistrar},attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header CM",staticStyle:{"padding":"8px"}},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.modalRegistrar=0}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.nuevoDominio.apply(null, arguments)}}},[_c('label',{attrs:{"for":""}},[_vm._v("Codigo:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Descripcion:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.descripcion),expression:"descripcion"}],staticClass:"form-control",attrs:{"required":"","cols":"30","rows":"3"},domProps:{"value":(_vm.descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descripcion=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v("\n                          Material de Psicología "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"36","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"36")},on:{"change":function($event){_vm.tipo="36"}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._v("\n                           Material de Terapia ocupacional "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"34","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"34")},on:{"change":function($event){_vm.tipo="34"}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v("\n                           Material de Fonoaudiología "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"33","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"33")},on:{"change":function($event){_vm.tipo="33"}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v("\n                           Material de Fisioterapia "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"32","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"32")},on:{"change":function($event){_vm.tipo="32"}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v("\n                           Material de Educación Especial"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"35","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"35")},on:{"change":function($event){_vm.tipo="35"}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Enviar Datos\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.limpiarFormulario()}}},[_c('i',{staticClass:"ti-close"})])])],1)]),_vm._v(" "),_c('center'),_vm._v(" "),_c('br')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                      Nuevo motivo de consulta\n                  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/n5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_aDashboard_nomina_cardnomina_vue__ = __webpack_require__("DBcq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__ = __webpack_require__("1byD");







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            informacionNomina: [],
            resumenGanancias: 0,
            resumenDeucciones: 0
        };
    },

    methods: {
        getNominaTerapeutas: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fechaInicial, fechaFinal) {
                var BASE_URL, response, data, resumenGananciasF, resumenDeuccionesF, dataFormated;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.$modal.show('carga');
                                BASE_URL = "api/informacion-dashboard-terapeuta/" + fechaInicial + "/" + fechaFinal + " ";
                                _context.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__["a" /* default */].get(BASE_URL);

                            case 5:
                                response = _context.sent;

                                if (response.data.status === true) {
                                    data = response.data.data;
                                    resumenGananciasF = 0;
                                    resumenDeuccionesF = 0;
                                    dataFormated = data.map(function (element) {
                                        resumenGananciasF += parseInt(element.Realizadas) + parseInt(element.adicionales);
                                        resumenDeuccionesF += parseInt(element.deducciones);
                                        return {
                                            nombre: element.terapeuta,
                                            ingreso: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(element.Realizadas),
                                            deducciones: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(element.deducciones),
                                            adicional: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(element.adicionales)
                                        };
                                    });

                                    this.resumenGanancias = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(resumenGananciasF);
                                    this.resumenDeucciones = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(resumenDeuccionesF);
                                    this.informacionNomina = dataFormated;
                                }
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](0);

                                console.log(_context.t0);

                            case 12:
                                _context.prev = 12;

                                this.$modal.hide('carga');
                                return _context.finish(12);

                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 9, 12, 15]]);
            }));

            function getNominaTerapeutas(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return getNominaTerapeutas;
        }()
    },
    components: {
        nomicard: __WEBPACK_IMPORTED_MODULE_2_src_components_aDashboard_nomina_cardnomina_vue__["a" /* default */]
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "0CPQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card'
});

/***/ }),

/***/ "0b5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gastosFijos_vue__ = __webpack_require__("31tF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ae95d0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gastosFijos_vue__ = __webpack_require__("uYdZ");
function injectStyle (ssrContext) {
  __webpack_require__("as5r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gastosFijos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ae95d0f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gastosFijos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0dmy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ingreso_vue__ = __webpack_require__("Doll");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc0df416_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ingreso_vue__ = __webpack_require__("1iY0");
function injectStyle (ssrContext) {
  __webpack_require__("P5wJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bc0df416"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ingreso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc0df416_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ingreso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1NcW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Reportes_modals_informacion_paciente_vue__ = __webpack_require__("72Uh");









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      url: "https://avanti-erp.com/",
      pacientes: [],
      paciente: 361,
      basic_information: null,
      proximas_sesiones: [],
      ultimas_sesiones: [],
      autorizacionesActivas: [],
      ordenesActivas: [],
      evoluciones: [],
      fechaAultimaAtencion: {},
      bolsaTotal: 0,
      indicadorAutorizacion: false,
      recomendacion: "",
      programaciones: {},

      fechaInicialEvoluciones: "",
      fechaFinalEvoluciones: "",

      MESSAGES: {
        NO_PACIENTE_SELECTED: "No ha seleccionado un paciente",
        NO_DATA_FOUND: "No hay datos para mostrar"
      }
    };
  },

  components: {
    modalPaciente: __WEBPACK_IMPORTED_MODULE_5__Reportes_modals_informacion_paciente_vue__["a" /* default */]
  },
  methods: {
    getPacientes: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.$modal.show("carga");
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__["a" /* default */].get("api/pacientesSelect");

              case 4:
                response = _context.sent;

                this.pacientes = response.data.data;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_crearAlerta__["a" /* default */])("Error", "No se pudo cargar la información de pacientes", "error");
                console.error(_context.t0);

              case 12:
                _context.prev = 12;

                this.$modal.hide("carga");
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8, 12, 15]]);
      }));

      function getPacientes() {
        return _ref.apply(this, arguments);
      }

      return getPacientes;
    }(),
    getInformation: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, EasyPieChart;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$modal.show("carga");
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__["a" /* default */].get("api/paciente-dashboard-information/" + this.paciente);

              case 4:
                response = _context2.sent;

                this.basic_information = response.data.information[0];
                this.proximas_sesiones = response.data.proximasSesiones;
                this.ultimas_sesiones = response.data.ultimasSesiones;
                this.autorizacionesActivas = response.data.autorizacionesActivas;
                this.ordenesActivas = response.data.ordenesActivas;
                this.evoluciones = response.data.evoluciones;
                this.bolsaTotal = this.obtenerBolsaTotal(this.autorizacionesActivas);
                this.indicadorAutorizacion = this.validarVencimientoAutorizacion(this.autorizacionesActivas);
                this.recomendacion = response.data.recomendacion;
                this.programaciones = response.data.estadisticasTerapias[0];
                this.programaciones.total = parseInt(response.data.estadisticasTerapias[0].Atendidas) + parseInt(response.data.estadisticasTerapias[0].Canceladas) + parseInt(response.data.estadisticasTerapias[0].SinAtencion);
                this.programaciones.porcentajeCumplimiento = (parseInt(response.data.estadisticasTerapias[0].Atendidas) / this.programaciones.total * 100).toFixed(2);
                if (this.ultimas_sesiones.length > 0) {
                  this.fechaAultimaAtencion = this.obtenerMesYDia(this.ultimas_sesiones[0].fecha);
                }

                _context2.next = 20;
                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "PeU/"));

              case 20:
                EasyPieChart = _context2.sent;

                this.renderChart(EasyPieChart);
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](1);

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_crearAlerta__["a" /* default */])("Error", "No se pudo cargar la información del paciente seleccionado", "error");
                console.error(_context2.t0);

              case 28:
                _context2.prev = 28;

                this.$modal.hide("carga");
                return _context2.finish(28);

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 24, 28, 31]]);
      }));

      function getInformation() {
        return _ref2.apply(this, arguments);
      }

      return getInformation;
    }(),
    mostrarModalPaciente: function mostrarModalPaciente() {
      this.$modal.show("informacion-paciente-dashboard");
    },
    renderChart: function renderChart(EasyPieChart) {
      this.chart = new EasyPieChart(this.$refs.chart, {
        lineWidth: 25,
        size: 160,
        scaleColor: false,
        trackColor: "#f3aed587",
        barColor: "#e3117dc9",
        animate: { duration: 1000, enabled: true }
      });
    },

    obtenerBolsaTotal: function obtenerBolsaTotal(autorizaciones) {
      return autorizaciones.reduce(function (total, item) {
        return total + item.bolsa;
      }, 0);
    },
    obtenerMesYDia: function obtenerMesYDia(fechaInput) {
      var mesesAbreviados = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

      var fecha = new Date(fechaInput);

      if (isNaN(fecha)) {
        throw new Error("Fecha inválida");
      }

      var mes = mesesAbreviados[fecha.getMonth()];
      var dia = fecha.getDate();
      var year = fecha.getFullYear();

      return {
        mes: mes,
        dia: dia,
        year: year
      };
    },

    validarVencimientoAutorizacion: function validarVencimientoAutorizacion(autorizacionesActivas) {
      var hoy = new Date();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(autorizacionesActivas), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var autorizacion = _step.value;

          var fechaVencimiento = new Date(autorizacion.fechaVencimiento);
          var diferenciaDias = Math.ceil((fechaVencimiento - hoy) / (1000 * 60 * 60 * 24));
          if (diferenciaDias <= 15) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    getEvoluciones: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var lokedInformation, response, evoluciones, i;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.evoluciones = [];
                this.$modal.show("carga");
                lokedInformation = 0;
                _context3.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__["a" /* default */].get("api/obtener-evoluciones/" + this.paciente + "/" + this.fechaInicialEvoluciones + "/" + this.fechaFinalEvoluciones + "/" + lokedInformation);

              case 6:
                response = _context3.sent;
                evoluciones = [];

                for (i = 0; i < response.data.data.length; i++) {
                  evoluciones.push({
                    terapeuta: response.data.data[i].nombres + " " + response.data.data[i].apellidos,
                    evolucion: response.data.data[i].Obs,
                    fecha: response.data.data[i].EvoFec
                  });
                }
                this.evoluciones = evoluciones;
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);

              case 15:
                _context3.prev = 15;

                this.$modal.hide("carga");
                return _context3.finish(15);

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 12, 15, 18]]);
      }));

      function getEvoluciones() {
        return _ref3.apply(this, arguments);
      }

      return getEvoluciones;
    }()
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.getPacientes();

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }))();
  }
});

/***/ }),

/***/ "1S6G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",class:{active: _vm.isActive || _vm.$route.fullPath.startsWith(_vm.link.path)},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"tag":"li"}},[(_vm.isMenu)?_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.collapseMenu}},[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name)+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path)?_vm._t("title",function(){return [_c(_vm.elementType(_vm.link, false),{tag:"component",class:{active: _vm.link.active},attrs:{"to":_vm.link.path,"target":_vm.link.target,"href":_vm.link.path}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-mini"},[_vm._v(_vm._s(_vm.link.name.substring(0, 1)))]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.link.name))])]:[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]],2)]}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1byD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var formatearPesosColombianos = function formatearPesosColombianos(valor) {
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0
  }).format(valor);
};

/* harmony default export */ __webpack_exports__["a"] = (formatearPesosColombianos);

/***/ }),

/***/ "1iY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",staticStyle:{"padding":"2%"}},[_vm._m(0),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-secondary btn-fill btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.abrirModal()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Buscar un paciente\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.limpiarFormulario()}}},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Limpiar Formulario\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"4%"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.agregarPaciente.apply(null, arguments)}}},[_c('span',{staticStyle:{"font-size":"19px","font-weight":"500"}},[_vm._v("Información personal")]),_vm._v(" "),_c('center',[_c('div',[_c('br'),_vm._v(" "),_c('div',{style:(_vm.estado==0?'height:190px;':'border: 0px #e3097e solid;   width: 170px; height: 150px;')},[_c('img',{staticClass:"img-thumbnail",attrs:{"src":_vm.fotoPaciente,"alt":"Cargar foto del paciente","id":"documentos"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{style:(_vm.estado==0?'display:none':'')},[_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"fotoPaciente","accept":".jpg, .png"},on:{"change":_vm.functionFotoPaciente}}),_vm._v(" "),(_vm.nombrefotoPaciente!=null)?_c('label',{staticClass:"btn btn-success btn-sm",attrs:{"for":"fotoPaciente","id":"buttonImg"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              Imagen seleccionada\n            ")]):_c('label',{staticClass:"btn btn-success btn-sm",attrs:{"for":"fotoPaciente"}},[_c('i',{staticClass:"fa fa-file-image-o"}),_vm._v("\n              Cargar Fotografía del paciente\n            ")]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.controlBoton=='registrar')?_c('div',{staticClass:"col-md-3 col-xs-12"},[_vm._m(1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoDocumento),expression:"tipoDocumento"}],staticClass:"form-control select-sm",attrs:{"id":"tipo_documento"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipoDocumento=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccionar")]),_vm._v(" "),_vm._l((_vm.arrayTipoDocumento),function(documento){return _c('option',{key:documento.TipDocCod,domProps:{"value":documento.TipDocCod,"textContent":_vm._s(documento.TipDocNom)}})})],2)]):_c('div',{staticClass:"col-md-3 col-xs-12"},[_vm._m(2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoDocumento),expression:"tipoDocumento"}],staticClass:"form-control select-sm",attrs:{"id":"tipo_documento"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipoDocumento=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccionar")]),_vm._v(" "),_vm._l((_vm.arrayTipoDocumento),function(documento){return _c('option',{key:documento.TipDocCod,domProps:{"value":documento.TipDocCod,"textContent":_vm._s(documento.TipDocNom)}})})],2)]),_vm._v(" "),(_vm.controlBoton=='registrar')?_c('div',{staticClass:"col-md-3"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroDocumento),expression:"numeroDocumento"}],staticClass:"form-control input-sm",attrs:{"type":"text","required":"","id":"documento_paciente"},domProps:{"value":(_vm.numeroDocumento)},on:{"change":function($event){return _vm.llamarPacienteExistente()},"input":function($event){if($event.target.composing){ return; }_vm.numeroDocumento=$event.target.value}}})]):_c('div',{staticClass:"col-md-3"},[_vm._m(4),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroDocumento),expression:"numeroDocumento"}],staticClass:"form-control input-sm",attrs:{"type":"text","required":"","id":"documento_paciente"},domProps:{"value":(_vm.numeroDocumento)},on:{"change":function($event){return _vm.llamarPacienteExistente()},"input":function($event){if($event.target.composing){ return; }_vm.numeroDocumento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-12"},[_vm._m(5),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apellidos),expression:"apellidos"}],staticClass:"form-control input-sm",attrs:{"type":"text","required":"","id":"apellidos_paciente"},domProps:{"value":(_vm.apellidos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.apellidos=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-12"},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombres),expression:"nombres"}],staticClass:"form-control input-sm",attrs:{"type":"text","required":"","id":"nombres_paciente"},domProps:{"value":(_vm.nombres)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombres=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-xs-12"},[_vm._m(7),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Fecha_nacimiento),expression:"Fecha_nacimiento"}],staticClass:"form-control input-sm",attrs:{"required":"","type":"date","id":"fecha_nacimiento"},domProps:{"value":(_vm.Fecha_nacimiento)},on:{"change":function($event){return _vm.calcularEdad()},"input":function($event){if($event.target.composing){ return; }_vm.Fecha_nacimiento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_vm._m(8),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sexo),expression:"sexo"}],staticClass:"form-control select-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sexo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Masculino")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Femenino")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Gay")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Lesbiana")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Bisexual")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Transgénero")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Intersexual")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Sin definir")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_vm._m(9),_vm._v(" "),(_vm.controlBoton=='registrar')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaIngreso),expression:"fechaIngreso"}],staticClass:"form-control input-sm",attrs:{"type":"date","required":"","max":_vm.fechaIngreso,"id":"fecha_ing_paciente"},domProps:{"value":(_vm.fechaIngreso)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaIngreso=$event.target.value}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaIngreso),expression:"fechaIngreso"}],staticClass:"form-control input-sm",attrs:{"type":"date","disabled":"","id":"fecha_ing_paciente"},domProps:{"value":(_vm.fechaIngreso)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaIngreso=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_vm._m(10),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoCliente),expression:"tipoCliente"}],staticClass:"form-control select-sm",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipoCliente=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccionar")]),_vm._v(" "),_vm._l((_vm.arrayTipoCliente),function(cliente){return _c('option',{key:cliente.TipCliCod,domProps:{"value":cliente.TipCliCod,"textContent":_vm._s(cliente.TipCliNom)}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('br'),_vm._v(" "),(_vm.Fecha_nacimiento!='' && _vm.Fecha_nacimiento<_vm.fechaActual)?_c('strong',[_vm._v(_vm._s(_vm.anos)+" años y "+_vm._s(_vm.meses)+" meses")]):_vm._e(),_vm._v(" "),(_vm.Fecha_nacimiento>_vm.fechaActual)?_c('strong',[_vm._v("La fecha de nacimiento no puede ser mayor a la fecha actual")]):_vm._e()])]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Datos de origen:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("País:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.paisOrigen),expression:"paisOrigen"}],staticClass:"form-control select-sm",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.paisOrigen=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccionar")]),_vm._v(" "),_vm._l((_vm.arrayPaises),function(pais){return _c('option',{key:pais.PaiCod,domProps:{"value":pais.PaiCod,"textContent":_vm._s(pais.PaiNom)}})})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Departamento/Estado:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.departamentoOrigen),expression:"departamentoOrigen"}],staticClass:"form-control select-sm",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.departamentoOrigen=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccionar")]),_vm._v(" "),_vm._l((_vm.arrayDepartamentos),function(departamento){return _c('option',{key:departamento.DepCod,domProps:{"value":departamento.DepCod,"textContent":_vm._s(departamento.DepNom)}})})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Ciudad:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ciudadOrigen),expression:"ciudadOrigen"}],staticClass:"form-control select-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ciudadOrigen=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0","disabled":""}},[_vm._v("Seleccione")]),_vm._v(" "),_vm._l((_vm.arrayCiudades),function(ciudad){return _c('option',{key:ciudad.ciuCod,domProps:{"value":ciudad.ciuCod,"textContent":_vm._s(ciudad.ciuNom)}})})],2)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Datos de residencia y contacto:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"pais"}},[_vm._v("País:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.paisResidencia),expression:"paisResidencia"}],staticClass:"form-control select-sm",attrs:{"id":"pais"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.paisResidencia=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccionar")]),_vm._v(" "),_vm._l((_vm.arrayPaises),function(pais){return _c('option',{key:pais.PaiCod,domProps:{"value":pais.PaiCod,"textContent":_vm._s(pais.PaiNom)}})})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"departamento"}},[_vm._v("Departamento:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.departamentoResidencia),expression:"departamentoResidencia"}],staticClass:"form-control select-sm",attrs:{"id":"departamento"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.departamentoResidencia=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccionar")]),_vm._v(" "),_vm._l((_vm.arrayDepartamentos),function(departamento){return _c('option',{key:departamento.DepCod,domProps:{"value":departamento.DepCod,"textContent":_vm._s(departamento.DepNom)}})})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"ciudad"}},[_vm._v("Ciudad:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ciudadResidencia),expression:"ciudadResidencia"}],staticClass:"form-control select-sm",attrs:{"id":"ciudad"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ciudadResidencia=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccione")]),_vm._v(" "),_vm._l((_vm.arrayCiudades),function(ciudad){return _c('option',{key:ciudad.ciuCod,domProps:{"value":ciudad.ciuCod,"textContent":_vm._s(ciudad.ciuNom)}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"direccion"}},[_vm._v("Dirección de residencia:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.direccionResidencia),expression:"direccionResidencia"}],staticClass:"form-control input-sm",attrs:{"type":"text","id":"direccion"},domProps:{"value":(_vm.direccionResidencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.direccionResidencia=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"telefono_paciente"}},[_vm._v("Teléfono:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telefonoContacto),expression:"telefonoContacto"}],staticClass:"form-control input-sm",attrs:{"type":"number","id":"telefono_paciente"},domProps:{"value":(_vm.telefonoContacto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telefonoContacto=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"email_paciente"}},[_vm._v("Email:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailContacto),expression:"emailContacto"}],staticClass:"form-control input-sm",attrs:{"type":"email","id":"email_paciente"},domProps:{"value":(_vm.emailContacto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailContacto=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Cobertura en salud:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Régimen:\n      "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},_vm._l((_vm.radioRegimen),function(radio){return _c('div',{key:radio.value,staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regimen),expression:"regimen"}],attrs:{"type":"radio","id":radio.nombre},domProps:{"value":radio.value,"checked":_vm._q(_vm.regimen,radio.value)},on:{"change":function($event){_vm.regimen=radio.value}}}),_vm._v(" "),_c('label',{attrs:{"for":radio.nombre},domProps:{"textContent":_vm._s(radio.nombre)}})])}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("EPS:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eps),expression:"eps"}],staticClass:"form-control select-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.eps=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"16","disabled":""}},[_vm._v("N/A")]),_vm._v(" "),_vm._l((_vm.arrayEps),function(eps){return _c('option',{key:eps.EpsCod,domProps:{"value":eps.EpsCod,"textContent":_vm._s(eps.EpsNom)}})})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Prepagada:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.prepagada),expression:"prepagada"}],staticClass:"form-control select-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.prepagada=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"16"}},[_vm._v("N/A")]),_vm._v(" "),_vm._l((_vm.arrayPrepagada),function(prepagada){return _c('option',{key:prepagada.EpsCod,attrs:{"disabled":_vm.regimen == 2 || _vm.poliza != '16'},domProps:{"value":prepagada.EpsCod,"textContent":_vm._s(prepagada.EpsNom)}})})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Póliza:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.poliza),expression:"poliza"}],staticClass:"form-control select-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.poliza=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"16"}},[_vm._v("N/A")]),_vm._v(" "),_vm._l((_vm.arrayPoliza),function(poliza){return _c('option',{key:poliza.EpsCod,attrs:{"disabled":_vm.regimen == 2 || _vm.prepagada != '16'},domProps:{"value":poliza.EpsCod,"textContent":_vm._s(poliza.EpsNom)}})})],2)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Datos del acompañante y remitente:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre del acompañante:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombreAcompanante),expression:"nombreAcompanante"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.nombreAcompanante)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombreAcompanante=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Teléfono del acompañante:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telefonoAcompanante),expression:"telefonoAcompanante"}],staticClass:"form-control input-sm",attrs:{"type":"number"},domProps:{"value":(_vm.telefonoAcompanante)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telefonoAcompanante=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Remitido por:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.remitente),expression:"remitente"}],staticClass:"form-control input-sm",attrs:{"type":"text","title":"Ej. Doctor remitente, colegio, conocido, red social instagram, pagina web, etc"},domProps:{"value":(_vm.remitente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.remitente=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('center',[(_vm.controlBoton == 'registrar' && _vm.Fecha_nacimiento<_vm.fechaActual)?_c('button',{staticClass:"btn btn-success btn-sm btn-fill",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Registrar Paciente\n        ")]):_vm._e(),_vm._v(" "),(_vm.controlBoton== 'editar' && _vm.Fecha_nacimiento<_vm.fechaActual && _vm.estado == 1)?_c('button',{staticClass:"btn btn-success btn-sm btn-fill",attrs:{"type":"button"},on:{"click":function($event){return _vm.actualizarPaciente()}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Editar Datos\n        ")]):_vm._e()])],1)]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.agregarAcudiente.apply(null, arguments)}}},[_c('div',{staticClass:"card-body",staticStyle:{"padding":"4%"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(13),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apellidosAcudiente),expression:"apellidosAcudiente"}],staticClass:"form-control input-sm",attrs:{"type":"text","id":"apellidos_acudientess","required":""},domProps:{"value":(_vm.apellidosAcudiente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.apellidosAcudiente=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(14),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombresAcudiente),expression:"nombresAcudiente"}],staticClass:"form-control input-sm",attrs:{"type":"text","id":"nombre_acudiente","required":""},domProps:{"value":(_vm.nombresAcudiente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombresAcudiente=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(15),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoDocumentoAcudiente),expression:"tipoDocumentoAcudiente"}],staticClass:"form-control select-sm",attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipoDocumentoAcudiente=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccionar")]),_vm._v(" "),_vm._l((_vm.arrayTipoDocumento),function(documento){return _c('option',{key:documento.TipDocCod,domProps:{"value":documento.TipDocCod,"textContent":_vm._s(documento.TipDocNom)}})})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(16),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documentoAcudiente),expression:"documentoAcudiente"}],staticClass:"form-control input-sm",attrs:{"type":"text","required":""},domProps:{"value":(_vm.documentoAcudiente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.documentoAcudiente=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(17),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.parentesco),expression:"parentesco"}],staticClass:"form-control select-sm",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.parentesco=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccionar")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("MADRE")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("PADRE")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("ABUELA")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("ABUELO")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("HERMANO(a)")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("TIO(a)")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("CUIDADOR(a)")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("AMIGO(a)")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("ESPOSO(a)/PAREJA")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("OTRO")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(18),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telefonoAcudiente),expression:"telefonoAcudiente"}],staticClass:"form-control input-sm",attrs:{"type":"number","id":"telefono_acudiente"},domProps:{"value":(_vm.telefonoAcudiente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telefonoAcudiente=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(19),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.correo),expression:"correo"}],staticClass:"form-control input-sm",attrs:{"type":"email","id":"correo_acudiente"},domProps:{"value":(_vm.correo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.correo=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"form-group"},[_vm._m(20),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ocupacion),expression:"ocupacion"}],staticClass:"form-control select-sm",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ocupacion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccionar")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("EMPLEADO")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("COMERCIANTE")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("EMPRESARIO")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("AMA DE CASA")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("PROFESIÓN INDEPENDIENTE")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("ESTUDIANTE")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("SIN OCUPACION")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("OTRO")])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[_c('div',{staticClass:"col-xs-12 col-md-12"},[(_vm.PacIde!='' && _vm.estado == 1)?_c('button',{staticClass:"btn btn-success btn-sm btn-fill",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Registrar acudiente\n          ")]):_vm._e(),_vm._v(" "),(_vm.estado==1)?_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.limpiarFormulario2()}}},[_c('i',{staticClass:"fa fa fa-history"}),_vm._v(" Limpiar formulario\n          ")]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"el-table"},[_c('table',{staticClass:"el-table el--table-hover el-table-condensed el--table-striped",staticStyle:{"margin":"0"}},[_vm._m(21),_vm._v(" "),_c('tbody',_vm._l((_vm.arrayAcudientes),function(acudiente){return _c('tr',{key:acudiente.nombres,style:(acudiente.id==1?'color:red':'')},[_c('td',{domProps:{"textContent":_vm._s(acudiente.TerNom  + ' ' +  acudiente.TerApe)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(acudiente.TerIde)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(acudiente.RolNom)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(acudiente.TerTel)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(acudiente.TerEma)}}),_vm._v(" "),_c('td',{domProps:{"textContent":_vm._s(acudiente.OcuNom)}}),_vm._v(" "),_c('td',[_c('center',[_c('button',{staticClass:"btn btn-simple btn-danger btn-icon",attrs:{"type":"button"},on:{"click":function($event){return _vm.eliminarAcudiente(acudiente)}}},[_c('i',{staticClass:"fa fa-close"})])])],1)])}),0)])])],1)]),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"4%"}},[_c('div',{staticClass:"row"},[_c('label',{attrs:{"for":"motivoConsulta"}},[_vm._v("Motivo de consulta:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivoConsulta),expression:"motivoConsulta"}],staticClass:"form-control",attrs:{"id":"motivoConsulta","cols":"20","rows":"5","maxlength":"1000"},domProps:{"value":(_vm.motivoConsulta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motivoConsulta=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[(_vm.estado==1)?_c('button',{staticClass:"btn btn-success btn-fill btn-sm",on:{"click":function($event){return _vm.nuevoMotivoConsulta()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n        Nuevo motivo de consulta\n      ")]):_vm._e(),_vm._v(" "),(_vm.estado==1)?_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.limpiarMotivoDeConsulta()}}},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Limpiar formulario\n      ")]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[(_vm.arrayMotivo!='')?_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.arrayMotivo}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fecha"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(_vm._f("date")(props.row.MotFec)))]}}],null,false,3326697798)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"MotDes","label":"Motivo de consulta","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"MotTer","width":"135","label":"Terapeuta"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Estado","width":"135"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.MotEst==0)?_c('div',[_c('span',{staticClass:"label label-warning",attrs:{"slot":"title-label"},slot:"title-label"},[_c('i',{staticClass:"ti-close"}),_vm._v(" Por verificar\n              ")])]):_vm._e(),_vm._v(" "),(props.row.MotEst==1)?_c('div',[_c('span',{staticClass:"label label-info",attrs:{"slot":"title-label"},slot:"title-label"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Verificado\n              ")])]):_vm._e()]}}],null,false,3780168917)})],1):_vm._e()],1)],1),_vm._v(" "),_vm._m(23),_vm._v(" "),_c('div',{staticClass:"card-body",staticStyle:{"padding":"4%"}},[_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Documento del paciente:")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","accept":".jpg, .png, .pdf","id":"image1"},on:{"change":_vm.functionFotoDocumento}}),_vm._v(" "),(_vm.nombreFotoDocumento!=null)?_c('label',{staticClass:"btn btn-primary",attrs:{"for":"image1","id":"botonConImagen"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.nombreFotoDocumento)+"\n          ")]):_c('label',{staticClass:"btn btn-success",attrs:{"for":"image1","id":"buttonImg"}},[_c('i',{staticClass:"fa fa-file-image-o"}),_vm._v(" Documento Paciente\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.UrlDoc!='' && _vm.UrlDoc!=null)?_c('a',{attrs:{"target":"_blank","href":'https://avanti-erp.com/'+_vm.UrlDoc}},[_vm._v("Ver Documento...")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Documento de acudiente:")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"image2","accept":".jpg, .png, .pdf"},on:{"change":_vm.functionFotoAcudiente}}),_vm._v(" "),(_vm.nombreFotoAcudiente!=null)?_c('label',{staticClass:"btn btn-primary",attrs:{"for":"image2","id":"botonConImagen"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.nombreFotoAcudiente)+"\n          ")]):_c('label',{staticClass:"btn btn-success",attrs:{"for":"image2","id":"buttonImg"}},[_c('i',{staticClass:"fa fa-file-image-o"}),_vm._v(" Documento del acudiente\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.UrlAcu!='' && _vm.UrlAcu != null)?_c('a',{attrs:{"target":"_blank","href":'https://avanti-erp.com/'+_vm.UrlAcu}},[_vm._v("Ver Documento...")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Consentimiento informado:")]),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"image3","accept":".jpg, .png, .pdf"},on:{"change":_vm.functionConsentimientoInformado}}),_vm._v(" "),(_vm.nombreConsentimientoInfor!=null)?_c('label',{staticClass:"btn btn-primary",attrs:{"for":"image3","id":"botonConImagen"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.nombreConsentimientoInfor)+"\n          ")]):_c('label',{staticClass:"btn btn-success",attrs:{"for":"image3","id":"buttonImg"}},[_c('i',{staticClass:"fa fa-file-image-o"}),_vm._v("Consentimiento informado\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.UrlCon!='' && _vm.UrlCon != null)?_c('a',{attrs:{"target":"_blank","href":'https://avanti-erp.com/'+_vm.UrlCon}},[_vm._v("Ver Documento...")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Orden médica:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"image4","accept":".jpg, .png, .pdf"},on:{"change":_vm.functionOrdenMedica}}),_vm._v(" "),(_vm.nombreordenMedica!=null)?_c('label',{staticClass:"btn btn-primary",attrs:{"for":"image4","id":"botonConImagen"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.nombreordenMedica)+"\n          ")]):_c('label',{staticClass:"btn btn-success",attrs:{"for":"image4","id":"buttonImg"}},[_c('i',{staticClass:"fa fa-file-image-o"}),_vm._v(" Orden Médica\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.UrlOrd!='' && _vm.UrlOrd != null)?_c('a',{attrs:{"target":"_blank","href":'https://avanti-erp.com/'+_vm.UrlOrd}},[_vm._v("Ver Documento...")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Autorización:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"image5","accept":".jpg, .png, .pdf"},on:{"change":_vm.functionAutorizacion}}),_vm._v(" "),(_vm.nombreAutorizacion!=null)?_c('label',{staticClass:"btn btn-primary",attrs:{"for":"image5","id":"botonConImagen"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            : "+_vm._s(_vm.nombreAutorizacion)+"\n          ")]):_c('label',{staticClass:"btn btn-success",attrs:{"for":"image5","id":"buttonImg"}},[_c('i',{staticClass:"fa fa-file-image-o"}),_vm._v("Autorización\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.UrlAut!='' && _vm.UrlAut!=null)?_c('a',{attrs:{"target":"_blank","href":'https://avanti-erp.com/'+_vm.UrlAut}},[_vm._v("Ver Documento...")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Otro documento:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"image6","accept":".jpg, .png, .pdf"},on:{"change":_vm.functionImagen2}}),_vm._v(" "),(_vm.nombreimagen2!=null)?_c('label',{staticClass:"btn btn-primary",attrs:{"for":"image6","id":"botonConImagen"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.nombreimagen2)+"\n          ")]):_c('label',{staticClass:"btn btn-success",attrs:{"for":"image6","id":"buttonImg"}},[_c('i',{staticClass:"fa fa-file-image-o"}),_vm._v("Seleccione un archivo\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.UrlArc!='' && _vm.UrlArc != null)?_c('a',{attrs:{"target":"_blank","href":'https://avanti-erp.com/'+_vm.UrlArc}},[_vm._v("Ver Documento...")]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[(_vm.estado==1)?_c('button',{staticClass:"btn btn-success btn-sm btn-fill",on:{"click":function($event){return _vm.cargarDocumentos()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Cargar Documentos\n      ")]):_vm._e(),_vm._v(" "),(_vm.estado==1)?_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.limpiarFormulario3()}}},[_c('i',{staticClass:"fa fa-history"}),_vm._v(" Limpiar formulario\n      ")]):_vm._e()])],1),_vm._v(" "),_c('modal',{attrs:{"name":"buscar","scrollable":true,"draggable":true,"width":"700","height":"auto","reset":true}},[_c('br'),_vm._v(" "),_c('div',[_c('div',[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"5px","padding-top":"0"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-search text-success",staticStyle:{"font-size":"37px"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("BUSCAR PACIENTES")]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("Formulario de busqueda de pacientes")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.buscarPacientes()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.criterio),expression:"criterio"}],staticClass:"form-control select-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.criterio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"PacApe1"}},[_vm._v("Apellidos del paciente")]),_vm._v(" "),_c('option',{attrs:{"value":"PacNom1"}},[_vm._v("Nombres del paciente")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],staticClass:"form-control input-sm",attrs:{"type":"text","required":""},domProps:{"value":(_vm.busqueda)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarPacientes()},"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('button',{staticClass:"btn btn-success btn-sm btn-simple",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-search",staticStyle:{"font-size":"22px"}})])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.arrayPacientes!='')?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"el-table table-striped table-sm table-condensed"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("Nombres")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("Apellidos")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("Acciones")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.arrayPacientes),function(paciente){return _c('tr',{key:paciente.PacIde},[_c('td',{staticStyle:{"text-align":"center"},domProps:{"textContent":_vm._s(paciente.PacNom1)}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"},domProps:{"textContent":_vm._s(paciente.PacApe1)}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_c('button',{staticClass:"btn btn-success btn-simple",staticStyle:{"padding":"1px"},on:{"click":function($event){return _vm.llamarPacienteExistente2(paciente)}}},[_c('i',{staticClass:"fa fa-check"})])])])}),0)])])]):_vm._e(),_vm._v(" "),(_vm.arrayPacientes=='')?_c('div',[_c('center',[_c('i',{staticClass:"fa fa-info"}),_vm._v(" "),_c('strong',[_vm._v("NO HAY PACIENTES")])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"padding-bottom":"0"}},[_c('button',{staticClass:"btn btn-danger btn-block btn-icon btn-simple",attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModal()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" CERRAR\n          ")])]),_vm._v(" "),_c('br')])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"20px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('span',{staticStyle:{"font-size":"22px","font-weight":"600"}},[_vm._v("Ingresar nuevos pacientes")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"texto-pequeno",staticStyle:{"padding-bottom":"-10px"}},[_vm._v("Formulario de ingreso de paciente")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"tipo_documento"}},[_vm._v("\n            Tipo de documento\n            "),_c('small',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"tipo_documento"}},[_vm._v("\n            Tipo de documento\n            "),_c('small',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"documento_paciente"}},[_vm._v("\n            N° documento\n            "),_c('small',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"documento_paciente"}},[_vm._v("\n            N° documento\n            "),_c('small',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"apellidos_paciente"}},[_vm._v("\n            Apellidos\n            "),_c('small',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"nombres_paciente"}},[_vm._v("\n            Nombres\n            "),_c('small',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"fecha_nacimiento"}},[_vm._v("\n            Fecha de nacimiento\n            "),_c('small',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":""}},[_vm._v("\n            Sexo\n            "),_c('small',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"fecha_ing_paciente"}},[_vm._v("\n            Fecha de registro\n            "),_c('small',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":""}},[_vm._v("\n            Tipo de vinculación\n            "),_c('small',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("\n            Estado civil\n          ")]),_vm._v(" "),_c('select',{staticClass:"form-control select-sm",attrs:{"id":""}},[_c('option',{attrs:{"value":"1"}},[_vm._v("SOLTERO")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("CASADO")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("DIVORCIADO")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("VIUDO")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("\n            Ocupación\n          ")]),_vm._v(" "),_c('select',{staticClass:"form-control select-sm",attrs:{"id":""}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Seleccionar")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("EMPLEADO")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("COMERCIANTE")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("EMPRESARIO")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("AMA DE CASA")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("PROFESIÓN INDEPENDIENTE")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("ESTUDIANTE")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("SIN OCUPACION")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("OTRO")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"20px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('span',{staticStyle:{"font-size":"22px","font-weight":"600"}},[_vm._v("Formulario de acudientes")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"texto-pequeno"},[_vm._v("Formulario de ingreso de responsables")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"apellidos_acudientess"}},[_vm._v("\n              Apellidos\n              "),_c('small',{staticStyle:{"color":"red"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"nombre_acudiente"}},[_vm._v("\n              Nombres\n              "),_c('small',{staticStyle:{"color":"red"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"documento_acudiente"}},[_vm._v("\n              Tipo de documento\n              "),_c('small',{staticStyle:{"color":"red"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"documento_acudiente"}},[_vm._v("\n              N° documento\n              "),_c('small',{staticStyle:{"color":"red"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":""}},[_vm._v("\n              Parentesco\n              "),_c('small',{staticStyle:{"color":"red"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"telefono_acudiente"}},[_vm._v("\n              Teléfono\n              "),_c('small',{staticStyle:{"color":"red"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"correo_acudiente"}},[_vm._v("\n              Correo\n              "),_c('small',{staticStyle:{"color":"red"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"parentesco"}},[_vm._v("\n              Ocupación\n              "),_c('small',{staticStyle:{"color":"red"}},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Nombre Completo")]),_vm._v(" "),_c('th',[_vm._v("Documento")]),_vm._v(" "),_c('th',[_vm._v("Parentesco")]),_vm._v(" "),_c('th',[_vm._v("Teléfono")]),_vm._v(" "),_c('th',[_vm._v("Correo electrónico")]),_vm._v(" "),_c('th',[_vm._v("Ocupación")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"20px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('span',{staticStyle:{"font-size":"22px","font-weight":"600"}},[_vm._v("Registrar motivo de consulta")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"texto-pequeno"},[_vm._v("Formulario de ingreso de motivos de consulta")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"20px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('span',{staticStyle:{"font-size":"22px","font-weight":"600"}},[_vm._v("Registrar documentos")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"texto-pequeno"},[_vm._v("Formulario de ingreso de documentos")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Af4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2M3y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2VOs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asistenciaUsuario_vue__ = __webpack_require__("Cqq6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58be7952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_asistenciaUsuario_vue__ = __webpack_require__("ozV4");
function injectStyle (ssrContext) {
  __webpack_require__("HAnZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asistenciaUsuario_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58be7952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_asistenciaUsuario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2Z2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card",staticStyle:{"padding":"2%"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{staticStyle:{"font-weight":"400"},attrs:{"for":"fecha_inicial"}},[_vm._v("Seleccione una fecha para cancelar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fecha_inicial),expression:"fecha_inicial"}],staticClass:"form-control",attrs:{"type":"date","id":"fecha_inicial"},domProps:{"value":(_vm.fecha_inicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fecha_inicial=$event.target.value}}})]),_vm._v(" "),(_vm.rol == 1)?_c('div',{staticClass:"col-md-3"},[_c('label',{staticStyle:{"font-weight":"400"},attrs:{"for":"fecha_inicial"}},[_vm._v("Tipo de programación a buscar")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoBuscar),expression:"tipoBuscar"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipoBuscar=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"Sesiones"}},[_vm._v("Sesiones/Evaluaciones")]),_vm._v(" "),_c('option',{attrs:{"value":"CYT"}},[_vm._v("CYT")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("dd")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-block",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.getEvents()}}},[_vm._v("\n            Buscar sesiones\n          ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.sesionesDisponibles != '')?_c('div',{staticClass:"row",staticStyle:{"border-radius":"10px"}},[_c('div',{staticClass:"col-md-12"},[_c('h5',{staticStyle:{"font-size":"17px","font-weight":"500"}},[_vm._v("\n            Sesiones disponibles para cancelar\n            "),_c('span',{staticStyle:{"border-radius":"10px","background-color":"#302254","color":"white","padding":"5px 10px"}},[_vm._v(_vm._s(_vm.sesionesDisponibles.length))])])]),_vm._v(" "),_vm._l((_vm.sesionesDisponibles),function(sesion){return _c('div',{key:sesion,staticClass:"col-md-3"},[_c('div',{staticClass:"card",staticStyle:{"box-shadow":"none","border":"0.1em #d4d4d4 solid"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('center',[_c('p',[_vm._v("\n                      "+_vm._s(sesion.nombrePaciente)+"\n                      "+_vm._s(sesion.apellidoPaciente)+"\n                    ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('center',[_c('span',[_vm._v("\n                      Terapeuta: "+_vm._s(sesion.nombreTerapeuta)+"\n                      "+_vm._s(sesion.apellidoTerapeuta)+"\n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("\n                      "+_vm._s(_vm._f("date")(sesion.fecha))+", "+_vm._s(sesion.horainicio)+" -\n                      "+_vm._s(sesion.horafin)+"\n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"border-radius":"50px","margin-top":"30px","padding":"5px 15px","background-color":"#302254","color":"white"}},[_vm._v("\n                      "+_vm._s(sesion.ProCanSes)+"\n                      "+_vm._s(sesion.ProCanSes > 1 ? "Sesiones" : "Sesión"))])]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary btn-block",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.cancelarEventos(sesion)}}},[_vm._v("\n                    Cancelar sesiones\n                  ")]),_vm._v(" "),(_vm.rol == 1 && sesion.tipo == 'CYT')?_c('button',{staticClass:"btn btn-success btn-block btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.aceptarCYT(sesion)}}},[_vm._v("\n                    Aceptar CYT\n                  ")]):_vm._e()])])])])])})],2):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"50px"}},[_c('div',[_c('i',{staticClass:"fa fa-calendar text-success",staticStyle:{"font-size":"50px"}})]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('span',{staticStyle:{"font-weight":"500","font-size":"20px"}},[_vm._v("Gestionar programaciones masivamente")]),_vm._v(" "),_c('small',{staticClass:"texto-pequeno"},[_vm._v("Gestión de programación")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df34212_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("Vi8u");
function injectStyle (ssrContext) {
  __webpack_require__("Ms/T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0df34212_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2cm6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionFechas_vue__ = __webpack_require__("mwgh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a53a84c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionFechas_vue__ = __webpack_require__("En5H");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionFechas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a53a84c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionFechas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2k/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miEspacioAdmin_vue__ = __webpack_require__("dD14");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1bc31b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_miEspacioAdmin_vue__ = __webpack_require__("7T7g");
function injectStyle (ssrContext) {
  __webpack_require__("wFyH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b1bc31b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miEspacioAdmin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1bc31b0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_miEspacioAdmin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2tsZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"row"},[_c('center',[(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e()])],1),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{ref:"component",staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill mb-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"Usuarios-salarios avanza","name":"Salarios avanza"}},[_vm._v("\n            Exportar a excel "),_c('i',{staticClass:"fa fa-download",attrs:{"color":"black"}})]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive table-striped mt-2",attrs:{"border":"","data":_vm.queriedData}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"full-width",class:_vm.getClass(column, row)},[(_vm.getClass(column, row) != '')?_c('strong',[_vm._v(_vm._s(row[column.prop]))]):(column.tipo == 'COP')?_c('strong',[_vm._v("\n                    "+_vm._s(_vm.formatearPesosColombianos(row[column.prop]))+"\n                  ")]):_c('span',[_vm._v(_vm._s(row[column.prop]))])])]}}],null,true)})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-simple btn-info btn-icon like",on:{"click":function($event){return _vm.modal(props.row)}}},[_c('i',{staticClass:"ti-pencil"})])])]}}],null,false,3884023063)})],2),_vm._v(" "),_c('modal',{attrs:{"name":"gestionar-salario","scrollable":true,"height":"auto","reset":true}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('strong',{staticClass:"titulo-modal"},[_vm._v("\n                    GESTIONAR LA INFORMACIÓN DE CONTRATO Y SALARIO\n                  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"grey"}},[_vm._v("\n                    Asignación y/o modifiación de contrato y salarios\n                  ")])])])]),_vm._v(" "),(_vm.usuarioSeleccionado.idUsuario != '')?_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v("Ajustar el tipo de contrato y salario de: "),_c('strong',[_vm._v(" "+_vm._s(_vm.usuarioSeleccionado.nombreUsuario)+" ")])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.actualizarInformacion()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"tipoContrato"}},[_vm._v("Tipo de contrato:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.tipoContratoId),expression:"usuarioSeleccionado.tipoContratoId"}],staticClass:"form-control",attrs:{"id":"tipoContrato"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.usuarioSeleccionado, "tipoContratoId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Prestación de servicios")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Contrato indefinido")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Contrato termino fijo")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"salarioFijo"}},[_vm._v("Salario fijo:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.salarioFijo),expression:"usuarioSeleccionado.salarioFijo"}],staticClass:"form-control",attrs:{"type":"text","id":"salarioFijo","title":"Escribir salario sin puntos"},domProps:{"value":(_vm.usuarioSeleccionado.salarioFijo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioSeleccionado, "salarioFijo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"transporte"}},[_vm._v("Auxilio de transporte:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.transporte),expression:"usuarioSeleccionado.transporte"}],staticClass:"form-control",attrs:{"type":"text","id":"transporte","title":"Escribir salario sin puntos"},domProps:{"value":(_vm.usuarioSeleccionado.transporte)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioSeleccionado, "transporte", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"salarioPorSesion"}},[_vm._v("Pago por sesión:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.pagoPorSesion),expression:"usuarioSeleccionado.pagoPorSesion"}],staticClass:"form-control",attrs:{"type":"text","id":"salarioPorSesion","title":"Escribir salario sin puntos"},domProps:{"value":(_vm.usuarioSeleccionado.pagoPorSesion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioSeleccionado, "pagoPorSesion", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"salarioPorSesionParticular"}},[_vm._v("Pago por sesión particular:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.pagoPorSesionParticular),expression:"usuarioSeleccionado.pagoPorSesionParticular"}],staticClass:"form-control",attrs:{"type":"text","id":"salarioPorSesionParticular","title":"Escribir salario sin puntos"},domProps:{"value":(_vm.usuarioSeleccionado.pagoPorSesionParticular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioSeleccionado, "pagoPorSesionParticular", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"salarioPorSesionDomicilio"}},[_vm._v("Pago por sesión domiciliaria:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.pagoPorSesionDomicilio),expression:"usuarioSeleccionado.pagoPorSesionDomicilio"}],staticClass:"form-control",attrs:{"type":"text","id":"salarioPorSesionDomicilio","title":"Escribir salario sin puntos"},domProps:{"value":(_vm.usuarioSeleccionado.pagoPorSesionDomicilio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioSeleccionado, "pagoPorSesionDomicilio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"salarioPorSesionDomicilioParticular"}},[_vm._v("Pago por sesión domiciliaria particular:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.pagoPorSesionDomicilioParticular),expression:"usuarioSeleccionado.pagoPorSesionDomicilioParticular"}],staticClass:"form-control",attrs:{"type":"text","id":"salarioPorSesionDomicilioParticular","title":"Escribir salario sin puntos"},domProps:{"value":(_vm.usuarioSeleccionado.pagoPorSesionDomicilioParticular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioSeleccionado, "pagoPorSesionDomicilioParticular", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"salarioPorEvaluacion"}},[_vm._v("Pago por evaluación:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.pagoPorEvaluacion),expression:"usuarioSeleccionado.pagoPorEvaluacion"}],staticClass:"form-control",attrs:{"type":"text","id":"salarioPorEvaluacion","title":"Escribir salario sin puntos"},domProps:{"value":(_vm.usuarioSeleccionado.pagoPorEvaluacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioSeleccionado, "pagoPorEvaluacion", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"salarioPorEvaluacionDomicilio"}},[_vm._v("Pago por evaluación particular:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.pagoPorEvaluacionDomicilio),expression:"usuarioSeleccionado.pagoPorEvaluacionDomicilio"}],staticClass:"form-control",attrs:{"type":"text","id":"salarioPorEvaluacionDomicilio","title":"Escribir salario sin puntos"},domProps:{"value":(_vm.usuarioSeleccionado.pagoPorEvaluacionDomicilio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioSeleccionado, "pagoPorEvaluacionDomicilio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"eps"}},[_vm._v("Caja de compensación:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.eps),expression:"usuarioSeleccionado.eps"}],staticClass:"form-control",attrs:{"type":"text","id":"eps","title":"Escribir salario sin puntos"},domProps:{"value":(_vm.usuarioSeleccionado.eps)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioSeleccionado, "eps", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"pension"}},[_vm._v("Pensión:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.pension),expression:"usuarioSeleccionado.pension"}],staticClass:"form-control",attrs:{"type":"text","id":"pension","title":"Escribir salario sin puntos"},domProps:{"value":(_vm.usuarioSeleccionado.pension)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioSeleccionado, "pension", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"arl"}},[_vm._v("ARL:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioSeleccionado.arl),expression:"usuarioSeleccionado.arl"}],staticClass:"form-control",attrs:{"type":"text","id":"arl","title":"Escribir salario sin puntos"},domProps:{"value":(_vm.usuarioSeleccionado.arl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioSeleccionado, "arl", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('center',[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModal()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit"}},[_vm._v("Actualizar datos")])])],1)])])]):_vm._e()])],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Gestión de salarios en avanza")]),_vm._v(" "),_c('p',[_vm._v("\n            Aquí podrá gestionar la información relacionada con los\n            "),_c('span',{staticClass:"text-success"},[_vm._v("salarios")]),_vm._v(" fijos o variables de\n            los empleados de "),_c('span',{staticClass:"text-success"},[_vm._v("Avanza")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "31tF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__("+Rp4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__ = __webpack_require__("1byD");





















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  data: function data() {
    return {
      fechaInicial: "",
      fechaFinal: "",
      searchQuery: "",
      nota: "",
      usuario: "",
      valor: "",
      queriedData2: [],
      listUsers: [],
      tableColumns: [{
        prop: "terapeuta",
        label: "Terapeuta",
        minWidth: 120 }, {
        prop: "paciente",
        label: "Paciente",
        minWidth: 120 }, {
        prop: "tipo",
        label: "Tipo sesión",
        minWidth: 100 }, {
        prop: "fecha",
        label: "Fecha sesión",
        minWidth: 100 }, {
        prop: "fechaFin",
        label: "Fecha final de evolución",
        minWidth: 100 }, {
        prop: "fechaEvolucion",
        label: "Fecha evolución",
        minWidth: 100 }, {
        prop: "precio",
        label: "Monto descontado",
        minWidth: 100 }],
      json_fields: {
        "paciente": "paciente",
        "terapeuta": "terapeuta",
        "fecha": "fecha",
        "fecha evolución": "fechaEvolucion",
        "valor descontado": "precio"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      sede: "Sede Principal",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  methods: {
    formatearPesosColombianos: __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__["a" /* default */],
    cerrarModal: function cerrarModal() {
      this.nota = "";
      this.valor = "";
      this.$modal.hide("registrar-gasto");
    },
    prepararRegistrar: function prepararRegistrar() {
      this.nota = "";
      this.valor = "";
      this.$modal.show("registrar-gasto");
    },
    newExpense: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.valor == "" || this.nota == "")) {
                  _context.next = 3;
                  break;
                }

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", "Complete los campos requeridos"));
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;

                this.$modal.show("carga");
                data = {
                  valor: this.valor,
                  nota: this.nota,
                  usuario: this.usuario
                };
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post("api/newExpense", data);

              case 8:
                response = _context.sent;


                if (response.data.status === true) {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("success", response.data.mensaje));
                  this.obtenerInformacionGastos();
                } else {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", response.data.mensaje));
                }
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](3);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", _context.t0));

              case 15:
                _context.prev = 15;

                this.$modal.hide("carga");
                this.cerrarModal();
                return _context.finish(15);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 12, 15, 19]]);
      }));

      function newExpense() {
        return _ref.apply(this, arguments);
      }

      return newExpense;
    }(),
    obtenerInformacionEvoluciones: function obtenerInformacionEvoluciones(fechaInicial, fechaFinal) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var sede, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.$modal.show("carga");
                sede = localStorage.getItem("sede");
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/evoluciones-atrasadas/" + fechaInicial + "/" + fechaFinal);

              case 5:
                response = _context2.sent;

                _this2.queriedData2 = response.data.data;
                _this2.json_data = response.data.data;
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);

                _this2.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", _context2.t0));

              case 13:
                _context2.prev = 13;

                _this2.$modal.hide("carga");
                return _context2.finish(13);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10, 13, 16]]);
      }))();
    },

    deleteExpense: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(gasto) {
        var data, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.$modal.show("carga");
                data = { id: gasto.id };
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post("api/deleteExpense", data);

              case 5:
                response = _context3.sent;


                if (response.data.status === true) {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("success", response.data.mensaje));
                  this.obtenerInformacionGastos();
                } else {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", response.data.mensaje));
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", _context3.t0));

              case 12:
                _context3.prev = 12;

                this.$modal.hide("carga");
                return _context3.finish(12);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9, 12, 15]]);
      }));

      function deleteExpense(_x) {
        return _ref2.apply(this, arguments);
      }

      return deleteExpense;
    }(),
    getListUsers: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                this.$modal.show("carga");
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/get-list-users");

              case 4:
                response = _context4.sent;


                if (response.data.status === true) {
                  this.listUsers = response.data.data;
                } else {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", response.data.mensaje));
                }
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", _context4.t0));

              case 11:
                _context4.prev = 11;

                this.$modal.hide("carga");
                return _context4.finish(11);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8, 11, 14]]);
      }));

      function getListUsers() {
        return _ref3.apply(this, arguments);
      }

      return getListUsers;
    }(),
    getClass: function getClass(column, row) {
      if (column.prop === "precio") {
        return "low-percentage";
      }
      return "";
    }
  },
  mounted: function mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de descargos";
  }
});

/***/ }),

/***/ "32is":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "34jJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Sq6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
















__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip: 'https://avanti-erp.com/',
      descripcion: "",
      tipo: 22,
      modalRegistrar: 0,

      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      },

      pagination: {
        perPage: 7,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['DomDes'],
      tableColumns: [{
        prop: 'DomDes',
        label: 'Nombre',
        minWidth: 150 }],
      arrayMotivo: []

    };
  },


  computed: {
    pagedData: function pagedData() {
      return this.arrayMotivo.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.arrayMotivo.length;
        return this.pagedData;
      }
      var result = this.arrayMotivo.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.arrayMotivo.length;
      return this.arrayMotivo.length;
    }
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },

  methods: {
    abrirModal: function abrirModal() {
      this.modalRegistrar = 1;
    },
    nuevoDominio: function nuevoDominio() {
      var _this2 = this;

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + 'api/nuevoDominio';
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(url, {
        descripcion: this.descripcion,
        tipo: this.tipo
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this2.$notify({
          component: {
            template: ' <div style="padding: 3%;">\n              <span><b> REGISTRADO CON \xC9XITO </b>.</span>\n              </div>\n              '
          },
          icon: 'ti-check',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: _this2.type[color]
        });
        _this2.tipo = 22;
        _this2.descripcion = "";
        _this2.modalRegistrar = 0;

        _this2.estrategias();
      }).catch(function (error) {
        console.log(error);
      });
    },
    desactivar: function desactivar() {
      var _this3 = this;

      var patologia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + 'api/desactivarDominio';
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url, {
        id: patologia.DomIde
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this3.$notify({
          component: {
            template: ' <div style="padding: 3%;">\n              <span><b> DESACTIVADO CON \xC9XITO </b>.</span>\n              </div>\n              '
          },
          icon: 'ti-check',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: _this3.type[color]
        });

        _this3.estrategias();
      }).catch(function (error) {
        console.log(error);
      });
    },
    activar: function activar() {
      var _this4 = this;

      var patologia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + 'api/activarDominio';
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url, {
        id: patologia.DomIde
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this4.$notify({
          component: {
            template: ' <div style="padding: 3%;">\n              <span><b> ACTIVADO CON \xC9XITO </b>.</span>\n              </div>\n              '
          },
          icon: 'ti-check',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: _this4.type[color]
        });

        _this4.estrategias();
      }).catch(function (error) {
        console.log(error);
      });
    },
    estrategias: function estrategias() {
      var _this5 = this;

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + "api/allEstrategias";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(url, config).then(function (response) {
        _this5.arrayMotivo = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    dominio: function dominio(_dominio) {
      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + "api/dominio/" + _dominio;
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(url, config).then(function (res) {
        return res.data.data;
      });
    },
    limpiarFormulario: function limpiarFormulario() {
      this.descripcion = "";
      this.tipo = 26;
    }
  },
  mounted: function mounted() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/');
    } else {
      this.estrategias();
    }
  }
});

/***/ }),

/***/ "3efL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Admisiones_formularios_eps_vue__ = __webpack_require__("+9s1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Admisiones_formularios_prepagada_vue__ = __webpack_require__("8n25");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Admisiones_formularios_convenio_vue__ = __webpack_require__("aHw6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Admisiones_formularios_poliza_vue__ = __webpack_require__("hLSs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Admisiones_formularios_particular_vue__ = __webpack_require__("UrQn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Admisiones_ordenes_ordenes_vue__ = __webpack_require__("e+il");









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      modalRegistrar: 0,
      tipoCliente: 6,
      time: 0,
      duration: 5000
    };
  },

  methods: {
    abrirModal: function abrirModal() {
      this.modalRegistrar = 1;
      this.$modal.show("ingreso_servicio");
    },
    cerrarModal: function cerrarModal() {
      this.$modal.hide("ingreso_servicio");
    },
    asignarTipoCliente: function asignarTipoCliente() {
      localStorage.setItem("tipoClienteIngreso", this.tipoCliente);
    }
  },
  components: {
    eps: __WEBPACK_IMPORTED_MODULE_1__Admisiones_formularios_eps_vue__["a" /* default */],
    prepagada: __WEBPACK_IMPORTED_MODULE_2__Admisiones_formularios_prepagada_vue__["a" /* default */],
    poliza: __WEBPACK_IMPORTED_MODULE_4__Admisiones_formularios_poliza_vue__["a" /* default */],
    particular: __WEBPACK_IMPORTED_MODULE_5__Admisiones_formularios_particular_vue__["a" /* default */],
    ordenes: __WEBPACK_IMPORTED_MODULE_6__Admisiones_ordenes_ordenes_vue__["a" /* default */],
    convenio: __WEBPACK_IMPORTED_MODULE_3__Admisiones_formularios_convenio_vue__["a" /* default */]
  },
  mounted: function mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.asignarTipoCliente();
    }
  }
});

/***/ }),

/***/ "3jlA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.obtenerInformacionGastos(_vm.fechaInicial, _vm.fechaFinal, _vm.categoria)}}},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","required":"","id":"fechaInicial"},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha final:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","required":"","id":"fechaInicial"},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Categoria:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoria),expression:"categoria"}],staticClass:"form-control",attrs:{"id":"categoria","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoria=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"Todas"}},[_vm._v("Todas")]),_vm._v(" "),_c('option',{attrs:{"value":"Prestamo"}},[_vm._v("Préstamo")]),_vm._v(" "),_c('option',{attrs:{"value":"Gasto general"}},[_vm._v("Gasto general")]),_vm._v(" "),_c('option',{attrs:{"value":"Gasto servicios"}},[_vm._v("Gasto servicios")])])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"card",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.prepararRegistrar()}}},[_vm._v("\n            Crear nuevo gasto\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('center',[(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e()])],1),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{ref:"component",staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill mb-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"gastos variables","name":"Gastos avanza"}},[_vm._v("\n            Exportar a excel "),_c('i',{staticClass:"fa fa-download",attrs:{"color":"black"}})]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive mt-2",attrs:{"border":"","data":_vm.queriedData}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"full-width",class:_vm.getClass(column, row)},[(_vm.getClass(column, row) != '')?_c('strong',[_vm._v(_vm._s(_vm.formatearPesosColombianos(row[column.prop])))]):_c('span',[_vm._v(_vm._s(row[column.prop]))])])]}}],null,true)})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-simple btn-danger btn-icon like",on:{"click":function($event){return _vm.deleteExpense(props.row)}}},[_c('i',{staticClass:"ti-trash"})])])]}}],null,false,211253505)})],2)],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()]),_vm._v(" "),_c('modal',{attrs:{"name":"registrar-gasto","scrollable":true,"height":"auto","reset":true}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('strong',{staticClass:"titulo-modal"},[_vm._v(" REGISTRA UN NUEVO GASTO ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.registrarGasto()}}},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"fecha"}},[_vm._v("Fecha del gasto:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.fecha),expression:"form.fecha"}],staticClass:"form-control",attrs:{"type":"date","id":"fecha","required":""},domProps:{"value":(_vm.form.fecha)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "fecha", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"monto"}},[_vm._v("Monto:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.monto),expression:"form.monto"}],staticClass:"form-control",attrs:{"type":"number","id":"monto","required":""},domProps:{"value":(_vm.form.monto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "monto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"usuario"}},[_vm._v("Usuario:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.usuario),expression:"form.usuario"}],staticClass:"form-control",attrs:{"id":"usuario"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "usuario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Seleccionar...")]),_vm._v(" "),_vm._l((_vm.listUsers),function(usuario){return _c('option',{key:usuario.id,domProps:{"value":usuario.usuario}},[_vm._v("\n                  "+_vm._s(usuario.nombreUsuario)+"\n                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"categoria"}},[_vm._v("Categoria")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.categoria),expression:"form.categoria"}],staticClass:"form-control",attrs:{"id":"categoria","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "categoria", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Prestamo"}},[_vm._v("Préstamo")]),_vm._v(" "),_c('option',{attrs:{"value":"Gasto general"}},[_vm._v("Gasto general")]),_vm._v(" "),_c('option',{attrs:{"value":"Gasto servicios"}},[_vm._v("Gasto servicios")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"comentario"}},[_vm._v("Comentarios:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.comentario),expression:"form.comentario"}],staticClass:"form-control",attrs:{"type":"text","id":"comentario","required":""},domProps:{"value":(_vm.form.comentario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "comentario", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-seconday",attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModal()}}},[_vm._v("\n                  Cancelar\n                ")]),_vm._v(" "),_c('input',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit","value":"Registrar"}})])],1)])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Gestión de gastos no recurrentes")]),_vm._v(" "),_c('p',[_vm._v("\n            Aquí podrá gestionar la información relacionada con los\n            "),_c('span',{staticClass:"text-success"},[_vm._v("gastos")]),_vm._v(" variables de\n            "),_c('span',{staticClass:"text-success"},[_vm._v("Avanza")]),_vm._v(" por fecha\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit","value":"Buscar información"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-5"},[_c('br'),_vm._v(" "),_c('table',[_c('tbody',[_c('tr',[_c('td',{staticClass:"low-percentage"},[_c('span',{staticClass:"color-box"})]),_vm._v(" "),_c('td',[_vm._v("Registros de prestamos")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"info-percentage"},[_c('span',{staticClass:"color-box"})]),_vm._v(" "),_c('td',[_vm._v("Registros sin categorias")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"high-percentage"},[_c('span',{staticClass:"color-box"})]),_vm._v(" "),_c('td',[_vm._v("Registros de servicios")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"medium-percentage"},[_c('span',{staticClass:"color-box"})]),_vm._v(" "),_c('td',[_vm._v("Registros de gastos generales")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "42D9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.opcion == 1),expression:"opcion == 1"}],staticClass:"col-md-12 card",staticStyle:{"border-radius":"20px","padding-left":"7%","padding-right":"7%"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-md-12"},[_c('center',[_c('h4',{staticClass:"title",staticStyle:{"margin-top":"10px","color":"grey"}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Buscar Historia Clínica\n          ")])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.buscarPacientes()}}},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xs-12 col-md-4"},[_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.criterio),expression:"criterio"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.criterio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_vm._m(0),_vm._v(" "),_c('option',{attrs:{"value":"paciente.PacNom1"}},[_vm._v("Nombres del paciente")]),_vm._v(" "),_c('option',{attrs:{"value":"paciente.PacNumDoc"}},[_vm._v("\n                Documento del paciente\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-6"},[_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],staticClass:"form-control",attrs:{"required":"","type":"text","id":"texto","name":"texto","placeholder":"Buscar..."},domProps:{"value":(_vm.busqueda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-1"})])])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.pacientes != '')?_c('div',{staticClass:"card-content"},[_c('center',[_c('el-table',{staticClass:"el-table table-striped el-table--fit el-table--enable-row-hover el-table--enable-row-transition",attrs:{"size":"mini","data":_vm.pacientes}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNom1","label":"Nombres"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacApe1","label":"Apellidos"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNumDoc","label":"Documento"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-icon btn-success",on:{"click":function($event){return _vm.llamarPacientes(props.row)}}},[_c('i',{staticClass:"fa fa-search"})])]}}],null,false,2306292946)})],1)],1)],1):_c('center',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"width":"80%"}},[_c('div',{staticClass:"alert alert-danger alert-with-icon"},[_c('center',[_c('img',{staticStyle:{"width":"20%"},attrs:{"src":"static/img/logo.webp","alt":""}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',{staticStyle:{"color":"white"},attrs:{"data-notify":"message"}},[_c('i',{class:'fa fa-' + _vm.icono}),_vm._v("\n              "+_vm._s(_vm.mensaje)+"\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])],1)])]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.opcion == 2),expression:"opcion == 2"}],staticClass:"col-md-12 card"},[_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){return _vm.cerrarHC()}}},[_c('i',{staticClass:"fa fa-arrow-circle-o-left",staticStyle:{"font-size":"23px","color":"#b3b3b3","float":"left"}})]),_vm._v(" "),_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('strong',{staticStyle:{"font-size":"18px"}},[_vm._v("Historia Clínica ")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("Paciente: "),_c('strong',[_vm._v(_vm._s(_vm.nombres)+"\n            "+_vm._s(_vm.apellidos))])]),_vm._v(" "),_c('p',[_vm._v("\n            Diagnóstico: \n            "+_vm._s(_vm.diagnosticoPaciente == null ? 'Sin diagnóstico' : _vm.diagnosticoPaciente)+" \n            "),_c('button',{staticClass:"btn btn-icon btn-success btn-sm",on:{"click":function($event){return _vm.prepararEditDX(_vm.diagnosticoPaciente)}}},[_vm._v("Actualizar diagnóstico")]),_c('br')]),_vm._v(" "),(_vm.estado == 0)?_c('strong',{staticStyle:{"font-size":"12px","color":"red"}},[_vm._v("INACTIVO")]):_vm._e(),_vm._v(" "),(_vm.estado == 1)?_c('strong',{staticStyle:{"font-size":"12px","color":"green"}},[_vm._v("ACTIVO")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.loked != null)?_c('strong',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v("CONFIDENCIAL")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.informacion == false)?_c('button',{staticClass:"btn btn-success btn-fill btn-primary",staticStyle:{"float":"right","border-radius":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.informacion = true}}},[_c('i',{staticClass:"fa fa-arrow-down"}),_vm._v(" Información del paciente\n          ")]):_c('button',{staticClass:"btn btn-success",staticStyle:{"float":"right","border-radius":"5px"},on:{"click":function($event){_vm.informacion = false}}},[_c('i',{staticClass:"fa fa-arrow-up"}),_vm._v(" Ocultar información\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.push('/diarioCampo/objetivos-y-logros')}}},[_vm._v("\n            Ir a objetivos y logros "),_c('i',{staticClass:"fa fa-arrow-right"})])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.informacion),expression:"informacion"}],staticClass:"card-informacion"},[_c('div',{staticClass:"row",staticStyle:{"background-color":"#f5f5f5","border-radius":"20px","padding":"15px"}},[_c('div',{staticClass:"col-md-10"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_c('small',[_vm._v("Nombre completo:")]),_vm._v(" "+_vm._s(_vm.nombres)+"\n                  "+_vm._s(_vm.apellidos))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_c('small',[_vm._v("Número de documento:")]),_vm._v("\n                  "+_vm._s(_vm.numeroDocumento))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_c('small',[_vm._v("Fecha de ingreso:")]),_vm._v("\n                  "+_vm._s(_vm._f("date")(_vm.fechaIngreso)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_c('small',[_vm._v("Fecha de nacimiento:")]),_vm._v("\n                  "+_vm._s(_vm._f("date")(_vm.Fecha_nacimiento)))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_c('small',[_vm._v("Sexo:")]),_vm._v(" "+_vm._s(_vm.sexo))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_c('small',[_vm._v("Edad: ")]),_vm._v(_vm._s(_vm.anos)+" Años y\n                  "+_vm._s(_vm.meses)+" Meses")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_c('small',[_vm._v("EPS:")]),_vm._v(" "+_vm._s(_vm.eps))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_c('small',[_vm._v("Régimen:")]),_vm._v(" "+_vm._s(_vm.regimen))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_c('small',[_vm._v("Prepagada:")]),_vm._v(" "+_vm._s(_vm.prepagada))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_c('small',[_vm._v("Póliza:")]),_vm._v(" "+_vm._s(_vm.poliza))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_c('small',[_vm._v("Tipo de afiliación:")]),_vm._v("\n                  "+_vm._s(_vm.tipoAfiliacion))])])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"image"},[_c('img',{staticStyle:{"border-radius":"15px !important"},attrs:{"width":"130","src":_vm.ip + '' + _vm.fotoPaciente}})])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('vue-tabs',{staticClass:"row",attrs:{"direction":"horizontal"}},[_c('v-tab',{attrs:{"title":"Motivo de consulta"}},[_c('template',{slot:"title"},[_c('p',[(_vm.motivoConsultaHoy == false)?_c('i',{staticClass:"fa fa-close texto_rojo"}):_c('i',{staticClass:"ti ti-check texto_verde"}),_vm._v("\n              Motivo Consulta Verificado\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-xs-5"}),_vm._v(" "),_c('center',[_c('h4',{staticStyle:{"margin":"0px","margin-top":"-3px"}},[_vm._v("\n              Motivos de consulta\n              "),_c('span',{staticClass:"badge badge-success"},[_vm._v(_vm._s(_vm.arrayMotivo.length))])]),_vm._v(" "),_c('div',[(_vm.estado == 1)?_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"float":"left","margin-bottom":"15px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.abrirModalAgregar()}}},[_vm._v("\n                 Nuevo motivo de consulta "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.arrayMotivo != '')?_c('el-table',{staticClass:"table-striped table-sm",staticStyle:{"width":"100%"},attrs:{"border":"","data":_vm.arrayMotivo,"max-height":"500"}},[_c('el-table-column',{attrs:{"label":"Fecha","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.MotFec))]}}],null,false,1931193835)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"MotDes","label":"Motivo de consulta"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"MotTer","width":"135","label":"Terapeuta"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Estado","width":"135"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.MotEst == 0)?_c('div',[_c('span',{staticClass:"label label-warning",attrs:{"slot":"title-label"},slot:"title-label"},[_c('i',{staticClass:"ti-close"}),_vm._v(" Por verificar\n                    ")])]):_vm._e(),_vm._v(" "),(props.row.MotEst == 1)?_c('div',[_c('span',{staticClass:"label label-info",attrs:{"slot":"title-label"},slot:"title-label"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Verificado\n                    ")])]):_vm._e()]}}],null,false,670139477)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Acciones","width":"85"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[(props.row.MotEst == 0)?_c('a',{staticClass:"btn btn-simple btn-warning btn-xs",attrs:{"data-target":"#modalMotivoV"},on:{"click":function($event){return _vm.motivoVerificar(props.row)}}},[_c('i',{staticClass:"ti-check"})]):_c('a',{staticClass:"btn btn-simple btn-warning btn-xs",attrs:{"data-toggle":"modal","data-target":"#modalMotivoV2"},on:{"click":function($event){return _vm.motivoVerificar(props.row)}}},[_c('i',{staticClass:"ti-eye"})])])]}}],null,false,980503963)})],1):_vm._e()],1)],2),_vm._v(" "),_c('v-tab',{attrs:{"title":"Antecedentes"}},[_c('template',{slot:"title"},[_c('p',[(_vm.antecedenteHoy == false)?_c('i',{staticClass:"fa fa-close texto_rojo"}):_c('i',{staticClass:"ti ti-check texto_verde"}),_vm._v("\n              Antecedentes\n            ")])]),_vm._v(" "),_c('h4',[_vm._v("ANTECEDENTES")]),_vm._v(" "),_c('vue-tabs',{attrs:{"direction":"vertical","value":"l"}},[_c('v-tab',{attrs:{"title":'Prenatales' + '  ' + '( ' + _vm.antecedentesPre.length + ' )'}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[(_vm.estado == 1)?_c('button',{staticClass:"btn btn-success btn-fill btn-block",on:{"click":function($event){return _vm.abrirModalAntecedente(1)}}},[_vm._v("\n                    Nuevo antecedente prenatal "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.antecedentesPre != '')?_c('el-table',{staticClass:"table-striped table-sm",staticStyle:{"width":"100%"},attrs:{"border":"","data":_vm.antecedentesPre,"max-height":"500"}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AntDes","label":"Descripción"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"185"}})],1):_vm._e()],1),_vm._v(" "),_c('v-tab',{attrs:{"title":'Perinatales' + ' ' + '( ' + _vm.antecedentesNeo.length + ' )'}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[(_vm.estado == 1)?_c('button',{staticClass:"btn btn-success btn-fill btn-block",on:{"click":function($event){return _vm.abrirModalAntecedente(2)}}},[_vm._v("\n                    Nuevo antecedente perinatal "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped table-sm",staticStyle:{"width":"100%"},attrs:{"border":"","data":_vm.antecedentesNeo,"max-height":"330"}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AntDes","label":"Descripción"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"185"}})],1)],1),_vm._v(" "),_c('v-tab',{attrs:{"title":'Postnatales ( ' + _vm.antecedentesPos.length + ' )'}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[(_vm.estado == 1)?_c('button',{staticClass:"btn btn-success btn-fill btn-block",on:{"click":function($event){return _vm.abrirModalAntecedente(3)}}},[_vm._v("\n                    Nuevo antecedente posnatal "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped table-sm",staticStyle:{"width":"100%"},attrs:{"border":"","data":_vm.antecedentesPos,"max-height":"500"}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AntDes","label":"Descripción"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"185"}})],1)],1),_vm._v(" "),_c('v-tab',{attrs:{"title":'Personales ( ' + _vm.antecedentesPer.length + ' )'}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[(_vm.estado == 1)?_c('button',{staticClass:"btn btn-success btn-fill btn-block",on:{"click":function($event){return _vm.abrirModalAntecedente(4)}}},[_vm._v("\n                    Nuevo antecedente personal "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped table-sm",staticStyle:{"width":"100%"},attrs:{"border":"","data":_vm.antecedentesPer,"max-height":"330"}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AntDes","label":"Descripción"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"185"}})],1)],1),_vm._v(" "),_c('v-tab',{attrs:{"title":'Familiares ( ' + _vm.antecedentesFam.length + ' )'}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[(_vm.estado == 1)?_c('button',{staticClass:"btn btn-success btn-fill btn-block",on:{"click":function($event){return _vm.abrirModalAntecedente(5)}}},[_vm._v("\n                    Nuevo antecedente familiar "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped table-sm",staticStyle:{"width":"100%"},attrs:{"border":"","data":_vm.antecedentesFam,"max-height":"500"}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AntDes","label":"Descripción"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"185"}})],1)],1)],1)],2),_vm._v(" "),_c('v-tab',{attrs:{"title":"Impresión General"}},[_c('template',{slot:"title"},[_c('p',[(_vm.impresionHoy == false)?_c('i',{staticClass:"fa fa-close texto_rojo"}):_c('i',{staticClass:"ti ti-check texto_verde"}),_vm._v("\n              Impresión General\n            ")])]),_vm._v(" "),_c('center',[_c('h4',{staticStyle:{"margin":"0px","margin-top":"-3px"}},[_vm._v("\n              Impresión general\n              "),_c('span',{staticClass:"badge badge-success"},[_vm._v(_vm._s(_vm.arrayResumen.length))])])]),_vm._v(" "),(_vm.estado == 1)?_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"float":"left","margin-bottom":"5px","border-radius":"5px","margin-top":"15px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.abriModalAnamnesis()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Nueva observación\n          ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"el-table table-striped el-table--fit el-table--enable-row-hover el-table--enable-row-transition",staticStyle:{"margin-top":"30px"},attrs:{"max-height":"500","border":"","data":_vm.arrayResumen}},[_c('el-table-column',{attrs:{"label":"#","width":"70","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fecha","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.ResFec)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ResDes","label":"Descripción"}})],1)],2),_vm._v(" "),_c('v-tab',{attrs:{"title":"Examen Paciente"}},[_c('template',{slot:"title"},[_c('p',[(_vm.examenHoy == false)?_c('i',{staticClass:"fa fa-close texto_rojo"}):_c('i',{staticClass:"ti ti-check texto_verde"}),_vm._v("\n              Examen Paciente\n            ")])]),_vm._v(" "),_c('center',[_c('strong',{staticStyle:{"color":"grey","font-size":"18px"}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Seleccione el exámen\n            ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.examen),expression:"examen"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.examen=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.tipoExamen()}]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Seleccionar...")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("\n                Formato de evaluación de terapia ocupacional (AVANZA)\n              ")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("\n                Formato de evaluación psicología niños\n              ")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("\n                Formato de evaluación fonoaudiólogia función oral faringea\n              ")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("\n                Formato de evaluación fonoaudiólogia lenguaje\n              ")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("\n                Examen fisico basado en neurodesarrollo (AVANZA)\n              ")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("\n                Evaluación de la desorganización postural\n              ")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("\n                Formato de evaluación musculoesquelética\n              ")]),_vm._v(" "),_c('option',{attrs:{"value":"8","disabled":""}},[_vm._v("Psicología adulto")]),_vm._v(" "),_c('option',{attrs:{"value":"9","disabled":""}},[_vm._v("Evaluación cognitiva")]),_vm._v(" "),_c('option',{attrs:{"value":"10","disabled":""}},[_vm._v("Evaluación comportamental")]),_vm._v(" "),_c('option',{attrs:{"value":"11","disabled":""}},[_vm._v("Revisión por sistemas")]),_vm._v(" "),_c('option',{attrs:{"value":"12","disabled":""}},[_vm._v("Actualización historia clínica")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("Desempeño ocupacional")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("EAT. 1O")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("Formato miofuncional")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("Formato conductual niños")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("Formato psicoterapia adultos")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("Formato RH niños")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("Formato rehabilitación Cog. Adultos")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("Formato test articular")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("Formato test lectoescritura")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.link_examen_selecte!='#' && _vm.examen != 0)?_c('a',{staticClass:"btn btn-secondary btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"href":_vm.link_examen_selecte,"target":"_blank"}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Descargar formato")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.examen != 0)?_c('div',{},[_c('div',{},[_c('div',{staticClass:"col-md-5"},[_c('center',[(_vm.estado == 1)?_c('input',{staticClass:"form-control",attrs:{"type":"file","id":"examen1"},on:{"change":_vm.cargarExamen}}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.estado == 1)?_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.agregarExamen()}}},[_c('i',{staticClass:"fa fa-save"}),_vm._v(" Guardar examen\n                  ")]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-success btn-sm btn-fill",staticStyle:{"border-radius":"5px","float":"left"},on:{"click":function($event){return _vm.examenes()}}},[_vm._v("\n                      Actualizar examenes\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(_vm.examen != 0)?_c('el-table',{staticClass:"table-striped",staticStyle:{"margin-top":"12px"},attrs:{"border":"","data":_vm.arrayActivo}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"Fecha y Hora"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',[_vm._v(_vm._s(props.row.created_at))])]}}],null,false,731343835)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Ver Examen"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-icon btn-xs",staticStyle:{"color":"grey"},attrs:{"target":"_blank","href":_vm.ip + '' + props.row.ExaUrl}},[_c('i',{staticClass:"ti-eye"})])]}}],null,false,1368333934)})],1):_vm._e()],1)])],2),_vm._v(" "),_c('v-tab',{attrs:{"title":"Conclusiones, Recomendación Y Plan De Tto"}},[_c('template',{slot:"title"},[_c('p',[(_vm.tratamientoHoy == false)?_c('i',{staticClass:"fa fa-close texto_rojo"}):_c('i',{staticClass:"ti ti-check texto_verde"}),_vm._v("\n              Conclusiones, Recomendación Y Plan De Tto\n            ")])]),_vm._v(" "),_c('center',[_c('h4',{staticStyle:{"margin":"0px","margin-top":"-3px"}},[_vm._v("\n              Conclusiones, recomendación y plan de Tto\n              "),_c('span',{staticClass:"badge badge-success"},[_vm._v(_vm._s(_vm.tratamiento.length))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"float":"left","margin-bottom":"5px","border-radius":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.abriModalNuevoPlan()}}},[_vm._v("\n            Nuevo plan de tratamiento "),_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped",staticStyle:{"margin-top":"15px"},attrs:{"data":_vm.tratamiento,"border":""}},[_c('el-table-column',{attrs:{"label":"Fecha inicial","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.TraFec))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fecha Fin","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.TraFecFin == null)?_c('p',[_vm._v("Indefinido")]):_c('p',[_vm._v(_vm._s(props.row.TraFecFin))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"TraDes","label":"Observaciones"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"90","label":"Detalle"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-simple btn-icon btn-xs",staticStyle:{"color":"grey"},attrs:{"title":"Informe de evaluación"},on:{"click":function($event){return _vm.verDetalle(props.row)}}},[_c('i',{staticClass:"ti-eye"})])])]}}])})],1)],2),_vm._v(" "),_c('v-tab',{attrs:{"title":"Plan Intervención Terapéutica"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicialEvoluciones),expression:"fechaInicialEvoluciones"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaInicialEvoluciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicialEvoluciones=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinalEvoluciones),expression:"fechaFinalEvoluciones"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaFinalEvoluciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinalEvoluciones=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-success pull-left",on:{"click":function($event){return _vm.getEvoluciones(_vm.PacIde)}}},[_vm._v("Consultar información")])])]),_vm._v(" "),_c('div',{staticClass:"card-content p-4 table-responsive table-full-width"},[_c('el-table',{staticClass:"table-striped",attrs:{"max-height":"500","border":"","data":_vm.evoluciones}},[_c('el-table-column',{attrs:{"label":"Terapeuta","prop":"EvoTer","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Evolución","width":"520","prop":"Obs"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Est. terapéutica"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(
                      props.row.Obs == 'Se hizo una evaluación del paciente'
                    )?_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v("\n                    Evaluación\n                  ")]):_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v("\n                    "+_vm._s(props.row.EvoEst)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fecha","prop":"EvoFec"}})],1)],1)])],1)],1)]),_vm._v(" "),_c('modal',{attrs:{"name":"modalVerificarFirmaElectronica","width":"500","height":"auto","persistent":"true"}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_vm._v("Verificar firma electronica")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_c('span',{staticStyle:{"font-weight":"600"}},[_vm._v("Digita tu firma electronica!")]),_vm._v(" "),_c('br'),_vm._v("\n          Verifica la firma electronica para validar los registros que hagas en la historia clinica de los pacientes.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-size":"12px"}},[_c('span',{staticStyle:{"font-weight":"600"}},[_vm._v("Recuerda:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("La firma electronica es de uso personal, recomendarlos no guardarla en el navegador.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputFirma),expression:"inputFirma"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"********"},domProps:{"value":(_vm.inputFirma)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputFirma=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.verificarFirmaElectronica()}}},[_vm._v("Verificar firma")])])])])]),_vm._v(" "),_c('modal',{attrs:{"name":"modalActualizarDiagnostico","width":"500","height":"auto"}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("ACTUALIZAR DIAGNOSTICO")]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("Actualizar diagnóstico")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"})]),_vm._v(" "),_c('div',[_c('modal',{attrs:{"name":"modalAgregar","width":"500","height":"auto"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.nuevoMotivoConsultaVerificado()}}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[(_vm.e_motivo == true)?_c('i',{staticClass:"fa fa-file"}):_vm._e(),_vm._v(" "),(_vm.e_motivo == false)?_c('i',{staticClass:"fa fa-spinner",staticStyle:{"font-size":"37px !important"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[(_vm.e_motivo == true)?_c('p',{staticClass:"titulo-modal"},[_vm._v("\n                NUEVO MOTIVO DE CONSULTA\n              ")]):_vm._e(),_vm._v(" "),(_vm.e_motivo == false)?_c('p',{staticClass:"titulo-modal"},[_vm._v("\n                ENVIANDO INFORMACIÓN\n              ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("Motivo de consulta verificado")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body scroll-gg"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de la consulta:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaDeConsulta),expression:"fechaDeConsulta"}],staticClass:"form-control select-sm",attrs:{"type":"date","disabled":""},domProps:{"value":(_vm.fechaDeConsulta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaDeConsulta=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{},[_c('label',{attrs:{"for":""}},[_vm._v("Motivo de la consulta:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivosConsulta),expression:"motivosConsulta"}],staticClass:"form-control",attrs:{"required":"","id":"","maxlength":"500","cols":"20","rows":"6"},domProps:{"value":(_vm.motivosConsulta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motivosConsulta=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",staticStyle:{"width":"100%"},attrs:{"multiple":true,"size":"large","max-height":"350","placeholder":"Seleccione...","required":""},model:{value:(_vm.tmconsulta),callback:function ($$v) {_vm.tmconsulta=$$v},expression:"tmconsulta"}},_vm._l((_vm.optionsArray),function(option){return _c('el-option',{key:option.DomDes,staticClass:"select-default",attrs:{"value":option.DomDes,"label":option.DomDes}},[_vm._v(_vm._s(option.DomDes))])}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Observaciones:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.consultaVerificada),expression:"consultaVerificada"}],staticClass:"form-control",attrs:{"name":"","required":"","cols":"30","rows":"6","maxlength":"500"},domProps:{"value":(_vm.consultaVerificada)},on:{"input":function($event){if($event.target.composing){ return; }_vm.consultaVerificada=$event.target.value}}})],1)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.cerrarModalMotivo()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" Cancelar\n          ")]),_vm._v(" "),(_vm.e_motivo == true)?_c('button',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit","data-dismiss":"modal"}},[_vm._v("\n            Guardar  "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(_vm.e_motivo == false)?_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button","disabled":"","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-spinner"}),_vm._v(" Guardando...\n          ")]):_vm._e()])])])],1),_vm._v(" "),_c('modal',{attrs:{"name":"modalDetallesMC","tabindex":"-1","role":"dialog","aria-hidden":"true","width":"500","height":"auto","draggable":true}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-file"})]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("VER DETALLES DEL MOTIVO DE CONSULTA")]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("Motivo detallado")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de la consulta:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivoVerificarFec),expression:"motivoVerificarFec"}],staticClass:"form-control",attrs:{"type":"date","disabled":""},domProps:{"value":(_vm.motivoVerificarFec)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motivoVerificarFec=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Motivo de la consulta:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivoVerificarDes),expression:"motivoVerificarDes"}],staticClass:"form-control",attrs:{"disabled":"","id":"","cols":"30","rows":"3"},domProps:{"value":(_vm.motivoVerificarDes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motivoVerificarDes=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaVerificado),expression:"fechaVerificado"}],staticClass:"form-control",attrs:{"type":"date","disabled":""},domProps:{"value":(_vm.fechaVerificado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaVerificado=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('el-select',{staticClass:"select-default",staticStyle:{"width":"100%","color":"white"},attrs:{"disabled":"","multiple":"","size":"large","placeholder":"Seleccione..."},model:{value:(_vm.tmconsulta),callback:function ($$v) {_vm.tmconsulta=$$v},expression:"tmconsulta"}},_vm._l((_vm.optionsArray),function(option){return _c('el-option',{key:option.DomId,staticClass:"select-default",attrs:{"value":option.DomDes,"label":option.DomDes}})}),1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.consultaVerificada),expression:"consultaVerificada"}],staticClass:"form-control",attrs:{"name":"","disabled":"","cols":"30","rows":"3"},domProps:{"value":(_vm.consultaVerificada)},on:{"input":function($event){if($event.target.composing){ return; }_vm.consultaVerificada=$event.target.value}}}),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"modal-footer"})]),_vm._v(" "),_c('modal',{attrs:{"name":"modalVerificarMC","tabindex":"-1","role":"dialog","aria-hidden":"true","width":"500","height":"auto","draggable":true}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("VERIFICAR MOTIVO DE CONSULTA")]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("Verificación del motivo de consulta")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de la consulta:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivoVerificarFec),expression:"motivoVerificarFec"}],staticClass:"form-control",attrs:{"type":"date","disabled":""},domProps:{"value":(_vm.motivoVerificarFec)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motivoVerificarFec=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Motivo de la consulta:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivoVerificarDes),expression:"motivoVerificarDes"}],staticClass:"form-control",attrs:{"disabled":"","id":"","cols":"30","rows":"3"},domProps:{"value":(_vm.motivoVerificarDes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motivoVerificarDes=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaVerificado),expression:"fechaVerificado"}],staticClass:"form-control",attrs:{"type":"date","disabled":""},domProps:{"value":(_vm.fechaVerificado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaVerificado=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('el-select',{staticClass:"select-default",staticStyle:{"width":"100%","color":"white"},attrs:{"multiple":"","size":"large","placeholder":"Seleccione..."},model:{value:(_vm.tmconsulta),callback:function ($$v) {_vm.tmconsulta=$$v},expression:"tmconsulta"}},_vm._l((_vm.optionsArray),function(option){return _c('el-option',{key:option.DomDes,staticClass:"select-default",attrs:{"value":option.DomDes,"label":option.DomDes}})}),1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Observaciones:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.consultaVerificada),expression:"consultaVerificada"}],staticClass:"form-control",attrs:{"name":"","cols":"30","rows":"3"},domProps:{"value":(_vm.consultaVerificada)},on:{"input":function($event){if($event.target.composing){ return; }_vm.consultaVerificada=$event.target.value}}}),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary btn-sm",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.cerrarModalMotivoVerificar()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" Cancelar\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.verificarMotivo()}}},[_vm._v("\n        Guardar "),_c('i',{staticClass:"fa fa-plus"})])])]),_vm._v(" "),_c('modal',{attrs:{"name":"nuevoAntecedente","height":"auto","draggable":true}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.nuevoAntecedente()}}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[(_vm.e_antecedente == true)?_c('i',{staticClass:"fa fa-backward"}):_vm._e(),_vm._v(" "),(_vm.e_antecedente == false)?_c('i',{staticClass:"fa fa-spinner",staticStyle:{"font-size":"37px !important"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[(_vm.e_antecedente == true)?_c('p',{staticClass:"titulo-modal"},[_vm._v("\n              NUEVO ANTECEDENTE\n            ")]):_vm._e(),_vm._v(" "),(_vm.e_antecedente == false)?_c('p',{staticClass:"titulo-modal"},[_vm._v("\n              ENVIANDO INFORMACIÓN\n            ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("Registrar antecedentes del paciente")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('label',{attrs:{"for":""}},[_vm._v("Descripción del antecedente:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.descripcionAntecedente),expression:"descripcionAntecedente"}],staticClass:"form-control",attrs:{"name":"","id":"","cols":"30","rows":"5","required":""},domProps:{"value":(_vm.descripcionAntecedente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descripcionAntecedente=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModalNuevoAntecedente()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v("Cancelar\n        ")]),_vm._v(" "),(_vm.e_antecedente == true)?_c('button',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit"}},[_vm._v("\n           Guardar "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(_vm.e_antecedente == false)?_c('button',{staticClass:"btn btn-success",attrs:{"disabled":""}},[_c('i',{staticClass:"fa fa-spinner"}),_vm._v(" Guardarando...\n        ")]):_vm._e()])])]),_vm._v(" "),_c('modal',{attrs:{"name":"modalAnamnesis","width":"700","height":"auto","draggable":true,"reset":true}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.nuevoResumen()}}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[(_vm.e_resumen == true)?_c('i',{staticClass:"fa fa-file"}):_vm._e(),_vm._v(" "),(_vm.e_resumen == false)?_c('i',{staticClass:"fa fa-spinner",staticStyle:{"font-size":"37px !important"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[(_vm.e_resumen == true)?_c('strong',{staticClass:"titulo-modal"},[_vm._v("\n              NUEVA OBSERVACIÓN\n            ")]):_vm._e(),_vm._v(" "),(_vm.e_resumen == false)?_c('strong',{staticClass:"titulo-modal"},[_vm._v("\n              ENVIANDO INFORMACIÓN\n            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('label',[_vm._v("Observación general:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.descripcionResumen),expression:"descripcionResumen"}],staticClass:"form-control",attrs:{"required":"","id":"","cols":"30","rows":"10"},domProps:{"value":(_vm.descripcionResumen)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descripcionResumen=$event.target.value}}}),_vm._v("\n        "+_vm._s(_vm.descripcionResumen.length)+"/ 30.000\n        "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.cerrarModalResumen()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v("Cancelar\n        ")]),_vm._v(" "),(_vm.e_resumen == true)?_c('button',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit"}},[_vm._v("\n          Guardar "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(_vm.e_resumen == false)?_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button","disabled":""}},[_c('i',{staticClass:"fa fa-spinner"}),_vm._v("Guardando...\n        ")]):_vm._e()])])]),_vm._v(" "),_c('modal',{attrs:{"name":"modaleditardx","draggable":false,"height":"300","width":"600","reset":true}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-file"})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("Editar DX")]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("Editar Dx (CIE10) del paciente")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body scroll-gg"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('form',[_c('el-select',{staticClass:"select-default",staticStyle:{"width":"100%","color":"white"},attrs:{"multiple":"","size":"large","placeholder":"Seleccione...","filterable":"","remote":""},model:{value:(_vm.dxedit),callback:function ($$v) {_vm.dxedit=$$v},expression:"dxedit"}},_vm._l((_vm.arrayCie10),function(option){return _c('el-option',{key:option.DomIde,staticClass:"select-primary",attrs:{"value":option.DomDes,"label":option.DomDes}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[(_vm.estado == 1)?_c('button',{staticClass:"btn btn-success btn-sm",on:{"click":function($event){return _vm.editDX()}}},[_vm._v("\n                Actualizar DX "),_c('i',{staticClass:"fa fa-pencil"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.cerrarPrepararEditDx()}}},[_vm._v("\n                Cancelar "),_c('i',{staticClass:"fa fa-close"})])])],1)])])])]),_vm._v(" "),_c('modal',{attrs:{"name":"modalNuevoPlan","draggable":true,"height":"auto","width":"800","scrollable":true,"reset":true}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.nuevoPlanTratamiento()}}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[(_vm.e_tratamiento == true)?_c('i',{staticClass:"fa fa-file"}):_vm._e(),_vm._v(" "),(_vm.e_tratamiento == false)?_c('i',{staticClass:"fa fa-spinner",staticStyle:{"font-size":"50px !important"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[(_vm.e_tratamiento == true)?_c('strong',{staticClass:"titulo-modal"},[_vm._v("\n              NUEVO PLAN DE TRATAMIENTO\n            ")]):_vm._e(),_vm._v(" "),(_vm.e_tratamiento == false)?_c('strong',{staticClass:"titulo-modal"},[_vm._v("\n              ENVIANDO INFORMACIÓN\n            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"modal-body scroll-gg"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"fechaTratamiento"}},[_vm._v("Fecha inicial del tratamiento:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaTratamiento),expression:"fechaTratamiento"}],staticClass:"form-control",attrs:{"type":"date","required":"","id":"fechaTratamiento"},domProps:{"value":(_vm.fechaTratamiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaTratamiento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"fechaFinTratamiento"}},[_vm._v("Fecha fin del tratamiento:")]),_vm._v(" "),(_vm.indefinido == false)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinTratamiento),expression:"fechaFinTratamiento"}],staticClass:"form-control",attrs:{"type":"date","id":"fechaFinTratamiento"},domProps:{"value":(_vm.fechaFinTratamiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinTratamiento=$event.target.value}}}):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.indefinido),expression:"indefinido"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.indefinido)?_vm._i(_vm.indefinido,null)>-1:(_vm.indefinido)},on:{"change":function($event){var $$a=_vm.indefinido,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.indefinido=$$a.concat([$$v]))}else{$$i>-1&&(_vm.indefinido=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.indefinido=$$c}}}}),_vm._v(" Indefinido\n          ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"conclusiones_t"}},[_vm._v("Conclusiones:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.descripcionTratamiento),expression:"descripcionTratamiento"}],staticClass:"form-control input-sm",attrs:{"name":"","id":"conclusiones_t","cols":"30","rows":"6","required":""},domProps:{"value":(_vm.descripcionTratamiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descripcionTratamiento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"conclusiones_t"}},[_vm._v("Recomendaciones:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.recomendacionesTratamiento),expression:"recomendacionesTratamiento"}],staticClass:"form-control input-sm",attrs:{"name":"","id":"conclusiones_t","cols":"30","rows":"6","required":""},domProps:{"value":(_vm.recomendacionesTratamiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.recomendacionesTratamiento=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"10px"}},[_c('strong',[_vm._v("Terapias y sesiones recomendadas:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('Label',[_vm._v("Seleccione el periodo de las sesiones:")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',{attrs:{"for":"p1"}},[_vm._v("Semanal")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.periodoPT),expression:"periodoPT"}],attrs:{"type":"radio","id":"p1","value":"1"},domProps:{"checked":_vm._q(_vm.periodoPT,"1")},on:{"change":function($event){_vm.periodoPT="1"}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',{attrs:{"for":"p2"}},[_vm._v("Mensual")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.periodoPT),expression:"periodoPT"}],attrs:{"type":"radio","id":"p2","value":"2"},domProps:{"checked":_vm._q(_vm.periodoPT,"2")},on:{"change":function($event){_vm.periodoPT="2"}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('label',{attrs:{"for":"especialidadtratamiento"}},[_vm._v("Especialidad:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.especialidad),expression:"especialidad"}],staticClass:"form-control",attrs:{"name":"","id":"especialidadtratamiento"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.especialidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayEspecialidades),function(especialidad){return _c('option',{key:especialidad.EspCod,domProps:{"value":[especialidad.EspCod, especialidad.EspNom],"textContent":_vm._s(especialidad.EspNom)}})}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"sesionestratamiento"}},[_vm._v("Sesiones:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sesiones),expression:"sesiones"}],staticClass:"form-control",attrs:{"type":"number","id":"sesionestratamiento"},domProps:{"value":(_vm.sesiones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sesiones=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1",staticStyle:{"padding-top":"25px"}},[_c('button',{staticClass:"btn btn-success btn-fill",attrs:{"type":"button"},on:{"click":function($event){return _vm.nuevaEspecialidad()}}},[_c('i',{staticClass:"fa fa-plus"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"el-table table-striped el-table--fit el-table--enable-row-hover el-table--enable-row-transition",attrs:{"id":"example"}},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("Cups")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("Especialidad")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("Sesiones")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.arrayEspecialidad),function(tratamiento,index){return _c('tr',{key:tratamiento.EspNom},[_c('td',{staticStyle:{"text-align":"center"},domProps:{"textContent":_vm._s(tratamiento.especialidad)}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"},domProps:{"textContent":_vm._s(tratamiento.nombre)}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"},domProps:{"textContent":_vm._s(tratamiento.sesiones)}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove",on:{"click":function($event){return _vm.eliminarServicio(index)}}},[_c('i',{staticClass:"ti-close"})])])])}),0)])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.cerrarModalNuevoPlan()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" Cancelar\n        ")]),_vm._v(" "),(_vm.e_tratamiento == true && _vm.arrayEspecialidad != '')?_c('button',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit"}},[_vm._v("\n           Guardar "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(_vm.e_tratamiento == true && _vm.arrayEspecialidad == '')?_c('button',{staticClass:"btn btn-success btn-fill",attrs:{"type":"button","disabled":""}},[_vm._v("\n          Guardar  "),_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(_vm.e_tratamiento == false)?_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","disabled":""}},[_c('i',{staticClass:"fa fa-spinner"}),_vm._v(" Guardando...\n        ")]):_vm._e()])])]),_vm._v(" "),_c('modal',{attrs:{"name":"pdfEva","height":"auto","width":"800"}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-file"})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("Exportar informe de evaluación")]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("Generar informe de evaluación")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body scroll"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Motivo de consulta verificado:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivoPDF),expression:"motivoPDF"}],staticClass:"form-control",attrs:{"cols":"30","rows":"5"},domProps:{"value":(_vm.motivoPDF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motivoPDF=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Antecedentes prenatales:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.antecedentesPrePDF),expression:"antecedentesPrePDF"}],staticClass:"form-control",domProps:{"value":(_vm.antecedentesPrePDF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.antecedentesPrePDF=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Antecedentes posnatales:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.antecedentesPosPDF),expression:"antecedentesPosPDF"}],staticClass:"form-control",domProps:{"value":(_vm.antecedentesPosPDF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.antecedentesPosPDF=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Antecedentes perinatales:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.antecedentesNeoPDF),expression:"antecedentesNeoPDF"}],staticClass:"form-control",domProps:{"value":(_vm.antecedentesNeoPDF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.antecedentesNeoPDF=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Antecedentes personales:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.antecedentesPerPDF),expression:"antecedentesPerPDF"}],staticClass:"form-control",domProps:{"value":(_vm.antecedentesPerPDF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.antecedentesPerPDF=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Antecedentes familiares:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.antecedentesFamPDF),expression:"antecedentesFamPDF"}],staticClass:"form-control",domProps:{"value":(_vm.antecedentesFamPDF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.antecedentesFamPDF=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Impresión general:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.impresionesPDF),expression:"impresionesPDF"}],staticClass:"form-control",attrs:{"cols":"30","rows":"5"},domProps:{"value":(_vm.impresionesPDF)},on:{"input":function($event){if($event.target.composing){ return; }_vm.impresionesPDF=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Conclusiones:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.descripcionTratamiento),expression:"descripcionTratamiento"}],staticClass:"form-control",attrs:{"cols":"30","rows":"5"},domProps:{"value":(_vm.descripcionTratamiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descripcionTratamiento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Recomendación:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.recomendacionesTratamiento),expression:"recomendacionesTratamiento"}],staticClass:"form-control",attrs:{"cols":"30","rows":"5"},domProps:{"value":(_vm.recomendacionesTratamiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.recomendacionesTratamiento=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger btn-fill",staticStyle:{"margin":"1%","border-radius":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModalpdf()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" Cerrar\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"margin":"1%","border-radius":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.generarInforme()}}},[_c('i',{staticClass:"fa fa-file",staticStyle:{"font-size":"12px !important"}}),_vm._v(" Generar\n        Informe\n      ")]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('modal',{attrs:{"name":"modalNuevoPlanDetalle","height":"auto","width":"800","scrollable":true,"reset":true}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-file"})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("VER DETALLES DEL TRATAMIENTO")]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("\n            Plan de tratamiento del paciente detallado\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body scroll"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha inicial del tratamiento:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaTratamiento),expression:"fechaTratamiento"}],staticClass:"form-control",attrs:{"type":"date","readonly":""},domProps:{"value":(_vm.fechaTratamiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaTratamiento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha fin del tratamiento:")]),_vm._v(" "),(_vm.fechaFinTratamiento!=null)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinTratamiento),expression:"fechaFinTratamiento"}],staticClass:"form-control",attrs:{"type":"date","readonly":""},domProps:{"value":(_vm.fechaFinTratamiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinTratamiento=$event.target.value}}}):_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":"","value":"Tratamiento indefinido"}})]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('hr',{staticClass:"py-4"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("DX:")]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"rows":"8","readonly":""},domProps:{"value":_vm.cie10mostrar}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v(" "),_c('strong',{staticStyle:{"color":"grey","font-size":"20px"}},[_vm._v("Terapias y sesiones:")]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('br'),_vm._v(" "),_c('table',{staticClass:"el-table table-striped el-table--fit el-table--enable-row-hover el-table--enable-row-transition table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("Especialidad")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("Sesiones")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.arrayDetalle),function(tratamiento){return _c('tr',{key:tratamiento.EspNom},[_c('td',{staticStyle:{"text-align":"center"},domProps:{"textContent":_vm._s(tratamiento.EspNom)}}),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"},domProps:{"textContent":_vm._s(tratamiento.TraEspSes)}})])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Conclusiones:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.descripcionTratamiento),expression:"descripcionTratamiento"}],staticClass:"form-control",attrs:{"readonly":"","cols":"30","rows":"4"},domProps:{"value":(_vm.descripcionTratamiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descripcionTratamiento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("recomendaciones:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.recomendacionesTratamiento),expression:"recomendacionesTratamiento"}],staticClass:"form-control",attrs:{"readonly":"","cols":"30","rows":"4"},domProps:{"value":(_vm.recomendacionesTratamiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.recomendacionesTratamiento=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary btn-fill",staticStyle:{"border-radius":"10px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModalDetallePlan()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" Cerrar\n      ")]),_vm._v(" "),_c('br')])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('option',{attrs:{"value":"paciente.PacApe1"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Apellidos del paciente\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-xs-12 col-md-2"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-success btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Buscar\n            ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "47VP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechainicial"}},[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","name":"fechainicial","id":"fechainicial"},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechafinal"}},[_vm._v("Fecha final:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","name":"fechaFinal","id":"fechafinal"},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}})]),_vm._v(" "),(_vm.rol == 1)?_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Sede:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sede),expression:"sede"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sede=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.SedesProgramacion),function(sede){return _c('option',{key:sede.sede,domProps:{"value":sede.sede}},[_vm._v("\n                "+_vm._s(sede.sede)+"\n              ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("..")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.getData()}}},[_vm._v("\n            Buscar "),_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("fff")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-excel btn-lg btn-fill",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"My Worksheet","name":'Reporte-objetivos-y-logros' +
              '-' +
              _vm.fechaInicial +
              '-' +
              '-' +
              _vm.fechaFinal}},[_vm._v("\n            Exportar a excel "),_c('i',{staticClass:"fa fa-file"})]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.data == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-responsive",attrs:{"border":"","data":_vm.data,"size":"mini"}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label}})}),1)],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-file",staticStyle:{"font-size":"50px","color":"grey"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-11",staticStyle:{"margin":"0","padding":"0"}},[_c('h4',{staticClass:"title-card"},[_vm._v("Reporte de objetivos y logros")]),_vm._v(" "),_c('span',[_vm._v("Gestiona los objetivos y logros")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4OLZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__global_services_arrayToText__ = __webpack_require__("jfmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_jspdf__ = __webpack_require__("3h9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jspdf_autotable__ = __webpack_require__("+2xD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_jspdf_autotable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_jspdf_autotable__);



























__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },

  data: function data() {
    return {
      ip: "https://avanti-erp.com/",
      type_report: "paciente",
      rol: localStorage.getItem("rol"),
      sede: localStorage.getItem("sede"),
      SedesProgramacion: [],
      searchQuery: "",
      value: "",
      logo: "",
      fechaValoracion: "",
      listPacientes: [],
      listTerapeutas: [],
      initialDate: "",
      endDate: "",
      queriedData2: [],
      tableColumns: [{
        prop: "fecha",
        label: "Fecha",
        minWidth: 70 }, {
        prop: "terapeuta",
        label: "Terapeuta",
        minWidth: 100
      }, {
        prop: "tipo",
        label: "Tipo",
        minWidth: 50
      }],

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      tiposDocumento: {
        NUIP: "NUIP",
        "CÉDULA DE CIUDADANIA": "CC",
        PASAPORTE: "PA",
        "TARJETA DE IDENTIDAD": "TI",
        "CEDULA DE EXTRANJERIA": "CE",
        "REGISTRO CIVIL": "RC",
        NIT: "NI",
        RUT: "RUT",
        "PERMISO POR PROTECCIÓN TEMPORAL": "PPT"
      },
      textoEjemplo: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
    };
  },

  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_16_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },

  methods: {
    getInfoPDF: function getInfoPDF(valoracion) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var paciente, motivos, resumen, tratamiento, firmas, firmasCordinacion, antecedentes, examenes, response, antecedentesAgrupados;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                paciente = [];
                motivos = [];
                resumen = [];
                tratamiento = [];
                firmas = [];
                firmasCordinacion = [];
                antecedentes = [];
                examenes = [];


                _this2.fechaValoracion = valoracion.fecha;
                _context.prev = 9;

                _this2.$modal.show("carga");
                _context.next = 13;
                return __WEBPACK_IMPORTED_MODULE_19_src_global_services_axiosInstance__["a" /* default */].get("api/reportes/informacion-reporte-evaluacion/" + valoracion.idPaciente + "/" + valoracion.fecha);

              case 13:
                response = _context.sent;

                if (!(response.data.mensaje == "Faltan examenes para poder exportar")) {
                  _context.next = 20;
                  break;
                }

                _this2.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__["a" /* default */])("danger", response.data.mensaje));
                _this2.$modal.hide("carga");
                return _context.abrupt("return");

              case 20:
                paciente = response.data.dataPaciente;
                motivos = response.data.dataMotivo;
                resumen = response.data.dataResumen;
                tratamiento = response.data.dataTratamiento;
                _this2.logo = response.data.logo;
                firmas = response.data.firmas;
                firmasCordinacion = response.data.firmasCordinacion;
                antecedentesAgrupados = response.data.antecedentes.reduce(function (acc, antecedente) {
                  if (!acc[antecedente.tipo]) {
                    acc[antecedente.tipo] = [];
                  }
                  acc[antecedente.tipo].push({ descripcion: antecedente.descripcion });
                  return acc;
                }, {});


                antecedentes = antecedentesAgrupados;
                examenes = response.data.examenes;

              case 30:
                _context.next = 35;
                break;

              case 32:
                _context.prev = 32;
                _context.t0 = _context["catch"](9);

                console.log("Error al obtener los datos:" + _context.t0);

              case 35:
                _context.prev = 35;

                _this2.generarPDF(paciente, motivos, resumen, tratamiento, firmas, firmasCordinacion, antecedentes, examenes);
                _this2.$modal.hide("carga");
                return _context.finish(35);

              case 39:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[9, 32, 35, 39]]);
      }))();
    },


    generarPDF: function generarPDF(paciente, motivo, resumen, tratamiento, firmas, firmasCordinacion, antecedentes, examenes) {
      var _this3 = this;

      if (resumen === null || resumen.length < 1) {
        alert('El paciente no tiene valoraciones registradas');
      }
      var doc = new __WEBPACK_IMPORTED_MODULE_20_jspdf__["jsPDF"]();

      var headerHeight = 35;
      var footerHeight = 35;
      var pageHeight = doc.internal.pageSize.height;
      var pageWidth = doc.internal.pageSize.getWidth();
      var anchoTexto = 180;
      var lineHeight = 4;

      var startX = 15;
      var startY = headerHeight + 20;
      var logo = this.logo;

      var addHeader = function addHeader(doc) {
        doc.addImage(logo, "png", 0, 0, 210, 40);
      };

      var addFooter = function addFooter(doc) {
        var fechaTexto = new Date().toLocaleDateString();
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        doc.text("Avanti", pageWidth / 2, pageHeight - footerHeight + 7, {
          align: "center"
        });
        doc.text("Fecha impresi\xF3n: " + fechaTexto, pageWidth / 2, pageHeight - footerHeight + 10, { align: "center" });
      };

      var addSignature = function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(doc, firmas, firmasCordinacion) {
          var imageWidth, imageHeight, margin, yPosition, todasFirmas;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  imageWidth = 60;
                  imageHeight = 15;
                  margin = 5;
                  yPosition = startY;
                  todasFirmas = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(firmas), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(firmasCordinacion));


                  todasFirmas.forEach(function (imageData) {
                    console.log(footerHeight, 'footer');
                    if (imageData.CamFir1 == null || imageData.CamFir1 == '') {
                      return 'ERROR';
                    }

                    var xPosition = pageWidth / 2;
                    if (yPosition + imageHeight + margin + footerHeight > pageHeight) {
                      doc.addPage();
                      yPosition = 15;
                      addFooter(doc);
                    }

                    doc.setFontSize(12);
                    doc.setFont("helvetica", "bold");
                    doc.setTextColor("#000000");
                    doc.text(imageData.nombreTerapeuta.toUpperCase(), xPosition, yPosition + imageHeight + 5, {
                      align: "center"
                    });
                    yPosition += 5 + 0;
                    doc.setFontSize(10);
                    doc.setFont("helvetica", "normal");
                    doc.setTextColor(100);
                    doc.text(imageData.CamFir1, xPosition, yPosition + imageHeight + 5, {
                      align: "center"
                    });
                    if (imageData.CamFir2 != null) {
                      yPosition += 6 + 0;
                      doc.setFontSize(10);
                      doc.setFont("helvetica", "normal");
                      doc.setTextColor(100);
                      doc.text(imageData.CamFir2, xPosition, yPosition + imageHeight + 5, {
                        align: "center"
                      });
                    }
                    if (imageData.CamFir3 != null) {
                      yPosition += 6 + 0;
                      doc.setFontSize(8);
                      doc.setFont("helvetica", "normal");
                      doc.setTextColor(100);
                      doc.text(imageData.CamFir3, xPosition, yPosition + imageHeight + 5, {
                        align: "center"
                      });
                    }
                    yPosition += imageHeight + margin;
                  });

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this3);
        }));

        return function addSignature(_x, _x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }();

      var checkPageSpace = function checkPageSpace(yPos) {
        var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        if (yPos + lineHeight + extra >= pageHeight - footerHeight) {
          doc.addPage();
          addFooter(doc);
          startY = 15;
        }
      };

      function renderJustifiedLine(line, x, y, maxWidth) {
        var newLine = line.replace(/\s+/g, " ");
        var words = newLine.split(" ");
        var wordCount = words.length;

        if (wordCount <= 300) {
          doc.text(line, x, y);
          return;
        }

        var totalWordsWidth = words.reduce(function (total, word) {
          return total + doc.getTextWidth(word);
        }, 0);
        var spaceWidth = (maxWidth - totalWordsWidth) / (wordCount - 1);
        var currentX = x;

        words.forEach(function (word, index) {
          doc.text(word, currentX, y);
          if (index < wordCount - 1) {
            currentX += doc.getTextWidth(word) + spaceWidth;
          }
        });
      }

      var renderJustifiedText = function renderJustifiedText(text) {
        var lines = doc.splitTextToSize(text, anchoTexto);
        lines.forEach(function (line) {
          checkPageSpace(startY);
          doc.setFontSize(10);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          renderJustifiedLine(line, startX, startY, anchoTexto);
          startY += lineHeight;
        });
      };

      addHeader(doc);
      addFooter(doc);

      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("DATOS PERSONALES", pageWidth / 2, startY, { align: "center" });
      startY += 5;

      var tableData = [[{
        content: "NOMBRE DEL PACIENTE",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: paciente[0].nombrePaciente + " " + paciente[0].apellidoPaciente,
        styles: { fontSize: 10 },
        colSpan: 3
      }], [{
        content: "FECHA DE NACIMIENTO",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: paciente[0].fechaNacimiento,
        styles: { fontSize: 10 }
      }, {
        content: "EDAD:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: this.calcularEdad(paciente[0].fechaNacimiento),
        styles: { fontSize: 10 }
      }], [{
        content: "TIPO DE IDENTIFICACIÓN",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: this.tiposDocumento[paciente[0].tipoDocumento],
        styles: { fontSize: 10 }
      }, {
        content: "NUMERO DE DOCUMENTO",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: parseFloat(paciente[0].numeroDocumento).toLocaleString("es-ES"),
        styles: { fontSize: 10 }
      }], [{
        content: "ESTADO CIVIL",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: 'SOLTERO/A',
        styles: { fontSize: 10 }
      }, {
        content: "SEXO",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: paciente[0].sexo == 1 ? "MASCULINO" : "FEMENINO",
        styles: { fontSize: 10 }
      }], [{
        content: "OCUPACIÓN",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: 'ESTUDIANTE',
        styles: { fontSize: 10 }
      }, {
        content: "DIRECCIÓN",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: paciente[0].direccion != null ? paciente[0].direccion : "SIN DIRECCIÓN",
        styles: { fontSize: 10 }
      }], [{
        content: "TELEFONO",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: paciente[0].telefono != null ? paciente[0].telefono : "SIN TELÉFONO",
        styles: { fontSize: 10 }
      }, {
        content: "LUGAR DE RESIDENCIA",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: paciente[0].ciudad,
        styles: { fontSize: 10 }
      }], [{
        content: "NOMBRE DEL ACUDIENTE",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: paciente[0].acudiente != null ? paciente[0].acudiente : "SIN ACUDIENTE",
        styles: { fontSize: 10 }
      }, {
        content: "TELEFONO DEL ACUDIENTE",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: paciente[0].telefonoAcudiente != null ? paciente[0].telefonoAcudiente : "SIN TELÉFONO",
        styles: { fontSize: 10 }
      }], [{
        content: "ENTIDAD ASEGURADORA",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: paciente[0].entidad,
        styles: { fontSize: 10 }
      }, {
        content: "TIPO DE AFILIACIÓN",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: paciente[0].regimen == 1 ? "CONTRIBUTIVO" : "SUBSIDIADO",
        styles: { fontSize: 10 }
      }], [{
        content: "DIAGNÓSTICO (S) MÉDICO (S):",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: paciente[0].diagnostico != null ? paciente[0].diagnostico : "Sin diagnóstico",
        styles: { fontSize: 10 },
        colSpan: 3
      }], [{
        content: "FECHA DE VALORACIÓN:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: this.fechaValoracion,
        styles: { fontSize: 10 },
        colSpan: 3
      }]];

      doc.autoTable({
        startY: startY,
        theme: "grid",
        body: tableData,
        margin: { top: headerHeight + 15, bottom: footerHeight + 20 },
        styles: {
          fontSize: 10,
          cellPadding: { top: 2, bottom: 2, left: 2, right: 2 }
        },
        pageBreak: "auto"
      });

      startY = doc.lastAutoTable.finalY + 10;
      checkPageSpace(startY);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("ANTECEDENTES", pageWidth / 2, startY, { align: "center" });
      startY += 8;

      var tiposAntecedentes = {
        1: 'Prenatales',
        2: 'Neonatales',
        3: 'Posnatales',
        4: 'Personales',
        5: 'Familiares'
      };

      var antecedentesTablaData = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(antecedentes).forEach(function (tipo) {
        antecedentesTablaData.push([{
          content: tiposAntecedentes[tipo],
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: antecedentes[tipo].length > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__global_services_arrayToText__["a" /* default */])(antecedentes[tipo], "descripcion") : "",
          styles: { fontSize: 10 }
        }]);
      });

      doc.autoTable({
        startY: startY,
        theme: "grid",
        body: antecedentesTablaData,
        margin: { top: 15, bottom: footerHeight + 25 },
        styles: {
          fontSize: 8,
          cellPadding: { top: 2, bottom: 2, left: 2, right: 2 }
        }

      });

      startY = doc.lastAutoTable.finalY + 10;

      checkPageSpace(startY);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("EXAMENES REALIZADOS", pageWidth / 2, startY, { align: "center" });
      startY += 8;

      var labelExamen = ['', 'Formato de evaluación de terapia ocupacional (AVANZA)', 'Formato de evaluación psicología niños', 'Formato de evaluación fonoaudiólogia función oral faringea', 'Formato de evaluación fonoaudiólogia lenguaje', 'Examen fisico basado en neurodesarrollo (AVANZA)', 'Evaluación de la desorganización postural', 'Formato de evaluación musculoesquelética', 'Psicología adulto', 'Evaluación cognitiva', 'Evaluación comportamental', 'Revisión por sistemas', 'Actualización historia clínica', 'Desempeño ocupacional', 'EAT. 10', 'Formato miofuncional', 'Formato conductual niños', 'Formato psicoterapia adultos', 'Formato RH niños', 'Formato rehabilitación cog. adultos', 'Formato test articular', 'Formato test lectoescritura'];

      var examenesTabla = [];
      examenes.forEach(function (item) {
        examenesTabla.push([{
          content: labelExamen[item.tipo],
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }]);
      });

      if (examenesTabla.length > 0) {
        doc.autoTable({
          startY: startY,
          theme: "grid",
          body: examenesTabla,
          margin: { top: 15, bottom: footerHeight + 20 },
          styles: {
            fontSize: 8,
            cellPadding: { top: 2, bottom: 2, left: 2, right: 2 }
          },
          pageBreak: "auto"
        });
      } else {
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor("#000000");
        doc.text("No se han realizado examenes", pageWidth / 2, startY, { align: "center" });
      }

      if (examenesTabla.length > 0) {
        startY = doc.lastAutoTable.finalY + 30;
      } else {
        startY += 20;
      }
      checkPageSpace(startY + 15);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("MOTIVO CONSULTA", pageWidth / 2, startY, { align: "center" });
      startY += 15;

      motivo.forEach(function (mov) {
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        renderJustifiedText(mov.MotDes);
        startY += lineHeight;
        renderJustifiedText(mov.MotVer);
        startY += lineHeight;
      });
      startY += 15;
      checkPageSpace(startY);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("VALORACIÓN CLÍNICA", pageWidth / 2, startY, {
        align: "center"
      });
      startY += 10;

      resumen.forEach(function (res) {
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        renderJustifiedText(res.ResDes);
        startY += 4;
        doc.text(res.terapeuta, startX, startY);
        startY += 3;
        doc.line(15, startY, 193, startY);
        startY += 10;
      });
      startY += 30;
      checkPageSpace(startY);
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("PLAN DE TRATAMIENTO", pageWidth / 2, startY, {
        align: "center"
      });
      startY += 8;

      checkPageSpace(startY);
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("CONCLUSIONES:", 14, startY);
      startY += 10;

      tratamiento.forEach(function (item) {
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        renderJustifiedText(item.TraDes);
        startY += 5;
      });
      startY += 10;

      checkPageSpace(startY);
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#000000");
      doc.text("RECOMENDACIONES:", 14, startY);
      startY += 10;

      tratamiento.forEach(function (item) {
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        renderJustifiedText(item.TraActFam);
        startY += 5;
      });
      startY += 10;

      var pageCount = doc.internal.getNumberOfPages();
      for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        var pageLabel = "Pag " + i + " de " + pageCount;
        var textWidth = doc.getTextWidth(pageLabel);
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        doc.text(pageLabel, (pageWidth - textWidth) / 2, pageHeight - footerHeight + 13);
      }
      var addSignatureValidation = addSignature(doc, firmas, firmasCordinacion);
      if (addSignatureValidation === 'ERROR') {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__["a" /* default */])("danger", "El terapeuta no tiene firma registrada"));
        this.$modal.hide("carga");
        return;
      }

      var nombreArchivo = ("valoracion_" + paciente[0].nombrePaciente + "_" + paciente[0].apellidoPaciente).toLowerCase().replace(/\s+/g, "_").replace(/[^\w_]/g, "");

      doc.save(nombreArchivo + ".pdf");
    },

    getEvents: function getEvents() {
      var _this4 = this;

      if (this.value == "") {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__["a" /* default */])("danger", "Parámetros incompletos para la búsqueda"));
        return;
      }

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/reportes/evaluaciones/" + this.value;
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(BASE_URL, config).then(function (res) {
        var datos = res.data.data.map(function (element) {
          return {
            fecha: element.fecha,
            terapeuta: element.nombreTerapeuta,
            auxiliar: "N/A",
            idPaciente: element.idPaciente,
            tipo: element.tipo == "Evaluacion" ? "Evaluación" : "Reevaluación",
            estado: element.estado
          };
        });
        _this4.queriedData2 = datos;
        _this4.$modal.hide("carga");
      }).catch(function (err) {
        _this4.$modal.hide("carga");
        console.log(err);
      });
    },

    calcularEdad: function calcularEdad(fecha) {
      var fechaNacimiento = fecha;
      var values = fechaNacimiento.split("-");
      var dia = values[2];
      var mes = values[1];
      var ano = values[0];

      var fecha_hoy = new Date();
      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;


      var edad = ahora_ano + 0 - ano;
      if (ahora_mes < mes) {
        edad--;
      }
      if (mes == ahora_mes && ahora_dia < dia) {
        edad--;
      }
      if (edad > 1900) {
        edad -= 1900;
      }

      var meses = 0;
      if (ahora_mes > mes) meses = ahora_mes - mes;
      if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
      if (ahora_mes == mes && dia > ahora_dia) meses = 11;

      var dias = 0;
      if (ahora_dia > dia) dias = ahora_dia - dia;
      if (ahora_dia < dia) {
        var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
        var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
      }

      return edad + " a\xF1o(s) y " + meses + " mes(es)";
    },


    getListPacientes: function getListPacientes() {
      var _this5 = this;

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var sede = this.sede;
      var BASE_URL = this.ip + "api/list-pacientes/" + sede;
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this5.$modal.hide("carga");
        _this5.listPacientes = res.data.data;
      }).catch(function (err) {
        _this5.$modal.hide("carga");
        alert("Ocurrió un error al traer los eventos, por favor comunique al administrador. ERROR: " + err);
        console.log(err);
      });
    },

    selectTerapeutas: function selectTerapeutas(especialidad) {
      var _this6 = this;

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/selectTerapeutasProgramar/" + especialidad;
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this6.$modal.hide("carga");
        _this6.listTerapeutas = res.data.data;
      }).catch(function (err) {
        _this6.$modal.hide("carga");
        console.log(err);
      });
    },
    cambiarSede: function cambiarSede() {
      this.getListPacientes();
    },
    emailsProgramacion: function emailsProgramacion() {
      var _this7 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/emailsProgramacion";
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this7.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },

  mounted: function mounted() {
    this.getListPacientes();
    this.selectTerapeutas(1);
    this.emailsProgramacion();
  }
});

/***/ }),

/***/ "4OcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
















__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip: "https://avanti-erp.com/",
      descripcion: "",
      tipo: 1,
      arrayPatologias: [],
      modalRegistrar: 0,

      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },

      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["DomDes"],
      tableColumns: [{
        prop: "DomDes",
        label: "Nombre",
        minWidth: 400 }],
      json_cie10: {
        "Codigo CIE 10": "cod_pat",
        'descripción': "DomDes"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]]
    };
  },

  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedData: function pagedData() {
      return this.arrayPatologias.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.arrayPatologias.length;
        return this.pagedData;
      }
      var result = this.arrayPatologias.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.arrayPatologias.length;
      return this.arrayPatologias.length;
    }
  },

  methods: {
    nuevoDominio: function nuevoDominio() {
      var _this2 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var vm = this;
      var url = this.ip + "api/nuevoDominio";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(url, {
        descripcion: this.descripcion,
        tipo: this.tipo
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this2.$notify({
          component: {
            template: " <div style=\"padding: 3%;\">\n              <span><b> REGISTRADO CON \xC9XITO </b>.</span>\n              </div>\n              "
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this2.type[color]
        });
        _this2.modalRegistrar = 0;
        _this2.tipo = 1;
        _this2.descripcion = "";
        _this2.patologias();
      }).catch(function (error) {
        console.log(error);
      });
    },
    patologias: function patologias() {
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var vm = this;
      var url = this.ip + "api/patologias";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(url, config).then(function (response) {
        vm.arrayPatologias = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    limpiarFormulario: function limpiarFormulario() {
      this.descripcion = "";
      this.tipo = 1;
    },
    desactivar: function desactivar() {
      var _this3 = this;

      var patologia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/desactivarDominio";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url, {
        id: patologia.DomIde
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this3.$notify({
          component: {
            template: " <div style=\"padding: 3%;\">\n              <span><b> DESACTIVADO CON \xC9XITO </b>.</span>\n              </div>\n              "
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this3.type[color]
        });
        _this3.patologias();
      }).catch(function (error) {
        console.log(error);
      });
    },
    activar: function activar() {
      var _this4 = this;

      var patologia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/activarDominio";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url, {
        id: patologia.DomIde
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this4.$notify({
          component: {
            template: " <div style=\"padding: 3%;\">\n              <span><b> ACTIVADA CON \xC9XITO </b>.</span>\n              </div>\n              "
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this4.type[color]
        });
        _this4.patologias();
      }).catch(function (error) {
        console.log(error);
      });
    },
    abrirModal: function abrirModal() {
      this.modalRegistrar = 1;
    }
  },
  mounted: function mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.patologias();
    }
  }
});

/***/ }),

/***/ "4SI9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal',{attrs:{"name":"gestionar","draggable":false,"width":"800","height":"auto","reset":true}},[_c('br'),_vm._v(" "),_c('div',[_c('div',[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"5px","padding-top":"0"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"ti-settings text-success",staticStyle:{"font-size":"47px"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("GESTIONAR PERMISOS")]),_vm._v(" "),(_vm.rolActivo!='')?_c('p',{staticClass:"texto-pequeno"},[_vm._v("Gestionar permisos para el rol "),_c('strong',[_vm._v(_vm._s(_vm.rolActivo.nombre.toUpperCase()))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"scroll"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('tr',[_c('th',[_vm._v("\n                        Modulo\n                      ")]),_vm._v(" "),_c('th',[_vm._v("\n                        Submodulo\n                      ")]),_vm._v(" "),_c('th',[_vm._v("\n                        Acceso?\n                      ")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.permisosRolVar),function(permiso,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n                        "+_vm._s(permiso.modulo)+"\n                      ")]),_vm._v(" "),_c('td',[_vm._v("\n                        "+_vm._s(permiso.name)+"\n                      ")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.permisosRolVar[index].estado),expression:"permisosRolVar[index].estado"}],staticClass:"select-sm from-control",domProps:{"value":permiso.estado},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.permisosRolVar[index], "estado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.update(permiso)}]}},[_c('option',{domProps:{"value":1}},[_vm._v("Si")]),_vm._v(" "),_c('option',{domProps:{"value":0}},[_vm._v("No")])])])])}),0)])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"padding-bottom":"0"}},[_c('button',{staticClass:"btn btn-danger btn-block btn-icon btn-simple",attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModal()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" CERRAR\n          ")])]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('center',[_c('h4',[_vm._v("Gestión de Roles Y Permisos")])])],1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"else":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Estado","minWidth":40},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.estado == 1)?_c('div',[_c('span',{staticClass:"label label-success",attrs:{"slot":"title-label"},slot:"title-label"},[_c('i',{staticClass:"ti-bell"}),_vm._v(" Activo\n                  ")])]):_c('div',[_c('span',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_c('i',{staticClass:"ti-power-off"}),_vm._v(" Inactivo\n                  ")])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","minWidth":40,"label":"Acciones"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.estado == 2)?_c('button',{staticClass:"btn btn-simple btn-info btn-icon check",on:{"click":function($event){return _vm.activar(props.row)}}},[_c('i',{staticClass:"ti-check"})]):_c('button',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit",on:{"click":function($event){return _vm.desactivar(props.row)}}},[_c('i',{staticClass:"ti-close"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-xs btn-success",on:{"click":function($event){return _vm.abrirModal(props.row)}}},[_c('i',{staticClass:"fa fa-pencil"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.nuevoRol.apply(null, arguments)}}},[_c('div',{staticClass:"col-md-12"},[_c('small',[_vm._v("Rol:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}})]),_vm._v(" "),_vm._m(0)])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-block btn-sm",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Nuevo Rol\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4f0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
















__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip: 'https://avanti-erp.com/',
      descripcion: "",
      tipo: 36,
      modalRegistrar: 0,

      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      },

      pagination: {
        perPage: 7,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['DomDes'],
      tableColumns: [{
        prop: 'DomDes',
        label: 'Nombre',
        minWidth: 150 }],
      arrayMotivo: []

    };
  },


  computed: {
    pagedData: function pagedData() {
      return this.arrayMotivo.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.arrayMotivo.length;
        return this.pagedData;
      }
      var result = this.arrayMotivo.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.arrayMotivo.length;
      return this.arrayMotivo.length;
    }
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },

  methods: {
    abrirModal: function abrirModal() {
      this.modalRegistrar = 1;
    },
    nuevoDominio: function nuevoDominio() {
      var _this2 = this;

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + 'api/nuevoDominio';
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(url, {
        descripcion: this.descripcion,
        tipo: this.tipo
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this2.$notify({
          component: {
            template: ' <div style="padding: 3%;">\n              <span><b> REGISTRADO CON \xC9XITO </b>.</span>\n              </div>\n              '
          },
          icon: 'ti-check',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: _this2.type[color]
        });
        _this2.tipo = 36;
        _this2.descripcion = "";
        _this2.modalRegistrar = 0;

        _this2.materiales();
      }).catch(function (error) {
        console.log(error);
      });
    },
    desactivar: function desactivar() {
      var _this3 = this;

      var patologia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + 'api/desactivarDominio';
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url, {
        id: patologia.DomIde
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this3.$notify({
          component: {
            template: ' <div style="padding: 3%;">\n              <span><b> DESACTIVADO CON \xC9XITO </b>.</span>\n              </div>\n              '
          },
          icon: 'ti-check',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: _this3.type[color]
        });
        _this3.materiales();
      }).catch(function (error) {
        console.log(error);
      });
    },
    activar: function activar() {
      var _this4 = this;

      var patologia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + 'api/activarDominio';
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url, {
        id: patologia.DomIde
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this4.$notify({
          component: {
            template: ' <div style="padding: 3%;">\n              <span><b> ACTIVADO CON \xC9XITO </b>.</span>\n              </div>\n              '
          },
          icon: 'ti-check',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: _this4.type[color]
        });
        _this4.materiales();
      }).catch(function (error) {
        console.log(error);
      });
    },
    materiales: function materiales() {
      var _this5 = this;

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + "api/allMateriales";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(url, config).then(function (response) {
        _this5.arrayMotivo = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    limpiarFormulario: function limpiarFormulario() {
      this.descripcion = "";
      this.tipo = 36;
    }
  },
  mounted: function mounted() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/');
    } else {
      this.materiales();
    }
  }
});

/***/ }),

/***/ "4tkk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mantenimiento_motivo_consulta_vue__ = __webpack_require__("hqCP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2a42022_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mantenimiento_motivo_consulta_vue__ = __webpack_require__("58Kf");
function injectStyle (ssrContext) {
  __webpack_require__("gjVO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mantenimiento_motivo_consulta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2a42022_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mantenimiento_motivo_consulta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "58Kf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.abrirModal()}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Nuevo motivo de consulta")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",staticStyle:{"width":"220%"},attrs:{"type":"search","placeholder":"Buscar motivo...","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped table-responsive",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":"","max-height":"400"}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"else":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":50,"label":"Estado"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.DomEst==1)?_c('p',{staticClass:"label label-success",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n                    activa\n                ")]):_c('p',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("Inactiva")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"fixed":"right","label":"Acc"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.DomEst==2)?_c('button',{staticClass:"btn btn-simple btn-xs btn-info btn-icon check",on:{"click":function($event){return _vm.activar(props.row)}}},[_c('i',{staticClass:"ti-check"})]):_c('button',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit",on:{"click":function($event){return _vm.desactivar(props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Mostrando del "+_vm._s(_vm.from + 1)+" al "+_vm._s(_vm.to)+" de "+_vm._s(_vm.total)+" registros")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"modal fade",class:{'mostrar' : _vm.modalRegistrar},attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header CM",staticStyle:{"padding":"8px"}},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.modalRegistrar=0}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.nuevoDominio.apply(null, arguments)}}},[_c('label',{attrs:{"for":""}},[_vm._v("Codigo:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Descripcion:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.descripcion),expression:"descripcion"}],staticClass:"form-control",attrs:{"required":"","cols":"30","rows":"3"},domProps:{"value":(_vm.descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descripcion=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar motivo de consulta\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.limpiarFormulario()}}},[_c('i',{staticClass:"ti-close"})])])],1)]),_vm._v(" "),_c('center'),_vm._v(" "),_c('br')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                      Nuevo motivo de consulta\n                  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5F1N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal',{attrs:{"adaptive":true,"scrollable":true,"name":"hello-world","height":"700","width":"800"}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-folder",staticStyle:{"font-size":"47px !important","color":"grey"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('p',{staticClass:"text-primary",staticStyle:{"margin-bottom":"-4px"}},[_c('strong',[_vm._v("DETALLE DE LA")]),_vm._v(" "),(_vm.formato == 1)?_c('strong',[_vm._v("AUTORIZACIÓN")]):_vm._e(),_vm._v(" "),(_vm.formato == 0)?_c('strong',[_vm._v("ORDEN MÉDICA")]):_vm._e(),_vm._v(" "),(_vm.formato == 2)?_c('strong',[_vm._v("SERVICIO PARTICULAR")]):_vm._e(),_vm._v(" "),(_vm.formato == 3)?_c('strong',[_vm._v("CONVENIO")]):_vm._e()]),_vm._v(" "),_c('p',{staticStyle:{"color":"grey"}},[_vm._v(_vm._s(_vm.servicioSeleccionado))])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.cerrarModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"min-height":"80%","height":"80%","max-height":"80%","overflow-y":"scroll"}},[_c('div',[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"title-card-detail"},[_vm._v("Nombre completo del paciente")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.nombreSeleccionado))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"title-card-detail"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Fecha de expedición ")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("date")(_vm.fechaSeleccionada)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"title-card-detail"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" Fecha de vencimiento ")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm._f("date")(_vm.fechaVencimientoSeleccionada)))])]),_vm._v(" "),(_vm.tipoOrden == 'particular' || _vm.tipoOrden == 'adm')?_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"title-card-detail"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Observaciones ")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.observaciones))])]):_vm._e(),_vm._v(" "),(_vm.tipoOrden == 'particular')?_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"title-card-detail"},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Nombre del cliente ")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.nombre_cliente))])]):_vm._e(),_vm._v(" "),(_vm.tipoOrden === 'adm')?_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"title-card-detail"},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Dato ")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-info"}),_vm._v("\n                Esta autorización fue ingresada como \"codigo 90\" por:\n                "+_vm._s(_vm.usuarioOrden)+"\n              ")])]):_vm._e()]),_vm._v(" "),(_vm.formato == 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"text-primary"},[_vm._v("Servicios ordenados")]),_vm._v(" "),(_vm.arrayServiciosOrden != [])?_c('el-table',{staticClass:"table-responsive",attrs:{"data":_vm.arrayServiciosOrden,"border":""}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"EspNom","label":"Servicio"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"OrdEspSes","label":"Cantidad","width":"130"}})],1):_c('h1',[_vm._v("Cargado datos...")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"text-primary"},[_vm._v("Autorizaciones de la orden")]),_vm._v(" "),_c('el-table',{staticClass:"table-responsive",staticStyle:{"width":"100%"},attrs:{"data":_vm.arrayAutorizaciones,"border":""}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"OrdCod","label":"Servicio"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"OrdFec","label":"Fecha"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"OrdVen","label":"Fecha de vencimiento"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-success btn-xs btn-icon like",on:{"click":function($event){return _vm.verServiciosAutorizacion(props.row)}}},[_c('i',{staticClass:"fa fa-eye"})])]}}],null,false,390635669)})],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.arrayServiciosAutorizacion != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('h4',{staticClass:"text-primary"},[_vm._v("Servicios autorizados")]),_vm._v(" "),_c('el-table',{staticClass:"table-responsive table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.arrayServiciosAutorizacion,"border":""}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"EspNom","label":"Servicio"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"OrdEspSes","label":"Cantidad autorizada"}})],1)],1)]):_vm._e()]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('center',[_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModal()}}},[_vm._v("\n            Cerrar ventana\n          ")])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Buscar..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-danger",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.ordenes()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Recargar datos\n    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-sm-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Cantidad de registros:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-striped table-responsive",staticStyle:{"margin-top":"20px","width":"100%"},attrs:{"data":_vm.queriedData,"max-height":"500","border":""}},[_c('el-table-column',{attrs:{"min-width":"350","label":"Paciente"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_vm._v(_vm._s(props.row.PacApe1)+" "+_vm._s(props.row.PacNom1))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"160","label":"Tipo"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.OrdFor == 0)?_c('p',[_vm._v("ORDEN MÉDICA")]):_vm._e(),_vm._v(" "),(props.row.OrdFor == 1)?_c('p',[_vm._v("AUTORIZACIÓN")]):_vm._e()]}}])}),_vm._v(" "),_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"220","label":"Fecha de expedición"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_vm._v(" "+_vm._s(_vm._f("date")(props.row.OrdFec))+" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"220","label":"Fecha de vencimiento"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_vm._v(" "+_vm._s(_vm._f("date")(props.row.OrdVen))+" ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"220","label":"Dias para vencimiento"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_vm._v(" "+_vm._s(_vm._f("diasFaltantes")(props.row.OrdVen))+" dia(s)")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"130","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('button',{staticClass:"btn btn-success btn-sm",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.abrirModal(props.row)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Ver más...\n              ")])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n          Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]),_vm._v(" "),_c('div')])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5cTF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6HyH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6IEP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionGastoNomina_vue__ = __webpack_require__("f0v9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ca4f9c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionGastoNomina_vue__ = __webpack_require__("fRTS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionGastoNomina_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ca4f9c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionGastoNomina_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6Sr7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.obtenerInformacionDeEvoluciones(_vm.fechaInicial, _vm.fechaFinal)}}},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","required":"","id":"fechaInicial"},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha final:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","required":"","id":"fechaInicial"},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"card",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"row"},[_c('center',[(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e()])],1),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{ref:"component",staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill mb-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"evoluciones sin logro de objetivo","name":("Evoluciones sin logro - " + _vm.fechaInicial + " -- " + _vm.fechaFinal)}},[_vm._v("\n            Exportar a excel "),_c('i',{staticClass:"fa fa-download",attrs:{"color":"black"}})]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive mt-2",attrs:{"border":"","data":_vm.queriedData}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row[column.prop]))])]}}],null,true)})}),1)],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Información de las evoluciones sin logro de objetivo")]),_vm._v(" "),_c('p',[_vm._v("\n            Aquí podrá gestionar la información relacionada con las\n            "),_c('span',{staticClass:"text-success"},[_vm._v("evoluciones sin logro de objetivo")]),_vm._v("\n            de "),_c('span',{staticClass:"text-success"},[_vm._v("Avanza")]),_vm._v(" por fecha\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit","value":"Buscar información"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6V8M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "721n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_aDashboard_nomina_informacionDia_vue__ = __webpack_require__("Br7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_aDashboard_nomina_informacionGastoNomina_vue__ = __webpack_require__("6IEP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_aDashboard_nomina_informacionGastos_vue__ = __webpack_require__("rK8S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_aDashboard_nomina_informacionFechas_vue__ = __webpack_require__("2cm6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_aDashboard_nomina_informacionEntidad_vue__ = __webpack_require__("hoIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_aDashboard_nomina_informacionEspecialidad_vue__ = __webpack_require__("yQsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_aDashboard_nomina_informacionGastoTerapeutas_vue__ = __webpack_require__("hSpV");









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    dia: __WEBPACK_IMPORTED_MODULE_0_src_components_aDashboard_nomina_informacionDia_vue__["a" /* default */],
    nomina: __WEBPACK_IMPORTED_MODULE_1_src_components_aDashboard_nomina_informacionGastoNomina_vue__["a" /* default */],
    gastos: __WEBPACK_IMPORTED_MODULE_2_src_components_aDashboard_nomina_informacionGastos_vue__["a" /* default */],
    informacionfecha: __WEBPACK_IMPORTED_MODULE_3_src_components_aDashboard_nomina_informacionFechas_vue__["a" /* default */],
    informacionEntidad: __WEBPACK_IMPORTED_MODULE_4_src_components_aDashboard_nomina_informacionEntidad_vue__["a" /* default */],
    informacionEspecialidad: __WEBPACK_IMPORTED_MODULE_5_src_components_aDashboard_nomina_informacionEspecialidad_vue__["a" /* default */],
    informacionTerapeutas: __WEBPACK_IMPORTED_MODULE_6_src_components_aDashboard_nomina_informacionGastoTerapeutas_vue__["a" /* default */]
  },
  data: function data() {
    return {
      fechaInicial: '',
      fechaFinal: ''
    };
  },

  methods: {
    actualizarInformacion: function actualizarInformacion() {
      this.$refs.componenteNomina.getNomina();
      this.$refs.componenteGastos.getGastos(this.fechaInicial, this.fechaFinal);
      this.$refs.componenteInformacionFechas.getInformationFechas(this.fechaInicial, this.fechaFinal);
      this.$refs.componenteEntidades.getInformationEntidades(this.fechaInicial, this.fechaFinal);
      this.$refs.componenteEspecialidades.getInformationEspecialidades(this.fechaInicial, this.fechaFinal);
      this.$refs.componenteTerapeutas.getNominaTerapeutas(this.fechaInicial, this.fechaFinal);
    }
  }
});

/***/ }),

/***/ "72Uh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacion_paciente_vue__ = __webpack_require__("WTz9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45483dcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacion_paciente_vue__ = __webpack_require__("wQaI");
function injectStyle (ssrContext) {
  __webpack_require__("wiHQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacion_paciente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45483dcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacion_paciente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "74Vt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"formato"}},[_vm._v("Formato:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formato),expression:"formato"}],staticClass:"form-control",attrs:{"id":"formato"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.formato=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Autorización")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Orden médica")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Buscar por")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.criterio),expression:"criterio"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.criterio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"PacApe1"}},[_vm._v("Apellidos del paciente")]),_vm._v(" "),_c('option',{attrs:{"value":"PacNom1"}},[_vm._v("Nombres del paciente")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('label',{attrs:{"for":""}},[_vm._v("Buscar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Escribe lo que quieres buscar..."},domProps:{"value":(_vm.busqueda)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarPacientes()},"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-icon btn-success btn-simple",on:{"click":function($event){return _vm.buscarPacientes()}}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('center',[_c('br'),_vm._v(" "),(_vm.buscar == false)?_c('div',{staticClass:"row"},[_c('div',[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive",staticStyle:{"width":"97%"},attrs:{"data":_vm.arrayPacientes,"border":"","size":"mini"}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacApe1","label":"Apellidos"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNom1","label":"Nombres"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNumDoc","label":"Numero de documento"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"TipCliNom","label":"Tipo de cliente"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[(props.row.estado==1)?_c('a',{staticClass:"btn btn-simple btn-success btn-xs btn-icon like",on:{"click":function($event){return _vm.seleccionarPaciente(props.row)}}},[_c('i',{staticClass:"fa fa-check"})]):_c('small',{staticClass:"text-danger"},[_vm._v("INACTIVO")])])]}}],null,false,3267663566)})],1)],1)]):_vm._e()]),_vm._v(" "),(_vm.nombre != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}}),_vm._v(" "),(_vm.alertTipoCliente)?_c('small',{staticClass:"text-danger"},[_vm._v("El tipo de cliente no concueda con el modulo seleccionado")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Documento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documento),expression:"documento"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.documento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.documento=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.formato == 1)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('center',[_c('label',{attrs:{"for":""}},[_vm._v("Registrar como codigo 90")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('switches',{attrs:{"type-bold":"true","theme":"bootstrap","color":"success"},model:{value:(_vm.c90),callback:function ($$v) {_vm.c90=$$v},expression:"c90"}})],1)],1)]),_vm._v(" "),(_vm.c90 == false)?_c('div',{staticClass:"row"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.tablaOrden == true && _vm.c90 == false)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-responsive",staticStyle:{"width":"100%"},attrs:{"data":_vm.arrayOrdenes,"border":""}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"OrdCod","label":"Codigo"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"OrdFec","label":"Fecha"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"EpsNom","label":"Entidad"}}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.seleccionarOrden(props.row)}}},[_vm._v("\n             Seleccionar\n          ")])])]}}],null,false,4036370400)})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.c90 == false)?_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("N° de orden:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroOrden),expression:"numeroOrden"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.numeroOrden)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroOrden=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Entidad:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eps),expression:"eps"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.eps)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eps=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de expedición:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicion),expression:"fechaExpedicion"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.fechaExpedicion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de vencimiento:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaVencimiento),expression:"fechaVencimiento"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.fechaVencimiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaVencimiento=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("N° de autorización:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroAutorizacion),expression:"numeroAutorizacion"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.numeroAutorizacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"especialidad"}},[_vm._v("Especialidad")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.especialidad_autorizacion),expression:"especialidad_autorizacion"}],staticClass:"form-control",attrs:{"id":"especialidad"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.especialidad_autorizacion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("No aplica")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Psicologia")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Fisioterapia")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Fonoaudiologia")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Terapia ocupacional")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de expedición:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicionAutorizacion),expression:"fechaExpedicionAutorizacion"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaExpedicionAutorizacion)},on:{"change":function($event){return _vm.generarCodigoAutorizacion()},"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicionAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Cobertura:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.coberturaAutorizacion),expression:"coberturaAutorizacion"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.coberturaAutorizacion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"45"}},[_vm._v("45 Días")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("1 Mes")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("2 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("3 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"120"}},[_vm._v("4 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"150"}},[_vm._v("5 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"180"}},[_vm._v("6 Meses")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Observaciones:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.observaciones),expression:"observaciones"}],staticClass:"form-control",attrs:{"id":"observaciones","cols":"30","rows":"3"},domProps:{"value":(_vm.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.observaciones=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.formato == 2)?_c('div',{staticStyle:{"padding":"10px"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regimen),expression:"regimen"}],attrs:{"type":"radio","disabled":"","value":"1"},domProps:{"checked":_vm._q(_vm.regimen,"1")},on:{"change":function($event){_vm.regimen="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Contributivo")]),_vm._v("    \n      ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eps),expression:"eps"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.eps=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.generarCodigo()}]}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v("Seleccione la EPS...")]),_vm._v(" "),_vm._l((_vm.arrayPrepagada),function(eps){return _c('option',{key:eps.EpsCod,domProps:{"value":eps.EpsCod,"textContent":_vm._s(eps.EpsNom)}})})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroOrden),expression:"numeroOrden"}],staticClass:"form-control",attrs:{"type":"text","disabled":"","placeholder":"Numero de la orden"},domProps:{"value":(_vm.numeroOrden)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroOrden=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de expedición:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicion),expression:"fechaExpedicion"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaExpedicion)},on:{"change":function($event){return _vm.generarCodigo()},"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Cobertura")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cobertura),expression:"cobertura"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cobertura=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"45"}},[_vm._v("45 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("1 Mes")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("2 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("3 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"120"}},[_vm._v("4 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"150"}},[_vm._v("5 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"180"}},[_vm._v("6 Meses")])])])]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.agregarServicios.apply(null, arguments)}}},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Servicio")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.especialidad),expression:"especialidad"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.especialidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayEspecialidad),function(especialidad){return _c('option',{key:especialidad.EspCod,domProps:{"value":especialidad.EspCod}},[_vm._v("\n              "+_vm._s(especialidad.EspNom)+"\n            ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Cantidad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cantidad),expression:"cantidad"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.cantidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cantidad=$event.target.value}}})]),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.arrayCantidad != '')?_c('div',{staticClass:"row"},[_c('el-table',{staticClass:"table-responsive table-bordered",staticStyle:{"width":"50%"},attrs:{"data":_vm.arrayCantidad,"border":""}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"servicio","label":"Cups"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cantidad","label":"Cantidad"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove",on:{"click":function($event){return _vm.eliminarServicio(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}],null,false,31756203)})],1),_vm._v(" "),_c('br')],1):_vm._e(),_vm._v(" "),_c('center',[_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),(_vm.formato == 1 && _vm.c90 == true)?_c('button',{staticClass:"btn btn-success btn-sm btn-fill",on:{"click":function($event){return _vm.nuevaAutorizacionSinOM()}}},[_vm._v("\n          Registrar Autorización \"codigo 90\"\n        ")]):_vm._e(),_vm._v(" "),(_vm.formato == 1 && _vm.c90 == false)?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.nuevaAutorizacion()}}},[_vm._v("\n          Registrar Autorización\n        ")]):_vm._e(),_vm._v(" "),(_vm.formato == 2)?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.nuevaOrdenMedica()}}},[_vm._v("\n          Registrar Orden médica\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon",on:{"click":function($event){return _vm.cerrar()}}},[_vm._v("\n          Cancelar\n        ")])])])],1),_vm._v(" "),_c('br')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"bold","margin-bottom":"15px"}},[_vm._v("Selecciona al paciente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n          Información de la orden\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n        Información de la autorización\n        \n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n        Inoformacion de la orden\n      ")]),_vm._v(" "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n        Servicios\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-1"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("---")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-success",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "78iL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informeSesiones_vue__ = __webpack_require__("exEM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7773857e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informeSesiones_vue__ = __webpack_require__("An5X");
function injectStyle (ssrContext) {
  __webpack_require__("fGY8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informeSesiones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7773857e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informeSesiones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7T7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Terapeuta:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectTerapeuta),expression:"selectTerapeuta"}],staticClass:"form-control",attrs:{"name":"terapeuta","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectTerapeuta=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.optionTerapeuta),function(item){return _c('option',{key:item.id,domProps:{"value":item}},[_vm._v(_vm._s(item.nombres + ' ' + item.apellidos))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"margin-top":"8%"},on:{"click":function($event){return _vm.buscarInformacion()}}},[_vm._v("Buscar información")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{staticClass:"img-responsive img-ter img-thumbnail",staticStyle:{"border-radius":"10px"},attrs:{"src":_vm.foto,"alt":"imagen del terapeuta"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('center',[_c('h4',{staticClass:"nombre-ter"},[_vm._v(_vm._s(_vm.nombre)+" "),_c('i',{staticClass:"fa fa-circle",staticStyle:{"font-size":"7px"}}),_vm._v(" "),_c('span',{staticStyle:{"color":"#E3097E"}},[_vm._v(_vm._s(_vm.usuario))])])])],1)]),_vm._v(" "),(_vm.selectTerapeuta != '')?_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.card_dia2),function(card){return _c('div',{key:card.title,staticClass:"col-xs-12 col-sm-6 col-md-3"},[_c('stats-card',{staticStyle:{"box-shadow":"0px 0px 0px #999"}},[_c('div',{staticClass:"icon-big text-center",attrs:{"slot":"header"},slot:"header"},[(card.img != '')?_c('img',{attrs:{"src":card.img,"alt":card.title}}):_c('i',{class:card.icon,staticStyle:{"color":"#e3097e"}})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('strong',[_c('p',{staticStyle:{"color":"grey"}},[_vm._v(_vm._s(card.title))])]),_vm._v(" "),_c('strong',{staticStyle:{"font-size":"30px"}},[_vm._v(_vm._s(card.value))])])])],1)})],2):_vm._e(),_vm._v(" "),(_vm.selectTerapeuta != '')?_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-xs-10 col-md-7 caja-titulo"},[_c('strong',{staticClass:"card-title"},[_vm._v("Objetivos y logros próximos a cumplirse ( "+_vm._s(_vm.objetivosProximos.length)+" )")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.objetivosProximos != '')?_c('download-excel',{staticClass:"btn btn-success btn-fill btn-sm pull-left",staticStyle:{"border-radius":"0px"},attrs:{"data":_vm.objetivosProximos,"fields":_vm.json_fieldsProximos,"worksheet":"My Worksheet","name":'objetivosProximos' + _vm.fechaActual}},[_vm._v("\n                Exportar a excel\n              ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-warning btn-fill btn-sm",staticStyle:{"border-radius":"0px"},on:{"click":function($event){return _vm.push('diarioCampo/objetivos-y-logros')}}},[_vm._v("Gestionar Objetivos")])])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-striped table-condensed table-responsive",attrs:{"data":_vm.objetivosProximosPag,"size":"mini"}},[_c('el-table-column',{attrs:{"label":"Paciente","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('small',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.PacApe1 + " " + props.row.PacNom1))])]}}],null,false,3688149462)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fec. Ingreso","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.ObjFec))])]}}],null,false,1323213950)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fec. Finalización","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.ObjFecCum))])]}}],null,false,2910230565)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Objetivo","width":"440"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.ObjObj))])]}}],null,false,4252482329)})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.paginationProximo.perPage,"total":_vm.paginationProximo.total},model:{value:(_vm.paginationProximo.currentPage),callback:function ($$v) {_vm.$set(_vm.paginationProximo, "currentPage", $$v)},expression:"paginationProximo.currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-xs-8 col-md-7 caja-titulo"},[_c('strong',{staticClass:"card-title"},[_vm._v("Objetivos con estado \"Pendiente por confirmar\" ( "+_vm._s(_vm.objetivosPendientes.length)+" )")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.objetivosPendientes != '')?_c('download-excel',{staticClass:"btn btn-success btn-fill btn-sm pull-left",staticStyle:{"border-radius":"0px"},attrs:{"data":_vm.objetivosPendientes,"fields":_vm.json_fieldsProximos,"worksheet":"My Worksheet","name":'objetivosPendienteConfirmar' + _vm.fechaActual}},[_vm._v("\n                Exportar a excel\n              ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-warning btn-fill btn-sm",staticStyle:{"border-radius":"0px"},on:{"click":function($event){return _vm.push('diarioCampo/objetivos-y-logros')}}},[_vm._v("Gestionar Objetivos")])])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-striped table-condensed table-responsive",attrs:{"data":_vm.objetivosPendientesPag,"size":"mini"}},[_c('el-table-column',{attrs:{"label":"Paciente","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('small',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.PacApe1 + " " + props.row.PacNom1))])]}}],null,false,3688149462)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fec. Ingreso","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.ObjFec))])]}}],null,false,1323213950)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fec. Finalización","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.ObjFecCum))])]}}],null,false,2910230565)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Objetivo","width":"440"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.ObjObj))])]}}],null,false,4252482329)}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"left","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.ObjLog!=null)?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"orange"}}):_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red"}})]}}],null,false,3934119755)})],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.paginationPendiente.perPage,"total":_vm.paginationPendiente.total},model:{value:(_vm.paginationPendiente.currentPage),callback:function ($$v) {_vm.$set(_vm.paginationPendiente, "currentPage", $$v)},expression:"paginationPendiente.currentPage"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.selectTerapeuta != '')?_c('div',{staticClass:"row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-3",staticStyle:{"padding-top":"2%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchPaciente),expression:"searchPaciente"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Buscar paciente..."},domProps:{"value":(_vm.searchPaciente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchPaciente=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.pacientesCargo != '')?_c('download-excel',{staticClass:"btn btn-success btn-fill btn-sm pull-left",staticStyle:{"border-radius":"0px"},attrs:{"data":_vm.pacientesCargo,"fields":_vm.json_fieldsPacientes,"worksheet":"My Worksheet","name":'pacientesACargo' + _vm.fechaActual}},[_vm._v("\n                Exportar a excel\n              ")]):_vm._e()],1)]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-table',{staticClass:"el-table table-striped table-condensed table-responsive",attrs:{"data":_vm.pacientesCargoPag,"size":"mini"}},[_c('el-table-column',{attrs:{"label":"Nombres y Apellidos","width":"350"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticStyle:{"font-size":"13px","color":"grey"}},[_vm._v(_vm._s(props.row.PacApe1 + " " + props.row.PacNom1))])]}}],null,false,3606318538)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Edad","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(_vm.calcularEdad(props.row.PacFecNac)))])]}}],null,false,4150012517)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Numero de documento","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.PacNumDoc))])]}}],null,false,3026486677)}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"250","label":"DX"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.dx))])]}}],null,false,3020106981)})],1)],1),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.paginationPacienteCargo.perPage,"total":_vm.paginationPacienteCargo.total},model:{value:(_vm.paginationPacienteCargo.currentPage),callback:function ($$v) {_vm.$set(_vm.paginationPacienteCargo, "currentPage", $$v)},expression:"paginationPacienteCargo.currentPage"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.selectTerapeuta != '')?_c('div',{staticClass:"row"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"col-xs-10 col-md-10 caja-titulo"},[_c('strong',{staticClass:"card-title"},[_vm._v("Sesiones Realizadas "),(_vm.hisAtenciones.length>0)?_c('span',[_vm._v("( "+_vm._s(_vm.hisAtenciones.length)+" )")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('small',[_vm._v("Fecha inicio:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicioHis),expression:"fechaInicioHis"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaInicioHis)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicioHis=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('small',[_vm._v("Fecha fin:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinHis),expression:"fechaFinHis"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaFinHis)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinHis=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"white"}},[_vm._v("jj")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.selectTerapeuta != '')?_c('button',{staticClass:"btn btn-success",staticStyle:{"border-radius":"0px"},on:{"click":function($event){return _vm.hisSesiones()}}},[_vm._v("\n                Buscar atenciones\n                "),_c('i',{staticClass:"fa fa-search"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('small',{staticStyle:{"color":"white"}},[_vm._v("jj")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.hisAtenciones != '')?_c('download-excel',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"0px"},attrs:{"data":_vm.hisAtenciones,"fields":_vm.json_fieldsAtenciones,"worksheet":"My Worksheet","name":'sesionesRealizadas' + _vm.fechaActual}},[_vm._v("\n                Exportar a excel\n              ")]):_vm._e()],1)]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-table',{staticClass:"el-table table-striped table-condensed",attrs:{"data":_vm.sesionesRRPag}},[_c('el-table-column',{attrs:{"label":"Nombres y Apellidos","width":"400"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticStyle:{"font-size":"13px","color":"grey"}},[_vm._v(_vm._s(props.row.PacApe1 + " " + props.row.PacNom1))])]}}],null,false,3606318538)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Entidad del paciente","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticStyle:{"font-size":"13px","color":"grey"}},[_vm._v(_vm._s(props.row.entidad))])]}}],null,false,2768765281)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fecha de atención","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(_vm._f("date")(props.row.ProFec)))])]}}],null,false,1627292505)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Hora","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.hora))])]}}],null,false,1159172269)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Lugar"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.ProLug))])]}}],null,false,1311514538)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Tipo"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.ProTip))])]}}],null,false,3006082937)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Valor"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(_vm.formatearPesosColombianos(props.row.ProValTer)))])]}}],null,false,3241932952)})],1)],1),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.paginationSesionesRR.perPage,"total":_vm.paginationSesionesRR.total},model:{value:(_vm.paginationSesionesRR.currentPage),callback:function ($$v) {_vm.$set(_vm.paginationSesionesRR, "currentPage", $$v)},expression:"paginationSesionesRR.currentPage"}})],1)])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Sesiones realizadas hoy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Objetivos y logros")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-2 col-md-1"},[_c('img',{staticClass:"img-responsive img-header",attrs:{"src":"static/img/ICONOS/logro pendiente.svg","alt":"icono de avanti"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-2 col-md-1"},[_c('img',{staticClass:"img-responsive img-header",attrs:{"src":"static/img/ICONOS/logro.svg","alt":"icono de avanti"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Pacientes liderados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-2 col-md-1"},[_c('img',{staticClass:"img-responsive img-header",attrs:{"src":"static/img/ICONOS/lider paciente.svg","alt":"icono de avanti"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-10 col-md-8 caja-titulo"},[_c('strong',{staticClass:"card-title"},[_vm._v("Pacientes liderados ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Sesiones realizadas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-2 col-md-1"},[_c('img',{staticClass:"img-responsive img-header",attrs:{"src":"static/img/ICONOS/AARR.svg","alt":"icono de avanti"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7XvZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.clase,staticStyle:{"padding":"40px","border-radius":"10px","margin-bottom":"7px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-body"},[_c('center',[_c('p',{staticStyle:{"font-weight":"bold","font-size":"1.0rem"}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('center',[_c('p',{staticClass:"card-text",staticStyle:{"font-weight":"900","font-size":"3.5rem"}},[_vm._v(_vm._s(_vm.value))])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7smt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8FxQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"formato"}},[_vm._v("Formato:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formato),expression:"formato"}],staticClass:"form-control",attrs:{"id":"formato"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.formato=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Autorización")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Orden médica")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"buscarPacientePor"}},[_vm._v("Buscar por")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.criterio),expression:"criterio"}],staticClass:"form-control",attrs:{"id":"buscarPacientePor"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.criterio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"PacApe1"}},[_vm._v("Apellidos del paciente")]),_vm._v(" "),_c('option',{attrs:{"value":"PacNom1"}},[_vm._v("Nombres del paciente")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('label',{attrs:{"for":"buscarPaciente"}},[_vm._v("Buscar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Escribe lo que quieres buscar...","id":"buscarPaciente"},domProps:{"value":(_vm.busqueda)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarPacientes()},"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-icon btn-success btn-simple",on:{"click":function($event){return _vm.buscarPacientes()}}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[(_vm.buscar == false)?_c('div',{staticClass:"row"},[_c('div',[_c('el-table',{staticClass:"table-responsive",staticStyle:{"width":"97%"},attrs:{"data":_vm.arrayPacientes,"border":"","size":"mini"}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacApe1","label":"Apellidos"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNom1","label":"Nombres"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNumDoc","label":"N° documento"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"TipCliNom","label":"Tipo de cliente"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[(props.row.estado==1)?_c('a',{staticClass:"btn btn-simple btn-success btn-xs btn-icon like",on:{"click":function($event){return _vm.seleccionarPaciente(props.row)}}},[_c('i',{staticClass:"fa fa-check"})]):_c('small',{staticClass:"text-danger"},[_vm._v("INACTIVO")])])]}}],null,false,3267663566)})],1)],1)]):_vm._e()]),_vm._v(" "),(_vm.nombre != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}}),_vm._v(" "),(_vm.alertTipoCliente)?_c('small',{staticClass:"text-danger"},[_vm._v("El tipo de cliente no concueda con el modulo seleccionado")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Documento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documento),expression:"documento"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.documento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.documento=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.formato == 1)?_c('div',{staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('center',[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v("Registrar como codigo 90")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('switches',{attrs:{"type-bold":"true","theme":"bootstrap","color":"success"},model:{value:(_vm.c90),callback:function ($$v) {_vm.c90=$$v},expression:"c90"}})],1)],1)]),_vm._v(" "),(_vm.c90 == false)?_c('div',{staticClass:"row"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.tablaOrden == true && _vm.c90 == false)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-responsive",staticStyle:{"width":"100%"},attrs:{"data":_vm.arrayOrdenes,"border":""}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"OrdCod","label":"Codigo"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"OrdFec","label":"Fecha"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"EpsNom","label":"Entidad"}}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.seleccionarOrden(props.row)}}},[_vm._v("\n              Seleccionar\n          ")])])]}}],null,false,1506455648)})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.c90 == false)?_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("N° de orden:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroOrden),expression:"numeroOrden"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.numeroOrden)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroOrden=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Entidad:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eps),expression:"eps"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.eps)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eps=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de expedición:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicion),expression:"fechaExpedicion"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.fechaExpedicion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de vencimiento:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaVencimiento),expression:"fechaVencimiento"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.fechaVencimiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaVencimiento=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("N° de autorización:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroAutorizacion),expression:"numeroAutorizacion"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.numeroAutorizacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de expedición:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicionAutorizacion),expression:"fechaExpedicionAutorizacion"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaExpedicionAutorizacion)},on:{"change":function($event){return _vm.generarCodigoAutorizacion()},"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicionAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Cobertura:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.coberturaAutorizacion),expression:"coberturaAutorizacion"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.coberturaAutorizacion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"45"}},[_vm._v("45 Días")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("1 Mes")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("2 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("3 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"120"}},[_vm._v("4 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"150"}},[_vm._v("5 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"180"}},[_vm._v("6 Meses")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Observaciones:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.observaciones),expression:"observaciones"}],staticClass:"form-control",attrs:{"id":"observaciones","cols":"30","rows":"3"},domProps:{"value":(_vm.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.observaciones=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.formato == 2 & _vm.nombre!= '')?_c('div',{staticStyle:{"padding":"10px"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regimen),expression:"regimen"}],attrs:{"type":"radio","value":"1"},domProps:{"checked":_vm._q(_vm.regimen,"1")},on:{"change":[function($event){_vm.regimen="1"},function($event){return _vm.selectEps()}]}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Contributivo")]),_vm._v("    \n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regimen),expression:"regimen"}],attrs:{"type":"radio","value":"2"},domProps:{"checked":_vm._q(_vm.regimen,"2")},on:{"change":[function($event){_vm.regimen="2"},function($event){return _vm.selectEps()}]}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Subsidiado")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eps),expression:"eps"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.eps=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.generarCodigo()}]}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v("Seleccione la EPS...")]),_vm._v(" "),_vm._l((_vm.arrayEps),function(eps){return _c('option',{key:eps.EpsCod,domProps:{"value":eps.EpsCod,"textContent":_vm._s(eps.EpsNom)}})})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroOrden),expression:"numeroOrden"}],staticClass:"form-control",attrs:{"type":"text","disabled":"","placeholder":"Numero de la orden"},domProps:{"value":(_vm.numeroOrden)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroOrden=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de expedición")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicion),expression:"fechaExpedicion"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaExpedicion)},on:{"change":function($event){return _vm.generarCodigo()},"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Cobertura")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cobertura),expression:"cobertura"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cobertura=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"45"}},[_vm._v("45 Días")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("1 Mes")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("2 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("3 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"120"}},[_vm._v("4 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"150"}},[_vm._v("5 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"180"}},[_vm._v("6 Meses")])])])]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.nombre != '')?_c('div',{staticClass:"row",staticStyle:{"padding":"10px"}},[_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.nombre != '')?_c('div',{staticClass:"row",staticStyle:{"padding":"10px"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.agregarServicios.apply(null, arguments)}}},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Servicio")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.especialidad),expression:"especialidad"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.especialidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayEspecialidad),function(especialidad){return _c('option',{key:especialidad.EspCod,domProps:{"value":[especialidad.EspCod, especialidad.EspNom]}},[_vm._v("\n              "+_vm._s(especialidad.EspNom)+"\n            ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Cantidad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cantidad),expression:"cantidad"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.cantidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cantidad=$event.target.value}}})]),_vm._v(" "),_vm._m(5)])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.arrayCantidad != '')?_c('div',{staticClass:"row",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-responsive table-bordered",staticStyle:{"width":"100%"},attrs:{"data":_vm.arrayCantidad,"border":""}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"servicio","label":"Cups"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nombre","label":"Nombre"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cantidad","label":"Cantidad"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove",on:{"click":function($event){return _vm.eliminarServicio(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}],null,false,31756203)})],1)],1)]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.mensaje != null)?_c('div',{staticClass:"alert alert-danger",staticStyle:{"color":"white"}},[_c('span',[_vm._v("\n        "+_vm._s(_vm.mensaje)+"\n        "),_c('i',{class:'fa fa-' + _vm.icono})])]):_vm._e(),_vm._v(" "),_c('center',[_c('div',{staticClass:"row"},[(_vm.formato == 1 && _vm.boton == true && _vm.c90 == true)?_c('button',{staticClass:"btn btn-success btn-fill btn-sm",on:{"click":function($event){return _vm.nuevaAutorizacionSinOM()}}},[_vm._v("\n          Registrar Autorización \"codigo 90\"\n        ")]):_vm._e(),_vm._v(" "),(_vm.formato == 1 && _vm.boton == true && _vm.c90 == false)?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.nuevaAutorizacion()}}},[_vm._v("\n          Registrar Autorización\n        ")]):_vm._e(),_vm._v(" "),(_vm.formato == 2 && _vm.boton == true)?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.nuevaOrdenMedica()}}},[_vm._v("\n          Registrar Orden médica\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.cerrar()}}},[_vm._v("\n          Cancelar\n        ")])])]),_vm._v(" "),_c('br')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"bold","margin-bottom":"15px"}},[_vm._v("Selecciona al paciente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n          Información de la orden\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n        Información de la autorización\n        \n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n        Inoformacion de la orden\n      ")]),_vm._v(" "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n        Servicios\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-1"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-success",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8LRc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__ = __webpack_require__("t/yl");







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SesionesTerapeutas',
    data: function data() {
        return {
            sesiones: [],
            dates: {
                initial: '',
                final: ''
            },
            data: [],
            especialidades: ['N/A', 'N/A', 'Fisioterapia', 'Fonoaudiologia', 'Terapia ocupacional', 'Educación especial', 'Psicologia']
        };
    },

    methods: {
        getSessions: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.$modal.show('carga');
                                _context.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__["a" /* default */].get("api/get-sessions-dynamic-table/" + this.dates.initial + "/" + this.dates.final);

                            case 4:
                                response = _context.sent;


                                this.data = response.data.data;
                                _context.next = 11;
                                break;

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](0);

                                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__global_services_crearAlerta__["a" /* default */])('error', _context.t0.response.data.message);

                            case 11:
                                _context.prev = 11;

                                this.$modal.hide('carga');
                                return _context.finish(11);

                            case 14:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 8, 11, 14]]);
            }));

            function getSessions() {
                return _ref.apply(this, arguments);
            }

            return getSessions;
        }(),
        calcularTotalesPorRol: function calcularTotalesPorRol(listaTerapeutas) {
            return listaTerapeutas.reduce(function (totalesPorRol, terapeuta) {
                totalesPorRol.Domicilio += Number(terapeuta.Domicilio);
                totalesPorRol.Sede += Number(terapeuta.Sede);
                totalesPorRol.Virtual += Number(terapeuta.Virtual);
                return totalesPorRol;
            }, { Domicilio: 0, Sede: 0, Virtual: 0 });
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "8j60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["icon", "title"]
});

/***/ }),

/***/ "8mNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8n25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepagada_vue__ = __webpack_require__("kpYD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eec297e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_prepagada_vue__ = __webpack_require__("74Vt");
function injectStyle (ssrContext) {
  __webpack_require__("jMFD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7eec297e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prepagada_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eec297e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_prepagada_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8nk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3 col-md-1"},[_c('center',[_c('i',{staticClass:"fa fa-file",staticStyle:{"font-size":"300%","color":"grey"}})]),_vm._v(" "),_c('br')],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('label',{attrs:{"for":""}},[_vm._v("Código:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.codigo),expression:"codigo"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Ingrese el código de la autorización"},domProps:{"value":(_vm.codigo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.codigo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("dd")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.buscarAutorizacion()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Buscar")])])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.numeroAutorizacion != 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[(_vm.tipo == 1)?_c('h4',[_vm._v(" Autorización N° "+_vm._s(_vm.numeroAutorizacion))]):_c('h4',[_vm._v(" Orden médica N° "+_vm._s(_vm.numeroAutorizacion))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Paciente:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pacienteAutorizacion),expression:"pacienteAutorizacion"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.pacienteAutorizacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pacienteAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Entidad:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.entidadAutorizacion),expression:"entidadAutorizacion"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.entidadAutorizacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.entidadAutorizacion=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha Expedición:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaAutorizacion),expression:"fechaAutorizacion"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.fechaAutorizacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha Vencimiento:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaVencimientoAutorizacion),expression:"fechaVencimientoAutorizacion"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaVencimientoAutorizacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaVencimientoAutorizacion=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.tipo == 1)?_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Saldo en bolsa:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bolsa),expression:"bolsa"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.bolsa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bolsa=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v(" "),(_vm.tipo == 1)?_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.ajustar()}}},[_vm._v("Ajustar\n                                            autorización")]):_vm._e(),_vm._v(" "),(_vm.tipo == 0)?_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.ajustar()}}},[_vm._v("Ajustar\n                                            orden")]):_vm._e(),_vm._v(" "),(_vm.tipo == 1)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.cancelarOrden()}}},[_vm._v("Cancelar\n                                            autorización")]):_vm._e(),_vm._v(" "),(_vm.tipo == 0)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.cancelarOrden()}}},[_vm._v("Cancelar\n                                            orden")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.numeroAutorizacion = 0}}},[_vm._v("Cancelar")])])])])])]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-9 col-md-11"},[_c('p',{staticClass:"title-card"},[_c('strong',{staticStyle:{"color":"grey"}},[_vm._v("Gestión de autorizaciones")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Administra la información de las ordenes y autorizaciones de AVANZA.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "91v4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "927F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9G8F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A+JM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'switches',

    props: {
        typeBold: {
            default: false
        },

        value: {
            default: false
        },

        disabled: {
            default: false
        },

        label: {
            default: ''
        },

        textEnabled: {
            default: ''
        },

        textDisabled: {
            default: ''
        },

        color: {
            default: 'default'
        },

        theme: {
            default: 'default'
        },

        emitOnMount: {
            default: true
        }
    },

    mounted: function mounted() {
        if (this.emitOnMount) {
            this.$emit('input', this.value);
        }
    },


    methods: {
        trigger: function trigger(e) {
            this.$emit('input', e.target.checked);
        }
    },

    computed: {
        classObject: function classObject() {
            var _ref;

            var color = this.color,
                value = this.value,
                theme = this.theme,
                typeBold = this.typeBold,
                disabled = this.disabled;


            return _ref = {
                'vue-switcher': true
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher--unchecked', !value), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher--disabled', disabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher--bold', typeBold), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher--bold--unchecked', typeBold && !value), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher-theme--' + theme, color), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher-color--' + color, color), _ref;
        },
        shouldShowLabel: function shouldShowLabel() {
            return this.label !== '' || this.textEnabled !== '' || this.textDisabled !== '';
        }
    }
});

/***/ }),

/***/ "AKvu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "APoQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card",staticStyle:{"padding":"5px 10px 5px","border-radius":"10px"}},[_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},_vm._l((_vm.informacionEspecialidad),function(especialidad){return _c('div',{key:especialidad.nombre,staticClass:"col-md-6"},[_c('nomicard',{attrs:{"title":especialidad.nombre,"clase":especialidad.clase,"imgRoute":"static/img/nomina/ganador.png","value":especialidad.realizadas}})],1)}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('strong',{staticStyle:{"font-size":"20px"}},[_vm._v("Información por especialidades")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"darkgrey"}},[_vm._v("Información de las ganancias de avanza por especialidad")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ASWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  var fechaActual = new Date();
  var fechaObjetivo = new Date(value + 'T00:00:00');

  var milisegundosFechaActual = fechaActual.getTime();
  var milisegundosFechaObjetivo = fechaObjetivo.getTime();

  var diferenciaMilisegundos = milisegundosFechaObjetivo - milisegundosFechaActual;

  var diasRestantes = Math.ceil(diferenciaMilisegundos / (1000 * 60 * 60 * 24));

  return diasRestantes;
});

/***/ }),

/***/ "An5X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.obtenerAsistenciaPorFecha(_vm.fechaInicial, _vm.fechaFinal)}}},[_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","required":""},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","required":"","min":_vm.fechaInicial},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"row"},[_c('center',[(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e()])],1),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{ref:"component",staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill mb-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"Asistencia por pacientes","name":"Asistencia por pacientes"}},[_vm._v("\n            Exportar a excel "),_c('i',{staticClass:"fa fa-download",attrs:{"color":"black"}})]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive table-striped mt-2",attrs:{"border":"","data":_vm.queriedData}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,staticStyle:{"height":"35px !important"},attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"full-width",class:_vm.getClass(column, row)},[(_vm.getClass(column, row) != '')?_c('strong',[_vm._v(_vm._s(row[column.prop]))]):_c('span',[_vm._v(_vm._s(row[column.prop]))])])]}}],null,true)})}),1)],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Asistencia por fecha")]),_vm._v(" "),_c('p',[_vm._v("\n            Seleccione las fechas y el sistema le mostrará las\n            "),_c('span',{staticClass:"text-success"},[_vm._v("Sesiones programadas, canceladas y realizadas")]),_vm._v(" en el rango de fecha que seleccione\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3"},[_c('input',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit","value":"Buscar"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B1+d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3 col-md-1"},[_c('center',[_c('i',{staticClass:"fa fa-file",staticStyle:{"font-size":"300%","color":"grey"}})]),_vm._v(" "),_c('br')],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',{attrs:{"for":""}},[_vm._v("Selecciona el paciente")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pacienteSelected),expression:"pacienteSelected"}],staticClass:"form-control",attrs:{"name":"","placeholder":"Selecciona el paciente..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.pacienteSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Seleccionar el paciente...")]),_vm._v(" "),_vm._l((_vm.pacientes),function(paciente){return _c('option',{key:paciente.PacIdeUsu,domProps:{"value":paciente.PacIdeUsu}},[_vm._v("\n            "+_vm._s(paciente.PacNom1 + " " + paciente.PacApe1)+"\n          ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',{attrs:{"for":""}},[_vm._v("En que fecha fue la terapia?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaSesion),expression:"fechaSesion"}],staticClass:"form-control",attrs:{"type":"date","min":_vm.fechaValidacion,"max":_vm.fechaActual},domProps:{"value":(_vm.fechaSesion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaSesion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("accion")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"7px"},on:{"click":function($event){return _vm.updateSesions()}}},[_vm._v("\n          Buscar\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.sesiones),function(sesion){return _c('div',{key:sesion.terapeuta,staticClass:"col-xs-12 col-md-4"},[_c('div',{staticClass:"card",staticStyle:{"padding":"20px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('center',[_c('strong',{staticClass:"text-success"},[_vm._v(_vm._s(sesion.nombrePaciente))])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"color":"grey"}},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("Fecha: "+_vm._s(sesion.fecha)+"\n                    ")]),_vm._v(" "),_c('p',{staticStyle:{"color":"grey"}},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" Hora: "+_vm._s(sesion.hora)+" a\n                      "+_vm._s(sesion.horaFin)+"\n                    ")]),_vm._v(" "),_c('p',{staticStyle:{"color":"grey"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Terapeuta:\n                      "+_vm._s(sesion.terapeuta)+"\n                    ")]),_vm._v(" "),_c('p',{staticStyle:{"color":"grey"}},[_c('i',{staticClass:"fa fa-hashtag"}),_vm._v("Cantidad:\n                      "+_vm._s(sesion.cantidad)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-block",staticStyle:{"border-radius":"7px"},on:{"click":function($event){return _vm.cancelarSesion(sesion)}}},[_vm._v("\n                      Cancelar registro\n                    ")])])])])])})],2)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-9 col-md-11"},[_c('p',{staticClass:"title-card"},[_c('strong',{staticStyle:{"color":"grey"}},[_vm._v("Gestión de terapias")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Administra la información de las terapias, podras cancelar el\n              registro.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-md-12"},[_c('p',{staticClass:"title-card"},[_c('strong',{staticStyle:{"color":"grey"}},[_vm._v("Terapias disponibles")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BGCZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usuarios_vue__ = __webpack_require__("CkIM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549b2608_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_usuarios_vue__ = __webpack_require__("OQ5W");
function injectStyle (ssrContext) {
  __webpack_require__("q+0e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-549b2608"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usuarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549b2608_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_usuarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BNE1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("aCDv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0903e4de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("xSGn");
function injectStyle (ssrContext) {
  __webpack_require__("VZyU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0903e4de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BRxa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mantenimiento_material_vue__ = __webpack_require__("4f0C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6d4d70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mantenimiento_material_vue__ = __webpack_require__("/icc");
function injectStyle (ssrContext) {
  __webpack_require__("w0tS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mantenimiento_material_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6d4d70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mantenimiento_material_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BUxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal',{attrs:{"name":"modalVerificarFirmaElectronica","width":"500","height":"auto","persistent":"true"}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_vm._v("Verificar firma electronica")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_c('span',{staticStyle:{"font-weight":"600"}},[_vm._v("Digita tu firma electronica!")]),_vm._v(" "),_c('br'),_vm._v("\n          Verifica la firma electronica para validar los registros que hagas en la historia clinica de los pacientes.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-size":"12px"}},[_c('span',{staticStyle:{"font-weight":"600"}},[_vm._v("Recuerda:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("La firma electronica es de uso personal, recomendarlos no guardarla en el navegador.")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputFirma),expression:"inputFirma"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"********"},domProps:{"value":(_vm.inputFirma)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inputFirma=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.verificarFirmaElectronica()}}},[_vm._v("Verificar firma")])])])])]),_vm._v(" "),_c('modal',{attrs:{"name":"modalFaltaInformacion","clickToClose":false,"width":"550px","height":"auto"}},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title",staticStyle:{"color":"#991b1b"}},[_vm._v("Alerta")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v("\n          Revisa los siguientes puntos para poder registrar la evolución\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"#991b1b","font-weight":"300"}},[_vm._v("Recuerda que tienes hasta el "),_c('span',{staticStyle:{"font-weight":"bold","color":"#991b1b"}},[_vm._v(_vm._s(_vm._f("date")(_vm.eventoSeleccionado.fechaFinEvolucion)))]),_vm._v(" para registrar la evolución y que no quede marcada como atrasada")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),(_vm.informacionEvaluacion.motivos == 0)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-information"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v(" Motivo de consulta ")]),_vm._v(" "),_c('p',[_vm._v(" Debes verificar o registrar un motivo de consulta ")])])]):_vm._e(),_vm._v(" "),(_vm.informacionEvaluacion.impresion == 0)?_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"card-information"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v(" Impresión diagnostica ")]),_vm._v(" "),_c('p',[_vm._v(" Debes registrar una impresión diagnostica ")])])]):_vm._e(),_vm._v(" "),(_vm.informacionEvaluacion.plan == 0)?_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"card-information"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v(" Plan de tratamiento ")]),_vm._v(" "),_c('p',[_vm._v(" Debes registrar un plan de tratamiento ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('span',[_vm._v("Los siguientes puntos no son requeridos para poder efectuar la evolución")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"card-information-no-require"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v(" Examenes de paciente ")]),_vm._v(" "),_c('p',[_vm._v(" Solo debes registrar examenes en caso que el paciente lo requiera ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"card-information-no-require"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v(" Antecedentes ")]),_vm._v(" "),_c('p',[_vm._v(" Solo debes registrar antecedentes en caso que sea necesario ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"25px"},on:{"click":function($event){return _vm.cerrarModalInformacionFaltante()}}},[_c('button',{staticClass:"btn btn-danger btn-block btn-lg",staticStyle:{"border-radius":"5px"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Volver a la agenda")])])])])]),_vm._v(" "),_c('div',{staticClass:"card",staticStyle:{"padding":"2%"}},[_vm._m(0),_vm._v(" "),(_vm.agenda == true)?_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{attrs:{"id":"calendarEl"}},[_c('br'),_vm._v(" "),[_c('FullCalendar',{ref:"fullCalendar",attrs:{"defaultView":"listWeek","hiddenDays":[],"locale":'esLocale',"plugins":_vm.calendarPlugins,"events":_vm.arrayEventos,"header":_vm.headers},on:{"eventClick":_vm.verEvento}})]],2)])])]):_vm._e(),_vm._v(" "),(_vm.agenda == false && _vm.eventoSeleccionado.nombrePaciente != '')?_c('div',{staticClass:"card-content"},[_c('section',{staticClass:"modal-body",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('center',[(_vm.eventoSeleccionado.estadoEvento === 3)?_c('div',{staticClass:"card-alert"},[_c('div',{staticClass:"mensaje-alerta"},[_c('span',{staticStyle:{"font-weight":"500","font-size":"15px"}},[_vm._v("Recuerda")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{},[_vm._v("Tienes hasta el "+_vm._s(_vm._f("date")(_vm.eventoSeleccionado.fechaFinEvolucion))+" para registrar la evolución y que no quede marcada como atrasada")])])]):_vm._e(),_vm._v(" "),_c('h4',{staticStyle:{"font-weight":"500"}},[_vm._v("\n                "+_vm._s(_vm.eventoSeleccionado.nombrePaciente)+"\n              ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","color":"grey"}},[_vm._v("\n                Documento de identidad: "+_vm._s(_vm.eventoSeleccionado.documentoPaciente)+"\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","color":"grey"}},[_vm._v("\n                "+_vm._s(_vm._f("date")(_vm.eventoSeleccionado.fecha))+",\n                "+_vm._s(_vm.eventoSeleccionado.horainicio)+" a\n                "+_vm._s(_vm.eventoSeleccionado.horafin)+"\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","padding":"5px","background-color":"#2f2254","color":"white","border-radius":"5px"}},[_vm._v("\n                "+_vm._s(_vm.eventoSeleccionado.cantidadSesiones)+" Sesion(es)\n              ")])])],1),_vm._v(" "),(
              _vm.eventoSeleccionado.tipo == 'Terapia' &&
              _vm.eventoSeleccionado.estadoEvento == 3
            )?_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"estrategiatp"}},[_vm._v("Estrategias terapeuticas implementada")]),_vm._v(" "),_c('el-select',{staticClass:"select-default",staticStyle:{"width":"100%"},attrs:{"multiple":"","size":"large","placeholder":"Seleccione estrategias terapeuticas implementadas","filterable":"","remote":""},model:{value:(_vm.estrategia),callback:function ($$v) {_vm.estrategia=$$v},expression:"estrategia"}},_vm._l((_vm.arrayEstrategiasActivos),function(estrategia){return _c('el-option',{key:estrategia.DomDes,staticClass:"select-primary",attrs:{"value":estrategia.DomDes,"label":estrategia.DomDes}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"estadoPaciente"}},[_vm._v("Describe en que estado estaba el paciente")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.estadoPaciente),expression:"estadoPaciente"}],staticClass:"form-control",attrs:{"id":"estadoPaciente","cols":"30","maxlength":"200","rows":"2"},domProps:{"value":(_vm.estadoPaciente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.estadoPaciente=$event.target.value}}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.estadoPaciente.length)+" / 200")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"evoluciontp"}},[_vm._v("Describe lo que se realizó en la terapia")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.evolucion),expression:"evolucion"}],staticClass:"form-control",attrs:{"id":"evoluciontp","cols":"30","maxlength":"1000","rows":"10"},domProps:{"value":(_vm.evolucion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.evolucion=$event.target.value}}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.evolucion.length)+" / 1.000")])])]):_vm._e(),_vm._v(" "),(
              _vm.eventoSeleccionado.tipo == 'Evaluacion' &&
              _vm.eventoSeleccionado.estadoEvento == 3
            )?_c('div',{staticClass:"row",staticStyle:{"margin-left":"50px","margin-right":"50px"}},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('center',[_c('div',{staticClass:"cardcyt"},[_c('div',{staticStyle:{"font-size":"18px"}},[_c('i',{staticClass:"fa fa-info",attrs:{"title":"Si marcas como requerido ✅, al momento de exportar el informe se valida si el paciente tiene examenes cargados en la fecha de la evaluación"}}),_vm._v(" "),_c('label',{attrs:{"for":"requiere"}},[_vm._v("El paciente requiere examen?")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.requiere),expression:"requiere"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"requiere"},domProps:{"checked":Array.isArray(_vm.requiere)?_vm._i(_vm.requiere,null)>-1:(_vm.requiere)},on:{"change":function($event){var $$a=_vm.requiere,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.requiere=$$a.concat([$$v]))}else{$$i>-1&&(_vm.requiere=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.requiere=$$c}}}})]),_vm._v(" "),_c('h3',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n                    Dale clic en evolucionar y terminar la evaluación en el\n                    modulo de historia clinica\n                  ")])])]),_vm._v(" "),_c('br')],1)]):_vm._e(),_vm._v(" "),(_vm.eventoSeleccionado.estadoEvento != 3)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('center',[(_vm.eventoSeleccionado.estadoEvento == 1)?_c('h4',{staticStyle:{"color":"green"}},[_vm._v("\n                  Sesión evolucionada con éxito\n                ")]):_vm._e(),_vm._v(" "),(_vm.eventoSeleccionado.estadoEvento == 2)?_c('h4',{staticStyle:{"color":"red"}},[_vm._v("\n                  Sesión cancelada\n                ")]):_vm._e()])],1)]):_vm._e()])]),_vm._v(" "),_c('footer',[_c('div',{staticClass:"modal-footer",staticStyle:{"padding-bottom":"9px"}},[_c('center',[_c('button',{staticClass:"btn btn-error",staticStyle:{"border-radius":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.agenda = true;
                _vm.eventoSeleccionado = [];}}},[_vm._v("\n             Cerrar\n            ")]),_vm._v(" "),(_vm.eventoSeleccionado.estadoEvento == 3)?_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.registrarEvolucion()}}},[_vm._v("\n            Registrar evolución\n            ")]):_vm._e()])],1)])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('p',[_c('span',{staticStyle:{"font-weight":"600","font-size":"20px"}},[_vm._v("Agenda de evoluciones")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"16px","color":"grey"}},[_vm._v("Registra la evolución del paciente")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BgsC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Br7V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionDia_vue__ = __webpack_require__("ZeQe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62927de7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionDia_vue__ = __webpack_require__("XYHH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionDia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62927de7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionDia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CEqL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fullcalendar_vue__ = __webpack_require__("l7UG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fullcalendar_daygrid__ = __webpack_require__("uJAD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fullcalendar_core_locales_es__ = __webpack_require__("ER/K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fullcalendar_core_locales_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fullcalendar_core_locales_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fullcalendar_list__ = __webpack_require__("L7mJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fullcalendar_timegrid__ = __webpack_require__("U2C2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fullcalendar_interaction__ = __webpack_require__("uX+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fullcalendar_moment__ = __webpack_require__("nAns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fullcalendar_google_calendar__ = __webpack_require__("OjwX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__ = __webpack_require__("o0VJ");

















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip: "https://avanti-erp.com",
      terapeutaEventos: "todos",
      desde: 7,
      formPaciente: {
        criterio: "paciente.PacApe1",
        busqueda: ""
      },
      pacienteSeleccionado: {
        documento: "",
        nombre: "",
        ide: ""
      },
      servicioSeleccionado: {
        id: "",
        codigo: "",
        sesionesAutorizadas: "",
        sesionesProgramadas: "",
        fechaVencimiento: "",
        tipo: "",
        entidad: ""
      },
      actualizarhorainicio: "",
      actualizarhorafin: "",
      eventoSeleccionado: [],
      diasProgramacion: {
        lunes: {
          horainicio: "",
          horafin: ""
        },
        martes: {
          horainicio: "",
          horafin: ""
        },
        miercoles: {
          horainicio: "",
          horafin: ""
        },
        jueves: {
          horainicio: "",
          horafin: ""
        },
        viernes: {
          horainicio: "",
          horafin: ""
        },
        sabado: {
          horainicio: "",
          horafin: ""
        },
        domingo: {
          horainicio: "",
          horafin: ""
        }
      },
      programacionIndividual: {
        fecha: "",
        horainicio: "",
        horafin: "",
        tipo: "",
        lugar: "",
        valorSesion: "",
        copago: ""
      },
      arrayProgramacionEspecialidad: [],
      contadorSesionesEspecialidad: 0,
      arrayPacientes: [],
      arrayServiciosDisponibles: [],
      arrayServiciosDisponiblesBackup: [],
      arrayServiciosConTarifa: [],
      arrayTerapeutas: [],
      iniciosesiones: "",
      finsesiones: "",
      terapeutaProgramar: "",
      arrayEventos: [],
      modal: 0,
      formato: 1,
      actionModal: "detalle",
      terapeutaActualizar: "",
      labelEspecialidad: {
        null: 'No aplica',
        0: 'No aplica',
        6: 'Psicologia',
        2: 'Fisioterapia',
        3: 'Fonoaudiologia',
        4: 'Terapia ocupacional'
      },

      calendarPlugins: [__WEBPACK_IMPORTED_MODULE_6__fullcalendar_daygrid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__fullcalendar_timegrid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__fullcalendar_interaction__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__fullcalendar_list__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__fullcalendar_google_calendar__["a" /* default */]],
      headers: {
        left: "prev,today,next",
        center: "title",

        right: "title"
      },
      type: ["", "info", "success", "warning", "danger"],
      mensaje: "",
      motivoCancelacion: "",
      motivoCancelarOptions: ["Cambio de terapeuta", "Clima", "Colegio", "Cuarentena / Posible COVID", "Decisión familia", "Enfermedad / Cita médica", "Evento Social / Extracurricular", "Error en la programación / Error administrativo", "Exigencias en la programación", "Falta de transporte", "Falta orden médica", "Hora programada no sirve", "No disponibilidad AVANZA", "Puntualidad / Trafico / Lejania con centro", "Retiro voluntario", "Servicios públicos", "Sin disponibilidad acudiente", "Viaje / Vacaciones", "Otros"]
    };
  },

  methods: {
    eliminarProgramacionDeLaLista: function eliminarProgramacionDeLaLista(index) {
      this.contadorSesionesEspecialidad = this.contadorSesionesEspecialidad - this.arrayProgramacionEspecialidad[index].sesiones;
      this.arrayProgramacionEspecialidad.splice(index, 1);
    },
    adicionarProgramacion: function adicionarProgramacion() {

      if (this.terapeutaProgramar == "" || this.programacionIndividual.horainicio == "" || this.programacionIndividual.horafin == "" || this.programacionIndividual.fecha == "" || this.programacionIndividual.tipo == "" || this.programacionIndividual.lugar == "" || this.programacionIndividual.valorSesion == "") {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", "Debes completar todos los campos"));
        return;
      }

      var CANTIDADSESIONES = this.calcularMinutos(this.programacionIndividual.horainicio, this.programacionIndividual.horafin);

      if (CANTIDADSESIONES > 6) {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", 'No puedes programar más de 6 sesiones continuas'));
        return;
      }

      if (CANTIDADSESIONES + this.contadorSesionesEspecialidad > this.servicioSeleccionado.sesionesAutorizadas) {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", "La cantidad de sesiones supera la cantidad de sesiones autorizadas"));
        return;
      }

      this.arrayProgramacionEspecialidad.push({
        horainicio: this.programacionIndividual.horainicio,
        horafin: this.programacionIndividual.horafin,
        fecha: this.programacionIndividual.fecha,
        sesiones: this.calcularMinutos(this.programacionIndividual.horainicio, this.programacionIndividual.horafin),
        tipo: this.programacionIndividual.tipo,
        terapeuta: this.terapeutaProgramar,
        servicio: this.servicioSeleccionado.id,
        servicioTipo: this.servicioSeleccionado.tipo,
        paciente: this.pacienteSeleccionado.ide,
        lugar: this.programacionIndividual.lugar,
        valor: this.servicioSeleccionado.tipo == 'particular' ? this.programacionIndividual.valorSesion : this.programacionIndividual.valorSesion.tarifa,
        copago: this.programacionIndividual.copago,
        sede: localStorage.getItem("sede")
      });

      this.contadorSesionesEspecialidad = this.contadorSesionesEspecialidad + CANTIDADSESIONES;
      this.programacionIndividual.horainicio = "";
      this.programacionIndividual.horafin = "";
      this.programacionIndividual.valorSesion = "";
      this.terapeutaProgramar = "";
    },
    recargarVentana: function recargarVentana() {
      location.reload();
    },
    buscarPaciente: function buscarPaciente() {
      var _this = this;

      this.$modal.show("carga");
      var _formPaciente = this.formPaciente,
          criterio = _formPaciente.criterio,
          busqueda = _formPaciente.busqueda;

      var rol = localStorage.getItem("rol");
      var sede = rol === 1 ? localStorage.getItem("sede") : "todas";
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/pacientesHC/" + criterio + "/" + busqueda + "/" + sede;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this.$modal.hide("carga");
        _this.arrayPacientes = res.data.data;
      }).catch(function (err) {
        _this.$modal.hide("carga");
        console.log(err);
      });
    },
    guardarMensaje: function guardarMensaje(mensaje) {
      this.mensaje = mensaje;
      this.$modal.hide("ingresar_programacion");
      this.$modal.show("mensaje");
    },
    obtenerDatosSelect: function obtenerDatosSelect() {
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/pacientesHC/" + criterio + "/" + busqueda + "/" + sede;
    },
    enviarProgramacion: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;

        var VECTORPROGRAMACION, _mensaje, color, SESIONESDISPONIBLES, SESIONES, SESIONESVALIDAR, contador, dia, config, BASE_URL;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                VECTORPROGRAMACION = [];

                if (!(this.formato === 3)) {
                  _context.next = 13;
                  break;
                }

                if (!(this.terapeutaProgramar == "")) {
                  _context.next = 7;
                  break;
                }

                _mensaje = "Debes seleccionar un terapeuta";

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", _mensaje));
                this.$modal.hide("carga");
                return _context.abrupt("return");

              case 7:
                if (!(this.servicioSeleccionado.tipo == 'particular' && this.programacionIndividual.valorSesion == '')) {
                  _context.next = 10;
                  break;
                }

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", 'Debe registrar el valor por sesión a cobrar'));
                return _context.abrupt("return");

              case 10:
                if (!(this.servicioSeleccionado.tipo != 'particular' && this.programacionIndividual.valorSesion.tarifa == '')) {
                  _context.next = 13;
                  break;
                }

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", 'Debe registrar el valor por sesión a cobrar'));
                return _context.abrupt("return");

              case 13:
                if (!(this.formato === 1)) {
                  _context.next = 36;
                  break;
                }

                if (!(this.programacionIndividual.fecha === "")) {
                  _context.next = 19;
                  break;
                }

                color = Math.floor(Math.random() * 4 + 1);

                this.$notify({
                  component: {
                    template: "\n                <div>\n                  <p>Notificaci\xF3n</p>  \n                  <strong>Debes ingresar la fecha de inicio de las sesiones</strong>\n                </div>\n              "
                  },
                  icon: "",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: this.type[color]
                });
                this.$modal.hide("carga");
                return _context.abrupt("return");

              case 19:
                if (!(this.programacionIndividual.horainicio === "" || this.programacionIndividual.horafin === "")) {
                  _context.next = 24;
                  break;
                }

                color = Math.floor(Math.random() * 4 + 1);

                this.$notify({
                  component: {
                    template: "\n                <div>\n                  <p>Notificaci\xF3n</p>  \n                  <strong>Ingrese la hora de inicio y final de la sesi\xF3n</strong>\n                </div>\n              "
                  },
                  icon: "",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: this.type[color]
                });
                this.$modal.hide("carga");
                return _context.abrupt("return");

              case 24:
                SESIONESDISPONIBLES = this.servicioSeleccionado.sesionesAutorizadas;
                SESIONES = this.calcularMinutos(this.programacionIndividual.horainicio, this.programacionIndividual.horafin);

                if (!(SESIONES > 6)) {
                  _context.next = 29;
                  break;
                }

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", 'No puedes programar más de 6 sesiones continuas'));
                return _context.abrupt("return");

              case 29:
                SESIONESVALIDAR = SESIONES;

                if (!(SESIONESVALIDAR > SESIONESDISPONIBLES)) {
                  _context.next = 33;
                  break;
                }

                this.$notify({
                  component: {
                    template: "\n                  <div>\n                    <p>Notificaci\xF3n</p>  \n                    <strong>Las sesiones que quiere programar superan la cantidad de sesiones disponibles en este servicio.</strong>\n                  </div>\n                "
                  },
                  icon: "",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "danger"
                });
                return _context.abrupt("return");

              case 33:

                VECTORPROGRAMACION.push({
                  horainicio: this.programacionIndividual.horainicio,
                  horafin: this.programacionIndividual.horafin,
                  fecha: this.programacionIndividual.fecha,
                  sesiones: this.calcularMinutos(this.programacionIndividual.horainicio, this.programacionIndividual.horafin),
                  tipo: this.programacionIndividual.tipo,
                  terapeuta: this.terapeutaProgramar,
                  servicio: this.servicioSeleccionado.id,
                  servicioTipo: this.servicioSeleccionado.tipo,
                  paciente: this.pacienteSeleccionado.ide,
                  lugar: this.programacionIndividual.lugar,
                  valor: this.servicioSeleccionado.tipo == 'particular' ? this.programacionIndividual.valorSesion : this.programacionIndividual.valorSesion.tarifa,
                  copago: this.programacionIndividual.copago,
                  sede: localStorage.getItem("sede")
                });
                _context.next = 60;
                break;

              case 36:
                if (!(this.formato === 2)) {
                  _context.next = 59;
                  break;
                }

                if (!(this.iniciosesiones === "" && this.formato === 2)) {
                  _context.next = 42;
                  break;
                }

                color = Math.floor(Math.random() * 4 + 1);

                this.$notify({
                  component: {
                    template: "\n                <div>\n                  <p>Notificaci\xF3n</p>  \n                  <strong>Debes ingresar la fecha de inicio de las sesiones</strong>\n                </div>\n              "
                  },
                  icon: "",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: this.type[color]
                });
                this.$modal.hide("carga");
                return _context.abrupt("return");

              case 42:
                if (!(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.diasProgramacion).length == 0)) {
                  _context.next = 47;
                  break;
                }

                color = Math.floor(Math.random() * 4 + 1);

                this.$notify({
                  component: {
                    template: "\n                <div>\n                  <p>Notificaci\xF3n</p>  \n                  <strong>No se ha programado ning\xFAn d\xEDa</strong>\n                </div>\n              "
                  },
                  icon: "",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: this.type[color]
                });
                this.$modal.hide("carga");
                return _context.abrupt("return");

              case 47:
                contador = 0;

                for (dia in this.diasProgramacion) {
                  if (this.diasProgramacion[dia].horainicio != "" && this.diasProgramacion[dia].horafin) {
                    contador = contador + 1;
                  }
                }

                if (!(contador == 0)) {
                  _context.next = 54;
                  break;
                }

                color = Math.floor(Math.random() * 4 + 1);

                this.$notify({
                  component: {
                    template: "\n                <div>\n                  <p>Notificaci\xF3n</p>  \n                  <strong>No se ha programado ning\xFAn d\xEDa</strong>\n                </div>\n              "
                  },
                  icon: "",
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: this.type[color]
                });
                this.$modal.hide("carga");
                return _context.abrupt("return");

              case 54:
                _context.next = 56;
                return this.crearVectorProgramacion();

              case 56:
                VECTORPROGRAMACION = _context.sent;
                _context.next = 60;
                break;

              case 59:
                VECTORPROGRAMACION = this.arrayProgramacionEspecialidad;

              case 60:

                this.$modal.show("carga");
                config = {
                  headers: {
                    Authorization: "Bearer " + localStorage.getItem("token")
                  }
                };
                BASE_URL = this.ip + "/api/programar-sesiones-calendario";

                __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(BASE_URL, { items: VECTORPROGRAMACION }, config).then(function (res) {
                  if (res.data.status === false) {
                    var color = Math.floor(Math.random() * 4 + 1);
                    _this2.$notify({
                      component: {
                        template: "\n                  <div>\n                    <p>Notificaci\xF3n</p>  \n                    <strong>" + res.data.mensaje + "</strong>\n                  </div>\n                "
                      },
                      icon: "",
                      horizontalAlign: "right",
                      verticalAlign: "top",
                      type: _this2.type[color]
                    });
                    _this2.$modal.hide("carga");
                    return;
                  }

                  if (_this2.formato == 2) {
                    _this2.guardarMensaje(res.data.mensaje);
                    _this2.setearEventos();
                  } else {
                    _this2.guardarMensaje("Sesión registrada con éxito");
                    _this2.setearEventos();
                  }
                  _this2.$modal.hide("carga");
                }).catch(function (err) {
                  _this2.$modal.hide("carga");
                  console.log(VECTORPROGRAMACION);
                  console.log(err);
                });

              case 64:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function enviarProgramacion() {
        return _ref.apply(this, arguments);
      }

      return enviarProgramacion;
    }(),
    setearEventos: function setearEventos() {
      if (this.terapeutaEventos === "todos") {
        this.obtenerEventos("sede");
      } else {
        this.obtenerEventos("terapeuta");
      }
    },

    obtenerEventos: function obtenerEventos(tipoBusqueda) {
      var _this3 = this;

      var CRITERIO = tipoBusqueda === "sede" ? "programacion.sede" : "programacion.terapeuta";
      var BUSQUEDA = tipoBusqueda === "sede" ? localStorage.getItem("sede") : this.terapeutaEventos;
      var DESDE = this.desde;
      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/obtener-eventos-calendario/" + CRITERIO + "/" + BUSQUEDA + "/" + DESDE;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this3.$modal.hide("carga");
        var data = res.data.data;
        var events = [];
        data.forEach(function (element) {
          events.push({
            title: element.tipo === "Terapia" ? element.nombrePaciente + " " + element.apellidoPaciente + " ( " + element.lugar + " )" : element.tipo === "CYT" ? element.nombrePaciente + " " + element.apellidoPaciente + " - CYT ( " + element.lugar + " )" : element.tipo === "Evaluacion" ? element.nombrePaciente + " " + element.apellidoPaciente + " - EVALUACI\xD3N ( " + element.lugar + " )" : element.nombrePaciente + " " + element.apellidoPaciente + " ( " + element.lugar + " )",

            start: element.fecha + "T" + element.horaInicio,
            end: element.fecha + "T" + element.horaFin,
            color: element.estadoEvento === 3 ? "blue" : element.estadoEvento === 2 ? "red" : "green",
            extendedProps: {
              nombreTerapeuta: element.nombreTerapeuta + " " + element.apellidoTerapeuta,
              usuarioTerapeuta: element.terapeuta,
              pacienteId: element.usuarioId,
              especialidad: element.especialidad,
              autorizacion: element.autorizacion,
              fecha: element.fecha,
              tipo: element.tipo,
              horainicio: element.horaInicio,
              horafin: element.horaFin,
              documentoPaciente: element.documentoPaciente,
              cantidadSesiones: parseInt(element.sesionesCantidad),
              estadoEvento: element.estadoEvento,
              idEvento: element.idEvento
            }
          });
        });

        _this3.arrayEventos = events;
      }).catch(function (err) {
        _this3.$modal.hide("carga");
        console.log(err);
      });
    },
    verEvento: function verEvento(arg) {
      var EVENT = arg.event;
      this.eventoSeleccionado = EVENT;
      this.$modal.show("detalle_terapia");
    },
    cancelarEvento: function cancelarEvento() {
      var _this4 = this;

      var EVENT = this.eventoSeleccionado.extendedProps;
      var CANTIDADSESIONES = this.eventoSeleccionado.extendedProps.cantidadSesiones;
      var AUTORIZACION = this.eventoSeleccionado.extendedProps.autorizacion;
      var MOTIVOCAN = this.motivoCancelacion;
      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/cancelar-evento-calendario";
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(BASE_URL, { EVENT: EVENT, CANTIDADSESIONES: CANTIDADSESIONES, AUTORIZACION: AUTORIZACION, MOTIVOCAN: MOTIVOCAN }, config).then(function (res) {
        _this4.$modal.hide("carga");
        if (res.data.status === false) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this4.$notify({
            component: {
              template: "<div>\n                    <p> Notificaci\xF3n<p>\n                    <p> <strong>" + res.data.mensaje + "</strong></p>\n                  </div>"
            },
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
          _this4.$modal.hide("carga");
        } else {
          _this4.motivoCancelacion = "";
          var color = Math.floor(Math.random() * 4 + 1);
          _this4.$notify({
            component: {
              template: "<div>\n                    <p> Notificaci\xF3n <p>\n                    <p> <strong>" + res.data.mensaje + "</strong></p>\n                  </div>"
            },
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });
          _this4.setearEventos();
          _this4.$modal.hide("carga");
          _this4.$modal.hide("detalle_terapia");
        }
      }).catch(function (err) {
        _this4.$modal.hide("carga");
        console.log(err);
      });
    },
    aceptarCYT: function aceptarCYT() {
      var _this5 = this;

      var EVENT = this.eventoSeleccionado.extendedProps;
      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/aceptar-cyt-calendario";
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(BASE_URL, { EVENT: EVENT }, config).then(function (res) {
        _this5.$modal.hide("carga");
        if (res.data.status === true) {
          _this5.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("success", res.data.mensaje));
          _this5.cerrarModal("detalle_terapia");
          _this5.setearEventos();
        }
      }).catch(function (err) {
        _this5.$modal.hide("carga");
        _this5.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", mensaje));
        console.log(err);
      });
    },
    actualizarHorario: function actualizarHorario() {
      var _this6 = this;

      var EVENT = this.eventoSeleccionado.extendedProps;
      var HORAINICIO = this.actualizarhorainicio;
      var HORAFIN = this.actualizarhorafin;
      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/actualizar-horario-evento";
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(BASE_URL, { EVENT: EVENT, HORAINICIO: HORAINICIO, HORAFIN: HORAFIN }, config).then(function (res) {
        _this6.$modal.hide("carga");
        if (res.data.status === true) {
          _this6.actualizarhorainicio = "";
          _this6.actualizarhorafin = "";
          _this6.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("success", res.data.mensaje));
          _this6.cerrarModal("detalle_terapia");
          _this6.setearEventos();
        }
      }).catch(function (err) {
        _this6.$modal.hide("carga");
        _this6.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", mensaje));
        console.log(err);
      });
    },
    actualizarTerapeuta: function actualizarTerapeuta() {
      var _this7 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var EVENT = this.eventoSeleccionado.extendedProps;
      var TERAPEUTA = this.terapeutaActualizar;
      var BASE_URL = this.ip + "/api/actualizar-terapeuta-evento";
      this.$modal.show("carga");
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(BASE_URL, { EVENT: EVENT, TERAPEUTA: TERAPEUTA }, config).then(function (res) {
        _this7.$modal.hide("carga");
        if (res.data.status === true) {
          _this7.terapeutaActualizar = "";
          _this7.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("success", res.data.mensaje));
          _this7.cerrarModal("detalle_terapia");
          _this7.setearEventos();
        }
      }).catch(function (err) {
        _this7.$modal.hide("carga");
        _this7.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", mensaje));
        console.log(err);
      });
    },
    buscarServiciosDisponibles: function buscarServiciosDisponibles() {
      var _this8 = this;

      this.$modal.show("carga");
      var ide = this.pacienteSeleccionado.ide;

      var date = this.calcularFechaActual();
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/paciente/serviciosDisponibles/" + ide + "/" + date;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this8.$modal.hide("carga");
        _this8.arrayServiciosDisponibles = res.data.items;
      }).catch(function (err) {
        _this8.$modal.hide("carga");
        console.log(err);
      });
    },
    seleccionarPaciente: function seleccionarPaciente(paciente) {
      var PacNom1 = paciente.PacNom1,
          PacApe1 = paciente.PacApe1,
          PacNumDoc = paciente.PacNumDoc,
          PacIdeUsu = paciente.PacIdeUsu;

      this.pacienteSeleccionado.nombre = PacNom1 + " " + PacApe1;
      this.pacienteSeleccionado.documento = PacNumDoc;
      this.pacienteSeleccionado.ide = PacIdeUsu;
      this.arrayPacientes = [];
      this.buscarServiciosDisponibles();
    },
    seleccionarServicio: function seleccionarServicio(servicio) {
      var id = servicio.id,
          bolsa = servicio.bolsa,
          codigo = servicio.codigo,
          fechaVencimiento = servicio.fechaVencimiento,
          tipo = servicio.tipo,
          entidad = servicio.entidad;

      this.servicioSeleccionado.id = id;
      this.servicioSeleccionado.codigo = codigo;
      this.servicioSeleccionado.sesionesAutorizadas = bolsa;
      this.servicioSeleccionado.sesionesProgramadas = 0;
      this.servicioSeleccionado.fechaVencimiento = fechaVencimiento;
      this.servicioSeleccionado.tipo = tipo;
      this.servicioSeleccionado.entidad = entidad;
      this.arrayServiciosDisponibles = [];
      this.obtenerServiciosConTarifa(entidad);
      this.selectTerapeuta(1);
    },
    selectTerapeuta: function selectTerapeuta(especialidad) {
      var _this9 = this;

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/selectTerapeutasProgramar/" + especialidad;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this9.$modal.hide("carga");
        _this9.arrayTerapeutas = res.data.data;
      }).catch(function (err) {
        _this9.$modal.hide("carga");
        console.log(err);
      });
    },
    abrirModal: function abrirModal() {
      this.modal = 1;
      this.$modal.show("ingresar_programacion");
    },
    cerrarModal: function cerrarModal(modal) {
      this.$modal.hide(modal);
      if (modal == "ingresar_programacion") {
        this.recargarVentana();
      }

      if (modal == "detalle_terapia") {
        this.actionModal = "detalle";
      }
    },
    calcularFechaActual: function calcularFechaActual() {
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    calcularDiasProgramar: function calcularDiasProgramar() {
      var arrayDiasProgramacion = [];
      var allDays = this.diasProgramacion;
      for (var dia in allDays) {
        if (allDays.hasOwnProperty(dia)) {
          var horainicio = allDays[dia].horainicio;
          var horafin = allDays[dia].horafin;

          if (horainicio != "" && horafin != "") {
            arrayDiasProgramacion.push({ horainicio: horainicio, horafin: horafin });
          } else {
            arrayDiasProgramacion.push(0);
          }
        }
      }
    },
    crearVectorProgramacion: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var SESIONESDISPONIBLES, FECHAINICIO, FECHAFIN, FECHAACTUAL, DIASPROGRAMACION, DIASDISPONIBLESPROGRAMAR, vectorprogramacion, index, ELEMENT, POSITION, VALIDARDIA, horainicio, horafin, DIASEMANA, FECHAFORMATEADA, CANTIDADSESIONES;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                SESIONESDISPONIBLES = this.servicioSeleccionado.sesionesAutorizadas;
                FECHAINICIO = this.iniciosesiones;
                FECHAFIN = this.finsesiones;
                FECHAACTUAL = this.calcularFechaActual();
                DIASPROGRAMACION = this.diasProgramacion;
                DIASDISPONIBLESPROGRAMAR = this.obtenerDiasEntreFechas(FECHAINICIO, FECHAFIN);
                vectorprogramacion = [];

                for (index = 0; index < DIASDISPONIBLESPROGRAMAR.length; index++) {
                  ELEMENT = DIASDISPONIBLESPROGRAMAR[index];
                  POSITION = ELEMENT["DIASEMANA"];
                  VALIDARDIA = DIASPROGRAMACION[POSITION];


                  if (VALIDARDIA.horainicio != "" && VALIDARDIA.horafinicio != "" && ELEMENT["FECHAFORMATEADA"] > FECHAACTUAL) {
                    horainicio = VALIDARDIA.horainicio, horafin = VALIDARDIA.horafin;
                    DIASEMANA = ELEMENT.DIASEMANA, FECHAFORMATEADA = ELEMENT.FECHAFORMATEADA;
                    CANTIDADSESIONES = this.calcularMinutos(horainicio, horafin);


                    if (SESIONESDISPONIBLES - CANTIDADSESIONES >= 0) {
                      vectorprogramacion.push({
                        horainicio: horainicio,
                        horafin: horafin,
                        dia: DIASEMANA,
                        fecha: FECHAFORMATEADA,
                        sesiones: CANTIDADSESIONES,
                        terapeuta: this.terapeutaProgramar,
                        servicio: this.servicioSeleccionado.id,
                        servicioTipo: this.servicioSeleccionado.tipo,
                        tipo: "Terapia",
                        lugar: this.programacionIndividual.lugar,
                        valor: this.servicioSeleccionado.tipo == 'particular' ? this.programacionIndividual.valorSesion : this.programacionIndividual.valorSesion.tarifa,
                        copago: this.programacionIndividual.copago,
                        paciente: this.pacienteSeleccionado.ide,
                        sede: localStorage.getItem("sede")
                      });
                      SESIONESDISPONIBLES = SESIONESDISPONIBLES - CANTIDADSESIONES;
                    }
                  }
                }

                return _context2.abrupt("return", vectorprogramacion);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function crearVectorProgramacion() {
        return _ref2.apply(this, arguments);
      }

      return crearVectorProgramacion;
    }(),
    obtenerDiasEntreFechas: function obtenerDiasEntreFechas(fechaInicio, fechaFin) {
      var diasEntreFechas = [];

      var inicio = new Date(fechaInicio + "T12:00:00-05:00");
      var fin = new Date(fechaFin + "T12:00:00-05:00");

      var fechaActual = inicio;
      while (fechaActual <= fin) {
        var año = fechaActual.getFullYear();
        var mes = fechaActual.getMonth() + 1;
        var dia = fechaActual.getDate();
        var FECHAFORMATEADA = año + "-" + (mes < 10 ? "0" : "") + mes + "-" + (dia < 10 ? "0" : "") + dia;

        var DIASEMANA = this.obtenerNombreDiaSemana(FECHAFORMATEADA);
        diasEntreFechas.push({ FECHAFORMATEADA: FECHAFORMATEADA, DIASEMANA: DIASEMANA });
        fechaActual.setDate(fechaActual.getDate() + 1);
      }
      console.log(diasEntreFechas, "dias programacion");
      return diasEntreFechas;
    },
    obtenerNombreDiaSemana: function obtenerNombreDiaSemana(fecha) {
      var diasSemana = ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"];
      var diaSemana = new Date(fecha).getDay();
      var nombreDia = diasSemana[diaSemana];
      return nombreDia;
    },
    calcularMinutos: function calcularMinutos(inicio, fin) {
      var horaInicial = this.devolverMinutos(inicio);
      var horaFinal = this.devolverMinutos(fin);

      if (horaInicial < horaFinal) {
        var sesiones = (horaFinal - horaInicial) / 30;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(sesiones);
      }
    },
    devolverMinutos: function devolverMinutos(horaMinutos) {
      return parseInt(horaMinutos.split(":")[0]) * 60 + parseInt(horaMinutos.split(":")[1]);
    },
    validarHoraInicio: function validarHoraInicio() {
      var horainicio = this.programacionIndividual.horainicio;

      if (horainicio < "07:00" || horainicio > "18:00") {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", "El rango de horas de programación es de 7:00 am y 6:00pm"));
        this.programacionIndividual.horainicio = "";
        return;
      }
    },
    validarHoraFin: function validarHoraFin() {
      var horafin = this.programacionIndividual.horafin;

      if (horafin < "07:00" || horafin > "18:00") {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", "El rango de horas de programación es de 7:00 am y 6:00pm"));
        this.programacionIndividual.horafin = "";
        return;
      }
    },

    adicionarHoras: function adicionarHoras() {
      var horainicio = this.actualizarhorainicio;
      var minutesAdd = this.eventoSeleccionado.extendedProps.cantidadSesiones * 30;

      var date = new Date("1970-01-01T" + horainicio);
      date.setMinutes(date.getMinutes() + minutesAdd);
      var newHour = date.toTimeString().slice(0, 5);

      this.actualizarhorafin = newHour + ":00";
    },
    obtenerServiciosConTarifa: function obtenerServiciosConTarifa(entidad) {
      var _this10 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/servicios-tarifa/" + entidad;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this10.arrayServiciosConTarifa = res.data.data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    this.obtenerEventos("sede");
    this.selectTerapeuta(1);
    window.document.title = "AVANTI | Programación";
  },

  components: {
    FullCalendar: __WEBPACK_IMPORTED_MODULE_5__fullcalendar_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "CJ46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip: "https://avanti-erp.com/",
      pacientes: [],
      pacienteSelected: "",
      fechaSesion: "",
      fechaValidacion: "",
      fechaActual: "",
      sesiones: []
    };
  },
  methods: {
    selectPaciente: function selectPaciente() {
      var _this = this;

      this.$modal.show("carga");
      var BASE_URL = this.ip + "api/pacientesSelect";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(BASE_URL).then(function (res) {
        _this.pacientes = res.data.data;
        _this.$modal.hide("carga");
      }).catch(function (err) {
        _this.$modal.hide("carga");
        console.log(err);
      });
    },
    updateSesions: function updateSesions() {
      var _this2 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var pacienteSelected = this.pacienteSelected;
      var fechaSesion = this.fechaSesion;
      var BASE_URL = this.ip + "api/sesionesDisponiblesCancelar/" + pacienteSelected + "/" + fechaSesion;
      if (fechaSesion == "" || pacienteSelected == "") {
        alert("Debe seleccionar un paciente y la fecha de la sesion");
        return;
      } else {
        this.$modal.show("carga");
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(BASE_URL, config).then(function (res) {
          var sesiones = res.data.data;
          var sesionesMostrar = [];
          var terapeutasSesiones = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sesiones);
          for (var index = 0; index < terapeutasSesiones.length; index++) {
            var element = sesiones[terapeutasSesiones[index]];
            var sesion = {
              paciente: element[0].PacIde,
              fecha: element[0].ProFec,
              hora: element[0].hora,
              horaFin: element[0].horaFin,
              terapeuta: element[0].terapeuta,
              autorizacion: element[0].autorizacion,
              cantidad: element.length,
              nombrePaciente: element[0].nombre + " " + element[0].apellido
            };

            sesionesMostrar.push(sesion);
          }
          _this2.$modal.hide("carga");
          _this2.sesiones = sesionesMostrar;
        }).catch(function (err) {
          _this2.$modal.hide("carga");
          console.log(err);
        });
      }
    },
    cancelarSesion: function cancelarSesion(sesion) {
      var _this3 = this;

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/cancelar-sesion";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(BASE_URL, {
        sesion: sesion,
        fechaActual: this.fechaActual
      }, config).then(function (res) {
        _this3.$modal.hide("carga");
        if (res.data.message == "orden vencida") {
          _this3.$notify({
            component: {
              template: " <div style=\"padding: 5%;\">\n                <p><strong> No se puede cancelar la sesi\xF3n</strong></p>\n                <span> La orden ya est\xE1 vencida </span>\n                </div>\n                "
            },
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });

          _this3.updateSesions();
        } else {
          _this3.$notify({
            component: {
              template: " <div style=\"padding: 5%;\">\n                <p><strong> Sesi\xF3n cancelada con \xE9xito</strong></p>\n                <span> La sesi\xF3n fue cancelada </span>\n                </div>\n                "
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
          _this3.updateSesions();
        }
      }).catch(function (err) {
        _this3.$notify({
          component: {
            template: " <div style=\"padding: 5%;\">\n              <p><strong> No se puede cancelar la sesi\xF3n</strong></p>\n              <span> Ocurri\xF3 un error en el servidor. </span>\n              </div>\n              "
          },
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger"
        });
        console.log(err);
        _this3.$modal.hide("carga");
      });
    },
    fechamenosdias: function fechamenosdias() {
      var fecha = new Date();
      fecha.setDate(fecha.getDate() - 5);


      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      return fechaFormateada;
    },

    calcularFechaActual: function calcularFechaActual() {
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    }
  },
  mounted: function mounted() {
    this.selectPaciente();
    this.fechaValidacion = this.fechamenosdias();
    this.fechaActual = this.calcularFechaActual();
    this.fechaSesion = "";
    this.pacienteSelected = '';
  }
});

/***/ }),

/***/ "CkIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedData: function pagedData() {
      return this.usuarios.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.usuarios.length;
        return this.pagedData;
      }
      var result = this.usuarios.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.usuarios.length;
      return this.usuarios.length;
    }
  },
  data: function data() {
    return {
      pagination: {
        perPage: 15,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["nombres", "apellidos", "usuario", "condicion", "nombre"],
      tableColumns: [{
        prop: "nombres",
        label: "Nombres" }, {
        prop: "apellidos",
        label: "Apellidos" }, {
        prop: "usuario",
        label: "Usuario",
        minWidth: 100
      }, {
        prop: "nombre",
        label: "Rol"
      }, {
        prop: "sede",
        label: "Sede"
      }],
      usuarios: [],

      nombreFoto: "",
      fotoEnviar: [],
      ip: "https://avanti-erp.com/",
      estadoModalAgregar: 0,
      nombres: "",
      apellidos: "",
      usuario: "",
      password: "",
      confirmPassword: "",
      rol: "",
      sede: 'Sede Principal',
      usuarioActivo: [],
      clave: "",
      firmaElectronica: "",

      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      SedesProgramacion: []
    };
  },

  methods: {
    abrirModal: function abrirModal(usuario) {
      this.$modal.show("gestionar");
      this.usuarioActivo = usuario;
    },
    cerrarModal: function cerrarModal() {
      this.$modal.hide("gestionar");
      this.usuarioActivo = [];
    },
    cargarUsuarios: function cargarUsuarios() {
      var _this2 = this;

      var token = localStorage.getItem("token");
      var user = localStorage.getItem("usuario");
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/usuarios/" + user,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this2.usuarios = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    nuevoUsuario: function nuevoUsuario() {
      var _this3 = this;

      if (this.nombres == "" || this.apellidos == "" || this.usuario == "" || this.password == "" || this.rol == "") {
        var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          component: {
            template: "<span><b>Faltan campos por llenar</b></span>"
          },
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: this.type["warning"]
        });
      } else {
        var token = localStorage.getItem("token");
        __WEBPACK_IMPORTED_MODULE_12_axios___default.a.request({
          method: "post",
          baseURL: this.ip + "api/nuevoUsuario",
          data: {
            nombres: this.nombres,
            apellidos: this.apellidos,
            usuario: this.usuario,
            password: this.password,
            rol: this.rol,
            correo: this.confirmPassword,
            sede: this.sede
          },
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json"
          }
        }).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this3.$notify({
            component: {
              template: "<span><b>Usuario registrado con \xE9xito </b></span>"
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this3.type["success"]
          });
          _this3.cargarUsuarios();

          _this3.estadoModalAgregar = 0;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    actualizarUsuario: function actualizarUsuario() {
      var _this4 = this;

      var BASE_URL = this.ip + "api/actualizarUsuario";
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.put(BASE_URL, {
        clave: this.clave,
        correo: this.usuarioActivo.email,
        tprofesional: this.usuarioActivo.tprofesional,
        cedula: this.usuarioActivo.cedula,
        id: this.usuarioActivo.id,
        rol: this.usuarioActivo.id_rol,
        foto: this.fotoEnviar,
        nombreFoto: this.nombreFoto,
        CamFir1: this.usuarioActivo.CamFir1,
        CamFir2: this.usuarioActivo.CamFir2,
        CamFir3: this.usuarioActivo.CamFir3,
        firmaElectronica: this.usuarioActivo.UsuFirEle
      }, config).then(function (res) {
        if (res.data.status = true) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this4.$notify({
            component: {
              template: " <div style=\"padding: 3%;\">\n              <span><b> USUARIO ACTUALIZADO CON \xC9XITO </b>.</span>\n              </div>\n              "
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this4.type["success"]
          });
          _this4.cargarUsuarios();
          _this4.cerrarModal();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    functionFotoPaciente: function functionFotoPaciente(e) {
      var _this5 = this;

      var reader = new FileReader();
      var fotoPaciente = e.target.files[0];
      this.nombreFoto = e.target.files[0].name;
      reader.readAsDataURL(fotoPaciente);
      reader.onload = function (e) {
        _this5.fotoEnviar = e.target.result;
      };

      console.log(this.fotoEnviar);
    },
    roles: function roles() {
      var _this6 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/roles",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this6.roles = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    desactivar: function desactivar() {
      var _this7 = this;

      var usuario = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var BASE_URL = this.ip + "api/desactivarUsuario";
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.put(BASE_URL, {
        id: usuario.id
      }, config).then(function (res) {
        if (res.data.status = true) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this7.$notify({
            component: {
              template: " <div style=\"padding: 3%;\">\n              <span><b> USUARIO INHABILITADO CON \xC9XITO </b>.</span>\n              </div>\n              "
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this7.type["success"]
          });
          _this7.cargarUsuarios();
        }
      }).catch(function (err) {
        console.log(err);
        alert("Ocurrió un error, intentelo de nuevo");
      });
    },
    activar: function activar() {
      var _this8 = this;

      var usuario = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      console.log(usuario);
      var BASE_URL = this.ip + "api/activarUsuario";
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.put(BASE_URL, {
        id: usuario.id
      }, config).then(function (res) {
        if (res.data.status = true) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this8.$notify({
            component: {
              template: " <div style=\"padding: 3%;\">\n              <span><b> USUARIO HABILITADO CON \xC9XITO </b>.</span>\n              </div>\n              "
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this8.type["success"]
          });
          _this8.cargarUsuarios();
        }
      }).catch(function (err) {
        console.log(err);
        alert("Ocurrió un error, intentelo de nuevo");
      });
    },


    emailsProgramacion: function emailsProgramacion() {
      var _this9 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/emailsProgramacion";
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this9.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },

  mounted: function mounted() {
    document.title = "Avanti | Usuarios";
    this.cargarUsuarios();
    this.roles();
    this.emailsProgramacion();
  }
});

/***/ }),

/***/ "Cqq6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__("+Rp4");



















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  data: function data() {
    return {
      ip: "https://fundaintegra.com/",
      searchQuery: "",
      fechaInicial: "",
      fechaFinal: "",
      queriedData2: [],
      fechaActual: "",
      tableColumns: [{
        prop: "nombrePaciente",
        label: "Paciente",
        minWidth: 180
      }, {
        prop: "Realizadas",
        label: "S. realizadas",
        minWidth: 100
      }, {
        prop: "PorcentajeRealizadas",
        label: "% realizadas",
        minWidth: 100
      }, {
        prop: "Canceladas",
        label: "S. canceladas",
        minWidth: 100
      }, {
        prop: "PorcentajeCanceladas",
        label: "% canceladas",
        minWidth: 100
      }, {
        prop: "SinCancelarORealizar",
        label: "S. Sin cancelar/realizar",
        minWidth: 100
      }, {
        prop: "PorcentajeSinRealizarOCancelar",
        label: "% sin cancelar/realizar",
        minWidth: 100
      }, {
        prop: "TotalSesiones",
        label: "Total de sesiones",
        minWidth: 100
      }],
      json_fields: {
        Paciente: "nombrePaciente",
        "Sesiones realizadas": "Realizadas",
        "% realizadas": "PorcentajeRealizadas",
        "Sesiones Canceladas": "Canceladas",
        "% canceladas": "PorcentajeCanceladas",
        "Sesiones sin cancelar/realizar": "SinCancelarORealizar",
        "% sin cancelar/realizar": "PorcentajeSinRealizarOCancelar",
        "Total de sesiones": "TotalSesiones"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      SedesProgramacion: [],
      sede: "Sede Principal",
      rol: "",
      tipo: "",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  methods: {
    obtenerAsistenciaPorUsuario: function obtenerAsistenciaPorUsuario(fechaInicial, fechaFinal) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sede, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.$modal.show("carga");
                sede = localStorage.getItem("sede");
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/reportes/asistencia-usuarios/" + fechaInicial + "/" + fechaFinal + "/" + sede);

              case 5:
                response = _context.sent;

                _this2.queriedData2 = response.data.eventos;
                _this2.json_data = response.data.eventos;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.log("Error al obtener los datos:" + _context.t0);

              case 13:
                _context.prev = 13;

                _this2.$modal.hide("carga");
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10, 13, 16]]);
      }))();
    },

    emailsProgramacion: function emailsProgramacion() {
      var _this3 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/emailsProgramacion";
      axios.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this3.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getClass: function getClass(column, row) {
      if (column.prop === "PorcentajeRealizadas") {
        return row.classRealizadas;
      } else if (column.prop === "PorcentajeCanceladas") {
        return row.classCanceladas;
      } else if (column.prop === "PorcentajeSinRealizarOCancelar") {
        return row.classSinRealizarOCancelar;
      }

      return "";
    }
  },
  mounted: function mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Integra | Reporte de asistencia por usuario";
  }
});

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__("HRUz");



var SidebarStore = {
    showSidebar: false,
    sidebarLinks: [],
    isMinimized: false,
    displaySidebar: function displaySidebar(value) {
        this.showSidebar = value;
    },
    toggleMinimize: function toggleMinimize() {
        document.body.classList.toggle('sidebar-mini');

        var simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);

        this.isMinimized = !this.isMinimized;
    }
};

var SidebarPlugin = {
    install: function install(Vue, options) {
        if (options && options.sidebarLinks) {
            SidebarStore.sidebarLinks = options.sidebarLinks;
        }
        Vue.mixin({
            data: function data() {
                return {
                    sidebarStore: SidebarStore
                };
            }
        });

        Object.defineProperty(Vue.prototype, '$sidebar', {
            get: function get() {
                return this.$root.sidebarStore;
            }
        });
        Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
        Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "Cs8e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_copagos_vue__ = __webpack_require__("VYlN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37817c47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_copagos_vue__ = __webpack_require__("lGNS");
function injectStyle (ssrContext) {
  __webpack_require__("K6vS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_copagos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37817c47_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_copagos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CsLv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mantenimiento_patologias_vue__ = __webpack_require__("4OcU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41756a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mantenimiento_patologias_vue__ = __webpack_require__("tKWI");
function injectStyle (ssrContext) {
  __webpack_require__("927F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-41756a7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mantenimiento_patologias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41756a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mantenimiento_patologias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CyIa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cz95":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DBcq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardnomina_vue__ = __webpack_require__("H3Ab");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e613cc16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardnomina_vue__ = __webpack_require__("H2gS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardnomina_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e613cc16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardnomina_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DOeu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination",class:_vm.paginationClass},[_c('li',{staticClass:"page-item prev-page",class:{disabled: _vm.value === 1}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Previous"},on:{"click":_vm.prevPage}},[_c('i',{staticClass:"fa fa-angle-double-left",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_vm._l((_vm.range(_vm.minPage, _vm.maxPage)),function(item){return _c('li',{staticClass:"page-item",class:{active: _vm.value === item}},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.changePage(item)}}},[_vm._v(_vm._s(item))])])}),_vm._v(" "),_c('li',{staticClass:"page-pre next-page",class:{disabled: _vm.value === _vm.totalPages}},[_c('a',{staticClass:"page-link",attrs:{"aria-label":"Next"},on:{"click":_vm.nextPage}},[_c('i',{staticClass:"fa fa-angle-double-right",attrs:{"aria-hidden":"true"}})])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DkcV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fechainicio: "",
      fechafin: "",
      sede: "",
      SedesProgramacion: [],
      ip: "https://avanti-erp.com/",
      rol: '',

      queriedData: [],
      tableColumns: [{
        prop: "nombre_paciente",
        label: "Nombres",
        minWidth: 150 }, {
        prop: "apellidos_paciente",
        label: "Apellidos",
        minWidth: 150 }, {
        prop: "codigo",
        label: "Autorizacion",
        minWidth: 130 }, {
        prop: "entidad",
        label: "Entidad",
        minWidth: 100 }, {
        prop: "fecha",
        label: "Fecha expedición",
        minWidth: 130 }, {
        prop: "fecha_vencimiento",
        label: "Fecha vencimiento",
        minWidth: 150 }, {
        prop: "pertenece",
        label: "Orden",
        minWidth: 100 }, {
        prop: "servicio",
        label: "servicio",
        minWidth: 160 }, {
        prop: "cantidad",
        label: "SSA" }, {
        prop: "consumidas",
        label: "SSR" }, {
        prop: "tipo",
        label: "Tipo",
        minWidth: 120 }, {
        prop: "usuario",
        label: "Usuario" }],
      json_fields: {
        "Nombres del paciente": "paciente",

        autorizacion: "codigo",
        Entidad: "entidad",
        "Fecha de registro": "fecha_ingreso",
        "Fecha expedición": "Fecha",
        "Fecha vencimiento": "Fecha_vencimiento",
        orden: "pertenece",
        servicio: "servicio",
        cantidad: "cantidad",
        SSR: "consumidas",
        Tipo: "tipo",
        usuario: "usuario",
        observaciones: "observacion"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]]
    };
  },
  methods: {
    getInformation: function getInformation() {
      var _this = this;

      this.$modal.show("carga");
      this.queriedData = [];

      var sede = this.rol == 1 ? this.sede : localStorage.getItem("sede");
      var BASE_URL = this.ip + "api/reporteAutorizaciones/" + this.fechainicio + "/" + this.fechafin + "/" + sede;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(BASE_URL).then(function (res) {
        var datos = [];
        _this.queriedData = res.data.data;

        for (var index = 0; index < res.data.data.length; index++) {
          datos.push({
            paciente: res.data.data[index].nombre_paciente + " " + res.data.data[index].apellidos_paciente,
            codigo: res.data.data[index].codigo,
            entidad: res.data.data[index].entidad,
            Fecha: res.data.data[index].fecha,
            Fecha_vencimiento: res.data.data[index].fecha_vencimiento,
            pertenece: res.data.data[index].pertenece,
            servicio: res.data.data[index].servicio,
            cantidad: res.data.data[index].cantidad,
            consumidas: res.data.data[index].consumidas,
            tipo: res.data.data[index].tipo,
            usuario: res.data.data[index].usuario,
            fecha_ingreso: res.data.data[index].created_at.substring(0, 10),
            observacion: res.data.data[index].observaciones
          });
        }

        _this.json_data = datos;
        _this.$modal.hide("carga");
      }).catch(function (err) {
        console.log(err);
        _this.$modal.hide("carga");
      });
    },

    emailsProgramacion: function emailsProgramacion() {
      var _this2 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/emailsProgramacion";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this2.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    this.rol = localStorage.getItem("rol");
    this.emailsProgramacion();
  }
});

/***/ }),

/***/ "DlrF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miEspacio_vue__ = __webpack_require__("uusu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed645998_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_miEspacio_vue__ = __webpack_require__("PSPc");
function injectStyle (ssrContext) {
  __webpack_require__("jnwT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed645998"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miEspacio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed645998_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_miEspacio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Doll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      fechaActual: "",

      criterio: "PacApe1",
      busqueda: "",
      arrayPacientes: [],

      spinner: 1,
      color: "#FF1873",
      loading: true,
      anos: 0,
      meses: 0,

      tipoDocumento: 4,
      numeroDocumento: "",
      apellidos: "",
      nombres: "",
      fechaIngreso: "",
      tipoCliente: "",
      Fecha_nacimiento: "",
      sexo: 1,
      paisOrigen: 1,
      departamentoOrigen: 1,
      ciudadOrigen: 1,
      paisResidencia: 1,
      departamentoResidencia: 1,
      ciudadResidencia: 1,
      direccionResidencia: "",
      barrioResidencia: "",
      telefonoContacto: "",
      eps: 16,
      poliza: 16,
      prepagada: 16,
      regimen: 1,
      emailContacto: "",
      tipoVinculacion: "",
      nombreAcompanante: "",
      telefonoAcompanante: "",
      remitente: "",
      ultimoAgregado: "",
      tipoDocumentoUltimoAgregado: "",
      PacIde: "",
      estado: 0,

      UrlDoc: "",
      UrlAcu: "",
      UrlArc: "",
      UrlOrd: "",
      UrlAut: "",
      UrlCon: "",

      apellidosAcudiente: "",
      nombresAcudiente: "",
      tipoDocumentoAcudiente: "",
      documentoAcudiente: "",
      parentesco: "",
      telefonoAcudiente: "",
      correo: "",
      ocupacion: "",
      id: 1,
      arrayAcudientes: [],

      epsp: 1,

      fechaConsulta: "",
      motivoConsulta: "",
      modalRegistrar: 0,

      tipoVinculacionAvanza: "",

      arrayCiudades: [],
      arrayDepartamentos: [],
      arrayPaises: [],
      arrayEps: [],
      arrayPrepagada: [],
      arrayPoliza: [],
      arrayTipoDocumento: [],
      arrayTipoCliente: [],
      icono: "bell",
      mensaje: "no hay datos de pacientes",

      radioRegimen: [{
        nombre: "Contributivo",
        value: 1
      }, {
        nombre: "Subsidiado",
        value: 2
      }],

      nombrefotoPaciente: null,
      fotoPaciente: [],
      fotoEnviar: [],

      nombreFotoDocumento: null,
      fotoDocumento: [],
      documentoIdentidad: [],

      nombreFotoAcudiente: null,
      fotoAcudiente: [],

      nombreConsentimientoInfor: null,
      fotoConsentimiento: [],

      nombreordenMedica: null,
      ordenMedica: [],

      nombreAutorizacion: null,
      fotoAutorizacion: [],
      nombreimagen2: null,
      foto2: [],
      arrayMotivo: [],

      lista: [],

      buscar: "",

      controlBoton: "registrar",
      controlBotonAcudiente: 0
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "estado", 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "ip", "https://avanti-erp.com/"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "type", ["", "info", "success", "warning", "danger"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "notifications", {
      topCenter: false
    }), _ref;
  },

  methods: {
    buscarPacientes: function buscarPacientes() {
      var _this = this;

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      this.arrayPacientes = [];
      var url = this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
        _this.arrayPacientes = response.data.data;
        _this.$modal.hide("carga");
      }).catch(function (error) {
        console.log(error);
      });
    },
    agregarPaciente: function agregarPaciente() {
      var _this2 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/nuevoPaciente";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, {
        PacNom1: this.nombres.toUpperCase(),
        PacNom2: "",
        PacApe1: this.apellidos.toUpperCase(),
        PacApe2: "",
        PacFecNac: this.Fecha_nacimiento,
        TipCod: this.tipoDocumento,
        PacNumDoc: this.numeroDocumento,
        PaiCodOri: this.paisOrigen,
        DepCodOri: this.departamentoOrigen,
        CiuCodOri: this.ciudadOrigen,
        PaiCodRes: this.paisResidencia,
        DepCodRes: this.departamentoResidencia,
        CiuCodRes: this.ciudadResidencia,
        EpsCod: this.eps,
        PacReg: this.regimen,
        PacTipVin: this.tipoVinculacion,
        PacNomAco: this.nombreAcompanante.toUpperCase(),
        PacTelAco: this.telefonoAcompanante,
        PacRem: this.remitente.toUpperCase(),
        PacTel: this.telefonoContacto,
        TipCliCod: this.tipoCliente,
        PacSex: this.sexo,
        PacBar: this.barrioResidencia,
        PacDir: this.direccionResidencia,
        fotoPaciente: this.fotoEnviar,
        nombreFotoPaciente: this.nombrefotoPaciente,
        PolCod: this.poliza,
        PreCod: this.prepagada,
        PacFecIng: this.fechaIngreso,
        sede: localStorage.getItem('sede'),
        emailContacto: this.emailContacto
      }, config).then(function (response) {
        if (response.data.status == true) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this2.$notify({
            component: {
              template: "<span>-<b> Paciente registrado con \xE9xito!</b>.</span>"
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this2.type[color]
          });
          _this2.calcularFechaActual();
          _this2.buscarUltimoAgregado();
          _this2.controlBoton = "editar";
        } else {
          _this2.$notify({
            component: {
              template: "<span>Lo sentimos!<b> Ocurri\xF3 un error, intentelo de nuevo!</b>.</span>"
            },
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this2.type["danger"]
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    buscarUltimoAgregado: function buscarUltimoAgregado() {
      var _this3 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var valor = this.numeroDocumento;
      var tipo = this.tipoDocumento;
      var url = this.ip + "api/ultimoPaciente/" + tipo + "/" + valor;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
        console.log(response);
        _this3.PacIde = response.data.data[0].PacIdeUsu;
      }).catch(function (error) {
        console.log(error);
      });
    },
    cargarDocumentos: function cargarDocumentos() {
      var _this4 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/guardarDocumentos";
      if (this.PacIde == "") {
        var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          component: {
            template: "<span>-<b> Faltan datos del paciente!</b>.</span>"
          },
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: this.type[color]
        });
      }

      if (this.nombreFotoDocumento != "" && this.nombreFotoAcudiente != "" && this.nombreConsentimientoInfor != "" && this.nombreordenMedica != "" && this.nombreAutorizacion != "") {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, {
          documentoPaciente: this.numeroDocumento,

          documentoIdentidad: this.documentoIdentidad,
          nombreDocumento: this.nombreFotoDocumento,

          documentoAcudiente: this.fotoAcudiente,
          nombreDocumentoAcudiente: this.nombreFotoAcudiente,

          consentimientoInformado: this.fotoConsentimiento,
          nombreConsentimientoInformado: this.nombreConsentimientoInfor,

          ordenMedica: this.ordenMedica,
          nombreOrdenMedica: this.nombreordenMedica,

          autorizacion: this.fotoAutorizacion,
          nombreAutorizacion: this.nombreAutorizacion,
          archivo: this.foto2,
          nombreArchivo: this.nombreimagen2,
          id: this.PacIde

        }, config).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this4.$notify({
            component: {
              template: "<span>!<b> Documentos registrados con \xE9xito!</b>.</span>"
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this4.type[color]
          });
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          component: {
            template: "<span>-<b> No hay documentos para guardar!</b>.</span>"
          },
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: this.type[color]
        });
      }
    },
    agregarAcudiente: function agregarAcudiente() {
      var _this5 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/nuevoTercero";

      if (this.parentesco != "" && this.documentoAcudiente != "" && this.tipoDocumentoAcudiente != "" && this.nombresAcudiente != "" && this.apellidosAcudiente != "" && this.telefonoAcudiente != "") {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, {
          TerRolCod: this.parentesco,
          TipDocTer: this.tipoDocumentoAcudiente,
          TerIde: this.documentoAcudiente,
          TipDocPac: this.tipoDocumentoUltimoAgregado,
          PacIde: this.PacIde,
          TerNom: this.nombresAcudiente.toUpperCase(),
          TerApe: this.apellidosAcudiente.toUpperCase(),
          TerTel: this.telefonoAcudiente,
          TerEma: this.correo,
          OcuCodTer: this.ocupacion
        }, config).then(function (response) {
          _this5.nombresAcudiente = "";
          _this5.documentoAcudiente = "";
          _this5.apellidosAcudiente = "";
          _this5.telefonoAcudiente = "";
          _this5.correo = "";
          _this5.parentesco = "";
          _this5.tipoDocumentoAcudiente = "";
          _this5.ocupacion = "";
          var color = Math.floor(Math.random() * 4 + 1);
          _this5.$notify({
            component: {
              template: "<span>!<b>Acudiente registrado con \xE9xito!</b>.</span>"
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this5.type[color]
          });
          _this5.llamarAcudientesDePaciente();
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          component: {
            template: "<span>-<b> Faltan campos por llenar!</b>.</span>"
          },
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: this.type[color]
        });
      }
    },
    actualizarPaciente: function actualizarPaciente() {
      var _this6 = this;

      this.$modal.show("carga");
      var url = this.ip + "api/actualizarPaciente";
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, {
        PacNom1: this.nombres.toUpperCase(),
        PacApe1: this.apellidos.toUpperCase(),
        PacFecNac: this.Fecha_nacimiento,
        PacNumDoc: this.numeroDocumento,
        TipCod: this.tipoDocumento,
        PaiCodOri: this.paisOrigen,
        DepCodOri: this.departamentoOrigen,
        CiuCodOri: this.ciudadOrigen,
        PaiCodRes: this.paisResidencia,
        DepCodRes: this.departamentoResidencia,
        CiuCodRes: this.ciudadResidencia,
        EpsCod: this.eps,
        PolCod: this.poliza,
        PreCod: this.prepagada,
        PacReg: this.regimen,
        PacTipVin: this.tipoVinculacion,
        PacNomAco: this.nombreAcompanante.toUpperCase(),
        PacTelAco: this.telefonoAcompanante,
        PacRem: this.remitente.toUpperCase(),
        PacTel: this.telefonoContacto,
        TipCliCod: this.tipoCliente,
        PacSex: this.sexo,
        PacBar: this.barrioResidencia,
        PacDir: this.direccionResidencia,
        fotoPaciente: this.fotoEnviar,
        nombreFotoPaciente: this.nombrefotoPaciente,
        PacIdeUsu: this.PacIde,
        PacFecIng: this.fechaIngreso,
        emailContacto: this.emailContacto
      }, config).then(function (response) {
        _this6.$modal.hide("carga");
        var color = Math.floor(Math.random() * 4 + 1);
        _this6.$notify({
          component: {
            template: " <div style=\"padding: 3%;\">\n              <span><b> PACIENTE ACTUALIZADO CON \xC9XITO </b>.</span>\n              </div>\n              "
          },
          icon: "fa fa-check",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: _this6.type[color]
        });

        _this6.calcularEdad();
      }).catch(function (error) {
        _this6.$modal.hide("carga");
        console.log(error);
      });
    },
    functionFotoPaciente: function functionFotoPaciente(e) {
      var _this7 = this;

      var reader = new FileReader();
      var fotoPaciente = e.target.files[0];
      this.nombrefotoPaciente = e.target.files[0].name;
      this.fotoPaciente = URL.createObjectURL(fotoPaciente);
      reader.readAsDataURL(fotoPaciente);
      reader.onload = function (e) {
        _this7.fotoEnviar = e.target.result;
      };
    },
    functionFotoDocumento: function functionFotoDocumento(e) {
      var _this8 = this;

      var reader = new FileReader();
      var documento = e.target.files[0];
      this.nombreFotoDocumento = e.target.files[0].name;
      reader.readAsDataURL(documento);
      reader.onload = function (e) {
        _this8.documentoIdentidad = e.target.result;
      };
    },
    functionFotoAcudiente: function functionFotoAcudiente(e) {
      var _this9 = this;

      var reader = new FileReader();
      var fotoAcudiente = e.target.files[0];
      this.nombreFotoAcudiente = e.target.files[0].name;
      reader.readAsDataURL(fotoAcudiente);
      reader.onload = function (e) {
        _this9.fotoAcudiente = e.target.result;
      };
    },
    functionConsentimientoInformado: function functionConsentimientoInformado(e) {
      var _this10 = this;

      var reader = new FileReader();
      var fotoConsentimiento = e.target.files[0];
      this.nombreConsentimientoInfor = e.target.files[0].name;
      reader.readAsDataURL(fotoConsentimiento);
      reader.onload = function (e) {
        _this10.fotoConsentimiento = e.target.result;
      };
    },
    functionOrdenMedica: function functionOrdenMedica(e) {
      var _this11 = this;

      var reader = new FileReader();
      var fotoOrdenMedica = e.target.files[0];
      this.nombreordenMedica = e.target.files[0].name;
      reader.readAsDataURL(fotoOrdenMedica);
      reader.onload = function (e) {
        _this11.ordenMedica = e.target.result;
      };
    },
    functionAutorizacion: function functionAutorizacion(e) {
      var _this12 = this;

      var reader = new FileReader();
      var autorizacion = e.target.files[0];
      this.nombreAutorizacion = e.target.files[0].name;
      reader.readAsDataURL(autorizacion);
      reader.onload = function (e) {
        _this12.fotoAutorizacion = e.target.result;
      };
    },
    functionImagen2: function functionImagen2(e) {
      var _this13 = this;

      var reader = new FileReader();
      var imagen2 = e.target.files[0];
      this.nombreimagen2 = e.target.files[0].name;
      reader.readAsDataURL(imagen2);
      reader.onload = function (e) {
        _this13.foto2 = e.target.result;
      };
    },
    selectCiudad: function selectCiudad() {
      var _this14 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/selectCiudad";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this14.arrayCiudades = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    selectDepartamento: function selectDepartamento() {
      var _this15 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/selectDepartamento";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this15.arrayDepartamentos = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    selectPais: function selectPais() {
      var _this16 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/selectPais";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this16.arrayPaises = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    selectEps: function selectEps() {
      var _this17 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/selectEps?reg=" + this.regimen;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this17.arrayEps = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    selectPrepagada: function selectPrepagada() {
      var _this18 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "/api/selectPrepagada";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this18.arrayPrepagada = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    selectPoliza: function selectPoliza() {
      var _this19 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "/api/selectPoliza";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this19.arrayPoliza = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    selectTipoDocumento: function selectTipoDocumento() {
      var _this20 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/tipoDocumento";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this20.arrayTipoDocumento = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    selectTipoCliente: function selectTipoCliente() {
      var _this21 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/tipoCliente";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this21.arrayTipoCliente = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    llamarPacienteExistente: function llamarPacienteExistente() {
      var _this22 = this;

      this.$modal.show("carga");
      this.fotoPaciente = [];
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };

      if (this.numeroDocumento != "") {
        var buscar = this.numeroDocumento;
        var buscar2 = this.tipoDocumento;
        var url = this.ip + "api/paciente/" + buscar2 + "/" + buscar;
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
          _this22.$modal.hide("carga");
          if (response.data.data != 0) {
            var respuesta = response.data.data[0];
            _this22.tipoDocumento = respuesta.TipCod;
            _this22.nombres = respuesta.PacNom1;
            _this22.apellidos = respuesta.PacApe1;
            _this22.Fecha_nacimiento = respuesta.PacFecNac;
            _this22.sexo = respuesta.PacSex;
            _this22.fechaIngreso = respuesta.PacFecIng;
            _this22.tipoCliente = respuesta.TipCliCod;
            _this22.paisOrigen = respuesta.PaiCodOri;
            _this22.departamentoOrigen = respuesta.DepCodOri;
            _this22.ciudadOrigen = respuesta.CiuCodOri;
            _this22.paisResidencia = respuesta.PaiCodRes;
            _this22.departamentoResidencia = respuesta.DepCodRes;
            _this22.ciudadResidencia = respuesta.CiuCodRes;
            _this22.direccionResidencia = respuesta.PacDir;
            _this22.telefonoContacto = respuesta.PacTel;
            _this22.eps = respuesta.EpsCod;
            _this22.poliza = respuesta.PolCod;
            _this22.prepagada = respuesta.PreCod;
            _this22.regimen = respuesta.PacReg;
            _this22.estado = respuesta.estado;
            if (respuesta.PacNomAco == null) {
              _this22.nombreAcompanante = "";
            } else {
              _this22.nombreAcompanante = respuesta.PacNomAco;
            }
            _this22.telefonoAcompanante = respuesta.PacTelAco;
            if (respuesta.PacRem == null) {
              _this22.remitente = "";
            } else {
              _this22.remitente = respuesta.PacRem;
            }
            if (respuesta.url_foto != null) {
              _this22.fotoPaciente = _this22.ip + respuesta.url_foto;
            }
            _this22.controlBoton = "editar";
            _this22.PacIde = respuesta.PacIdeUsu;
            _this22.fotoEnviar = null;
            _this22.nombreFotoDocumento = respuesta.NomDoc;
            _this22.nombreFotoAcudiente = respuesta.NomAcu;
            _this22.nombreConsentimientoInfor = respuesta.NomCon;
            _this22.nombreordenMedica = respuesta.NomOrd;
            _this22.nombreAutorizacion = respuesta.NomAut;
            _this22.nombreimagen2 = respuesta.NomArc;
            _this22.UrlOrd = respuesta.UrlOrd;
            _this22.UrlCon = respuesta.UrlCon;
            _this22.UrlAut = respuesta.UrlAut;
            _this22.UrlArc = respuesta.UrlArc;
            _this22.UrlDoc = respuesta.UrlDoc;
            _this22.UrlAcu = respuesta.UrlAcu;
            _this22.emailContacto = respuesta.PacEma;

            _this22.llamarAcudientesDePaciente();
            _this22.calcularEdad();
            _this22.motivos();
          } else {
            var color = Math.floor(Math.random() * 4 + 1);
            _this22.$notify({
              component: {
                template: " <div style=\"padding: 3%;\">\n                      <p><b> NO SE ENCONTRARON REGISTROS </b>.</p>\n                      </div>\n                      "
              },
              icon: "fa fa-info",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: _this22.type[color],
              width: 100,
              height: 100
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {}
    },
    llamarPacienteExistente2: function llamarPacienteExistente2(paciente) {
      var _this23 = this;

      this.numeroDocumento = paciente.PacNumDoc;
      this.tipoDocumento = paciente.TipCod;

      setTimeout(function () {
        _this23.llamarPacienteExistente();
        _this23.cerrarModal();
        _this23.arrayPacientes = [];
        _this23.busqueda = "";
      }, 1000);
    },
    llamarAcudientesDePaciente: function llamarAcudientesDePaciente() {
      var _this24 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/acudientes/" + this.PacIde;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, config).then(function (response) {
        _this24.arrayAcudientes = [];
        var respuesta = response.data.data;
        for (var i = 0; i < respuesta.length; i++) {
          var respuesta1 = response.data.data[i][0];
          _this24.arrayAcudientes.push(respuesta1);
        }

        console.log(response.data.data);

        if (_this24.nombreAcompanante == "") {
          _this24.nombreAcompanante = response.data.data[0][0].TerNom + " " + response.data.data[0][0].TerApe;
          _this24.telefonoAcompanante = response.data.data[0][0].TerTel;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    calcularEdad: function calcularEdad() {
      if (this.Fecha_nacimiento != "") {
        var fechaNacimiento = this.Fecha_nacimiento;
        var values = fechaNacimiento.split("-");
        var dia = values[2];
        var mes = values[1];
        var ano = values[0];

        var fecha_hoy = new Date();
        var ahora_ano = fecha_hoy.getFullYear();
        var ahora_mes = fecha_hoy.getMonth() + 1;
        var ahora_dia = fecha_hoy.getDate();

        var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;


        var edad = ahora_ano + 0 - ano;
        if (ahora_mes < mes) {
          edad--;
        }
        if (mes == ahora_mes && ahora_dia < dia) {
          edad--;
        }
        if (edad > 1900) {
          edad -= 1900;
        }

        var meses = 0;
        if (ahora_mes > mes) meses = ahora_mes - mes;
        if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
        if (ahora_mes == mes && dia > ahora_dia) meses = 11;

        var dias = 0;
        if (ahora_dia > dia) dias = ahora_dia - dia;
        if (ahora_dia < dia) {
          var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
          var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
        }

        this.anos = edad;
        this.meses = meses;
      } else {
        this.anos = 0;
      }
    },
    calcularFechaActual: function calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fechaIngreso = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaIngreso = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    limpiarFormulario: function limpiarFormulario() {
      var _this25 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
        title: "¿Seguro desea limpiar el formulario?",
        text: "",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        reverseButtons: true
      }).then(function (result) {
        _this25.calcularFechaActual();
        _this25.nombres = "";
        _this25.apellidos = "";
        _this25.fotoPaciente = [];
        _this25.nombrefotoPaciente = null;
        _this25.numeroDocumento = "";
        _this25.tipoVinculacion = "";
        _this25.tipoDocumento = 1;
        _this25.sexo = 1;
        _this25.paisOrigen = 1;
        _this25.tipoCliente = "";
        _this25.departamentoOrigen = 1;
        _this25.ciudadOrigen = 1;
        _this25.paisResidencia = 1;
        _this25.departamentoResidencia = 1;
        _this25.ciudadResidencia = 1;
        _this25.direccionResidencia = "";
        _this25.barrioResidencia = "";
        _this25.telefonoContacto = "";
        _this25.eps = 16;
        _this25.prepagada = 16;
        _this25.poliza = 16;
        _this25.nombreAcompanante = "";
        _this25.telefonoAcompanante = "";
        _this25.remitente = "";
        _this25.anos = 0;
        _this25.meses = 0;
        _this25.Fecha_nacimiento = "";
        _this25.estado = 1;
        _this25.controlBoton = "registrar";
        _this25.arrayAcudientes = [];
        _this25.PacIde = "";
        _this25.apellidosAcudiente = "";
        _this25.nombresAcudiente = "";
        _this25.documentoAcudiente = "";
        _this25.tipoDocumentoAcudiente = "";
        _this25.parentesco = "";
        _this25.telefonoAcudiente = "";
        _this25.correo = "";
        _this25.ocupacion = "";
        _this25.arrayAcudientes = [];
        _this25.nombreFotoDocumento = null;
        _this25.nombreFotoAcudiente = null;
        _this25.nombreConsentimientoInfor = null;
        _this25.nombreordenMedica = null;
        _this25.nombreAutorizacion = null;
        _this25.nombreimagen2 = null;
        _this25.arrayMotivo = [];
        _this25.nombreFotoDocumento = null;
        _this25.nombreFotoAcudiente = null;
        _this25.nombreConsentimientoInfor = null;
        _this25.nombreordenMedica = null;
        _this25.nombreAutorizacion = null;
        _this25.nombreimagen2 = null;
        _this25.motivoConsulta = "";
      });
    },
    limpiarFormulario2: function limpiarFormulario2() {
      var _this26 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
        title: "¿Seguro desea limpiar el formulario?",
        text: "",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        reverseButtons: true
      }).then(function (result) {
        _this26.apellidosAcudiente = "";
        _this26.nombresAcudiente = "";
        _this26.documentoAcudiente = "";
        _this26.tipoDocumentoAcudiente = "";
        _this26.parentesco = "";
        _this26.telefonoAcudiente = "";
        _this26.correo = "";
        _this26.ocupacion = "";
        _this26.arrayAcudientes = [];
        _this26.nombreFotoDocumento = null;
        _this26.nombreFotoAcudiente = null;
        _this26.nombreConsentimientoInfor = null;
        _this26.nombreordenMedica = null;
        _this26.nombreAutorizacion = null;
        _this26.nombreimagen2 = null;
      });
    },
    limpiarFormulario3: function limpiarFormulario3() {
      var _this27 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
        title: "¿Seguro desea limpiar el formulario?",
        text: "",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        reverseButtons: true
      }).then(function (result) {
        _this27.nombreFotoDocumento = null;
        _this27.nombreFotoAcudiente = null;
        _this27.nombreConsentimientoInfor = null;
        _this27.nombreordenMedica = null;
        _this27.nombreAutorizacion = null;
        _this27.nombreimagen2 = null;
        _this27.UrlCon = "";
        _this27.UrlDoc = "";
        _this27.UrlAcu = "";
        _this27.UrlArc = "";
        _this27.UrlOrd = "";
        _this27.UrlAut = "";
      });
    },
    eliminarAcudiente: function eliminarAcudiente(acudiente) {
      var _this28 = this;

      var url = this.ip + "api/eliminarRelacion/" + this.PacIde + "/" + acudiente.TerIde;
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
        title: "¿Seguro desea eliminar el registro?",
        text: "",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "Cancelar",
        reverseButtons: true
      }).then(function (result) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, {
          paciente: _this28.PacIde,
          acudiente: acudiente.TerIde
        }, config).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this28.$notify({
            component: {
              template: "<span>" + response.data.reaccion + "! " + response.data.mensaje + "!<b></b>.</span>"
            },
            icon: "ti-" + response.data.icono,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this28.type[color]
          });
          _this28.llamarAcudientesDePaciente();
        }).catch(function (error) {
          console.log(error);
        });
      });
    },
    nuevoMotivoConsulta: function nuevoMotivoConsulta() {
      var _this29 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/nuevoMotivo";
      if (this.PacIde != "") {
        if (this.motivoConsulta != "") {
          this.$modal.show("carga");
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, {
            MotFec: this.fechaActual,
            PacIde: this.PacIde,
            MotDes: this.motivoConsulta
          }, config).then(function (response) {
            _this29.$modal.hide("carga");
            var color = Math.floor(Math.random() * 4 + 1);
            _this29.$notify({
              component: {
                template: "<div style=\"padding: 3%;\">\n                      <span>'<b>" + response.data.mensaje.toUpperCase() + "</b>.</span>\n                      </div>\n                      "
              },
              icon: "fa fa-info",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: _this29.type[color]
            });
            _this29.motivoConsulta = "";
          }).catch(function (error) {
            console.log(error);
          });
        }
      } else {
        var color = Math.floor(Math.random() * 4 + 1);
        this.$notify({
          component: {
            template: "<div style=\"padding: 3%;\">\n                      <p><b>FALTAN DATOS DEL PACIENTE</b>. <br></p>\n                      </div>"
          },
          icon: "fa fa-info",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: this.type[color]
        });
      }
    },
    motivos: function motivos() {
      var _this30 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/motivos/" + this.PacIde,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this30.arrayMotivo = response.data.data;
        console.log(_this30.arrayMotivo);
      }).catch(function (error) {
        console.log(error);
      });
    },
    limpiarMotivoDeConsulta: function limpiarMotivoDeConsulta() {
      this.motivoConsulta = "";
    },
    abrirModal: function abrirModal() {
      this.$modal.show("buscar");
      this.arrayPacientes = [];
      this.busqueda = "";
    },
    cerrarModal: function cerrarModal() {
      this.$modal.hide("buscar");
    }
  },

  mounted: function mounted() {
    if (!localStorage.getItem("token")) {
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        component: {
          template: "<span>-<b> No tiene autorizaci\xF3n para est\xE1r aqu\xED</b>.</span>"
        },
        icon: "ti-close",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: this.type[color]
      });
      this.$router.push("/");
    } else {
      this.selectCiudad();
      this.selectDepartamento();
      this.selectPais();
      this.selectEps();
      this.selectPrepagada();
      this.selectPoliza();
      this.selectTipoDocumento();
      this.selectTipoCliente();
      this.calcularFechaActual();

      window.document.title = "Avanti: Ingreso de pacientes";
    }
  }
});

/***/ }),

/***/ "Dte2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EMR6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_jspdf__ = __webpack_require__("3h9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jspdf_autotable__ = __webpack_require__("+2xD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jspdf_autotable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_jspdf_autotable__);





















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },

  data: function data() {
    return {
      ip: "https://avanti-erp.com/",
      type_report: "paciente",
      searchQuery: "",
      sede: localStorage.getItem("sede"),
      rol: localStorage.getItem("rol"),
      logo: "",
      SedesProgramacion: [],
      firma: "",
      value: "todos",
      listPacientes: [],
      listTerapeutas: [],
      initialDate: "",
      endDate: "",
      queriedData2: [],
      tableColumns: [{
        prop: "paciente",
        label: "Paciente",
        minWidth: 250 }, {
        prop: "fecha",
        label: "Fecha",
        minWidth: 120 }, {
        prop: "fechaLimite",
        label: "Fecha limite",
        minWidth: 120
      }, {
        prop: "terapeuta",
        label: "Terapeuta",
        minWidth: 150
      }, {
        prop: "objetivo",
        label: "Objetivo",
        minWidth: 300
      }, {
        prop: "comentario",
        label: "Comentario del objetivo",
        minWidth: 300
      }, {
        prop: "porcentaje",
        label: "% general de avance",
        minWidth: 200
      }],
      tableColumnsTask: [{
        prop: "descripcion",
        label: "Tareas",
        minWidth: 200 }, {
        prop: "porcentaje",
        label: "%",
        minWidth: 30
      }, {
        prop: "cumplido",
        label: "Cumplido",
        minWidth: 40
      }],

      periodoVisualizacion: "all",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      optionPeriods: [{ label: "Primer trimestre", valueInitial: "01-01", valueFinal: "03-30" }, {
        label: "Segundo trimestre",
        valueInitial: "04-01",
        valueFinal: "06-31"
      }, { label: "Tercer trimestre", valueInitial: "07-01", valueFinal: "09-30" }, { label: "Cuarto trimestre", valueInitial: "10-01", valueFinal: "12-31" }],
      periodo: "",
      year: "",
      currentYear: new Date().getFullYear(),
      json_fields: {
        "Paciente": "paciente",
        "Terapeuta": "terapeuta",
        "Fecha del objetivo": "fecha",
        "Objetivo": "objetivo",
        "Logro": "comentario",
        "Tarea1": "tarea1",
        "Primera evaluación": "calificacion1",
        "Tarea2": "tarea2",
        "Segunda evaluación": "calificacion2",
        "Tarea3": "tarea3",
        "Tercera evaluación": "calificacion3"
      },
      json_data: [],
      objetivoSeleccionado: [],
      mesVisualizacion: {
        "Primer trimestre": {
          1: "Enero",
          2: "Febrero",
          3: "Marzo"
        },
        "Segundo trimestre": {
          1: "Abril",
          2: "Mayo",
          3: "Junio"
        },
        "Tercer trimestre": {
          1: "Julio",
          2: "Agosto",
          3: "Septiembre"
        },
        "Cuarto trimestre": {
          1: "Octubre",
          2: "Noviembre",
          3: "Diciembre"
        }
      },
      trimestreVisualizacion: {
        "Primer trimestre": "Ene, Feb, Mar",
        "Segundo trimestre": "Abr, May, Jun",
        "Tercer trimestre": "Jul, Ago, Sep",
        "Cuarto trimestre": "Oct, Nov, Dic"
      },
      tiposDocumento: {
        NUIP: "NUIP",
        "CÉDULA DE CIUDADANIA": "CC",
        PASAPORTE: "PA",
        "TARJETA DE IDENTIDAD": "TI",
        "CEDULA DE EXTRANJERIA": "CE",
        "REGISTRO CIVIL": "RC",
        NIT: "NI",
        RUT: "RUT",
        "PERMISO POR PROTECCIÓN TEMPORAL": "PPT"
      }
    };
  },

  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },

  methods: {
    abrirSeleccionarPeriodo: function abrirSeleccionarPeriodo(row) {
      this.objetivoSeleccionado = row;
      this.$modal.show("seleccionarPeriodo");
    },
    cerrarSeleccionarPeriodo: function cerrarSeleccionarPeriodo() {
      this.objetivoSeleccionado = [];
      this.$modal.hide("seleccionarPeriodo");
      this.periodoVisualizacion = "all";
    },
    generarPDF: function generarPDF(objetivo) {
      var _this2 = this;

      console.log(objetivo, "dssdsd");
      var doc = new __WEBPACK_IMPORTED_MODULE_14_jspdf__["jsPDF"]();
      var lineHeight = 4;
      var pageHeight = doc.internal.pageSize.height;
      var pageWidth = doc.internal.pageSize.getWidth();
      var anchoTexto = 180;
      var footerHeight = 15;

      var headerHeight = 26;
      var startX = 15;
      var startY = headerHeight + 26;
      var logo = this.logo;


      var addHeader = function addHeader(doc, periodoVisualizacion) {
        var pageCount = doc.internal.getNumberOfPages();

        var tableEncabezado = [[{
          content: "",
          styles: {
            halign: "center",
            fontSize: 10,
            fontStyle: [0, 0, 0],
            fontFamily: "helvetica"
          }
        }, {
          content: "INFORME " + (periodoVisualizacion == "all" ? "TRIMESTRAL" : "MENSUAL") + " DE OBJETIVOS Y LOGROS",
          styles: {
            halign: "center",
            fontSize: 10,
            fontStyle: "bold",
            textColor: "#302254",
            fontFamily: "helvetica"
          }
        }, {
          content: "Pag " + String(doc.internal.getCurrentPageInfo().pageNumber) + " de " + String(pageCount),
          styles: {
            halign: "center",
            fontSize: 9,
            fontStyle: "bold",
            textColor: "#000000",
            fontFamily: "helvetica"
          }
        }]];

        doc.autoTable({
          startY: 10,
          body: tableEncabezado,
          theme: "grid",
          styles: {
            cellPadding: 0,
            halign: "left",
            valign: "middle",
            lineWidth: 0,
            minCellHeight: 20
          },
          columnStyles: {
            0: { cellWidth: 50 },
            1: { cellWidth: 90 },
            2: { cellWidth: 40 }
          },
          didDrawPage: function didDrawPage(data) {}
        });
      };

      var addFooter = function addFooter(doc) {
        var pageSize = doc.internal.pageSize;
        var fechaActual = new Date();
        var fechaTexto = fechaActual.toLocaleDateString();

        doc.setFontSize(9);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        doc.text("Avanti ERP", pageWidth / 2, pageHeight - footerHeight + 7, {
          align: "center"
        });

        doc.setFontSize(9);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100);
        doc.text("Fecha impresi\xF3n: " + fechaTexto, pageSize.width / 2, pageHeight - footerHeight + 10, {
          align: "center"
        });
      };

      var setupPage = function setupPage(doc) {
        var pageCount = doc.internal.getNumberOfPages();

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          addHeader(doc, _this2.periodoVisualizacion);
          addFooter(doc);
        }
      };

      var checkPageSpace = function checkPageSpace(yPos) {
        if (yPos + lineHeight >= pageHeight - footerHeight) {
          headerHeight = 40;
          doc.addPage();
          addHeader(doc);
          addFooter(doc);
          startY = headerHeight + 10;
        }
      };

      function renderJustifiedLine(line, x, y, maxWidth) {
        var newLine = line.replace(/\s+/g, " ");
        var words = newLine.split(" ");
        var wordCount = words.length;

        if (wordCount <= 300) {
          doc.text(line, x, y);
          return;
        }

        var totalWordsWidth = words.reduce(function (total, word) {
          return total + doc.getTextWidth(word);
        }, 0);

        var spaceWidth = (maxWidth - totalWordsWidth) / (wordCount - 1);

        var currentX = x;
        words.forEach(function (word, index) {
          doc.text(word, currentX, y);
          if (index < wordCount - 1) {
            currentX += doc.getTextWidth(word) + spaceWidth;
          }
        });
      }

      var renderJustifiedText = function renderJustifiedText(text) {
        var lines = doc.splitTextToSize(text, anchoTexto);
        lines.forEach(function (line) {
          checkPageSpace(startY);
          doc.setFontSize(10);
          doc.setFont("helvetica", "normal");
          doc.setTextColor("#1E201E");
          renderJustifiedLine(line, startX, startY, anchoTexto);
          startY += lineHeight;
        });
      };

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#302254");
      doc.text("DATOS PERSONALES", 14, startY);
      startY += 5;

      var tableData = [[{
        content: "Nombre del paciente:",
        styles: {
          fontSize: 10,
          fontStyle: "bold",
          textColor: "#000000"
        }
      }, {
        content: objetivo.paciente,
        styles: { fontSize: 10 },
        colSpan: 3
      }], [{
        content: "Fecha de nacimiento:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: objetivo.fechaNacimiento,
        styles: { fontSize: 10 }
      }, {
        content: "Edad:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: this.calcularEdad(objetivo.fechaNacimiento),
        styles: { fontSize: 10 }
      }], [{
        content: "Tipo de identificación:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: this.tiposDocumento[objetivo.tipoDocumento],
        styles: { fontSize: 10 }
      }, {
        content: "Número de documento:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: parseFloat(objetivo.numeroDocumento).toLocaleString("es-ES"),
        styles: { fontSize: 10 }
      }], [{
        content: "Entidad:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: objetivo.entidad,
        styles: { fontSize: 10 }
      }, {
        content: "Mes del reporte:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: this.trimestreVisualizacion[this.periodo.label] + ", " + this.year,
        styles: { fontSize: 10 }
      }]];

      var tableData2 = [[{
        content: "Nombre del paciente:",
        styles: {
          fontSize: 10,
          fontStyle: "bold",
          textColor: "#000000"
        }
      }, {
        content: objetivo.paciente,
        styles: { fontSize: 10 },
        colSpan: 3
      }], [{
        content: "Fecha de nacimiento:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: objetivo.fechaNacimiento,
        styles: { fontSize: 10 }
      }, {
        content: "Edad:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: this.calcularEdad(objetivo.fechaNacimiento),
        styles: { fontSize: 10 }
      }], [{
        content: "Tipo de identificación:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: this.tiposDocumento[objetivo.tipoDocumento],
        styles: { fontSize: 10 }
      }, {
        content: "Número de documento:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: parseFloat(objetivo.numeroDocumento).toLocaleString("es-ES"),
        styles: { fontSize: 10 }
      }], [{
        content: "Entidad:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: objetivo.entidad,
        styles: { fontSize: 10 }
      }, {
        content: "Mes del reporte:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: this.mesVisualizacion[this.periodo.label][this.periodoVisualizacion] + ", " + this.year,
        styles: { fontSize: 10 }
      }]];

      doc.autoTable({
        startY: startY,
        theme: "grid",
        body: this.periodoVisualizacion == "all" ? tableData : tableData2,
        margin: { top: headerHeight + 15, bottom: footerHeight + 20 },
        styles: {
          minCellHeight: 10 * 1.15,
          fontSize: 10,
          cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
          lineWidth: 0.1
        },
        pageBreak: "auto"
      });
      startY = doc.lastAutoTable.finalY + 10;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#302254");
      doc.text("DATOS DEL OBJETIVO", 14, startY);
      startY += 10;

      var tablaObjetivo = [[{
        content: "Porcentaje general de avance:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: objetivo.porcentaje + "%",
        styles: { fontSize: 10, fontStyle: "bold", textColor: objetivo.porcentaje >= 60 ? "green" : "red" }
      }, {
        content: "Periodo de evaluación:",
        styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
      }, {
        content: this.periodo.label,
        styles: { fontSize: 10 }
      }]];

      var comentario = objetivo && objetivo.comentario ? objetivo.comentario : "";

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor("#000000");
      doc.text("Objetivo propuesto:", 14, startY);
      startY += 5;

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.setTextColor("#1E201E");
      renderJustifiedText(objetivo.objetivo);
      startY += 5;

      if (comentario != "") {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.setTextColor("#000000");
        doc.text("Logro del objetivo:", 14, startY);
        startY += 5;

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor("#1E201E");
        renderJustifiedText(comentario);
        startY += 10;
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor("#000000");
      doc.text("Porcentaje general de avance:", 14, startY);
      startY += 5;

      var porcentaje = objetivo.porcentaje == 0 ? "Pendiente evaluar" : objetivo.porcentaje + "%";
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(objetivo.porcentaje >= 60 ? "green" : "red");
      doc.text("" + porcentaje, 14, startY);
      startY += 10;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor("#000000");
      doc.text("Periodo de evaluación:", 14, startY);
      startY += 5;

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.setTextColor("#000000");
      doc.text("" + this.periodo.label, 14, startY);
      startY += 13;

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor("#302254");
      doc.text("DATOS DE LAS TAREAS", 14, startY);
      startY += 5;

      var tableDataTareas = [];

      var calificacion1 = objetivo.tareas[0].calificaciones[0];
      var calificacion2 = objetivo.tareas[1].calificaciones[0];
      var calificacion3 = objetivo.tareas[2].calificaciones[0];

      if (this.periodoVisualizacion == "all") {
        tableDataTareas = [[{
          content: objetivo.tareas[0].description,
          styles: { fontSize: 10, fontStyle: "normal" }
        }, {
          content: "" + objetivo.tareas[0].calificaciones[0],
          styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion1 >= 60 ? "green" : "red" }
        }], [{
          content: objetivo.tareas[1].description,
          styles: { fontSize: 10, fontStyle: "normal" }
        }, {
          content: "" + objetivo.tareas[1].calificaciones[0],
          styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion2 >= 60 ? "green" : "red" }
        }], [{
          content: objetivo.tareas[2].description,
          styles: { fontSize: 10, fontStyle: "normal" }
        }, {
          content: "" + objetivo.tareas[2].calificaciones[0],
          styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion3 >= 60 ? "green" : "red" }
        }]];
      } else if (this.periodoVisualizacion == 1) {
        tableDataTareas = [[{
          content: objetivo.tareas[0].description,
          styles: { fontSize: 10, fontStyle: "normal" }
        }, {
          content: objetivo.tareas[0].calificaciones[0] + "%",
          styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion1 >= 60 ? "green" : "red" }
        }]];
      } else if (this.periodoVisualizacion == 2) {
        tableDataTareas = [[{
          content: objetivo.tareas[1].description,
          styles: { fontSize: 10, fontStyle: "normal" }
        }, {
          content: objetivo.tareas[1].calificaciones[0] + "%",
          styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion2 >= 60 ? "green" : "red" }
        }]];
      } else if (this.periodoVisualizacion == 3) {
        tableDataTareas = [[{
          content: objetivo.tareas[2].description,
          styles: { fontSize: 10, fontStyle: "normal" }
        }, {
          content: objetivo.tareas[2].calificaciones[0] + "%",
          styles: { fontSize: 10, fontStyle: "bold", textColor: calificacion3 >= 60 ? "green" : "red" }
        }]];
      }

      var tableDataHeader = [];

      if (this.periodoVisualizacion == "all") {
        tableDataHeader = [["Tareas", "Calificación"]];
      } else {
        tableDataHeader = [["Tarea", "Calificaci\xF3n"]];
      }

      doc.autoTable({
        startY: startY,
        theme: "grid",
        head: tableDataHeader,
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "center"
        },
        columnStyles: {
          0: { cellWidth: 107 }
        },
        body: tableDataTareas,
        margin: { top: headerHeight + 15, bottom: footerHeight + 20 },
        styles: {
          minCellHeight: 10 * 1.15,
          fontSize: 10,
          cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
          halign: "center"
        },
        pageBreak: "auto"
      });
      startY = doc.lastAutoTable.finalY + 10;

      setupPage(doc);

      doc.save("reporte de objetivos de " + objetivo.paciente + ".pdf");
      this.cerrarSeleccionarPeriodo();
    },

    getObjetives: function getObjetives() {
      var _this3 = this;

      if (this.value == "" || this.periodo == "" || this.yeah == "") {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__global_services_crearAlerta__["a" /* default */])("danger", "Parametros incompletos para la busqueda"));
        return;
      }

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };

      var fechaInicial = this.year + "-" + this.periodo.valueInitial;
      var fechaFinal = this.year + "-" + this.periodo.valueFinal;
      var paciente = this.value;
      var BASE_URL = this.ip + "api/reportes/objetivos-y-logros/" + paciente + "/" + fechaInicial + "/" + fechaFinal + "/" + this.sede;
      __WEBPACK_IMPORTED_MODULE_11_axios___default.a.get(BASE_URL, config).then(function (res) {
        var datos = res.data.data.map(function (element) {
          return {
            paciente: element.apellidoPaciente + " " + element.nombrePaciente,
            terapeuta: element.apellidoTerapeuta + " " + element.nombreTerapeuta,
            fecha: element.fecha,
            fechaLimite: element.fechaCumplimiento,
            terapeutaUsuario: element.terapeuta,
            objetivo: element.objetivo,
            tareas: element.tareas,
            comentario: element.logroGeneral,
            porcentaje: element.porcentaje,
            numeroDocumento: element.numeroDocumento,
            fechaNacimiento: element.fechaNacimiento,
            tipoDocumento: element.tipoDocumento,
            entidad: element.entidad
          };
        });
        _this3.queriedData2 = datos;
        _this3.json_data = _this3.formatedObjetivesV2(datos);
        _this3.logo = res.data.logo;
        _this3.$modal.hide("carga");
      }).catch(function (err) {
        _this3.$modal.hide("carga");
        console.log(err);
      });
    },
    formatedObjetivesV2: function formatedObjetivesV2(datos) {
      var dataReturn = [];
      datos.forEach(function (element) {
        dataReturn.push({
          paciente: element.paciente,
          terapeuta: element.terapeuta,
          fecha: element.fecha,
          fechaLimite: element.fechaLimite,
          objetivo: element.objetivo,
          comentario: element.comentario,
          porcentaje: element.porcentaje,
          tarea1: element.tareas[0].description,
          calificacion1: element.tareas[0].calificaciones[0],
          tarea2: element.tareas[1].description,
          calificacion2: element.tareas[1].calificaciones[0],
          tarea3: element.tareas[2].description,
          calificacion3: element.tareas[2].calificaciones[0]
        });
      });

      console.log(dataReturn, 'Nuevo excel');
      return dataReturn;
    },
    formatedObjetives: function formatedObjetives(datos) {
      console.log(datos);
      var datosReturn = [];
      datos.forEach(function (element) {
        var tareas = element.tareas;
        tareas.forEach(function (elementTask) {
          datosReturn.push({
            description: elementTask.description,
            calificacion1: elementTask.calificaciones[0] == "Sin calificar" ? "-1" : elementTask.calificaciones[0],
            objetivo: element.objetivo,
            paciente: element.paciente,
            terapeuta: element.terapeuta
          });
        });
      });

      console.log(datosReturn, "datos returned");
      return datosReturn;
    },
    calcularEdad: function calcularEdad(fecha) {
      var fechaNacimiento = fecha;
      var values = fechaNacimiento.split("-");
      var dia = values[2];
      var mes = values[1];
      var ano = values[0];

      var fecha_hoy = new Date();
      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;


      var edad = ahora_ano + 0 - ano;
      if (ahora_mes < mes) {
        edad--;
      }
      if (mes == ahora_mes && ahora_dia < dia) {
        edad--;
      }
      if (edad > 1900) {
        edad -= 1900;
      }

      var meses = 0;
      if (ahora_mes > mes) meses = ahora_mes - mes;
      if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
      if (ahora_mes == mes && dia > ahora_dia) meses = 11;

      var dias = 0;
      if (ahora_dia > dia) dias = ahora_dia - dia;
      if (ahora_dia < dia) {
        var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
        var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
      }

      return edad + " a\xF1o(s) y " + meses + " mes(es)";
    },

    getListPacientes: function getListPacientes() {
      var _this4 = this;

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var sede = this.sede;
      var BASE_URL = this.ip + "api/list-pacientes/" + sede;
      __WEBPACK_IMPORTED_MODULE_11_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this4.$modal.hide("carga");
        _this4.listPacientes = res.data.data;
      }).catch(function (err) {
        _this4.$modal.hide("carga");
        alert("Ocurrió un error al traer los eventos, por favor comunique al administrador. ERROR: " + err);
        console.log(err);
      });
    },
    selectTerapeutas: function selectTerapeutas(especialidad) {
      var _this5 = this;

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/selectTerapeutasProgramar/" + especialidad;
      __WEBPACK_IMPORTED_MODULE_11_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this5.$modal.hide("carga");
        _this5.listTerapeutas = res.data.data;
      }).catch(function (err) {
        _this5.$modal.hide("carga");
        console.log(err);
      });
    },
    emailsProgramacion: function emailsProgramacion() {
      var _this6 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/emailsProgramacion";
      __WEBPACK_IMPORTED_MODULE_11_axios___default.a.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this6.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    cambiarSede: function cambiarSede() {
      this.getListPacientes();
      this.queriedData2 = [];
      this.json_data = [];
    }
  },

  mounted: function mounted() {
    this.getListPacientes();
    this.selectTerapeutas(1);
    this.emailsProgramacion();
  }
});

/***/ }),

/***/ "En5H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('nomicard',{staticStyle:{"background-color":"#45a22f","color":"white"},attrs:{"title":"Ingresos totales por SSR","imgRoute":"static/img/nomina/ganador.png","value":_vm.realizadas,"footerText":_vm.cardFooterText}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('nomicard',{staticStyle:{"background-color":"#d32437","color":"white"},attrs:{"title":"Servicios no completados","imgRoute":"static/img/nomina/perdida.png","value":_vm.canceladas,"footerText":_vm.cardFooterText}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('nomicard',{staticStyle:{"background-color":"#21659e","color":"white"},attrs:{"title":"Ingreso en copagos","imgRoute":"static/img/nomina/bolsa-de-dinero.png","value":_vm.copago,"footerText":_vm.cardFooterText}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('nomicard',{staticStyle:{"background-color":"#da9729","color":"white"},attrs:{"title":"Pago a terapeutas","imgRoute":"static/img/nomina/dar-dinero.png","value":_vm.terapeuta,"footerText":_vm.cardFooterText}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Eu9G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_aDashboard_nomina_cardnominaespecialidad_vue__ = __webpack_require__("FJOV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__global_services_formatear_pesos__ = __webpack_require__("1byD");









/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  data: function data() {
    return {
      informacionEspecialidad: []
    };
  },

  components: {
    nomicard: __WEBPACK_IMPORTED_MODULE_3_src_components_aDashboard_nomina_cardnominaespecialidad_vue__["a" /* default */]
  },
  methods: {
    getInformationEspecialidades: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(fechaInicial, fechaFinal) {
        var BASE_URL, response, data, dataFormated;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                BASE_URL = "api/informacion-dashboard-especialidad/" + fechaInicial + "/" + fechaFinal;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_src_global_services_axiosInstance__["a" /* default */].get(BASE_URL);

              case 4:
                response = _context.sent;

                if (response.data.status == true) {
                  data = response.data.data;
                  dataFormated = data.map(function (element) {
                    var clase = '';
                    var nombre = '';
                    if (element.especialidad == 2) {
                      clase = 'fisioterapia';
                      nombre = 'fisioterapia';
                    } else if (element.especialidad == 3) {
                      clase = 'fonoaudiologia';
                      nombre = 'fonoaudiologia';
                    } else if (element.especialidad == 4) {
                      clase = 'terapia_ocupacional';
                      nombre = 'terapia ocupacional';
                    } else if (element.especialidad == 5) {
                      clase = 'educacion_especial';
                      nombre = 'educacion especial';
                    } else {
                      clase = 'psicologia';
                      nombre = 'psicologia';
                    }

                    return {
                      nombre: nombre.toLocaleUpperCase(),
                      realizadas: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__global_services_formatear_pesos__["a" /* default */])(element.Realizadas),
                      clase: clase
                    };
                  });


                  this.informacionEspecialidad = dataFormated;
                }
                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

              case 10:
                _context.prev = 10;
                return _context.finish(10);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8, 10, 12]]);
      }));

      function getInformationEspecialidades(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getInformationEspecialidades;
    }()
  }
}, "components", {
  nomicard: __WEBPACK_IMPORTED_MODULE_3_src_components_aDashboard_nomina_cardnominaespecialidad_vue__["a" /* default */]
}));

/***/ }),

/***/ "F5ab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardNomina_vue__ = __webpack_require__("721n");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f670c4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardNomina_vue__ = __webpack_require__("Yg7q");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardNomina_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f670c4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardNomina_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FJOV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardnominaespecialidad_vue__ = __webpack_require__("e5Qa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ae3c150_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardnominaespecialidad_vue__ = __webpack_require__("7XvZ");
function injectStyle (ssrContext) {
  __webpack_require__("K2kv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ae3c150"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardnominaespecialidad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ae3c150_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardnominaespecialidad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FZq3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-5"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-7"},[_vm._t("content")],2)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FfHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"card-header"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.prepararNuevaTarifa()}}},[_vm._v("Agregar tarifa")])]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"mensaje-vacio"}},[_c('center',[(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e()])],1),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding":"15px"},attrs:{"id":"paginacion"}},[_c('div',{staticClass:"col-md-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12",attrs:{"id":"exportar"}},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill mb-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"tarifas-especialidades","name":"Tarifas avanza"}},[_vm._v("\n              Exportar a excel "),_c('i',{staticClass:"fa fa-download",attrs:{"color":"black"}})]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-12",attrs:{"id":"table"}},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive table-striped mt-2",attrs:{"border":"","data":_vm.queriedData}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"full-width",class:_vm.getClass(column, row)},[(_vm.getClass(column, row) != '')?_c('strong',[_vm._v(_vm._s(_vm.formatearPesosColombianos(row[column.prop])))]):_c('span',[_vm._v(_vm._s(row[column.prop]))])])]}}],null,true)})}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-simple btn-info btn-icon like",on:{"click":function($event){return _vm.modal(props.row)}}},[_c('i',{staticClass:"ti-pencil"})])])]}}],null,false,3884023063)})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n              Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e(),_vm._v(" "),_c('modal',{attrs:{"name":"agregar_tarifa","scrollable":true,"width":"550","height":"auto","reset":true}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('strong',{staticClass:"titulo-modal"},[_vm._v("\n                    GESTIONAR LA INFORMACIÓN DE LAS TARIFAS DE EPS\n                  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"grey"}},[_vm._v("\n                    Asignación y/o modifiación de las tarifas\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"eps"}},[_vm._v("Eps:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eps),expression:"eps"}],staticClass:"form-control",attrs:{"name":"eps","id":"eps"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.eps=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("seleccione la eps")]),_vm._v(" "),_vm._l((_vm.arrayEps),function(eps){return _c('option',{key:eps.codigo,domProps:{"value":eps.codigo}},[_vm._v("\n                      "+_vm._s(eps.nombre)+"\n                    ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"eps"}},[_vm._v("Especialidad:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.especialidad),expression:"especialidad"}],staticClass:"form-control",attrs:{"name":"eps","id":"eps"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.especialidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("seleccione la especialidad")]),_vm._v(" "),_vm._l((_vm.arrayEspecialidades),function(especialidad){return _c('option',{key:especialidad.codigo,domProps:{"value":especialidad.codigo}},[_vm._v("\n                      "+_vm._s(especialidad.nombre)+"\n                    ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"tarifa"}},[_vm._v("Tarifa:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tarifa),expression:"tarifa"}],staticClass:"form-control",attrs:{"type":"number","id":"tarifa"},domProps:{"value":(_vm.tarifa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tarifa=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-secondary",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.cerrarModal()}}},[_vm._v("Cancelar")]),_vm._v(" "),(_vm.accion=='registrar')?_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.newRate()}}},[_vm._v("Guardar")]):_vm._e(),_vm._v(" "),(_vm.accion=='actualizar')?_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.updateRate()}}},[_vm._v("Actualizar")]):_vm._e()])],1)])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Gestión de tarifas en avanza")]),_vm._v(" "),_c('p',[_vm._v("\n            Aquí podrá gestionar la información relacionada con las\n            "),_c('span',{staticClass:"text-success"},[_vm._v("tarifas")]),_vm._v(" de las eps que tienen\n            convenio con "),_c('span',{staticClass:"text-success"},[_vm._v("Avanza")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FiZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'Dashboard',
    icon: 'ti-file',
    collapsed: true,
    children: [{
        name: 'Dashboard',
        icon: 'user',
        path: '/dashboard/avanti'
    }, {
        name: 'Gestión de autorizaciones',
        icon: 'user',
        path: '/gestion-ordenes'
    }]

}, {
    name: 'Reportes',
    icon: 'ti-folder',
    collapsed: true,
    children: [{
        name: 'Pacientes',
        icon: 'user',
        path: '/reportes/pacientes'
    }, {
        name: 'Ordenes Medicas',
        icon: 'user',
        path: '/reportes/ordenes'
    }, {
        name: 'Reporte Maestro',
        icon: 'user',
        path: '/reportes/maestro'
    }, {

        name: 'Reporte de autorizaciones',
        icon: 'user',
        path: '/reportes/autorizaciones'
    }, {

        name: 'Informes de paciente',
        icon: 'user',
        path: '/reportes/informeEvolucion'
    }]
}, {
    name: 'Admisiones',
    icon: 'ti-user',
    collapsed: true,
    children: [{
        name: 'Ingreso de pacientes',
        icon: 'user',
        path: '/admisiones/ingreso'
    }, {
        name: 'Pacientes Registrados',
        icon: 'user',
        path: '/admisiones/pacientes'
    }, {
        name: 'Ingreso de autorizaciones',
        icon: 'user',
        path: '/admisiones/servicios'
    }]
}, {
    name: 'Historia Clínica',
    icon: 'ti-folder',
    collapsed: true,
    children: [{
        name: 'Historia Clínica',
        path: '/historiaClinica/historia'
    }]
}, {
    name: 'Mantenimiento',
    icon: 'ti-settings',
    collapsed: true,
    children: [{
        name: 'Eps',
        path: '/mantenimiento/mantenimientoEps'
    }, {
        name: 'Patologías',
        path: '/mantenimiento/mantenimientoPatologias'
    }, {
        name: 'Motivo de Consulta',
        path: '/mantenimiento/mantenimientoMC'
    }, {
        name: 'Material de apoyo',
        path: '/mantenimiento/mantenimientoMat'
    }, {
        name: 'Estrategías terapeuticas',
        path: '/mantenimiento/mantenimientoEs'
    }]
}, {
    name: 'Acceso',
    icon: 'ti-shift-right',
    collapsed: true,
    children: [{
        name: 'Usuarios',
        path: '/acceso/usuario'
    }, {
        name: 'Roles',
        path: '/acceso/roles'
    }]
}, {
    name: 'Plan de intervención',
    icon: 'ti-agenda',
    collapsed: true,
    children: [{
        name: 'Evoluciones',
        path: '/diarioCampo/evoluciones'
    }, {
        name: 'Objetivos y Logros',
        path: '/diarioCampo/objetivos-y-logros'
    }, {
        name: 'Objetivos y Logros en Familia',
        path: '/diarioCampo/objetivos-logros-familia'
    }]
}, {
    name: 'Programación',
    icon: 'ti-alarm-clock',

    collapsed: true,
    children: [{
        name: 'Programación de citas',
        path: '/programacion/programacion-citas'
    }]
}]);

/***/ }),

/***/ "FlRp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_aDashboard_nomina_cardnomina_vue__ = __webpack_require__("DBcq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__ = __webpack_require__("1byD");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      informacionEntidad: [],
      resumenEntidad: 0,
      resumenCanceladasEntidad: 0
    };
  },

  methods: {
    getInformationEntidades: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fechaInicial, fechaFinal) {
        var BASE_URL, response, data, resumen, resumenCanceladas, dataFormated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                BASE_URL = "api/informacion-dashboard-entidad/" + fechaInicial + "/" + fechaFinal;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__["a" /* default */].get(BASE_URL);

              case 4:
                response = _context.sent;

                if (response.data.status == true) {
                  data = response.data.data;
                  resumen = 0;
                  resumenCanceladas = 0;
                  dataFormated = data.map(function (element) {
                    resumen = resumen + parseInt(element.Realizadas);
                    resumenCanceladas = resumenCanceladas + parseInt(element.Canceladas);
                    return {
                      nombre: element.nombre,
                      realizadas: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(element.Realizadas),
                      canceladas: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(element.Canceladas)
                    };
                  });

                  this.resumenCanceladasEntidad = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(resumenCanceladas);
                  this.resumenEntidad = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(resumen);
                  this.informacionEntidad = dataFormated;
                }
                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

              case 10:
                _context.prev = 10;
                return _context.finish(10);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8, 10, 12]]);
      }));

      function getInformationEntidades(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getInformationEntidades;
    }()
  },
  components: {
    nomicard: __WEBPACK_IMPORTED_MODULE_2_src_components_aDashboard_nomina_cardnomina_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "GGWZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[(_vm.rol == 1 || _vm.rol == 20 || _vm.rol == 23 || _vm.rol == 19)?_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Sede:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sede),expression:"sede"}],staticClass:"form-control",staticStyle:{"background-color":"white"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sede=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.cambiarSede()}]}},_vm._l((_vm.SedesProgramacion),function(sede){return _c('option',{key:sede.sede,domProps:{"value":sede.sede}},[_vm._v("\n            "+_vm._s(sede.sede)+"\n          ")])}),0),_vm._v(" "),_c('br')]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"type_report"}},[_vm._v("Seleccione el Paciente")]),_vm._v(" "),(_vm.type_report == 'paciente')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"form-control",staticStyle:{"background-color":"white"},attrs:{"id":"type_report"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.value=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.listPacientes),function(paciente){return _c('option',{key:paciente.id,domProps:{"value":paciente.id}},[_vm._v("\n            "+_vm._s(paciente.apellidos)+" "+_vm._s(paciente.nombres)+"\n          ")])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3",staticStyle:{"margin-top":"25px"}},[_c('button',{staticClass:"btn btn-success btn-block btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.getEvents()}}},[_vm._v("\n          Buscar\n        ")])]),_vm._v(" "),_c('div')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacíos","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{ref:"component",staticClass:"col-md-12"},[_c('div',[_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row[column.prop]))])]}}],null,true)})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"label":"Acción"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[(props.row.estado == 3)?_c('span',{staticClass:"badge text-bg-success",staticStyle:{"background-color":"red"}},[_vm._v("Pendiente por evolucionar")]):_vm._e(),_vm._v(" "),(props.row.estado == 1)?_c('span',{staticClass:"badge text-bg-success",staticStyle:{"background-color":"green"}},[_vm._v("Evolucionado")]):_vm._e()])]}}],null,false,1331456474)}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"label":"Acción"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-fill btn-sm btn-success",staticStyle:{"border-radius":"5px"},attrs:{"title":"Exportar a PDF"},on:{"click":function($event){return _vm.getInfoPDF(props.row)}}},[_c('i',{staticClass:"ti-file"}),_vm._v(" Exportar\n                    ")])])]}}],null,false,823007729)})],2)],1)]):_vm._e()]),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("INFORME CLÍNICO DE VALORACIÓN")]),_vm._v(" "),_c('p',{staticStyle:{"color":"darkgray","margin-bottom":"30px"}},[_vm._v("\n      Reporte donde se puede ver la valoraciones de un\n      "),_c('span',{staticClass:"text-success"},[_vm._v("paciente")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GTEX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_switches__ = __webpack_require__("lqen");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      c90: false,
      formato: 1,
      criterio: "PacApe1",
      buscar: true,
      arrayPacientes: [],
      busqueda: "",
      ip: "https://avanti-erp.com/",
      nombre: "",
      documento: "",
      pacIde: "",
      alertTipoCliente: '',
      numeroOrden: "",
      eps: "",
      cobertura: "",
      regimen: 1,
      fechaExpedicion: "",
      fechaVencimiento: "",
      arrayCantidad: [],
      arrayEspecialidad: [],
      cantidad: "",
      observaciones: '',
      epsCod: "",
      especialidad: "",
      arrayOrdenes: [],
      tablaOrden: false,
      numeroAutorizacion: "",
      fechaExpedicionAutorizacion: "",
      coberturaAutorizacion: "",
      arrayEps: [],
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      boton: true,
      mensaje: null,
      icono: null,
      bolsa: 0
    };
  },

  components: {
    Switches: __WEBPACK_IMPORTED_MODULE_1_vue_switches__["a" /* default */]
  },
  methods: {
    eliminarServicio: function eliminarServicio(index, fila) {
      this.arrayCantidad.splice(index, 1);

      this.bolsa = this.bolsa - parseInt(fila.cantidad);
      console.log('Bolsa', this.bolsa);
    },
    buscarPacientes: function buscarPacientes() {
      var _this = this;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      this.arrayPacientes = [];
      var vm = this;
      var url = this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        vm.arrayPacientes = response.data.data;
        _this.buscar = false;
        console.log(response.data.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    seleccionarPaciente: function seleccionarPaciente(paciente) {
      var _this2 = this;

      if (paciente.TipCliCod != localStorage.getItem("tipoClienteIngreso")) {
        var alerta = confirm('El tipo de cliente de este paciente, no concuerta con el modulo seleccionado, ¿desea continuar?');
        if (alerta == true) {
          this.buscar = true;
          this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
          this.documento = paciente.PacNumDoc;
          this.pacIde = paciente.PacIdeUsu;
          this.alertTipoCliente = true;

          setTimeout(function () {
            _this2.cargarOrdenes();
          }, 1000);
        }
      } else {
        this.buscar = true;
        this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
        this.documento = paciente.PacNumDoc;
        this.pacIde = paciente.PacIdeUsu;
        this.alertTipoCliente = false;

        setTimeout(function () {
          _this2.cargarOrdenes();
        }, 1000);
      }
    },
    generarCodigo: function generarCodigo() {
      this.numeroOrden = "EPS-" + this.pacIde + "-" + this.fechaExpedicion;
    },
    selectEspecialidad: function selectEspecialidad() {
      var _this3 = this;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/selectEspecialidad";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data.data;
        _this3.arrayEspecialidad = respuesta;
      }).catch(function (error) {
        console.log(error);
      });
    },
    agregarServicios: function agregarServicios() {
      if (this.especialidad != "" && this.cantidad != "") {
        this.arrayCantidad.push({
          servicio: this.especialidad[0],
          cantidad: this.cantidad,
          nombre: this.especialidad[1]
        });

        this.bolsa = parseInt(this.bolsa) + parseInt(this.cantidad);

        console.log("Bolsa", this.bolsa);

        this.cantidad = "";
        this.especialidad = "";
      }
    },
    cargarOrdenes: function cargarOrdenes() {
      var _this4 = this;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/cargarOrdenesActivas/" + this.pacIde + "/eps";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        _this4.arrayOrdenes = response.data.data;

        _this4.tablaOrden = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    seleccionarOrden: function seleccionarOrden(orden) {
      this.tablaOrden = false;
      this.numeroOrden = orden.OrdCod;
      this.eps = orden.EpsNom;
      this.fechaExpedicion = orden.OrdFec;
      this.fechaVencimiento = orden.OrdVen;
      this.numeroAutorizacion = "EPS-AUT-" + this.pacIde;
      this.epsCod = orden.CodEnt;
    },
    selectEps: function selectEps() {
      var _this5 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/selectEps?reg=" + this.regimen;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this5.arrayEps = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    nuevaAutorizacionSinOM: function nuevaAutorizacionSinOM() {
      var _this6 = this;

      if (this.bolsa == 0) {
        alert("Debe cargar servicios");
      } else {
        this.$modal.show("carga");
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        };
        if (this.coberturaAutorizacion == "") {
          this.fechaVencimientoAutorizacion = "";
          this.cobertura = 0;
        } else {
          this.calcularFechaAutorizacion();
          var url = this.ip + "api/nuevaAutorizacionSinOM";
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
            codigoOrden: this.numeroAutorizacion,
            tipoServicio: "adm",
            entidad: 16,
            fechaOrden: this.fechaExpedicionAutorizacion,
            cobertura: this.coberturaAutorizacion,
            fechaVencimiento: this.fechaVencimientoAutorizacion,
            paciente: this.pacIde,
            servicios: this.arrayCantidad,
            formato: 1,
            pertenece: "avanza",
            usuario: localStorage.getItem("usuario"),
            bolsa: this.bolsa,
            observacion: this.observaciones
          }, config).then(function (response) {
            var color = Math.floor(Math.random() * 4 + 1);
            _this6.$notify({
              component: {
                template: "<span>!<b> Autorizaci\xF3n registrada con \xE9xito!</b>.</span>"
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: _this6.type[color]
            });
            _this6.bolsa = 0;

            _this6.$modal.hide("carga");
            _this6.cerrar();
          }).catch(function (error) {
            console.log(error);
            _this6.$modal.hide("carga");
          });
        }
      }
    },
    calcularFecha: function calcularFecha() {
      var dias = parseInt(this.cobertura);
      var fechaInicio = new Date(this.fechaExpedicion);
      fechaInicio.setDate(fechaInicio.getDate() + dias);

      var fechaFin = new Date(fechaInicio);

      var dia = fechaFin.getDate();
      var mes = fechaFin.getMonth() + 1;
      var ano = fechaFin.getFullYear();
      var cero = "0";
      if (mes < 10 && dia < 10) {
        this.fechaVencimiento = ano + "-" + "0" + mes + "-" + "0" + dia;
        this.fechaVencimientoAutorizacion = ano + "-" + "0" + mes + "-" + "0" + dia;
      } else {
        this.fechaVencimiento = ano + "-" + mes + "-" + dia;
        this.fechaExpedicionAutorizacion = ano + "-" + mes + "-" + dia;
      }
    },
    calcularFechaAutorizacion: function calcularFechaAutorizacion() {
      var dias = parseInt(this.coberturaAutorizacion);
      var fechaInicio = new Date(this.fechaExpedicionAutorizacion);
      fechaInicio.setDate(fechaInicio.getDate() + dias);

      var fechaFin = new Date(fechaInicio);

      var dia = fechaFin.getDate();
      var mes = fechaFin.getMonth() + 1;
      var ano = fechaFin.getFullYear();
      var cero = "0";
      if (mes < 10 && dia < 10) {
        this.fechaVencimientoAutorizacion = ano + "-" + "0" + mes + "-" + "0" + dia;
      } else {
        this.fechaVencimientoAutorizacion = ano + "-" + mes + "-" + dia;
      }
    },
    nuevaOrdenMedica: function nuevaOrdenMedica() {
      var _this7 = this;

      if (this.bolsa == 0) {
        alert("Debe cargar servicios para poder ingresar la Orden médica");
      } else {
        this.boton = false;
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        };
        this.calcularFecha();
        var url = this.ip + "api/nuevaOrdenMedica";
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
          codigoOrden: this.numeroOrden,
          tipoServicio: "eps",
          entidad: this.eps,
          fechaOrden: this.fechaExpedicion,
          cobertura: this.cobertura,
          fechaVencimiento: this.fechaVencimiento,
          paciente: this.pacIde,
          servicios: this.arrayCantidad,
          formato: 0,
          bolsa: this.bolsa
        }, config).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this7.$notify({
            component: {
              template: "<span>!<b> Orden m\xE9dica registrada con \xE9xito!</b>.</span>"
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this7.type[color]
          });
          _this7.criterio = "";
          _this7.busqueda = "";
          _this7.numeroOrden = "";
          _this7.eps = "";
          _this7.fechaExpedicion = "";
          _this7.cobertura = "";
          _this7.fechaVencimiento = "";
          _this7.pacIde = "";
          _this7.arrayCantidad = "";
          _this7.pacIde = "";
          _this7.arrayPacientes = "", _this7.formato = 1;
          _this7.nombre = "", _this7.documento = "";
          _this7.fechaExpedicion = "";
          _this7.$modal.hide("ingreso_servicio");
          _this7.buscar = true;
          _this7.boton = true;
          _this7.bolsa = 0;
        }).catch(function (error) {
          console.log(error);
          _this7.boton = true;
        });
      }
    },
    nuevaAutorizacion: function nuevaAutorizacion() {
      var _this8 = this;

      if (this.bolsa == 0) {
        alert("Debe cargar servicios para ingresar autorización");
      } else {
        this.boton = false;
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        };
        this.calcularFechaAutorizacion();
        var url = this.ip + "api/nuevaAutorizacion";
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
          codigoOrden: this.numeroAutorizacion,
          tipoServicio: "eps",
          entidad: this.epsCod,
          fechaOrden: this.fechaExpedicionAutorizacion,
          cobertura: this.coberturaAutorizacion,
          fechaVencimiento: this.fechaVencimientoAutorizacion,
          paciente: this.pacIde,
          servicios: this.arrayCantidad,
          formato: 1,
          pertenece: this.numeroOrden,
          bolsa: this.bolsa,
          observacion: this.observaciones,
          usuario: localStorage.getItem("usuario")
        }, config).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this8.$notify({
            component: {
              template: "<span>!<b> Autorizaci\xF3n registrada con \xE9xito!</b>.</span>"
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this8.type[color]
          });
          _this8.criterio = "";
          _this8.busqueda = "";
          _this8.numeroOrden = "";
          _this8.numeroAutorizacion = "";
          _this8.fechaVencimientoAutorizacion = "";
          _this8.fechaExpedicionAutorizacion = "";
          _this8.coberturaAutorizacion = "";
          _this8.eps = "";
          _this8.fechaExpedicion = "";
          _this8.cobertura = "";
          _this8.fechaVencimiento = "";
          _this8.pacIde = "";
          _this8.arrayCantidad = "";
          _this8.pacIde = "";
          _this8.arrayPacientes = "", _this8.formato = 1;
          _this8.nombre = "", _this8.documento = "";
          _this8.fechaExpedicion = "";
          _this8.$modal.hide("ingreso_servicio");
          _this8.buscar = true;
          _this8.boton = true;
          _this8.bolsa = 0;
        }).catch(function (error) {
          console.log(error);
          _this8.boton = true;
        });
      }
    },
    generarCodigoAutorizacion: function generarCodigoAutorizacion() {
      this.numeroAutorizacion = "EPS-AUT" + this.pacIde + "-" + this.fechaExpedicionAutorizacion;
    },
    cerrar: function cerrar() {
      this.$modal.hide("ingreso_servicio");
    }
  },
  props: ["modal"],
  mounted: function mounted() {
    this.selectEspecialidad();
    this.selectEps();
  }
});

/***/ }),

/***/ "Grcq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gastosVariables_vue__ = __webpack_require__("cq/t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a92d9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gastosVariables_vue__ = __webpack_require__("3jlA");
function injectStyle (ssrContext) {
  __webpack_require__("wcWk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gastosVariables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20a92d9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gastosVariables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H2gS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mb-3",staticStyle:{"padding":"40px","border-radius":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card-body"},[_c('p',{staticStyle:{"font-weight":"400","font-size":"1.7rem"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"card-text",staticStyle:{"font-weight":"900","font-size":"3rem"}},[_vm._v(_vm._s(_vm.value))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('img',{staticClass:"img-fluid rounded-start",attrs:{"src":_vm.imgRoute,"alt":"..."}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H3Ab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: '',
    imgRoute: '',
    title: '',
    footerText: ''
  }
});

/***/ }),

/***/ "HAnZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HIL4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_json_excel__ = __webpack_require__("+Rp4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__global_services_crearAlerta__ = __webpack_require__("o0VJ");
























__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_16_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_18_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  data: function data() {
    return {
      ip: "https://avanti-erp.com/",
      fechaInicial: "",
      fechaFinal: "",
      pacientes: [],
      pacienteSelected: "todos",
      queriedData2: [],
      tableColumns: [{
        prop: "TipoDeDoc",
        label: "Tipo deDoc",
        minWidth: 100
      }, {
        prop: "Prefijo",
        label: "Prefijo",
        minWidth: 100
      }, {
        prop: "CodigoFac",
        label: "Numero Factura",
        minWidth: 100
      }, {
        prop: "NombrePaciente",
        label: "Nombre del paciente",
        minWidth: 180
      }, {
        prop: "CodInventario",
        label: "Cod Inventario",
        minWidth: 100
      }, {
        prop: "IdPaciente",
        label: "Id Paciente",
        minWidth: 100
      }, {
        prop: "CodPrestador",
        label: "Cod Prestador",
        minWidth: 100
      }, {
        prop: "FechaInicioAtencion",
        label: "Fecha inicio atencion",
        minWidth: 200
      }, {
        prop: "NumAutorizacion",
        label: "Num. Autorizacion",
        minWidth: 100
      }, {
        prop: "Cups",
        label: "Cups",
        minWidth: 100
      }, {
        prop: "ModalidadAtencion",
        label: "Modalidad de atencion",
        minWidth: 100
      }, {
        prop: "CodGrupoServicio",
        label: "Cod. Grupo servicio",
        minWidth: 100
      }, {
        prop: "CodServicio",
        label: "Cod. Servicio",
        minWidth: 100
      }, {
        prop: "CodFinalidad",
        label: "Cod. Finalidad",
        minWidth: 100
      }, {
        prop: "CodMotivoAtencion",
        label: "Cod. Motivo de Atencion",
        minWidth: 100
      }, {
        prop: "Dx",
        label: "Diagnostico",
        minWidth: 100
      }, {
        prop: "CodTipoDiagnostico",
        label: "Cod. Tipo Diagnostico",
        minWidth: 100
      }, {
        prop: "TipoDocumentoIdentificacionTerapeuta",
        label: "Tipo Identificacion",
        minWidth: 100
      }, {
        prop: "NumIdentificacionTerapeuta",
        label: "Num. Identificacion",
        minWidth: 100
      }, {
        prop: "VrServicio",
        label: "Vr Servicio",
        minWidth: 100
      }, {
        prop: "ConceptoRecaudo",
        label: "Concepto recaudo",
        minWidth: 100
      }, {
        prop: "ValorPagoModerador",
        label: "Valor pago moderador",
        minWidth: 100
      }, {
        prop: "NumFev",
        label: "NumFEVPagoMode",
        minWidth: 100
      }, {
        prop: "CodigoVida",
        label: "codigoVIDA",
        minWidth: 100
      }],
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      json_fields: {
        "Tipo deDoc": "TipoDeDoc",
        Prefijo: "Prefijo",
        "Numero Factura": "CodigoFac",
        "Cod Inventario": "CodInventario",
        "Nombre del paciente": "NombrePaciente",
        "ID paciente": "IdPaciente",
        CodPrestador: "CodPrestador",
        FechaInicioAtencion: "FechaInicioAtencion",
        NumAutorizacion: "NumAutorizacion",
        CUPS: "Cups",
        Cod_ModalidadAtencion: "ModalidadAtencion",
        Cod_GrupoServicio: "CodGrupoServicio",
        Cod_Servicio: "CodServicio",
        Cod_Finalidad: "CodFinalidad",
        Cod_MotivoAtencion: "CodMotivoAtencion",
        "codDiagnosticoPrincipalCIE11": "codDiagnosticoPrincipalCIE11",
        "nomCodDiagnosticoPrincipalCIE11": "nomCodDiagnosticoPrincipalCIE11",
        "Cod DiagnosticoRelacionado1": "CodDiagnosticoRelacionado1",
        codDiagnosticoRelacionado1CIE11: "codDiagnosticoRelacionado1CIE11",
        nomCodDiagnosticoRelacionado1CIE11: "nomCodDiagnosticoRelacionado1CIE11",
        "Cod DiagnosticoRelacionado2": "CodDiagnosticoRelacionado2",
        codDiagnosticoRelacionado2CIE11: "codDiagnosticoRelacionado2CIE11",
        nomCodDiagnosticoRelacionado2CIE11: "nomCodDiagnosticoRelacionado2CIE11",
        "Cod DiagnosticoRelacionado3": "CodDiagnosticoRelacionado3",
        codDiagnosticoRelacionado3CIE11: "codDiagnosticoRelacionado3CIE11",
        nomCodDiagnosticoRelacionado3CIE11: "nomCodDiagnosticoRelacionado3CIE11",
        Cod_TipoDiagnostico: "CodTipoDiagnostico",
        TipoDocumentoIdentificacion: "TipoDocumentoIdentificacionTerapeuta",
        NumDocumentoIdentificacion: "NumIdentificacionTerapeuta",
        VrServicio: "VrServicio",
        ConceptoRecaudo: "ConceptoRecaudo",
        ValorPagoModerador: "ValorPagoModerador",
        NumFEVPagoMode: "NumFev",
        codigoVIDA: "CodigoVida"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]]
    };
  },
  methods: {
    obtenerInformacionFacturacion: function obtenerInformacionFacturacion(fechaInicial, fechaFinal, paciente) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.$modal.show("carga");
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_14_src_global_services_axiosInstance__["a" /* default */].get("api/obtener-reporte-facturacion/" + fechaInicial + "/" + fechaFinal + "/" + paciente);

              case 4:
                response = _context.sent;

                _this2.expandirSesiones(response.data.data);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.log("Error al obtener los datos:" + _context.t0);

              case 11:
                _context.prev = 11;

                _this2.$modal.hide("carga");
                return _context.finish(11);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 8, 11, 14]]);
      }))();
    },
    toMinutos: function toMinutos(hhmmss) {
      var _hhmmss$split$map = hhmmss.split(":").map(Number),
          _hhmmss$split$map2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_hhmmss$split$map, 3),
          h = _hhmmss$split$map2[0],
          m = _hhmmss$split$map2[1],
          s = _hhmmss$split$map2[2];

      return h * 60 + m + (s || 0) / 60;
    },
    minutosAHHMM: function minutosAHHMM(totalMinutos) {
      var h = Math.floor(totalMinutos / 60);
      var m = Math.round(totalMinutos % 60);
      return String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0");
    },
    comoTexto: function comoTexto(valor) {
      return "=\"" + valor + "\"";
    },
    expandirSesiones: function expandirSesiones(data) {
      var _this3 = this;

      var resultado = [];

      data.forEach(function (row) {
        var ProFec = row.ProFec,
            hora = row.hora,
            horaFin = row.horaFin,
            ProCanSes = row.ProCanSes,
            terapeuta = row.terapeuta,
            PacNumDoc = row.PacNumDoc,
            ProEst = row.ProEst,
            cedula = row.cedula,
            PacDia = row.PacDia,
            PacNom1 = row.PacNom1,
            PacApe1 = row.PacApe1;


        var codigo = '';
        if (PacDia) {
          codigo = PacDia.trim().split('-')[0];
        }

        var inicioMin = _this3.toMinutos(hora);
        var finMin = _this3.toMinutos(horaFin);
        var duracionTotal = finMin - inicioMin;
        var duracionSesion = ProCanSes > 0 ? duracionTotal / ProCanSes : duracionTotal;

        for (var i = 0; i < ProCanSes; i++) {
          var inicioSesion = inicioMin + i * duracionSesion;
          var finSesion = inicioSesion + duracionSesion;

          var horaInicioStr = _this3.minutosAHHMM(inicioSesion);
          var horaFinStr = _this3.minutosAHHMM(finSesion);

          resultado.push({
            TipoDeDoc: "FV",
            Prefijo: "CR",
            CodigoFac: "",
            CodInventario: "",
            NombrePaciente: PacNom1 + " " + PacApe1,
            IdPaciente: PacNumDoc,
            CodPrestador: "080010311201",
            FechaInicioAtencion: ProFec + " " + horaInicioStr,
            NumAutorizacion: "",
            Cups: "",
            ModalidadAtencion: "01",
            CodGrupoServicio: "02",
            CodServicio: "",
            CodFinalidad: "17",
            CodMotivoAtencion: "38",
            Dx: codigo,
            codDiagnosticoPrincipalCIE11: '',
            nomCodDiagnosticoPrincipalCIE11: '',
            CodDiagnosticoRelacionado1: '',
            codDiagnosticoRelacionado1CIE11: '',
            nomCodDiagnosticoRelacionado1CIE11: '',
            CodDiagnosticoRelacionado2: '',
            codDiagnosticoRelacionado2CIE11: '',
            nomCodDiagnosticoRelacionado2CIE11: '',
            codDiagnosticoRelacionado3CIE11: '',
            nomCodDiagnosticoRelacionado3CIE11: '',
            CodDiagnosticoRelacionado3: '',
            CodTipoDiagnostico: "01",
            TipoDocumentoIdentificacionTerapeuta: "CC",
            NumIdentificacionTerapeuta: cedula,
            VrServicio: "",
            ConceptoRecaudo: "05",
            ValorPagoModerador: "",
            NumFev: "",
            CodigoVida: ""
          });
        }
      });
      this.queriedData2 = resultado;

      var camposComoTexto = ["CodPrestador", "ModalidadAtencion", "CodGrupoServicio", "CodFinalidad", "CodMotivoAtencion", "CodTipoDiagnostico", "ConceptoRecaudo"];

      this.json_data = resultado.map(function (fila) {
        var filaExportacion = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fila);
        camposComoTexto.forEach(function (campo) {
          if (filaExportacion[campo] !== "") {
            filaExportacion[campo] = _this3.comoTexto(filaExportacion[campo]);
          }
        });
        return filaExportacion;
      });
    },

    selectPaciente: function selectPaciente() {
      var _this4 = this;

      this.$modal.show("carga");
      var BASE_URL = this.ip + "api/pacientesSelect";
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(BASE_URL).then(function (res) {
        _this4.pacientes = res.data.data;
        _this4.$modal.hide("carga");
      }).catch(function (err) {
        _this4.$modal.hide("carga");
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    this.selectPaciente();
  }
});

/***/ }),

/***/ "HRUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("zwtn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c7da72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("1S6G");
function injectStyle (ssrContext) {
  __webpack_require__("YoFX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c7da72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I4Gl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_historia_clinica_vue__ = __webpack_require__("fM/j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b4f36e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_historia_clinica_vue__ = __webpack_require__("42D9");
function injectStyle (ssrContext) {
  __webpack_require__("OwEp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-82b4f36e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_historia_clinica_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b4f36e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_historia_clinica_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I4nB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IIyn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iclx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestionOrdenes_vue__ = __webpack_require__("+L4t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25e08ab4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gestionOrdenes_vue__ = __webpack_require__("8nk2");
function injectStyle (ssrContext) {
  __webpack_require__("AKvu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25e08ab4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestionOrdenes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25e08ab4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gestionOrdenes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JuGc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K2kv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K6vS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K7VR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Buscar por")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.criterio),expression:"criterio"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.criterio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"PacApe1"}},[_vm._v("Apellidos del paciente")]),_vm._v(" "),_c('option',{attrs:{"value":"PacNom1"}},[_vm._v("Nombres del paciente")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('label',{attrs:{"for":""}},[_vm._v("Buscar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Escribe lo que quieres buscar..."},domProps:{"value":(_vm.busqueda)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarPacientes()},"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-icon btn-simple",on:{"click":function($event){return _vm.buscarPacientes()}}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('center',[(_vm.buscar == false)?_c('div',{staticClass:"row"},[_c('div',[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive",staticStyle:{"width":"97%"},attrs:{"data":_vm.arrayPacientes,"border":"","size":"mini"}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacApe1","label":"Apellidos"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNom1","label":"Nombres"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNumDoc","label":"Numero de documento"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"TipCliNom","label":"Tipo de cliente"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[(props.row.estado==1)?_c('a',{staticClass:"btn btn-simple btn-success btn-xs btn-icon like",on:{"click":function($event){return _vm.seleccionarPaciente(props.row)}}},[_c('i',{staticClass:"fa fa-check"})]):_c('small',{staticClass:"text-danger"},[_vm._v("INACTIVO")])])]}}],null,false,3267663566)})],1)],1)]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.nombre != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}}),_vm._v(" "),(_vm.alertTipoCliente)?_c('small',{staticClass:"text-danger"},[_vm._v("El tipo de cliente no concueda con el modulo seleccionado")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Documento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documento),expression:"documento"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.documento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.documento=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("N° del servicio:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroAutorizacion),expression:"numeroAutorizacion"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.numeroAutorizacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha inicio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicion),expression:"fechaExpedicion"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaExpedicion)},on:{"change":function($event){return _vm.generarCodigo()},"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Cobertura:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cobertura),expression:"cobertura"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cobertura=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"45"}},[_vm._v("45 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("1 Mes")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("2 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("3 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"120"}},[_vm._v("4 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"150"}},[_vm._v("5 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"180"}},[_vm._v("6 Meses")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroOrden),expression:"numeroOrden"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.numeroOrden)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroOrden=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre del cliente")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cliente),expression:"cliente"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.cliente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cliente=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Forma de pago:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formaPago),expression:"formaPago"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.formaPago=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Efectivo")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Tarjeta")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Periodo de pago:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.periodo),expression:"periodo"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.periodo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"15"}},[_vm._v("15 días")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("1 Mes")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("2 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("3 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"120"}},[_vm._v("4 Meses")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("N° de contrato:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroContrato),expression:"numeroContrato"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.numeroContrato)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroContrato=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_vm._m(4),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.observaciones),expression:"observaciones"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.observaciones=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(5),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.agregarServicios.apply(null, arguments)}}},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Servicio")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.especialidad),expression:"especialidad"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.especialidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayEspecialidad),function(especialidad){return _c('option',{key:especialidad.EspCod,domProps:{"value":especialidad.EspCod}},[_vm._v("\n                "+_vm._s(especialidad.EspNom)+"\n            ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Cantidad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cantidad),expression:"cantidad"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.cantidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cantidad=$event.target.value}}})]),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.arrayCantidad!='')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-responsive table-bordered",staticStyle:{"width":"100%"},attrs:{"data":_vm.arrayCantidad,"border":""}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"servicio","label":"Cups"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cantidad","label":"Cantidad"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove",on:{"click":function($event){return _vm.eliminarServicio(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}],null,false,31756203)})],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.nuevaParticular()}}},[_vm._v("Registrar servicio particular")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.cerrar()}}},[_vm._v("Cancelar")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"bold","margin-bottom":"15px"}},[_vm._v("Selecciona al paciente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n          Información del servicio\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":""}},[_vm._v("Numero° orden "),_c('small',[_vm._v("(opcional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n          Información del pago\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":""}},[_vm._v("Observaciones: "),_c('small',[_vm._v("(opcional)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n          Servicios\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-1"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("---")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-success",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KMJO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_json_excel__ = __webpack_require__("+Rp4");

















__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_13_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip: "https://avanti-erp.com/",
      fechaInicial: "",
      fechaFinal: "",
      data: [],
      rol: localStorage.getItem('rol'),
      sede: 'Sede Principal',
      SedesProgramacion: [],
      tableColumns: [{
        prop: "UsuEst",
        label: "Estado",
        minWidth: 100 }, {
        prop: "paciente",
        label: "Paciente",
        minWidth: 250 }, {
        prop: "PacIndice",
        label: "idA",
        minWidth: 70 }, {
        prop: "ObjFec",
        label: "Fecha",
        minWidth: 100 }, {
        prop: "ObjFecCum",
        label: "Fecha de cumplimiento",
        minWidth: 140 }, {
        prop: "ObjUsu",
        label: "Terapeuta",
        minWidth: 100 }, {
        prop: "ObjObj",
        label: "Objetivo",
        minWidth: 250 }, {
        prop: "ObjLog",
        label: "Logro",
        minWidth: 250 }, {
        prop: "ObjPor",
        label: "%",
        minWidth: 60 }],
      json_fields: {
        "Estado del paciente": "UsuEst",
        "Nombre del paciente": "paciente",
        "Indice de atención": "PacIndice",
        "Fecha inicial": "ObjFec",
        "Fecha de cumplimiento": "ObjFecCum",
        "Terapeuta": "ObjUsu",
        "Objetivo": "ObjObj",
        "Logro": "ObjLog",
        "%": "ObjPor"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]]
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      if (this.fechaInicial == '' || this.fechaFinal == '') {
        alert('ERROR: Faltan fechas por seleccionar');
        return;
      }
      this.$modal.show("carga");
      var sede = this.rol == 1 ? this.sede : localStorage.getItem("sede");
      var BASE_URL = this.ip + "api/reporteObjetivos/" + this.fechaInicial + "/" + this.fechaFinal + "/" + this.fechamenosdias() + "/" + sede;
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(BASE_URL).then(function (res) {
        var dateFormated = [];
        var datos = res.data.data;
        datos.forEach(function (element) {
          var estado = "";
          var porcentaje = "";
          if (element.estado == 1) {
            estado = "A";
          } else {
            estado = "I";
          }

          if (element.ObjPor == 0 && element.ObjLog == null) {
            porcentaje = "";
          } else {
            porcentaje = element.ObjPor + "%";
          }
          dateFormated.push({
            paciente: element.PacNom1 + " " + element.PacApe1,
            PacIndice: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(element.indiceAtencion) + '%',
            ObjFec: element.ObjFec,
            ObjFecCum: element.ObjFecCum,
            ObjObj: element.ObjObj,
            ObjLog: element.ObjLog,
            ObjPor: porcentaje,
            ObjUsu: element.ObjUsu,
            UsuEst: estado
          });

          _this.data = dateFormated;
          _this.json_data = dateFormated;
        });
        _this.$modal.hide('carga');
      }).catch(function (err) {
        _this.$modal.hide('carga');
        alert('Ocurrió un error, intentelo de nuevo.');
        console.log(err);
      });
    },
    fechamenosdias: function fechamenosdias() {
      var fecha = new Date();
      var fechaCalcular = new Date();
      if (new Date(this.fechaFinal) < fechaCalcular) {
        fecha = new Date(this.fechaFinal);
      } else {
        fecha = fechaCalcular;
      }

      fecha.setDate(fecha.getDate() - 90);

      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
      return fechaFormateada;
    },
    emailsProgramacion: function emailsProgramacion() {
      var _this2 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/emailsProgramacion";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this2.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    document.title = "Avanti | Reporte de objetivos y logros";
    if (localStorage.getItem('rol') == 1) {
      this.emailsProgramacion();
    }
  }
});

/***/ }),

/***/ "KMwH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KlTD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('h2',{staticStyle:{"font-weight":"bold"}},[_c('i',{class:_vm.icon + ' text-success py-2',staticStyle:{"margin-right":"15px"}}),_vm._v(" "+_vm._s(_vm.title))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ks1f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kscm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getCurrentDate = function getCurrentDate() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();

  if (month < 10) {
    month = '0' + month;
  }

  if (day < 10) {
    day = '0' + day;
  }

  return year + '-' + month + '-' + day;
};

/* harmony default export */ __webpack_exports__["a"] = (getCurrentDate);

/***/ }),

/***/ "L4l+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LjH8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LtqI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pacientes_vue__ = __webpack_require__("NoA9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b500273_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pacientes_vue__ = __webpack_require__("i8I4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pacientes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b500273_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pacientes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Luuf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.abrirModal()}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Nueva Estrategía")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",staticStyle:{"width":"220%"},attrs:{"type":"search","placeholder":"Buscar estrategia...","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped table-responsive",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":"","max-height":"400"}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"else":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":50,"label":"Estado"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.DomEst==1)?_c('p',{staticClass:"label label-success",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n                    activa\n                ")]):_c('p',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("Inactiva")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"fixed":"right","label":"Acc"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.DomEst==2)?_c('button',{staticClass:"btn btn-simple btn-xs btn-info btn-icon check",on:{"click":function($event){return _vm.activar(props.row)}}},[_c('i',{staticClass:"ti-check"})]):_c('button',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit",on:{"click":function($event){return _vm.desactivar(props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("Mostrando del "+_vm._s(_vm.from + 1)+" al "+_vm._s(_vm.to)+" de "+_vm._s(_vm.total)+" registros")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"modal fade",class:{'mostrar' : _vm.modalRegistrar},attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header CM",staticStyle:{"padding":"8px"}},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.modalRegistrar=0}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.nuevoDominio.apply(null, arguments)}}},[_c('label',{attrs:{"for":""}},[_vm._v("Codigo:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Descripcion:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.descripcion),expression:"descripcion"}],staticClass:"form-control",attrs:{"required":"","cols":"30","rows":"3"},domProps:{"value":(_vm.descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descripcion=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v("\n                          Estrategía de Psicología "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"26","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"26")},on:{"change":function($event){_vm.tipo="26"}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_vm._v("\n                           Estrategía de Terapia ocupacional "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"24","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"24")},on:{"change":function($event){_vm.tipo="24"}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v("\n                           Estrategía de Fonoaudiología "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"23","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"23")},on:{"change":function($event){_vm.tipo="23"}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v("\n                           Estrategía de Fisioterapia "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"22","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"22")},on:{"change":function($event){_vm.tipo="22"}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('br'),_vm._v("\n                           Estrategía de Educación Especial"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"25","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"25")},on:{"change":function($event){_vm.tipo="25"}}})])]),_vm._v(" "),_c('center',[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Enviar Datos\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.limpiarFormulario()}}},[_c('i',{staticClass:"ti-close"})])])],1)]),_vm._v(" "),_c('center'),_vm._v(" "),_c('br')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                      Nuevo motivo de consulta\n                  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66e458c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("WTyt");
function injectStyle (ssrContext) {
  __webpack_require__("32is")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66e458c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00530c66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("pLOp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00530c66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarItem_vue__ = __webpack_require__("HRUz");







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { SidebarItem: __WEBPACK_IMPORTED_MODULE_3__SidebarItem_vue__["a" /* default */] },
  props: {
    title: {
      type: String,
      default: "/static/img/logo.webp"
    },
    type: {
      type: String,
      default: "sidebar",
      validator: function validator(value) {
        var acceptedValues = ["sidebar", "navbar"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: function validator(value) {
        var acceptedValues = ["white", "brown", "black"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: "success",
      validator: function validator(value) {
        var acceptedValues = ["primary", "info", "success", "warning", "danger"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === "sidebar") {
        return "sidebar";
      } else {
        return "collapse navbar-collapse off-canvas-sidebar";
      }
    },
    navClasses: function navClasses() {
      if (this.type === "sidebar") {
        return "nav";
      } else {
        return "nav navbar-nav";
      }
    }
  },
  methods: {
    initScrollBarAsync: function initScrollBarAsync() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var PerfectScroll;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "ieps"));

              case 2:
                _context.next = 4;
                return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "Fiov"));

              case 4:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(_this.$refs.sidebarScrollArea);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getPermisos: function getPermisos() {
      var _this2 = this;

      var BASE_URL = this.ip + "permisos/" + localStorage.getItem("rol");
      if (!localStorage.getItem("rol")) {
        this.$router.push("/");
      } else {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(BASE_URL).then(function (res) {
          _this2.permisos = res.data.data;
        }).catch(function (err) {
          console.log(err);
        });
      }
    }
  },
  data: function data() {
    return {
      rol: localStorage.getItem("rol"),
      permisos: [],
      ip: "https://avanti-erp.com/api/"
    };
  },
  mounted: function mounted() {
    this.initScrollBarAsync();
    this.getPermisos();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
});

/***/ }),

/***/ "MfEB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_CircleChartCard_vue__ = __webpack_require__("WFzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs__);






















__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      terapeutaLog: localStorage.getItem("usuario"),
      opciones: [{ texto: "Totalmente satisfactorio - 5", valor: 100, id: 0 }, { texto: "Muy satisfactorio 4", valor: 80, id: 1 }, {
        texto: "Satisfactorio - 3",
        valor: 60,
        id: 2
      }, {
        texto: "Poco satisfactorio - 2",
        valor: 40,
        id: 3
      }, {
        texto: "Nada satisfactorio - 1",
        valor: 20,
        id: 4
      }],
      tabs: [{
        nombre: "Fisioterapia",
        id: "1",
        datos: [],
        promedio: 0,
        color: "blue",
        lider: "",
        bar: "#b8d8d8",
        notification: 0,
        pendiente: false,
        pendienteEvaluar: 0
      }, {
        nombre: "Fonoaudiología",
        id: "2",
        datos: [],
        promedio: 0,
        color: "orange",
        bar: "#ff8f5e",
        lider: "",
        notification: 0,
        pendiente: false,
        pendienteEvaluar: 0
      }, {
        nombre: "Ter. ocupacional",
        id: "3",
        datos: [],
        promedio: 0,
        color: "green",
        bar: "#d5e5a3",
        lider: "",
        notification: 0,
        pendiente: false,
        pendienteEvaluar: 0
      }, {
        nombre: "Psicología",
        id: "4",
        datos: [],
        promedio: 0,
        color: "brown",
        bar: "#d6c1ab",
        lider: "",
        notification: 0,
        pendiente: false
      }, {
        nombre: "Educación Especial",
        id: "5",
        datos: [],
        promedio: 0,
        color: "blue",
        bar: "#b8d8d8",
        lider: "",
        notification: 0,
        pendiente: false,
        pendienteEvaluar: 0
      }],
      buscar: true,
      controlContenido: 1,
      fecha: "",
      fechaCumplimiento: "",
      terapia: "",
      logro: "",
      foto: "",
      fecha_nacimiento: "",

      tipoDocumento: 1,
      documentoBuscar: "",
      nombre: "",
      PacIde: "",
      fechaNacimiento: "",
      numeroDocumento: "",
      mostrarCalificar: false,
      ObjCalificar: "",
      puntaje: "",
      anos: 0,
      meses: 0,
      edad: "",
      objetivo: "",
      criterio: "PacApe1",
      busqueda: "",
      arrayPacientes: [],
      logros: false,
      infObjetivo: true,
      fechaEdit: "",
      idEdit: 0,

      modalRegistrar: 0,
      tipoRegistro: 0,
      modalCalificar: 0,
      tituloModalCalificar: "",

      ip: "https://avanti-erp.com/",
      loked: null,
      token: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      icono: "bell",
      mensaje: "No hay datos de pacientes",
      usuario: "",
      rol: 0,
      estado: 0,
      evidenciaRegistroObjetivo: "",
      evidenciaRegistroLogro: "",

      Log1: "",
      Log2: "",
      Log3: "",

      puntaje1: "",
      puntaje2: "",
      puntaje3: "",

      cumple1: "",
      cumple2: "",
      cumple3: "",

      bloquearBotonEvaluar: false,

      comentario: "",
      PeriodoCalificar: null
    };
  },


  methods: {
    validarTareasIguales: function validarTareasIguales() {
      console.log(this.Log1 === this.Log2 || this.Log1 === this.Log3 || this.Log2 === this.Log3);
      return this.Log1 === this.Log2 || this.Log1 === this.Log3 || this.Log2 === this.Log3;
    },
    abrirModalRegistrar: function abrirModalRegistrar(especialidad) {
      this.fechaCumplimiento = "";
      this.objetivo = "";
      this.modalRegistrar = 1;
      this.calcularFechaActual();
      this.tipoRegistro = especialidad.id;
      this.Log1 = "";
      this.Log2 = "";
      this.Log3 = "";
      this.objetivo = "";
      console.log(especialidad);
    },
    prepararExtenderFecha: function prepararExtenderFecha(date, id) {
      this.$modal.show("modalextenderLogro");
      this.fechaEdit = date;
      this.idEdit = id;
    },


    editDate: function editDate() {
      var _this = this;

      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      var BASE_URL = this.ip + "api/editDateObjetivo";
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.post(BASE_URL, {
        id: this.idEdit,
        date: this.fechaEdit
      }, config).then(function (res) {
        if (res.data.status == true) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this.$notify({
            component: {
              template: " <div style=\"padding: 3%;\">\n              <span><b> ACTUALIZADO CON \xC9XITO </b>.</span>\n              </div>\n              "
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this.type[color]
          });

          _this.objetivosFisio();
          _this.objetivosFono();
          _this.objetivosTeo();
          _this.objetivosPsi();
          _this.objetivosEsp();
          _this.$modal.hide("modalextenderLogro");
        }
      });
    },
    nuevoObjetivo: function nuevoObjetivo() {
      var _this2 = this;

      if (this.Log1 === this.Log2 || this.Log1 === this.Log3 || this.Log2 === this.Log3) {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__global_services_crearAlerta__["a" /* default */])("danger", "Las tareas no pueden ser las mismas"));
        return;
      }
      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      var vm = this;
      var url = this.ip + "api/nuevoObjetivoV2";
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.post(url, {
        PacIde: this.PacIde,
        fecha: this.fecha,
        objetivo: this.objetivo,
        Log1: this.Log1,
        Log2: this.Log2,
        Log3: this.Log3,
        fechaCumplir: this.obtenerUltimoDiaTrimestre(this.fecha),
        terapia: this.tipoRegistro,
        usuario: localStorage.getItem("usuario"),
        tipo: 1
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this2.$notify({
          component: {
            template: "<span>-<b> Objetivo registrado con \xE9xito!</b>.</span>"
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this2.type[color]
        });
        vm.modalRegistrar = 0;
        vm.fechaCumplimiento = "";
        vm.objetivo = "";
        vm.Log1 = "";
        vm.Log2 = "";
        vm.Log3 = "";
        if (vm.tipoRegistro == 1) {
          vm.objetivosFisio();
        }
        if (vm.tipoRegistro == 2) {
          vm.objetivosFono();
        }
        if (vm.tipoRegistro == 3) {
          vm.objetivosTeo();
        }
        if (vm.tipoRegistro == 4) {
          vm.objetivosPsi();
        }
        if (vm.tipoRegistro == 5) {
          vm.objetivosEsp();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    objetivosFisio: function objetivosFisio() {
      var _this3 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      var url = this.ip + "api/objetivosFisio/" + this.PacIde + "/" + 1;
      var vm = this;
      var suma = 0;
      var entre = 0;
      var sinEvaluar = 0;
      var pendienteConfirmar = 0;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url, config).then(function (response) {
        vm.tabs[0].datos = response.data;
        if (response.data.length > 0) {
          for (var index = 0; index < response.data.length; index++) {
            if (response.data[index].ObjLog != null) {
              suma = suma + parseInt(response.data[index].ObjPor);
              entre = entre + 1;
            }
            if (response.data[index].ObjFecCum > vm.fecha && response.data[index].ObjLog == null) {
              sinEvaluar = sinEvaluar + 1;
            }

            if (response.data[index].ObjLog == null && response.data[index].ObjFecCum < _this3.fecha) {
              pendienteConfirmar = pendienteConfirmar + 1;
              vm.tabs[0].pendiente = true;
            }
            var promedioFisio = suma / entre;
            parseInt(promedioFisio);
            var numero = promedioFisio.toFixed(0);
            if (isNaN(numero)) {
              vm.tabs[0].promedio = "--";
            } else {
              vm.tabs[0].promedio = parseInt(numero);
            }
          }
          vm.tabs[0].notification = pendienteConfirmar;
          vm.tabs[0].pendienteEvaluar = sinEvaluar;
        } else {
          vm.tabs[0].promedio = "--";
        }
        console.log(_this3.tabs[0], "tabs 0");
      }).catch(function (error) {
        console.log(error);
      });
    },
    objetivosFono: function objetivosFono() {
      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      var url = this.ip + "api/objetivosFono/" + this.PacIde + "/" + 1;
      var vm = this;
      var suma = 0;
      var entre = 0;
      var sinEvaluar = 0;
      var pendienteConfirmar = 0;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url, config).then(function (response) {
        vm.tabs[1].datos = response.data;
        if (response.data.length > 0) {
          for (var index = 0; index < response.data.length; index++) {
            if (response.data[index].ObjLog != null) {
              suma = suma + parseInt(response.data[index].ObjPor);
              entre = entre + 1;
            }

            if (response.data[index].ObjFecCum > vm.fecha && response.data[index].ObjLog == null) {
              sinEvaluar = sinEvaluar + 1;
            }

            if (response.data[index].ObjLog == null && response.data[index].ObjFecCum < vm.fecha) {
              pendienteConfirmar = pendienteConfirmar + 1;
              vm.tabs[1].pendiente = true;
            }
            var promedioFono = suma / entre;
            parseInt(promedioFono);
            var numero = promedioFono.toFixed(0);
            if (isNaN(numero)) {
              vm.tabs[1].promedio = "--";
            } else {
              vm.tabs[1].promedio = parseInt(numero);
            }
          }
          vm.tabs[1].notification = pendienteConfirmar;
          vm.tabs[1].pendienteEvaluar = sinEvaluar;
        } else {
          vm.tabs[1].promedio = "--";
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    objetivosTeo: function objetivosTeo() {
      var _this4 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      var url = this.ip + "api/objetivosTeo/" + this.PacIde + "/" + 1;
      var vm = this;
      var suma = 0;
      var entre = 0;
      var sinEvaluar = 0;
      var pendienteConfirmar = 0;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url, config).then(function (response) {
        vm.tabs[2].datos = response.data;
        if (response.data.length > 0) {
          for (var index = 0; index < response.data.length; index++) {
            if (response.data[index].ObjLog != null) {
              suma = suma + parseInt(response.data[index].ObjPor);
              entre = entre + 1;
            }

            if (response.data[index].ObjFecCum > vm.fecha && response.data[index].ObjLog == null) {
              sinEvaluar = sinEvaluar + 1;
            }

            if (response.data[index].ObjLog == null && response.data[index].ObjFecCum < _this4.fecha) {
              pendienteConfirmar = pendienteConfirmar + 1;
              vm.tabs[0].pendiente = true;
            }
            var promedioFono = suma / entre;
            parseInt(promedioFono);
            var numero = promedioFono.toFixed(1);
            if (isNaN(numero)) {
              vm.tabs[2].promedio = "--";
            } else {
              vm.tabs[2].promedio = parseInt(numero);
            }
          }
          vm.tabs[2].notification = pendienteConfirmar;
          vm.tabs[2].pendienteEvaluar = sinEvaluar;
        } else {
          vm.tabs[2].promedio = "--";
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    objetivosPsi: function objetivosPsi() {
      var _this5 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      var url = this.ip + "api/objetivosPsi/" + this.PacIde + "/" + 1;
      var vm = this;
      var suma = 0;
      var entre = 0;
      var sinEvaluar = 0;
      var pendienteConfirmar = 0;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url, config).then(function (response) {
        if (_this5.loked == null || _this5.loked == _this5.usuario || _this5.rol == 1 || _this5.rol == 9 || _this5.rol == 13) {
          vm.tabs[3].datos = response.data;

          if (response.data.length > 0) {
            for (var index = 0; index < response.data.length; index++) {
              if (response.data[index].ObjLog != null) {
                suma = suma + parseInt(response.data[index].ObjPor);
                entre = entre + 1;
              }
              if (response.data[index].ObjFecCum > vm.fecha && response.data[index].ObjLog == null) {
                sinEvaluar = sinEvaluar + 1;
              }

              if (response.data[index].ObjLog == null && response.data[index].ObjFecCum < _this5.fecha) {
                pendienteConfirmar = pendienteConfirmar + 1;
                vm.tabs[3].pendiente = true;
              }
              var promedioFono = suma / entre;
              parseInt(promedioFono);
              var numero = promedioFono.toFixed(1);
              if (isNaN(numero)) {
                vm.tabs[3].promedio = "--";
              } else {
                vm.tabs[3].promedio = parseInt(numero);
              }
            }
            vm.tabs[3].notification = pendienteConfirmar;
            vm.tabs[3].pendienteEvaluar = sinEvaluar;
          } else {
            vm.tabs[3].promedio = "--";
          }
        } else {
          vm.tabs[3].promedio = "--";
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    objetivosEsp: function objetivosEsp() {
      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      var url = this.ip + "api/objetivosEsp/" + this.PacIde + "/" + 1;
      var vm = this;
      var suma = 0;
      var entre = 0;
      var sinEvaluar = 0;
      var pendienteConfirmar = 0;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url, config).then(function (response) {
        vm.tabs[4].datos = response.data;
        if (response.data.length > 0) {
          for (var index = 0; index < response.data.length; index++) {
            if (response.data[index].ObjLog != null) {
              suma = suma + parseInt(response.data[index].ObjPor);
              entre = entre + 1;
            }
            if (response.data[index].ObjFecCum > vm.fecha && response.data[index].ObjLog == null) {
              sinEvaluar = sinEvaluar + 1;
            }

            if (response.data[index].ObjLog == null && response.data[index].ObjFecCum < this.fecha) {
              pendienteConfirmar = pendienteConfirmar + 1;
              vm.tabs[4].pendiente = true;
            }
            var promedioFono = suma / entre;
            parseInt(promedioFono);
            var numero = promedioFono.toFixed(1);
            if (isNaN(numero)) {
              vm.tabs[4].promedio = "--";
            } else {
              vm.tabs[4].promedio = parseInt(numero);
            }
            vm.tabs[4].notification = pendienteConfirmar;
            vm.tabs[4].pendienteEvaluar = sinEvaluar;
          }
        } else {
          vm.tabs[4].promedio = "--";
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    buscarPacientes: function buscarPacientes() {
      var _this6 = this;

      this.icono = "spinner";
      this.mensaje = "Cargando...";
      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      this.arrayPacientes = [];
      var vm = this;
      var url = this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url, config).then(function (response) {
        _this6.icono = "bell";
        _this6.mensaje = "No hay resultados para su busqueda:  " + _this6.busqueda;
        vm.arrayPacientes = response.data.data;
        if (localStorage.getItem("PacienteHC")) {
          _this6.cargarAllObjetivos(response.data.data[0]);
        }
        if (response.data.data.length > 0) {
          vm.buscar = false;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    volver: function volver() {
      this.logros = false;
      this.infObjetivo = true;
      this.promedioFisio = 0;
      localStorage.removeItem('PacienteHC');
      localStorage.removeItem('PacienteId');
    },
    cargarAllObjetivos: function cargarAllObjetivos(paciente) {
      var _this7 = this;

      this.tabs[0].lider = paciente.t_fisio;
      this.tabs[1].lider = paciente.t_fono;
      this.tabs[2].lider = paciente.t_teo;
      this.tabs[3].lider = paciente.t_psico;
      this.tabs[4].lider = paciente.t_edu;
      this.PacIde = paciente.PacIdeUsu;
      this.loked = paciente.PacBlo;
      this.infObjetivo = false;
      this.estado = paciente.estado;
      this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
      this.foto = this.ip + "" + paciente.url_foto;
      this.fecha_nacimiento = paciente.PacFecNac;
      this.logros = true;
      localStorage.setItem('PacienteHC', paciente.PacNumDoc);
      localStorage.setItem('PacienteId', paciente.PacIdeUsu);
      localStorage.setItem('PacienteNombre', paciente.PacNom1 + ' ' + paciente.PacApe1);

      setTimeout(function () {
        _this7.objetivosFisio();
        _this7.objetivosFono();
        _this7.objetivosTeo();
        _this7.objetivosPsi();
        _this7.objetivosEsp();
        _this7.calcularEdad();
      }, 1000);
    },
    cargarObjetivo: function cargarObjetivo(objetivo) {
      this.modalCalificar = 1;
      this.mostrarCalificar = true;
      this.ObjCalificar = objetivo.ObjIde;
    },
    cargarObjetivoV2: function cargarObjetivoV2(objetivo, periodo) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, logros;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this8.$modal.show("carga");
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/obtener-logros-periodo/" + objetivo.ObjIde + "/" + periodo);

              case 4:
                response = _context.sent;
                logros = response.data.data;

                logros.forEach(function (element) {
                  switch (element.id) {
                    case 1:
                      _this8.Log1 = element.description;
                      _this8.puntaje1 = element.calificacion == null ? "" : element.calificacion;
                      _this8.cumple1 = element.cumple;
                      if (element.calificacion != null) {
                        _this8.bloquearBotonEvaluar = true;
                      } else {
                        _this8.bloquearBotonEvaluar = false;
                      }
                      break;
                    case 2:
                      _this8.Log2 = element.description;
                      _this8.puntaje2 = element.calificacion == null ? "" : element.calificacion;
                      _this8.cumple2 = element.cumple;
                      if (element.calificacion != null) {
                        _this8.bloquearBotonEvaluar = true;
                      } else {
                        _this8.bloquearBotonEvaluar = false;
                      }
                      break;
                    case 3:
                      _this8.Log3 = element.description;
                      _this8.puntaje3 = element.calificacion == null ? "" : element.calificacion;
                      _this8.cumple3 = element.cumple;
                      if (element.calificacion != null) {
                        _this8.bloquearBotonEvaluar = true;
                      } else {
                        _this8.bloquearBotonEvaluar = false;
                      }
                      _this8.comentario = objetivo.ObjLog;
                      _this8.evidenciaRegistroLogro = objetivo.UrlLogEvi;
                      break;
                    default:
                      console.warn("ID de logro no esperado: " + element.id);
                  }
                });
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                console.log("Error al obtener los datos:" + _context.t0);

              case 12:
                _context.prev = 12;

                _this8.ObjCalificar = objetivo.ObjIde;
                _this8.PeriodoCalificar = periodo;
                _this8.modalCalificar = 1;
                _this8.$modal.hide("carga");
                return _context.finish(12);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this8, [[0, 9, 12, 18]]);
      }))();
    },
    calificarObjetivo: function calificarObjetivo() {
      var _this9 = this;

      if (this.logro == "") {
        alert("Es necesario registrar un logro");
      } else {
        var config = {
          headers: {
            Authorization: "Bearer " + this.token
          }
        };
        var vm = this;
        var url = this.ip + "api/calificar";
        __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url, {
          objetivo: this.ObjCalificar,
          puntaje: this.puntaje,
          evidencia: this.evidenciaRegistroLogro,
          logro: this.logro
        }, config).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this9.$notify({
            component: {
              template: "<span>-<b> Objetivo evaluado con \xE9xito!</b>.</span>"
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this9.type["success"]
          });
          vm.objetivosFisio();
          vm.objetivosFono();
          vm.objetivosTeo();
          vm.objetivosPsi();
          vm.objetivosEsp();
          vm.ObjCalificar = "";
          vm.puntaje = "";
          vm.logro = "";
          vm.modalCalificar = 0;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    calificarObjetivoV2: function calificarObjetivoV2() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var periodo, objetivo, datos, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                periodo = _this10.PeriodoCalificar;
                objetivo = _this10.ObjCalificar;
                datos = {
                  periodo: periodo,
                  objetivo: objetivo,

                  puntaje1: _this10.puntaje1,
                  cumple1: _this10.cumple1 == true ? 1 : 0,

                  puntaje2: _this10.puntaje2,
                  cumple2: _this10.cumple2 == true ? 1 : 0,

                  puntaje3: _this10.puntaje3,
                  cumple3: _this10.cumple3 == true ? 1 : 0,
                  comentario: _this10.comentario,

                  evidencia: _this10.evidenciaRegistroLogro
                };

                _this10.$modal.show("carga");
                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post("api/calificar-logros-periodo", datos);

              case 7:
                response = _context2.sent;


                if (response.data.status === true) {
                  _this10.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__global_services_crearAlerta__["a" /* default */])("success", "Periodo evaluado con éxito"));
                }
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](0);

                console.log("Error al obtener los datos:" + _context2.t0);

              case 14:
                _context2.prev = 14;

                _this10.ObjCalificar = null;
                _this10.PeriodoCalificar = null;
                _this10.modalCalificar = 0;
                _this10.$modal.hide("carga");
                window.location.reload();
                return _context2.finish(14);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this10, [[0, 11, 14, 21]]);
      }))();
    },
    calcularEdad: function calcularEdad() {
      if (this.fechaNacimiento != "") {
        var fechaNacimiento = this.fechaNacimiento;
        var values = fechaNacimiento.split("-");
        var dia = values[2];
        var mes = values[1];
        var ano = values[0];

        var fecha_hoy = new Date();
        var ahora_ano = fecha_hoy.getFullYear();
        var ahora_mes = fecha_hoy.getMonth() + 1;
        var ahora_dia = fecha_hoy.getDate();

        var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;


        var edad = ahora_ano + 0 - ano;
        if (ahora_mes < mes) {
          edad--;
        }
        if (mes == ahora_mes && ahora_dia < dia) {
          edad--;
        }
        if (edad > 1900) {
          edad -= 1900;
        }

        var meses = 0;
        if (ahora_mes > mes) meses = ahora_mes - mes;
        if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
        if (ahora_mes == mes && dia > ahora_dia) meses = 11;

        var dias = 0;
        if (ahora_dia > dia) dias = ahora_dia - dia;
        if (ahora_dia < dia) {
          var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
          var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
        }

        this.anos = edad;
        this.meses = meses;
        this.edad = this.anos + " años y " + this.meses + " meses";
      } else {
        this.anos = 0;
      }
    },
    calcularFechaActual: function calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fecha = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fecha = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    iniciar: function iniciar() {
      this.mensaje = "No hay datos de pacientes";
      this.buscar = true;
      this.arrayPacientes = [];
      this.busqueda = "";
    },
    alerta: function alerta() {
      var opcion = confirm("\xBFdesea continuar viendo los objetivos de " + localStorage.getItem('PacienteNombre') + "?");
      if (opcion == true) {
        this.criterio = 'PacNumDoc';
        this.busqueda = localStorage.getItem("PacienteHC");
        this.buscarPacientes();
      } else {
        localStorage.removeItem("PacienteHC");
        localStorage.removeItem("PacienteId");
        localStorage.removeItem("PacienteNombre");
      }
    },
    obtenerUltimoDiaTrimestre: function obtenerUltimoDiaTrimestre(fecha) {
      fecha = new Date(fecha);
      var year = fecha.getFullYear();
      var trimestre = Math.ceil((fecha.getMonth() + 1) / 3);
      var ultimoDiaPorTrimestre = [31, 30, 30, 31];
      var ultimoMesTrimestre = trimestre * 3 - 1;

      var ultimoDia = new Date(year, ultimoMesTrimestre, ultimoDiaPorTrimestre[trimestre - 1]);
      return ultimoDia.toISOString().split("T")[0];
    },
    push: function push(route) {
      this.$router.push(route);
    }
  },
  components: {
    CircleChartCard: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Cards_CircleChartCard_vue__["a" /* default */]
  },
  mounted: function mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.token = localStorage.getItem("token");
      this.usuario = localStorage.getItem("usuario");
      this.rol = localStorage.getItem("rol");
      this.calcularFechaActual();
      if (localStorage.getItem("PacienteHC")) {
        this.alerta();
      }
    }
  }
});

/***/ }),

/***/ "Ms/T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mu0F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salarios_vue__ = __webpack_require__("W4lv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c313c2ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salarios_vue__ = __webpack_require__("2tsZ");
function injectStyle (ssrContext) {
  __webpack_require__("LjH8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c313c2ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N6Po":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card",staticStyle:{"padding":"5px 10px 5px","border-radius":"10px"}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('strong',{staticStyle:{"font-size":"20px"}},[_vm._v("Información por entidades")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"darkgrey"}},[_vm._v("Información de las ganancias y servicios no completados por entidad")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"darkgray"}},[_vm._v("Resumen: "),_c('span',{staticStyle:{"color":"green"}},[_c('i',{staticClass:"fa fa-arrow-up",staticStyle:{"color":"green"}}),_vm._v(" "+_vm._s(_vm.resumenEntidad))]),_vm._v(" || "),_c('span',{staticStyle:{"color":"red"}},[_c('i',{staticClass:"fa fa-arrow-down",staticStyle:{"color":"red"}}),_vm._v(" "+_vm._s(_vm.resumenCanceladasEntidad))])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"max-height":"400px","overflow":"scroll","overflow-x":"hidden"}},[_c('div',{staticClass:"row"},_vm._l((_vm.informacionEntidad),function(entidad){return _c('div',{key:entidad.nombre,staticClass:"col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"border":"1px darkgray solid"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v(_vm._s(entidad.nombre != 'N/A' ? entidad.nombre : 'Particulares'))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("ENTIDAD")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('i',{staticClass:"fa fa-arrow-up",staticStyle:{"color":"green"}}),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(entidad.realizadas))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("TOTAL EN SERVICIOS REALIZADOS")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('i',{staticClass:"fa fa-arrow-down",staticStyle:{"color":"red"}}),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(entidad.canceladas))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("SERVICIOS NO COMPLETADOS")])])])])])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N9S+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.obtenerInformacionFacturacion(_vm.fechaInicial, _vm.fechaFinal, _vm.pacienteSelected)}}},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","required":"","id":"fechaInicial"},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha final:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","required":"","id":"fechaInicial"},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Selecciona el paciente")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pacienteSelected),expression:"pacienteSelected"}],staticClass:"form-control",attrs:{"name":"","placeholder":"Selecciona el paciente..."},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.pacienteSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"todos","selected":""}},[_vm._v("Todos los pacientes")]),_vm._v(" "),_vm._l((_vm.pacientes),function(paciente){return _c('option',{key:paciente.PacIdeUsu,domProps:{"value":paciente.PacIdeUsu}},[_vm._v("\n            "+_vm._s(paciente.PacNom1 + " " + paciente.PacApe1)+"\n          ")])})],2)]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"card",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"row"},[_c('center',[(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e()])],1),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"30px"}},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{ref:"component",staticClass:"row",staticStyle:{"padding":"20px"}},[_c('div',{staticClass:"col-md-12"},[(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill mb-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"Copagos recibidos","name":("reporte para facturacion " + _vm.fechaInicial + " -- " + _vm.fechaFinal)}},[_vm._v("\n            Exportar a excel "),_c('i',{staticClass:"fa fa-download",attrs:{"color":"black"}})]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"padding":"20px"}},[_c('br'),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","data":_vm.queriedData}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"height":"500","min-width":column.minWidth,"prop":column.prop,"label":column.label}})}),1)],1)])]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding":"25px"}},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Reporte para facturacion")]),_vm._v(" "),_c('p',[_vm._v("Reporte para facturación RIPS")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit","value":"Buscar información"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pollyfills__ = __webpack_require__("im4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale__ = __webpack_require__("urW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_chart_js__ = __webpack_require__("ikxi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_hchs_vue_charts__ = __webpack_require__("h0do");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_hchs_vue_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_hchs_vue_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay__ = __webpack_require__("G9B3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filtros_fecha__ = __webpack_require__("rEl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__filtros_fechaCompleta__ = __webpack_require__("hf80");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__filtros_diasFaltantes__ = __webpack_require__("ASWW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_sass_paper_dashboard_scss__ = __webpack_require__("MAOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_sass_paper_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_sass_paper_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_sass_element_variables_scss__ = __webpack_require__("yv97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_sass_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_sass_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_sass_demo_scss__ = __webpack_require__("9G8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_sass_demo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_sass_demo_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_src_sweetalert2_scss__ = __webpack_require__("CyIa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_src_sweetalert2_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_sweetalert2_src_sweetalert2_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__sidebarLinks__ = __webpack_require__("FiZY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sidebarLlinksAdmi__ = __webpack_require__("laR2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_loaders_dist_vue_loaders_css__ = __webpack_require__("v8QE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_loaders_dist_vue_loaders_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_loaders_dist_vue_loaders_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_loaders__ = __webpack_require__("MTav");






































__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('loader', __WEBPACK_IMPORTED_MODULE_27_vue_loaders__["a" /* default */].component);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_loading_overlay___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_25_axios___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_notifyjs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9__components_UIComponents_SidebarPlugin__["a" /* default */], { sidebarLinks: __WEBPACK_IMPORTED_MODULE_23__sidebarLinks__["a" /* default */] }, { sidebarLinksAdmi: __WEBPACK_IMPORTED_MODULE_24__sidebarLlinksAdmi__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(window.VueCharts);
__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_js_modal___default.a, { dialog: true });
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('date', __WEBPACK_IMPORTED_MODULE_16__filtros_fecha__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('dateC', __WEBPACK_IMPORTED_MODULE_17__filtros_fechaCompleta__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('diasFaltantes', __WEBPACK_IMPORTED_MODULE_18__filtros_diasFaltantes__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_15__routes_routes__["a" /* default */],
    linkActiveClass: 'active'
});

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    el: '#app',
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_7__App_vue__["a" /* default */]);
    },
    router: router
});

/***/ }),

/***/ "NniW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NoA9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      estado: 1,
      especialidad: 0,
      tipo: 1,
      opciones_fecha: 2,
      tipocliente: 2,
      fecha_inicial: "",
      fecha_final: "",
      ip: "https://avanti-erp.com/api/",
      pacientes: [],
      tipoEntidad: "EpsCod",
      arrayEps: [],
      arrayPrepagada: [],
      arrayPoliza: [],
      entidad: 16,
      regimen: 1,
      sede: "Sede Principal",
      SedesProgramacion: [],
      rol: "",

      tableColumns: [{
        prop: "PacApe1",
        label: "Apellidos",
        minWidth: 150 }, {
        prop: "PacNom1",
        label: "Nombres",
        minWidth: 150 }, {
        prop: "entidad",
        label: "Entidad",
        minWidth: 150 }, {
        prop: "Realizadas",
        label: "SSR"
      }, {
        prop: "Canceladas",
        label: "CE"
      }, {
        prop: "Sesiones Disponibles",
        label: "SSAs"
      }, {
        prop: "Autorizaciones",
        label: "Autorizaciones Activas",
        minWidth: 120
      }]
    };
  },
  methods: {
    selectEps: function selectEps() {
      var _this = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "selectEps?reg=" + this.regimen;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this.arrayEps = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    selectPrepagada: function selectPrepagada() {
      var _this2 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "selectPrepagada";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this2.arrayPrepagada = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    selectPoliza: function selectPoliza() {
      var _this3 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "selectPoliza";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this3.arrayPoliza = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },

    getPacientes: function getPacientes() {
      var _this4 = this;

      this.$modal.show("carga");
      this.pacientes = [];
      var rol = localStorage.getItem("rol");
      var sede = rol == 1 ? this.sede : localStorage.getItem("sede");
      if (this.tipo == 1) {
        if (this.opciones_fecha == 1) {
          var BASE_URL = this.ip + "reportes/pacientes/fecha/" + this.fecha_inicial + "/" + this.fecha_inicial + "/" + sede;
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(BASE_URL).then(function (res) {
            var pacientes_activos = [];
            var data_pacientes = res.data.data;
            if (_this4.estado == 3) {
              _this4.pacientes = res.data.data;
            } else {
              for (var index = 0; index < data_pacientes.length; index++) {
                if (data_pacientes[index].estado == _this4.estado) {
                  pacientes_activos.push(data_pacientes[index]);
                }
              }
              _this4.pacientes = pacientes_activos;
            }
          }).catch(function (err) {
            _this4.$modal.hide("carga");
            console.log(err);
          });
        } else {
          var _BASE_URL = this.ip + "reportes/pacientes/fecha/" + this.fecha_inicial + "/" + this.fecha_final + "/" + this.especialidad + "/" + sede;
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_BASE_URL).then(function (res) {
            var pacientes_activos = [];
            var data_pacientes = res.data.data;
            if (_this4.estado == 3) {
              _this4.pacientes = res.data.data;
            } else {
              for (var index = 0; index < data_pacientes.length; index++) {
                if (data_pacientes[index].estado == _this4.estado) {
                  pacientes_activos.push(data_pacientes[index]);
                }
              }
              _this4.pacientes = pacientes_activos;
            }
            _this4.$modal.hide("carga");
          }).catch(function (err) {
            _this4.$modal.hide("carga");
            console.log(err);
          });
        }
      } else if (this.tipo == 2) {
        var _BASE_URL2 = this.ip + "reportes/pacientes/tipocliente/" + this.tipocliente + "/" + this.fecha_inicial + "/" + this.fecha_final + "/" + this.especialidad + "/" + sede;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_BASE_URL2).then(function (res) {
          var pacientes_activos = [];
          var data_pacientes = res.data.data;
          if (_this4.estado == 3) {
            _this4.pacientes = res.data.data;
          } else {
            for (var index = 0; index < data_pacientes.length; index++) {
              if (data_pacientes[index].estado == _this4.estado) {
                pacientes_activos.push(data_pacientes[index]);
              }
            }
            _this4.pacientes = pacientes_activos;
          }
          _this4.$modal.hide("carga");
        }).catch(function (err) {
          _this4.$modal.hide("carga");
          console.log(err);
        });
      } else {
        var _BASE_URL3 = this.ip + "reportes/pacientes/entidad/" + this.tipoEntidad + "/" + this.entidad + "/" + this.fecha_inicial + "/" + this.fecha_final + "/" + this.especialidad + "/" + sede;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(_BASE_URL3).then(function (res) {
          var pacientes_activos = [];
          var data_pacientes = res.data.data;
          if (_this4.estado == 3) {
            _this4.pacientes = res.data.data;
          } else {
            for (var index = 0; index < data_pacientes.length; index++) {
              if (data_pacientes[index].estado == _this4.estado) {
                pacientes_activos.push(data_pacientes[index]);
              }
            }
            _this4.pacientes = pacientes_activos;
          }
          _this4.$modal.hide("carga");
        }).catch(function (err) {
          _this4.$modal.hide("carga");
          console.log(err);
        });
      }
    },
    emailsProgramacion: function emailsProgramacion() {
      var _this5 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "emailsProgramacion";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this5.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    this.selectEps();
    this.selectPrepagada();
    this.selectPoliza();
    this.emailsProgramacion();
    this.rol = localStorage.getItem("rol");
  }
});

/***/ }),

/***/ "O791":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.nombres != '')?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-success btn-block btn-simple",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.cerrarHC()}}},[_c('i',{staticClass:"fa fa-chevron-left"}),_vm._v(" Cerrar Historia Clínica\n      ")])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.opcion == 1),expression:"opcion == 1"}],staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('center',[_c('h5',{staticStyle:{"color":"grey"}},[_vm._v("\n          Buscar Historia Clínica "),_c('i',{staticClass:"fa fa-search"})])])],1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.buscarPacientes()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-xs-12 col-md-4"},[_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.criterio),expression:"criterio"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.criterio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_vm._m(0),_vm._v(" "),_c('option',{attrs:{"value":"paciente.PacNom1"}},[_vm._v("Nombres del paciente")]),_vm._v(" "),_c('option',{attrs:{"value":"paciente.PacNumDoc"}},[_vm._v("\n                Documento del paciente\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-6"},[_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],staticClass:"form-control",attrs:{"required":"","type":"text","id":"texto","name":"texto","placeholder":"Buscar..."},domProps:{"value":(_vm.busqueda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-1"})])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-striped",attrs:{"size":"mini","bordered":"","data":_vm.pacientes}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNom1","label":"Nombres","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacApe1","label":"Apellidos","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNumDoc","label":"Documento","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"50","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-icon btn-success",on:{"click":function($event){return _vm.llamarPacientes(props.row)}}},[_c('i',{staticClass:"fa fa-search"})])]}}])})],1)],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.opcion != 1 && _vm.viewTab == 0),expression:"opcion != 1 && viewTab == 0"}],staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"card",staticStyle:{"border-radius":"10px"}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('center',[_c('div',{staticClass:"col-12"},[_c('strong',{staticClass:"text-grey"},[_vm._v(_vm._s(_vm.nombres + " " + _vm.apellidos))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.estado == 0)?_c('strong',{staticStyle:{"font-size":"12px","color":"red"}},[_vm._v("INACTIVO")]):_vm._e(),_vm._v(" "),(_vm.estado == 1)?_c('strong',{staticStyle:{"font-size":"12px","color":"green"}},[_vm._v("ACTIVO")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.loked != null)?_c('strong',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v("CONFIDENCIAL")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticStyle:{"width":"120px","padding-top":"5px"}},[_c('img',{staticClass:"img-thumbnail",staticStyle:{"border-radius":"15px !important"},attrs:{"src":_vm.ip + '' + _vm.fotoPaciente}})]),_vm._v(" "),_c('br')])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_c('small',{staticClass:"text-grey"},[_vm._v("F. de ingreso:")]),_vm._v(" "),_c('small',[_c('strong',[_vm._v(_vm._s(_vm._f("date")(_vm.fechaIngreso)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_c('small',{staticClass:"text-grey"},[_vm._v("F. de nacimiento:")]),_vm._v(" "),_c('small',[_c('strong',[_vm._v(_vm._s(_vm._f("date")(_vm.Fecha_nacimiento)))])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_c('small',{staticClass:"text-grey"},[_vm._v("Edad")]),_vm._v(" "),_c('small',[_c('strong',[_vm._v(_vm._s(_vm.anos)+" años y "+_vm._s(_vm.meses)+" meses")])])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('p',[_c('i',{staticClass:"fa fa-male"}),_vm._v(" "),_c('small',{staticClass:"text-grey"},[_vm._v("Sexo:")]),_vm._v(" "),_c('small',[_c('strong',[_vm._v(_vm._s(_vm.sexo))])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('small',[_vm._v("EPS:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.eps))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('small',[_vm._v("Prepagada:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.prepagada))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('small',[_vm._v("Póliza:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.poliza))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('small',[_vm._v("Tipo de afiliación:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.tipoAfiliacion))])])],1),_vm._v(" "),(
              _vm.loked == _vm.usuarioAvanza ||
              _vm.loked == null ||
              _vm.rol == 1 ||
              _vm.rol == 9 ||
              _vm.rol == 13
            )?_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_vm._l((_vm.cards_tab),function(card){return _c('div',{key:card.tab,staticClass:"col-xs-12"},[_c('div',{staticClass:"card",staticStyle:{"background-color":"#efefef","border-radius":"5px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_vm._m(4,true),_vm._v(" "),_c('div',{staticClass:"col-xs-7"},[_c('strong',[_vm._v(_vm._s(card.title))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2"},[_c('button',{staticClass:"btn btn-primary btn-simple",on:{"click":function($event){return _vm.viewTabFunction(card.tab)}}},[_c('i',{staticClass:"fa fa-chevron-right"})])])])])])])})],2):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('center',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{staticClass:"img-responsive",staticStyle:{"width":"120px"},attrs:{"src":"static/img/ICONOS/candado.svg","alt":"Imagen de bloqueo de HC avanti"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Esta HC es confidencial. Por favor comunicarse con el\n                  administrador para solicitar acceso.")])])],1)])])])])]),_vm._v(" "),(_vm.opcion != 1 && _vm.viewTab == 1)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary btn-simple",on:{"click":function($event){return _vm.viewTabFunction(0)}}},[_c('i',{staticClass:"fa fa-chevron-left"}),_vm._v(" Volver\n          ")])]),_vm._v(" "),_c('center',[_c('div',{staticClass:"col-12"},[_c('strong',{staticClass:"text-grey"},[_vm._v(_vm._s(_vm.nombres + " " + _vm.apellidos))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.estado == 0)?_c('strong',{staticStyle:{"font-size":"12px","color":"red"}},[_vm._v("INACTIVO")]):_vm._e(),_vm._v(" "),(_vm.estado == 1)?_c('strong',{staticStyle:{"font-size":"12px","color":"green"}},[_vm._v("ACTIVO")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.loked != null)?_c('strong',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v("CONFIDENCIAL")]):_vm._e()])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('center',[_c('strong',{staticClass:"text-grey"},[_vm._v("Motivo de consulta verificado")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Total motivos de consulta: ( "+_vm._s(_vm.arrayMotivo.length)+" )")])])],1),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding":"5px"}},[_c('div',{staticClass:"table-responsive",staticStyle:{"border":"none"}},[(_vm.arrayMotivo != '')?_c('el-table',{staticClass:"table-striped table-sm",attrs:{"size":"mini","data":_vm.arrayMotivo}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fecha","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.MotFec))]}}],null,false,1931193835)}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"250","prop":"MotDes","label":"Motivo de consulta"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"MotTer","width":"135","label":"Terapeuta"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Estado","width":"135","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.MotEst == 0)?_c('div',[_c('span',{staticClass:"label label-warning",staticStyle:{"border-radius":"5px"},attrs:{"slot":"title-label"},slot:"title-label"},[_c('i',{staticClass:"ti-close"}),_vm._v(" Por verificar\n                  ")])]):_vm._e(),_vm._v(" "),(props.row.MotEst == 1)?_c('div',[_c('span',{staticClass:"label label-success",staticStyle:{"border-radius":"5px"},attrs:{"slot":"title-label"},slot:"title-label"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Verificado\n                  ")])]):_vm._e()]}}],null,false,1878374053)})],1):_vm._e()],1)])])]):_vm._e(),_vm._v(" "),(_vm.opcion != 1 && _vm.viewTab == 2)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary btn-simple",on:{"click":function($event){return _vm.viewTabFunction(0)}}},[_c('i',{staticClass:"fa fa-chevron-left"}),_vm._v(" Volver\n          ")])]),_vm._v(" "),_c('center',[_c('div',{staticClass:"col-12"},[_c('strong',{staticClass:"text-grey"},[_vm._v(_vm._s(_vm.nombres + " " + _vm.apellidos))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.estado == 0)?_c('strong',{staticStyle:{"font-size":"12px","color":"red"}},[_vm._v("INACTIVO")]):_vm._e(),_vm._v(" "),(_vm.estado == 1)?_c('strong',{staticStyle:{"font-size":"12px","color":"green"}},[_vm._v("ACTIVO")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.loked != null)?_c('strong',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v("CONFIDENCIAL")]):_vm._e()])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('center',[_c('strong',{staticClass:"text-grey"},[_vm._v("Antecedentes")]),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('vue-tabs',{attrs:{"direction":"horizontal","value":"l"}},[_c('v-tab',{attrs:{"title":'Prenatales' + '  ' + '( ' + _vm.antecedentesPre.length + ' )'}},[_c('div',{staticClass:"table-responsive"},[(_vm.antecedentesPre != '')?_c('el-table',{staticClass:"table-striped",attrs:{"size":"mini","data":_vm.antecedentesPre}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AntDes","label":"Descripción"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"185"}})],1):_vm._e()],1)]),_vm._v(" "),_c('v-tab',{attrs:{"title":'Neonatales' + ' ' + '( ' + _vm.antecedentesNeo.length + ' )'}},[_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-striped",attrs:{"size":"mini","data":_vm.antecedentesNeo}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AntDes","label":"Descripción"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"185"}})],1)],1)]),_vm._v(" "),_c('v-tab',{attrs:{"title":'Postnatales ( ' + _vm.antecedentesPos.length + ' )'}},[_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-striped",attrs:{"size":"mini","data":_vm.antecedentesPos}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AntDes","label":"Descripción"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"185"}})],1)],1)]),_vm._v(" "),_c('v-tab',{attrs:{"title":'Personales ( ' + _vm.antecedentesPer.length + ' )'}},[_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-striped",attrs:{"size":"mini","data":_vm.antecedentesPer}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AntDes","label":"Descripción"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"185"}})],1)],1)]),_vm._v(" "),_c('v-tab',{attrs:{"title":'Familiares ( ' + _vm.antecedentesFam.length + ' )'}},[_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-striped table-sm",attrs:{"size":"mini","data":_vm.antecedentesFam}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"AntDes","label":"Descripción"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"185"}})],1)],1)])],1)],1)])]):_vm._e(),_vm._v(" "),(_vm.opcion != 1 && _vm.viewTab == 3)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary btn-simple",on:{"click":function($event){return _vm.viewTabFunction(0)}}},[_c('i',{staticClass:"fa fa-chevron-left"}),_vm._v(" Volver\n          ")])]),_vm._v(" "),_c('center',[_c('div',{staticClass:"col-12"},[_c('strong',{staticClass:"text-grey"},[_vm._v(_vm._s(_vm.nombres + " " + _vm.apellidos))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.estado == 0)?_c('strong',{staticStyle:{"font-size":"12px","color":"red"}},[_vm._v("INACTIVO")]):_vm._e(),_vm._v(" "),(_vm.estado == 1)?_c('strong',{staticStyle:{"font-size":"12px","color":"green"}},[_vm._v("ACTIVO")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.loked != null)?_c('strong',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v("CONFIDENCIAL")]):_vm._e()])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('center',[_c('strong',{staticClass:"text-grey"},[_vm._v("Impresión General")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Total de observaciones ( "+_vm._s(_vm.arrayResumen.length)+" )")])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-striped",attrs:{"size":"mini","data":_vm.arrayResumen}},[_c('el-table-column',{attrs:{"label":"#","width":"70","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fecha","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.ResFec)+"\n              ")]}}],null,false,2474963257)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"350","prop":"ResDes","label":"Descripción"}})],1)],1)])])]):_vm._e(),_vm._v(" "),(_vm.opcion != 1 && _vm.viewTab == 4)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary btn-simple",on:{"click":function($event){return _vm.viewTabFunction(0)}}},[_c('i',{staticClass:"fa fa-chevron-left"}),_vm._v(" Volver\n          ")])]),_vm._v(" "),_c('center',[_c('div',{staticClass:"col-12"},[_c('strong',{staticClass:"text-grey"},[_vm._v(_vm._s(_vm.nombres + " " + _vm.apellidos))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.estado == 0)?_c('strong',{staticStyle:{"font-size":"12px","color":"red"}},[_vm._v("INACTIVO")]):_vm._e(),_vm._v(" "),(_vm.estado == 1)?_c('strong',{staticStyle:{"font-size":"12px","color":"green"}},[_vm._v("ACTIVO")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.loked != null)?_c('strong',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v("CONFIDENCIAL")]):_vm._e()])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('center',[_c('strong',{staticClass:"text-grey"},[_vm._v("Examen Paciente")]),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('center',[_c('strong',{staticStyle:{"color":"grey","font-size":"18px"}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Seleccione el exámen\n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.examen),expression:"examen"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.examen=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.tipoExamen()}]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Seleccionar...")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("\n              Formato de evaluación de terapia ocupacional (AVANZA)\n            ")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Formato de evaluación psicología niños")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("\n              Formato de evaluación fonoaudiólogia función oral faringea\n            ")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("\n              Formato de evaluación fonoaudiólogia lenguaje\n            ")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("\n              Examen fisico basado en neurodesarrollo (AVANZA)\n            ")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("\n              Evaluación de la desorganización postural\n            ")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("\n              Formato de evaluación musculoesquelética\n            ")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Psicología adulto")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Evaluación cognitiva")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Evaluación comportamental")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Revisión por sistemas")])])]),_vm._v(" "),_c('div',[(_vm.examen != 0)?_c('div',{},[_c('div',{staticClass:"table-responsive",staticStyle:{"border":"none"}},[_c('center',[(_vm.examen != 0)?_c('el-table',{staticClass:"table-striped",attrs:{"size":"mini","data":_vm.arrayActivo}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"Fecha y Hora"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',[_vm._v(_vm._s(_vm._f("dateC")(props.row.created_at)))])]}}],null,false,2284701173)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta"}})],1):_vm._e()],1)],1)]):_vm._e()])],1)])]):_vm._e(),_vm._v(" "),(_vm.opcion != 1 && _vm.viewTab == 5)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary btn-simple",on:{"click":function($event){return _vm.viewTabFunction(0)}}},[_c('i',{staticClass:"fa fa-chevron-left"}),_vm._v(" Volver\n          ")])]),_vm._v(" "),_c('center',[_c('div',{staticClass:"col-12"},[_c('strong',{staticClass:"text-grey"},[_vm._v(_vm._s(_vm.nombres + " " + _vm.apellidos))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.estado == 0)?_c('strong',{staticStyle:{"font-size":"12px","color":"red"}},[_vm._v("INACTIVO")]):_vm._e(),_vm._v(" "),(_vm.estado == 1)?_c('strong',{staticStyle:{"font-size":"12px","color":"green"}},[_vm._v("ACTIVO")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.loked != null)?_c('strong',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v("CONFIDENCIAL")]):_vm._e()])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('center',[_c('strong',{staticClass:"text-grey"},[_vm._v("Conclusiones, recomendación y plan de tratamiento")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Total tratamientos: ( "+_vm._s(_vm.tratamiento.length)+" )")])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-striped table-sm",attrs:{"data":_vm.tratamiento}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fecha inicial","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v(_vm._s(props.row.TraFec))]}}],null,false,1634973658)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fecha Fin","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.TraFecFin == null)?_c('p',[_vm._v("Indefinido")]):_c('p',[_vm._v(_vm._s(props.row.TraFecFin))])]}}],null,false,1692374923)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"terapeuta","label":"Terapeuta","width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"300","prop":"TraDes","label":"Observaciones"}})],1)],1)])])]):_vm._e(),_vm._v(" "),(_vm.opcion != 1 && _vm.viewTab == 6)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary btn-simple",on:{"click":function($event){return _vm.viewTabFunction(0)}}},[_c('i',{staticClass:"fa fa-chevron-left"}),_vm._v(" Volver\n          ")])]),_vm._v(" "),_c('center',[_c('div',{staticClass:"col-12"},[_c('strong',{staticClass:"text-grey"},[_vm._v(_vm._s(_vm.nombres + " " + _vm.apellidos))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.estado == 0)?_c('strong',{staticStyle:{"font-size":"12px","color":"red"}},[_vm._v("INACTIVO")]):_vm._e(),_vm._v(" "),(_vm.estado == 1)?_c('strong',{staticStyle:{"font-size":"12px","color":"green"}},[_vm._v("ACTIVO")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.loked != null)?_c('strong',{staticClass:"text-secondary",staticStyle:{"font-size":"12px"}},[_vm._v("CONFIDENCIAL")]):_vm._e()])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('center',[_c('strong',{staticClass:"text-grey"},[_vm._v("Plan de intervención terapéutica")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Total tratamientos: ( "+_vm._s(_vm.evoluciones.length)+" )")])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive"},[_c('el-table',{staticClass:"table-striped",attrs:{"size":"mini","max-height":"500","data":_vm.evoluciones}},[_c('el-table-column',{attrs:{"label":"#","type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fecha","width":"100","prop":"EvoFec"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Terapeuta","prop":"EvoTer","width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Evolución","width":"400","prop":"Obs"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"170","label":"Est. terapéutica"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(
                    props.row.Obs == 'Se hizo una evaluación del paciente'
                  )?_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v("\n                  Evaluación\n                ")]):_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v("\n                  "+_vm._s(props.row.EvoEst)+"\n                ")])]}}],null,false,764905697)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Mat. de apoyo","width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(
                    props.row.Obs == 'Se hizo una evaluación del paciente'
                  )?_c('p',{staticStyle:{"font-size":"12px"}}):_c('p',{staticStyle:{"font-size":"12px"}},[_vm._v("\n                  "+_vm._s(props.row.EvoMat)+"\n                ")])]}}],null,false,582324484)})],1)],1)])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('option',{attrs:{"value":"paciente.PacApe1"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Apellidos del paciente\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-xs-12 col-md-2"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-success btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Buscar\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('p',{staticClass:"text-grey"},[_vm._v("Información del paciente:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('p',{staticClass:"text-grey"},[_vm._v("Datos de afiliación:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-2"},[_c('i',{staticClass:"fa fa-file text-grey",staticStyle:{"font-size":"30px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OQ5W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('modal',{attrs:{"name":"gestionar","draggable":true,"scrollable":true,"width":"550","height":"auto","reset":true}},[_c('br'),_vm._v(" "),_c('div',[_c('div',[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"5px","padding-top":"0"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"ti-settings text-success",staticStyle:{"font-size":"35px"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal",staticStyle:{"margin-bottom":"-7px"}},[_c('strong',[_vm._v("GESTIONAR USUARIOS")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.actualizarUsuario.apply(null, arguments)}}},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('strong',[_vm._v("Información de acceso:")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('small',[_vm._v("Firma electronica:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioActivo.UsuFirEle),expression:"usuarioActivo.UsuFirEle"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.usuarioActivo.UsuFirEle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioActivo, "UsuFirEle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('small',[_vm._v("Clave:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clave),expression:"clave"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.clave)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clave=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('small',[_vm._v("Correo:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioActivo.email),expression:"usuarioActivo.email"}],staticClass:"form-control",attrs:{"type":"email"},domProps:{"value":(_vm.usuarioActivo.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioActivo, "email", $event.target.value)}}})]),_vm._v(" "),(_vm.usuarioActivo.id_rol != 1)?_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Rol")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioActivo.id_rol),expression:"usuarioActivo.id_rol"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.usuarioActivo, "id_rol", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.roles),function(rol){return _c('option',{key:rol.id,domProps:{"value":rol.id}},[_vm._v("\n                    "+_vm._s(rol.nombre)+"\n                  ")])}),0),_vm._v(" "),_c('br'),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('strong',[_vm._v("Firma")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('small',[_vm._v("Campo 1:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioActivo.CamFir1),expression:"usuarioActivo.CamFir1"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.usuarioActivo.CamFir1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioActivo, "CamFir1", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('small',[_vm._v("Campo 2:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioActivo.CamFir2),expression:"usuarioActivo.CamFir2"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.usuarioActivo.CamFir2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioActivo, "CamFir2", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('small',[_vm._v("Campo 3:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarioActivo.CamFir3),expression:"usuarioActivo.CamFir3"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.usuarioActivo.CamFir3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarioActivo, "CamFir3", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('strong',[_vm._v("Foto de perfil:")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('small',[_vm._v("Seleccionar nueva foto de perfil:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"file","accept":".jpg, .png"},on:{"change":_vm.functionFotoPaciente}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-success btn-fill btn-sm",staticStyle:{"border-radius":"5px"},attrs:{"type":"submit"}},[_vm._v("\n                    Actualizar Datos "),_c('i',{staticClass:"fa fa-send"})])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"padding-bottom":"0"}},[_c('button',{staticClass:"btn btn-danger btn-block btn-icon btn-simple",attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModal()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" CERRAR\n          ")])]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 card",staticStyle:{"border-radius":"20px"}},[_c('div',{staticClass:"card-content row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-default",staticStyle:{"border-radius":"5px"},on:{"click":function($event){_vm.estadoModalAgregar = 1}}},[_vm._v("\n          Nuevo Usuario "),_c('i',{staticClass:"fa fa-user"})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Buscar usuario...","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"else":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"fixed":"right","label":"Estado"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[(props.row.condicion == 1)?_c('div',[_c('span',{staticClass:"label label-success",staticStyle:{"border-radius":"5px"},attrs:{"slot":"title-label"},slot:"title-label"},[_c('i',{staticClass:"ti-check"}),_vm._v(" Activo\n                  ")])]):_c('div',[_c('span',{staticClass:"label label-default",staticStyle:{"border-radius":"5px"},attrs:{"slot":"title-label"},slot:"title-label"},[_c('i',{staticClass:"ti-power-off"}),_vm._v(" Inactivo\n                  ")])])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.condicion == 2 && props.row.usuario != 'kballeng')?_c('button',{staticClass:"btn btn-simple btn-xs btn-info btn-icon check",on:{"click":function($event){return _vm.activar(props.row)}}},[_c('i',{staticClass:"ti-check"})]):_vm._e(),_vm._v(" "),(props.row.condicion == 1 && props.row.usuario != 'kballeng')?_c('button',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit",on:{"click":function($event){return _vm.desactivar(props.row)}}},[_c('i',{staticClass:"ti-close"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-simple btn-xs btn-success",on:{"click":function($event){return _vm.abrirModal(props.row)}}},[_c('i',{staticClass:"fa fa-pencil"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n          Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"modal fade",class:{ mostrar: _vm.estadoModalAgregar },staticStyle:{"padding":"20px"},attrs:{"id":"modalMotivo","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"padding":"10px"},attrs:{"role":"document"}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-content",staticStyle:{"padding":"10px"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombres:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombres),expression:"nombres"}],staticClass:"form-control",domProps:{"value":(_vm.nombres)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombres=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Apellidos:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apellidos),expression:"apellidos"}],staticClass:"form-control",domProps:{"value":(_vm.apellidos)},on:{"input":function($event){if($event.target.composing){ return; }_vm.apellidos=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Usuario:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario),expression:"usuario"}],staticClass:"form-control",domProps:{"value":(_vm.usuario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.usuario=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Contraseña:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Correo Avanza:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"form-control",domProps:{"value":(_vm.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Rol:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.rol),expression:"rol"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.rol=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.roles),function(rol){return _c('option',{key:rol.id,domProps:{"value":rol.id}},[_vm._v("\n                    "+_vm._s(rol.nombre)+"\n                  ")])}),0),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Sede:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sede),expression:"sede"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sede=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.SedesProgramacion),function(sede){return _c('option',{key:sede,domProps:{"value":sede.sede}},[_vm._v("\n                    "+_vm._s(sede.sede)+"\n                  ")])}),0),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('center',[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"20px"}},[_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"type":"submit","data-dismiss":"modal"},on:{"click":function($event){return _vm.nuevoUsuario()}}},[_vm._v("\n                    Agregar\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.estadoModalAgregar = 0}}},[_vm._v("\n                    Cancelar\n                  ")])])])],1)])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"25px"}},[_c('p',{staticClass:"titulo-modal",staticStyle:{"margin-bottom":"-1px"}},[_c('strong',{staticStyle:{"font-size":"25px","font-weight":"bold"}},[_vm._v("Usuarios registrados")])]),_vm._v(" "),_c('small',{staticClass:"texto-pequeno",staticStyle:{"color":"grey"}},[_vm._v("Gestionar la información de los nuevos usuarios")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"5px","padding-top":"0"}},[_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"ti-user text-success",staticStyle:{"font-size":"35px"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal",staticStyle:{"margin-bottom":"-7px"}},[_c('strong',[_vm._v("Nuevo usuario")])]),_vm._v(" "),_c('small',{staticClass:"texto-pequeno",staticStyle:{"color":"grey"}},[_vm._v("Gestionar la información de los nuevos usuarios")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OwEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P5wJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PSPc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"contenido-informacion"},[_c('div',{staticClass:"imagen"},[_c('img',{staticClass:"img-responsive img-ter",staticStyle:{"border":"none"},attrs:{"src":_vm.foto,"alt":"imagen del terapeuta"}})]),_vm._v(" "),_c('div',{staticClass:"informacion"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h1',{staticClass:"nombre-ter"},[_vm._v(_vm._s(_vm.nombre)+" ")]),_vm._v(" "),_c('span',{staticClass:"rol-ter"},[_vm._v(_vm._s(_vm.usuario))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("@"+_vm._s(_vm.nombreUsuario.toLowerCase()))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticStyle:{"border-radius":"7px","background-color":"#e3097e","color":"white","border":"none","padding":"10px 20px","font-size":"16px","font-weight":"500"}},[_vm._v(" Actualizar información ")])])]),_vm._v(" "),_c('div',{staticClass:"card-contenido",staticStyle:{"display":"flex","gap":"20px"}},[_c('div',{staticClass:"card-proxima-sesion"},[_c('div',{staticClass:"card-evento"},[_c('div',{staticClass:"informacion"},[_c('div',[_vm._v("PRÓXIMA SESIÓN")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"paciente"},[_vm._v("SALOMON PALACIO BARBA")]),_vm._v(" "),_c('div',{staticClass:"fecha"},[_vm._v(_vm._s(_vm._f("date")(_vm.fechaProxima))+", 11:00 a 11:30")])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"card-resumen-dia"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"accion-resumen"},[_c('center',[_c('div',{staticClass:"mes"},[_vm._v("\n                "+_vm._s(_vm.fechaActualSeparada.mes.toUpperCase())+", "+_vm._s(_vm.fechaActualSeparada.year)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"dia"},[_vm._v("\n                "+_vm._s(_vm.fechaActualSeparada.dia)+"\n              ")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped table-condensed table-responsive",attrs:{"data":_vm.objetivosProximosPag}},[_c('el-table-column',{attrs:{"label":"Paciente","width":"350"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('small',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.nombrePaciente + " " + props.row.apellidoPaciente))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fec. Ingreso","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.fecha))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fec. Finalización","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.fechaCumplimiento))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Objetivo","width":"440"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.objetivo))])]}}])})],1),_vm._v(" "),_c('p-pagination',{attrs:{"per-page":_vm.paginationProximo.perPage,"total":_vm.paginationProximo.total},model:{value:(_vm.paginationProximo.currentPage),callback:function ($$v) {_vm.$set(_vm.paginationProximo, "currentPage", $$v)},expression:"paginationProximo.currentPage"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticStyle:{"font-size":"18px","font-weight":"500"}},[_vm._v("Pacientes liderados")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","margin-top":"10px","justify-content":"space-between"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchPaciente),expression:"searchPaciente"}],staticClass:"form-control",staticStyle:{"width":"300px"},attrs:{"type":"text","placeholder":"Buscar paciente..."},domProps:{"value":(_vm.searchPaciente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchPaciente=$event.target.value}}}),_vm._v(" "),(_vm.pacientesCargo != '')?_c('download-excel',{staticClass:"btn btn-simple",staticStyle:{"border-radius":"7px","color":"green","font-size":"18px","font-weight":"500"},attrs:{"data":_vm.pacientesCargo,"fields":_vm.json_fieldsPacientes,"worksheet":"My Worksheet","name":'pacientesACargo' + _vm.fechaActual}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Exportar\n              ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('el-table',{staticClass:"el-table table-striped table-condensed table-responsive",attrs:{"border":"","data":_vm.pacientesCargoPag}},[_c('el-table-column',{attrs:{"label":"Nombres y Apellidos","width":"450"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticStyle:{"font-size":"13px","color":"grey"}},[_vm._v(_vm._s(props.row.PacApe1 + " " + props.row.PacNom1))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Edad","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(_vm.calcularEdad(props.row.PacFecNac)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Numero de documento","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.PacNumDoc))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"DX","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.dx))])]}}])})],1),_vm._v(" "),_c('p-pagination',{attrs:{"per-page":_vm.paginationPacienteCargo.perPage,"total":_vm.paginationPacienteCargo.total},model:{value:(_vm.paginationPacienteCargo.currentPage),callback:function ($$v) {_vm.$set(_vm.paginationPacienteCargo, "currentPage", $$v)},expression:"paginationPacienteCargo.currentPage"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"margin-top":"10px","margin-left":"3px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Fecha inicio:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicioHis),expression:"fechaInicioHis"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaInicioHis)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicioHis=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Fecha fin:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinHis),expression:"fechaFinHis"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaFinHis)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinHis=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('small',{staticStyle:{"color":"white"}},[_vm._v("jj")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success",staticStyle:{"border-radius":"0px"},on:{"click":function($event){return _vm.hisSesiones()}}},[_vm._v("\n                Buscar atenciones\n                "),_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('small',{staticStyle:{"color":"white"}},[_vm._v("jj")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.hisAtenciones != '')?_c('download-excel',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"0px"},attrs:{"data":_vm.hisAtenciones,"fields":_vm.json_fieldsAtenciones,"worksheet":"My Worksheet","name":'sesionesRealizadas' + _vm.fechaActual}},[_vm._v("\n                Exportar a excel\n              ")]):_vm._e()],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"el-table table-striped table-condensed table-responsive",attrs:{"data":_vm.sesionesRRPag}},[_c('el-table-column',{attrs:{"label":"Nombres y Apellidos","width":"400"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticStyle:{"font-size":"13px","color":"grey"}},[_vm._v(_vm._s(props.row.PacApe1 + " " + props.row.PacNom1))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Entidad del paciente","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticStyle:{"font-size":"13px","color":"grey"}},[_vm._v(_vm._s(props.row.entidad))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fecha de atención"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(_vm._f("date")(props.row.ProFec)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Hora"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.hora))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Lugar"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.ProLug))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Tipo"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(props.row.ProTip))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Valor"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"grey-text"},[_vm._v(_vm._s(_vm.formatearPesosColombianos(props.row.ProValTer)))])]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.paginationSesionesRR.perPage,"total":_vm.paginationSesionesRR.total},model:{value:(_vm.paginationSesionesRR.currentPage),callback:function ($$v) {_vm.$set(_vm.paginationSesionesRR, "currentPage", $$v)},expression:"paginationSesionesRR.currentPage"}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accion"},[_c('button',{staticClass:"button-sesion"},[_vm._v("\n            Registrar evolución\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-resumen"},[_c('div',{staticClass:"titulo-resumen"},[_vm._v("Resumen del día")]),_vm._v(" "),_c('div',{staticClass:"resumen"},[_c('div',{staticClass:"informacion-resumen"},[_c('span',[_vm._v("22 Sesiones programadas")]),_vm._v(" "),_c('span',[_vm._v("5 Sesiones realizadas")]),_vm._v(" "),_c('span',[_vm._v("17 Sesiones pendientes")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticStyle:{"font-size":"18px","font-weight":"500"}},[_vm._v("Objetivos activos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-10 col-md-10"},[_c('span',{staticStyle:{"font-size":"18px","font-weight":"500"}},[_vm._v("Sesiones realizadas por fecha")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PScw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_aDashboard_nomina_cardnomina_vue__ = __webpack_require__("DBcq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__ = __webpack_require__("1byD");







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      informacionGastos: [],
      resumenGastos: 0
    };
  },

  methods: {
    getGastos: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fechaInicial, fechaFinal) {
        var BASE_URL, response, data, resumen, dataFormated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                BASE_URL = "api/gastos-dashboard/" + fechaInicial + "/" + fechaFinal;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__["a" /* default */].get(BASE_URL);

              case 4:
                response = _context.sent;

                if (response.data.status == true) {
                  data = response.data.data;
                  resumen = 0;
                  dataFormated = data.map(function (element) {
                    resumen = resumen + element.valor;
                    return {
                      usuario: element.usuario,
                      valor: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(element.valor),
                      fecha: element.fecha,
                      concepto: element.comentario,
                      categoria: element.categoria
                    };
                  });

                  this.resumenGastos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(resumen);
                  this.informacionGastos = dataFormated;
                }
                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

              case 10:
                _context.prev = 10;
                return _context.finish(10);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8, 10, 12]]);
      }));

      function getGastos(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getGastos;
    }()
  },
  components: {
    nomicard: __WEBPACK_IMPORTED_MODULE_2_src_components_aDashboard_nomina_cardnomina_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "Pecg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roles_vue__ = __webpack_require__("xH8E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f3cbe0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roles_vue__ = __webpack_require__("4SI9");
function injectStyle (ssrContext) {
  __webpack_require__("k8gv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55f3cbe0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_roles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f3cbe0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_roles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q9Qi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QmWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tarifas_vue__ = __webpack_require__("Vca+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1857dd92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tarifas_vue__ = __webpack_require__("FfHr");
function injectStyle (ssrContext) {
  __webpack_require__("Cz95")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tarifas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1857dd92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tarifas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QmxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classObject},[(_vm.shouldShowLabel)?_c('span',{staticClass:"vue-switcher__label"},[(_vm.label)?_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e(),_vm._v(" "),(!_vm.label && _vm.value)?_c('span',{domProps:{"textContent":_vm._s(_vm.textEnabled)}}):_vm._e(),_vm._v(" "),(!_vm.label && !_vm.value)?_c('span',{domProps:{"textContent":_vm._s(_vm.textDisabled)}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.trigger}}),_vm._v(" "),_c('div')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R+H9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"wrapper wrapper-full-page"},[_c('div',{staticClass:"full-page login-page"},[_c('div',{staticClass:"content",staticStyle:{"background-color":"#302254"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-sm-5 col-md-offset-3 col-sm-offset-3"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login()}}},[_c('div',{staticClass:"card",staticStyle:{"padding":"10px"}},[_c('br'),_vm._v(" "),(_vm.mensaje!=null)?_c('div',{staticClass:"alert alert-danger",staticStyle:{"color":"rgb(47, 34, 84)","background-color":"rgb(158, 137, 213)","font-size":"17px","margin":"10px 15px"}},[_c('span',[_vm._v(_vm._s(_vm.mensaje)+" "),_c('i',{class:'fa fa-'+_vm.icono})])]):_vm._e(),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"usuario"}},[_vm._v("Usuario")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario),expression:"usuario"}],staticClass:"form-control input-lg input-no-border",attrs:{"type":"text","id":"usuario","placeholder":"Ingrese su usuario","required":""},domProps:{"value":(_vm.usuario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.usuario=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"clave"}},[_vm._v("Contaseña")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control input-lg input-no-border",attrs:{"type":"password","id":"clave","placeholder":"Ingrese su clave","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v("\n                  \n                    "+_vm._s(_vm.error)+"\n                  ")]),_vm._v(" "),_vm._m(2)])])])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"full-page-background",staticStyle:{"background-image":"url(static/img/background/background-2.jpg)"}})])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse off-canvas-sidebar"},[_c('ul',{staticClass:"nav nav-mobile-menu"},[_c('router-link',{attrs:{"to":"/register","tag":"li"}},[_c('a',[_vm._v("Register")])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/admin/overview","tag":"li"}},[_c('a',[_vm._v("Dashboard")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-transparent navbar-absolute"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12"},[_c('img',{staticClass:"img-fluid",staticStyle:{"width":"30%","height":"30%"},attrs:{"src":"static/img/logo.webp","alt":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('span',{staticStyle:{"font-size":"25px","font-weight":"400"}},[_vm._v("Inicia sesión en avanti")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"15px","color":"gray","font-weight":"200"}},[_vm._v(" Inicia sesión con el usuario y contraseña que te asignaron ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('button',{staticClass:"btn btn-fill btn-lg btn-wd btn-block",staticStyle:{"border-radius":"0px"},attrs:{"type":"submit"}},[_vm._v("Iniciar sesión")]),_vm._v(" "),_c('div',{staticStyle:{"background-color":"#edededb5","margin":"25px 0px","border-radius":"7px","padding":"10px","color":"gray"}},[_c('span',[_c('i',{staticClass:"fa fa-close"}),_vm._v(" Recuerda no compartir tus datos de acceso ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_c('i',{staticClass:"fa fa-info"}),_vm._v(" Si no recuerdas tu clave, avisa al administrador ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",staticStyle:{"background-color":"#302254"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n            AVANTI v11     Desarrollado por Avanza IPS "),_c('a',[_vm._v(" - 2019")]),_vm._v(".\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c47aa618_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("hOWM");
function injectStyle (ssrContext) {
  __webpack_require__("Ks1f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c47aa618_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RNWA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rgrq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-secondary btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.prepararRegistrar()}}},[_vm._v("\n          Registrar deducción\n        ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","id":"fechaIncial"},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaFinal"}},[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","id":"fechaFinal"},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticStyle:{"display":"none"},attrs:{"for":"acciones"}},[_vm._v("Acciones")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.obtenerInformacionDescargos(_vm.fechaInicial, _vm.fechaFinal)}}},[_vm._v("\n          Buscar información\n        ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[(_vm.queriedData2 == '')?_c('div',{staticClass:"row"},[_c('center',[_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1)])],1):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive table-striped mt-2",attrs:{"border":"","data":_vm.queriedData}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"full-width",class:_vm.getClass(column, row)},[(_vm.getClass(column, row) != '')?_c('strong',[_vm._v(_vm._s(_vm.formatearPesosColombianos(row[column.prop])))]):_c('span',[_vm._v(_vm._s(row[column.prop]))])])]}}],null,true)})}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-simple btn-danger btn-icon like",on:{"click":function($event){return _vm.deleteDiscart(props.row)}}},[_c('i',{staticClass:"ti-trash"})])])]}}],null,false,3707133451)})],2)],1)]):_vm._e(),_vm._v(" "),_c('modal',{attrs:{"name":"registrar-descarte","scrollable":true,"height":"auto","reset":true}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('strong',{staticClass:"titulo-modal"},[_vm._v(" REGISTRAR UN DESCARGO ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"grey"}},[_vm._v(" Asignación de descartes ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.newDiscard()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"terapeuta"}},[_vm._v("Terapeuta:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.terapeuta),expression:"terapeuta"}],staticClass:"form-control",attrs:{"name":"terapeuta","id":"terapeuta","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.terapeuta=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("seleccione...")]),_vm._v(" "),_vm._l((_vm.arrayTerapeutas),function(usuario){return _c('option',{key:usuario.id,domProps:{"value":usuario.id}},[_vm._v("\n                      "+_vm._s(usuario.nombres)+" "+_vm._s(usuario.apellidos)+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"valor"}},[_vm._v("Valor del descarte:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valor),expression:"valor"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valor=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"concepto"}},[_vm._v("Seleccione el concepto:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.concepto),expression:"concepto"}],staticClass:"form-control",attrs:{"name":"concepto","id":"concepto","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.concepto=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"Informe atrasado"}},[_vm._v("\n                    Entrega de informe atrasado\n                  ")]),_vm._v(" "),_c('option',{attrs:{"value":"Objetivos y logros"}},[_vm._v("\n                    Calificación de objetivos y logros\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"nota"}},[_vm._v("Nota (opcional):")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.nota),expression:"nota"}],staticClass:"form-control",attrs:{"name":"nota","id":"nota","cols":"30","rows":"2"},domProps:{"value":(_vm.nota)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nota=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('center',[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.cerrarModal()}}},[_vm._v("\n                    Cancelar\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit"}},[_vm._v("\n                      Registrar descarte\n                  ")])])],1)])])])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Gestión de deducciones en avanza")]),_vm._v(" "),_c('p',[_vm._v("\n            Aquí podrá gestionar la información relacionada con las\n            "),_c('span',{staticClass:"text-success"},[_vm._v("deducciones")]),_vm._v(" de los empleados de\n            "),_c('span',{staticClass:"text-success"},[_vm._v("Avanza")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RuiY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card",staticStyle:{"padding":"5px 10px 5px","border-radius":"10px"}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('strong',{staticStyle:{"font-size":"20px"}},[_vm._v("Información de los gastos")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"darkgray"}},[_vm._v("Listado de todos los gastos que corresponden a estas fechas")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"darkgray"}},[_vm._v("Resumen de los gatos: "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.resumenGastos))])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"max-height":"400px","overflow":"scroll","overflow-x":"hidden"}},[_c('div',{staticClass:"row"},_vm._l((_vm.informacionGastos),function(gasto){return _c('div',{key:gasto.id,staticClass:"col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"border":"1px darkgray solid"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(gasto.valor))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("MONTO")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('strong',[_vm._v(" "+_vm._s(gasto.fecha != null ? gasto.fecha  : 'N/A'))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("FECHA")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('strong',[_vm._v(" "+_vm._s(gasto.usuario != null ? gasto.usuario : 'N/A'))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("USUARIO")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('strong',[_vm._v(" "+_vm._s(gasto.categoria))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("CATEGORIA")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v(" "+_vm._s(gasto.concepto))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("COMENTARIO")])])])])])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RzCZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S6tD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SpjM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      criterio: "PacApe1",
      buscar: true,
      arrayPacientes: [],
      busqueda: "",
      ip: "https://avanti-erp.com/",
      nombre: "",
      documento: "",
      pacIde: "",
      alertTipoCliente: false,
      numeroAutorizacion: '',
      fechaExpedicion: '',
      numeroOrden: '',
      numeroContrato: '',
      cliente: '',
      formaPago: '',
      bolsa: 0,
      periodo: '',
      observaciones: '',
      arrayCantidad: [],
      arrayEspecialidad: [],
      fechaVencimientoAutorizacion: '',
      cobertura: '',
      especialidad: [],
      cantidad: '',
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      }

    };
  },

  methods: {
    eliminarServicio: function eliminarServicio(index, fila) {
      this.arrayCantidad.splice(index, 1);
      this.bolsa = this.bolsa - parseInt(fila.cantidad);
      console.log('Bolsa', this.bolsa);
    },
    buscarPacientes: function buscarPacientes() {
      var _this = this;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      this.arrayPacientes = [];
      var vm = this;
      var url = this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        vm.arrayPacientes = response.data.data;
        _this.buscar = false;
        console.log(response.data.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    seleccionarPaciente: function seleccionarPaciente(paciente) {
      var _this2 = this;

      if (paciente.TipCliCod != localStorage.getItem("tipoClienteIngreso")) {
        var alerta = confirm('El tipo de cliente de este paciente, no concuerta con el modulo seleccionado, ¿desea continuar?');
        if (alerta == true) {
          this.buscar = true;
          this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
          this.documento = paciente.PacNumDoc;
          this.pacIde = paciente.PacIdeUsu;
          this.alertTipoCliente = true;

          setTimeout(function () {
            _this2.cargarOrdenes();
          }, 1000);
        }
      } else {
        this.buscar = true;
        this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
        this.documento = paciente.PacNumDoc;
        this.pacIde = paciente.PacIdeUsu;
        this.alertTipoCliente = false;

        setTimeout(function () {
          _this2.cargarOrdenes();
        }, 1000);
      }
    },
    generarCodigo: function generarCodigo() {
      this.numeroAutorizacion = 'CON-' + this.pacIde + '-' + this.fechaExpedicion;
    },
    selectEspecialidad: function selectEspecialidad() {
      var _this3 = this;

      var token = localStorage.getItem('token');
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/selectEspecialidad";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data.data;
        _this3.arrayEspecialidad = respuesta;
      }).catch(function (error) {
        console.log(error);
      });
    },
    agregarServicios: function agregarServicios() {
      if (this.especialidad != "" && this.cantidad != "") {
        this.arrayCantidad.push({
          servicio: this.especialidad,
          cantidad: this.cantidad
        });

        this.bolsa = parseInt(this.bolsa) + parseInt(this.cantidad);

        this.cantidad = "";
        this.especialidad = "";
      }
    },
    nuevaParticular: function nuevaParticular() {
      var _this4 = this;

      if (this.bolsa == 0) {
        alert('Debe cargar servicios a la autorización');
      } else {
        this.calcularFecha();
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        };
        var url = this.ip + 'api/nuevoParticular';
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
          paciente: this.pacIde,
          codigo: this.numeroAutorizacion,
          servicio: 'convenio',
          entidad: 16,
          fecha: this.fechaExpedicion,
          cobertura: this.cobertura,
          fechaVencimiento: this.fechaVencimientoAutorizacion,
          formato: 3,
          nombre_cliente: this.nombre_cliente,
          servicios: this.arrayCantidad,
          bolsa: this.bolsa,
          usuario: localStorage.getItem("usuario")
        }, config).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this4.$notify({
            component: {
              template: "<span>!<b> Servicio registrado con \xE9xito!</b>.</span>"
            },
            icon: 'ti-check',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: _this4.type[color]
          });
          _this4.pacIde = '';
          _this4.fechaExpedicion = '';
          _this4.numeroAutorizacion = '';
          _this4.cobertura = '';
          _this4.fechaVencimientoAutorizacion = '';
          _this4.nombre_cliente = '';
          _this4.periodo = '';
          _this4.formaPago = '';
          _this4.numeroContrato = '';
          _this4.observaciones = '';
          _this4.arrayCantidad = [];
          _this4.bolsa = 0;
          _this4.cerrar();
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    calcularFecha: function calcularFecha() {
      var dias = parseInt(this.cobertura);
      var fechaInicio = new Date(this.fechaExpedicion);
      fechaInicio.setDate(fechaInicio.getDate() + dias);

      var fechaFin = new Date(fechaInicio);

      var dia = fechaFin.getDate();
      var mes = fechaFin.getMonth() + 1;
      var ano = fechaFin.getFullYear();
      var cero = "0";

      if (dia < 10) {
        dia = '0' + dia;
      }
      if (mes < 10) {
        mes = '0' + mes;
      }
      this.fechaVencimientoAutorizacion = ano + '-' + mes + '-' + dia;
    },
    cerrar: function cerrar() {
      this.$modal.hide('ingreso_servicio');
    }
  },
  mounted: function mounted() {
    this.selectEspecialidad();
  }
});

/***/ }),

/***/ "Suhd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardPacientes_vue__ = __webpack_require__("1NcW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e8d5974_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardPacientes_vue__ = __webpack_require__("whLi");
function injectStyle (ssrContext) {
  __webpack_require__("VY9H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e8d5974"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardPacientes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e8d5974_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardPacientes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SwSL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_switches__ = __webpack_require__("lqen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_rocker_switch__ = __webpack_require__("L2Mo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_rocker_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_rocker_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_rocker_switch_dist_vue_rocker_switch_css__ = __webpack_require__("0CPQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_rocker_switch_dist_vue_rocker_switch_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_rocker_switch_dist_vue_rocker_switch_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);



















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.pacientes.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.pacientes.length;
        return this.pagedData;
      }
      var result = this.pacientes.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.pacientes.length;
      return this.pacientes.length;
    }
  },
  data: function data() {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      searchQuery: "",
      ver: 1,
      propsToSearch: ["PacNom1", "PacApe1", "PacNumDoc", "PacFecNac", "PacFecIng"],
      tableColumns: [{
        prop: "PacNom1",
        label: "Nombres",
        minWidth: 150 }, {
        prop: "PacApe1",
        label: "Apellidos",
        minWidth: 150 }, {
        prop: "PacNumDoc",
        label: "Número de documento",
        minWidth: 150
      }, {
        prop: "PacFecNac",
        label: "Fecha de nacimiento",
        minWidth: 150
      }, {
        prop: "PacFecIng",
        label: "Fecha de ingreso",
        minWidth: 120
      }],
      ip: "https://avanti-erp.com",
      pacientes: [],
      PacIde: 0,
      informacionPaciente: [],
      rol: '',

      pacientesActivos: 0,
      pacientesInactivos: 0,
      totalPacientes: 0,
      fisio: "",
      fono: "",
      teo: "",
      edu: "",
      psico: "",
      block: false,
      terapeutasFisio: [],
      terapeutasTeo: [],
      terapeutasFono: [],
      terapeutasPsico: [],
      terapeutasEdu: [],
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      json_fields: {
        "Nombres del paciente": "paciente",
        "Numero documento": "documento",
        "Fecha nacimiento": 'fecha_nacimiento',
        "Fecha ingreso": "fecha_ingreso",
        "Lider Fisioterapia": "terapeutaFisio",
        "Lider Fonoaudiología": "terapeutaFono",
        "Lider Psicología": "terapeutaPsico",
        "Lider Terapia ocupacional": "terapeutaTeo",
        "Lider Educación Especial": "terapeutaEdu",
        "estado": "estado"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]]
    };
  },

  components: {
    Switches: __WEBPACK_IMPORTED_MODULE_11_vue_switches__["a" /* default */],
    rockerswitch: __WEBPACK_IMPORTED_MODULE_12_vue_rocker_switch___default.a,
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  methods: {
    actualizarEstado: function actualizarEstado(id, estado) {
      var _this2 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/actualizarEstado";
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(BASE_URL, {
        id: id,
        estado: estado
      }, config).then(function (res) {
        console.log(res.data);
        alert("Estado del usuario actualizado con éxito");
        _this2.cargarPacientes();
      }).catch(function (err) {
        console.log(err);
        alert("Error en el servidor, intentelo de nuevo");
      });
    },
    modal: function modal(index, paciente) {
      this.$modal.show("buscar");
      this.PacIde = paciente.PacIdeUsu;
      this.fisio = paciente.t_fisio;
      this.fono = paciente.t_fono;
      this.teo = paciente.t_teo;
      this.psico = paciente.t_psico;
      this.edu = paciente.t_edu;
      this.block = paciente.PacBlo;
    },
    modalDetallePaciente: function modalDetallePaciente(paciente) {
      var _this3 = this;

      this.informacionPaciente = [];
      this.$modal.show("modalDetallePaciente");
      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "/api/pacienteHC/" + paciente.PacIdeUsu,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this3.informacionPaciente = response.data.data;
        console.log(_this3.informacionPaciente, "datos");
      }).catch(function (err) {
        console.log(err);
      });
    },
    cerrar_modal: function cerrar_modal(index, paciente) {
      this.$modal.hide("buscar");
      this.PacIde = "";
    },

    t_fisio: function t_fisio() {
      var _this4 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var rol = localStorage.getItem('rol');
      var sede = 'todas';
      if (rol > 1) {
        sede = localStorage.getItem('sede');
      }
      var url = this.ip + "/api/terapeutas/2/" + sede;
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(url, config).then(function (response) {
        _this4.terapeutasFisio = response.data.data;
      }).catch(function (error) {
        console.log();
      });
    },
    t_teo: function t_teo() {
      var _this5 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var rol = localStorage.getItem('rol');
      var sede = 'todas';
      if (rol > 1) {
        sede = localStorage.getItem('sede');
      }
      var url = this.ip + "/api/terapeutas/4/" + sede;
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(url, config).then(function (response) {
        _this5.terapeutasTeo = response.data.data;
      }).catch(function (error) {
        console.log();
      });
    },
    t_fono: function t_fono() {
      var _this6 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var rol = localStorage.getItem('rol');
      var sede = 'todas';
      if (rol > 1) {
        sede = localStorage.getItem('sede');
      }
      var url = this.ip + "/api/terapeutas/3/" + sede;
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(url, config).then(function (response) {
        _this6.terapeutasFono = response.data.data;
      }).catch(function (error) {
        console.log();
      });
    },
    t_psico: function t_psico() {
      var _this7 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var rol = localStorage.getItem('rol');
      var sede = 'todas';
      if (rol > 1) {
        sede = localStorage.getItem('sede');
      }
      var url = this.ip + "/api/terapeutas/6/" + sede;
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(url, config).then(function (response) {
        _this7.terapeutasPsico = response.data.data;
      }).catch(function (error) {
        console.log();
      });
    },
    t_edu: function t_edu() {
      var _this8 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var rol = localStorage.getItem('rol');
      var sede = 'todas';
      if (rol > 1) {
        sede = localStorage.getItem('sede');
      }
      var url = this.ip + "/api/terapeutas/5/" + sede;
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(url, config).then(function (response) {
        _this8.terapeutasEdu = response.data.data;
      }).catch(function (error) {
        console.log();
      });
    },
    asignar_lideres: function asignar_lideres() {
      var _this9 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "/api/asignarLideres";
      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(url, {
        paciente: this.PacIde,
        lider_fisio: this.fisio,
        lider_fono: this.fono,
        lider_teo: this.teo,
        lider_psi: this.psico,
        lider_edu: this.edu,
        block: this.block
      }, config).then(function (response) {
        _this9.$modal.hide("buscar");
        var color = Math.floor(Math.random() * 4 + 1);
        _this9.$notify({
          component: {
            template: "<span><b>Lideres actualizados con \xE9xito!</b>.</span>"
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this9.type[color]
        });
        _this9.cargarPacientes();
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleEdit: function handleEdit(index, row) {
      alert("Your want to edit " + row.name);
    },
    handleDelete: function handleDelete(index, row) {
      var indexToDelete = this.pacientes.findIndex(function (tableRow) {
        return tableRow.id === row.id;
      });
      if (indexToDelete >= 0) {
        this.pacientes.splice(indexToDelete, 1);
      }
    },
    valueWithState: function valueWithState(arr, state) {
      var acu = 0;
      for (var index = 0; index < arr.length; index++) {
        if (arr[index].estado == state) {
          acu = acu + 1;
        }
      }
      return acu;
    },
    cargarPacientes: function cargarPacientes() {
      var _this10 = this;

      this.json_data = [];
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };

      var rol = localStorage.getItem('rol');
      var sede = 'todas';
      if (rol > 1) {
        sede = localStorage.getItem('sede');
      }
      var url = this.ip + "/api/allPacientes/" + this.ver + "/" + sede;

      __WEBPACK_IMPORTED_MODULE_15_axios___default.a.get(url, config).then(function (response) {
        var datos = [];
        _this10.pacientes = response.data.data;
        _this10.pacientesActivos = _this10.valueWithState(response.data.estadistica, 1);
        _this10.pacientesInactivos = _this10.valueWithState(response.data.estadistica, 0);
        _this10.totalPacientes = response.data.estadistica.length;

        for (var index = 0; index < response.data.data.length; index++) {
          var estado = '';

          if (response.data.data[index].estado == 1) {
            estado = 'Activo';
          } else {
            estado = 'Inactivo';
          }

          datos.push({
            paciente: response.data.data[index].PacApe1 + ' ' + response.data.data[index].PacNom1,
            documento: response.data.data[index].PacNumDoc,
            fecha_nacimiento: response.data.data[index].PacFecNac,
            fecha_ingreso: response.data.data[index].PacFecIng,
            estado: estado,
            terapeutaFisio: response.data.data[index].t_fisio,
            terapeutaFono: response.data.data[index].t_fono,
            terapeutaTeo: response.data.data[index].t_teo,
            terapeutaPsico: response.data.data[index].t_psico,
            terapeutaEdu: response.data.data[index].t_edu
          });
        }

        _this10.json_data = datos;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.cargarPacientes();
      this.t_fisio();
      this.t_fono();
      this.t_psico();
      this.t_edu();
      this.t_teo();
      this.rol = localStorage.getItem("rol");
    }
  }
});

/***/ }),

/***/ "SzsE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fecha_inicial: "",
      fecha_final: "",
      ip: "https://avanti-erp.com/api/",
      autorizaciones: [],
      fechaActual: "",
      rol: localStorage.getItem('rol'),
      sede: 'Sede Principal',
      SedesProgramacion: [],

      tableColumns: [{
        prop: "codigo",
        label: "Codigo",
        minWidth: 150 }, {
        prop: "paciente",
        label: "Paciente",
        minWidth: 160 }, {
        prop: "entidad",
        label: "Entidad"
      }, {
        prop: "bolsa",
        label: "Saldo en bolsa",
        minWidth: 100
      }, {
        prop: "vencimiento",
        label: "Vencimiento",
        minWidth: 130
      }, {
        prop: "orden",
        label: "Orden medica",
        minWidth: 150
      }, {
        prop: "ordenVencimiento",
        label: "Vencimiento de la orden",
        minWidth: 150
      }],

      json_fields: {
        "Nombres del paciente": "paciente",

        "autorizacion": "codigo",
        "Entidad": 'entidad',
        "saldo en bolsa": "bolsa",
        "Fecha vencimiento": "vencimientoExcel",
        "orden": "orden",
        "vencimiento orden": "ordenVencimientoExcel"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]]
    };
  },
  methods: {
    getAutorizaciones: function getAutorizaciones() {
      var _this = this;

      if (this.fecha_inicial == '' || this.fecha_final == '') {
        alert('ERROR: Faltan fechas por seleccionar');
        return;
      }
      this.autorizaciones = [];
      this.$modal.show('carga');
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var sede = this.rol == 1 ? this.sede : localStorage.getItem('sede');
      var BASE_URL = this.ip + "autorizacionesVencimiento/fechainicial=" + this.fecha_inicial + "/fechafinal=" + this.fecha_final + "/sede=" + sede;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(BASE_URL, config).then(function (res) {
        var datos = res.data.data;
        var autorizaciones = [];
        datos.forEach(function (element) {
          var orden_medica = "";
          if (element.OrdPer != 1) {
            orden_medica = element.OrdPer;
          } else {
            orden_medica = "Autorización sin orden";
          }
          autorizaciones.push({
            codigo: element.OrdCod,
            paciente: element.PacApe1 + ' ' + element.PacNom1,
            bolsa: element.OrdBol,
            entidad: element.EpsNom,
            vencimiento: element.OrdVen,
            vencimientoExcel: element.OrdVen,
            orden: orden_medica,
            ordenVencimiento: element.OrdMedVen,
            ordenVencimientoExcel: element.OrdMedVen
          });
        });
        _this.autorizaciones = autorizaciones;
        _this.json_data = autorizaciones;
        _this.$modal.hide('carga');
      }).catch(function (err) {
        console.log(err);
        _this.$modal.hide('carga');
      });
    },
    calcularVencimiento: function calcularVencimiento(fecha) {

      if (fecha == "Sin orden") {
        return "Autorización sin orden";
      } else {
        var fechaini = new Date(this.fechaActual);
        var fechafin = new Date(fecha);
        var diasdif = fechafin.getTime() - fechaini.getTime();
        var contdias = Math.round(diasdif / (1000 * 60 * 60 * 24));


        if (contdias == 0) {
          return "Vence hoy";
        } else if (contdias < 0) {
          return "Vencida";
        } else {
          return "Fatan " + contdias + " dia(s) para su vencimiento";
        }
      }
    },
    calcularFechaActual: function calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }

        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },


    emailsProgramacion: function emailsProgramacion() {
      var _this2 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "emailsProgramacion";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this2.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    this.calcularFechaActual();
    this.emailsProgramacion();
  }
});

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Pages_Login_vue__ = __webpack_require__("WI53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Admisiones_Ingreso_vue__ = __webpack_require__("0dmy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Admisiones_ingresoServicios_vue__ = __webpack_require__("xwzm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Admisiones_pacientes_registrados_vue__ = __webpack_require__("z0cy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Historia_Clinica_historia_clinica_vue__ = __webpack_require__("I4Gl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Historia_Clinica_historia_clinica_movil_vue__ = __webpack_require__("T6ty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Mantenimiento_mantenimiento_eps_vue__ = __webpack_require__("Wq91");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Mantenimiento_mantenimiento_patologias_vue__ = __webpack_require__("CsLv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Mantenimiento_mantenimiento_motivo_consulta_vue__ = __webpack_require__("4tkk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Acceso_roles_vue__ = __webpack_require__("Pecg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Acceso_usuarios_vue__ = __webpack_require__("BGCZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Diario_De_Campo_evoluciones_citas_vue__ = __webpack_require__("nRoc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Diario_De_Campo_objetivos_logros_vue__ = __webpack_require__("gYgR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_ADashboard_ADashboard_vue__ = __webpack_require__("rDei");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_ADashboard_gestionOrdenes_vue__ = __webpack_require__("Iclx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_src_components_ADashboard_gestionTerapias_vue__ = __webpack_require__("eFYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_Programacion_programacion_vue__ = __webpack_require__("+tMB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_components_Programacion_cancelar_masivo_vue__ = __webpack_require__("ydfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_src_components_mantenimiento_mantenimiento_estrategias__ = __webpack_require__("rYom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_src_components_mantenimiento_mantenimiento_material__ = __webpack_require__("BRxa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_src_components_Reportes_Pacientes__ = __webpack_require__("LtqI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_Reportes_Ordenes__ = __webpack_require__("xuNr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_src_components_Reportes_MaestroV2__ = __webpack_require__("kunQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_src_components_Reportes_Autorizaciones__ = __webpack_require__("Yncg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_src_components_Reportes_InformeEvolucion__ = __webpack_require__("xMf4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_src_components_Reportes_Programacion__ = __webpack_require__("+Hhe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_src_components_Reportes_Objetivos__ = __webpack_require__("TGjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_src_components_Reportes_evolucionesSinLogro_vue__ = __webpack_require__("Unav");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_src_components_Reportes_logInformes_vue__ = __webpack_require__("lHnL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_src_components_Reportes_valoraciones_vue__ = __webpack_require__("ipIU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_src_components_Reportes_sesionesTerapeutas_vue__ = __webpack_require__("hLLX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_src_components_Reportes_dashboardPacientes_vue__ = __webpack_require__("Suhd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Reportes_asistenciaUsuario_vue__ = __webpack_require__("2VOs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Reportes_informeSesiones_vue__ = __webpack_require__("78iL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Reportes_informeAutorizaciones_vue__ = __webpack_require__("ka1j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Reportes_objetivosLogros_vue__ = __webpack_require__("ppsA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_src_components_ADashboard_miEspacio_vue__ = __webpack_require__("DlrF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_src_components_ADashboard_miEspacioAdmin__ = __webpack_require__("2k/A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_src_components_ADashboard_salarios_vue__ = __webpack_require__("Mu0F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_src_components_ADashboard_tarifas_vue__ = __webpack_require__("QmWa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_src_components_ADashboard_descargos_vue__ = __webpack_require__("amSi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_src_components_ADashboard_gastosFijos_vue__ = __webpack_require__("0b5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_src_components_ADashboard_dashboardNomina_vue__ = __webpack_require__("F5ab");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_src_components_ADashboard_gastosVariables_vue__ = __webpack_require__("Grcq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_src_components_ADashboard_copagos_vue__ = __webpack_require__("Cs8e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Reportes_reporteFacturacion_vue__ = __webpack_require__("kQnT");
























































var routes = [{
  path: "/",
  component: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Pages_Login_vue__["a" /* default */],
  redirect: "/login"
}, {
  path: "/login",
  component: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Pages_Login_vue__["a" /* default */],
  redirect: "/login",
  children: [{
    path: "/login",
    component: __WEBPACK_IMPORTED_MODULE_1_src_components_Dashboard_Views_Pages_Login_vue__["a" /* default */]
  }]
}, {
  path: "/dashboard",
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: "/dashboard/avanti",
  children: [{
    path: "/dashboard/avanti",
    name: "DashBoard",
    component: __WEBPACK_IMPORTED_MODULE_14_src_components_ADashboard_ADashboard_vue__["a" /* default */]
  }, {
    path: "/gestion-ordenes",
    name: "Gestión de autorizaciones",
    component: __WEBPACK_IMPORTED_MODULE_15_src_components_ADashboard_gestionOrdenes_vue__["a" /* default */]
  }, {
    path: "/mi-espacio",
    name: "Bienvenido a Mi Espacio",
    component: __WEBPACK_IMPORTED_MODULE_37_src_components_ADashboard_miEspacio_vue__["a" /* default */]
  }, {
    path: "/mi-espacio-admin",
    name: "Dashboard terapeutas",
    component: __WEBPACK_IMPORTED_MODULE_38_src_components_ADashboard_miEspacioAdmin__["a" /* default */]
  }, {
    path: "/gestion-terapias",
    name: "Gestión de terapias",
    component: __WEBPACK_IMPORTED_MODULE_16_src_components_ADashboard_gestionTerapias_vue__["a" /* default */]
  }, {
    path: "/ajustar-salarios",
    name: "Gestión de Salarios",
    component: __WEBPACK_IMPORTED_MODULE_39_src_components_ADashboard_salarios_vue__["a" /* default */]
  }, {
    path: "/ajustar-tarifas",
    name: "Gestión de tarifas",
    component: __WEBPACK_IMPORTED_MODULE_40_src_components_ADashboard_tarifas_vue__["a" /* default */]
  }, {
    path: "/descargos",
    name: "Gestión de deducciones",
    component: __WEBPACK_IMPORTED_MODULE_41_src_components_ADashboard_descargos_vue__["a" /* default */]
  }, {
    path: "/gastos-fijos",
    name: "Gestión de gastos fijos",
    component: __WEBPACK_IMPORTED_MODULE_42_src_components_ADashboard_gastosFijos_vue__["a" /* default */]
  }, {
    path: "/dashboard-nomina",
    name: "Gestión de ingresos y egresos",
    component: __WEBPACK_IMPORTED_MODULE_43_src_components_ADashboard_dashboardNomina_vue__["a" /* default */]
  }, {
    path: "/gastos-variables",
    name: "Gestión de gastos por fechas",
    component: __WEBPACK_IMPORTED_MODULE_44_src_components_ADashboard_gastosVariables_vue__["a" /* default */]
  }]
}, {
  path: "/admisiones",
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: "/admisiones/ingreso",
  children: [{
    path: "ingreso",
    name: "Ingreso de pacientes",
    component: __WEBPACK_IMPORTED_MODULE_2_src_components_Admisiones_Ingreso_vue__["a" /* default */]
  }, {
    path: "pacientes",
    name: "Pacientes Registrados",
    component: __WEBPACK_IMPORTED_MODULE_4_src_components_Admisiones_pacientes_registrados_vue__["a" /* default */]
  }, {
    path: "servicios",
    name: "Ingreso de servicios",
    component: __WEBPACK_IMPORTED_MODULE_3_src_components_Admisiones_ingresoServicios_vue__["a" /* default */]
  }, {
    path: "/copagos",
    name: "Gestión de copagos",
    component: __WEBPACK_IMPORTED_MODULE_45_src_components_ADashboard_copagos_vue__["a" /* default */]
  }]
}, {
  path: "/historiaClinica",
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: "/historiaClinica/historia",
  children: [{
    path: "historia",
    name: "Historia Clínica",
    component: __WEBPACK_IMPORTED_MODULE_5_src_components_Historia_Clinica_historia_clinica_vue__["a" /* default */]
  }, {
    path: "historia-movil",
    name: "Historia Clínica Movil",
    component: __WEBPACK_IMPORTED_MODULE_6_src_components_Historia_Clinica_historia_clinica_movil_vue__["a" /* default */]
  }]
}, {
  path: "/mantenimiento",
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: "/mantenimiento/mantenimientoEps",
  children: [{
    path: "mantenimientoEps",
    name: "Mantenimiento EPS",
    component: __WEBPACK_IMPORTED_MODULE_7_src_components_Mantenimiento_mantenimiento_eps_vue__["a" /* default */]
  }, {
    path: "mantenimientoPatologias",
    name: "Mantenimiento Patologías",
    component: __WEBPACK_IMPORTED_MODULE_8_src_components_Mantenimiento_mantenimiento_patologias_vue__["a" /* default */]
  }, {
    path: "mantenimientoMc",
    name: "Mantenimiento Motivos de Consulta",
    component: __WEBPACK_IMPORTED_MODULE_9_src_components_Mantenimiento_mantenimiento_motivo_consulta_vue__["a" /* default */]
  }, {
    path: "mantenimientoEs",
    name: "Mantenimiento Estrategías Ter.",
    component: __WEBPACK_IMPORTED_MODULE_19_src_components_mantenimiento_mantenimiento_estrategias__["a" /* default */]
  }, {
    path: "mantenimientoMat",
    name: "Mantenimiento Material de apoyo",
    component: __WEBPACK_IMPORTED_MODULE_20_src_components_mantenimiento_mantenimiento_material__["a" /* default */]
  }]
}, {
  path: "/acceso",
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: "/acceso/usuario",
  children: [{
    path: "usuario",
    name: "Usuario",
    component: __WEBPACK_IMPORTED_MODULE_11_src_components_Acceso_usuarios_vue__["a" /* default */]
  }, {
    path: "roles",
    name: "Roles",
    component: __WEBPACK_IMPORTED_MODULE_10_src_components_Acceso_roles_vue__["a" /* default */]
  }]
}, {
  path: "/diarioCampo",
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: "/diarioCampo/evoluciones",
  children: [{
    path: "evoluciones",
    name: "Evoluciones",
    component: __WEBPACK_IMPORTED_MODULE_12_src_components_Diario_De_Campo_evoluciones_citas_vue__["a" /* default */]
  }, {
    path: "objetivos-y-logros",
    name: "Objetivos y Logros",
    component: __WEBPACK_IMPORTED_MODULE_13_src_components_Diario_De_Campo_objetivos_logros_vue__["a" /* default */]
  }]
}, {
  path: "/programacion",
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: "/programacion/programacion-citas",
  children: [{
    path: "programacion-citas",
    name: "Programar Citas Médicas",
    component: __WEBPACK_IMPORTED_MODULE_17_src_components_Programacion_programacion_vue__["a" /* default */]
  }, {
    path: "cancelar-masivo",
    name: "Cancelar citas masivamente",
    component: __WEBPACK_IMPORTED_MODULE_18_src_components_Programacion_cancelar_masivo_vue__["a" /* default */]
  }]
}, {
  path: "/reportes",
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
  redirect: "/reportes/pacientes",
  children: [{
    path: "pacientes",
    name: "Reporte de pacientes",
    component: __WEBPACK_IMPORTED_MODULE_21_src_components_Reportes_Pacientes__["a" /* default */]
  }, {
    path: "ordenes",
    name: "Consolidado de ordenes medicas",
    component: __WEBPACK_IMPORTED_MODULE_22_src_components_Reportes_Ordenes__["a" /* default */]
  }, {
    path: "maestro",
    name: "Reporte maestro",
    component: __WEBPACK_IMPORTED_MODULE_23_src_components_Reportes_MaestroV2__["a" /* default */]
  }, {
    path: "autorizaciones",
    name: "Reporte de autorizaciones",
    component: __WEBPACK_IMPORTED_MODULE_24_src_components_Reportes_Autorizaciones__["a" /* default */]
  }, {
    path: "informeEvolucion",
    name: "Informes",
    component: __WEBPACK_IMPORTED_MODULE_25_src_components_Reportes_InformeEvolucion__["a" /* default */]
  }, {
    path: "cancelaciones",
    name: "Reporte de cancelaciones",
    component: __WEBPACK_IMPORTED_MODULE_26_src_components_Reportes_Programacion__["a" /* default */]
  }, {
    path: "objetivos-y-logros",
    name: "Reporte de objetivos y logros",
    component: __WEBPACK_IMPORTED_MODULE_27_src_components_Reportes_Objetivos__["a" /* default */]
  }, {
    path: "asistencia-usuarios",
    name: "Asistencia por usuarios",
    component: __WEBPACK_IMPORTED_MODULE_33__components_Reportes_asistenciaUsuario_vue__["a" /* default */]
  }, {
    path: "asistencia-por-fecha",
    name: "Asistencia por fecha",
    component: __WEBPACK_IMPORTED_MODULE_34__components_Reportes_informeSesiones_vue__["a" /* default */]
  }, {
    path: "informe-autorizaciones",
    name: "Informe de autorizaciones",
    component: __WEBPACK_IMPORTED_MODULE_35__components_Reportes_informeAutorizaciones_vue__["a" /* default */]
  }, {
    path: "objetivos-logros",
    name: "Reporte de objetivos y logros",
    component: __WEBPACK_IMPORTED_MODULE_36__components_Reportes_objetivosLogros_vue__["a" /* default */]
  }, {
    path: "evoluciones-sin-logro",
    name: "Reporte de evoluciones sin logro de objetivo",
    component: __WEBPACK_IMPORTED_MODULE_28_src_components_Reportes_evolucionesSinLogro_vue__["a" /* default */]
  }, {
    path: "registro-informes",
    name: "Informes entregados a pacientes",
    component: __WEBPACK_IMPORTED_MODULE_29_src_components_Reportes_logInformes_vue__["a" /* default */]
  }, {
    path: "valoraciones",
    name: "Valoraciones",
    component: __WEBPACK_IMPORTED_MODULE_30_src_components_Reportes_valoraciones_vue__["a" /* default */]
  }, {
    path: "sesiones-terapeuticas",
    name: "Sesiones Terapéuticas",
    component: __WEBPACK_IMPORTED_MODULE_31_src_components_Reportes_sesionesTerapeutas_vue__["a" /* default */]
  }, {
    path: "dashboard-pacientes",
    name: "Dashboard Pacientes",
    component: __WEBPACK_IMPORTED_MODULE_32_src_components_Reportes_dashboardPacientes_vue__["a" /* default */]
  }, {
    path: "reporte-facturacion",
    name: "Reporte para facturacion",
    component: __WEBPACK_IMPORTED_MODULE_46__components_Reportes_reporteFacturacion_vue__["a" /* default */]
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "T353":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.abrirModal()}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Nueva EPS\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",staticStyle:{"width":"220%"},attrs:{"type":"search","placeholder":"Buscar eps...","aria-controls":"datatables"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"else":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":100,"fixed":"right","label":"Estado"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.EpsEst == 1)?_c('p',[_vm._v("activa")]):_c('p',[_vm._v("Inactiva")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"fixed":"right","label":"Rango"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.EpsTip == 1)?_c('p',{staticClass:"label label-warning",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n                EPS\n              ")]):(props.row.EpsTip == 2)?_c('p',{staticClass:"label label-success",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n                Prepagada\n              ")]):_c('p',{staticClass:"label label-info",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("Poliza")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"fixed":"right","label":"Régimen"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.EpsReg == 1)?_c('span',{staticClass:"label label-warning",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n                Contributivo\n              ")]):(props.row.EpsReg == 2)?_c('span',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n                Subsidiado\n              ")]):_c('span',{staticClass:"label label-success",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n                Contributivo y Subsidiado\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"fixed":"right","label":"Acc"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.EpsEst == 2)?_c('button',{staticClass:"btn btn-simple btn-xs btn-info btn-icon check",on:{"click":function($event){return _vm.activar(props.row)}}},[_c('i',{staticClass:"ti-check"})]):_c('button',{staticClass:"btn btn-simple btn-xs btn-warning btn-icon edit",on:{"click":function($event){return _vm.desactivar(props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n          Mostrando del "+_vm._s(_vm.from + 1)+" al "+_vm._s(_vm.to)+" de "+_vm._s(_vm.total)+" registros\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"modal fade",class:{ mostrar: _vm.modalRegistrar },attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.agregarEntidad.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-xs-12"},[_c('label',{attrs:{"for":""}},[_vm._v("NIT:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nit),expression:"nit"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.nit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nit=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xs-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombreEps),expression:"nombreEps"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.nombreEps)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombreEps=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre corto:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombreCorto),expression:"nombreCorto"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.nombreCorto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombreCorto=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticStyle:{"padding-top":"11px"},attrs:{"for":""}},[_vm._v("Tipo:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"1","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"1")},on:{"change":function($event){_vm.tipo="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("EPS")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"2","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"2")},on:{"change":function($event){_vm.tipo="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Prepag.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"3","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"3")},on:{"change":function($event){_vm.tipo="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Póliza")])])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.tipo == 1)?_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regimen),expression:"regimen"}],attrs:{"type":"radio","value":"1"},domProps:{"checked":_vm._q(_vm.regimen,"1")},on:{"change":function($event){_vm.regimen="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Contri.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regimen),expression:"regimen"}],attrs:{"type":"radio","value":"2"},domProps:{"checked":_vm._q(_vm.regimen,"2")},on:{"change":function($event){_vm.regimen="2"}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Subsi.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regimen),expression:"regimen"}],attrs:{"type":"radio","value":"3"},domProps:{"checked":_vm._q(_vm.regimen,"3")},on:{"change":function($event){_vm.regimen="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Ambos")])])]):_vm._e()])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar Entidad\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.limpiarFormulario()}}},[_c('i',{staticClass:"fa fa-history"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.modalRegistrar = 0}}},[_vm._v("\n                Cancelar\n              ")])])],1)]),_vm._v(" "),_c('center'),_vm._v(" "),_c('br')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"title"},[_vm._v("Listado de eps registradas en el sistema")]),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header CM",staticStyle:{"padding":"8px"}},[_c('strong',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v("\n            Nueva EPS\n          ")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Régimen:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T54D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("v2o3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_434f2c6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("DOeu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_434f2c6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T6ty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_historia_clinica_movil_vue__ = __webpack_require__("pgSd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d79b08c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_historia_clinica_movil_vue__ = __webpack_require__("O791");
function injectStyle (ssrContext) {
  __webpack_require__("S6tD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d79b08c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_historia_clinica_movil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d79b08c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_historia_clinica_movil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TGjf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Objetivos_vue__ = __webpack_require__("KMJO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cd85ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Objetivos_vue__ = __webpack_require__("47VP");
function injectStyle (ssrContext) {
  __webpack_require__("WCJm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25cd85ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Objetivos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cd85ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Objetivos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_SidebarPlugin_UserMenu_vue__ = __webpack_require__("ij53");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__ = __webpack_require__("BNE1");








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
    ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
    DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
    UserMenu: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_SidebarPlugin_UserMenu_vue__["a" /* default */],
    MobileMenu: __WEBPACK_IMPORTED_MODULE_4_src_components_UIComponents_SidebarPlugin_MobileMenu_vue__["a" /* default */]
  },
  methods: {
    toggleSidebar: function toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
});

/***/ }),

/***/ "Twpb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ty35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fullcalendar_vue__ = __webpack_require__("l7UG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fullcalendar_daygrid__ = __webpack_require__("uJAD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fullcalendar_core_locales_es__ = __webpack_require__("ER/K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fullcalendar_core_locales_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__fullcalendar_core_locales_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fullcalendar_list__ = __webpack_require__("L7mJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fullcalendar_timegrid__ = __webpack_require__("U2C2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fullcalendar_interaction__ = __webpack_require__("uX+s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fullcalendar_moment__ = __webpack_require__("nAns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fullcalendar_google_calendar__ = __webpack_require__("OjwX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__global_services_fecha_actual__ = __webpack_require__("Kscm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__global_services_axiosInstance__ = __webpack_require__("t/yl");























__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip: "https://avanti-erp.com",
      agenda: true,
      arrayEventos: [],
      eventoSeleccionado: [],
      arrayEstrategiasActivos: [],
      arrayMaterialesActivos: [],
      fechaActual: "",
      requiere: false,

      evolucion: "",
      estadoPaciente: "",
      estrategia: "",

      calendarPlugins: [__WEBPACK_IMPORTED_MODULE_10__fullcalendar_daygrid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__fullcalendar_timegrid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__fullcalendar_interaction__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__fullcalendar_list__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__fullcalendar_google_calendar__["a" /* default */]],
      headers: {
        left: "prev,today,next",
        center: "",

        right: "title"
      },
      informacionEvaluacion: {
        motivos: 0,
        impresion: 0,
        plan: 0
      }
    };
  },

  methods: {
    verEvento: function verEvento(arg) {

      var EVENT = arg.event.extendedProps;
      if (EVENT.fecha > this.fechaActual) {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__["a" /* default */])("danger", "No se puede ingresar la evolución porque la fecha del evento es superior a la fecha actual"));
        return;
      }
      this.eventoSeleccionado = EVENT;
      this.agenda = false;
      if (EVENT.tipo === 'Evaluacion' && EVENT.estadoEvento === 3) {
        this.verificarRegistrosEvaluacionHistoriaClinica(EVENT.fecha, EVENT.pacienteId, EVENT.usuarioTerapeuta);
      }
    },
    verificarRegistrosEvaluacionHistoriaClinica: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fecha, paciente, terapeuta) {
        var url, response, data, motivos, planes, impresiones;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.$modal.show("carga");
                url = "/api/verificar-registros-evaluacion-historia-clinica/" + fecha + "/" + paciente + "/" + terapeuta;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_19__global_services_axiosInstance__["a" /* default */].get(url);

              case 5:
                response = _context.sent;
                data = response.data;
                motivos = data.motivos, planes = data.planes, impresiones = data.impresiones;

                this.informacionEvaluacion.motivos = motivos;
                this.informacionEvaluacion.plan = planes;
                this.informacionEvaluacion.impresion = impresiones;
                if (motivos == 0 || impresiones == 0 || planes == 0) {
                  this.mostrarModalFaltaInformacion();
                }
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__["a" /* default */])("danger", "Ocurrió un error verificando la información de la historia clinica, contacte al administrador del sistema"));
                return _context.abrupt("return");

              case 18:
                _context.prev = 18;

                this.$modal.hide("carga");
                return _context.finish(18);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 14, 18, 21]]);
      }));

      function verificarRegistrosEvaluacionHistoriaClinica(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return verificarRegistrosEvaluacionHistoriaClinica;
    }(),
    mostrarModalFaltaInformacion: function mostrarModalFaltaInformacion() {
      this.$modal.show("modalFaltaInformacion");
    },
    cerrarModalInformacionFaltante: function cerrarModalInformacionFaltante() {
      this.eventoSeleccionado = [];
      this.agenda = true;
      this.$modal.hide("modalFaltaInformacion");
      this.informacionEvaluacion = {
        motivos: 0,
        impresion: 0,
        plan: 0
      };
    },
    obtenerEventos: function obtenerEventos(tipoBusqueda) {
      var _this = this;

      var CRITERIO = tipoBusqueda === "sede" ? "programacion.sede" : "programacion.terapeuta";
      var BUSQUEDA = tipoBusqueda === "sede" ? localStorage.getItem("sede") : localStorage.getItem("usuario");
      console.log(BUSQUEDA);
      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/obtener-eventos-calendario/" + CRITERIO + "/" + BUSQUEDA;
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this.$modal.hide("carga");
        var data = res.data.data;
        var events = [];
        data.forEach(function (element) {
          if (element.tipo != "CYT") {
            events.push({
              title: element.nombrePaciente + " " + element.apellidoPaciente,

              start: element.fecha + "T" + element.horaInicio,
              end: element.fecha + "T" + element.horaFin,
              color: element.estadoEvento === 3 ? "blue" : element.estadoEvento === 2 ? "red" : "green",
              extendedProps: {
                nombreTerapeuta: element.nombreTerapeuta + " " + element.apellidoTerapeuta,
                usuarioTerapeuta: element.terapeuta,
                pacienteId: element.usuarioId,
                especialidad: element.especialidad,
                autorizacion: element.autorizacion,
                fecha: element.fecha,
                tipo: element.tipo,
                horainicio: element.horaInicio,
                horafin: element.horaFin,
                documentoPaciente: element.documentoPaciente,
                cantidadSesiones: parseInt(element.sesionesCantidad),
                estadoEvento: element.estadoEvento,
                idEvento: element.idEvento,
                fotoPaciente: element.url_foto,
                nombrePaciente: element.nombrePaciente + " " + element.apellidoPaciente,
                fechaFinEvolucion: element.fechaFinEvolucion
              }
            });
          }
        });

        _this.arrayEventos = events;
      }).catch(function (err) {
        _this.$modal.hide("carga");
        console.log(err);
      });
    },
    registrarEvolucion: function registrarEvolucion() {
      var _this2 = this;

      var EVENT = this.eventoSeleccionado;
      var atrasado = "no";
      if (EVENT.fechaFinEvolucion < this.fechaActual) {
        atrasado = "si";
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__["a" /* default */])('danger', 'La evolución se hará una fecha posterior a la programación, por lo tanto se pagará a la mitad.'));
      }

      var EVOLUCION = EVENT.tipo === "Terapia" ? this.estadoPaciente + " \n\n" + this.evolucion + " \n\nDurante la sesi\xF3n se implementarion las siguientes estrategias terap\xE9uticas: " + this.estrategia.join(", ") + "." : "Se realizó una evaluación";
      var ESTRATEGIA = EVENT.tipo === "Terapia" ? this.estrategia.join(", ") : "Evaluación";

      if (EVOLUCION === "" || ESTRATEGIA === "") {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__["a" /* default */])("danger", "Faltan campos por llenar"));
        this.$modal.hide("carga");
        return;
      }
      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/registrar-evolucion-calendario";
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(BASE_URL, {
        EVENT: EVENT,
        evolucion: EVOLUCION,
        estrategia: ESTRATEGIA,
        material: null,
        atrasado: atrasado,
        requiereExamen: this.requiere ? 1 : 0
      }, config).then(function (res) {
        _this2.$modal.hide("carga");
        if (res.data.status === true) {
          _this2.evolucion = "";
          _this2.estrategia = "";
          _this2.agenda = true;
          _this2.$modal.hide("detalle_terapia");
          _this2.obtenerEventos("terapeuta");
          _this2.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__["a" /* default */])("success", res.data.mensaje));
        }
      }).catch(function (err) {
        _this2.$modal.hide("carga");
        _this2.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__["a" /* default */])("danger", res.data.mensaje));
        console.log(err);
      });
    },
    dominio: function dominio(_dominio) {
      var _this3 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "/api/dominio/" + _dominio;
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(url, config).then(function (res) {
        _this3.arrayMaterialesActivos = res.data.data;
      });
    },
    estrategias: function estrategias(dominio) {
      var _this4 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "/api/dominio/" + dominio;
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(url, config).then(function (res) {
        _this4.arrayEstrategiasActivos = res.data.data;
      });
    },

    cerrarModal: function cerrarModal(modal) {
      this.$modal.hide(modal);
    },

    verificarFirmaElectronica: function verificarFirmaElectronica() {
      this.$modal.show('carga');
      var FIRMA = localStorage.getItem('firmaElectronica');
      if (this.inputFirma === FIRMA) {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__["a" /* default */])("success", 'Firma valida'));
        this.$modal.hide('modalVerificarFirmaElectronica');
        this.$modal.hide('carga');
      } else {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__global_services_crearAlerta__["a" /* default */])("danger", "Firma invalida"));
        this.$modal.hide('carga');
      }
    },

    abrirModalVerificarFirma: function abrirModalVerificarFirma() {
      var ROL = localStorage.getItem('rol');
      if (ROL >= 1 && ROL < 7) {
        this.$modal.show('modalVerificarFirmaElectronica');
      }
    }
  },
  mounted: function mounted() {
    window.document.title = "Avanti | Mi agenda";
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.obtenerEventos("terapeuta");
      this.rol = localStorage.getItem("rol");
      this.dominio(parseInt(this.rol) + 30);
      this.estrategias(parseInt(this.rol) + 20);
      this.fechaActual = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__global_services_fecha_actual__["a" /* default */])();
      this.abrirModalVerificarFirma();
    }
  },

  components: {
    FullCalendar: __WEBPACK_IMPORTED_MODULE_9__fullcalendar_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "TzyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U4cv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__("+Rp4");



















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip: "https://avanti-erp.com/",
      fuente: "avanti",
      fechaInicial: "",
      fechaFinal: "",
      queriedData: [],
      fechaActual: "",
      tableColumns: [{
        prop: "paciente",
        label: "Paciente",
        minWidth: 250 }, {
        prop: "fecha",
        label: "Fecha",
        minWidth: 100 }, {
        prop: "entidad",
        label: "Entidad",
        minWidth: 170 }, {
        prop: "hora",
        label: "Hora",
        minWidth: 100 }, {
        prop: "cantidad",
        label: "Cant. SSP" }, {
        prop: "terapeuta",
        label: "Terapeuta",
        minWidth: 150 }, {
        prop: "especialidad",
        label: "Especialidad",
        minWidth: 140 }, {
        prop: "ubicacion",
        label: "Ubicación",
        minWidth: 100 }, {
        prop: "motivoCancelar",
        label: "Motivo de cancelación",
        minWidth: 190 }, {
        prop: "usuarioCan",
        label: "Usuario Cancela",
        minWidth: 190 }],
      json_fields: {
        "Nombre del paciente": "paciente",
        'Entidad': "entidad",
        "Fecha sesión": "fecha",
        'Hora': "hora",
        'Terapeuta': "terapeuta",
        'Especialidad': "especialidad",
        'Ubicación': "ubicacion",
        'Motivo de cancelación': 'motivoCancelar',
        'Usuario Cancela': 'usuarioCan'
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      SedesProgramacion: [],
      sede: '',
      rol: ''
    };
  },
  methods: {
    getProgramacion: function getProgramacion() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var BASE_URL, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.queriedData = [];

                if (!(_this.fuente == "gCalendar")) {
                  _context.next = 9;
                  break;
                }

                BASE_URL = "https://www.googleapis.com/calendar/v3/calendars/" + sede + "/events?key=AIzaSyCS6MXgvS2kJs7YaIkUfFGx2O1fI9BKuC0&timeMin=" + _this.fechaInicial + "T00:00:00-05:00&timeMax=" + _this.fechaFinal + "T00:00:00-05:00";
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get(BASE_URL);

              case 5:
                data = _context.sent;

                _this.convertirProgramacion(data.data.items);
                _context.next = 10;
                break;

              case 9:
                _this.reporteAvanti();

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    reporteAvanti: function reporteAvanti() {
      var _this2 = this;

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/reporteCancelacion/" + this.fechaInicial + "/" + this.fechaFinal + "/" + this.sede;
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get(BASE_URL, config).then(function (res) {
        var datos = res.data.data;
        var dateFormated = [];
        datos.forEach(function (element) {
          dateFormated.push({
            paciente: element.PacNom1 + " " + element.PacApe1,
            fecha: element.ProFec,
            hora: element.hora,
            cantidad: 1,
            terapeuta: element.terapeutaNombre,
            especialidad: element.especialidad,
            ubicacion: element.ProLug,
            entidad: element.entidad,
            motivoCancelar: element.ProMotCan,
            usuarioCan: element.ProUsuCan
          });
          _this2.$modal.hide("carga");
          _this2.queriedData = dateFormated;
          _this2.json_data = dateFormated;
        });
      });

      this.$modal.hide('carga');
    },
    getHTMLCOMPONENT: function getHTMLCOMPONENT() {

      var componentHTMLTABLE = this.$refs.component.innerHTML;
      console.log('HTML TABLE', componentHTMLTABLE);
    },
    convertirProgramacion: function convertirProgramacion(data) {
      var _this3 = this;

      var BASE_URL = this.ip + "api/convertirProgramacion";
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.post(BASE_URL, {
        data: data
      }).then(function (res) {
        var response = res.data.data;
        var datos = [];
        response.forEach(function (element) {
          var tipo = "";
          if (element.location) {
            tipo = "Virtual";
          } else {
            tipo = "Domicilio";
          }
          datos.push({
            fecha: element.start.dateTime.substring(0, 10),
            paciente: element.paciente[0].PacNom1 + " " + element.paciente[0].PacApe1,
            hora: _this3.horaFormateada(element.start.dateTime),
            cantidad: _this3.calcularMinutos(_this3.horaFormateada(element.start.dateTime), _this3.horaFormateada(element.end.dateTime)),
            terapeuta: "N/A",
            especialidad: "N/A",
            ubicacion: tipo,
            entidad: element.entidad
          });
        });

        _this3.queriedData = datos;
      });
    },
    horaFormateada: function horaFormateada(fecha) {
      var hora = new Date(fecha).getHours();
      var minutos = new Date(fecha).getMinutes();
      if (minutos == 0) {
        minutos = "00";
      }
      var horaFormateada = hora + ":" + minutos;
      return horaFormateada;
    },
    calcularMinutos: function calcularMinutos(inicio, fin) {
      var horaInicial = this.devolverMinutos(inicio);
      var horaFinal = this.devolverMinutos(fin);

      if (horaInicial < horaFinal) {
        var sesiones = (horaFinal - horaInicial) / 30;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(sesiones);
      } else {}
    },
    devolverMinutos: function devolverMinutos(horaMinutos) {
      return parseInt(horaMinutos.split(":")[0]) * 60 + parseInt(horaMinutos.split(":")[1]);
    },
    calcularFechaActual: function calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }

        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },

    emailsProgramacion: function emailsProgramacion() {
      var _this4 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/emailsProgramacion";
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this4.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    this.calcularFechaActual();
    this.emailsProgramacion();
    this.rol = localStorage.getItem('rol');
    if (localStorage.getItem('rol') != 1) {
      this.sede = localStorage.getItem('sede');
    }
    document.title = "Avanti | Reporte programación";
  }
});

/***/ }),

/***/ "Unav":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_evolucionesSinLogro_vue__ = __webpack_require__("XEAq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_717150c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_evolucionesSinLogro_vue__ = __webpack_require__("6Sr7");
function injectStyle (ssrContext) {
  __webpack_require__("alJ1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_evolucionesSinLogro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_717150c3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_evolucionesSinLogro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uquv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UrQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_particular_vue__ = __webpack_require__("yWjZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002620d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_particular_vue__ = __webpack_require__("K7VR");
function injectStyle (ssrContext) {
  __webpack_require__("7smt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-002620d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_particular_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002620d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_particular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V6+9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card",staticStyle:{"padding":"2%"}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-success btn-fill btn-block",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.abrirModal()}}},[_vm._v("\n            Registrar una programación\n          ")]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"ver_eventos_desde"}},[_vm._v("Ver eventos desde:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.desde),expression:"desde"}],staticClass:"form-control",attrs:{"id":"ver_eventos_desde"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.desde=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.setearEventos()}]}},[_c('option',{attrs:{"value":"7"}},[_vm._v("Hace una semana")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("Hace 15 días")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("Hace 1 mes")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("Hace 2 meses")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"ver_eventos_de"}},[_vm._v("Ver eventos de:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.terapeutaEventos),expression:"terapeutaEventos"}],staticClass:"form-control",attrs:{"id":"ver_eventos_de"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.terapeutaEventos=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.setearEventos()}]}},[_c('option',{attrs:{"value":"todos"}},[_vm._v("Todos los eventos")]),_vm._v(" "),_vm._l((_vm.arrayTerapeutas),function(Terapeuta){return _c('option',{key:Terapeuta.usuario,domProps:{"value":Terapeuta.usuario}},[_vm._v("\n              "+_vm._s(Terapeuta.nombres)+" "+_vm._s(Terapeuta.apellidos)+"\n            ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{attrs:{"id":"calendarEl"}},[_c('br'),_vm._v(" "),[_c('FullCalendar',{ref:"fullCalendar",attrs:{"defaultView":"listWeek","hiddenDays":[],"locale":'esLocale',"plugins":_vm.calendarPlugins,"events":_vm.arrayEventos,"header":_vm.headers},on:{"eventClick":_vm.verEvento}})]],2)])])])]),_vm._v(" "),_c('modal',{attrs:{"name":"ingresar_programacion","id":"modal","height":"800","width":"1500","clickToClose":false}},[_c('header',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('p',[_c('span',{staticStyle:{"font-weight":"600","font-size":"20px"}},[_vm._v("Programación de citas")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 pull-lefth"},[_c('button',{staticClass:"close btn btn-danger btn-simple btn-icon",staticStyle:{"color":"red"},attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.cerrarModal('ingresar_programacion')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"padding":"10px 30px 30px 30px","height":"83%","overflow-y":"scroll"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.buscarPaciente.apply(null, arguments)}}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("Buscar paciente")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formPaciente.criterio),expression:"formPaciente.criterio"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formPaciente, "criterio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"paciente.PacApe1"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Apellidos del paciente\n              ")]),_vm._v(" "),_c('option',{attrs:{"value":"paciente.PacNom1"}},[_vm._v("Nombres del paciente")]),_vm._v(" "),_c('option',{attrs:{"value":"paciente.PacNumDoc"}},[_vm._v("\n                Documento del paciente\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formPaciente.busqueda),expression:"formPaciente.busqueda"}],staticClass:"form-control",attrs:{"required":"","type":"text","id":"texto","placeholder":"Buscar..."},domProps:{"value":(_vm.formPaciente.busqueda)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formPaciente, "busqueda", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-2"},[_c('button',{staticClass:"btn btn-block btn-success btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Buscar\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"})])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.arrayPacientes.length > 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("Pacientes encontrados")])]),_vm._v(" "),_c('center',[_c('div',[_c('el-table',{staticClass:"table-responsive",staticStyle:{"width":"97%"},attrs:{"data":_vm.arrayPacientes,"border":"","size":"mini"}},[_c('el-table-column',{attrs:{"type":"index","label":"#"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacApe1","label":"Apellidos","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNom1","label":"Nombres","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNumDoc","label":"N° documento","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Acción","width":"270","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-sm btn-fill btn-success btn-xs btn-icon like",on:{"click":function($event){return _vm.seleccionarPaciente(props.row)}}},[_vm._v("\n                      Seleccionar\n                    ")])])]}}],null,false,4076172723)})],1)],1)])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.pacienteSeleccionado.documento != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("Paciente seleccionado")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticStyle:{"font-weight":"500"},attrs:{"for":""}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{staticClass:"form-control input-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.pacienteSeleccionado.nombre}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"font-weight":"500"},attrs:{"for":""}},[_vm._v("Documento")]),_vm._v(" "),_c('input',{staticClass:"form-control input-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.pacienteSeleccionado.documento}})]),_vm._v(" "),_c('center',{staticClass:"col-md-2 text-success"},[_c('label',{attrs:{"for":""}},[_vm._v("Cod. único")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"19px"}},[_vm._v(_vm._s(_vm.pacienteSeleccionado.ide))])])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(
          _vm.arrayServiciosDisponibles != '' && _vm.servicioSeleccionado.id == ''
        )?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("Autorizaciones")])]),_vm._v(" "),_c('center',[_c('div',[_c('el-table',{staticClass:"table-responsive",staticStyle:{"width":"97%"},attrs:{"data":_vm.arrayServiciosDisponibles,"border":"","size":"mini"}},[_c('el-table-column',{attrs:{"type":"index","label":"#"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codigo","label":"Codigo de autorización","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Especialidad","width":"150","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticStyle:{"background-color":"#E3097E","color":"white","padding":"5px","border-radius":"7px","font-weight":"600"}},[_vm._v("\n                    "+_vm._s(_vm.labelEspecialidad[props.row.especialidad])+"\n                  ")])]}}],null,false,4003354285)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fechaExpedicion","label":"Fecha de expedición","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fechaVencimiento","label":"Fecha de vencimiento","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bolsa","label":"Bolsa actual","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Acción","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-simple btn-success btn-xs btn-icon like",attrs:{"disabled":props.row.bolsa < 1},on:{"click":function($event){return _vm.seleccionarServicio(props.row)}}},[_vm._v("\n                      Seleccionar\n                    ")])])]}}],null,false,990288870)})],1)],1)])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.servicioSeleccionado.id != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("Servicio Seleccionado")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticStyle:{"font-weight":"500"},attrs:{"for":""}},[_vm._v("Autorización")]),_vm._v(" "),_c('input',{staticClass:"form-control input-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.servicioSeleccionado.codigo}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticStyle:{"font-weight":"500"},attrs:{"for":""}},[_vm._v("Sesiones Autorizadas")]),_vm._v(" "),_c('input',{staticClass:"form-control input-sm",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.servicioSeleccionado.sesionesAutorizadas}})])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.servicioSeleccionado.id != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("Tipo de programación:")]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formato),expression:"formato"}],attrs:{"type":"radio","value":"1","id":"unica"},domProps:{"checked":_vm._q(_vm.formato,"1")},on:{"change":function($event){_vm.formato="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":"unica"}},[_vm._v("Única")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formato),expression:"formato"}],attrs:{"type":"radio","id":"especialidad","value":"3"},domProps:{"checked":_vm._q(_vm.formato,"3")},on:{"change":function($event){_vm.formato="3"}}}),_vm._v(" "),_c('label',{attrs:{"for":"especialidad"}},[_vm._v("Por especialidad")])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.servicioSeleccionado.id != '' && _vm.formato == 2)?_c('div',[_c('form',[_c('br'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding":"0 10px"}},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("Programación")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-6"},[_c('label',{staticStyle:{"font-weight":"500"},attrs:{"for":""}},[_vm._v("Terapeuta")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.terapeutaProgramar),expression:"terapeutaProgramar"}],staticClass:"form-control",attrs:{"name":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.terapeutaProgramar=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayTerapeutas),function(Terapeuta){return _c('option',{key:Terapeuta.usuario,domProps:{"value":Terapeuta.usuario}},[_vm._v("\n                  "+_vm._s(Terapeuta.nombres)+" "+_vm._s(Terapeuta.apellidos)+"\n                ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-6"},[_c('label',{staticStyle:{"font-weight":"500"},attrs:{"for":""}},[_vm._v("Lugar")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.programacionIndividual.lugar),expression:"programacionIndividual.lugar"}],staticClass:"form-control",attrs:{"name":"","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.programacionIndividual, "lugar", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Sede"}},[_vm._v("Sede")]),_vm._v(" "),_c('option',{attrs:{"value":"Domicilio"}},[_vm._v("Domicilio")]),_vm._v(" "),_c('option',{attrs:{"value":"Virtual"}},[_vm._v("Virtual")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"valor"}},[_vm._v(_vm._s(_vm.servicioSeleccionado.tipo == 'particular' ? 'Valor por sesión' : 'Servicio'))]),_vm._v(" "),(_vm.servicioSeleccionado.tipo == 'particular')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.programacionIndividual.valorSesion),expression:"programacionIndividual.valorSesion"}],staticClass:"form-control",attrs:{"type":"number","id":"valor","required":""},domProps:{"value":(_vm.programacionIndividual.valorSesion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.programacionIndividual, "valorSesion", $event.target.value)}}}):_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.programacionIndividual.valorSesion),expression:"programacionIndividual.valorSesion"}],staticClass:"form-control",attrs:{"id":"valor"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.programacionIndividual, "valorSesion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.arrayServiciosConTarifa),function(tarifa){return _c('option',{key:tarifa.id,domProps:{"value":tarifa}},[_vm._v(" "+_vm._s(tarifa.especialidad)+"  ")])}),0)]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding":"0 10px"}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-6"},[_c('label',{attrs:{"for":"fechaInicioSesiones"}},[_vm._v("Fecha inicio de las sesiones")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.iniciosesiones),expression:"iniciosesiones"}],staticClass:"form-control",attrs:{"min":_vm.calcularFechaActual(),"max":_vm.servicioSeleccionado.fechaVencimiento,"required":"","type":"date","id":"fechaInicioSesiones"},domProps:{"value":(_vm.iniciosesiones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.iniciosesiones=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-6"},[_c('label',{attrs:{"for":"fechaFinSesiones"}},[_vm._v("Fecha fin de las sesiones")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.finsesiones),expression:"finsesiones"}],staticClass:"form-control",attrs:{"min":_vm.iniciosesiones,"max":_vm.servicioSeleccionado.fechaVencimiento,"required":"","type":"date","id":"fechaFinSesiones"},domProps:{"value":(_vm.finsesiones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.finsesiones=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding":"0 10px"}},[_c('div',{staticClass:"col-md-12"},[_c('h5',[_vm._v("Seleccione los dias a programar")])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-12"},[_c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('p',[_vm._v("LUNES")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"l_horainicio"}},[_vm._v("Hora inicio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.lunes.horainicio),expression:"diasProgramacion.lunes.horainicio"}],staticClass:"form-control",attrs:{"type":"time","id":"l_horainicio"},domProps:{"value":(_vm.diasProgramacion.lunes.horainicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.lunes, "horainicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"l_horafin"}},[_vm._v("Hora fin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.lunes.horafin),expression:"diasProgramacion.lunes.horafin"}],staticClass:"form-control",attrs:{"type":"time","id":"l_horafin"},domProps:{"value":(_vm.diasProgramacion.lunes.horafin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.lunes, "horafin", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-12"},[_c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('p',[_vm._v("MARTES")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"m_horainicio"}},[_vm._v("Hora inicio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.martes.horainicio),expression:"diasProgramacion.martes.horainicio"}],staticClass:"form-control",attrs:{"type":"time","id":"m_horainicio"},domProps:{"value":(_vm.diasProgramacion.martes.horainicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.martes, "horainicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"m_horafin"}},[_vm._v("Hora fin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.martes.horafin),expression:"diasProgramacion.martes.horafin"}],staticClass:"form-control",attrs:{"type":"time","id":"m_horafin"},domProps:{"value":(_vm.diasProgramacion.martes.horafin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.martes, "horafin", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-12"},[_c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('p',[_vm._v("MIERCOLES")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"x_horainicio"}},[_vm._v("Hora inicio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.miercoles.horainicio),expression:"diasProgramacion.miercoles.horainicio"}],staticClass:"form-control",attrs:{"type":"time","id":"x_horainicio"},domProps:{"value":(_vm.diasProgramacion.miercoles.horainicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.miercoles, "horainicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"x_horafin"}},[_vm._v("Hora fin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.miercoles.horafin),expression:"diasProgramacion.miercoles.horafin"}],staticClass:"form-control",attrs:{"type":"time","id":"x_horafin"},domProps:{"value":(_vm.diasProgramacion.miercoles.horafin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.miercoles, "horafin", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-12"},[_c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('p',[_vm._v("JUEVES")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"j_horainicio"}},[_vm._v("Hora inicio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.jueves.horainicio),expression:"diasProgramacion.jueves.horainicio"}],staticClass:"form-control",attrs:{"type":"time","id":"j_horainicio"},domProps:{"value":(_vm.diasProgramacion.jueves.horainicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.jueves, "horainicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"j_horafin"}},[_vm._v("Hora fin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.jueves.horafin),expression:"diasProgramacion.jueves.horafin"}],staticClass:"form-control",attrs:{"type":"time","id":"j_horafin"},domProps:{"value":(_vm.diasProgramacion.jueves.horafin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.jueves, "horafin", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-12"},[_c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('p',[_vm._v("VIERNES")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"v_horainicio"}},[_vm._v("Hora inicio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.viernes.horainicio),expression:"diasProgramacion.viernes.horainicio"}],staticClass:"form-control",attrs:{"type":"time","id":"v_horainicio"},domProps:{"value":(_vm.diasProgramacion.viernes.horainicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.viernes, "horainicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"v_horafin"}},[_vm._v("Hora fin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.viernes.horafin),expression:"diasProgramacion.viernes.horafin"}],staticClass:"form-control",attrs:{"type":"time","id":"v_horafin"},domProps:{"value":(_vm.diasProgramacion.viernes.horafin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.viernes, "horafin", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-xs-12 col-md-12"},[_c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('p',[_vm._v("SABADO")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"s_horainicio"}},[_vm._v("Hora inicio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.sabado.horainicio),expression:"diasProgramacion.sabado.horainicio"}],staticClass:"form-control",attrs:{"type":"time","id":"s_horainicio"},domProps:{"value":(_vm.diasProgramacion.sabado.horainicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.sabado, "horainicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"s_horafin"}},[_vm._v("Hora fin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.diasProgramacion.sabado.horafin),expression:"diasProgramacion.sabado.horafin"}],staticClass:"form-control",attrs:{"type":"time","id":"s_horafin"},domProps:{"value":(_vm.diasProgramacion.sabado.horafin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.diasProgramacion.sabado, "horafin", $event.target.value)}}})])])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.servicioSeleccionado.id != '' && _vm.formato != 2)?_c('div',[_c('form',[_c('br'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding":"0 10px"}},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"bold"}},[_vm._v("Programación")])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-xs-6 col-md-6"},[_c('label',{staticStyle:{"font-weight":"500"},attrs:{"for":""}},[_vm._v("Terapeuta")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.terapeutaProgramar),expression:"terapeutaProgramar"}],staticClass:"form-control",attrs:{"name":"","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.terapeutaProgramar=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayTerapeutas),function(Terapeuta){return _c('option',{key:Terapeuta.usuario,domProps:{"value":Terapeuta.usuario}},[_vm._v("\n                  "+_vm._s(Terapeuta.nombres)+" "+_vm._s(Terapeuta.apellidos)+"\n                ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-6 col-xs-6 col-md-3"},[_c('label',{staticStyle:{"font-weight":"500"},attrs:{"for":""}},[_vm._v("Tipo de sesión")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.programacionIndividual.tipo),expression:"programacionIndividual.tipo"}],staticClass:"form-control",attrs:{"name":"","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.programacionIndividual, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Terapia"}},[_vm._v("Terapia")]),_vm._v(" "),_c('option',{attrs:{"value":"Evaluacion"}},[_vm._v("Evaluación")]),_vm._v(" "),_c('option',{attrs:{"value":"CYT"}},[_vm._v("CYT")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-xs-6 col-md-3"},[_c('label',{staticStyle:{"font-weight":"500"},attrs:{"for":""}},[_vm._v("Lugar")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.programacionIndividual.lugar),expression:"programacionIndividual.lugar"}],staticClass:"form-control",attrs:{"name":"","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.programacionIndividual, "lugar", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Sede"}},[_vm._v("Sede")]),_vm._v(" "),_c('option',{attrs:{"value":"Domicilio"}},[_vm._v("Domicilio")]),_vm._v(" "),_c('option',{attrs:{"value":"Virtual"}},[_vm._v("Virtual")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding":"0 10px"}},[_c('div',{staticClass:"col-12 col-xs-12 col-md-6"},[_c('label',{attrs:{"for":"fechaInicioSesiones"}},[_vm._v("Fecha de la sesión")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.programacionIndividual.fecha),expression:"programacionIndividual.fecha"}],staticClass:"form-control",attrs:{"min":_vm.calcularFechaActual(),"max":_vm.servicioSeleccionado.fechaVencimiento,"required":"","type":"date","id":"fechaInicioSesiones"},domProps:{"value":(_vm.programacionIndividual.fecha)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.programacionIndividual, "fecha", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"l_horainicio"}},[_vm._v("Hora inicio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.programacionIndividual.horainicio),expression:"programacionIndividual.horainicio"}],staticClass:"form-control",attrs:{"type":"time","id":"l_horainicio","required":""},domProps:{"value":(_vm.programacionIndividual.horainicio)},on:{"change":_vm.validarHoraInicio,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.programacionIndividual, "horainicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"l_horafin"}},[_vm._v("Hora fin")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.programacionIndividual.horafin),expression:"programacionIndividual.horafin"}],staticClass:"form-control",attrs:{"type":"time","id":"l_horafin","required":""},domProps:{"value":(_vm.programacionIndividual.horafin)},on:{"change":_vm.validarHoraFin,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.programacionIndividual, "horafin", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"valor"}},[_vm._v(_vm._s(_vm.servicioSeleccionado.tipo == 'particular' ? 'Valor por sesión' : 'Servicio'))]),_vm._v(" "),(_vm.servicioSeleccionado.tipo == 'particular')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.programacionIndividual.valorSesion),expression:"programacionIndividual.valorSesion"}],staticClass:"form-control",attrs:{"type":"number","id":"valor","required":""},domProps:{"value":(_vm.programacionIndividual.valorSesion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.programacionIndividual, "valorSesion", $event.target.value)}}}):_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.programacionIndividual.valorSesion),expression:"programacionIndividual.valorSesion"}],staticClass:"form-control",attrs:{"id":"valor"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.programacionIndividual, "valorSesion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.arrayServiciosConTarifa),function(tarifa){return _c('option',{key:tarifa.id,domProps:{"value":tarifa}},[_vm._v(" "+_vm._s(tarifa.especialidad)+"  ")])}),0)])])]),_vm._v(" "),(_vm.formato == 3 && _vm.arrayProgramacionEspecialidad.length > 0)?_c('div',{staticClass:"row",staticStyle:{"padding":"10px","margin-top":"10px"}},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"cantses"}},[_vm._v("Cantidad de sesiones a programar")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","id":"cantses","readonly":"","disabled":""},domProps:{"value":_vm.contadorSesionesEspecialidad}}),_vm._v(" "),_c('br')]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-striped table-hover table-bordered"},[_c('tr',{staticStyle:{"background-color":"#E3097E","color":"white"}},[_c('th',{staticStyle:{"padding":"10px"}},[_vm._v("Terapeuta")]),_vm._v(" "),_c('th',{staticStyle:{"padding":"10px"}},[_vm._v("Fecha")]),_vm._v(" "),_c('th',{staticStyle:{"padding":"10px"}},[_vm._v("Hora Inicio")]),_vm._v(" "),_c('th',{staticStyle:{"padding":"10px"}},[_vm._v("Hora Fin")]),_vm._v(" "),_c('th',{staticStyle:{"padding":"10px"}},[_vm._v("Acciones")])]),_vm._v(" "),_vm._l((_vm.arrayProgramacionEspecialidad),function(terapia,index){return _c('tr',{key:index},[_c('td',{staticStyle:{"padding":"10px"}},[_vm._v(_vm._s(terapia.terapeuta))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"10px"}},[_vm._v(_vm._s(_vm._f("date")(terapia.fecha)))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"10px"}},[_vm._v(_vm._s(terapia.horainicio))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"10px"}},[_vm._v(_vm._s(terapia.horafin))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"10px"}},[_c('center',[_c('button',{staticClass:"btn btn-success btn-icon",staticStyle:{"border-radius":"7px"},on:{"click":function($event){return _vm.eliminarProgramacionDeLaLista(index)}}},[_c('i',{staticClass:"fa fa-trash"})])])],1)])})],2)])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"padding-bottom":"0"}},[_c('center',[(_vm.formato == 3)?_c('button',{staticClass:"btn btn-primary btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.adicionarProgramacion()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Adicionar programación\n        ")]):_vm._e(),_vm._v(" "),(_vm.servicioSeleccionado.id != '')?_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.enviarProgramacion()}}},[_c('i',{staticClass:"fa fa-send"}),_vm._v(" Enviar programación\n        ")]):_vm._e()])],1)]),_vm._v(" "),_c('modal',{attrs:{"name":"detalle_terapia","id":"modal","height":"auto","width":"550","clickToClose":false}},[_c('header',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('strong',[_vm._v("Detalle de la terapia:")])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 pull-lefth"},[_c('button',{staticClass:"close btn btn-danger btn-simple btn-icon",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.cerrarModal('detalle_terapia')}}},[_c('span',{staticStyle:{"color":"red"},attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])])]),_vm._v(" "),(_vm.eventoSeleccionado != '')?_c('section',{staticClass:"modal-body",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_c('i',{staticClass:"fa fa-user"}),_vm._v(" "+_vm._s(_vm.eventoSeleccionado.title)+" -\n            "+_vm._s(_vm.eventoSeleccionado.extendedProps.documentoPaciente)+"\n          ")]),_vm._v(" "),(
              _vm.actionModal === 'detalle' || _vm.actionModal != 'actualizar horario'
            )?_c('small',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" El\n            "),_c('strong',[_vm._v(_vm._s(_vm._f("date")(_vm.eventoSeleccionado.extendedProps.fecha))+"\n            ")]),_vm._v("\n            de\n            "),_c('strong',[_vm._v(_vm._s(_vm.eventoSeleccionado.extendedProps.horainicio))]),_vm._v("\n            a "),_c('strong',[_vm._v(_vm._s(_vm.eventoSeleccionado.extendedProps.horafin))]),_vm._v(" "),(
                _vm.eventoSeleccionado.extendedProps.tipo != 'CYT' &&
                _vm.eventoSeleccionado.extendedProps.estadoEvento === 3
              )?_c('button',{staticClass:"btn btn-xs btn-fill btn-info",on:{"click":function($event){_vm.actionModal = 'actualizar horario'}}},[_vm._v("\n              Actualizar horario\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.actionModal === 'actualizar horario')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('small',[_vm._v("Actualizar la hora de la sesión")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.actualizarhorainicio),expression:"actualizarhorainicio"}],staticClass:"form-control input-sm",attrs:{"type":"time"},domProps:{"value":(_vm.actualizarhorainicio)},on:{"change":function($event){return _vm.adicionarHoras()},"input":function($event){if($event.target.composing){ return; }_vm.actualizarhorainicio=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_vm._v("a")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.actualizarhorafin),expression:"actualizarhorafin"}],staticClass:"form-control input-sm",attrs:{"type":"time","disabled":""},domProps:{"value":(_vm.actualizarhorafin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.actualizarhorafin=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v("\n            "+_vm._s(_vm.eventoSeleccionado.extendedProps.cantidadSesiones * 30)+"\n            minutos\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.actionModal === 'detalle')?_c('strong',[_c('i',{staticClass:"fa fa-user"}),_vm._v("\n            "+_vm._s(_vm.eventoSeleccionado.extendedProps.nombreTerapeuta)+"\n            "),(
                _vm.eventoSeleccionado.extendedProps.tipo != 'CYT' &&
                _vm.eventoSeleccionado.extendedProps.estadoEvento === 3)?_c('button',{staticClass:"btn btn-xs btn-success btn-fill",on:{"click":function($event){_vm.actionModal = 'actualizar terapeuta'}}},[_vm._v("\n              Actualizar terapeuta\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.actionModal == 'actualizar terapeuta')?_c('div',{staticClass:"changeUser"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('strong',[_vm._v("Modificar terapeuta de la sesión")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.terapeutaActualizar),expression:"terapeutaActualizar"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.terapeutaActualizar=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayTerapeutas),function(Terapeuta){return _c('option',{key:Terapeuta.usuario,attrs:{"disabled":Terapeuta.usuario ==
                      _vm.eventoSeleccionado.extendedProps.usuarioTerapeuta},domProps:{"value":Terapeuta.usuario}},[_vm._v("\n                    "+_vm._s(Terapeuta.nombres)+" "+_vm._s(Terapeuta.apellidos)+"\n                  ")])}),0)])])]):_vm._e(),_vm._v(" "),_c('small',[_c('i',{staticClass:"fa fa-file"}),_vm._v(" "),(_vm.eventoSeleccionado.extendedProps.tipo == 'Evaluacion')?_c('strong',[_vm._v("\n              Evaluación")]):_c('strong',[_vm._v("Terapia")])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.eventoSeleccionado.extendedProps.tipo == 'GTSL')?_c('small',[_c('i',{staticClass:"fa fa-eye"}),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("Observación:")]),_vm._v("  Gestión sin logro de objetivo\n          ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.eventoSeleccionado.extendedProps.especialidad != null)?_c('small',[_c('i',{staticClass:"fa fa-file"}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.eventoSeleccionado.extendedProps.especialidad))])]):_vm._e()])]),_vm._v(" "),(
          _vm.eventoSeleccionado.extendedProps.tipo === 'CYT' &&
          _vm.eventoSeleccionado.extendedProps.estadoEvento === 3
        )?_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"cardcyt"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('strong',{staticClass:"text-gray",staticStyle:{"font-size":"17px"}},[_vm._v("Esta sesión es un CYT, solo debe hacer click en aceptar\n                  para hacerlo efectivo")]),_vm._v(" "),_c('p',[_c('br'),_vm._v("\n                  Para hacer efectivo el "),_c('strong',[_vm._v("CYT")]),_vm._v(" ahora solo debe\n                  hacer click en aceptar y la información será registrada, en\n                  caso de que no se haya dado el "),_c('strong',[_vm._v("CYT")]),_vm._v(" solo\n                  debe hacer click en cancelar.\n                ")]),_vm._v(" "),_c('p',[_c('button',{staticClass:"btn btn-secondary btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.aceptarCYT()}}},[_c('strong',{staticStyle:{"color":"white"}},[_vm._v("Aceptar CYT")])])])])])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.eventoSeleccionado != '')?_c('footer',{staticClass:"modal-footer"},[_c('div',{staticClass:"row"},[_c('center',[(
              _vm.eventoSeleccionado.extendedProps.estadoEvento === 1 &&
              _vm.actionModal === 'detalle'
            )?_c('div',{staticClass:"col-md-12"},[_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" Esta sesión fue realizada ")])]):_vm._e(),_vm._v(" "),(
              _vm.eventoSeleccionado.extendedProps.estadoEvento === 2 &&
              _vm.actionModal === 'detalle'
            )?_c('div',{staticClass:"col-md-12"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(" Esta sesión fue cancelada ")])]):_vm._e(),_vm._v(" "),(
              _vm.eventoSeleccionado.extendedProps.estadoEvento === 3 &&
              _vm.actionModal === 'detalle'
            )?_c('div',{staticClass:"row",staticStyle:{"padding-left":"8px"}},[_c('div',{staticClass:"col-md-8"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.motivoCancelacion),expression:"motivoCancelacion"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.motivoCancelacion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Seleccione motivo de cancelación...")]),_vm._v(" "),_vm._l((_vm.motivoCancelarOptions),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-danger btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.cancelarEvento()}}},[_c('strong',{staticStyle:{"color":"white"}},[_vm._v("Cancelar sesión")])])])]):_vm._e(),_vm._v(" "),(_vm.actionModal === 'actualizar horario')?_c('div',{staticClass:"row"},[_c('center',[_c('button',{staticClass:"btn btn-secondary btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){_vm.actionModal = 'detalle'}}},[_vm._v("\n                Cancelar\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.actualizarHorario()}}},[_vm._v("\n                Actualizar horario\n              ")])])],1):_vm._e(),_vm._v(" "),(_vm.actionModal === 'actualizar terapeuta')?_c('div',{staticClass:"row"},[_c('center',[_c('button',{staticClass:"btn btn-secondary btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){_vm.actionModal = 'detalle'}}},[_vm._v("\n                Cancelar\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.actualizarTerapeuta()}}},[_vm._v("\n                Actualizar terapeuta\n              ")])])],1):_vm._e()])],1)]):_vm._e()]),_vm._v(" "),_c('modal',{staticStyle:{"text-align":"center"},attrs:{"name":"mensaje","id":"modal","height":"auto","width":"500","clickToClose":false}},[_c('header',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('strong',[_vm._v("Registro exitoso!")])]),_vm._v(" "),_c('div',{staticClass:"col-md-5 pull-lefth"},[_c('button',{staticClass:"close btn btn-danger btn-simple btn-icon",staticStyle:{"color":"red"},attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.cerrarModal('mensaje')}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])])]),_vm._v(" "),_c('section',{staticClass:"modal-body",staticStyle:{"padding":"60px 0","text-align":"center"}},[_c('p',{staticStyle:{"font-size":"xx-large","font-weight":"bold"}},[_vm._v(_vm._s(_vm.mensaje))])]),_vm._v(" "),_c('footer',{staticClass:"modal-footer"},[_c('div',{staticClass:"row"},[_c('center',[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-danger btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.recargarVentana()}}},[_c('strong',{staticStyle:{"color":"white"}},[_vm._v("Cerrar")])])])])],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-10"},[_c('p',[_c('span',{staticStyle:{"font-weight":"600","font-size":"20px"}},[_vm._v("Calendario de programación")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"14px","color":"grey"}},[_vm._v("Gestiona las sesiones de los pacientes")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VDNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-bottom":"20px"}},[_c('label',{attrs:{"for":""}},[_vm._v("Cantidad de registros:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},_vm._l((_vm.colums),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"else":""}})}),1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n        Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VY9H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VYlN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__("+Rp4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__ = __webpack_require__("1byD");






















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  data: function data() {
    return {
      searchQuery: "",
      fechaInicial: "",
      fechaFinal: "",
      listUsers: [],
      arrayEps: [],
      categoria: "Todas",
      queriedData2: [],
      form: {
        fecha: "",
        monto: "",
        categoria: "Prestamo",
        comentario: "",
        usuario: "",
        eps: "",
        tipo: ""
      },
      fechaActual: "",
      tableColumns: [{
        prop: "paciente",
        label: "Paciente",
        minWidth: 100
      }, {
        prop: "entidad",
        label: "Entidad",
        minWidth: 100
      }, {
        prop: "fecha",
        label: "Fecha",
        minWidth: 100
      }, {
        prop: "valor",
        label: "Monto $",
        minWidth: 100
      }, {
        prop: "tipo",
        label: "Metodo de pago",
        minWidth: 100
      }, {
        prop: "comentario",
        label: "Comentario",
        minWidth: 300
      }],
      json_fields: {
        paciente: "paciente",
        entidad: "entidad",
        fecha: "fecha",
        monto: "valor",
        'metodo de pago': "tipo",
        comentarios: "comentario"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      SedesProgramacion: [],
      sede: "Sede Principal",
      rol: "",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  methods: {
    formatearPesosColombianos: __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__["a" /* default */],
    prepararRegistrar: function prepararRegistrar() {
      this.$modal.show("registrar-gasto");
    },
    obtenerInformacionCopagos: function obtenerInformacionCopagos(fechaInicial, fechaFinal) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sede, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.$modal.show("carga");
                sede = localStorage.getItem("sede");
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/get-copays/" + fechaInicial + "/" + fechaFinal);

              case 5:
                response = _context.sent;

                _this2.queriedData2 = response.data.data;
                _this2.json_data = response.data.data;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.log("Error al obtener los datos:" + _context.t0);

              case 13:
                _context.prev = 13;

                _this2.$modal.hide("carga");
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10, 13, 16]]);
      }))();
    },
    registrarCopago: function registrarCopago() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.$modal.show("carga");
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post("api/newCopay", _this3.form);

              case 4:
                response = _context2.sent;

                if (response.data.status == true) {
                  _this3.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("success", response.data.mensaje));
                  _this3.obtenerInformacionCopagos(_this3.form.fecha, _this3.form.fecha);
                  _this3.fechaInicial = _this3.form.fecha;
                  _this3.fechaFinal = _this3.form.fecha;
                  _this3.resetForm();
                }
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.log(_context2.t0);
                _this3.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", "Ocurrió un error, intentelo de nuevo."));

              case 12:
                _context2.prev = 12;

                _this3.$modal.hide("carga");
                _this3.$modal.hide("registrar-gasto");
                return _context2.finish(12);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 8, 12, 16]]);
      }))();
    },

    deleteCopay: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(copago) {
        var data, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.$modal.show("carga");
                data = { id: copago.id };
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post("api/deleteCopay", data);

              case 5:
                response = _context3.sent;


                if (response.data.status === true) {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("success", response.data.mensaje));
                  this.obtenerInformacionCopagos(this.fechaInicial, this.fechaFinal);
                } else {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", response.data.mensaje));
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", _context3.t0));

              case 12:
                _context3.prev = 12;

                this.$modal.hide("carga");
                return _context3.finish(12);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9, 12, 15]]);
      }));

      function deleteCopay(_x) {
        return _ref.apply(this, arguments);
      }

      return deleteCopay;
    }(),
    getListUsers: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                this.$modal.show("carga");
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/pacientesSelect");

              case 4:
                response = _context4.sent;


                if (response.data.status === true) {
                  this.listUsers = response.data.data;
                } else {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", response.data.mensaje));
                }
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", _context4.t0));

              case 11:
                _context4.prev = 11;

                this.$modal.hide("carga");
                return _context4.finish(11);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8, 11, 14]]);
      }));

      function getListUsers() {
        return _ref2.apply(this, arguments);
      }

      return getListUsers;
    }(),
    getListEps: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                this.$modal.show("carga");
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/list-eps");

              case 4:
                response = _context5.sent;


                this.arrayEps = response.data.data;
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);

                console.log("Error al obtener los datos:" + _context5.t0);

              case 11:
                _context5.prev = 11;

                this.$modal.hide("carga");
                return _context5.finish(11);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 8, 11, 14]]);
      }));

      function getListEps() {
        return _ref3.apply(this, arguments);
      }

      return getListEps;
    }(),
    resetForm: function resetForm() {
      this.form.fecha = "";
      this.form.monto = "";
      this.form.categoria = "Prestamo";
      this.form.comentario = "";
      this.form.usuario = "";
      this.form.tipo = "";
    },
    cerrarModal: function cerrarModal() {
      this.resetForm();
      this.$modal.hide("registrar-gasto");
    },
    getClass: function getClass(column, row) {
      if (column.prop === "valor") {
        if (row.tipo === "Efectivo") {
          return "low-percentage";
        }

        if (row.tipo === "Transferencia") {
          return "medium-percentage";
        }
      }
      return "";
    }
  },
  mounted: function mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de copagos";
    this.getListUsers();
    this.getListEps();
  }
});

/***/ }),

/***/ "VZyU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vca+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__("+Rp4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__ = __webpack_require__("1byD");






















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  data: function data() {
    return {
      searchQuery: "",
      fechaInicial: "",
      fechaFinal: "",

      accion: 'registrar',
      eps: '',
      especialidad: '',
      tarifa: 0,
      copago: 0,
      arrayEspecialidades: [],
      arrayEps: [],
      idActualizar: '',

      queriedData2: [],
      fechaActual: "",
      tableColumns: [{
        prop: "entidad",
        label: "Entidad",
        minWidth: 180 }, {
        prop: "especialidad",
        label: "Especialidad",
        minWidth: 100 }, {
        prop: "tarifa",
        label: "Tarifa",
        minWidth: 100 }],
      json_fields: {
        "Entidad": "entidad",
        "Especialidad": "especialidad",
        "tarifa": "tarifa"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      SedesProgramacion: [],
      sede: "Sede Principal",
      rol: "",
      tipo: "",
      usuarioSeleccionado: {
        nombreUsuario: "",
        tipoContrato: "",
        salarioFijo: "",
        pagoPorSesion: "",
        pagoPorSesionDomicilio: "",
        tipoContratoId: "",
        idUsuario: ""
      },
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },
  methods: {
    formatearPesosColombianos: __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__["a" /* default */],
    prepararNuevaTarifa: function prepararNuevaTarifa() {
      this.$modal.show('agregar_tarifa');
      this.accion = 'registrar';
      this.copago = 0;
      this.tarifa = 0;
      this.especialidad = '';
      this.eps = '';
    },
    modal: function modal(tarifa) {
      console.log(tarifa);
      this.idActualizar = tarifa.id;
      this.tarifa = tarifa.tarifa;
      this.especialidad = tarifa.especialidadId;
      this.eps = tarifa.epsId;
      this.copago = tarifa.copago;
      this.accion = 'actualizar';
      this.$modal.show('agregar_tarifa');
    },
    obtenerTarifas: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.$modal.show("carga");
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/informe-tarifas");

              case 4:
                response = _context.sent;


                this.queriedData2 = response.data.data;
                this.json_data = response.data.data;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                console.log("Error al obtener los datos:" + _context.t0);

              case 12:
                _context.prev = 12;

                this.$modal.hide("carga");
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9, 12, 15]]);
      }));

      function obtenerTarifas() {
        return _ref.apply(this, arguments);
      }

      return obtenerTarifas;
    }(),
    getListEspecialidades: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                this.$modal.show("carga");
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/list-especialidades");

              case 4:
                response = _context2.sent;


                this.arrayEspecialidades = response.data.data;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.log("Error al obtener los datos:" + _context2.t0);

              case 11:
                _context2.prev = 11;

                this.$modal.hide("carga");
                return _context2.finish(11);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8, 11, 14]]);
      }));

      function getListEspecialidades() {
        return _ref2.apply(this, arguments);
      }

      return getListEspecialidades;
    }(),
    getListEps: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.$modal.show("carga");
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/list-eps");

              case 4:
                response = _context3.sent;


                this.arrayEps = response.data.data;
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                console.log("Error al obtener los datos:" + _context3.t0);

              case 11:
                _context3.prev = 11;

                this.$modal.hide("carga");
                return _context3.finish(11);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8, 11, 14]]);
      }));

      function getListEps() {
        return _ref3.apply(this, arguments);
      }

      return getListEps;
    }(),
    newRate: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                this.$modal.show("carga");
                data = { tarifa: this.tarifa, copago: this.copago, eps: this.eps, especialidad: this.especialidad };
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post("api/newRate", data);

              case 5:
                response = _context4.sent;

                if (!(response.data.status == false)) {
                  _context4.next = 9;
                  break;
                }

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", response.data.mensaje));
                return _context4.abrupt("return");

              case 9:

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("success", response.data.mensaje));
                this.$modal.hide("agregar_tarifa");
                this.obtenerTarifas();

                _context4.next = 17;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](0);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", _context4.t0.error));

              case 17:
                _context4.prev = 17;

                this.$modal.hide("carga");
                return _context4.finish(17);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 14, 17, 20]]);
      }));

      function newRate() {
        return _ref4.apply(this, arguments);
      }

      return newRate;
    }(),

    updateRate: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                this.$modal.show("carga");
                data = { idActualizar: this.idActualizar, copago: this.copago, tarifa: this.tarifa };
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post("api/updateRate", data);

              case 5:
                response = _context5.sent;

                if (!(response.data.status == false)) {
                  _context5.next = 9;
                  break;
                }

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", response.data.mensaje));
                return _context5.abrupt("return");

              case 9:

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("success", response.data.mensaje));
                this.$modal.hide("agregar_tarifa");
                this.obtenerTarifas();
                _context5.next = 17;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](0);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", _context5.t0.error));

              case 17:
                _context5.prev = 17;

                this.$modal.hide("carga");
                return _context5.finish(17);

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 14, 17, 20]]);
      }));

      function updateRate() {
        return _ref5.apply(this, arguments);
      }

      return updateRate;
    }(),
    getClass: function getClass(column, row) {
      if (column.prop === "tarifa") {
        return "high-percentage";
      }
      return "";
    },

    cerrarModal: function cerrarModal() {
      this.$modal.hide("agregar_tarifa");
    }
  },
  mounted: function mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de tarifas";
    this.obtenerTarifas();
    this.getListEps();
    this.getListEspecialidades();
  }
});

/***/ }),

/***/ "Vi8u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-minimize"},[_c('button',{staticClass:"btn btn-fill btn-icon",on:{"click":_vm.minimizeSidebar}},[_c('i',{class:_vm.$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'})])]),_vm._v(" "),_c('div',{staticClass:"navbar-header"},[_c('button',{staticClass:"navbar-toggle",class:{toggled: _vm.$sidebar.showSidebar},attrs:{"type":"button"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar bar1"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar2"}),_vm._v(" "),_c('span',{staticClass:"icon-bar bar3"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand"},[_vm._v(_vm._s(this.$route.name))])]),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "W/DJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W4lv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__("+Rp4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__ = __webpack_require__("1byD");






















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  data: function data() {
    return {
      searchQuery: "",
      fechaInicial: "",
      fechaFinal: "",
      queriedData2: [],
      fechaActual: "",
      tableColumns: [{
        prop: "nombreUsuario",
        label: "usuario",
        minWidth: 150,
        tipo: "text"
      }, {
        prop: "salarioFijo",
        label: "Salario fijo",
        minWidth: 100,
        tipo: "COP"
      }, {
        prop: "transporte",
        label: "Aux. Transporte",
        minWidth: 100,
        tipo: "COP"
      }, {
        prop: "pagoPorSesion",
        label: "Pago por sesión",
        minWidth: 100,
        tipo: "COP"
      }, {
        prop: "pagoPorSesionParticular",
        label: "Pago por sesión particular",
        minWidth: 100,
        tipo: "COP"
      }, {
        prop: "pagoPorSesionDomicilio",
        label: "Pago por sesión domicilio",
        minWidth: 100,
        tipo: "COP"
      }, {
        prop: "pagoPorSesionDomicilioParticular",
        label: "Pago por sesión domicilio particular",
        minWidth: 100,
        tipo: "COP"
      }, {
        prop: "pagoPorEvaluacion",
        label: "Pago por evaluación",
        minWidth: 100,
        tipo: "COP"
      }, {
        prop: "pagoPorEvaluacionDomicilio",
        label: "Pago por evaluación particular",
        minWidth: 100,
        tipo: "COP"
      }, {
        prop: "eps",
        label: "Caja de C",
        minWidth: 100,
        tipo: "COP"
      }, {
        prop: "pension",
        label: "Pensión",
        minWidth: 100,
        tipo: "COP"
      }, {
        prop: "arl",
        label: "ARL",
        minWidth: 100,
        tipo: "COP"
      }],
      json_fields: {
        "Usuario": "nombreUsuario",
        "Tipo de contrato": "tipoContrato",
        "Salario fijo": "salarioFijo",
        "Pago por sesión": "pagoPorSesion",
        "Pago por sesión particular": "pagoPorSesionParticular",
        "Pago por sesión domicilio": "pagoPorSesionDomicilio",
        "Pago por sesión domicilio particular": "pagoPorSesionDomicilioParticular",
        "Pago por evaluación": "pagoPorEvaluacion",
        "Pago por evaluación particular": "pagoPorEvaluacionDomicilio"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      SedesProgramacion: [],
      sede: "Sede Principal",
      rol: "",
      tipo: "",
      usuarioSeleccionado: {
        nombreUsuario: "",
        tipoContrato: "",
        salarioFijo: "",
        pagoPorSesion: "",
        pagoPorSesionParticular: "",
        pagoPorSesionDomicilio: "",
        pagoPorSesionDomicilioParticular: "",
        pagoPorEvaluacion: "",
        pagoPorEvaluacionDomicilio: "",
        tipoContratoId: "",
        eps: "",
        pension: "",
        arl: "",
        transporte: "",
        idUsuario: ""
      },
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  methods: {
    formatearPesosColombianos: __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__["a" /* default */],
    obtenerInformacionSalarios: function obtenerInformacionSalarios() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sede, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.$modal.show("carga");
                sede = localStorage.getItem("sede");
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/informe-salarios/" + sede);

              case 5:
                response = _context.sent;

                _this2.queriedData2 = response.data.data;
                _this2.json_data = response.data.data;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.log("Error al obtener los datos:" + _context.t0);

              case 13:
                _context.prev = 13;

                _this2.$modal.hide("carga");
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10, 13, 16]]);
      }))();
    },
    actualizarInformacion: function actualizarInformacion() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var payload, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.$modal.show("carga");
                payload = _this3.usuarioSeleccionado;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post("api/actualizar-informacion-salario", payload);

              case 5:
                response = _context2.sent;

                if (response.data.status == false) {
                  _this3.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", 'Error al actualizar la información'));
                } else {
                  _this3.obtenerInformacionSalarios();
                  _this3.cerrarModal();
                  _this3.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("success", 'Datos actualizados correctamente'));
                }
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

                console.log("Error al actualizar la información:" + _context2.t0);
                _this3.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", 'Error al actualizar la información'));

              case 13:
                _context2.prev = 13;

                _this3.$modal.hide("carga");
                return _context2.finish(13);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 9, 13, 16]]);
      }))();
    },

    modal: function modal(usuario) {
      this.usuarioSeleccionado.nombreUsuario = usuario.nombreUsuario;
      this.usuarioSeleccionado.tipoContrato = usuario.tipoContrato;
      this.usuarioSeleccionado.tipoContratoId = usuario.tipoContratoId;
      this.usuarioSeleccionado.salarioFijo = usuario.salarioFijo;
      this.usuarioSeleccionado.pagoPorSesion = usuario.pagoPorSesion;
      this.usuarioSeleccionado.pagoPorSesionParticular = usuario.pagoPorSesionParticular;
      this.usuarioSeleccionado.pagoPorSesionDomicilio = usuario.pagoPorSesionDomicilio;
      this.usuarioSeleccionado.pagoPorSesionDomicilioParticular = usuario.pagoPorSesionDomicilioParticular;
      this.usuarioSeleccionado.pagoPorEvaluacion = usuario.pagoPorEvaluacion;
      this.usuarioSeleccionado.pagoPorEvaluacionDomicilio = usuario.pagoPorEvaluacionDomicilio;
      this.usuarioSeleccionado.eps = usuario.eps;
      this.usuarioSeleccionado.pension = usuario.pension;
      this.usuarioSeleccionado.arl = usuario.arl;
      this.usuarioSeleccionado.transporte = usuario.transporte;
      this.usuarioSeleccionado.idUsuario = usuario.idUsuario;
      this.$modal.show("gestionar-salario");
    },
    cerrarModal: function cerrarModal() {
      this.usuarioSeleccionado.idUsuario = "";
      this.usuarioSeleccionado.tipoContrato = "";
      this.usuarioSeleccionado.tipoContratoId = "";
      this.usuarioSeleccionado.salarioFijo = "";
      this.usuarioSeleccionado.pagoPorSesion = "";
      this.usuarioSeleccionado.pagoPorSesionParticular = "";
      this.usuarioSeleccionado.pagoPorSesionDomicilio = "";
      this.usuarioSeleccionado.pagoPorSesionDomicilioParticular = "";
      this.usuarioSeleccionado.pagoPorEvaluacion = "";
      this.usuarioSeleccionado.pagoPorEvaluacionDomicilio = "";
      this.usuarioSeleccionado.eps = "";
      this.usuarioSeleccionado.pension = "";
      this.usuarioSeleccionado.arl = "";
      this.usuarioSeleccionado.transporte = "";
      this.usuarioSeleccionado.idUsuario = "";
      this.$modal.hide("gestionar-salario");
    },
    getClass: function getClass(column, row) {
      if (column.prop === "tipoContrato") {
        return row.classContrato;
      }
      return "";
    }
  },
  mounted: function mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de salarios";
    this.obtenerInformacionSalarios();
  }
});

/***/ }),

/***/ "WCJm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WFzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__ = __webpack_require__("x/a9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16cb2f58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__ = __webpack_require__("hgCH");
function injectStyle (ssrContext) {
  __webpack_require__("RzCZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16cb2f58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CircleChartCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16cb2f58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CircleChartCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WI53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("hJZU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218e89f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("R+H9");
function injectStyle (ssrContext) {
  __webpack_require__("bE7w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-218e89f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218e89f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WTyt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"out-in"}}),_vm._v(" "),_c('transition',{staticStyle:{"position":"relative"},attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('modal',{attrs:{"name":"carga","clickToClose":false}},[_c('div',{staticClass:"contenido_modal"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[_c('loader',{staticStyle:{"position":"absolute","padding-right":"5%","margin-bottom":"4%"},attrs:{"name":"ball-scale-multiple","color":"#E3097E","scale":"3"}}),_c('br'),_vm._v(" "),_c('h3',{staticStyle:{"padding-top":"11%","color":"#e3097e !important"}},[_vm._v("Cargando")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WTz9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        paciente: {}
    },
    data: function data() {
        return {
            url: 'https://avanti-erp.com/'
        };
    }
});

/***/ }),

/***/ "WWyB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wi7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3 col-md-1"},[_c('center',[_c('i',{staticClass:"fa fa-calendar",staticStyle:{"font-size":"300%","color":"grey"}})]),_vm._v(" "),_c('br')],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.rol == 1)?_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Sede:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailsStats),expression:"emailsStats"}],staticClass:"form-control",staticStyle:{"background-color":"white"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.emailsStats=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.getEvents('filtro')}]}},_vm._l((_vm.SedesProgramacion),function(sede){return _c('option',{key:sede.sede,domProps:{"value":sede}},[_vm._v(" "+_vm._s(sede.sede)+" ")])}),0),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.statsCards),function(stats){return _c('div',{key:stats.title,staticClass:"col-lg-3 col-sm-6"},[_c('stats-card',{staticStyle:{"box-shadow":"0px 0px 0px #999"}},[_c('div',{staticClass:"icon-big text-center",class:("icon-" + (stats.type)),attrs:{"slot":"header"},slot:"header"},[_c('i',{class:stats.icon,staticStyle:{"color":"#e3097e"}})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('strong',[_c('p',{staticStyle:{"color":"grey"}},[_vm._v(_vm._s(stats.title))])]),_vm._v(" "),_c('strong',{staticStyle:{"font-size":"40px"}},[_vm._v(_vm._s(stats.value))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_c('i',{class:stats.footerIcon}),_vm._v(" "),_c('strong',{staticStyle:{"color":"grey"}},[_vm._v(_vm._s(stats.footerText))])])])],1)})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-3 col-md-1"},[_c('center',[_c('i',{staticClass:"fa fa-calendar",staticStyle:{"font-size":"300%","color":"grey"}})]),_vm._v(" "),_c('br')],1),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha inicio:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicio),expression:"fechaInicio"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicio=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha fin:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFin),expression:"fechaFin"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaFin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFin=$event.target.value}}}),_vm._v(" "),(_vm.fechaFin < _vm.fechaInicio)?_c('span',[_vm._v("La fecha final no puede se menor a la fecha inicial")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('label',{staticStyle:{"color":"#f3f2ee"},attrs:{"for":""}},[_vm._v("dd")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.getTerapias()}}},[_vm._v("\n              Buscar "),_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_vm._l((_vm.statsCards2),function(stats){return _c('div',{key:stats.title,staticClass:"col-md-4 col-md-4"},[_c('stats-card',{staticStyle:{"box-shadow":"0px 0px 0px #999"}},[_c('div',{staticClass:"icon-big text-center",class:("icon-" + (stats.type)),attrs:{"slot":"header"},slot:"header"},[_c('i',{class:stats.icon,staticStyle:{"color":"#e3097e"}})]),_vm._v(" "),_c('div',{staticClass:"numbers",attrs:{"slot":"content"},slot:"content"},[_c('strong',[_c('p',{staticStyle:{"color":"grey"}},[_vm._v(_vm._s(stats.title))])]),_vm._v(" "),_c('strong',{staticStyle:{"font-size":"40px"}},[_vm._v(_vm._s(stats.value))])]),_vm._v(" "),_c('div',{staticClass:"stats",attrs:{"slot":"footer"},slot:"footer"},[_c('i',{class:stats.footerIcon}),_vm._v(" "),_c('strong',{staticStyle:{"color":"grey"}},[_vm._v(_vm._s(stats.footerText))])])])],1)})],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"card-header"},[(_vm.grafico == true)?_c('chartjs-pie',{attrs:{"labels":_vm.labels,"datasets":_vm.datasets,"option":_vm.option}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.resumen == true)?_c('div',{staticClass:"row"},[_c('hr'),_vm._v(" "),_c('center',[_c('div',{staticClass:"col-md-12"},[_c('strong',[_vm._v("Resumen de la información:")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',{staticStyle:{"color":"#E3097E"}},[_vm._v(" CANCELADAS: "+_vm._s(_vm.datasets[0].data[0])+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',{staticStyle:{"color":"#302254"}},[_vm._v(" REALIZADAS: "+_vm._s(_vm.datasets[0].data[1])+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',{staticStyle:{"color":"blue"}},[_vm._v(" TOTAL DE SESIONES: "+_vm._s(_vm.datasets[0].data[0] + _vm.datasets[0].data[1]))])])])],1):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"card-header"},[(_vm.grafico == true)?_c('chartjs-pie',{attrs:{"labels":_vm.labels2,"datasets":_vm.datasets2,"option":_vm.option2}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.resumen == true)?_c('div',{staticClass:"row"},[_c('hr'),_vm._v(" "),_c('center',[_c('div',{staticClass:"col-md-12"},[_c('strong',[_vm._v("Resumen de la información:")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',{staticStyle:{"color":"#E3097E"}},[_vm._v(" POLIZAS: "+_vm._s(_vm.datasets2[0].data[0])+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',{staticStyle:{"color":"#302254"}},[_vm._v(" EPS: "+_vm._s(_vm.datasets2[0].data[1])+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',{staticStyle:{"color":"grey"}},[_vm._v(" PARTICULARES: "+_vm._s(_vm.datasets2[0].data[2])+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v(" PREPAGADAS: "+_vm._s(_vm.datasets2[0].data[3])+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('strong',{staticStyle:{"color":"blue"}},[_vm._v(" TOTAL DE SESIONES: "+_vm._s(_vm.datasets2[0].data[0] + _vm.datasets2[0].data[1] +
                    _vm.datasets2[0].data[2] + _vm.datasets2[0].data[3]))])])])],1):_vm._e()],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-9 col-md-11"},[_c('p',{staticClass:"title-card"},[_c('strong',{staticStyle:{"color":"grey"}},[_vm._v("Información del día")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Administra la información actual de AVANZA.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-9 col-md-11"},[_c('p',{staticClass:"title-card"},[_c('strong',{staticStyle:{"color":"grey"}},[_vm._v("Información por fechas")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v("Administra la información por fechas de avanza de AVANZA.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wq91":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mantenimiento_eps_vue__ = __webpack_require__("zach");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f1b6fa1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mantenimiento_eps_vue__ = __webpack_require__("T353");
function injectStyle (ssrContext) {
  __webpack_require__("5cTF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mantenimiento_eps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f1b6fa1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mantenimiento_eps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X0ox":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_services_crearAlerta__ = __webpack_require__("o0VJ");






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip: "https://avanti-erp.com/",
      filter: "paciente",
      listPacientes: [],
      listTerapeutas: [],
      paciente: "",
      fecha_inicial: "",
      fecha_final: "",
      sesionesDisponibles: [],
      value: "361",
      rol: localStorage.getItem("rol"),
      tipoBuscar: "Sesiones"
    };
  },

  methods: {
    getEvents: function getEvents() {
      var _this = this;

      this.$modal.show("carga");
      var BASE_URL = this.ip + "api/cancelacion-masiva/date/" + this.fecha_inicial + "/" + this.tipoBuscar;
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this.$modal.hide("carga");
        if (res.data.status == true) {
          _this.sesionesDisponibles = res.data.data;
          console.log(res.data.data);
        } else {
          _this.$modal.hide("carga");
          _this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__global_services_crearAlerta__["a" /* default */])("danger", res.data.mensaje));
        }
      }).catch(function (err) {
        _this.$modal.hide("carga");
        alert("Ocurrió un error al traer los eventos, por favor comunique al administrador. ERROR: " + err);
        console.log(err);
      });
    },
    getListPacientes: function getListPacientes() {
      var _this2 = this;

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var sede = localStorage.getItem("sede");
      var BASE_URL = this.ip + "api/list-pacientes/" + sede;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this2.$modal.hide("carga");
        _this2.listPacientes = res.data.data;
      }).catch(function (err) {
        _this2.$modal.hide("carga");
        alert("Ocurrió un error al traer los pacientes, por favor comunique al administrador. ERROR: " + err);
        console.log(err);
      });
    },
    otraBusqueda: function otraBusqueda() {
      this.sesionesDisponibles = [];
    },
    cancelarEventos: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(evento) {
        var eventosCancelar, config, BASE_URL, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.$modal.show("carga");

                eventosCancelar = {
                  paciente: evento.pacienteId,
                  terapeuta: evento.usuarioTerapeuta,
                  fecha_inicial: this.fecha_inicial,
                  usuariocancela: localStorage.getItem("usuario")
                };
                config = {
                  headers: {
                    Authorization: "Bearer " + localStorage.getItem("token")
                  }
                };
                BASE_URL = this.ip + "api/cancelar-eventos-masivos";
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(BASE_URL, { events: eventosCancelar }, config);

              case 7:
                _ref2 = _context.sent;
                data = _ref2.data;


                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__global_services_crearAlerta__["a" /* default */])(data.status ? "success" : "danger", data.status ? data.mensaje : "Ocurrió un error, contacte al administrador"));
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                console.error("Error al cancelar eventos:", _context.t0);
                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__global_services_crearAlerta__["a" /* default */])("danger", "Ocurrió un error, contacte al administrador"));

              case 16:
                _context.prev = 16;

                this.$modal.hide("carga");
                this.getEvents();
                return _context.finish(16);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12, 16, 20]]);
      }));

      function cancelarEventos(_x) {
        return _ref.apply(this, arguments);
      }

      return cancelarEventos;
    }(),
    selectTerapeutas: function selectTerapeutas(especialidad) {
      var _this3 = this;

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/selectTerapeutasProgramar/" + especialidad;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this3.$modal.hide("carga");
        _this3.listTerapeutas = res.data.data;
      }).catch(function (err) {
        _this3.$modal.hide("carga");
        console.log(err);
      });
    },
    aceptarCYT: function aceptarCYT(sesion) {
      var _this4 = this;

      var EVENT = sesion;
      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "/api/aceptar-cyt-calendario";
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(BASE_URL, { EVENT: EVENT }, config).then(function (res) {
        _this4.$modal.hide("carga");
        if (res.data.status === true) {
          _this4.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__global_services_crearAlerta__["a" /* default */])("success", "CYT aceptado con éxito"));
          _this4.getEvents();
        }
      }).catch(function (err) {
        _this4.$modal.hide("carga");
        _this4.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__global_services_crearAlerta__["a" /* default */])("danger", mensaje));
        console.log(err);
        _this4.getEvents();
      });
    }
  },
  mounted: function mounted() {
    this.getListPacientes();
    this.selectTerapeutas(1);
  }
});

/***/ }),

/***/ "XEAq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__("+Rp4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__ = __webpack_require__("1byD");






















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  data: function data() {
    return {
      searchQuery: "",
      fechaInicial: "",
      fechaFinal: "",
      listUsers: [],
      arrayEps: [],
      categoria: "Todas",
      queriedData2: [],
      form: {
        fecha: "",
        monto: "",
        categoria: "Prestamo",
        comentario: "",
        usuario: "",
        eps: "",
        tipo: ""
      },
      fechaActual: "",
      tableColumns: [{
        prop: "nombrePaciente",
        label: "Paciente",
        minWidth: 100
      }, {
        prop: "terapeuta",
        label: "Terapeuta",
        minWidth: 100
      }, {
        prop: "fecha",
        label: "Fecha",
        minWidth: 100
      }],
      json_fields: {
        paciente: "nombrePaciente",
        terapeuta: "terapeuta",
        fecha: "fecha"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      SedesProgramacion: [],
      sede: "Sede Principal",
      rol: "",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  methods: {
    formatearPesosColombianos: __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__["a" /* default */],
    prepararRegistrar: function prepararRegistrar() {
      this.$modal.show("registrar-gasto");
    },
    obtenerInformacionDeEvoluciones: function obtenerInformacionDeEvoluciones(fechaInicial, fechaFinal) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sede, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.$modal.show("carga");
                sede = localStorage.getItem("sede");
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/obtener-evoluciones-sin-logro/" + fechaInicial + "/" + fechaFinal);

              case 5:
                response = _context.sent;

                _this2.queriedData2 = response.data.data;
                _this2.json_data = response.data.data;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.log("Error al obtener los datos:" + _context.t0);

              case 13:
                _context.prev = 13;

                _this2.$modal.hide("carga");
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10, 13, 16]]);
      }))();
    },
    getClass: function getClass(column, row) {
      if (column.prop === "valor") {
        if (row.tipo === "Efectivo") {
          return "low-percentage";
        }

        if (row.tipo === "Transferencia") {
          return "medium-percentage";
        }
      }
      return "";
    }
  },
  mounted: function mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de evoluciones sin logro de objetivo";
  }
});

/***/ }),

/***/ "XPMo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XXU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  data: function data() {
    return {
      isClosed: true,
      usuario: ''
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    getUser: function getUser() {
      this.usuario = localStorage.getItem('usuario');
    },
    cerrarSesion: function cerrarSesion() {
      this.$router.push('/');
      localStorage.removeItem('token');
      localStorage.removeItem('rol');
      localStorage.removeItem('usuario');
    }
  },
  mounted: function mounted() {
    this.getUser();
  }
});

/***/ }),

/***/ "XYHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",staticStyle:{"padding":"15px"}},[_c('div',{staticClass:"card-header"},[_c('h4',{staticStyle:{"font-size":"35px"}},[_vm._v("Hola, "+_vm._s(_vm.nombreUsuario))]),_vm._v(" "),_c('p',{staticStyle:{"color":"grey"}},[_vm._v("Información actualizada, "+_vm._s(_vm._f("date")(_vm.fecha_hoy)))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('nomicard',{staticStyle:{"background-color":"#45a22f","color":"white"},attrs:{"title":"Ingresos totales por SSR","imgRoute":"static/img/nomina/ganador.png","value":_vm.realizadas,"footerText":_vm.cardFooterText}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('nomicard',{staticStyle:{"background-color":"#d32437","color":"white"},attrs:{"title":"Servicios no completados","imgRoute":"static/img/nomina/perdida.png","value":_vm.canceladas,"footerText":_vm.cardFooterText}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('nomicard',{staticStyle:{"background-color":"#21659e","color":"white"},attrs:{"title":"Ingreso en copagos","imgRoute":"static/img/nomina/bolsa-de-dinero.png","value":_vm.copago,"footerText":_vm.cardFooterText}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('nomicard',{staticStyle:{"background-color":"#da9729","color":"white"},attrs:{"title":"Pago a terapeutas","imgRoute":"static/img/nomina/dar-dinero.png","value":_vm.terapeuta,"footerText":_vm.cardFooterText}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YCQR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-3",staticStyle:{"padding-top":"14px"}},[_c('label',{attrs:{"for":"initialDate"}},[_vm._v("Fecha inicial")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dates.initial),expression:"dates.initial"}],staticClass:"form-control",attrs:{"type":"date","id":"initialDate"},domProps:{"value":(_vm.dates.initial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dates, "initial", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3",staticStyle:{"padding-top":"14px"}},[_c('label',{attrs:{"for":"finalDate"}},[_vm._v("Fecha final")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dates.final),expression:"dates.final"}],staticClass:"form-control",attrs:{"type":"date","id":"finalDate"},domProps:{"value":(_vm.dates.final)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dates, "final", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-fill btn-success",staticStyle:{"border-radius":"7px"},on:{"click":function($event){return _vm.getSessions()}}},[_vm._v("\n                                Buscar información\n                                "),_c('i',{staticClass:"fa fa-arrow-right"})])])])]),_vm._v(" "),(_vm.data != [])?_c('div',{staticClass:"card-content"},_vm._l((_vm.data),function(terapeutas,rol){return _c('div',{staticClass:"card-especialidad"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.especialidades[rol]))]),_vm._v(" "),_c('ul',{staticStyle:{"padding-top":"10px"}},[_c('li',[_vm._v("\n                                        Total domicilio: "+_vm._s(_vm.calcularTotalesPorRol(terapeutas).Domicilio)+"\n                                    ")]),_vm._v(" "),_c('li',[_vm._v("\n                                        Total sede: "+_vm._s(_vm.calcularTotalesPorRol(terapeutas).Sede)+"\n                                    ")]),_vm._v(" "),_c('li',[_vm._v("\n                                        Total virtual: "+_vm._s(_vm.calcularTotalesPorRol(terapeutas).Virtual)+"    \n                                    ")])]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('table',{staticClass:"el-table el-table-sm table-condensed"},[_vm._m(2,true),_vm._v(" "),_c('tbody',_vm._l((terapeutas),function(terapeuta,index){return _c('tr',[_c('td',[_vm._v(_vm._s(terapeuta.nombres)+"  "+_vm._s(terapeuta.apellidos))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(terapeuta.Sede))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(terapeuta.Domicilio))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(terapeuta.Virtual))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(parseInt(terapeuta.Virtual) + parseInt(terapeuta.Domicilio) + parseInt(terapeuta.Sede)))])])}),0)])])])])}),0):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"report-title"},[_vm._v("Sesiones por terapeuta y tipo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"bold","font-size":"20px"}},[_vm._v(" Filtros ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"width":"20%"}},[_vm._v("Terapeuta")]),_vm._v(" "),_c('th',[_vm._v("Sesiones en sede")]),_vm._v(" "),_c('th',[_vm._v("Sesiones Domicilio")]),_vm._v(" "),_c('th',[_vm._v("Sesiones Virtuales")]),_vm._v(" "),_c('th',[_vm._v("Total")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YOGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */]
  },
  data: function data() {
    return {
      cardterapias: true,
      fechaInicio: "",
      fechaFin: "",
      grafico: true,
      resumen: false,
      ip: "https://avanti-erp.com/",
      nuser: 0,
      rol: "",
      sede: '',
      SedesProgramacion: [],
      emailsStats: '',
      emailsProgramacionVar: [],
      statsCards: [{
        type: "info",
        icon: "fa fa-user",
        title: "Usuarios",
        footerText: "Usuarios activos",
        footerIcon: "fa fa-user",
        value: 0
      }, {
        type: "primary",
        icon: "fa fa-calendar",
        title: "Sesiones",
        footerText: "SS programadas hoy",
        footerIcon: "fa fa-calendar",
        value: 0
      }, {
        type: "info",
        icon: "fa fa-check",
        title: "SS Realiza.",
        footerText: "SS realizadas hoy",
        footerIcon: "ti-check",
        value: 0
      }, {
        type: "primary",
        icon: "fa fa-close",
        title: "SS Cancel.",
        footerText: "SS canceladas hoy",
        footerIcon: "ti-close",
        value: 0
      }],

      statsCards2: [{
        type: "primary",
        icon: "fa fa-calendar",
        title: "Sesiones",
        footerText: "SS programadas",
        footerIcon: "fa fa-calendar",
        value: 0
      }, {
        type: "info",
        icon: "fa fa-check",
        title: "SS Realiza.",
        footerText: "SS realizadas",
        footerIcon: "ti-check",
        value: 0
      }, {
        type: "primary",
        icon: "fa fa-close",
        title: "SS Cancel.",
        footerText: "SS canceladas",
        footerIcon: "ti-close",
        value: 0
      }],

      labels: ["Canceladas", "Realizadas"],
      datasets: [{
        data: [0, 0],
        backgroundColor: ["#E3097E", "#302254"]
      }],
      option: {
        title: {
          display: true,
          position: "top",
          text: "Sesiones Programadas"
        }
      },
      labels2: ["POLIZAS", "EPS", "PARTICULARES", "PREPAGADAS"],
      datasets2: [{
        data: [0, 0, 0, 0, 0],
        backgroundColor: ["#E3097E", "#302254", "grey", "red", "blue"]
      }],
      option2: {
        title: {
          display: true,
          position: "top",
          text: "Sesiones Autorizadas"
        }
      }
    };
  },

  created: function created() {},
  methods: {
    getNumberUsers: function getNumberUsers(sede) {
      var _this = this;

      var token = localStorage.getItem("token");
      this.nuser = 0;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/npacientes/" + sede,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this.statsCards[0].value = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getTerapias: function getTerapias() {
      var _this2 = this;

      this.grafico = false;
      this.resumen = false;

      this.datasets[0].data = [];
      this.datasets2[0].data = [];
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = "https://avanti-erp.com/api/terapiasDash/" + this.fechaInicio + "/" + this.fechaFin;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this2.grafico = false;
        _this2.datasets[0].data.push(res.data.canceladas);
        _this2.datasets[0].data.push(res.data.cumplidas);

        _this2.datasets2[0].data.push(res.data.poliza);
        _this2.datasets2[0].data.push(res.data.eps);
        _this2.datasets2[0].data.push(res.data.particular);
        _this2.datasets2[0].data.push(res.data.prepagadas);

        _this2.statsCards2[0].value = res.data.canceladas + res.data.cumplidas;
        _this2.statsCards2[1].value = res.data.cumplidas;
        _this2.statsCards2[2].value = res.data.canceladas;
        console.log(_this2.datasets[0].data);
        _this2.grafico = true;
        _this2.resumen = true;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getEvents: function getEvents(moment) {
      var _this3 = this;

      var fechaActual = this.fechaEvento();
      var fechamas = this.fechamasdias(fechaActual);
      var email = '';

      if (moment == 'inicial') {
        email = localStorage.getItem("email");
      } else {
        email = this.emailsStats.correo;
      }
      console.log(this.emailsStats.sede);
      this.getNumberUsers(this.emailsStats.sede);

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://www.googleapis.com/calendar/v3/calendars/" + email + "/events?key=AIzaSyCS6MXgvS2kJs7YaIkUfFGx2O1fI9BKuC0&timeMin=" + fechaActual + "T00:00:00-05:00&timeMax=" + fechamas + "T00:00:00-05:00&singleEvents=true&maxResults=1000").then(function (res) {

        var datos = res.data.items;
        var eventos = [];
        var emailsProgramacion = _this3.emailsProgramacionVar;

        datos.forEach(function (element) {
          if (emailsProgramacion.indexOf(element.organizer.email) != -1 && element.status != "cancelled") {
            eventos.push({
              start: element.start.dateTime,
              end: element.end.dateTime
            });
          }
        });
        var sesiones = 0;
        var sesiones_necesarias = 0;
        eventos.forEach(function (element) {
          sesiones = _this3.calcularMinutos(_this3.horaFormateada(element.start), _this3.horaFormateada(element.end));
          sesiones_necesarias = sesiones_necesarias + sesiones;
        });

        _this3.statsCards[1].value = sesiones_necesarias;
        if (moment != 'incial') {
          _this3.estadistica();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    horaFormateada: function horaFormateada(fecha) {
      var hora = new Date(fecha).getHours();
      var minutos = new Date(fecha).getMinutes();
      if (minutos == 0) {
        minutos = "00";
      }
      var horaFormateada = hora + ":" + minutos;
      return horaFormateada;
    },
    devolverMinutos: function devolverMinutos(horaMinutos) {
      return parseInt(horaMinutos.split(":")[0]) * 60 + parseInt(horaMinutos.split(":")[1]);
    },
    calcularMinutos: function calcularMinutos(inicio, fin) {
      var horaInicial = this.devolverMinutos(inicio);
      var horaFinal = this.devolverMinutos(fin);

      if (horaInicial < horaFinal) {
        var sesiones = (horaFinal - horaInicial) / 30;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(sesiones);
      } else {}
    },
    estadistica: function estadistica() {
      var _this4 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var fecha = this.fechaEvento();
      var sede = this.emailsStats.sede;
      var BASE_URL = this.ip + "api/estadisticaTerapias/" + fecha + "/" + sede;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(BASE_URL, config).then(function (res) {
        _this4.statsCards[2].value = res.data.cumplidas;
        _this4.statsCards[3].value = res.data.canceladas;
        _this4.statsCards[1].value = res.data.programadas;
      }).catch(function (err) {
        console.log(err);
      });
    },
    fechaEvento: function fechaEvento() {
      var fecha = new Date();
      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      return fechaFormateada;
    },

    fechamasdias: function fechamasdias(fecha) {
      var fecha = new Date(fecha);
      fecha.setDate(fecha.getDate() + 2);


      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      return fechaFormateada;
    },
    emailsProgramacion: function emailsProgramacion() {
      var _this5 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/emailsProgramacion";
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this5.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    this.getNumberUsers(localStorage.getItem('sede'));
    this.emailsProgramacion();
    this.rol = localStorage.getItem("rol");
    this.emailsStats = { correo: localStorage.getItem("email"), sede: localStorage.getItem('sede') };
    var emailsProgramacion = localStorage.getItem('emailsProgramacion');
    this.emailsProgramacionVar = JSON.parse(emailsProgramacion);

    this.estadistica();
    window.document.title = "Avanti | Dashboard";
    if (localStorage.getItem('rol') != 1) {
      this.sede = localStorage.getItem('sede');
    }
  }
});

/***/ }),

/***/ "Yg7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('dia')],1),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha inicial: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",staticStyle:{"background-color":"white","border":"none","border-radius":"10px"},attrs:{"type":"date"},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha inicial: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",staticStyle:{"background-color":"white","border":"none","border-radius":"10px"},attrs:{"type":"date"},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"8px"},on:{"click":function($event){return _vm.actualizarInformacion()}}},[_vm._v("Buscar información")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('informacionfecha',{ref:"componenteInformacionFechas"})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('nomina',{ref:"componenteNomina"}),_vm._v(" "),_c('informacionEntidad',{ref:"componenteEntidades"}),_vm._v(" "),_c('informacionTerapeutas',{ref:"componenteTerapeutas"})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('gastos',{ref:"componenteGastos"}),_vm._v(" "),_c('informacionEspecialidad',{ref:"componenteEspecialidades"})],1)]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Información por fechas")]),_vm._v(" "),_c('p',[_vm._v("Administra la información contable de avanza según un rango de fechas")]),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"}),_vm._v(" "),_c('div',{staticClass:"col-md-6"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Yncg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autorizaciones_vue__ = __webpack_require__("DkcV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f3aebcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autorizaciones_vue__ = __webpack_require__("g187");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autorizaciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f3aebcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autorizaciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YoFX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZeQe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_aDashboard_nomina_cardnomina_vue__ = __webpack_require__("DBcq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_services_formatear_pesos__ = __webpack_require__("1byD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_services_fecha_actual__ = __webpack_require__("Kscm");










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    nomicard: __WEBPACK_IMPORTED_MODULE_3_src_components_aDashboard_nomina_cardnomina_vue__["a" /* default */]
  },
  data: function data() {
    return {
      realizadas: 0,
      canceladas: 0,
      copago: 0,
      terapeuta: 0,
      cardFooterText: 'Información actual',
      nombreUsuario: localStorage.getItem('nombre'),
      fecha_hoy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__global_services_fecha_actual__["a" /* default */])()
    };
  },

  methods: {
    getInformationToday: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var date, BASE_URL, response, information;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                date = this.calcularFechaActual();
                BASE_URL = "api/informationNominaToday/" + date + "/" + date;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5_src_global_services_axiosInstance__["a" /* default */].get(BASE_URL);

              case 5:
                response = _context.sent;
                information = response.data.data[0];

                this.realizadas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__global_services_formatear_pesos__["a" /* default */])(information.Realizadas);
                this.canceladas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__global_services_formatear_pesos__["a" /* default */])(information.Canceladas);
                this.copago = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__global_services_formatear_pesos__["a" /* default */])(information.Copago);
                this.terapeuta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__global_services_formatear_pesos__["a" /* default */])(information.Terapeuta);
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 16:
                _context.prev = 16;
                return _context.finish(16);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13, 16, 18]]);
      }));

      function getInformationToday() {
        return _ref.apply(this, arguments);
      }

      return getInformationToday;
    }(),
    calcularFechaActual: function calcularFechaActual() {
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = ("0" + (fecha_hoy.getMonth() + 1)).slice(-2);
      var ahora_dia = ("0" + fecha_hoy.getDate()).slice(-2);

      return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
    }
  },
  mounted: function mounted() {
    this.getInformationToday();
  }
});

/***/ }),

/***/ "aCDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "aHw6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_convenio_vue__ = __webpack_require__("SpjM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e2b6fd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_convenio_vue__ = __webpack_require__("oDAD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_convenio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e2b6fd2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_convenio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "alJ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "amSi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_descargos_vue__ = __webpack_require__("cS4E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a4e75b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_descargos_vue__ = __webpack_require__("Rgrq");
function injectStyle (ssrContext) {
  __webpack_require__("IIyn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_descargos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a4e75b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_descargos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "as5r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "atf9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bE7w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_879b8aa4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("6V8M");
function injectStyle (ssrContext) {
  __webpack_require__("u3/v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_879b8aa4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cDSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cS4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__("+Rp4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__ = __webpack_require__("1byD");






















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  data: function data() {
    return {
      searchQuery: "",
      fechaInicial: "",
      fechaFinal: "",
      concepto: 'Informe atrasado',
      nota: '',
      terapeuta: '',
      valor: '',
      queriedData2: [],
      arrayTerapeutas: [],
      fechaActual: "",
      tableColumns: [{
        prop: "terapeuta",
        label: "Usuario",
        minWidth: 180 }, {
        prop: "fecha",
        label: "Fecha",
        minWidth: 180 }, {
        prop: "valor",
        label: "Monto",
        minWidth: 100 }, {
        prop: "concepto",
        label: "Concepto",
        minWidth: 100 }, {
        prop: "nota",
        label: "Notas",
        minWidth: 100 }],
      json_fields: {
        Usuario: "nombreUsuario",
        "Tipo de contrato": "tipoContrato",
        "Salario fijo": "salarioFijo",
        "Pago por sesión": "pagoPorSesion",
        "Pago por sesión domicilio": "pagoPorSesionDomicilio"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      sede: "Sede Principal",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  methods: {
    formatearPesosColombianos: __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__["a" /* default */],
    cerrarModal: function cerrarModal() {
      this.concepto = 'Informe atrasado';
      this.terapeuta = '';
      this.nota = '';
      this.valor = '';
      this.$modal.hide('registrar-descarte');
    },
    prepararRegistrar: function prepararRegistrar() {
      this.concepto = 'Informe atrasado';
      this.terapeuta = '';
      this.nota = '';
      this.valor = '';
      this.$modal.show('registrar-descarte');
    },
    selectTerapeuta: function selectTerapeuta(especialidad) {
      var _this2 = this;

      this.$modal.show("carga");
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = "api/selectTerapeutasProgramar/" + especialidad;
      __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get(BASE_URL, config).then(function (res) {
        _this2.$modal.hide("carga");
        _this2.arrayTerapeutas = res.data.data;
      }).catch(function (err) {
        _this2.$modal.hide("carga");
        console.log(err);
      });
    },
    newDiscard: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, response, fecha;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.valor == '' || this.terapeuta == '')) {
                  _context.next = 3;
                  break;
                }

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", "Complete los campos requeridos"));
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;

                this.$modal.show("carga");
                data = {
                  terapeuta: this.terapeuta,
                  valor: this.valor,
                  concepto: this.concepto,
                  nota: this.nota,
                  fecha: this.calcularFechaActual()
                };
                _context.next = 8;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post('api/newDiscard', data);

              case 8:
                response = _context.sent;


                if (response.data.status === true) {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])('success', response.data.mensaje));
                  fecha = this.calcularFechaActual();

                  this.fechaInicial = fecha;
                  this.fechaFinal = fecha;
                  this.obtenerInformacionDescargos(fecha, fecha);
                } else {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])('danger', response.data.mensaje));
                }
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](3);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])('danger', _context.t0));

              case 15:
                _context.prev = 15;

                this.$modal.hide("carga");
                this.cerrarModal();
                return _context.finish(15);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 12, 15, 19]]);
      }));

      function newDiscard() {
        return _ref.apply(this, arguments);
      }

      return newDiscard;
    }(),
    obtenerInformacionDescargos: function obtenerInformacionDescargos(fechaInicial, fechaFinal) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var sede, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(fechaInicial == "" || fechaFinal == "")) {
                  _context2.next = 3;
                  break;
                }

                _this3.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", "Seleccione las fechas en las que quiere ver la información"));
                return _context2.abrupt("return");

              case 3:
                _context2.prev = 3;

                _this3.$modal.show("carga");
                sede = localStorage.getItem("sede");
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/informe-descartes/" + fechaInicial + "/" + fechaFinal + "/" + sede);

              case 8:
                response = _context2.sent;

                _this3.queriedData2 = response.data.data;
                _this3.json_data = response.data.data;
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](3);

                _this3.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])('danger', _context2.t0));

              case 16:
                _context2.prev = 16;

                _this3.$modal.hide("carga");
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[3, 13, 16, 19]]);
      }))();
    },

    deleteDiscart: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(descarte) {
        var data, response, fecha;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.$modal.show("carga");
                data = { id: descarte.id };
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post("api/deleteDiscard", data);

              case 5:
                response = _context3.sent;


                if (response.data.status === true) {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])('success', response.data.mensaje));
                  fecha = this.calcularFechaActual();

                  this.fechaInicial = fecha;
                  this.fechaFinal = fecha;
                  this.obtenerInformacionDescargos(fecha, fecha);
                } else {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])('danger', response.data.mensaje));
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])('danger', _context3.t0));

              case 12:
                _context3.prev = 12;

                this.$modal.hide("carga");
                return _context3.finish(12);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9, 12, 15]]);
      }));

      function deleteDiscart(_x) {
        return _ref2.apply(this, arguments);
      }

      return deleteDiscart;
    }(),
    getClass: function getClass(column, row) {
      if (column.prop === "valor") {
        return "low-percentage";
      }
      return "";
    },
    calcularFechaActual: function calcularFechaActual() {
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    }
  },

  mounted: function mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    var fechaInicial = this.calcularFechaActual();
    this.fechaInicial = fechaInicial;
    this.fechaFinal = fechaInicial;
    document.title = "Avanti | Gestión de descargos";
    this.selectTerapeuta(1);
    this.obtenerInformacionDescargos(fechaInicial, fechaInicial);
  }
});

/***/ }),

/***/ "cmih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"type_report"}},[_vm._v("Seleccione el Paciente")]),_vm._v(" "),(_vm.type_report == 'paciente')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"form-control",staticStyle:{"background-color":"white"},attrs:{"id":"type_report"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.value=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"todos","selected":""}},[_vm._v("Todos...")]),_vm._v(" "),_vm._l((_vm.listPacientes),function(paciente){return _c('option',{key:paciente.id,domProps:{"value":paciente.id}},[_vm._v("\n            "+_vm._s(paciente.apellidos)+" "+_vm._s(paciente.nombres)+"\n          ")])})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"type_report"}},[_vm._v("Seleccione el periodo")]),_vm._v(" "),(_vm.type_report == 'paciente')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.periodo),expression:"periodo"}],staticClass:"form-control",staticStyle:{"background-color":"white"},attrs:{"id":"type_report"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.periodo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.optionPeriods),function(periodo){return _c('option',{key:periodo.label,domProps:{"value":periodo}},[_vm._v("\n            "+_vm._s(periodo.label)+"\n          ")])}),0):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"type_report"}},[_vm._v("Seleccione el año")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.year),expression:"year"}],staticClass:"form-control",staticStyle:{"background-color":"white"},attrs:{"type":"number","id":"year","name":"year","min":"2025","max":_vm.currentYear,"step":"1","placeholder":"Año"},domProps:{"value":(_vm.year)},on:{"input":function($event){if($event.target.composing){ return; }_vm.year=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3",staticStyle:{"margin-top":"25px"}},[_c('button',{staticClass:"btn btn-success btn-block btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.getObjetives()}}},[_vm._v("\n          Buscar\n        ")])]),_vm._v(" "),_c('div')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("fff")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"Objetivos y logros","name":"Reporte de objetivos"}},[_vm._v("\n            Exportar todos "),_c('i',{staticClass:"fa fa-download",attrs:{"color":"black"}})]):_vm._e()],1)]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacíos","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{ref:"component",staticClass:"col-md-12"},[_c('div',[_c('el-table',{staticClass:"table-condensed table-responsive",attrs:{"data":_vm.queriedData,"border":""}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('span',[_c('center',[_vm._v(_vm._s(row[column.prop]))])],1)]}}],null,true)})}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Tareas","min-width":"1000"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('table',{staticClass:"table table-condensed table-responsive",staticStyle:{"border-radius":"8px"}},[_c('tr',[_c('th',{staticStyle:{"max-width":"500px"}},[_c('center',[_vm._v("Tarea")])],1),_vm._v(" "),_c('th',[_c('center',[_vm._v("Calificación")])],1)]),_vm._v(" "),_vm._l((row.tareas),function(tarea){return _c('tr',{key:tarea.description},[_c('td',{staticStyle:{"align-items":"center","min-width":"500px","max-width":"500px"}},[_c('center',[_vm._v("\n                          "+_vm._s(tarea.description)+"\n                        ")])],1),_vm._v(" "),_c('td',[_c('center',[(tarea.calificaciones[0] == 'Pendiente evaluar')?_c('p',[_c('span',[_vm._v("Pendiente evaluación")])]):_c('p',[_vm._v(_vm._s(tarea.calificaciones[0])+"%")])])],1)])})],2)]}}],null,false,3405116421)}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"120","label":"Exportar","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-fill btn-sm btn-success",staticStyle:{"border-radius":"5px"},attrs:{"title":"Exportar a PDF"},on:{"click":function($event){return _vm.abrirSeleccionarPeriodo(props.row)}}},[_c('i',{staticClass:"ti-file"}),_vm._v(" Exportar\n                    ")])])]}}],null,false,1314749087)})],2)],1)]):_vm._e()]),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()]),_vm._v(" "),_c('modal',{attrs:{"name":"seleccionarPeriodo"}},[_c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("\n          Selecciona el periodo de evaluación que quieres visualizar en el\n          reporte\n        ")])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"periodo"}},[_vm._v("Selecciona el periodo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.periodoVisualizacion),expression:"periodoVisualizacion"}],staticClass:"form-control",attrs:{"id":"periodo"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.periodoVisualizacion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"all"}},[_vm._v("Todos los periodos de evaluación")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Periodo 1 de evaluación")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Periodo 2 de evaluación")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Periodo 3 de evaluación")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-danger",staticStyle:{"border-radius":"7px"},on:{"click":function($event){return _vm.cerrarSeleccionarPeriodo()}}},[_vm._v("\n                Cancelar\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"7px"},on:{"click":function($event){return _vm.generarPDF(_vm.objetivoSeleccionado)}}},[_vm._v("\n                Imprimir informe\n              ")])])],1)])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Objetivos y tareas")]),_vm._v(" "),_c('p',{staticStyle:{"color":"darkgray","margin-bottom":"30px"}},[_vm._v("\n      Reporte donde se puede ver los objetivos y tareas de un\n      "),_c('span',{staticClass:"text-success"},[_vm._v("paciente")]),_vm._v(".\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cq/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__("+Rp4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__ = __webpack_require__("1byD");






















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  data: function data() {
    return {
      searchQuery: "",
      fechaInicial: "",
      fechaFinal: "",
      listUsers: [],
      categoria: "Todas",
      queriedData2: [],
      form: {
        fecha: "",
        monto: "",
        categoria: "Prestamo",
        comentario: "",
        usuario: ""
      },
      fechaActual: "",
      tableColumns: [{
        prop: "fecha",
        label: "Fecha",
        minWidth: 100
      }, {
        prop: "valor",
        label: "Monto $",
        minWidth: 100
      }, {
        prop: "usuario",
        label: "Usuario",
        minWidth: 110
      }, {
        prop: "comentario",
        label: "Comentario",
        minWidth: 300
      }],
      json_fields: {
        fecha: "fecha",
        monto: "valor",
        categoria: "categoria",
        comentarios: "comentario"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      SedesProgramacion: [],
      sede: "Sede Principal",
      rol: "",
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  methods: {
    formatearPesosColombianos: __WEBPACK_IMPORTED_MODULE_17__global_services_formatear_pesos__["a" /* default */],
    prepararRegistrar: function prepararRegistrar() {
      this.$modal.show("registrar-gasto");
    },
    obtenerInformacionGastos: function obtenerInformacionGastos(fechaInicial, fechaFinal, categoria) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sede, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.$modal.show("carga");
                sede = localStorage.getItem("sede");
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/informe-gastos-variables/" + fechaInicial + "/" + fechaFinal + "/" + categoria);

              case 5:
                response = _context.sent;

                _this2.queriedData2 = response.data.data;
                _this2.json_data = response.data.data;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.log("Error al obtener los datos:" + _context.t0);

              case 13:
                _context.prev = 13;

                _this2.$modal.hide("carga");
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10, 13, 16]]);
      }))();
    },
    registrarGasto: function registrarGasto() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.$modal.show("carga");
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post("api/newExpenseVariable", _this3.form);

              case 4:
                response = _context2.sent;

                if (response.data.status == true) {
                  _this3.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("success", response.data.mensaje));
                  _this3.obtenerInformacionGastos(_this3.form.fecha, _this3.form.fecha);
                  _this3.fechaInicial = _this3.form.fecha;
                  _this3.fechaFinal = _this3.form.fecha;
                  _this3.resetForm();
                }
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.log(_context2.t0);
                _this3.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", "Ocurrió un error, intentelo de nuevo."));

              case 12:
                _context2.prev = 12;

                _this3.$modal.hide("carga");
                _this3.$modal.hide("registrar-gasto");
                return _context2.finish(12);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 8, 12, 16]]);
      }))();
    },

    deleteExpense: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(gasto) {
        var data, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                this.$modal.show("carga");
                data = { id: gasto.id };
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].post("api/deleteExpense", data);

              case 5:
                response = _context3.sent;


                if (response.data.status === true) {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("success", response.data.mensaje));
                  this.obtenerInformacionGastos(this.fechaInicial, this.fechaFinal, this.categoria);
                } else {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", response.data.mensaje));
                }
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", _context3.t0));

              case 12:
                _context3.prev = 12;

                this.$modal.hide("carga");
                return _context3.finish(12);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9, 12, 15]]);
      }));

      function deleteExpense(_x) {
        return _ref.apply(this, arguments);
      }

      return deleteExpense;
    }(),
    getListUsers: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                this.$modal.show("carga");
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/get-list-users");

              case 4:
                response = _context4.sent;


                if (response.data.status === true) {
                  this.listUsers = response.data.data;
                } else {
                  this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", response.data.mensaje));
                }
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__global_services_crearAlerta__["a" /* default */])("danger", _context4.t0));

              case 11:
                _context4.prev = 11;

                this.$modal.hide("carga");
                return _context4.finish(11);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8, 11, 14]]);
      }));

      function getListUsers() {
        return _ref2.apply(this, arguments);
      }

      return getListUsers;
    }(),
    resetForm: function resetForm() {
      this.form.fecha = "";
      this.form.monto = "";
      this.form.categoria = "Prestamo";
      this.form.comentario = "";
      this.form.usuario = "";
    },
    cerrarModal: function cerrarModal() {
      this.resetForm();
      this.$modal.hide("registrar-gasto");
    },
    getClass: function getClass(column, row) {
      if (column.prop === "valor") {
        if (row.categoria === "Prestamo") {
          return "low-percentage";
        }

        if (row.categoria === "Gasto general") {
          return "medium-percentage";
        }

        if (row.categoria === "Gasto servicios") {
          return "high-percentage";
        }

        return "info-percentage";
      }
      return "";
    }
  },
  mounted: function mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Avanti | Gestión de salarios";
    this.getListUsers();
  }
});

/***/ }),

/***/ "dD14":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__global_services_formatear_pesos__ = __webpack_require__("1byD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");



















__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    PPagination: __WEBPACK_IMPORTED_MODULE_15_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedDataPendiente: function pagedDataPendiente() {
      return this.objetivosPendientes.slice(this.fromPendiente, this.toPendiente);
    },
    objetivosPendientesPag: function objetivosPendientesPag() {
      var _this = this;

      if (!this.searchQuery) {
        this.paginationPendiente.total = this.objetivosPendientes.length;
        return this.pagedDataPendiente;
      }
      var result = this.objetivosPendientes.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.paginationPendiente.total = result.length;
      return result.slice(this.fromPendiente, this.toPendiente);
    },
    toPendiente: function toPendiente() {
      var highBound = this.fromPendiente + this.paginationPendiente.perPage;
      if (this.totalPendiente < highBound) {
        highBound = this.totalPendiente;
      }
      return highBound;
    },
    fromPendiente: function fromPendiente() {
      return this.paginationPendiente.perPage * (this.paginationPendiente.currentPage - 1);
    },
    totalPendiente: function totalPendiente() {
      this.paginationPendiente.total = this.objetivosPendientes.length;
      return this.objetivosPendientes.length;
    },
    pagedDataPacientesCargo: function pagedDataPacientesCargo() {
      return this.pacientesCargo.slice(this.fromPacienteCargo, this.toPacienteCargo);
    },
    pacientesCargoPag: function pacientesCargoPag() {
      var _this2 = this;

      if (!this.searchPaciente) {
        this.paginationPacienteCargo.total = this.pacientesCargo.length;
        return this.pagedDataPacientesCargo;
      }
      var result = this.pacientesCargo.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this2.propsToSearch), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this2.searchPaciente.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return isIncluded;
      });
      this.paginationPacienteCargo.total = result.length;
      return result.slice(this.fromPacienteCargo, this.toPacienteCargo);
    },
    toPacienteCargo: function toPacienteCargo() {
      var highBound = this.fromPacienteCargo + this.paginationPacienteCargo.perPage;
      if (this.totalPacienteCargo < highBound) {
        highBound = this.totalPacienteCargo;
      }
      return highBound;
    },
    fromPacienteCargo: function fromPacienteCargo() {
      return this.paginationPacienteCargo.perPage * (this.paginationPacienteCargo.currentPage - 1);
    },
    totalPacienteCargo: function totalPacienteCargo() {
      this.paginationPacienteCargo.total = this.pacientesCargo.length;
      return this.pacientesCargo.length;
    },
    pagedDataObjetivosProximos: function pagedDataObjetivosProximos() {
      return this.objetivosProximos.slice(this.fromObjetivosProximos, this.toObjetivosProximos);
    },
    objetivosProximosPag: function objetivosProximosPag() {
      var _this3 = this;

      if (!this.searchQuery) {
        this.paginationProximo.total = this.objetivosProximos.length;
        return this.pagedDataObjetivosProximos;
      }
      var result = this.objetivosProximos.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this3.propsToSearch), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var key = _step3.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this3.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return isIncluded;
      });
      this.paginationProximo.total = result.length;
      return result.slice(this.fromObjetivosProximos, this.toObjetivosProximos);
    },
    toObjetivosProximos: function toObjetivosProximos() {
      var highBound = this.fromObjetivosProximos + this.paginationProximo.perPage;
      if (this.totalObjetivosProximo < highBound) {
        highBound = this.totalObjetivosProximo;
      }
      return highBound;
    },
    fromObjetivosProximos: function fromObjetivosProximos() {
      return this.paginationProximo.perPage * (this.paginationProximo.currentPage - 1);
    },
    totalObjetivosProximo: function totalObjetivosProximo() {
      this.paginationProximo.total = this.objetivosProximos.length;
      return this.objetivosProximos.length;
    },
    pagedDataSesionesRR: function pagedDataSesionesRR() {
      return this.hisAtenciones.slice(this.fromSesionesRR, this.toSesionesRR);
    },
    sesionesRRPag: function sesionesRRPag() {
      var _this4 = this;

      if (!this.searchQuery) {
        this.paginationProximo.total = this.hisAtenciones.length;
        return this.pagedDataSesionesRR;
      }
      var result = this.hisAtenciones.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this4.propsToSearch), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var key = _step4.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this4.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        return isIncluded;
      });
      this.paginationSesionesRR.total = result.length;
      return result.slice(this.fromSesionesRR, this.toSesionesRR);
    },
    toSesionesRR: function toSesionesRR() {
      var highBound = this.fromSesionesRR + this.paginationSesionesRR.perPage;
      if (this.totalSesionesRR < highBound) {
        highBound = this.totalSesionesRR;
      }
      return highBound;
    },
    fromSesionesRR: function fromSesionesRR() {
      return this.paginationSesionesRR.perPage * (this.paginationSesionesRR.currentPage - 1);
    },
    totalSesionesRR: function totalSesionesRR() {
      this.paginationSesionesRR.total = this.hisAtenciones.length;
      return this.hisAtenciones.length;
    }
  },
  data: function data() {
    return {
      selectTerapeuta: '',
      optionTerapeuta: [],
      searchQuery: "",
      fechaActual: "",
      fechaFin: "",
      paginationPendiente: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      paginationProximo: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      searchPaciente: "",
      paginationPacienteCargo: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      paginationSesionesRR: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      propsToSearch: ["PacNom1", "PacApe1", "PacNumDoc", "PacFecNac", "PacFecIng"],
      ip: "https://avanti-erp.com/",
      pacientesCargo: [],
      objetivosProximos: [],
      objetivosPendientes: [],
      hisAtenciones: [],
      foto: "",
      usuario: '',
      nombre: '',
      especialidad: '',
      fechaInicioHis: "",
      fechaFinHis: "",

      card_dia: [{
        title: "SSP Virtuales",
        value: 0,
        icon: "fa fa-play",
        img: "static/img/ICONOS/consulta virtual.svg"
      }, {
        title: "SSP Presen.",
        value: 0,
        icon: "fa fa-users",
        img: "static/img/ICONOS/familia.svg"
      }, {
        title: "SSP Totales",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSPP.svg"
      }],
      card_dia2: [{
        title: "SSR virtuales",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/consulta virtual.svg"
      }, {
        title: "SSR domicilio",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/AARR.svg"
      }, {
        title: "SSR Cancel.",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSCC.svg"
      }, {
        title: "SSR Totales",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSPP.svg"
      }],


      json_fieldsProximos: {
        Nombres: "PacNom1",
        Apellidos: "PacApe1",
        "Fecha objetivo": "ObjFec",
        "Fecha fin objetivo": "ObjFecCum",
        Objetivo: "ObjObj"
      },
      json_fieldsPacientes: {
        Nombres: "PacNom1",
        Apellidos: "PacApe1",
        "Numero Documento": "PacNumDoc",
        "Edad": "Edad",
        "Dx": "dx",
        "Terapeuta": "Terapeuta",
        "Especialiad": "Especialidad"
      },
      json_fieldsAtenciones: {
        Nombres: "PacNom1",
        Apellidos: "PacApe1",
        "Fecha de atención": "ProFec",
        hora: "hora",
        "Hora fin": "horaFin",
        lugar: "ProLug",
        "Tipo de sesión": "ProTip",
        "Pago al terapeuta": "ProValTer"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]]
    };
  },
  methods: {
    formatearPesosColombianos: __WEBPACK_IMPORTED_MODULE_13__global_services_formatear_pesos__["a" /* default */],
    selectTerapeutasFun: function selectTerapeutasFun() {
      var _this5 = this;

      var BASE_URL = this.ip + "api/selectTerapeutasMiEspacio";
      __WEBPACK_IMPORTED_MODULE_14_axios___default.a.get(BASE_URL).then(function (res) {
        _this5.optionTerapeuta = res.data.data;
      });
    },
    getEvents: function getEvents() {
      var _this6 = this;

      var fechaF = this.fechamasdias(this.fechaActual);
      __WEBPACK_IMPORTED_MODULE_14_axios___default.a.get("https://www.googleapis.com/calendar/v3/calendars/" + this.selectTerapeuta.email + "/events?key=AIzaSyCS6MXgvS2kJs7YaIkUfFGx2O1fI9BKuC0&timeMin=" + this.fechaActual + "T00:00:00-05:00&timeMax=" + fechaF + "T00:00:00-05:00&maxResults=100").then(function (res) {
        var datos = res.data.items;
        var domicilio = 0;
        var virtual = 0;
        datos.forEach(function (element) {
          var tuDate1 = new Date();
          var tuDate2 = new Date(element.start.dateTime);

          var a = new Date(tuDate1.getFullYear(), tuDate1.getMonth(), tuDate1.getDate());
          var b = new Date(tuDate2.getFullYear(), tuDate2.getMonth(), tuDate2.getDate());

          if (element.location) {
            if (+a == +b) {
              virtual = virtual + _this6.calcularMinutos(_this6.horaFormateada(element.start.dateTime), _this6.horaFormateada(element.end.dateTime));
            }
          } else {
            if (+a == +b) {
              domicilio = domicilio + _this6.calcularMinutos(_this6.horaFormateada(element.start.dateTime), _this6.horaFormateada(element.end.dateTime));
            }
          }
        });
        _this6.card_dia[1].value = domicilio;
        _this6.card_dia[0].value = virtual;
        _this6.card_dia[2].value = domicilio + virtual;
      }).catch(function (err) {
        console.log(err);
      });
    },
    horaFormateada: function horaFormateada(fecha) {
      var hora = new Date(fecha).getHours();
      var minutos = new Date(fecha).getMinutes();
      if (minutos == 0) {
        minutos = "00";
      }
      var horaFormateada = hora + ":" + minutos;
      return horaFormateada;
    },
    calcularMinutos: function calcularMinutos(inicio, fin) {
      var horaInicial = this.devolverMinutos(inicio);
      var horaFinal = this.devolverMinutos(fin);

      if (horaInicial < horaFinal) {
        var sesiones = (horaFinal - horaInicial) / 30;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(sesiones);
      } else {}
    },
    devolverMinutos: function devolverMinutos(horaMinutos) {
      return parseInt(horaMinutos.split(":")[0]) * 60 + parseInt(horaMinutos.split(":")[1]);
    },

    fechamasdias: function fechamasdias(fecha) {
      var fecha = new Date(fecha);
      fecha.setDate(fecha.getDate() + 10);


      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      return fechaFormateada;
    },
    calcularFechaActual: function calcularFechaActual() {
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      this.fechaFin = this.fechamasdias(this.fechaActual);
      this.objetivosProximosFun();
    },

    objetivosPendientesFun: function objetivosPendientesFun() {
      var _this7 = this;

      var datos = [];
      var BASE_URL = this.ip + "api/objetivosPendienteConfirmar/" + this.selectTerapeuta.usuario + "/" + this.fechaActual;
      __WEBPACK_IMPORTED_MODULE_14_axios___default.a.get(BASE_URL).then(function (res) {
        if (res.data.status == true) {}

        datos = res.data.data.concat(res.data.data2);

        datos.sort(function (a, b) {
          if (a.ObjFec > b.ObjFec) {
            return -1;
          }
          if (a.ObjFec < b.ObjFec) {
            return 1;
          }

          return 0;
        });
        _this7.objetivosPendientes = datos;
        console.log(_this7.objetivosPendientes, 'pendientes');
      }).catch(function (err) {
        console.log(err);
      });
    },
    objetivosProximosFun: function objetivosProximosFun() {
      var _this8 = this;

      var fecha = this.fechamasdias(this.fechaActual);
      var BASE_URL = this.ip + "api/objetivosProximos/" + this.selectTerapeuta.usuario + "/" + this.fechaActual + "/" + fecha;
      __WEBPACK_IMPORTED_MODULE_14_axios___default.a.get(BASE_URL).then(function (res) {
        if (res.data.status == true) {
          _this8.objetivosProximos = res.data.data;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    pacientesCargoFun: function pacientesCargoFun() {
      var _this9 = this;

      var BASE_URL = this.ip + "api/pacientesCargo/" + this.selectTerapeuta.usuario + "/" + this.selectTerapeuta.id_rol;
      __WEBPACK_IMPORTED_MODULE_14_axios___default.a.get(BASE_URL).then(function (res) {
        if (res.data.status == true) {
          var datos = res.data.data;
          var datos_f = [];
          _this9.pacientesCargo = res.data.data;
          for (var index = 0; index < datos.length; index++) {
            datos_f.push({
              PacApe1: datos[index].PacApe1,
              PacNom1: datos[index].PacNom1,
              PacFecNac: datos[index].PacFecNac,
              PacNumDoc: datos[index].PacNumDoc,
              Edad: _this9.calcularEdad(datos[index].PacFecNac),
              dx: datos[index].dx,
              Terapeuta: _this9.nombre,
              Especialidad: _this9.especialidad
            });

            _this9.pacientesCargo = datos_f;
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    hisSesiones: function hisSesiones() {
      var _this10 = this;

      var BASE_URL = this.ip + "api/hisSesiones/" + this.selectTerapeuta.usuario + "/" + this.fechaInicioHis + "/" + this.fechaFinHis;
      __WEBPACK_IMPORTED_MODULE_14_axios___default.a.get(BASE_URL).then(function (res) {
        if (res.data.status == true) {
          _this10.hisAtenciones = res.data.data;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    hisSesionesHoy: function hisSesionesHoy() {
      var _this11 = this;

      var BASE_URL = this.ip + "api/hisSesionesHoy/" + this.selectTerapeuta.usuario + "/" + this.selectTerapeuta.email + "/" + this.fechaActual;
      __WEBPACK_IMPORTED_MODULE_14_axios___default.a.get(BASE_URL).then(function (res) {
        if (res.data.status == true) {
          _this11.card_dia2[0].value = res.data.terapiasV;
          _this11.card_dia2[1].value = res.data.terapiasD;
          _this11.card_dia2[2].value = res.data.terapiasC;
          _this11.card_dia2[3].value = res.data.terapiasV + res.data.terapiasD + res.data.terapiasC;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    calcularEdad: function calcularEdad(fecha) {

      var fechaNacimiento = fecha;
      var values = fechaNacimiento.split("-");
      var dia = values[2];
      var mes = values[1];
      var ano = values[0];

      var fecha_hoy = new Date();
      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;


      var edad = ahora_ano + 0 - ano;
      if (ahora_mes < mes) {
        edad--;
      }
      if (mes == ahora_mes && ahora_dia < dia) {
        edad--;
      }
      if (edad > 1900) {
        edad -= 1900;
      }

      var meses = 0;
      if (ahora_mes > mes) meses = ahora_mes - mes;
      if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
      if (ahora_mes == mes && dia > ahora_dia) meses = 11;

      var dias = 0;
      if (ahora_dia > dia) dias = ahora_dia - dia;
      if (ahora_dia < dia) {
        var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
        var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
      }

      return edad + ' años y ' + meses + ' meses';
    },


    buscarInformacion: function buscarInformacion() {
      if (this.selectTerapeuta.id_rol == 2) {
        this.usuario = 'Fisioterapeuta';
        this.especialidad = 'Fisioterapia';
      } else if (this.selectTerapeuta.id_rol == 3) {
        this.usuario = 'Fonoaudiólogo';
        this.especialidad = 'Fonoaudiología';
      } else if (this.selectTerapeuta.id_rol == 4) {
        this.usuario = 'Terapeuta ocupacional';
        this.especialidad = 'Terapia ocupacional';
      } else if (this.selectTerapeuta.id_rol == 5) {
        this.usuario = 'Terapeuta en educación especial';
        this.especialidad = 'Educación especial';
      } else {
        this.usuario = 'Psicólogo';
        this.especialidad = 'Psicología';
      }
      this.calcularFechaActual();
      this.objetivosPendientesFun();
      this.pacientesCargoFun();
      this.hisSesionesHoy();
      this.fechamasdias();
      this.foto = "https://avanti-erp.com/" + this.selectTerapeuta.url_foto;
      this.nombre = this.selectTerapeuta.nombres + " " + this.selectTerapeuta.apellidos;
    },
    push: function push(route) {
      this.$router.push(route);
    }
  },
  mounted: function mounted() {
    this.selectTerapeutasFun();
    document.title = "Avanti | Administrar espacio";
  }
});

/***/ }),

/***/ "e+il":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ordenes_vue__ = __webpack_require__("mfVt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0e1ce5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ordenes_vue__ = __webpack_require__("5F1N");
function injectStyle (ssrContext) {
  __webpack_require__("BgsC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d0e1ce5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ordenes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d0e1ce5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ordenes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e5Qa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: '',
    imgRoute: '',
    title: '',
    clase: ''
  }
});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5665f22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("+M8q");
function injectStyle (ssrContext) {
  __webpack_require__("KMwH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5665f22_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eFYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestionTerapias_vue__ = __webpack_require__("CJ46");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3064d19d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gestionTerapias_vue__ = __webpack_require__("B1+d");
function injectStyle (ssrContext) {
  __webpack_require__("2M3y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3064d19d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gestionTerapias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3064d19d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gestionTerapias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eLRN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.informacionPaciente != '')?_c('modal',{attrs:{"name":"informe","scrollable":true,"draggable":false,"width":"700","height":"auto","reset":true}},[_c('br'),_vm._v(" "),_c('div',[_c('div',[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"5px","padding-top":"0"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-file text-success",staticStyle:{"font-size":"37px"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("\n                Generar informe de evolución de -\n                "),_c('strong',[_vm._v("\n                  "+_vm._s(_vm.informacionPaciente[0].PacNom1 +
                  " " +
                  _vm.informacionPaciente[0].PacApe1)+"\n                ")])]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("\n                Formulario de exportanción de informe\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha inicio:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechainicio),expression:"fechainicio"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.fechainicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechainicio=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha fin:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechafin),expression:"fechafin"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.fechafin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechafin=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Resumen:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.resumen),expression:"resumen"}],staticClass:"form-control",attrs:{"cols":"30","rows":"10","maxlength":_vm.configInput.MAX_CHARTERS},domProps:{"value":(_vm.resumen)},on:{"input":function($event){if($event.target.composing){ return; }_vm.resumen=$event.target.value}}}),_vm._v(" "),_c('span',{class:{
                  'text-danger': _vm.resumen.length == _vm.configInput.MAX_CHARTERS,
                }},[_vm._v(_vm._s(_vm.resumen.length)+" / "+_vm._s(_vm.configInput.MAX_CHARTERS)+"\n                "),_c('small',{class:{
                    'd-none': _vm.resumen.length < _vm.configInput.MAX_CHARTERS,
                  }},[_vm._v("\n                  - Solo se permiten\n                  "+_vm._s(_vm.configInput.MAX_CHARTERS)+" caracteres")])]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"padding-bottom":"0"}},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"border-radius":"7px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModal()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" CERRAR\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"7px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.generarInformeDeEvolucion()}}},[_c('i',{staticClass:"fa fa-file"}),_vm._v(" GENERAR INFORME\n          ")])]),_vm._v(" "),_c('br')])])]):_vm._e(),_vm._v(" "),(_vm.informacionPaciente != '')?_c('modal',{attrs:{"name":"informeporpaciente","scrollable":true,"draggable":false,"width":"700","height":"auto","reset":true}},[_c('br'),_vm._v(" "),_c('div',[_c('div',[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"5px","padding-top":"0"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-file text-success",staticStyle:{"font-size":"37px"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("\n                Generar informe por paciente de -\n                "),_c('strong',[_vm._v("\n                  "+_vm._s(_vm.informacionPaciente[0].PacNom1 +
                  " " +
                  _vm.informacionPaciente[0].PacApe1)+"\n                ")])]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("\n                Formulario de exportanción de informe\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Mes:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mes),expression:"mes"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mes=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"Enero"}},[_vm._v("Enero")]),_vm._v(" "),_c('option',{attrs:{"value":"Febrero"}},[_vm._v("Febrero")]),_vm._v(" "),_c('option',{attrs:{"value":"Marzo"}},[_vm._v("Marzo")]),_vm._v(" "),_c('option',{attrs:{"value":"Abril"}},[_vm._v("Abril")]),_vm._v(" "),_c('option',{attrs:{"value":"Mayo"}},[_vm._v("Mayo")]),_vm._v(" "),_c('option',{attrs:{"value":"Junio"}},[_vm._v("Junio")]),_vm._v(" "),_c('option',{attrs:{"value":"Julio"}},[_vm._v("Julio")]),_vm._v(" "),_c('option',{attrs:{"value":"Agosto"}},[_vm._v("Agosto")]),_vm._v(" "),_c('option',{attrs:{"value":"Septiembre"}},[_vm._v("Septiembre")]),_vm._v(" "),_c('option',{attrs:{"value":"Octubre"}},[_vm._v("Octubre")]),_vm._v(" "),_c('option',{attrs:{"value":"Noviembre"}},[_vm._v("Noviembre")]),_vm._v(" "),_c('option',{attrs:{"value":"Diciembre"}},[_vm._v("Diciembre")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Especialidad")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.especialidad),expression:"especialidad"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.especialidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"Psicología"}},[_vm._v("Psicología")]),_vm._v(" "),_c('option',{attrs:{"value":"Fonoaudiología"}},[_vm._v("Fonoaudiología")]),_vm._v(" "),_c('option',{attrs:{"value":"Terapia Ocupacional"}},[_vm._v("\n                  Terapia Ocupacional\n                ")]),_vm._v(" "),_c('option',{attrs:{"value":"Educación Especial"}},[_vm._v("Educación Especial")]),_vm._v(" "),_c('option',{attrs:{"value":"Fisioterapia"}},[_vm._v("Fisioterapia")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Concepto:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.concepto),expression:"concepto"}],staticClass:"form-control",attrs:{"cols":"30","rows":"5","maxlength":_vm.configInput.MAX_CHARTERS},domProps:{"value":(_vm.concepto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.concepto=$event.target.value}}}),_vm._v(" "),_c('span',{class:{
                  'text-danger': _vm.concepto.length == _vm.configInput.MAX_CHARTERS,
                }},[_vm._v(_vm._s(_vm.concepto.length)+"/ "+_vm._s(_vm.configInput.MAX_CHARTERS)+"\n                "),_c('small',{class:{
                    'd-none': _vm.concepto.length < _vm.configInput.MAX_CHARTERS,
                  }},[_vm._v("\n                  - Solo se permiten\n                  "+_vm._s(_vm.configInput.MAX_CHARTERS)+" caracteres")])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Recomendación:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.recomendacion),expression:"recomendacion"}],staticClass:"form-control",attrs:{"cols":"30","rows":"5","maxlength":_vm.configInput.MAX_CHARTERS},domProps:{"value":(_vm.recomendacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.recomendacion=$event.target.value}}}),_vm._v(" "),_c('span',{class:{
                  'text-danger':
                    _vm.recomendacion.length == _vm.configInput.MAX_CHARTERS,
                }},[_vm._v(_vm._s(_vm.recomendacion.length)+"/ "+_vm._s(_vm.configInput.MAX_CHARTERS)+"\n                "),_c('small',{class:{
                    'd-none': _vm.recomendacion.length < _vm.configInput.MAX_CHARTERS,
                  }},[_vm._v("\n                  - Solo se permiten\n                  "+_vm._s(_vm.configInput.MAX_CHARTERS)+" caracteres")])]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"padding-bottom":"0"}},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"border-radius":"7px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModal()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" CERRAR\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"7px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.generarInformePaciente()}}},[_c('i',{staticClass:"fa fa-file"}),_vm._v(" GENERAR INFORME\n          ")])]),_vm._v(" "),_c('br')])])]):_vm._e(),_vm._v(" "),_c('modal',{attrs:{"name":"informeOyL","scrollable":false,"draggable":false,"width":"700","height":"auto","reset":true}},[_c('br'),_vm._v(" "),_c('div',[_c('div',[_c('div',{staticClass:"modal-header",staticStyle:{"padding-right":"5px","padding-top":"0"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-file text-success",staticStyle:{"font-size":"37px"}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha inicio:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechainicio),expression:"fechainicio"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.fechainicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechainicio=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha fin:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechafin),expression:"fechafin"}],staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":(_vm.fechafin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechafin=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Resumen:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.resumen),expression:"resumen"}],staticClass:"form-control",attrs:{"cols":"30","rows":"10","maxlength":"1000"},domProps:{"value":(_vm.resumen)},on:{"input":function($event){if($event.target.composing){ return; }_vm.resumen=$event.target.value}}}),_vm._v(" "),_c('span',{class:{ 'text-danger': _vm.resumen.length == 1000 }},[_vm._v(_vm._s(_vm.resumen.length)+"/1000\n                "),_c('small',{class:{ 'd-none': _vm.resumen.length < 1000 }},[_vm._v("\n                  - Solo se permiten 1000 caracteres")])]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"padding-bottom":"0"}},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"border-radius":"7px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModal()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" CERRAR\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"7px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.generatePDFOyL()}}},[_c('i',{staticClass:"fa fa-file"}),_vm._v(" GENERAR INFORME\n          ")])]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('div',{staticClass:"card-header"},[_c('center',[_c('h4',[_vm._v("Informes")])])],1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Tipo de informe")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.informe),expression:"informe"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.informe=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.reset()}]}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Informe de evolución")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Informe por paciente")])])])]),_vm._v(" "),(_vm.informe == 1)?_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Especialidad:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.especialidadEvo),expression:"especialidadEvo"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.especialidadEvo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"Todas"}},[_vm._v("Todas")]),_vm._v(" "),_c('option',{attrs:{"value":"Terapia ocupacional"}},[_vm._v("Terapia Ocupacional")]),_vm._v(" "),_c('option',{attrs:{"value":"Psicología"}},[_vm._v("Psicología")]),_vm._v(" "),_c('option',{attrs:{"value":"Fonoaudiología"}},[_vm._v("Fonoaudiología")]),_vm._v(" "),_c('option',{attrs:{"value":"Fisioterapia"}},[_vm._v("Fisioterapia")]),_vm._v(" "),_c('option',{attrs:{"value":"Educación Especial"}},[_vm._v("Educación Especial")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Paciente:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.paciente),expression:"paciente"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.paciente=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Seleccionar paciente....")]),_vm._v(" "),_vm._l((_vm.pacienteSelect),function(paciente){return _c('option',{key:paciente.PacIdeUsu,domProps:{"value":paciente.PacIdeUsu}},[_vm._v("\n            "+_vm._s(paciente.PacNom1 + " " + paciente.PacApe1)+"\n          ")])})],2)]),_vm._v(" "),(_vm.informe != 2)?_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha inicio:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechainicio),expression:"fechainicio"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechainicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechainicio=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.informe != 2)?_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha fin:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechafin),expression:"fechafin"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechafin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechafin=$event.target.value}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',{attrs:{"for":""}},[_vm._v("Acciones")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.getInforme()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Buscar\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),(_vm.informe == 1)?_c('div',{staticClass:"col-md-4"},[(_vm.pdf == true)?_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.abrirModalGenerarPDF()}}},[_vm._v("\n          Generar Informe de evolución "),_c('i',{staticClass:"fa fa-file"})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.informe == 2)?_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),(_vm.pdf == true)?_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.abrirModalGenerarInforme()}}},[_vm._v("\n          Generar Informe por paciente "),_c('i',{staticClass:"fa fa-file"})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.informe == 3)?_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),(_vm.pdf == true)?_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.abrirModalGenerarInformeOyL()}}},[_vm._v("\n          Generar Informe OyL "),_c('i',{staticClass:"fa fa-file"})]):_vm._e()]):_vm._e()]),_vm._v(" "),(_vm.informacionPaciente != '')?_c('div',{staticClass:"row",staticStyle:{"margin":"3px"}},[_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-striped table-sm table-bordered"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("\n              "+_vm._s(_vm.informacionPaciente[0].PacNom1 +
                " " +
                _vm.informacionPaciente[0].PacApe1)+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(_vm.informacionPaciente[0].PacNumDoc)+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(_vm.informacionPaciente[0].PacFecNac)+"\n            ")])])])])]):_vm._e(),_vm._v(" "),(_vm.informe == 1 && _vm.terapias != '')?_c('div',{ref:"evoluciones",staticClass:"row",staticStyle:{"margin":"3px"}},[_c('br'),_vm._v(" "),_c('table',{staticClass:"mi-table table table-striped table-sm table-bordered",attrs:{"id":"mi-table"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.terapias),function(terapia){return (
              (terapia.ProEst == 1 && _vm.especialidadEvo == terapia.TerIde) ||
              _vm.especialidadEvo == 'Todas'
            )?_c('tr',{key:terapia.ProIde},[_c('td',[_vm._v("\n              "+_vm._s(terapia.ProFec)+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(terapia.terapeuta)+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(terapia.TerIde)+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(terapia.estrategia)+"\n            ")]),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(terapia.ProLug)+"\n            ")])]):_vm._e()}),0)])]):_vm._e(),_vm._v(" "),(_vm.informe == 3 && _vm.objetivos != '')?_c('div',{ref:"objetivos",staticClass:"row",staticStyle:{"margin":"3px"}},[_c('br'),_vm._v(" "),_c('table',{staticClass:"objetivoss table table-striped table-sm table-bordered",attrs:{"id":"objetivoss"}},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.objetivos),function(objetivo){return _c('tr',{key:objetivo.ProIde},[_c('td',[_c('center',[_vm._v(_vm._s(objetivo.ObjFec))])],1),_vm._v(" "),_c('td',[_c('center',[_vm._v(_vm._s(objetivo.ObjFecCum))])],1),_vm._v(" "),_c('td',[_vm._v("\n              "+_vm._s(objetivo.ObjUsu)+"\n            ")]),_vm._v(" "),_c('td',[_c('center',[(objetivo.ObjTer == 1)?_c('p',[_vm._v("Fisioterapia")]):_vm._e(),_vm._v(" "),(objetivo.ObjTer == 2)?_c('p',[_vm._v("Fonoaudiología")]):_vm._e(),_vm._v(" "),(objetivo.ObjTer == 3)?_c('p',[_vm._v("Terapia ocupacional")]):_vm._e(),_vm._v(" "),(objetivo.ObjTer == 4)?_c('p',[_vm._v("Psicología")]):_vm._e(),_vm._v(" "),(objetivo.ObjTer == 5)?_c('p',[_vm._v("Edu. Especial")]):_vm._e()])],1),_vm._v(" "),_c('td',[_c('center',[_vm._v("\n                "+_vm._s(objetivo.ObjObj)+"\n              ")])],1),_vm._v(" "),_c('td',[_c('center',[(
                    _vm.fechaActual > objetivo.ObjFecCum &&
                    objetivo.ObjLog == null
                  )?_c('span',[_vm._v("Logro en proceso de confirmación")]):_c('span',[_vm._v(_vm._s(objetivo.ObjLog))])])],1),_vm._v(" "),_c('td',[_c('center',[(objetivo.ObjLog == null)?_c('p',[_vm._v("Sin evaluar")]):_c('p',[_vm._v(_vm._s(objetivo.ObjPor)+"%")])])],1)])}),0)])]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Paciente")]),_vm._v(" "),_c('th',[_vm._v("Documento")]),_vm._v(" "),_c('th',[_vm._v("Fecha de nacimiento")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Fecha de atención")]),_vm._v(" "),_c('th',[_vm._v("Terapeuta")]),_vm._v(" "),_c('th',[_vm._v("Especialidad")]),_vm._v(" "),_c('th',[_vm._v("Estrategia terapéutica")]),_vm._v(" "),_c('th',[_vm._v("Lugar")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Fecha")]),_vm._v(" "),_c('th',[_vm._v("Fecha a cumplir")]),_vm._v(" "),_c('th',[_vm._v("Terapeuta")]),_vm._v(" "),_c('th',[_vm._v("Especialidad")]),_vm._v(" "),_c('th',[_vm._v("Objetivo")]),_vm._v(" "),_c('th',[_vm._v("Logro")]),_vm._v(" "),_c('th',[_vm._v("Logro en %")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "esqW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "exEM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__("+Rp4");



















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  data: function data() {
    return {
      ip: "https://fundaintegra.com/",
      searchQuery: "",
      fechaInicial: "",
      fechaFinal: "",
      queriedData2: [],
      fechaActual: "",
      tableColumns: [{
        prop: "fecha",
        label: "Fecha",
        minWidth: 180 }, {
        prop: "Realizadas",
        label: "S. realizadas",
        minWidth: 100 }, {
        prop: "PorcentajeRealizadas",
        label: "% realizadas",
        minWidth: 100 }, {
        prop: "Canceladas",
        label: "S. canceladas",
        minWidth: 100 }, {
        prop: "PorcentajeCanceladas",
        label: "% canceladas",
        minWidth: 100 }, {
        prop: "SinCancelarORealizar",
        label: "S. Sin cancelar/realizar",
        minWidth: 100 }, {
        prop: "PorcentajeSinRealizarOCancelar",
        label: "% sin cancelar/realizar",
        minWidth: 100 }, {
        prop: "TotalSesiones",
        label: "Total de sesiones",
        minWidth: 100 }],
      json_fields: {
        "Fecha": "fecha",
        "Sesiones realizadas": "Realizadas",
        "% realizadas": "PorcentajeRealizadas",
        "Sesiones Canceladas": "Canceladas",
        "% canceladas": "PorcentajeCanceladas",
        "Sesiones sin cancelar/realizar": "SinCancelarORealizar",
        "% sin cancelar/realizar": "PorcentajeSinRealizarOCancelar",
        "Total de sesiones": "TotalSesiones"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      SedesProgramacion: [],
      sede: "Sede Principal",
      rol: "",
      tipo: "",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  methods: {
    obtenerAsistenciaPorFecha: function obtenerAsistenciaPorFecha(fechaInicial, fechaFinal) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sede, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.$modal.show("carga");
                sede = localStorage.getItem("sede");
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/reportes/informe-sesiones-periodo/" + fechaInicial + "/" + fechaFinal + "/" + sede);

              case 5:
                response = _context.sent;

                _this2.queriedData2 = response.data.eventos;
                _this2.json_data = response.data.eventos;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.log("Error al obtener los datos:" + _context.t0);

              case 13:
                _context.prev = 13;

                _this2.$modal.hide("carga");
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10, 13, 16]]);
      }))();
    },

    emailsProgramacion: function emailsProgramacion() {
      var _this3 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/emailsProgramacion";
      axios.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this3.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getClass: function getClass(column, row) {
      if (column.prop === "PorcentajeRealizadas") {
        return row.classRealizadas;
      } else if (column.prop === "PorcentajeCanceladas") {
        return row.classCanceladas;
      } else if (column.prop === "PorcentajeSinRealizarOCancelar") {
        return row.classSinRealizarOCancelar;
      }

      return "";
    }
  },
  mounted: function mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    document.title = "Integra | Reporte de asistencia por fecha";
  }
});

/***/ }),

/***/ "f0v9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_aDashboard_nomina_cardnomina_vue__ = __webpack_require__("DBcq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__ = __webpack_require__("1byD");







/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            informacionNomina: [],
            resumenNomina: 0
        };
    },

    methods: {
        getNomina: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var BASE_URL, response, data, resumen, dataFormated;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;

                                this.$modal.show('carga');
                                BASE_URL = "api/nomina-dashboard";
                                _context.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_3_src_global_services_axiosInstance__["a" /* default */].get(BASE_URL);

                            case 5:
                                response = _context.sent;

                                if (response.data.status === true) {
                                    data = response.data.data;
                                    resumen = 0;
                                    dataFormated = data.map(function (element) {
                                        var prestaciones = element.eps + element.pension + element.arl;
                                        var transporte = element.transporte;
                                        resumen = resumen + (element.salarioFijo - prestaciones + transporte);
                                        return {
                                            nombre: element.nombre,
                                            salarioFijo: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(element.salarioFijo - prestaciones),
                                            prestaciones: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(prestaciones),
                                            transporte: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(transporte)
                                        };
                                    });

                                    this.resumenNomina = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__global_services_formatear_pesos__["a" /* default */])(resumen);
                                    this.informacionNomina = dataFormated;
                                }
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context["catch"](0);

                                console.log(_context.t0);

                            case 12:
                                _context.prev = 12;

                                this.$modal.hide('carga');
                                return _context.finish(12);

                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 9, 12, 15]]);
            }));

            function getNomina() {
                return _ref.apply(this, arguments);
            }

            return getNomina;
        }()
    },
    components: {
        nomicard: __WEBPACK_IMPORTED_MODULE_2_src_components_aDashboard_nomina_cardnomina_vue__["a" /* default */]
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "fGY8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fKYh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fM/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jspdf__ = __webpack_require__("3h9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_jspdf_autotable__ = __webpack_require__("+2xD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_jspdf_autotable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_jspdf_autotable__);
























__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_16_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_collapse_item___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      dxeditId: "",
      dxedit: [],
      usuarioAvanza: "",
      motivosConsulta: "",
      optionsArray: [],
      tmconsulta: [],
      informacion: "",
      pacientes: [],
      arrayMotivo: [],
      criterio: "paciente.PacApe1",
      busqueda: "",
      anos: 0,
      meses: 0,
      multiple: "ARS",

      numeroDocumento: "",
      tipoDocumentoPDF: '',
      apellidos: "",
      nombres: "",
      fechaIngreso: "",
      Fecha_nacimiento: "",
      diagnosticoPaciente: "",
      sexo: "",
      labelSexo: {
        1: "Masculino",
        2: "Femenino",
        3: "Gay",
        4: "Lesbiana",
        5: "Bisexual",
        6: "Transgénero",
        7: "Intersexual",
        8: "Sin definir"
      },
      eps: "",
      poliza: "",
      prepagada: "",
      tipoAfiliacion: "",
      regimen: 1,
      PacIde: "",
      loked: true,
      numeroDocumentoBuscar: "",
      fotoPaciente: "",
      estado: 0,
      rol: localStorage.getItem("rol"),

      motivoDeConsulta: "",
      fechaDeConsulta: "",
      fechaVerificado: "",
      motivoVerificarIde: "",
      motivoVerificarFec: "",
      motivoVerificarDes: "",
      consultaVerificada: "",
      contador_motivos: 0,
      evoluciones: [],
      fechaInicialEvoluciones: '',
      fechaFinalEvoluciones: '',

      arrayImpresion: [],

      tipoAntecedente: 1,
      antecedenteActivo: "",
      fechaAntecedente: "",

      descripcionAntecedente: "",
      antecedentesPre: [],
      contador_pre: 0,
      antecedentesNeo: [],
      antecedentesPos: [],
      antecedentesPer: [],
      antecedentesFam: [],
      fotoBASE: "",

      fechaResumen: "",
      descripcionResumen: "",
      arrayResumen: [],
      descripcionImpresion: "",
      impresionDiagnostica: "",
      conclusiones: "",
      arrayAntecedente: [],
      arrayCie10: [],
      arrayDsm4: [],
      cie10: [],
      dsm4: []
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "conclusiones", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "detalleResumenFecha", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "detalleDescripcionResumen", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "detalleConclusionResumen", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "detalleCie10", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "detalleDsm4", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "fechaTratamiento", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "descripcionTratamiento", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "recomendacionesTratamiento", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayTratamiento", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayEspecialidad", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayEspecialidades", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "especialidad", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "sesiones", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayDetalle", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "fechaFinTratamiento", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "actividadFamiliar", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "trabajoFamiliar", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "fechaIngresoTratamiento", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examen", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "verificacion", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mostrarCie10", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mostrarDsm4", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "opcion", 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenes_t", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenesPDF", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenActivo", 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayActivo", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenEnviar", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "nombreExamen", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "links_examen", ["NULL", "https://drive.google.com/file/d/1QQvTRCVPfbgasJ-agXYymsFzCSOsIEtp/view?usp=sharing", "https://drive.google.com/file/d/1nZTTxOPpTy_RYbcqFcClm6wEKMqsM2yx/view?usp=sharing", "https://drive.google.com/file/d/1AKYS5wSOs8cCh0fVc4cE3Tc32GcAvhrG/view", "https://drive.google.com/file/d/1um4R2ymKd_gdww2WPBsdwzmS1dHoQf5R/view", "https://drive.google.com/file/d/1y9pVcX8QR55yyxtzmjsELkNB-FpQMeXA/view?usp=sharing", "https://drive.google.com/open?id=1uHrljOme7yU-7Ssok1mr1A3ajGsUC_lD", "https://drive.google.com/open?id=1d5K0en09ws3umkRoXZF5UC548tTmhDnB", "https://drive.google.com/file/d/17EaZD7K4bddoVmuTIm9kpqMhsZ4kVKww/view", "https://drive.google.com/open?id=1-WrHRmIMCbXO-dq3MuwuaUHbTRf8knM0", "https://drive.google.com/open?id=1tzemT8CBzdUW5E9I8449NjlGP-2hma03", "https://drive.google.com/file/d/0B54PTJg2YNL-TVFvbnpTc3laZGc/view?resourcekey=0-QCwexOdYyxlTsC5V9hT7Cw", '#', 'https://docs.google.com/document/d/1k1QfqebMl0yT2aVeryIY9VQquUISuvy7/edit', 'https://docs.google.com/document/d/18Af8DG-pIWLo-mdTMGaF8Wo20B79L0QB/edit?usp=sharing&ouid=106019725576061634179&rtpof=true&sd=true', 'https://docs.google.com/document/d/1a8hvVTjdBAXPb7VBq-PIX36M_xMER3cb/edit?usp=drive_link&ouid=106019725576061634179&rtpof=true&sd=true', 'https://drive.google.com/file/d/1FPTdBztShATSSt_94O5BKVOI-7bKJB_U/view?usp=drive_link', 'https://drive.google.com/file/d/1YGdKPoXQhxY36SImDmLWcGJKWQEneHlO/view?usp=drive_link', 'https://drive.google.com/file/d/1aCNi2Kni2P-3uSxicDIyFxsNJrh0KwD3/view?usp=drive_link', 'https://drive.google.com/file/d/1jaLNu7r7pMHFmLpZYOGTujePWYYNyuuh/view?usp=drive_link', 'https://docs.google.com/document/d/1gdz2aMJsENNy3oD30O76lDJZfsDRja0_/edit?usp=drive_link&ouid=106019725576061634179&rtpof=true&sd=true', 'https://docs.google.com/document/d/1Zm6lASLGaJG3DH-oYQSKN_ZUcGeSqcrT/edit?usp=drive_link&ouid=106019725576061634179&rtpof=true&sd=true']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "link_examen_selecte", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tratamiento", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "motivoPDF", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "motivoPDF_id", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "impresionesPDF", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "antecedentesPrePDF", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "antecedentesNeoPDF", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "antecedentesNeo", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "antecedentesPosPDF", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "antecedentesPos", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "antecedentesPerPDF", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "antecedentesPer", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "antecedentesFamPDF", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "antecedentesFam", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "conclusionesPDF", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "terapeutaPDF", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "type", ["", "info", "success", "warning", "danger"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "notifications", {
      topCenter: false
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "ip", "https://avanti-erp.com/"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mensaje", "No hay datos de pacientes"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "icono", "bell"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenesRealizados", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenesRealizadosPs", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenesRealizadosfonol", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "indefinido", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "periodoPT", 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "motivoConsultaHoy", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "motivoConsultaUsuario", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "antecedenteHoy", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "impresionHoy", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenHoy", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tratamientoHoy", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "e_motivo", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "e_antecedente", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "e_resumen", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "e_tratamiento", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "cie10mostrar", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "logo", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "terapeutaPDF", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "recomendacionPDF", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "fechaPDF", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenesPaciente", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "inputFirma", ''), _ref;
  },

  methods: {
    prepararEditDX: function prepararEditDX(dx) {
      this.$modal.show("modaleditardx");
      if (dx != null) {
        dx = dx.split(", ");
        this.dxedit = dx;
      }
    },


    abrirModalVerificarFirma: function abrirModalVerificarFirma() {
      var ROL = localStorage.getItem('rol');
      if (ROL > 1 && ROL < 7) {
        this.$modal.show('modalVerificarFirmaElectronica');
      }
    },

    verificarFirmaElectronica: function verificarFirmaElectronica() {
      this.$modal.show('carga');
      var FIRMA = localStorage.getItem('firmaElectronica');
      if (this.inputFirma === FIRMA) {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__global_services_crearAlerta__["a" /* default */])("success", 'Firma valida'));
        this.$modal.hide('modalVerificarFirmaElectronica');
        this.$modal.hide('carga');
      } else {
        this.$notify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__global_services_crearAlerta__["a" /* default */])("danger", "Firma invalida"));
        this.$modal.hide('carga');
      }
    },

    cerrarPrepararEditDx: function cerrarPrepararEditDx() {
      this.$modal.hide("modaleditardx");
    },


    editDX: function editDX() {
      var _this = this;

      if (false) {
        alert("No se permite DX vacio");
      } else {
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        };

        var textoDelArray = "";
        for (var i = 0; i < this.dxedit.length; i++) {
          textoDelArray = textoDelArray + (" " + this.dxedit[i] + ",");
        }

        var BASE_URL = this.ip + "api/editDXV2";
        __WEBPACK_IMPORTED_MODULE_13_axios___default.a.post(BASE_URL, {
          id: this.PacIde,
          dx: textoDelArray.toUpperCase()
        }, config).then(function (res) {
          if (res.data.status == true) {
            var color = Math.floor(Math.random() * 4 + 1);
            _this.$notify({
              component: {
                template: " <div style=\"padding: 3%;\">\n              <span><b> ACTUALIZADO CON \xC9XITO </b>.</span>\n              </div>\n              "
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: _this.type[color]
            });
            _this.diagnosticoPaciente = textoDelArray;
            _this.cerrarPrepararEditDx();
          }
        }).catch(function (error) {
          console.log(error);
          var color = Math.floor(Math.random() * 4 + 1);
          _this.$notify({
            component: {
              template: " <div style=\"padding: 3%;\">\n              <span><b> ERROR AL ACTUALIZAR DX </b>.</span>\n              </div>\n              "
            },
            icon: "ti-close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this.type[color]
          });
        });
      }
    },
    prepararPDFEva: function prepararPDFEva() {
      this.$modal.show("pdfEva");
      this.$modal.hide("modalNuevoPlanDetalle");
      this.selectDataInformeEvolucion(this.fechaIngresoTratamiento, this.terapeutaPDF, this.descripcionTratamiento);
    },
    cerrarModalpdf: function cerrarModalpdf() {
      this.$modal.hide("pdfEva");
      this.recomendacionPDF = "";
    },
    generarInforme: function generarInforme() {
      if (this.recomendacionesTratamiento != '') {
        var informacion = [{
          terapeuta: this.terapeutaPDF,
          fecha: this.fechaPDF,
          recomendaciones: this.recomendacionesTratamiento,
          antecedentes_prenatales: this.antecedentesPrePDF,
          antecedentes_neonatales: this.antecedentesNeoPDF,
          antecedentes_postnatales: this.antecedentesPosPDF,
          antecedentes_personales: this.antecedentesPerPDF,
          antecedentes_familiares: this.antecedentesFamPDF,
          conclusiones: this.descripcionTratamiento,
          examenes: this.examenesPDF,
          motivo: this.motivoPDF,
          motivoId: this.motivoPDF_id,
          impresion: this.impresionesPDF
        }];

        var paciente = [{
          edad: this.anos + " a\xF1o(s) y " + this.meses + " mes(es)",
          nombre: this.nombres + " " + this.apellidos,
          tipoDocumento: this.tipoDocumentoPDF,
          documento: this.numeroDocumento,
          ide: this.PacIde
        }];
        __WEBPACK_IMPORTED_MODULE_13_axios___default()({
          method: "post",
          url: "https://avanti-erp.com/api/imprimir",
          responseType: "arraybuffer",
          data: {
            formularioData: informacion,
            paciente: paciente
          }
        }).then(function (response) {
          if (response.headers['content-type'] == 'application/pdf') {
            var blob = new Blob([response.data], { type: "application/pdf" });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "informe_evaluacion_" + paciente[0].nombre + ".pdf";
            link.click();
          } else {
            alert('El usuario que registró el plan no es terapeuta');
          }
        });
        this.cerrarModalpdf();
      } else {
        alert('El campo de recomendaciones es requerido para generar el informe');
      }
    },
    realizarExamen: function realizarExamen() {},
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    abrirModalAgregar: function abrirModalAgregar() {
      this.$modal.show("modalAgregar");
      this.tmconsulta = [];
      this.motivosConsulta = "";
      this.consultaVerificada = "";
    },
    cerrarModalMotivo: function cerrarModalMotivo() {
      this.$modal.hide("modalAgregar");
    },
    cerrarModalMotivoVerificar: function cerrarModalMotivoVerificar() {
      this.$modal.hide("modalVerificarMC");
    },
    abrirModalAntecedente: function abrirModalAntecedente(tipo) {
      this.$modal.show("nuevoAntecedente");
      this.descripcionAntecedente = "";
      this.tipoAntecedente = tipo;
    },
    cerrarModalNuevoAntecedente: function cerrarModalNuevoAntecedente() {
      this.$modal.hide("nuevoAntecedente");
    },
    abriModalAnamnesis: function abriModalAnamnesis() {
      this.$modal.show("modalAnamnesis");
    },
    cerrarModalResumen: function cerrarModalResumen() {
      this.$modal.hide("modalAnamnesis");
    },
    cerrarModalDetalleResumen: function cerrarModalDetalleResumen() {
      this.$modal.hide("modalDetalleAnamnesis");
    },
    abriModalNuevoPlan: function abriModalNuevoPlan() {
      this.$modal.show("modalNuevoPlan");
      this.fechaTratamiento = "", this.descripcionTratamiento = "", this.especialidad = "", this.sesiones = "", this.fechaFinTratamiento = "", this.actividadFamiliar = "", this.trabajoFamiliar = "", this.arrayEspecialidad = [];
      this.selectEspecialidad();
    },
    cerrarModalDetallePlan: function cerrarModalDetallePlan() {
      this.$modal.hide("modalNuevoPlanDetalle");
    },
    cerrarModalNuevoPlan: function cerrarModalNuevoPlan() {
      this.$modal.hide("modalNuevoPlan");
    },
    cerrarHC: function cerrarHC() {
      this.opcion = 1;
      this.arrayMotivo = [];
      this.arrayExamen = [];
      this.examenesPaciente = [];
      this.arrayActivo = [];
      localStorage.removeItem("PacienteHC");
      localStorage.removeItem("PacienteId");
    },

    cambiarLinkExamen: function cambiarLinkExamen() {
      this.link_examen_selecte = this.links_examen[this.examen];
    },
    motivos: function motivos() {
      var _this2 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/motivos/" + this.PacIde,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this2.arrayMotivo = response.data.data;
        console.log(_this2.arrayMotivo, 'motivos');
        _this2.contador_motivos = _this2.arrayMotivo.length;
        if (response.data.data.length > 0) {
          _this2.motivoConsultaHoy = true;
        }
        _this2.validarMotivosIngresadosHoy(response.data.data);
        _this2.validarMotivosVerificados(response.data.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    validarMotivosVerificados: function validarMotivosVerificados(motivos) {
      for (var index = 0; index < motivos.length; index++) {
        if (motivos[index].MotEst != 1) {
          this.motivoConsultaHoy = false;
        }
      }
    },
    validarMotivosIngresadosHoy: function validarMotivosIngresadosHoy(motivos) {
      for (var index = 0; index < motivos.length; index++) {
        if (motivos[index].MotFec == this.fechaDeConsulta && motivos[index].MotTer == this.usuarioAvanza || motivos[index].updated_at.substring(0, 10) == this.fechaDeConsulta && motivos[index].MotTer == this.usuarioAvanza) {
          this.motivoConsultaUsuario = true;
        }
      }
    },
    motivosM: function motivosM() {
      var _this3 = this;

      this.optionsArray = [];
      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/motivos",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this3.optionsArray = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    motivoVerificar: function motivoVerificar(row) {
      var _this4 = this;

      var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      this.verificacion = row.MotEst;
      if (this.verificacion == 0 && option == 1) {
        this.$modal.show("modalVerificarMC");
      }
      if (this.verificacion != 0 && option == 1) {
        this.$modal.show("modalDetallesMC");
      }
      this.tmconsulta = [];
      this.motivoVerificarIde = row.MotIde;
      this.motivoVerificarFec = row.MotFec;
      this.motivoVerificarDes = row.MotDes;
      this.consultaVerificada = row.MotVer;
      var token = localStorage.getItem("token");

      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/completo/" + this.motivoVerificarIde,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        var datos = response.data.data.length;
        for (var i = 0; i < datos;) {
          _this4.tmconsulta.push(response.data.data[i].VerDes);
          i++;
        }

        if (option == 1) {
          _this4.motivos();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    nuevoMotivoConsulta: function nuevoMotivoConsulta() {
      var _this5 = this;

      var token = localStorage.getItem("token");
      if (this.motivoConsulta != "") {
        __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
          method: "post",
          baseURL: this.ip + "api/nuevoMotivo",
          data: {
            MotFec: this.fechaDeConsulta,
            PacIde: this.PacIde,
            MotDes: this.motivosConsulta
          },
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json"
          }
        }).then(function (response) {
          if (response.data == 1) {
            var color = Math.floor(Math.random() * 4 + 1);
            _this5.$notify({
              component: {
                template: "<span>-<b> Motivo registrado con \xE9xito!</b>.</span>"
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: _this5.type["success"]
            });
          }

          _this5.motivoDeConsulta = "";
          _this5.fechaDeConsulta = "";
          _this5.motivosConsulta = "";
          _this5.motivos();
          _this5.estadoModalAgregarMC = 0;

          _this5.$modal.hide("modalAgregar");
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    nuevoMotivoConsultaVerificado: function nuevoMotivoConsultaVerificado() {
      var _this6 = this;

      this.e_motivo = false;
      var token = localStorage.getItem("token");
      if (this.PacIde != "") {
        if (this.motivoConsulta != "") {
          __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
            method: "post",
            baseURL: this.ip + "api/nuevoMotivoVerificado",
            data: {
              MotFec: this.fechaDeConsulta,
              PacIde: this.PacIde,
              MotDes: this.motivosConsulta,
              Parametros: this.tmconsulta,
              verificada: this.consultaVerificada,
              MotTer: localStorage.getItem("usuario")
            },
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json"
            }
          }).then(function (response) {
            var color = Math.floor(Math.random() * 4 + 1);
            _this6.$notify({
              component: {
                template: "<span>-<b> Motivo registrado con \xE9xito!</b>.</span>"
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: _this6.type["success"]
            });

            _this6.motivosConsulta = "";
            _this6.consultaVerificada = "";
            _this6.tmconsulta = [];
            _this6.estadoModalAgregarMC = 0;
            _this6.motivos();
            _this6.motivoConsultaHoy = true;
            _this6.$modal.hide("modalAgregar");
            _this6.e_motivo = "enviar";
          }).catch(function (error) {
            console.log(error);
          });
        }
      } else {
        alert("Faltan Datos Del Paciente");
      }
    },
    verificarMotivo: function verificarMotivo() {
      var _this7 = this;

      var token = localStorage.getItem("token");

      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "post",
        baseURL: this.ip + "api/verificar",
        data: {
          id: this.motivoVerificarIde,
          terminos: this.tmconsulta,
          consultaVerificada: this.consultaVerificada,
          fechaVerificado: this.fechaVerificado,
          terapeuta: localStorage.getItem("usuario")
        },
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this7.$notify({
          component: {
            template: "<span>-<b> Motivo verificado!</b>.</span>"
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this7.type["success"]
        });
        _this7.motivos();
        _this7.estadoModalVerificarMC = 0;
        _this7.cerrarModalMotivoVerificar();
      }).catch(function (error) {
        console.log(error);
      });
    },
    llamarPacientes: function llamarPacientes(row) {
      var _this8 = this;

      var respuesta = "";
      this.numeroDocumentoBuscar = row.PacNumDoc;
      if (this.numeroDocumentoBuscar != "") {
        var buscar = this.numeroDocumentoBuscar;
        var token = localStorage.getItem("token");
        __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
          method: "get",
          baseURL: this.ip + "api/pacienteHC/" + row.PacIdeUsu,
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json"
          }
        }).then(function (response) {
          if (response.data.data == 0) {
            alert("No se encontraron datos");
          } else {
            _this8.PacIde = row.PacIdeUsu;
            _this8.numeroDocumento = response.data.data.datos[0].PacNumDoc;
            localStorage.setItem("PacienteHC", response.data.data.datos[0].PacNumDoc);
            localStorage.setItem("PacienteId", row.PacIdeUsu);
            localStorage.setItem("PacienteNombre", response.data.data.datos[0].PacNom1 + " " + response.data.data.datos[0].PacApe1);
            _this8.nombres = response.data.data.datos[0].PacNom1;
            _this8.apellidos = response.data.data.datos[0].PacApe1;
            _this8.fotoPaciente = response.data.data.datos[0].url_foto;
            _this8.sexo = _this8.labelSexo[response.data.data.datos[0].PacSex];
            _this8.tipoDocumentoPDF = response.data.data.datos[0].TipDocNom;

            _this8.Fecha_nacimiento = response.data.data.datos[0].PacFecNac;
            _this8.fechaIngreso = response.data.data.datos[0].PacFecIng;
            _this8.eps = response.data.data.eps;
            _this8.prepagada = response.data.data.prepagada;
            _this8.tipoAfiliacion = response.data.data.datos[0].TipCliNom;
            _this8.poliza = response.data.data.poliza;
            _this8.diagnosticoPaciente = response.data.data.datos[0].PacDia;
            _this8.regimen = response.data.data.datos[0].PacReg == 1 ? "Contributivo" : "Subsidiado";

            _this8.estado = response.data.data.datos[0].estado;
            _this8.loked = response.data.data.datos[0].PacBlo;

            _this8.fotoBASE = response.data.data.datos[0].url_fotoBS;

            _this8.motivos();
            _this8.resumen();
            _this8.examenes();
            _this8.antecedentes();
            _this8.tratamientos();

            _this8.calcularEdad();

            _this8.motivoConsultaHoy = false;
            _this8.antecedenteHoy = false;
            _this8.impresionHoy = false;
            _this8.examenHoy = false;
            _this8.tratamientoHoy = false;
            _this8.e_motivo = true;
            _this8.opcion = 2;
            _this8.e_antecedente = true;
            _this8.e_resumen = true;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    buscarPacientes: function buscarPacientes() {
      var _this9 = this;

      this.mensaje = "Cargando...";
      this.icono = "spinner";
      this.pacientes = [];
      var token = localStorage.getItem("token");

      var rol = localStorage.getItem('rol');
      var sedeBuscar = 'todas';
      if (rol > 1) {
        sedeBuscar = localStorage.getItem('sede');
      }
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda + "/" + sedeBuscar,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this9.icono = "bell";
        _this9.mensaje = "No hay datos de pacientes";
        _this9.pacientes = response.data.data;
        if (localStorage.getItem("PacienteHC")) {
          _this9.llamarPacientes(response.data.data[0]);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    cie10M: function cie10M() {
      var _this10 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/cie10",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this10.arrayCie10 = [];
        var datos = response.data.data.length;
        if (response.data.data != "") {
          for (var i = 0; i < datos;) {
            _this10.arrayCie10.push(response.data.data[i]);

            i++;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    dsm4M: function dsm4M() {
      var _this11 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/dsm4",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        var datos = response.data.data.length;
        if (response.data.data != "") {
          for (var i = 0; i < datos;) {
            _this11.arrayDsm4.push(response.data.data[i]);
            i++;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    nuevoAntecedente: function nuevoAntecedente() {
      var _this12 = this;

      this.e_antecedente = false;
      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "post",
        baseURL: this.ip + "api/nuevoAntecedente",
        data: {
          descripcion: this.descripcionAntecedente,
          PacIde: this.PacIde,
          terapeuta: localStorage.getItem("usuario"),
          tipo: this.tipoAntecedente
        },
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this12.$modal.hide("nuevoAntecedente");
        var color = Math.floor(Math.random() * 4 + 1);
        _this12.$notify({
          component: {
            template: "<span>-<b> Antecedente registrado con \xE9xito!</b>.</span>"
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this12.type["success"]
        });
        _this12.antecedenteHoy = true;
        _this12.antecedentes();
        _this12.e_antecedente = true;
      }).catch(function (error) {
        console.log(error);
      });
    },


    getEvoluciones: function getEvoluciones(paciente) {
      var _this13 = this;

      this.$modal.show("carga");
      var lokedInformation = 0;
      if (this.loked != null && this.loked != '' && this.usuarioAvanza != this.loked) {
        lokedInformation = 1;
      }
      var BASE_URL = this.ip + "api/obtener-evoluciones/" + paciente + "/" + this.fechaInicialEvoluciones + "/" + this.fechaFinalEvoluciones + "/" + lokedInformation;
      var config = {
        Authorization: "Bearer " + localStorage.getItem("token")
      };
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json"
        }
      }).then(function (res) {
        _this13.$modal.hide("carga");
        var evoluciones = [];

        for (var i = 0; i < res.data.data.length; i++) {
          evoluciones.push({
            EvoTer: res.data.data[i].nombres + " " + res.data.data[i].apellidos,
            Obs: res.data.data[i].Obs,
            EvoMat: res.data.data[i].EvoMat,
            EvoFec: res.data.data[i].EvoFec,
            EvoEst: res.data.data[i].EvoEst
          });
        }
        _this13.evoluciones = evoluciones;
      }).catch(function (err) {
        _this13.$modal.hide("carga");
        console.log(err);
      });
    },

    antecedentes: function antecedentes() {
      var _this14 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/antecedentes/" + this.PacIde,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this14.antecedentesPre = response.data.data.pre;
        if (response.data.data.pre.length > 0) {
          _this14.antecedenteHoy = true;
        }
        _this14.contador_pre = response.data.data.pre.length;
        _this14.antecedentesNeo = response.data.data.neo;
        if (response.data.data.neo.length > 0) {
          _this14.antecedenteHoy = true;
        }
        _this14.antecedentesPos = response.data.data.pos;
        if (response.data.data.pos.length > 0) {
          _this14.antecedenteHoy = true;
        }
        _this14.antecedentesPer = response.data.data.per;
        if (response.data.data.per.length > 0) {
          _this14.antecedenteHoy = true;
        }
        _this14.antecedentesFam = response.data.data.fam;
        if (response.data.data.fam.length > 0) {
          _this14.antecedenteHoy = true;
        }
        _this14.cambiarTipoAntecedente();
      }).catch(function (error) {
        console.log(error);
      });
    },
    cambiarTipoAntecedente: function cambiarTipoAntecedente() {
      if (this.tipoAntecedente == "1") {
        this.antecedenteActivo = "Prenatales";
        this.arrayAntecedente = this.antecedentesPre;
      }
      if (this.tipoAntecedente == 2) {
        this.antecedenteActivo = "Neonatales";
        this.arrayAntecedente = this.antecedentesNeo;
      }
      if (this.tipoAntecedente == 3) {
        this.antecedenteActivo = "Postnatales";
        this.arrayAntecedente = this.antecedentesPos;
      }
      if (this.tipoAntecedente == 4) {
        this.antecedenteActivo = "Personales";
        this.arrayAntecedente = this.antecedentesPer;
      }
      if (this.tipoAntecedente == 5) {
        this.antecedenteActivo = "Familiares";
        this.arrayAntecedente = this.antecedentesFam;
      }
    },
    nuevoResumen: function nuevoResumen() {
      var _this15 = this;

      this.e_resumen = false;
      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "post",
        baseURL: this.ip + "api/nuevoResumen",
        data: {
          ResFec: this.fechaResumen,
          ResDes: this.descripcionResumen,
          PacIde: this.PacIde,
          ResCon: " ",
          terapeuta: localStorage.getItem("usuario")
        },
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this15.$notify({
          component: {
            template: "<span><b> Amanmesis Registrada Con \xC9xito</b>.</span>"
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this15.type["success"]
        });

        _this15.$modal.hide("modalAnamnesis");
        _this15.resumen();
        _this15.descripcionResumen = "";
        _this15.conclusiones = "";
        _this15.impresionHoy = true;
        _this15.e_resumen = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    resumen: function resumen() {
      var _this16 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/resumen/" + this.PacIde,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this16.cie10M();
        _this16.dsm4M();
        _this16.arrayResumen = response.data.data;
        if (response.data.data.length > 0) {
          _this16.impresionHoy = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    detalleResumen: function detalleResumen(row) {
      var _this17 = this;

      var token = localStorage.getItem("token");
      this.detalleResumenFecha = row.ResFec;
      this.detalleDescripcionResumen = row.ResDes;
      this.detalleConclusionResumen = row.ResCon;
      this.$modal.show("modalDetalleAnamnesis");
      this.detalleDsm4 = [];
      this.detalleCie10 = [];

      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/detalleResumen/" + row.ResIde,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        for (var i = 0; i < response.data.data.cie10.length; i++) {
          _this17.detalleCie10.push(response.data.data.cie10[i].DetDes);
        }
        for (var _i = 0; _i < response.data.data.dsm4.length; _i++) {
          _this17.detalleDsm4.push(response.data.data.dsm4[_i].DetDes);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    examenes: function examenes() {
      var _this18 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/examenes/" + this.PacIde,
        headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }, "Content-Type", "multipart/form-data")
      }).then(function (response) {

        _this18.examenesPaciente = response.data.data.examenes;

        _this18.examenes_t = response.data.data.examenes;

        for (var index = 1; index < 11; index++) {
          if (response.data.data["examenes" + index].length > 0) {
            _this18.examenHoy = true;
          }
        }
        _this18.tipoExamen();
      }).catch(function (error) {
        console.log(error);
      });
    },
    tratamientos: function tratamientos() {
      var _this19 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/tratamientos/" + this.PacIde,
        headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }, "Content-Type", "multipart/form-data")
      }).then(function (response) {
        _this19.tratamiento = response.data.data;
        if (response.data.data.length > 0) {
          _this19.tratamientoHoy = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    nuevoPlanTratamiento: function nuevoPlanTratamiento() {
      var _this20 = this;

      var textoDelArray = "";
      for (var i = 0; i < this.cie10.length; i++) {
        textoDelArray = textoDelArray + (" " + this.cie10[i] + ",");
      }

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "post",
        baseURL: this.ip + "api/nuevoTratamiento",
        data: {
          PacIde: this.PacIde,
          TraFec: this.fechaTratamiento,
          TraDes: this.descripcionTratamiento,
          TraRec: this.recomendacionesTratamiento,
          servicios: this.arrayEspecialidad,
          TraFecFin: this.fechaFinTratamiento,

          TraCas: textoDelArray,
          terapeuta: localStorage.getItem("usuario")
        },
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this20.$notify({
          component: {
            template: "<span><b> Plan De Tratamiento Registrado Con \xC9xito</b>.</span>"
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this20.type["success"]
        });
        _this20.calcularFechaActual();
        _this20.descripcionTratamiento = "";
        _this20.recomendacionesTratamiento = "";
        _this20.arrayEspecialidad = [];
        _this20.tratamientos();
        _this20.tratamientoHoy = true;
        _this20.$modal.hide("modalNuevoPlan");
        _this20.e_tratamiento = true;
      }).catch(function (error) {
        console.log(error);
        _this20.e_tratamiento = true;
      });
    },
    nuevaEspecialidad: function nuevaEspecialidad() {
      if (this.especialidad != "" && this.sesiones != "") {
        this.arrayEspecialidad.push({
          especialidad: this.especialidad[0],
          sesiones: this.sesiones,
          nombre: this.especialidad[1]
        });
        this.especialidad = "";
        this.sesiones = "";
      }
    },
    selectEspecialidad: function selectEspecialidad() {
      var _this21 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/selectEspecialidad",
        headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }, "Content-Type", "multipart/form-data")
      }).then(function (response) {
        _this21.arrayEspecialidades = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    verDetalle: function verDetalle(row) {
      var _this22 = this;

      this.terapeutaPDF = "";
      this.$modal.show("modalNuevoPlanDetalle");
      var token = localStorage.getItem("token");
      var TraIde = row.TraIde;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/detalle/" + TraIde,
        headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }, "Content-Type", "multipart/form-data")
      }).then(function (response) {
        _this22.arrayDetalle = response.data.data;
        _this22.fechaTratamiento = row.TraFec;
        _this22.cie10mostrar = row.TraCas;
        _this22.descripcionTratamiento = row.TraDes, _this22.recomendacionesTratamiento = row.TraActFam, _this22.fechaFinTratamiento = row.TraFecFin, _this22.actividadFamiliar = row.TraActFam;
        _this22.logo = response.data.logo;

        _this22.terapeutaPDF = row.terapeuta;
        _this22.fechaIngresoTratamiento = row.created_at.substring(0, 10);
      }).catch(function (error) {});
    },
    tipoExamen: function tipoExamen() {
      var _this23 = this;

      this.cambiarLinkExamen();
      this.arrayActivo = this.examenesPaciente.filter(function (examen) {
        return examen.tipo == _this23.examen;
      });
    },
    agregarExamen: function agregarExamen() {
      var _this24 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "api/nuevoExamen";
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.post(url, {
        examen: this.examenEnviar,
        nombreExamen: this.nombreExamen,
        PacIde: this.PacIde,
        IdPaciente: this.numeroDocumento,
        fecha: this.motivoVerificarFec,
        tipo: this.examen,
        terapeuta: localStorage.getItem("usuario")
      }, config).then(function (response) {
        _this24.examenes();
        _this24.nombreExamen = "";
        _this24.examenEnviar = null;
        _this24.examenHoy = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    cargarExamen: function cargarExamen(e) {
      var _this25 = this;

      var reader = new FileReader();
      var examen1 = e.target.files[0];
      this.nombreExamen = e.target.files[0].name;
      this.examen2 = URL.createObjectURL(examen1);
      reader.readAsDataURL(examen1);
      reader.onload = function (e) {
        _this25.examenEnviar = e.target.result;
      };
    },
    calcularFechaActual: function calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fechaDeConsulta = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaAntecedente = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaImpresion = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaResumen = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaTratamiento = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaVerificado = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaAntecedente = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaDeConsulta = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaImpresion = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaResumen = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaTratamiento = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaVerificado = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    calcularEdad: function calcularEdad() {
      if (this.Fecha_nacimiento != "") {
        var fechaNacimiento = this.Fecha_nacimiento;
        var values = fechaNacimiento.split("-");
        var dia = values[2];
        var mes = values[1];
        var ano = values[0];

        var fecha_hoy = new Date();
        var ahora_ano = fecha_hoy.getFullYear();
        var ahora_mes = fecha_hoy.getMonth() + 1;
        var ahora_dia = fecha_hoy.getDate();

        var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;


        var edad = ahora_ano + 0 - ano;
        if (ahora_mes < mes) {
          edad--;
        }
        if (mes == ahora_mes && ahora_dia < dia) {
          edad--;
        }
        if (edad > 1900) {
          edad -= 1900;
        }

        var meses = 0;
        if (ahora_mes > mes) meses = ahora_mes - mes;
        if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
        if (ahora_mes == mes && dia > ahora_dia) meses = 11;

        var dias = 0;
        if (ahora_dia > dia) dias = ahora_dia - dia;
        if (ahora_dia < dia) {
          var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
          var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
        }

        this.anos = edad;
        this.meses = meses;
        this.edad = this.anos + " años y " + this.meses + " meses";
      } else {
        this.anos = 0;
      }
    },

    e_realizados_to: function e_realizados_to() {
      var _this26 = this;

      var url = this.ip + "api/To_fechas/" + this.PacIde;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url).then(function (response) {
        _this26.examenesRealizados = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    e_realizados_ps: function e_realizados_ps() {
      var _this27 = this;

      var url = this.ip + "api/ps_fechas/" + this.PacIde;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url).then(function (response) {
        _this27.examenesRealizadosPs = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    e_realizados_fonol: function e_realizados_fonol() {
      var _this28 = this;

      var url = this.ip + "api/fonoL_fechas/" + this.PacIde;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url).then(function (response) {
        _this28.examenesRealizadosfonol = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    examenesRealizadosF: function examenesRealizadosF() {
      this.e_realizados_ps();
      this.e_realizados_ps();
      this.e_realizados_fonol();
    },
    eliminarServicio: function eliminarServicio(index) {
      this.arrayEspecialidad.splice(index, 1);
    },
    selectDataInformeEvolucion: function selectDataInformeEvolucion(fecha, terapeuta, tratamiento) {

      this.examenesPDF = [];
      this.motivoPDF = '';
      this.motivoPDF_id = 0;
      this.impresionesPDF = '';
      this.antecedentesPrePDF = [];
      this.antecedentesNeoPDF = [];
      this.antecedentesPosPDF = [];
      this.antecedentesPerPDF = [];
      this.antecedentesFamPDF = [];
      this.conclusionesPDF = [];
      this.recomendacionPDF = [];

      this.terapeutaPDF = terapeuta;

      var motivos = this.arrayMotivo;
      var impresiones = this.arrayResumen;
      var examenes = this.examenes_t;

      var motivoPDF = motivos.filter(function (motivo) {
        return motivo.MotFec == fecha && motivo.MotTer == terapeuta;
      });

      this.motivoPDF = motivoPDF[0].MotVer;
      this.motivoPDF_id = motivoPDF[0].MotIde;
      console.log('id_pfd_motivo', this.motivoPDF_id);

      var examenesPDF = examenes.filter(function (examen) {
        return examen.created_at.substring(0, 10) == fecha;
      });
      this.examenesPDF = examenesPDF;
      var impresionesPDF = impresiones.filter(function (impresion) {
        return impresion.ResFec == fecha && impresion.terapeuta == terapeuta;
      });

      if (impresionesPDF.length > 0) {
        this.impresionesPDF = impresionesPDF[0].ResDes;
      }
      this.antecedentesPrePDF = this.convertArrayToText(this.antecedentesPre, "AntDes");
      this.antecedentesNeoPDF = this.convertArrayToText(this.antecedentesNeo, "AntDes");
      this.antecedentesPosPDF = this.convertArrayToText(this.antecedentesPos, "AntDes");
      this.antecedentesPerPDF = this.convertArrayToText(this.antecedentesPer, "AntDes");
      this.antecedentesFamPDF = this.convertArrayToText(this.antecedentesFam, "AntDes");
      this.conclusionesPDF = tratamiento;
      this.fechaPDF = fecha;
    },
    convertArrayToText: function convertArrayToText(data, propiedad) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      var texto = "";
      var prop = propiedad;
      if (propiedad != "") {
        for (var i = 0; i < data.length; i++) {
          texto = texto + (" " + data[i][propiedad] + ",");
        }
      } else {
        for (var _i2 = 0; _i2 < data.length; _i2++) {
          texto = texto + (" " + data[_i2] + ",");
        }
      }

      if (option == 1) {
        return this.eliminarUltimoCaracter(texto);
      } else {
        return texto;
      }
    },
    eliminarUltimoCaracter: function eliminarUltimoCaracter(texto) {
      return texto.substring(0, texto.length - 1);
    },
    alerta: function alerta() {
      var opcion = confirm("\xBFdesea continuar viendo la historia clinica de " + localStorage.getItem("PacienteNombre") + "?");
      if (opcion == true) {
        this.criterio = "PacNumDoc";
        this.busqueda = localStorage.getItem("PacienteHC");
        this.buscarPacientes();
      } else {
        localStorage.removeItem("PacienteHC");
        localStorage.removeItem("PacienteId");
        localStorage.removeItem("PacienteNombre");
      }
    },
    push: function push(route) {
      this.$router.push(route);
    },

    validarDispositivo: function validarDispositivo() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.push("historia-movil");
      }
    }
  },

  mounted: function mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.motivosM();
      this.calcularFechaActual();
      this.usuarioAvanza = localStorage.getItem("usuario");
      if (localStorage.getItem("PacienteHC")) {
        this.alerta();
      }
      this.abrirModalVerificarFirma();

      this.validarDispositivo();
    }
  }
});

/***/ }),

/***/ "fRTS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card",staticStyle:{"padding":"5px 10px 5px","border-radius":"10px"}},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('strong',{staticStyle:{"font-size":"20px"}},[_vm._v("Información de la nomina")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"darkgray"}},[_vm._v("Listado de todas las personas que tienen salario fijo")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"darkgray"}},[_vm._v("Resumen de los gatos de nomina: "),_c('span',{staticStyle:{"color":"green"}},[_vm._v(_vm._s(_vm.resumenNomina))])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"max-height":"400px","overflow":"scroll","overflow-x":"hidden"}},[_c('div',{staticClass:"row"},_vm._l((_vm.informacionNomina),function(persona){return _c('div',{key:persona.nombre,staticClass:"col-md-12"},[_c('div',{staticClass:"card",staticStyle:{"border":"1px darkgray solid"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v(_vm._s(persona.nombre))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("NOMBRE COMPLETO")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(persona.salarioFijo))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("SALARIO FIJO")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v(" "+_vm._s(persona.prestaciones))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("PRESTACIONES SOCIALES")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v(" "+_vm._s(persona.transporte))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"color":"grey"}},[_vm._v("AUXILIO DE TRANSPORTE")])])])])])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g187":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('small',[_vm._v(" Fecha inicial: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechainicio),expression:"fechainicio"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechainicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechainicio=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('small',[_vm._v(" Fecha final: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechafin),expression:"fechafin"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechafin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechafin=$event.target.value}}})]),_vm._v(" "),(_vm.rol == 1)?_c('div',{staticClass:"col-md-3"},[_c('small',{attrs:{"for":""}},[_vm._v("Sede:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sede),expression:"sede"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sede=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.SedesProgramacion),function(sede){return _c('option',{key:sede.sede,domProps:{"value":sede.sede}},[_vm._v("\n              "+_vm._s(sede.sede)+"\n            ")])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"0px"},on:{"click":function($event){return _vm.getInformation()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Buscar\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('br'),_vm._v(" "),(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-primary btn-fill",staticStyle:{"border-radius":"0px"},attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"My Worksheet","name":'Reporte-autorizaciones' + '-' + _vm.fechainicio + '-' + _vm.fechafin}},[_vm._v("\n            Exportar a excel\n          ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"size":"mini","data":_vm.queriedData,"max-height":"500"}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":130,"label":"Fecha de registro"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.created_at.substring(0, 10))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":160,"label":"Observaciones"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n                "+_vm._s(props.row.observaciones)+"\n              ")]}}])})],2)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('h4',[_vm._v("Reporte de autorizaciones")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gYgR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objetivos_logros_vue__ = __webpack_require__("MfEB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2736ee1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_objetivos_logros_vue__ = __webpack_require__("sJQM");
function injectStyle (ssrContext) {
  __webpack_require__("Uquv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2736ee1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objetivos_logros_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2736ee1e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_objetivos_logros_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gjVO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hJZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      usuario: '',
      password: '',
      token: '',
      ip: 'https://avanti-erp.com/',
      error: '',
      mensaje: null,
      icono: null
    };
  },

  methods: {
    toggleNavbar: function toggleNavbar() {
      document.body.classList.toggle('nav-open');
    },
    closeMenu: function closeMenu() {
      document.body.classList.remove('nav-open');
      document.body.classList.remove('off-canvas-sidebar');
    },
    login: function login() {
      var _this = this;

      this.mensaje = 'Iniciando sesión...';
      this.icono = 'spinner';
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.ip + 'api/login', {
        'usuario': this.usuario,
        'password': this.password
      }).then(function (response) {

        if (response.data.status == true) {
          _this.token = response.data.token;
          localStorage.setItem('token', _this.token);
          localStorage.setItem('emailsProgramacion', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.emails));
          localStorage.setItem('usuario', response.data.usuario[0].usuario);
          localStorage.setItem('rol', response.data.usuario[0].id_rol);
          localStorage.setItem('email', response.data.usuario[0].email);
          localStorage.setItem('foto', response.data.usuario[0].url_foto);
          localStorage.setItem('sede', response.data.usuario[0].sede);
          localStorage.setItem('nombre', response.data.usuario[0].nombres + ' ' + response.data.usuario[0].apellidos);
          localStorage.setItem('firmaElectronica', response.data.usuario[0].UsuFirEle);
          if (response.data.usuario[0].id_rol == 1) {
            _this.$router.push('/dashboard/avanti');
          } else if (response.data.usuario[0].id_rol == 7) {
            _this.$router.push('/programacion/programacion-citas');
          } else if (response.data.usuario[0].id_rol == 8) {
            _this.$router.push('/reportes/pacientes');
          } else if (response.data.usuario[0].id_rol == 9) {
            _this.$router.push('/programacion/programacion-citas');
          } else if (response.data.usuario[0].id_rol == 14) {
            _this.$router.push('/dashboard/avanti');
          } else if (response.data.usuario[0].id_rol == 10) {
            _this.$router.push('/historiaClinica/historia');
          } else {
            _this.$router.push('/diarioCampo/evoluciones');
          }
          location.reload();
        }

        if (response.data.status == false) {
          _this.mensaje = 'Usuario o contraseña incorrectos!';
          _this.icono = 'close';
          _this.password = '';
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    beforeDestroy: function beforeDestroy() {
      this.closeMenu();
    }
  },
  mounted: function mounted() {
    document.title = 'Avanti | Login';
    localStorage.removeItem('PacienteHC');
    localStorage.removeItem('PacienteId');
    localStorage.removeItem("PacienteNombre");
  }
});

/***/ }),

/***/ "hLLX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sesionesTerapeutas_vue__ = __webpack_require__("8LRc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc60b21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sesionesTerapeutas_vue__ = __webpack_require__("YCQR");
function injectStyle (ssrContext) {
  __webpack_require__("qdTC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1dc60b21"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sesionesTerapeutas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc60b21_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sesionesTerapeutas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hLSs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_poliza_vue__ = __webpack_require__("y6op");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2112e2e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_poliza_vue__ = __webpack_require__("plmj");
function injectStyle (ssrContext) {
  __webpack_require__("Q9Qi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2112e2e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_poliza_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2112e2e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_poliza_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hOWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{staticClass:"logo"},[_c('center',[_c('img',{staticStyle:{"width":"70%"},attrs:{"src":_vm.title,"alt":""}})])],1),_vm._v(" "),_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[_vm._t("default"),_vm._v(" "),_c('ul',{class:_vm.navClasses},[_vm._t("links",function(){return [_c('sidebar-item',{attrs:{"link":{name: 'Dashboard', icon: 'fa fa-home'}}},[_vm._l((_vm.permisos),function(permiso){return (permiso.modulo == 'Dashboard')?_c('sidebar-item',{key:permiso.id,attrs:{"link":{
            name: permiso.name,
            icon: permiso.icon,
            path: permiso.path
          }}}):_vm._e()}),_vm._v(" "),(_vm.rol==2 || _vm.rol==3 || _vm.rol==4 || _vm.rol==5 || _vm.rol==6)?_c('sidebar-item',{attrs:{"link":{name: 'Mi Espacio', 
          path: '/mi-espacio',
          icon: 'ti-file'
          }}}):_vm._e()],2),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{name: 'Reportes', icon: 'fa fa-folder'}}},_vm._l((_vm.permisos),function(permiso){return (permiso.modulo == 'Reportes')?_c('sidebar-item',{key:permiso.id,attrs:{"link":{
            name: permiso.name,
            icon: permiso.icon,
            path: permiso.path
          }}}):_vm._e()}),1),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{name: 'Admisiones', icon: 'fa fa-user'}}},_vm._l((_vm.permisos),function(permiso){return (permiso.modulo == 'Admisiones')?_c('sidebar-item',{key:permiso.id,attrs:{"link":{
            name: permiso.name,
            icon: permiso.icon,
            path: permiso.path
          }}}):_vm._e()}),1),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{name: 'Historia Clínica', icon: 'fa fa-folder'}}},_vm._l((_vm.permisos),function(permiso){return (permiso.modulo == 'Historia Clinica')?_c('sidebar-item',{key:permiso.id,attrs:{"link":{
            name: permiso.name,
            icon: permiso.icon,
            path: permiso.path
          }}}):_vm._e()}),1),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{name: 'Mantenimiento', icon: 'fa fa-gear'}}},_vm._l((_vm.permisos),function(permiso){return (permiso.modulo == 'Mantenimiento')?_c('sidebar-item',{key:permiso.id,attrs:{"link":{
            name: permiso.name,
            icon: permiso.icon,
            path: permiso.path
          }}}):_vm._e()}),1),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{name: 'Acceso', icon: 'fa fa-key'}}},_vm._l((_vm.permisos),function(permiso){return (permiso.modulo == 'Acceso')?_c('sidebar-item',{key:permiso.id,attrs:{"link":{
            name: permiso.name,
            icon: permiso.icon,
            path: permiso.path
          }}}):_vm._e()}),1),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{name: 'Plan de intervención', icon: 'fa fa-book'}}},_vm._l((_vm.permisos),function(permiso){return (permiso.modulo == 'Plan de intervención')?_c('sidebar-item',{key:permiso.id,attrs:{"link":{
            name: permiso.name,
            icon: permiso.icon,
            path: permiso.path
          }}}):_vm._e()}),1),_vm._v(" "),_c('sidebar-item',{attrs:{"link":{name: 'Programación', icon: 'fa fa-calendar'}}},_vm._l((_vm.permisos),function(permiso){return (permiso.modulo == 'Programación')?_c('sidebar-item',{key:permiso.id,attrs:{"link":{
            name: permiso.name,
            icon: permiso.icon,
            path: permiso.path
          }}}):_vm._e()}),1)]})],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hRHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__ = __webpack_require__("+Rp4");



















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_15_vue_json_excel__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.queriedData2.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.queriedData2.length;
        return this.pagedData;
      }
      var result = this.queriedData2.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.queriedData2.length;
      return this.queriedData2.length;
    }
  },
  data: function data() {
    return {
      ip: "https://fundaintegra.com/",
      searchQuery: "",
      fechaInicial: "",
      fechaFinal: "",
      queriedData2: [],
      fechaActual: "",
      tableColumns: [{
        prop: "nombrePaciente",
        label: "Paciente",
        minWidth: 180
      }, {
        prop: "codigoOrden",
        label: "Codigo orden",
        minWidth: 150
      }, {
        prop: "fechaExpedicion",
        label: "F. expedición",
        minWidth: 90
      }, {
        prop: "fechaVencimiento",
        label: "F. vencimiento",
        minWidth: 90
      }, {
        prop: "total",
        label: "S. totales",
        minWidth: 50
      }, {
        prop: "bolsa",
        label: "S. bolsa",
        minWidth: 50
      }, {
        prop: "remaining",
        label: "% restante",
        minWidth: 70
      }],
      json_fields: {
        "Paciente": "nombrePaciente",
        "Codigo orden": "codigoOrden",
        "F. expedición": "fechaExpedicion",
        "F. vencimiento": "fechaVencimiento",
        "S. totales": "total",
        "S. bolsa": "bolsa",
        "% restante": "remaining"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]],
      SedesProgramacion: [],
      sede: "Sede Principal",
      rol: "",
      tipo: "",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  methods: {
    obtenerAutorizaciones: function obtenerAutorizaciones() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sede, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.$modal.show("carga");
                sede = localStorage.getItem("sede");
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_12_src_global_services_axiosInstance__["a" /* default */].get("api/reportes/informe-autorizaciones/" + sede);

              case 5:
                response = _context.sent;

                _this2.queriedData2 = response.data.data;
                _this2.json_data = response.data.data;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.log("Error al obtener los datos:" + _context.t0);

              case 13:
                _context.prev = 13;

                _this2.$modal.hide("carga");
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10, 13, 16]]);
      }))();
    },

    emailsProgramacion: function emailsProgramacion() {
      var _this3 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var BASE_URL = this.ip + "api/emailsProgramacion";
      axios.get(BASE_URL, config).then(function (res) {
        var data = res.data.data;
        _this3.SedesProgramacion = data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getClass: function getClass(column, row) {
      if (column.prop === "remaining") {
        return row.classRemaining;
      }
      return "";
    }
  },
  mounted: function mounted() {
    this.rol = localStorage.getItem("rol");
    if (localStorage.getItem("rol") != 1) {
      this.sede = localStorage.getItem("sede");
    }
    this.obtenerAutorizaciones();
    document.title = "Integra | Reporte de autorizaciones";
  }
});

/***/ }),

/***/ "hSpV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionGastoTerapeutas_vue__ = __webpack_require__("/n5s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_690b8168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionGastoTerapeutas_vue__ = __webpack_require__("+jLu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionGastoTerapeutas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_690b8168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionGastoTerapeutas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hf80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
   var dateC = new Date(value);
   return dateC.toLocaleString(['es-ES'], { month: 'long',
      day: '2-digit', year: 'numeric' });
});

/***/ }),

/***/ "hgCH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'card card-circle-chart ' + _vm.color},[_c('div',{staticClass:"card-header text-center"},[_c('strong',{staticClass:"card-title",staticStyle:{"font-size":"17px"}},[_vm._v(_vm._s(_vm.title)),(_vm.pendiente)?_c('span',{staticStyle:{"color":"red","font-size":"18px"}},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"description",staticStyle:{"color":"grey"}},[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_c('p',{staticClass:"pendienteEvaluar",staticStyle:{"color":"grey"}},[_vm._v(_vm._s(_vm.pendienteEvaluar))])]),_vm._v(" "),(_vm.confidencial == false)?_c('div',{staticClass:"card-content"},[(_vm.percentage != '--')?_c('div',[_c('div',{ref:"chart",staticClass:"chart-circle",attrs:{"data-percent":_vm.percentage}},[_vm._v("\n        "+_vm._s(_vm.percentage)+"%\n      ")])]):_c('div',[_c('div',{ref:"chart",staticClass:"chart-circle",attrs:{"data-percent":_vm.percentage}},[_vm._v("\n        "+_vm._s(_vm.percentage)+"\n      ")])])]):_c('div',{staticClass:"card-content"},[_c('center',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{staticClass:"img-responsive",attrs:{"src":"static/img/ICONOS/candado.svg","width":"70","alt":"Imagen de bloqueo de HC avanti"}})]),_vm._v(" "),_c('p',[_vm._v("Confidencial")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hoIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionEntidad_vue__ = __webpack_require__("FlRp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a695c3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionEntidad_vue__ = __webpack_require__("N6Po");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionEntidad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a695c3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionEntidad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hqCP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
















__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip: 'https://avanti-erp.com/',
      descripcion: "",
      tipo: 3,
      modalRegistrar: 0,

      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      },

      pagination: {
        perPage: 7,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['DomDes'],
      tableColumns: [{
        prop: 'DomDes',
        label: 'Nombre',
        minWidth: 150 }],
      arrayMotivo: []

    };
  },


  computed: {
    pagedData: function pagedData() {
      return this.arrayMotivo.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.arrayMotivo.length;
        return this.pagedData;
      }
      var result = this.arrayMotivo.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.arrayMotivo.length;
      return this.arrayMotivo.length;
    }
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },

  methods: {
    abrirModal: function abrirModal() {
      this.modalRegistrar = 1;
    },
    nuevoDominio: function nuevoDominio() {
      var _this2 = this;

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + 'api/nuevoDominio';
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(url, {
        descripcion: this.descripcion,
        tipo: this.tipo
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this2.$notify({
          component: {
            template: '<span>-<b> Motivo de consulta registrado con \xE9xito!</b>.</span>'
          },
          icon: 'ti-check',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: _this2.type[color]
        });
        _this2.tipo = 3;
        _this2.descripcion = "";
        _this2.modalRegistrar = 0;
        _this2.motivos();
      }).catch(function (error) {
        console.log(error);
      });
    },
    desactivar: function desactivar() {
      var _this3 = this;

      var patologia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + 'api/desactivarDominio';
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url, {
        id: patologia.DomIde
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this3.$notify({
          component: {
            template: '<span>-<b> Motivo de consulta Desactivado con \xE9xito!</b>.</span>'
          },
          icon: 'ti-check',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: _this3.type[color]
        });
        _this3.motivos();
      }).catch(function (error) {
        console.log(error);
      });
    },
    activar: function activar() {
      var _this4 = this;

      var patologia = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + 'api/activarDominio';
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url, {
        id: patologia.DomIde
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this4.$notify({
          component: {
            template: '<span>-<b> Motivo de consulta Activado con \xE9xito!</b>.</span>'
          },
          icon: 'ti-check',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: _this4.type[color]
        });
        _this4.motivos();
      }).catch(function (error) {
        console.log(error);
      });
    },
    motivos: function motivos() {
      var _this5 = this;

      var config = {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      };
      var url = this.ip + "api/allMotivos";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(url, config).then(function (response) {
        _this5.arrayMotivo = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    limpiarFormulario: function limpiarFormulario() {
      this.descripcion = "";
      this.tipo = 3;
    }
  },
  mounted: function mounted() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/');
    } else {
      this.motivos();
    }
  }
});

/***/ }),

/***/ "i8I4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('center',[_c('h3',[_vm._v("\n          Reporte de pacientes\n          "),_c('i',{staticClass:"fa fa-folder"})])]),_vm._v(" "),_c('hr')],1),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[(_vm.rol == 1)?_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Sede:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sede),expression:"sede"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sede=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.SedesProgramacion),function(sede){return _c('option',{key:sede.sede,domProps:{"value":sede.sede}},[_vm._v("\n                "+_vm._s(sede.sede)+"\n              ")])}),0),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]):_vm._e()]),_vm._v(" "),_c('center',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Todos los pacientes:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"1","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"1")},on:{"change":function($event){_vm.tipo="1"}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Tipo de cliente:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"2","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"2")},on:{"change":function($event){_vm.tipo="2"}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Entidad:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"3","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"3")},on:{"change":function($event){_vm.tipo="3"}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Ver pacientes:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.estado),expression:"estado"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.estado=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":1}},[_vm._v("Activos")]),_vm._v(" "),_c('option',{domProps:{"value":0}},[_vm._v("Inactivos")]),_vm._v(" "),_c('option',{domProps:{"value":3}},[_vm._v("Todos")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.tipo == 2)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Opciones:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipocliente),expression:"tipocliente"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipocliente=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"2"}},[_vm._v("PARTICULARES")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("CONVENIOS")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("PROYECTOS")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("EPS")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("PREPAGADAS")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("POLIZAS")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("OTROS")])])])]):_vm._e(),_vm._v(" "),(_vm.tipo == 3)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Tipo de entidad:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoEntidad),expression:"tipoEntidad"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipoEntidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"EpsCod"}},[_vm._v("EPS")]),_vm._v(" "),_c('option',{attrs:{"value":"PreCod"}},[_vm._v("PREPAGADAS")]),_vm._v(" "),_c('option',{attrs:{"value":"PolCod"}},[_vm._v("POLIZAS")])])]),_vm._v(" "),(_vm.tipoEntidad == 'EpsCod')?_c('div',{staticClass:"col-md-2"},[_c('label',{attrs:{"for":""}},[_vm._v("Regimen:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.regimen),expression:"regimen"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.regimen=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.selectEps()}]}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Contributivo")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Subsidiado")])])]):_vm._e(),_vm._v(" "),(_vm.tipoEntidad == 'EpsCod')?_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Entidad:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.entidad),expression:"entidad"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.entidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayEps),function(entidad){return _c('option',{key:entidad.EpsCod,domProps:{"value":entidad.EpsCod}},[_vm._v("\n              "+_vm._s(entidad.EpsNom)+"\n            ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.tipoEntidad == 'PreCod')?_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Entidad:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.entidad),expression:"entidad"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.entidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayPrepagada),function(entidad){return _c('option',{key:entidad.EpsCod,domProps:{"value":entidad.EpsCod}},[_vm._v("\n              "+_vm._s(entidad.EpsNom)+"\n            ")])}),0)]):_vm._e(),_vm._v(" "),(_vm.tipoEntidad == 'PolCod')?_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Entidad:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.entidad),expression:"entidad"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.entidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayPoliza),function(entidad){return _c('option',{key:entidad.EpsCod,domProps:{"value":entidad.EpsCod}},[_vm._v("\n              "+_vm._s(entidad.EpsNom)+"\n            ")])}),0)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Especialidad:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.especialidad),expression:"especialidad"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.especialidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Todas")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Fisioterapia")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Fonoaudiología")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Terapia Ocupacional")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Educación Especial")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Psicología")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fecha_inicial),expression:"fecha_inicial"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fecha_inicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fecha_inicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Fecha final:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fecha_final),expression:"fecha_final"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fecha_final)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fecha_final=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',{attrs:{"for":""}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.getPacientes()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Buscar\n          ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Cant. datos: "+_vm._s(_vm.pacientes.length))]),_vm._v(" "),_c('el-table',{staticClass:"table-striped",attrs:{"data":_vm.pacientes,"border":""}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"else":""}})}),1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ij53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__ = __webpack_require__("XXU8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcfadbe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__ = __webpack_require__("liBz");
function injectStyle (ssrContext) {
  __webpack_require__("RNWA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dcfadbe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "im4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);


/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }

        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ "ipIU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_valoraciones_vue__ = __webpack_require__("4OLZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_026746f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_valoraciones_vue__ = __webpack_require__("GGWZ");
function injectStyle (ssrContext) {
  __webpack_require__("oQg9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_valoraciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_026746f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_valoraciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "isE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jMFD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jfmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var convertArrayToText = function convertArrayToText(data, propiedad) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  var texto = '';
  if (propiedad !== '') {
    for (var i = 0; i < data.length; i++) {
      texto = texto + (' ' + data[i][propiedad] + ',');
    }
  } else {
    for (var _i = 0; _i < data.length; _i++) {
      texto = texto + (' ' + data[_i] + ',');
    }
  }

  if (option === 1) {
    return texto.substring(0, texto.length - 1);
  } else {
    return texto;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (convertArrayToText);

/***/ }),

/***/ "jnwT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k8gv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kQnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reporteFacturacion_vue__ = __webpack_require__("HIL4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_516e2bc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reporteFacturacion_vue__ = __webpack_require__("N9S+");
function injectStyle (ssrContext) {
  __webpack_require__("sQEs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-516e2bc8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reporteFacturacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_516e2bc8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reporteFacturacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ka1j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informeAutorizaciones_vue__ = __webpack_require__("hRHF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33c98831_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informeAutorizaciones_vue__ = __webpack_require__("vl8t");
function injectStyle (ssrContext) {
  __webpack_require__("JuGc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informeAutorizaciones_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33c98831_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informeAutorizaciones_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kpYD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_switches__ = __webpack_require__("lqen");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      c90: false,
      formato: 1,
      criterio: "PacApe1",
      buscar: true,
      arrayPacientes: [],
      busqueda: "",
      ip: "https://avanti-erp.com/",
      nombre: "",
      documento: "",
      pacIde: "",
      especialidad_autorizacion: 0,
      alertTipoCliente: '',
      numeroOrden: "",
      eps: "",
      cobertura: "",
      observaciones: '',
      regimen: 1,
      bolsa: 0,
      fechaExpedicion: "",
      fechaVencimiento: "",
      arrayCantidad: [],
      arrayEspecialidad: [],
      cantidad: "",
      epsCod: "",
      especialidad: "",
      arrayOrdenes: [],
      tablaOrden: false,
      numeroAutorizacion: "",
      fechaExpedicionAutorizacion: "",
      coberturaAutorizacion: "",
      arrayPrepagada: [],
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      }
    };
  },

  components: {
    Switches: __WEBPACK_IMPORTED_MODULE_1_vue_switches__["a" /* default */]
  },
  methods: {
    eliminarServicio: function eliminarServicio(index, fila) {
      this.arrayCantidad.splice(index, 1);
      this.bolsa = this.bolsa - parseInt(fila.cantidad);
      console.log('Bolsa', this.bolsa);
    },
    buscarPacientes: function buscarPacientes() {
      var _this = this;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      this.arrayPacientes = [];
      var vm = this;
      var url = this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        vm.arrayPacientes = response.data.data;
        _this.buscar = false;
        console.log(response.data.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    seleccionarPaciente: function seleccionarPaciente(paciente) {
      var _this2 = this;

      if (paciente.TipCliCod != localStorage.getItem("tipoClienteIngreso")) {
        var alerta = confirm('El tipo de cliente de este paciente, no concuerta con el modulo seleccionado, ¿desea continuar?');
        if (alerta == true) {
          this.buscar = true;
          this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
          this.documento = paciente.PacNumDoc;
          this.pacIde = paciente.PacIdeUsu;
          this.alertTipoCliente = true;

          setTimeout(function () {
            _this2.cargarOrdenes();
          }, 1000);
        }
      } else {
        this.buscar = true;
        this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
        this.documento = paciente.PacNumDoc;
        this.pacIde = paciente.PacIdeUsu;
        this.alertTipoCliente = false;

        setTimeout(function () {
          _this2.cargarOrdenes();
        }, 1000);
      }
    },
    generarCodigo: function generarCodigo() {
      this.numeroOrden = "PRE-" + this.pacIde + "-" + this.fechaExpedicion;
    },
    selectEspecialidad: function selectEspecialidad() {
      var _this3 = this;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/selectEspecialidad";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data.data;
        _this3.arrayEspecialidad = respuesta;
      }).catch(function (error) {
        console.log(error);
      });
    },
    agregarServicios: function agregarServicios() {
      if (this.especialidad != "" && this.cantidad != "") {
        this.arrayCantidad.push({
          servicio: this.especialidad,
          cantidad: this.cantidad
        });

        this.bolsa = parseInt(this.bolsa) + parseInt(this.cantidad);

        this.cantidad = "";
        this.especialidad = "";
      }
    },
    nuevaAutorizacionSinOM: function nuevaAutorizacionSinOM() {
      var _this4 = this;

      if (this.bolsa == 0) {
        alert("Debe cargarle servicios a la autorización");
      } else {
        this.$modal.show("carga");
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        };
        if (this.coberturaAutorizacion == "") {
          this.fechaVencimientoAutorizacion = "";
          this.cobertura = 0;
        } else {
          this.calcularFechaAutorizacion();
          var url = this.ip + "api/nuevaAutorizacionSinOM";
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
            codigoOrden: this.numeroAutorizacion,
            tipoServicio: "adm",
            entidad: 16,
            fechaOrden: this.fechaExpedicionAutorizacion,
            cobertura: this.coberturaAutorizacion,
            fechaVencimiento: this.fechaVencimientoAutorizacion,
            paciente: this.pacIde,
            servicios: this.arrayCantidad,
            formato: 1,
            pertenece: "avanza",
            bolsa: this.bolsa,
            usuario: localStorage.getItem("usuario"),
            observacion: this.observaciones,
            especialidad_autorizacion: this.especialidad_autorizacion
          }, config).then(function (response) {
            var color = Math.floor(Math.random() * 4 + 1);
            _this4.$notify({
              component: {
                template: "<span>!<b> Autorizaci\xF3n registrada con \xE9xito!</b>.</span>"
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: _this4.type[color]
            });

            _this4.bolsa = 0;
            _this4.$modal.hide("carga");
            _this4.cerrar();
          }).catch(function (error) {
            console.log(error);
            _this4.$modal.hide("carga");
          });
        }
      }
    },
    cargarOrdenes: function cargarOrdenes() {
      var _this5 = this;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/cargarOrdenesActivas/" + this.pacIde + "/prepagada";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        _this5.arrayOrdenes = response.data.data;

        _this5.tablaOrden = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    seleccionarOrden: function seleccionarOrden(orden) {
      this.tablaOrden = false;
      this.numeroOrden = orden.OrdCod;
      this.eps = orden.EpsNom;
      this.fechaExpedicion = orden.OrdFec;
      this.fechaVencimiento = orden.OrdVen;
      this.numeroAutorizacion = "PRE-AUT-" + this.pacIde;
      this.epsCod = orden.CodEnt;
    },
    selectPrepagada: function selectPrepagada() {
      var _this6 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "/api/selectPrepagada";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this6.arrayPrepagada = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    calcularFecha: function calcularFecha() {
      var dias = parseInt(this.cobertura);
      var fechaInicio = new Date(this.fechaExpedicion);
      fechaInicio.setDate(fechaInicio.getDate() + dias);

      var fechaFin = new Date(fechaInicio);

      var dia = fechaFin.getDate();
      var mes = fechaFin.getMonth() + 1;
      var ano = fechaFin.getFullYear();
      var cero = "0";
      if (mes < 10 && dia < 10) {
        this.fechaVencimiento = ano + "-" + "0" + mes + "-" + "0" + dia;
        this.fechaVencimientoAutorizacion = ano + "-" + "0" + mes + "-" + "0" + dia;
      } else {
        this.fechaVencimiento = ano + "-" + mes + "-" + dia;
        this.fechaExpedicionAutorizacion = ano + "-" + mes + "-" + dia;
      }
    },
    calcularFechaAutorizacion: function calcularFechaAutorizacion() {
      var dias = parseInt(this.coberturaAutorizacion);
      var fechaInicio = new Date(this.fechaExpedicionAutorizacion);
      fechaInicio.setDate(fechaInicio.getDate() + dias);

      var fechaFin = new Date(fechaInicio);

      var dia = fechaFin.getDate();
      var mes = fechaFin.getMonth() + 1;
      var ano = fechaFin.getFullYear();
      var cero = "0";
      if (mes < 10 && dia < 10) {
        this.fechaVencimientoAutorizacion = ano + "-" + "0" + mes + "-" + "0" + dia;
      } else {
        this.fechaVencimientoAutorizacion = ano + "-" + mes + "-" + dia;
      }
    },
    nuevaOrdenMedica: function nuevaOrdenMedica() {
      var _this7 = this;

      if (this.bolsa == 0) {
        alert("Debe cargar servicios a la orden");
      } else {
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        };
        this.calcularFecha();
        var url = this.ip + "api/nuevaOrdenMedica";
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
          codigoOrden: this.numeroOrden,
          tipoServicio: "prepagada",
          entidad: this.eps,
          fechaOrden: this.fechaExpedicion,
          cobertura: this.cobertura,
          fechaVencimiento: this.fechaVencimiento,
          paciente: this.pacIde,
          servicios: this.arrayCantidad,
          formato: 0,
          bolsa: this.bolsa
        }, config).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this7.$notify({
            component: {
              template: "<span>!<b> Orden m\xE9dica registrada con \xE9xito!</b>.</span>"
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this7.type[color]
          });
          _this7.criterio = "";
          _this7.busqueda = "";
          _this7.numeroOrden = "";
          _this7.eps = "";
          _this7.fechaExpedicion = "";
          _this7.cobertura = "";
          _this7.fechaVencimiento = "";
          _this7.pacIde = "";
          _this7.arrayCantidad = "";
          _this7.pacIde = "";
          _this7.arrayPacientes = "", _this7.formato = 1;
          _this7.nombre = "", _this7.documento = "";
          _this7.fechaExpedicion = "";
          _this7.bolsa = 0;
          _this7.cerrar();
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    nuevaAutorizacion: function nuevaAutorizacion() {
      var _this8 = this;

      if (this.bolsa == 0) {
        alert('Debe cargar servicios a la autorización');
      } else {
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        };
        this.calcularFechaAutorizacion();
        var url = this.ip + "api/nuevaAutorizacion";
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
          codigoOrden: this.numeroAutorizacion,
          tipoServicio: "prepagada",
          entidad: this.epsCod,
          fechaOrden: this.fechaExpedicionAutorizacion,
          cobertura: this.coberturaAutorizacion,
          fechaVencimiento: this.fechaVencimientoAutorizacion,
          paciente: this.pacIde,
          servicios: this.arrayCantidad,
          formato: 1,
          pertenece: this.numeroOrden,
          bolsa: this.bolsa,
          usuario: localStorage.getItem("usuario"),
          observacion: this.observaciones,
          especialidad_autorizacion: this.especialidad_autorizacion
        }, config).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this8.$notify({
            component: {
              template: "<span>!<b> Autorizaci\xF3n registrada con \xE9xito!</b>.</span>"
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this8.type[color]
          });
          _this8.criterio = "";
          _this8.busqueda = "";
          _this8.numeroOrden = "";
          _this8.numeroAutorizacion = "";
          _this8.fechaVencimientoAutorizacion = "";
          _this8.fechaExpedicionAutorizacion = "";
          _this8.coberturaAutorizacion = "";
          _this8.eps = "";
          _this8.fechaExpedicion = "";
          _this8.cobertura = "";
          _this8.fechaVencimiento = "";
          _this8.pacIde = "";
          _this8.arrayCantidad = "";
          _this8.pacIde = "";
          _this8.bolsa = 0;
          _this8.arrayPacientes = "", _this8.formato = 1;
          _this8.nombre = "", _this8.documento = "";
          _this8.fechaExpedicion = "";
          _this8.cerrar();
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    generarCodigoAutorizacion: function generarCodigoAutorizacion() {
      this.numeroAutorizacion = "PRE-AUT" + this.pacIde + "-" + this.fechaExpedicionAutorizacion;
    },
    cerrar: function cerrar() {
      this.$modal.hide("ingreso_servicio");
    }
  },
  props: ["modal"],
  mounted: function mounted() {
    this.selectEspecialidad();
    this.selectPrepagada();
  }
});

/***/ }),

/***/ "kunQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaestroV2_vue__ = __webpack_require__("yeKB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba89948_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaestroV2_vue__ = __webpack_require__("/W7v");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MaestroV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba89948_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MaestroV2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lGNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.obtenerInformacionCopagos(_vm.fechaInicial, _vm.fechaFinal)}}},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","required":"","id":"fechaInicial"},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha final:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","required":"","id":"fechaInicial"},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"card",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.prepararRegistrar()}}},[_vm._v("\n            Registrar nuevo copago\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('center',[(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e()])],1),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{ref:"component",staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill mb-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"Copagos recibidos","name":("Copagos de " + _vm.fechaInicial + " -- " + _vm.fechaFinal)}},[_vm._v("\n            Exportar a excel "),_c('i',{staticClass:"fa fa-download",attrs:{"color":"black"}})]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive mt-2",attrs:{"border":"","data":_vm.queriedData}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"full-width",class:_vm.getClass(column, row)},[(_vm.getClass(column, row) != '')?_c('strong',[_vm._v(_vm._s(_vm.formatearPesosColombianos(row[column.prop])))]):_c('span',[_vm._v(_vm._s(row[column.prop]))])])]}}],null,true)})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('button',{staticClass:"btn btn-simple btn-danger btn-icon like",on:{"click":function($event){return _vm.deleteCopay(props.row)}}},[_c('i',{staticClass:"ti-trash"})])])]}}],null,false,175429141)})],2)],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()]),_vm._v(" "),_c('modal',{attrs:{"name":"registrar-gasto","scrollable":true,"height":"auto","reset":true}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('strong',{staticClass:"titulo-modal"},[_vm._v(" REGISTRA UN NUEVO COPAGO ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.registrarCopago()}}},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"fecha"}},[_vm._v("Fecha del copago:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.fecha),expression:"form.fecha"}],staticClass:"form-control",attrs:{"type":"date","id":"fecha","required":""},domProps:{"value":(_vm.form.fecha)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "fecha", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"monto"}},[_vm._v("Monto:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.monto),expression:"form.monto"}],staticClass:"form-control",attrs:{"type":"number","id":"monto","required":""},domProps:{"value":(_vm.form.monto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "monto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"usuario"}},[_vm._v("Paciente:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.usuario),expression:"form.usuario"}],staticClass:"form-control",attrs:{"id":"usuario"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "usuario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Seleccionar...")]),_vm._v(" "),_vm._l((_vm.listUsers),function(usuario){return _c('option',{key:usuario.PacIdeUsu,domProps:{"value":usuario.PacIdeUsu}},[_vm._v("\n                "+_vm._s(usuario.PacNom1 + " " + usuario.PacApe1)+"\n                ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"eps"}},[_vm._v("Eps:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.eps),expression:"form.eps"}],staticClass:"form-control",attrs:{"name":"eps","id":"eps"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "eps", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("seleccione la eps")]),_vm._v(" "),_vm._l((_vm.arrayEps),function(eps){return _c('option',{key:eps.codigo,domProps:{"value":eps.codigo}},[_vm._v("\n                      "+_vm._s(eps.nombre)+"\n                    ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"categoria"}},[_vm._v("Metodo de pago")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tipo),expression:"form.tipo"}],staticClass:"form-control",attrs:{"id":"categoria","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Efectivo")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Transferencia")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"comentario"}},[_vm._v("Comentarios:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.comentario),expression:"form.comentario"}],staticClass:"form-control",attrs:{"type":"text","id":"comentario"},domProps:{"value":(_vm.form.comentario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "comentario", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-seconday",attrs:{"type":"button"},on:{"click":function($event){return _vm.cerrarModal()}}},[_vm._v("\n                  Cancelar\n                ")]),_vm._v(" "),_c('input',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit","value":"Registrar"}})])],1)])])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Gestión de copagos")]),_vm._v(" "),_c('p',[_vm._v("\n            Aquí podrá gestionar la información relacionada con los\n            "),_c('span',{staticClass:"text-success"},[_vm._v("copagos")]),_vm._v(" de\n            "),_c('span',{staticClass:"text-success"},[_vm._v("Avanza")]),_vm._v(" por fecha\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit","value":"Buscar información"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-5"},[_c('br'),_vm._v(" "),_c('table',[_c('tbody',[_c('tr',[_c('td',{staticClass:"low-percentage"},[_c('span',{staticClass:"color-box"})]),_vm._v(" "),_c('td',[_vm._v("Efectivo")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"medium-percentage"},[_c('span',{staticClass:"color-box"})]),_vm._v(" "),_c('td',[_vm._v("Transferencia")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lHnL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logInformes_vue__ = __webpack_require__("+CoK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199a43f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logInformes_vue__ = __webpack_require__("t0R4");
function injectStyle (ssrContext) {
  __webpack_require__("NniW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logInformes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199a43f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logInformes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "laR2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    name: 'Dashboard',
    icon: 'ti-file',
    collapsed: true,
    children: [{
        name: 'Dashboard',
        icon: 'user',
        path: '/dashboard/avanti'
    }]
}, {
    name: 'Admisiones',
    icon: 'ti-user',
    collapsed: true,
    children: [{
        name: 'Ingreso de pacientes',
        icon: 'user',
        path: '/admisiones/ingreso'
    }, {
        name: 'Pacientes Registrados',
        icon: 'user',
        path: '/admisiones/pacientes'
    }, {
        name: 'Ingreso de autorizaciones',
        icon: 'user',
        path: '/admisiones/servicios'
    }]
}, {
    name: 'Historia Clínica',
    icon: 'ti-folder',
    collapsed: true,
    children: [{
        name: 'Historia Clínica',
        path: '/historiaClinica/historia'
    }]
}, {
    name: 'Mantenimiento',
    icon: 'ti-settings',
    collapsed: true,
    children: [{
        name: 'Eps',
        path: '/mantenimiento/mantenimientoEps'
    }, {
        name: 'Patologías',
        path: '/mantenimiento/mantenimientoPatologias'
    }, {
        name: 'Motivo de Consulta',
        path: '/mantenimiento/mantenimientoMC'
    }]
}, {
    name: 'Acceso',
    icon: 'ti-shift-right',
    collapsed: true,
    children: [{
        name: 'Usuarios',
        path: '/acceso/usuario'
    }, {
        name: 'Roles',
        path: '/acceso/roles'
    }]
}, {
    name: 'Diario de campo',
    icon: 'ti-agenda',
    collapsed: true,
    children: [{
        name: 'Evoluciones',
        path: '/diarioCampo/evoluciones'
    }, {
        name: 'Objetivos y Logros',
        path: '/diarioCampo/objetivos-y-logros'
    }, {
        name: 'Objetivos y Logros en Familia',
        path: '/diarioCampo/objetivos-logros-familia'
    }]
}, {
    name: 'ProgramaciónTTTTTTTT',
    icon: 'ti-alarm-clock',
    collapsed: true,
    children: [{
        name: 'ProgramacióDSCSCDEVDSVn de citas',
        path: '/programacion/programacion-citas'
    }]
}, {
    name: 'Exámenes',
    icon: 'ti-alarm-clock',
    collapsed: true,
    children: [{
        name: 'Psicologia de Niños',
        path: '/examenes/psicologia-ninos'
    }]
}]);

/***/ }),

/***/ "liBz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"photo"},[_c('center',[_c('img',{attrs:{"width":"200","src":"/static/img/ICONOS/face-2.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"info"},[_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.toggleMenu}},[_c('span',[_vm._v("\n          "+_vm._s(_vm.usuario)+"\n           "),_c('b',{staticClass:"caret"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isClosed),expression:"!isClosed"}],staticClass:"nav"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.cerrarSesion()}}},[_c('span',{staticClass:"sidebar-mini"},[_vm._v("Mp")]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v("Cerrar sesión")])])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lqen":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_switches_vue__ = __webpack_require__("A+JM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8e4870fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_switches_vue__ = __webpack_require__("QmxO");
function injectStyle (ssrContext) {
  __webpack_require__("wCHw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_switches_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8e4870fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_switches_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mfVt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);








__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    pagedData: function pagedData() {
      return this.arrayOrdenes.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.arrayOrdenes.length;
        return this.pagedData;
      }
      var result = this.arrayOrdenes.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.arrayOrdenes.length;
      return this.arrayOrdenes.length;
    }
  },
  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  data: function data() {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      propsToSearch: ["PacNom1", "PacApe1", "OrdCod"],
      tableColumns: [{
        prop: "OrdCod",
        label: "Codigo",
        minWidth: 250 }, {
        prop: "EpsNom",
        label: "Entidad",
        minWidth: 250
      }],
      searchQuery: "",
      modalDetalles: 0,
      arrayOrdenes: [],
      tipoOrden: "",
      ip: "https://avanti-erp.com/",
      servicioSeleccionado: "",
      nombreSeleccionado: "",
      fechaSeleccionada: "",
      fechaVencimientoSeleccionada: "",
      formato: "",
      arrayServiciosOrden: [],
      arrayAutorizaciones: [],
      arrayServiciosAutorizacion: [],
      buscar: "",
      fechaActual: "",
      cancelar: false,
      usuarioOrden: "",
      ordide: 0,
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      observaciones: "",
      nombre_cliente: ""
    };
  },

  methods: {
    ordenes: function ordenes() {
      var _this2 = this;

      this.$modal.show("carga");
      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };

      var rol = localStorage.getItem('rol');
      var sedeBuscar = 'todas';
      if (rol > 1) {
        sedeBuscar = localStorage.getItem('sede');
      }
      var url = this.ip + "api/allOrdenes/" + this.fechaActual + "/" + sedeBuscar;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, config).then(function (response) {
        _this2.arrayOrdenes = response.data.data;
        _this2.$modal.hide("carga");
      }).catch(function (error) {
        console.log(error);
        _this2.$modal.hide("carga");
      });
    },
    verServiciosOrden: function verServiciosOrden(codigo) {
      var _this3 = this;

      this.$modal.show("carga");
      this.arrayServiciosOrden = [];
      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/verServiciosOrden/" + codigo;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, config).then(function (response) {
        _this3.arrayServiciosOrden = response.data.data;
        _this3.$modal.hide("carga");
      }).catch(function (error) {
        console.log(error);
        _this3.$modal.hide("carga");
      });
    },
    verServiciosAutorizacionUnica: function verServiciosAutorizacionUnica(codigo) {
      var _this4 = this;

      this.$modal.show("carga");
      this.cancelar = false;
      this.arrayServiciosAutorizacion = [];
      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/verServiciosOrden/" + codigo;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, config).then(function (response) {
        _this4.arrayServiciosAutorizacion = response.data.data;
        for (var i = 0; i < response.data.data.length; i++) {
          if (response.data.data[i].sesiones_pro != 0) {
            _this4.cancelar = false;
            break;
          } else {
            _this4.cancelar = true;
          }

          console.log(_this4.cancelar);
          _this4.$modal.hide("carga");
        }
      }).catch(function (error) {
        console.log(error);
        _this4.$modal.hide("carga");
      });
    },
    verAutorizaciones: function verAutorizaciones(codigo) {
      var _this5 = this;

      this.$modal.show("carga");
      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/verAutorizaciones/" + codigo;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, config).then(function (response) {
        _this5.arrayAutorizaciones = response.data.data;
        _this5.$modal.hide("carga");
      }).catch(function (error) {
        console.log(error);
        _this5.$modal.hide("carga");
      });
    },
    verServiciosAutorizacion: function verServiciosAutorizacion(autorizacion) {
      var _this6 = this;

      this.$modal.show("carga");
      this.arrayServiciosAutorizacion = [];
      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/verServiciosOrden/" + autorizacion.OrdIde;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url, config).then(function (response) {
        _this6.arrayServiciosAutorizacion = response.data.data;
        _this6.$modal.hide("carga");
      }).catch(function (error) {
        console.log(error);
        _this6.$modal.hide("carga");
      });
    },
    abrirModal: function abrirModal(orden) {
      var _this7 = this;

      this.$modal.show("hello-world");
      this.modalDetalles = 1;
      this.servicioSeleccionado = orden.OrdCod;
      this.nombreSeleccionado = orden.PacApe1 + " " + orden.PacNom1;
      this.fechaSeleccionada = orden.OrdFec;
      this.tipoOrden = orden.TipSer;
      this.fechaVencimientoSeleccionada = orden.OrdVen;
      this.formato = orden.OrdFor;
      this.ordide = orden.OrdIde;
      this.usuarioOrden = orden.UsuAdm;
      this.observaciones = orden.observaciones;
      this.nombre_cliente = orden.nombre_cliente;

      console.log(orden);
      setTimeout(function () {
        if (orden.OrdFor == 0) {
          _this7.verServiciosOrden(orden.OrdIde);
          _this7.verAutorizaciones(orden.OrdCod);
        } else {
          _this7.verServiciosAutorizacionUnica(orden.OrdIde);
        }
      }, 1000);
    },
    cancelarOrden: function cancelarOrden() {
      var _this8 = this;

      this.$modal.show("carga");
      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var BASE_URL = this.ip + "api/cancelarOrden/" + this.ordide;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(BASE_URL).then(function (res) {
        _this8.$modal.hide("carga");
        if (res.data.status == true) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this8.$notify({
            component: {
              template: "<span>!<br> Autorizaci\xF3n desactivada con \xE9xito!<br>.</span>"
            },
            icon: "ti-info",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: _this8.type[color]
          });
          _this8.$modal.hide("hello-world");
          _this8.ordenes();
        } else {
          var color = Math.floor(Math.random() * 4 + 1);
          _this8.$notify({
            component: {
              template: "<span>!<br>Ocurri\xF3 un error, intentelo de nuevo!<br>.</span>"
            },
            icon: "ti-info",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: _this8.type[color]
          });
        }
      }).catch(function (error) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this8.$notify({
          component: {
            template: "<span>!<br>Ocurri\xF3 un error en el servidor, intentelo de nuevo!<br>.</span>"
          },
          icon: "ti-info",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: _this8.type[color]
        });
        _this8.$modal.hide("carga");
        console.log(error);
      });
    },
    cerrarModal: function cerrarModal() {
      this.$modal.hide("hello-world");
      this.modalDetalles = 0;
      this.servicioSeleccionado = "";
      this.nombreSeleccionado = "";
      this.fechaSeleccionada = "";
      this.fechaVencimientoSeleccionada = "";
      this.formato = "";
      this.arrayServiciosOrden = [];
      this.arrayAutorizaciones = [];
      this.arrayServiciosAutorizacion = [];
      this.arrayServiciosOrden = [];
    },
    calcular: function calcular() {
      var fechaini = new Date("2020-02-21");
      var fechafin = new Date("2020-02-22");
      var diasdif = fechafin.getTime() - fechaini.getTime();
      var contdias = Math.round(diasdif / (1000 * 60 * 60 * 24));
      alert(contdias);
    },
    calcularFechaActual: function calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }

        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    this.calcularFechaActual();
    setTimeout(function () {
      _this9.ordenes();
    }, 2000);
  }
});

/***/ }),

/***/ "mwgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_aDashboard_nomina_cardnomina_vue__ = __webpack_require__("DBcq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__global_services_crearAlerta__ = __webpack_require__("o0VJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_global_services_axiosInstance__ = __webpack_require__("t/yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global_services_formatear_pesos__ = __webpack_require__("1byD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__global_services_fecha_actual__ = __webpack_require__("Kscm");










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    nomicard: __WEBPACK_IMPORTED_MODULE_3_src_components_aDashboard_nomina_cardnomina_vue__["a" /* default */]
  },
  data: function data() {
    return {
      realizadas: 0,
      canceladas: 0,
      copago: 0,
      terapeuta: 0,
      cardFooterText: 'Información actual',
      nombreUsuario: localStorage.getItem('nombre'),
      fecha_hoy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__global_services_fecha_actual__["a" /* default */])()
    };
  },

  methods: {
    getInformationFechas: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fechaInicial, fechaFinal) {
        var BASE_URL, response, information;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                BASE_URL = "api/informationNominaToday/" + fechaInicial + "/" + fechaFinal;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_5_src_global_services_axiosInstance__["a" /* default */].get(BASE_URL);

              case 4:
                response = _context.sent;
                information = response.data.data[0];

                this.realizadas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__global_services_formatear_pesos__["a" /* default */])(information.Realizadas);
                this.canceladas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__global_services_formatear_pesos__["a" /* default */])(information.Canceladas);
                this.copago = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__global_services_formatear_pesos__["a" /* default */])(information.Copago);
                this.terapeuta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__global_services_formatear_pesos__["a" /* default */])(information.Terapeuta);
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 15:
                _context.prev = 15;
                return _context.finish(15);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 12, 15, 17]]);
      }));

      function getInformationFechas(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return getInformationFechas;
    }(),
    calcularFechaActual: function calcularFechaActual() {
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = ("0" + (fecha_hoy.getMonth() + 1)).slice(-2);
      var ahora_dia = ("0" + fecha_hoy.getDate()).slice(-2);

      return ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "nRoc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_evoluciones_citas_vue__ = __webpack_require__("Ty35");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c3f468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_evoluciones_citas_vue__ = __webpack_require__("BUxp");
function injectStyle (ssrContext) {
  __webpack_require__("W/DJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15c3f468"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_evoluciones_citas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c3f468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_evoluciones_citas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o0VJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var crearAlerta = function crearAlerta(color, mensaje) {
  return {
    component: {
      template: '\n            <div>\n                <p>Notificaci\xF3n</p>  \n                <strong>' + mensaje + '</strong>\n            </div>\n            '
    },
    icon: '',
    horizontalAlign: 'right',
    verticalAlign: 'top',
    type: color
  };
};

/* harmony default export */ __webpack_exports__["a"] = (crearAlerta);

/***/ }),

/***/ "o0bn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oDAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v("\n        Paciente\n        "),_c('i',{staticClass:"fa fa-users"})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.criterio),expression:"criterio"}],staticClass:"form-control select-sm",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.criterio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"PacApe1"}},[_vm._v("Apellidos del paciente")]),_vm._v(" "),_c('option',{attrs:{"value":"PacNom1"}},[_vm._v("Nombres del paciente")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.busqueda)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarPacientes()},"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-link btn-icon btn-simple",on:{"click":function($event){return _vm.buscarPacientes()}}},[_c('i',{staticClass:"fa fa-search"})])])])]),_vm._v(" "),_c('center',[(_vm.buscar == false)?_c('div',{staticClass:"row"},[_c('div',[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive",staticStyle:{"width":"97%"},attrs:{"data":_vm.arrayPacientes,"border":"","size":"mini"}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacApe1","label":"Apellidos"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNom1","label":"Nombres"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNumDoc","label":"Numero de documento"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"TipCliNom","label":"Tipo de cliente"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[(props.row.estado==1)?_c('a',{staticClass:"btn btn-simple btn-success btn-xs btn-icon like",on:{"click":function($event){return _vm.seleccionarPaciente(props.row)}}},[_c('i',{staticClass:"fa fa-check"})]):_c('small',{staticClass:"text-danger"},[_vm._v("INACTIVO")])])]}}],null,false,3267663566)})],1)],1)]):_vm._e()]),_vm._v(" "),_c('center',[(_vm.nombre != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],staticClass:"form-control input-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}}),_vm._v(" "),(_vm.alertTipoCliente)?_c('small',{staticClass:"text-danger"},[_vm._v("El tipo de cliente no concueda con el modulo seleccionado")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Documento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documento),expression:"documento"}],staticClass:"form-control input-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.documento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.documento=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 text-success"},[_c('label',{attrs:{"for":""}},[_vm._v("Cod. único")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"19px"}},[_vm._v(_vm._s(_vm.pacIde))])])]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[_c('div',{staticClass:"row"},[_c('p',[_vm._v("Información del servicio "),_c('i',{staticClass:"fa fa-file"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Numero del servicio:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroAutorizacion),expression:"numeroAutorizacion"}],staticClass:"form-control input-sm",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.numeroAutorizacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha inicio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicion),expression:"fechaExpedicion"}],staticClass:"form-control input-sm",attrs:{"type":"date"},domProps:{"value":(_vm.fechaExpedicion)},on:{"change":function($event){return _vm.generarCodigo()},"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Cobertura:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cobertura),expression:"cobertura"}],staticClass:"select-sm form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cobertura=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"45"}},[_vm._v("45 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("1 Mes")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("2 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("3 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"120"}},[_vm._v("4 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"150"}},[_vm._v("5 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"180"}},[_vm._v("6 Meses")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Numero° orden "),_c('small',[_vm._v("(opcional)")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroOrden),expression:"numeroOrden"}],staticClass:"form-control input-sm",attrs:{"type":"text"},domProps:{"value":(_vm.numeroOrden)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroOrden=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',[_vm._v("Información de cliente "),_c('i',{staticClass:"fa fa-user"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Cliente/convenio")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombreCliente),expression:"nombreCliente"}],staticClass:"form-control select-sm",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.nombreCliente=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("\n                    convenio 1\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Observaciones: "),_c('small',[_vm._v("(opcional)")])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.observaciones),expression:"observaciones"}],staticClass:"input-sm form-control",attrs:{"type":"text"},domProps:{"value":(_vm.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.observaciones=$event.target.value}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.agregarServicios.apply(null, arguments)}}},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Servicio")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.especialidad),expression:"especialidad"}],staticClass:"form-control select-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.especialidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayEspecialidad),function(especialidad){return _c('option',{key:especialidad.EspCod,domProps:{"value":especialidad.EspCod}},[_vm._v("\n              "+_vm._s(especialidad.EspNom)+"\n          ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Cantidad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cantidad),expression:"cantidad"}],staticClass:"form-control input-sm",attrs:{"type":"text","required":""},domProps:{"value":(_vm.cantidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cantidad=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("---")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-success",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"})])])])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.arrayCantidad!='')?_c('div',{staticClass:"row"},[_c('el-table',{staticClass:"table-responsive table-bordered",staticStyle:{"width":"50%"},attrs:{"data":_vm.arrayCantidad,"border":""}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"servicio","label":"Cups"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cantidad","label":"Cantidad"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove",on:{"click":function($event){return _vm.eliminarServicio(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}],null,false,31756203)})],1),_vm._v(" "),_c('br')],1):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-success btn-sm",on:{"click":function($event){return _vm.nuevaParticular()}}},[_vm._v("Registrar servicio para convenio")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.cerrar()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" Cancelar")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oQg9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ozV4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.obtenerAsistenciaPorUsuario(_vm.fechaInicial, _vm.fechaFinal)}}},[_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","required":""},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","required":"","min":_vm.fechaInicial},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"row"},[_c('center',[(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e()])],1),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{ref:"component",staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill mb-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"Asistencia por pacientes","name":"Asistencia por pacientes"}},[_vm._v("\n            Exportar a excel "),_c('i',{staticClass:"fa fa-download",attrs:{"color":"black"}})]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive table-striped mt-2",attrs:{"border":"","data":_vm.queriedData}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,staticStyle:{"height":"35px !important"},attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"full-width",class:_vm.getClass(column, row)},[(_vm.getClass(column, row) != '')?_c('strong',[_vm._v(_vm._s(row[column.prop]))]):_c('span',[_vm._v(_vm._s(row[column.prop]))])])]}}],null,true)})}),1)],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Asistencia por usuario")]),_vm._v(" "),_c('p',[_vm._v("\n            Seleccione las fechas y el sistema le mostrará las\n            "),_c('span',{staticClass:"text-success"},[_vm._v("Sesiones programadas, canceladas y realizadas")]),_vm._v("\n            en el rango de fecha que seleccione\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3"},[_c('input',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit","value":"Buscar"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pH++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderCard_vue__ = __webpack_require__("8j60");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e9bae14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderCard_vue__ = __webpack_require__("KlTD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e9bae14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pLOp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pU/z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jspdf__ = __webpack_require__("3h9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf_autotable__ = __webpack_require__("+2xD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf_autotable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jspdf_autotable__);










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pacienteSelect: [],
      paciente: "",
      informacionPaciente: "",
      ip: "https://avanti-erp.com/",
      fechainicio: "",
      fechafin: "",
      pdf: false,
      terapias: [],
      resumen: "",
      realizadas: 0,
      canceladas: 0,
      mes: "Enero",
      especialidadEvo: "Todas",
      especialidad: "Psicología",
      concepto: "",
      recomendacion: "",
      logo: "",
      informe: 1,
      cabecera_rosa: "",
      objetivos: [],
      cabecera_oyl: "",
      dx: "",
      fechaActual: "",
      indice: 0,
      usuarioExporta: [],
      configInput: {
        MAX_CHARTERS: 20000
      }
    };
  },
  methods: {
    reset: function reset() {
      this.pdf = false;
      this.informacionPaciente = [];
    },
    getInformacion: function getInformacion() {
      var _this = this;

      var BASE_URL = this.ip + "api/pacientesSelect";
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(BASE_URL).then(function (res) {
        _this.pacienteSelect = res.data.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    abrirModalGenerarInformeOyL: function abrirModalGenerarInformeOyL() {
      this.resumen = "";
      this.$modal.show("informeOyL");
    },
    abrirModalGenerarPDF: function abrirModalGenerarPDF() {
      this.resumen = "";
      this.$modal.show("informe");
    },
    abrirModalGenerarInforme: function abrirModalGenerarInforme() {
      this.resumen = "";
      this.$modal.show("informeporpaciente");
    },
    cerrarModal: function cerrarModal() {
      this.$modal.hide("informe");
      this.$modal.hide("informeporpaciente");
      this.$modal.hide("informeOyL");
      this.recomendacion = "";
      this.concepto = "";
    },
    usuarioExportacion: function usuarioExportacion() {
      var _this2 = this;

      var BASE_URL = this.ip + "api/usuarioExporta/E.Florez";
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(BASE_URL).then(function (res) {
        _this2.usuarioExporta = res.data.data[0];
      }).catch(function (err) {
        console.log(err);
      });
    },
    getInforme: function getInforme() {
      var _this3 = this;

      this.$modal.show("carga");
      var BASE_URL = "";
      if (this.informe != 2) {
        BASE_URL = this.ip + "api/informeEvolucion/" + this.paciente + "/" + this.fechainicio + "/" + this.fechafin;
      } else {
        BASE_URL = this.ip + "api/informeEvolucion/" + this.paciente + "/2021-01-01/2021-01-01";
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(BASE_URL).then(function (res) {
        _this3.indiceAtencion(_this3.paciente);
        _this3.informacionPaciente = res.data.paciente;
        _this3.logo = res.data.CabeceraDef;
        _this3.cabecera_rosa = res.data.CabeceraDef;
        _this3.cabecera_oyl = res.data.CabeceraDef;


        if (res.data.dx.length > 0) {
          _this3.dx = res.data.dx;
        }

        if (_this3.informe == 1) {
          _this3.terapias = res.data.evoluciones;

          var realizadas = 0;
          var canceladas = 0;
          for (var index = 0; index < res.data.evoluciones.length; index++) {
            if (res.data.evoluciones[index].ProEst == 1) {
              realizadas = realizadas + 1;
            } else {
              canceladas = canceladas + 1;
            }
          }
          _this3.realizadas = realizadas;
          _this3.canceladas = canceladas;
        } else if (_this3.informe == 3) {
          _this3.objetivos = res.data.objetivos;
        } else {
          _this3.terapias = [];
          _this3.canceladas = 0;
          _this3.realizadas = 0;
        }
        _this3.pdf = true;
        _this3.$modal.hide("carga");
      }).catch(function (err) {
        console.log(err);
        _this3.$modal.hide("carga");
      });
    },

    indiceAtencion: function indiceAtencion(paciente) {
      var _this4 = this;

      var fechafin = this.fechamenosdias();
      var BASE_URL = this.ip + "api/indiceAtencion/" + paciente + "/" + this.fechaActual + "/" + fechafin;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(BASE_URL).then(function (res) {
        _this4.indice = res.data.indice;
      }).catch(function (err) {
        console.log(err);
      });
    },
    generateInformePaciente: function generateInformePaciente() {
      var _this5 = this;

      var CreateTitle = function CreateTitle(doc) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(17);
        doc.setTextColor(50);
        doc.text(10, 60, "INFORME DE PACIENTE");
      };

      var buscar = "";
      if (this.especialidad == "Psicología") {
        buscar = this.informacionPaciente[0].t_psico;
      } else if (this.especialidad == "Terapia Ocupacional") {
        buscar = this.informacionPaciente[0].t_teo;
      } else if (this.especialidad == "Fonoaudiología") {
        buscar = this.informacionPaciente[0].t_fono;
      } else if (this.especialidad == "Fisioterapia") {
        buscar = this.informacionPaciente[0].t_fisio;
      } else {
        buscar = this.informacionPaciente[0].t_edu;
      }

      if (buscar != null) {
        var BASE_URL = this.ip + "api/informacionTerapeuta/E.Florez";
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(BASE_URL).then(function (res) {
          var doc = new __WEBPACK_IMPORTED_MODULE_4_jspdf__["jsPDF"]();
          var fecha = new Date();
          var ano = fecha.getFullYear();

          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          doc.setTextColor(100);
          doc.text(10, 65, "MES: " + _this5.mes + " del " + ano);

          if (_this5.informacionPaciente[0].url_foto != null) {
            var tipo1 = _this5.informacionPaciente[0].url_foto.charAt(0);
            var formato1 = "";
            if (tipo1 == "/") {
              formato1 = " jpg";
            } else {
              formato1 = "png";
            }
            doc.addImage(_this5.informacionPaciente[0].url_foto, formato1, 145, 40, 50, 60);
          }

          doc.setFontSize(14);
          doc.setTextColor(50);
          doc.text(10, 75, "" + (_this5.informacionPaciente[0].PacNom1 + " " + _this5.informacionPaciente[0].PacApe1));

          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 85, "Tipo de identificaci\xF3n:");

          doc.setFont("helvetica", "normal");
          doc.setFontSize(11);
          doc.setTextColor(100);
          doc.text(60, 85, "" + _this5.informacionPaciente[0].tipoDocumento);

          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 90, "N\xFAmero de identidad:");

          doc.setFont("helvetica", "normal");
          doc.setFontSize(11);
          doc.setTextColor(100);
          doc.text(60, 90, "" + _this5.informacionPaciente[0].PacNumDoc);

          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 95, "Edad:");

          doc.setFontSize(11);
          doc.setTextColor(100);
          doc.text(24, 95, "" + _this5.calcularEdad(_this5.informacionPaciente[0].PacFecNac));

          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.setTextColor(100);
          doc.text(10, 270, "" + (res.data.data[0].nombres.toUpperCase() + " " + res.data.data[0].apellidos.toUpperCase()));

          if (res.data.data[0].CamFir1 != null) {
            doc.setFont("helvetica", "normal");
            doc.setFontSize(12);
            doc.setTextColor(50);
            doc.text(10, 275, res.data.data[0].CamFir1.toUpperCase());
          }
          if (res.data.data[0].CamFir2 != null) {
            doc.setFont("helvetica", "normal");
            doc.setFontSize(12);
            doc.setTextColor(50);
            doc.text(10, 280, res.data.data[0].CamFir2.toUpperCase());
          }
          if (res.data.data[0].CamFir3 != null) {
            doc.setFont("helvetica", "normal");
            doc.setFontSize(12);
            doc.setTextColor(50);
            doc.text(10, 285, res.data.data[0].CamFir3.toUpperCase());
          }

          doc.autoTable({
            margin: { top: 135, left: 10, right: 10 },
            theme: "striped",
            head: [[" Especialidad ", "Concepto", "Terapeuta"]],
            headStyles: {
              overflow: "linebreak",
              fontSize: 12,
              fontStyle: "normal",
              halign: "center",
              valign: "middle",
              fillColor: [48, 36, 84]
            },
            columnStyles: {
              0: { columnWidth: 30, halign: "center" },
              1: { columnWidth: 125 },
              2: { columnWidth: 30, halign: "center" }
            },
            body: [[_this5.especialidad, _this5.concepto, "" + (res.data.data[0].nombres + " " + res.data.data[0].apellidos)]],
            didDrawPage: function didDrawPage(data) {
              var yFinal = data.cursor.y + 10;
              doc.setFont("helvetica", "bold");
              doc.setFontSize(12);
              doc.setTextColor(50);
              doc.text(10, yFinal, "RECOMENDACIÓN:");

              var splitdx = doc.splitTextToSize(_this5.recomendacion, 245);
              doc.setFont("helvetica", "normal");
              doc.setFontSize(10);
              doc.setTextColor(100);
              doc.text(10, yFinal + 6, splitdx);
            }
          });
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 115, "DX:");

          if (_this5.dx != null) {
            var dx = _this5.dx;
            var ddx = doc.splitTextToSize(dx, 200);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(11);
            doc.setTextColor(100);
            doc.text(10, 120, ddx);
          }
          CreateTitle(doc);
          addFooters(doc);
          doc.save("informePaciente-" + (_this5.informacionPaciente[0].PacNom1 + "-" + _this5.informacionPaciente[0].PacApe1) + "-" + _this5.mes + ".pdf");
          _this5.crearLogInforme(_this5.paciente, "N/A", _this5.recomendacion, _this5.concepto, "Informe por paciente");
          _this5.cerrarModal();
        }).catch(function (err) {
          console.error(err);
        });
      } else {
        alert("No se encontró un lider para esta especialidad");
      }

      var addFooters = function addFooters(doc) {
        var pageCount = doc.internal.getNumberOfPages();

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.addImage(_this5.cabecera_rosa, "png", 0, 0, 210, 40);

          doc.setFontSize(8);
          doc.setTextColor(100);
          doc.text("Pag " + String(i) + " de " + String(pageCount), doc.internal.pageSize.width / 2, 288, {
            align: "center"
          });
          doc.setFontSize(8);
          doc.setTextColor(100);
          doc.text("DOCUMENTO CON FIRMA DIGITAL EXPORTADO DESDE AVANTI-ERP", doc.internal.pageSize.width / 2, 293, {
            align: "center"
          });
        }
      };
    },
    generarInformePaciente: function generarInformePaciente() {
      var _this6 = this;

      try {
        var renderJustifiedLine = function renderJustifiedLine(line, x, y, maxWidth) {
          var newLine = line.replace(/\s+/g, " ");
          var words = newLine.split(" ");
          var wordCount = words.length;

          if (wordCount <= 300) {
            doc.text(line, x, y, { maxWidth: 180 });
            return;
          }

          var totalWordsWidth = words.reduce(function (total, word) {
            return total + doc.getTextWidth(word);
          }, 0);
          var spaceWidth = (maxWidth - totalWordsWidth) / (wordCount - 1);
          var currentX = x;

          words.forEach(function (word, index) {
            doc.text(word, currentX, y);
            if (index < wordCount - 1) {
              currentX += doc.getTextWidth(word) + spaceWidth;
            }
          });
        };

        var doc = new __WEBPACK_IMPORTED_MODULE_4_jspdf__["jsPDF"]();
        var paciente = this.informacionPaciente[0];
        var headerHeight = 35;
        var footerHeight = 35;
        var pageHeight = doc.internal.pageSize.height;
        var pageWidth = doc.internal.pageSize.getWidth();
        var anchoTexto = 260;
        var lineHeight = 4;

        var startX = 15;
        var startY = headerHeight + 20;
        var logo = this.logo;

        var addHeader = function addHeader(doc) {
          doc.addImage(logo, "png", 0, 0, 210, 40);
        };

        var addFooter = function addFooter(doc) {
          var fechaTexto = new Date().toLocaleDateString();
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          doc.text("Avanti", pageWidth / 2, pageHeight - footerHeight + 7, {
            align: "center"
          });
          doc.text("Fecha impresi\xF3n: " + fechaTexto, pageWidth / 2, pageHeight - footerHeight + 10, { align: "center" });
        };

        var checkPageSpace = function checkPageSpace(yPos) {
          var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

          if (yPos + lineHeight + extra >= pageHeight - footerHeight) {
            doc.addPage();
            addFooter(doc);
            startY = 15;
          }
        };

        var renderJustifiedText = function renderJustifiedText(text) {
          var lines = doc.splitTextToSize(text, anchoTexto);
          lines.forEach(function (line) {
            checkPageSpace(startY);
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(100);
            renderJustifiedLine(line, startX, startY, anchoTexto);
            startY += lineHeight;
          });
        };

        var addSignature = function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(doc) {
            var firmas, imageWidth, imageHeight, margin, yPosition, todasFirmas;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    firmas = [];

                    firmas.push(_this6.usuarioExporta);
                    imageWidth = 60;
                    imageHeight = 15;
                    margin = 5;
                    yPosition = startY;
                    todasFirmas = [].concat(firmas);


                    todasFirmas.forEach(function (imageData) {
                      console.log(footerHeight, "footer");
                      if (imageData.CamFir1 == null || imageData.CamFir1 == "") {
                        return "ERROR";
                      }

                      var xPosition = pageWidth / 2;
                      if (yPosition + imageHeight + margin + footerHeight > pageHeight) {
                        doc.addPage();
                        yPosition = 15;
                        addFooter(doc);
                      }


                      var nombreTerapeuta = imageData.nombres + " " + imageData.apellidos;
                      doc.setFontSize(12);
                      doc.setFont("helvetica", "bold");
                      doc.setTextColor("#000000");
                      doc.text(nombreTerapeuta.toUpperCase(), xPosition, yPosition + imageHeight + 5, {
                        align: "center"
                      });
                      yPosition += 5 + 0;
                      doc.setFontSize(10);
                      doc.setFont("helvetica", "normal");
                      doc.setTextColor(100);
                      doc.text(imageData.CamFir1, xPosition, yPosition + imageHeight + 5, {
                        align: "center"
                      });
                      if (imageData.CamFir2 != null) {
                        yPosition += 6 + 0;
                        doc.setFontSize(10);
                        doc.setFont("helvetica", "normal");
                        doc.setTextColor(100);
                        doc.text(imageData.CamFir2, xPosition, yPosition + imageHeight + 5, {
                          align: "center"
                        });
                      }
                      if (imageData.CamFir3 != null) {
                        yPosition += 6 + 0;
                        doc.setFontSize(8);
                        doc.setFont("helvetica", "normal");
                        doc.setTextColor(100);
                        doc.text(imageData.CamFir3, xPosition, yPosition + imageHeight + 5, {
                          align: "center"
                        });
                      }
                      yPosition += imageHeight + margin;
                    });

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this6);
          }));

          return function addSignature(_x2) {
            return _ref.apply(this, arguments);
          };
        }();

        addHeader(doc);
        addFooter(doc);

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor("#000000");
        doc.text("INFORME POR PACIENTE", pageWidth / 2, startY, {
          align: "center"
        });
        startY += 5;

        var tableData = [[{
          content: "NOMBRE DEL PACIENTE",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: paciente.PacNom1 + " " + paciente.PacApe1,
          styles: { fontSize: 10 },
          colSpan: 3
        }], [{
          content: "FECHA DE NACIMIENTO",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: paciente.PacFecNac,
          styles: { fontSize: 10 }
        }, {
          content: "EDAD:",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: this.calcularEdad(paciente.PacFecNac),
          styles: { fontSize: 10 }
        }], [{
          content: "NUMERO DE DOCUMENTO",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: parseFloat(paciente.PacNumDoc).toLocaleString("es-ES"),
          styles: { fontSize: 10 },
          colSpan: 3
        }], [{
          content: "DIAGNÓSTICO (S) MÉDICO (S):",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: paciente.PacDia != null ? paciente.PacDia : "Sin diagnóstico",
          styles: { fontSize: 10 },
          colSpan: 3
        }], [{
          content: "ESPECIALIDAD",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: this.especialidad.toUpperCase(),
          styles: { fontSize: 10 },
          colSpan: 3
        }], [{
          content: "MES DEL INFORME",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: this.mes.toUpperCase(),
          styles: { fontSize: 10 },
          colSpan: 3
        }]];
        doc.autoTable({
          startY: startY,
          theme: "grid",
          body: tableData,
          margin: { top: headerHeight + 15, bottom: footerHeight + 20 },
          styles: {
            fontSize: 10,
            cellPadding: { top: 2, bottom: 2, left: 2, right: 2 }
          },
          pageBreak: "auto"
        });

        startY = doc.lastAutoTable.finalY + 10;

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor("#000000");
        doc.text("CONCEPTO", pageWidth / 2, startY, {
          align: "center"
        });

        startY += 8;
        renderJustifiedText(this.concepto);

        checkPageSpace(startY);
        startY += 8;

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor("#000000");
        doc.text("RECOMENDACIONES", pageWidth / 2, startY, {
          align: "center"
        });

        startY += 8;
        renderJustifiedText(this.recomendacion);
        startY += 8;
        checkPageSpace(startY);
        addSignature(doc);

        var pageCount = doc.internal.getNumberOfPages();
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          var pageLabel = "Pag " + i + " de " + pageCount;
          var textWidth = doc.getTextWidth(pageLabel);
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          doc.text(pageLabel, (pageWidth - textWidth) / 2, pageHeight - footerHeight + 13);
        }

        doc.save("informe-paciente-" + paciente.PacNom1 + "-" + paciente.PacApe1 + ".pdf");
        this.cerrarModal();
      } catch (error) {
        console.log(error);
      }
    },
    generatePDFOyL: function generatePDFOyL() {
      var _this7 = this;

      var addFooters = function addFooters(doc) {
        var pageCount = doc.internal.getNumberOfPages();

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.addImage(_this7.cabecera_oyl, "png", 0, 0, 300, 40);

          doc.setFontSize(8);
          doc.setTextColor(50);
          doc.text("Pag " + String(i) + " de " + String(pageCount), doc.internal.pageSize.width / 2, 202, {
            align: "center"
          });
          doc.setFontSize(8);
          doc.setTextColor(50);
          doc.text("DOCUMENTO EXPORTADO DESDE AVANTI-ERP", doc.internal.pageSize.width / 2, 207, {
            align: "center"
          });

          doc.setFontSize(14);
          doc.setTextColor(50);
          doc.text(10, 70, "" + (_this7.informacionPaciente[0].PacNom1 + " " + _this7.informacionPaciente[0].PacApe1));

          doc.setFontSize(11);
          doc.setTextColor(50);
          doc.text(10, 75, "" + _this7.calcularEdad(_this7.informacionPaciente[0].PacFecNac));

          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 85, "DE:");

          doc.setFontSize(11);
          doc.setTextColor(100);
          doc.text(19, 85, _this7.fechainicio);

          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 90, "HASTA:");

          doc.setFontSize(11);
          doc.setTextColor(100);
          doc.text(26, 90, _this7.fechafin);

          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 95, "ESPECIALIDADES:");

          doc.setFontSize(11);
          doc.setTextColor(100);
          doc.text(48, 95, "Todas");

          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(225, 70, "ÍNDICE DE ATENCIÓN:");

          doc.setFontSize(12);
          doc.setTextColor(100);
          doc.text(272, 70, _this7.indice.toFixed(0) + "%");

          doc.setFontSize(12);
          doc.setTextColor(50);
          doc.text(10, 100, "RESUMEN:");

          var resumen = _this7.resumen;
          var splitResumen = doc.splitTextToSize(resumen, 300);
          doc.setFontSize(11);
          doc.setTextColor(100);
          doc.text(10, 105, splitResumen);

          var CreateTitle = function CreateTitle(doc, text) {
            doc.setFont(undefined, "bold");
            doc.setFontSize(19);
            doc.setTextColor(50);
            doc.text(237, 60, "INFORME OYL");
          };

          CreateTitle(doc);
        }
      };
      var doc = new __WEBPACK_IMPORTED_MODULE_4_jspdf__["jsPDF"]("landscape");

      doc.autoTable(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        theme: "css",
        html: "#objetivoss",
        headStyles: {
          overflow: "linebreak",
          fontSize: 10,
          fontStyle: "normal",
          halign: "center",
          valign: "middle",
          fillColor: [48, 36, 84]
        },
        margin: { top: 142, left: 10, right: 10 }
      }, "theme", "striped"));

      addFooters(doc);
      doc.save("informeOyL-" + this.informacionPaciente[0].PacNom1 + ".pdf");
      this.crearLogInforme(this.paciente, this.resumen, "N/A", "N/A", "Informe de objetivos y logros");
      this.cerrarModal();
    },

    generarInformeDeEvolucion: function generarInformeDeEvolucion() {
      var _this8 = this;

      try {
        var renderJustifiedLine = function renderJustifiedLine(line, x, y, maxWidth) {
          var newLine = line.replace(/\s+/g, " ");
          var words = newLine.split(" ");
          var wordCount = words.length;

          if (wordCount <= 300) {
            doc.text(line, x, y);
            return;
          }

          var totalWordsWidth = words.reduce(function (total, word) {
            return total + doc.getTextWidth(word);
          }, 0);
          var spaceWidth = (maxWidth - totalWordsWidth) / (wordCount - 1);
          var currentX = x;

          words.forEach(function (word, index) {
            doc.text(word, currentX, y);
            if (index < wordCount - 1) {
              currentX += doc.getTextWidth(word) + spaceWidth;
            }
          });
        };

        var doc = new __WEBPACK_IMPORTED_MODULE_4_jspdf__["jsPDF"]();
        var paciente = this.informacionPaciente[0];
        var headerHeight = 35;
        var footerHeight = 35;
        var pageHeight = doc.internal.pageSize.height;
        var pageWidth = doc.internal.pageSize.getWidth();
        var anchoTexto = 260;
        var lineHeight = 4;

        var startX = 15;
        var startY = headerHeight + 20;
        var logo = this.logo;

        var addHeader = function addHeader(doc) {
          doc.addImage(logo, "png", 0, 0, 210, 40);
        };

        var addFooter = function addFooter(doc) {
          var fechaTexto = new Date().toLocaleDateString();
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          doc.text("Avanti", pageWidth / 2, pageHeight - footerHeight + 7, {
            align: "center"
          });
          doc.text("Fecha impresi\xF3n: " + fechaTexto, pageWidth / 2, pageHeight - footerHeight + 10, { align: "center" });
        };

        var checkPageSpace = function checkPageSpace(yPos) {
          var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

          if (yPos + lineHeight + extra >= pageHeight - footerHeight) {
            doc.addPage();
            addFooter(doc);
            startY = 15;
          }
        };

        var renderJustifiedText = function renderJustifiedText(text) {
          var lines = doc.splitTextToSize(text, anchoTexto);
          lines.forEach(function (line) {
            checkPageSpace(startY);
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(100);
            renderJustifiedLine(line, startX, startY, anchoTexto);
            startY += lineHeight;
          });
        };

        var addSignature = function () {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(doc) {
            var firmas, imageWidth, imageHeight, margin, yPosition, todasFirmas;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    firmas = [];

                    firmas.push(_this8.usuarioExporta);
                    imageWidth = 60;
                    imageHeight = 15;
                    margin = 5;
                    yPosition = startY;
                    todasFirmas = [].concat(firmas);


                    todasFirmas.forEach(function (imageData) {
                      console.log(footerHeight, "footer");
                      if (imageData.CamFir1 == null || imageData.CamFir1 == "") {
                        return "ERROR";
                      }

                      var xPosition = pageWidth / 2;
                      if (yPosition + imageHeight + margin + footerHeight > pageHeight) {
                        doc.addPage();
                        yPosition = 15;
                        addFooter(doc);
                      }


                      var nombreTerapeuta = imageData.nombres + " " + imageData.apellidos;
                      doc.setFontSize(12);
                      doc.setFont("helvetica", "bold");
                      doc.setTextColor("#000000");
                      doc.text(nombreTerapeuta.toUpperCase(), xPosition, yPosition + imageHeight + 5, {
                        align: "center"
                      });
                      yPosition += 5 + 0;
                      doc.setFontSize(10);
                      doc.setFont("helvetica", "normal");
                      doc.setTextColor(100);
                      doc.text(imageData.CamFir1, xPosition, yPosition + imageHeight + 5, {
                        align: "center"
                      });
                      if (imageData.CamFir2 != null) {
                        yPosition += 6 + 0;
                        doc.setFontSize(10);
                        doc.setFont("helvetica", "normal");
                        doc.setTextColor(100);
                        doc.text(imageData.CamFir2, xPosition, yPosition + imageHeight + 5, {
                          align: "center"
                        });
                      }
                      if (imageData.CamFir3 != null) {
                        yPosition += 6 + 0;
                        doc.setFontSize(8);
                        doc.setFont("helvetica", "normal");
                        doc.setTextColor(100);
                        doc.text(imageData.CamFir3, xPosition, yPosition + imageHeight + 5, {
                          align: "center"
                        });
                      }
                      yPosition += imageHeight + margin;
                    });

                  case 8:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, _this8);
          }));

          return function addSignature(_x4) {
            return _ref2.apply(this, arguments);
          };
        }();

        addHeader(doc);
        addFooter(doc);

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor("#000000");
        doc.text("INFORME DE EVOLUCIÓN", pageWidth / 2, startY, {
          align: "center"
        });
        startY += 5;

        var tableData = [[{
          content: "NOMBRE DEL PACIENTE",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: paciente.PacNom1 + " " + paciente.PacApe1,
          styles: { fontSize: 10 },
          colSpan: 3
        }], [{
          content: "FECHA DE NACIMIENTO",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: paciente.PacFecNac,
          styles: { fontSize: 10 }
        }, {
          content: "EDAD:",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: this.calcularEdad(paciente.PacFecNac),
          styles: { fontSize: 10 }
        }], [{
          content: "NUMERO DE DOCUMENTO",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: parseFloat(paciente.PacNumDoc).toLocaleString("es-ES"),
          styles: { fontSize: 10 },
          colSpan: 3
        }], [{
          content: "DIAGNÓSTICO (S) MÉDICO (S):",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: paciente.PacDia != null ? paciente.PacDia : "Sin diagnóstico",
          styles: { fontSize: 10 },
          colSpan: 3
        }], [{
          content: "ESPECIALIDAD",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: this.especialidadEvo,
          styles: { fontSize: 10 },
          colSpan: 3
        }], [{
          content: "FECHAS",
          styles: { fontSize: 10, fontStyle: "bold", textColor: "#000000" }
        }, {
          content: this.fechainicio + " - " + this.fechafin,
          styles: { fontSize: 10 },
          colSpan: 3
        }]];
        doc.autoTable({
          startY: startY,
          theme: "grid",
          body: tableData,
          margin: { top: headerHeight + 15, bottom: footerHeight + 20 },
          styles: {
            fontSize: 10,
            cellPadding: { top: 2, bottom: 2, left: 2, right: 2 }
          },
          pageBreak: "auto"
        });

        startY = doc.lastAutoTable.finalY + 10;

        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor("#000000");
        doc.text("RESUMEN", pageWidth / 2, startY, {
          align: "center"
        });

        startY += 8;
        renderJustifiedText(this.resumen);

        startY += 10;

        checkPageSpace(startY);
        addSignature(doc);

        startY += 10;
        doc.autoTable({
          startY: startY,
          theme: "grid",
          html: "#mi-table",
          headStyles: {
            fillColor: [48, 36, 84]
          },
          margin: { top: headerHeight + 25, bottom: footerHeight + 20 },
          styles: {
            fontSize: 10,
            cellPadding: { top: 2, bottom: 2, left: 2, right: 2 }
          },
          pageBreak: "auto"
        });

        var pageCount = doc.internal.getNumberOfPages();
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          var pageLabel = "Pag " + i + " de " + pageCount;
          var textWidth = doc.getTextWidth(pageLabel);
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          doc.text(pageLabel, (pageWidth - textWidth) / 2, pageHeight - footerHeight + 13);
        }

        doc.save("informe-de-evolucion-" + paciente.PacNom1 + "-" + paciente.PacApe1 + ".pdf");
        this.crearLogInforme(this.paciente, this.resumen, "N/A", "N/A", "Informe de evolución");
        this.cerrarModal();
      } catch (error) {
        console.log(error);
      }
    },
    calcularEdad: function calcularEdad(fecha) {
      var fechaNacimiento = fecha;
      var values = fechaNacimiento.split("-");
      var dia = values[2];
      var mes = values[1];
      var ano = values[0];

      var fecha_hoy = new Date();
      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;


      var edad = ahora_ano + 0 - ano;
      if (ahora_mes < mes) {
        edad--;
      }
      if (mes == ahora_mes && ahora_dia < dia) {
        edad--;
      }
      if (edad > 1900) {
        edad -= 1900;
      }

      var meses = 0;
      if (ahora_mes > mes) meses = ahora_mes - mes;
      if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
      if (ahora_mes == mes && dia > ahora_dia) meses = 11;

      var dias = 0;
      if (ahora_dia > dia) dias = ahora_dia - dia;
      if (ahora_dia < dia) {
        var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
        var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
      }

      return edad + " a\xF1o(s) y " + meses + " mes(es)";
    },

    fechamenosdias: function fechamenosdias() {
      var fecha = new Date();
      fecha.setDate(fecha.getDate() - 90);


      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
      return fechaFormateada;
    },
    calcularFechaActual: function calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    crearLogInforme: function crearLogInforme(paciente, resumen, recomendacion, concepto, informe_tipo) {
      var BASE_URL = this.ip + "api/log-informe";
      var data = {
        entrega: localStorage.getItem("usuario"),
        paciente: paciente,
        informe_tipo: informe_tipo,
        resumen: resumen,
        recomendacion: recomendacion,
        concepto: concepto
      };
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(BASE_URL, data).then(function (res) {
        console.log("Log creado:", res.data);
      }).catch(function (err) {
        console.error("Error creando log:", err);
      });
    }
  },
  mounted: function mounted() {
    this.getInformacion();
    this.calcularFechaActual();
    this.fechamenosdias();
    this.usuarioExportacion();
  }
});

/***/ }),

/***/ "pgSd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_collapse_item_css__ = __webpack_require__("XPMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_collapse_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_collapse_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_collapse_item__ = __webpack_require__("uEG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_collapse_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_collapse_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_collapse_css__ = __webpack_require__("8mNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_collapse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_collapse_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_collapse__ = __webpack_require__("YnkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_nav_tabs__ = __webpack_require__("lEct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_js_modal__ = __webpack_require__("rifk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_jspdf__ = __webpack_require__("3h9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jspdf_autotable__ = __webpack_require__("+2xD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_jspdf_autotable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_jspdf_autotable__);























__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue_nav_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_collapse___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_collapse_item___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_12_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_table_column___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      viewTab: 0,
      dxeditId: "",
      dxedit: [],
      usuarioAvanza: "",
      motivosConsulta: "",
      optionsArray: [],
      tmconsulta: [],
      informacion: "",
      pacientes: [],
      arrayMotivo: [],
      criterio: "paciente.PacApe1",
      busqueda: "",
      anos: 0,
      meses: 0,
      multiple: "ARS",

      numeroDocumento: "",
      apellidos: "",
      nombres: "",
      fechaIngreso: "",
      Fecha_nacimiento: "",
      sexo: "",
      eps: "",
      poliza: "",
      tipoAfiliacion: '',
      prepagada: "",
      regimen: 1,
      PacIde: "",
      loked: true,
      numeroDocumentoBuscar: "",
      fotoPaciente: "",
      estado: 0,
      rol: localStorage.getItem("rol"),

      motivoDeConsulta: "",
      fechaDeConsulta: "",
      fechaVerificado: "",
      motivoVerificarIde: "",
      motivoVerificarFec: "",
      motivoVerificarDes: "",
      consultaVerificada: "",
      contador_motivos: 0,
      evoluciones: [],

      arrayImpresion: [],

      tipoAntecedente: 1,
      antecedenteActivo: "",
      fechaAntecedente: "",

      descripcionAntecedente: "",
      antecedentesPre: [],
      contador_pre: 0,
      antecedentesNeo: [],
      antecedentesPos: [],
      antecedentesPer: [],
      antecedentesFam: [],
      fotoBASE: "",

      fechaResumen: "",
      descripcionResumen: "",
      arrayResumen: [],
      descripcionImpresion: "",
      impresionDiagnostica: "",
      conclusiones: "",
      arrayAntecedente: [],
      arrayCie10: [],
      arrayDsm4: [],
      cie10: [],
      dsm4: []
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "conclusiones", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "detalleResumenFecha", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "detalleDescripcionResumen", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "detalleConclusionResumen", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "detalleCie10", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "detalleDsm4", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "fechaTratamiento", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "descripcionTratamiento", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayTratamiento", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayEspecialidad", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayEspecialidades", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "especialidad", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "sesiones", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayDetalle", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "fechaFinTratamiento", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "actividadFamiliar", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "trabajoFamiliar", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examen", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "verificacion", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mostrarCie10", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mostrarDsm4", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "opcion", 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen2", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen3", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen4", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen5", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen6", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen7", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen8", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen9", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen10", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayExamen11", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenActivo", 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "arrayActivo", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenEnviar", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "nombreExamen", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "links_examen", ["NULL", "https://drive.google.com/file/d/1QQvTRCVPfbgasJ-agXYymsFzCSOsIEtp/view?usp=sharing", "https://drive.google.com/file/d/1nZTTxOPpTy_RYbcqFcClm6wEKMqsM2yx/view?usp=sharing", "https://drive.google.com/file/d/1AKYS5wSOs8cCh0fVc4cE3Tc32GcAvhrG/view", "https://drive.google.com/file/d/1um4R2ymKd_gdww2WPBsdwzmS1dHoQf5R/view", "https://drive.google.com/file/d/1y9pVcX8QR55yyxtzmjsELkNB-FpQMeXA/view?usp=sharing", "https://drive.google.com/open?id=1uHrljOme7yU-7Ssok1mr1A3ajGsUC_lD", "https://drive.google.com/open?id=1d5K0en09ws3umkRoXZF5UC548tTmhDnB", "https://drive.google.com/file/d/17EaZD7K4bddoVmuTIm9kpqMhsZ4kVKww/view", "https://drive.google.com/open?id=1-WrHRmIMCbXO-dq3MuwuaUHbTRf8knM0", "https://drive.google.com/open?id=1tzemT8CBzdUW5E9I8449NjlGP-2hma03", "https://drive.google.com/file/d/0B54PTJg2YNL-TVFvbnpTc3laZGc/view?resourcekey=0-QCwexOdYyxlTsC5V9hT7Cw"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "link_examen_selecte", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tratamiento", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "cards_tab", [{
      tab: 1,
      title: "MOTIVO DE CONSULTA VERIFICADO"
    }, {
      tab: 2,
      title: "ANTECEDENTES"
    }, {
      tab: 3,
      title: "IMPRESIÓN GENERAL"
    }, {
      tab: 4,
      title: "EXAMEN PACIENTE"
    }, {
      tab: 5,
      title: "CONCLUSIONES, RECOMENDACIÓN Y PLAN DE TTO"
    }, {
      tab: 6,
      title: "PLAN INTERVENCIÓN TERAPÉUTICA"
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "type", ["", "info", "success", "warning", "danger"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "notifications", {
      topCenter: false
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "ip", "https://avanti-erp.com/"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mensaje", "No hay datos de pacientes"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "icono", "bell"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenesRealizados", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenesRealizadosPs", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenesRealizadosfonol", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "indefinido", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "periodoPT", 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "motivoConsultaHoy", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "antecedenteHoy", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "impresionHoy", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "examenHoy", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tratamientoHoy", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "e_motivo", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "e_antecedente", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "e_resumen", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "e_tratamiento", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "cie10mostrar", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "logo", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "terapeutaPDF", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "recomendacionPDF", ""), _ref;
  },

  methods: {
    viewTabFunction: function viewTabFunction(tab) {
      this.viewTab = tab;
      window.scroll(0, 0);
    },
    getError: function getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function validate() {
      return this.$validator.validateAll();
    },
    cerrarHC: function cerrarHC() {
      localStorage.removeItem("PacienteHC");
      localStorage.removeItem("PacienteId");

      location.reload();
    },

    cambiarLinkExamen: function cambiarLinkExamen() {
      this.link_examen_selecte = this.links_examen[this.examen];
    },
    motivos: function motivos() {
      var _this = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/motivos/" + this.PacIde,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this.arrayMotivo = response.data.data;

        _this.contador_motivos = _this.arrayMotivo.length;
        if (response.data.data.length > 0) {
          _this.motivoConsultaHoy = true;
        }

        _this.validarMotivosVerificados(response.data.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    validarMotivosVerificados: function validarMotivosVerificados(motivos) {
      for (var index = 0; index < motivos.length; index++) {
        if (motivos[index].MotEst != 1) {
          this.motivoConsultaHoy = false;
        }
      }
    },
    motivosM: function motivosM() {
      var _this2 = this;

      this.optionsArray = [];
      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/motivos",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this2.optionsArray = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    motivoVerificar: function motivoVerificar(row) {
      var _this3 = this;

      var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      this.verificacion = row.MotEst;
      if (this.verificacion == 0 && option == 1) {
        this.$modal.show("modalVerificarMC");
      }
      if (this.verificacion != 0 && option == 1) {
        this.$modal.show("modalDetallesMC");
      }
      this.tmconsulta = [];
      this.motivoVerificarIde = row.MotIde;
      this.motivoVerificarFec = row.MotFec;
      this.motivoVerificarDes = row.MotDes;
      this.consultaVerificada = row.MotVer;
      var token = localStorage.getItem("token");

      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/completo/" + this.motivoVerificarIde,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        var datos = response.data.data.length;
        for (var i = 0; i < datos;) {
          _this3.tmconsulta.push(response.data.data[i].VerDes);
          i++;
        }

        if (option == 1) {
          _this3.motivos();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    llamarPacientes: function llamarPacientes(row) {
      var _this4 = this;

      var respuesta = "";
      this.numeroDocumentoBuscar = row.PacNumDoc;
      if (this.numeroDocumentoBuscar != "") {
        var buscar = this.numeroDocumentoBuscar;
        var token = localStorage.getItem("token");
        __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
          method: "get",
          baseURL: this.ip + "api/pacienteHC/" + row.PacIdeUsu,
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json"
          }
        }).then(function (response) {
          if (response.data.data == 0) {
            alert("No se encontraron datos");
          } else {
            _this4.PacIde = row.PacIdeUsu;
            _this4.numeroDocumento = response.data.data.datos[0].PacNumDoc;
            localStorage.setItem("PacienteHC", response.data.data.datos[0].PacNumDoc);
            localStorage.setItem("PacienteId", row.PacIdeUsu);
            localStorage.setItem("PacienteNombre", response.data.data.datos[0].PacNom1 + " " + response.data.data.datos[0].PacApe1);
            _this4.nombres = response.data.data.datos[0].PacNom1;
            _this4.apellidos = response.data.data.datos[0].PacApe1;
            _this4.fotoPaciente = response.data.data.datos[0].url_foto;
            if (response.data.data.datos[0].PacSex == 1) {
              _this4.sexo = "Masculino";
            } else {
              _this4.sexo = "Femenino";
            }
            _this4.Fecha_nacimiento = response.data.data.datos[0].PacFecNac;
            _this4.fechaIngreso = response.data.data.datos[0].PacFecIng;
            _this4.eps = response.data.data.eps;
            _this4.tipoAfiliacion = response.data.data.datos[0].TipCliNom;
            _this4.prepagada = response.data.data.prepagada;
            _this4.poliza = response.data.data.poliza;
            if (response.data.data.datos[0].PacReg == 1) {
              _this4.regimen = "Contributivo";
            } else {
              _this4.regimen = "Subsidiado";
            }

            _this4.estado = response.data.data.datos[0].estado;
            _this4.loked = response.data.data.datos[0].PacBlo;

            _this4.fotoBASE = response.data.data.datos[0].url_fotoBS;

            _this4.motivos();
            _this4.resumen();
            _this4.examenes();
            _this4.antecedentes();
            _this4.tratamientos();
            _this4.e_realizados_to();
            _this4.e_realizados_ps();
            _this4.e_realizados_fonol();
            _this4.calcularEdad();
            _this4.getEvoluciones(row.PacIdeUsu);
            _this4.motivoConsultaHoy = false;
            _this4.antecedenteHoy = false;
            _this4.impresionHoy = false;
            _this4.examenHoy = false;
            _this4.tratamientoHoy = false;
            _this4.e_motivo = true;
            _this4.opcion = 2;
            _this4.e_antecedente = true;
            _this4.e_resumen = true;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    buscarPacientes: function buscarPacientes() {
      var _this5 = this;

      this.mensaje = "Cargando...";
      this.icono = "spinner";
      this.pacientes = [];
      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this5.icono = "bell";
        _this5.mensaje = "No hay datos de pacientes";
        _this5.pacientes = response.data.data;
        if (localStorage.getItem("PacienteHC")) {
          _this5.llamarPacientes(response.data.data[0]);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    cie10M: function cie10M() {
      var _this6 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/cie10",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        var datos = response.data.data.length;
        if (response.data.data != "") {
          for (var i = 0; i < datos;) {
            _this6.arrayCie10.push(response.data.data[i]);

            i++;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    dsm4M: function dsm4M() {
      var _this7 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/dsm4",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        var datos = response.data.data.length;
        if (response.data.data != "") {
          for (var i = 0; i < datos;) {
            _this7.arrayDsm4.push(response.data.data[i]);
            i++;
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


    getEvoluciones: function getEvoluciones(paciente) {
      var _this8 = this;

      var BASE_URL = this.ip + "api/evoluciones/" + paciente;
      var config = {
        Authorization: "Bearer " + localStorage.getItem("token")
      };
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/json"
        }
      }).then(function (res) {
        var evoluciones = [];

        for (var i = 0; i < res.data.data.length; i++) {
          evoluciones.push({
            EvoTer: res.data.data[i].nombres + " " + res.data.data[i].apellidos,
            Obs: res.data.data[i].Obs,
            EvoMat: res.data.data[i].EvoMat,
            EvoFec: res.data.data[i].EvoFec,
            EvoEst: res.data.data[i].EvoEst
          });
        }
        _this8.evoluciones = evoluciones;
      }).catch(function (err) {
        console.log(err);
      });
    },

    antecedentes: function antecedentes() {
      var _this9 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/antecedentes/" + this.PacIde,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this9.antecedentesPre = response.data.data.pre;
        if (response.data.data.pre.length > 0) {
          _this9.antecedenteHoy = true;
        }
        _this9.contador_pre = response.data.data.pre.length;
        _this9.antecedentesNeo = response.data.data.neo;
        if (response.data.data.neo.length > 0) {
          _this9.antecedenteHoy = true;
        }
        _this9.antecedentesPos = response.data.data.pos;
        if (response.data.data.pos.length > 0) {
          _this9.antecedenteHoy = true;
        }
        _this9.antecedentesPer = response.data.data.per;
        if (response.data.data.per.length > 0) {
          _this9.antecedenteHoy = true;
        }
        _this9.antecedentesFam = response.data.data.fam;
        if (response.data.data.fam.length > 0) {
          _this9.antecedenteHoy = true;
        }
        _this9.cambiarTipoAntecedente();
      }).catch(function (error) {
        console.log(error);
      });
    },
    cambiarTipoAntecedente: function cambiarTipoAntecedente() {
      if (this.tipoAntecedente == "1") {
        this.antecedenteActivo = "Prenatales";
        this.arrayAntecedente = this.antecedentesPre;
      }
      if (this.tipoAntecedente == 2) {
        this.antecedenteActivo = "Neonatales";
        this.arrayAntecedente = this.antecedentesNeo;
      }
      if (this.tipoAntecedente == 3) {
        this.antecedenteActivo = "Postnatales";
        this.arrayAntecedente = this.antecedentesPos;
      }
      if (this.tipoAntecedente == 4) {
        this.antecedenteActivo = "Personales";
        this.arrayAntecedente = this.antecedentesPer;
      }
      if (this.tipoAntecedente == 5) {
        this.antecedenteActivo = "Familiares";
        this.arrayAntecedente = this.antecedentesFam;
      }
    },
    resumen: function resumen() {
      var _this10 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/resumen/" + this.PacIde,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this10.cie10M();
        _this10.dsm4M();
        _this10.arrayResumen = response.data.data;
        if (response.data.data.length > 0) {
          _this10.impresionHoy = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    detalleResumen: function detalleResumen(row) {
      var _this11 = this;

      var token = localStorage.getItem("token");
      this.detalleResumenFecha = row.ResFec;
      this.detalleDescripcionResumen = row.ResDes;
      this.detalleConclusionResumen = row.ResCon;
      this.$modal.show("modalDetalleAnamnesis");
      this.detalleDsm4 = [];
      this.detalleCie10 = [];

      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/detalleResumen/" + row.ResIde,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        for (var i = 0; i < response.data.data.cie10.length; i++) {
          _this11.detalleCie10.push(response.data.data.cie10[i].DetDes);
        }
        for (var _i = 0; _i < response.data.data.dsm4.length; _i++) {
          _this11.detalleDsm4.push(response.data.data.dsm4[_i].DetDes);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    examenes: function examenes() {
      var _this12 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/examenes/" + this.PacIde,
        headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }, "Content-Type", "multipart/form-data")
      }).then(function (response) {
        _this12.arrayExamen = response.data.data.examenes1;
        _this12.arrayExamen2 = response.data.data.examenes2;
        _this12.arrayExamen3 = response.data.data.examenes3;
        _this12.arrayExamen4 = response.data.data.examenes4;
        _this12.arrayExamen5 = response.data.data.examenes5;
        _this12.arrayExamen6 = response.data.data.examenes6;
        _this12.arrayExamen7 = response.data.data.examenes7;
        _this12.arrayExamen8 = response.data.data.examenes8;
        _this12.arrayExamen9 = response.data.data.examenes9;
        _this12.arrayExamen10 = response.data.data.examenes10;
        _this12.arrayExamen11 = response.data.data.examenes11;
        for (var index = 1; index < 11; index++) {
          if (response.data.data["examenes" + index].length > 0) {
            _this12.examenHoy = true;
          }
        }
        _this12.tipoExamen();
      }).catch(function (error) {
        console.log(error);
      });
    },
    tratamientos: function tratamientos() {
      var _this13 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/tratamientos/" + this.PacIde,
        headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }, "Content-Type", "multipart/form-data")
      }).then(function (response) {
        _this13.tratamiento = response.data.data;
        if (response.data.data.length > 0) {
          _this13.tratamientoHoy = true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    nuevaEspecialidad: function nuevaEspecialidad() {
      if (this.especialidad != "" && this.sesiones != "") {
        this.arrayEspecialidad.push({
          especialidad: this.especialidad[0],
          sesiones: this.sesiones,
          nombre: this.especialidad[1]
        });
        this.especialidad = "";
        this.sesiones = "";
      }
    },
    selectEspecialidad: function selectEspecialidad() {
      var _this14 = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/selectEspecialidad",
        headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }, "Content-Type", "multipart/form-data")
      }).then(function (response) {
        _this14.arrayEspecialidades = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    verDetalle: function verDetalle(row) {
      var _this15 = this;

      this.terapeutaPDF = "";
      this.$modal.show("modalNuevoPlanDetalle");
      var token = localStorage.getItem("token");
      var TraIde = row.TraIde;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/detalle/" + TraIde,
        headers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }, "Content-Type", "multipart/form-data")
      }).then(function (response) {
        _this15.arrayDetalle = response.data.data;
        _this15.fechaTratamiento = row.TraFec;
        _this15.cie10mostrar = row.TraCas;
        _this15.descripcionTratamiento = row.TraDes, _this15.fechaFinTratamiento = row.TraFecFin, _this15.actividadFamiliar = row.TraActFam;
        _this15.logo = response.data.logo;

        _this15.terapeutaPDF = row.terapeuta;
      }).catch(function (error) {});
    },
    tipoExamen: function tipoExamen() {
      this.cambiarLinkExamen();
      if (this.examen == 1) {
        this.arrayActivo = this.arrayExamen;
      }
      if (this.examen == 2) {
        this.arrayActivo = this.arrayExamen2;
      }
      if (this.examen == 3) {
        this.arrayActivo = this.arrayExamen3;
      }
      if (this.examen == 4) {
        this.arrayActivo = this.arrayExamen4;
      }
      if (this.examen == 5) {
        this.arrayActivo = this.arrayExamen5;
      }
      if (this.examen == 6) {
        this.arrayActivo = this.arrayExamen6;
      }
      if (this.examen == 7) {
        this.arrayActivo = this.arrayExamen7;
      }
      if (this.examen == 8) {
        this.arrayActivo = this.arrayExamen8;
      }
      if (this.examen == 9) {
        this.arrayActivo = this.arrayExamen9;
      }
      if (this.examen == 10) {
        this.arrayActivo = this.arrayExamen10;
      }
      if (this.examen == 11) {
        this.arrayActivo = this.arrayExamen11;
      }
    },
    calcularFechaActual: function calcularFechaActual() {
      var mes;
      var fecha_hoy = new Date();

      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        this.fechaDeConsulta = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaAntecedente = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaImpresion = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaResumen = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaTratamiento = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaVerificado = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        this.fechaAntecedente = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaDeConsulta = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaImpresion = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaResumen = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaTratamiento = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
        this.fechaVerificado = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }
    },
    calcularEdad: function calcularEdad() {
      if (this.Fecha_nacimiento != "") {
        var fechaNacimiento = this.Fecha_nacimiento;
        var values = fechaNacimiento.split("-");
        var dia = values[2];
        var mes = values[1];
        var ano = values[0];

        var fecha_hoy = new Date();
        var ahora_ano = fecha_hoy.getFullYear();
        var ahora_mes = fecha_hoy.getMonth() + 1;
        var ahora_dia = fecha_hoy.getDate();

        var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;


        var edad = ahora_ano + 0 - ano;
        if (ahora_mes < mes) {
          edad--;
        }
        if (mes == ahora_mes && ahora_dia < dia) {
          edad--;
        }
        if (edad > 1900) {
          edad -= 1900;
        }

        var meses = 0;
        if (ahora_mes > mes) meses = ahora_mes - mes;
        if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
        if (ahora_mes == mes && dia > ahora_dia) meses = 11;

        var dias = 0;
        if (ahora_dia > dia) dias = ahora_dia - dia;
        if (ahora_dia < dia) {
          var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
          var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
        }

        this.anos = edad;
        this.meses = meses;
        this.edad = this.anos + " años y " + this.meses + " meses";
      } else {
        this.anos = 0;
      }
    },

    e_realizados_to: function e_realizados_to() {
      var _this16 = this;

      var url = this.ip + "api/To_fechas/" + this.PacIde;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url).then(function (response) {
        _this16.examenesRealizados = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    e_realizados_ps: function e_realizados_ps() {
      var _this17 = this;

      var url = this.ip + "api/ps_fechas/" + this.PacIde;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url).then(function (response) {
        _this17.examenesRealizadosPs = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    e_realizados_fonol: function e_realizados_fonol() {
      var _this18 = this;

      var url = this.ip + "api/fonoL_fechas/" + this.PacIde;
      __WEBPACK_IMPORTED_MODULE_13_axios___default.a.get(url).then(function (response) {
        _this18.examenesRealizadosfonol = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    examenesRealizadosF: function examenesRealizadosF() {
      this.e_realizados_ps();
      this.e_realizados_ps();
      this.e_realizados_fonol();
    },

    alerta: function alerta() {
      var opcion = confirm("\xBFdesea continuar viendo la historia clinica de " + localStorage.getItem("PacienteNombre") + "?");
      if (opcion == true) {
        this.criterio = "PacNumDoc";
        this.busqueda = localStorage.getItem("PacienteHC");
        this.buscarPacientes();
      } else {
        localStorage.removeItem("PacienteHC");
        localStorage.removeItem("PacienteId");
        localStorage.removeItem("PacienteNombre");
      }
    },
    push: function push(route) {
      this.$router.push(route);
    },

    validarDispositivo: function validarDispositivo() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {} else {
        this.push('historia');
      }
    }
  },

  mounted: function mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/");
    } else {
      this.motivosM();
      this.calcularFechaActual();
      this.usuarioAvanza = localStorage.getItem("usuario");
      if (localStorage.getItem("PacienteHC")) {
        this.alerta();
      }
      this.validarDispositivo();
    }
  }
});

/***/ }),

/***/ "plmj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"formato"}},[_vm._v("Formato:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formato),expression:"formato"}],staticClass:"form-control",attrs:{"id":"formato"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.formato=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Autorización")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Orden médica")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Buscar por")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.criterio),expression:"criterio"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.criterio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"PacApe1"}},[_vm._v("Apellidos del paciente")]),_vm._v(" "),_c('option',{attrs:{"value":"PacNom1"}},[_vm._v("Nombres del paciente")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('label',{attrs:{"for":""}},[_vm._v("Buscar")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Escribe lo que quieres buscar..."},domProps:{"value":(_vm.busqueda)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarPacientes()},"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-icon btn-simple",on:{"click":function($event){return _vm.buscarPacientes()}}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),(_vm.buscar == false)?_c('div',{staticClass:"row"},[_c('div',[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive",staticStyle:{"width":"97%"},attrs:{"data":_vm.arrayPacientes,"border":"","size":"mini"}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacApe1","label":"Apellidos"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNom1","label":"Nombres"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNumDoc","label":"Numero de documento"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"TipCliNom","label":"Tipo de cliente"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[(props.row.estado==1)?_c('a',{staticClass:"btn btn-simple btn-success btn-xs btn-icon like",on:{"click":function($event){return _vm.seleccionarPaciente(props.row)}}},[_c('i',{staticClass:"fa fa-check"})]):_c('small',{staticClass:"text-danger"},[_vm._v("INACTIVO")])])]}}],null,false,3267663566)})],1)],1)]):_vm._e(),_vm._v(" "),(_vm.nombre != '')?_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}}),_vm._v(" "),(_vm.alertTipoCliente)?_c('small',{staticClass:"text-danger"},[_vm._v("El tipo de cliente no concueda con el modulo seleccionado")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Documento")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documento),expression:"documento"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.documento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.documento=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.formato == 1)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('center',[_c('label',{attrs:{"for":""}},[_vm._v("Autorización sin orden médica")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('switches',{attrs:{"type-bold":"true","theme":"bootstrap","color":"success"},model:{value:(_vm.sinOrden),callback:function ($$v) {_vm.sinOrden=$$v},expression:"sinOrden"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('center',[_c('label',{attrs:{"for":""}},[_vm._v("Autorización \"codigo 90\"")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('switches',{attrs:{"type-bold":"true","theme":"bootstrap","color":"danger"},model:{value:(_vm.c90),callback:function ($$v) {_vm.c90=$$v},expression:"c90"}})],1)],1)]),_vm._v(" "),(_vm.sinOrden == false && _vm.c90 == false)?_c('div',{staticClass:"row"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.tablaOrden == true && _vm.sinOrden == false && _vm.c90 == false)?_c('div',{staticClass:"row"},[_c('center',[_c('el-table',{staticClass:"table-responsive",staticStyle:{"width":"100%"},attrs:{"data":_vm.arrayOrdenes,"border":""}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"OrdCod","label":"Codigo"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"OrdFec","label":"Fecha"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"EpsNom","label":"Entidad"}}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.seleccionarOrden(props.row)}}},[_vm._v("\n              Seleccionar\n            ")])]}}],null,false,2453609611)})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.sinOrden == false && _vm.c90 == false)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("N° de orden:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroOrden),expression:"numeroOrden"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.numeroOrden)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroOrden=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Entidad:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eps),expression:"eps"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.eps)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eps=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de expedición:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicion),expression:"fechaExpedicion"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.fechaExpedicion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de vencimiento:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaVencimiento),expression:"fechaVencimiento"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.fechaVencimiento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaVencimiento=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(2),_vm._v(" "),(_vm.sinOrden == false)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("N° de autorización:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroAutorizacion),expression:"numeroAutorizacion"}],staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":(_vm.numeroAutorizacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de expedición:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicionAutorizacion),expression:"fechaExpedicionAutorizacion"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaExpedicionAutorizacion)},on:{"change":function($event){return _vm.generarCodigoAutorizacion()},"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicionAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Cobertura:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.coberturaAutorizacion),expression:"coberturaAutorizacion"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.coberturaAutorizacion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"45"}},[_vm._v("45 Días")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("1 Mes")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("2 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("3 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"120"}},[_vm._v("4 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"150"}},[_vm._v("5 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"180"}},[_vm._v("6 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"365"}},[_vm._v("Sin vigencia")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Observaciones:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.observaciones),expression:"observaciones"}],staticClass:"form-control",attrs:{"id":"observaciones","cols":"30","rows":"3"},domProps:{"value":(_vm.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.observaciones=$event.target.value}}})])]):_vm._e(),_vm._v(" "),(_vm.sinOrden == true)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Numero de la autorización:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroAutorizacion),expression:"numeroAutorizacion"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.numeroAutorizacion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Entidad:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eps),expression:"eps"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.eps=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v("Seleccione la EPS...")]),_vm._v(" "),_vm._l((_vm.arrayPoliza),function(eps){return _c('option',{key:eps.EpsCod,domProps:{"value":eps.EpsCod,"textContent":_vm._s(eps.EpsNom)}})})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de expedición:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicionAutorizacion),expression:"fechaExpedicionAutorizacion"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaExpedicionAutorizacion)},on:{"change":function($event){return _vm.generarCodigoAutorizacion()},"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicionAutorizacion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Cobertura:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.coberturaAutorizacion),expression:"coberturaAutorizacion"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.coberturaAutorizacion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"45"}},[_vm._v("45 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("1 Mes")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("2 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("3 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"120"}},[_vm._v("4 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"150"}},[_vm._v("5 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"180"}},[_vm._v("6 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":""}},[_vm._v("Sin vigencia")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Observaciones:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.observaciones),expression:"observaciones"}],staticClass:"form-control",attrs:{"id":"observaciones","cols":"30","rows":"3"},domProps:{"value":(_vm.observaciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.observaciones=$event.target.value}}})])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.formato == 2)?_c('div',{staticStyle:{"padding":"10px"}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regimen),expression:"regimen"}],attrs:{"type":"radio","disabled":"","value":"1"},domProps:{"checked":_vm._q(_vm.regimen,"1")},on:{"change":function($event){_vm.regimen="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Contributivo")]),_vm._v("    \n      ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.eps),expression:"eps"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.eps=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.generarCodigo()}]}},[_c('option',{attrs:{"value":"","selected":"","disabled":""}},[_vm._v("Seleccione la EPS...")]),_vm._v(" "),_vm._l((_vm.arrayPoliza),function(eps){return _c('option',{key:eps.EpsCod,domProps:{"value":eps.EpsCod,"textContent":_vm._s(eps.EpsNom)}})})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numeroOrden),expression:"numeroOrden"}],staticClass:"form-control",attrs:{"type":"text","disabled":"","placeholder":"N° de orden"},domProps:{"value":(_vm.numeroOrden)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numeroOrden=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Fecha de expedición:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaExpedicion),expression:"fechaExpedicion"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.fechaExpedicion)},on:{"change":function($event){return _vm.generarCodigo()},"input":function($event){if($event.target.composing){ return; }_vm.fechaExpedicion=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Cobertura")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cobertura),expression:"cobertura"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cobertura=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"45"}},[_vm._v("45 Días")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("1 Mes")]),_vm._v(" "),_c('option',{attrs:{"value":"60"}},[_vm._v("2 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"90"}},[_vm._v("3 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"120"}},[_vm._v("4 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"150"}},[_vm._v("5 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"180"}},[_vm._v("6 Meses")])])])]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('div',[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.agregarServicios.apply(null, arguments)}}},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Servicio")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.especialidad),expression:"especialidad"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.especialidad=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.arrayEspecialidad),function(especialidad){return _c('option',{key:especialidad.EspCod,domProps:{"value":especialidad.EspCod}},[_vm._v("\n              "+_vm._s(especialidad.EspNom)+"\n            ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Cantidad")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cantidad),expression:"cantidad"}],staticClass:"form-control",attrs:{"type":"text","required":""},domProps:{"value":(_vm.cantidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cantidad=$event.target.value}}})]),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.arrayCantidad != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-responsive table-bordered",staticStyle:{"width":"100%"},attrs:{"data":_vm.arrayCantidad,"border":""}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"servicio","label":"Cups"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cantidad","label":"Cantidad"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-xs btn-danger btn-icon remove",on:{"click":function($event){return _vm.eliminarServicio(props.$index, props.row)}}},[_c('i',{staticClass:"ti-close"})])]}}],null,false,31756203)})],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('center',[_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),(_vm.formato == 1 && _vm.sinOrden == false && _vm.c90 == false)?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.nuevaAutorizacion()}}},[_vm._v("\n          Registrar Autorización (OM)\n        ")]):_vm._e(),_vm._v(" "),(
            (_vm.formato == 1 && _vm.sinOrden == true) ||
            (_vm.formato == 1 && _vm.c90 == true)
          )?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.nuevaAutorizacionSinOM()}}},[_vm._v("\n          Registrar Autorización (sin OM)\n        ")]):_vm._e(),_vm._v(" "),(_vm.formato == 2)?_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.nuevaOrdenMedica()}}},[_vm._v("\n          Registrar Orden médica\n        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-icon",on:{"click":function($event){return _vm.cerrar()}}},[_vm._v("\n          Cancelar\n        ")])])])],1),_vm._v(" "),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"bold","margin-bottom":"15px"}},[_vm._v("Selecciona al paciente")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n          Información de la orden\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n        Información de la autorización\n        \n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n        Información de la orden\n        \n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticStyle:{"font-weight":"600"}},[_vm._v("\n        Servicios\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-1"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("---")]),_vm._v(" "),_c('button',{staticClass:"btn btn-icon btn-simple btn-success",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ppsA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objetivosLogros_vue__ = __webpack_require__("EMR6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ea90f6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_objetivosLogros_vue__ = __webpack_require__("cmih");
function injectStyle (ssrContext) {
  __webpack_require__("WWyB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_objetivosLogros_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ea90f6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_objetivosLogros_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "puqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-12 card"},[_c('div',{staticClass:"card-content row"},[_c('div',{staticClass:"col-sm-6"},[_c('label',{attrs:{"for":""}},[_vm._v("Cantidad de registros:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"pull-right"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Buscar paciente..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Ver:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ver),expression:"ver"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.ver=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.cargarPacientes()}]}},[_c('option',{domProps:{"value":1}},[_vm._v("Activos")]),_vm._v(" "),_c('option',{domProps:{"value":0}},[_vm._v("Inactivos")]),_vm._v(" "),_c('option',{domProps:{"value":2}},[_vm._v("Todos")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',{staticStyle:{"color":"green"}},[_vm._v("Pacientes Activos: "+_vm._s(_vm.pacientesActivos))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("Pacientes Inactivos: "+_vm._s(_vm.pacientesInactivos))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Total pacientes: "+_vm._s(_vm.totalPacientes))])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[(_vm.json_data!='')?_c('download-excel',{staticClass:"btn pull-right",staticStyle:{"border-radius":"0px","color":"white","border":"green","background-color":"#03C639"},attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"My Worksheet","name":'Reporte-pacientes'}},[_vm._v("\n              Exportar a excel\n              ")]):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":""}},[_c('el-table-column',{attrs:{"min-width":60,"fixed":"left","label":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('a',{staticClass:"btn btn-simple btn-info btn-icon like",on:{"click":function($event){return _vm.modalDetallePaciente(props.row)}}},[_c('i',{staticClass:"ti-eye"})])])]}}])}),_vm._v(" "),_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"else":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":60,"fixed":"right","label":"Lideres"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('a',{staticClass:"btn btn-simple btn-info btn-icon like",on:{"click":function($event){return _vm.modal(props.$index, props.row)}}},[_c('i',{staticClass:"ti-user"})])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":120,"fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('br'),_vm._v(" "),_c('select',{staticClass:"form-control select-sm",domProps:{"value":props.row.estado},on:{"change":function($event){return _vm.actualizarEstado(props.row.PacIdeUsu, props.row.estado)}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Activo")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Inactivo")])])]}}])})],2)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n          Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)])]),_vm._v(" "),_c('modal',{attrs:{"name":"buscar","scrollable":true,"height":"auto","reset":true}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-users"})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("ASIGNAR LIDERES TERAPÉUTICOS")]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("\n            Asignación y/o modifiación de lideres terapéuticos\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"padding":"30px","margin":"5px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_vm._v("Psicología")])],1)],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.psico),expression:"psico"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.psico=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Sin lider")]),_vm._v(" "),_vm._l((_vm.terapeutasPsico),function(terapeuta){return _c('option',{key:terapeuta.id,domProps:{"value":terapeuta.usuario}},[_vm._v("\n              "+_vm._s(terapeuta.nombres + " " + terapeuta.apellidos)+"\n            ")])})],2),_vm._v(" "),(_vm.rol == 1)?_c('p',{staticStyle:{"padding-left":"5px"}},[_vm._v("Confidencial  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.block),expression:"block"}],attrs:{"disabled":_vm.psico==null,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.block)?_vm._i(_vm.block,null)>-1:(_vm.block)},on:{"change":function($event){var $$a=_vm.block,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.block=$$a.concat([$$v]))}else{$$i>-1&&(_vm.block=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.block=$$c}}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_vm._v("Fisioterapia")])],1)],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fisio),expression:"fisio"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fisio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Sin lider")]),_vm._v(" "),_vm._l((_vm.terapeutasFisio),function(terapeuta){return _c('option',{key:terapeuta.id,domProps:{"value":terapeuta.usuario}},[_vm._v("\n              "+_vm._s(terapeuta.nombres + " " + terapeuta.apellidos)+"\n            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_vm._v("Fonoaudiología")])],1)],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.fono),expression:"fono"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.fono=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Sin lider")]),_vm._v(" "),_vm._l((_vm.terapeutasFono),function(terapeuta){return _c('option',{key:terapeuta.id,domProps:{"value":terapeuta.usuario}},[_vm._v("\n              "+_vm._s(terapeuta.nombres + " " + terapeuta.apellidos)+"\n            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_vm._v("Educación especial")])],1)],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.edu),expression:"edu"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.edu=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Sin lider")]),_vm._v(" "),_vm._l((_vm.terapeutasEdu),function(terapeuta){return _c('option',{key:terapeuta.id,domProps:{"value":terapeuta.usuario}},[_vm._v("\n              "+_vm._s(terapeuta.nombres + " " + terapeuta.apellidos)+"\n            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_c('font',{staticStyle:{"vertical-align":"inherit"}},[_vm._v("Terapia Ocupacional")])],1)],1),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.teo),expression:"teo"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.teo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":null}},[_vm._v("Sin lider")]),_vm._v(" "),_vm._l((_vm.terapeutasTeo),function(terapeuta){return _c('option',{key:terapeuta.id,domProps:{"value":terapeuta.usuario}},[_vm._v("\n              "+_vm._s(terapeuta.nombres + " " + terapeuta.apellidos)+"\n            ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn-sm btn-fill btn btn-secondary",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.cerrar_modal()}}},[_c('i',{staticClass:"fa fa-close"}),_vm._v(" Cerrar\n      ")]),_vm._v(" "),(_vm.rol == 1 || _vm.rol == 9 || _vm.rol == 13 || _vm.rol == 14 || _vm.rol == 15)?_c('button',{staticClass:"btn-sm btn-fill btn btn-success",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.asignar_lideres()}}},[_c('i',{staticClass:"fa fa-send"}),_vm._v(" Actualizar Información\n      ")]):_vm._e()])]),_vm._v(" "),_c('modal',{attrs:{"name":"modalDetallePaciente","height":"auto","width":"800"}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-user"})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("DETALLE DEL PACIENTE")]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("Información detallada del paciente")])])])]),_vm._v(" "),(_vm.informacionPaciente != '')?_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('img',{staticClass:"img-thumbnail",attrs:{"width":"200","height":"200","alt":"posible fotografía del paciente","src":'https://avanti-erp.com/' +
              _vm.informacionPaciente.datos[0].url_foto}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[(_vm.informacionPaciente.datos[0].estado == 1)?_c('h4',{staticStyle:{"color":"green"}},[_vm._v("\n              ACTIVO\n            ")]):_c('h4',{staticStyle:{"color":"red"}},[_vm._v("INACTIVO")])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('center',[_c('span',[_vm._v("Datos Personales")])]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('small',{attrs:{"for":""}},[_vm._v("Nombres")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.informacionPaciente.datos[0].PacNom1}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('small',{attrs:{"for":""}},[_vm._v("Apellidos")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.informacionPaciente.datos[0].PacApe1}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('small',{attrs:{"for":""}},[_vm._v("Fecha de nacimiento")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.informacionPaciente.datos[0].PacFecNac}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('small',{attrs:{"for":""}},[_vm._v("Fehca de ingreso")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.informacionPaciente.datos[0].PacFecIng}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('center',[_c('span',[_vm._v("Datos de afiliación")])]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('small',[_vm._v("Eps")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.informacionPaciente.eps}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('small',[_vm._v("Prepagada")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.informacionPaciente.prepagada}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('small',[_vm._v("Póliza")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.informacionPaciente.poliza}})])])])])]):_c('div',{staticClass:"modal-body"},[_c('center',[_c('h4',[_c('i',{staticClass:"fa fa-spinner"}),_vm._v(" Actualizando información del\n          paciente...\n        ")])])],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"title"},[_vm._v("Listado de pacientes registrados en el sistema")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q+0e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qdTC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rDei":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ADashboard_vue__ = __webpack_require__("YOGp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04792a72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ADashboard_vue__ = __webpack_require__("Wi7L");
function injectStyle (ssrContext) {
  __webpack_require__("atf9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04792a72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ADashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04792a72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ADashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rEl7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
    var date = new Date(value + 'T00:00:00');
    return date.toLocaleString(['es-ES'], { month: 'long',
        day: '2-digit', year: 'numeric' });
});

/***/ }),

/***/ "rK8S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionGastos_vue__ = __webpack_require__("PScw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11d77488_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionGastos_vue__ = __webpack_require__("RuiY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionGastos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11d77488_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionGastos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rYom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mantenimiento_estrategias_vue__ = __webpack_require__("3Sq6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_621d239d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mantenimiento_estrategias_vue__ = __webpack_require__("Luuf");
function injectStyle (ssrContext) {
  __webpack_require__("TzyY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mantenimiento_estrategias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_621d239d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mantenimiento_estrategias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sJQM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.infObjetivo),expression:"infObjetivo"}],staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('center',[_c('p',{staticClass:"titulo"},[_vm._v("Buscar Pacientes "),_c('i',{staticClass:"fa fa-user"})])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.buscar == true),expression:"buscar == true"}],staticClass:"container"},[_c('div',{staticClass:"col-md-4 col-12"},[_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.criterio),expression:"criterio"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.criterio=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"PacApe1"}},[_vm._v("Apellidos del paciente")]),_vm._v(" "),_c('option',{attrs:{"value":"PacNom1"}},[_vm._v("Nombre del paciente")]),_vm._v(" "),_c('option',{attrs:{"value":"PacNumDoc"}},[_vm._v("Documento del paciente")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-12"},[_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busqueda),expression:"busqueda"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.busqueda)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarPacientes()},"input":function($event){if($event.target.composing){ return; }_vm.busqueda=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.buscarPacientes()}}},[_vm._v("\n              Buscar "),_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.buscar == false),expression:"buscar == false"}],staticStyle:{"padding":"40px"}},[_c('button',{staticClass:"btn btn-primary btn-sm btn-icon",on:{"click":function($event){return _vm.iniciar()}}},[_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[_c('br'),_vm._v(" "),_c('div',[_c('el-table',{staticClass:"table-responsive table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.arrayPacientes,"size":"small"}},[_c('el-table-column',{attrs:{"prop":"PacApe1","label":"Apellidos"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNom1","label":"Nombres"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"PacNumDoc","label":"N° documento"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"80","label":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{staticClass:"btn btn-simple btn-sm btn-success",on:{"click":function($event){return _vm.cargarAllObjetivos(props.row)}}},[_c('i',{staticClass:"ti-eye"})])]}}])})],1)],1)])],1),_vm._v(" "),_c('center',[_c('br'),_c('br'),_vm._v(" "),(_vm.arrayPacientes == '')?_c('div',{staticStyle:{"width":"80%"}},[_c('div',{staticClass:"alert alert-danger alert-with-icon"},[_c('center',[_c('img',{staticStyle:{"width":"20%"},attrs:{"src":"static/img/logo.webp","alt":""}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('strong',{staticStyle:{"color":"white"},attrs:{"data-notify":"message"}},[_c('i',{class:'fa fa-' + _vm.icono}),_vm._v(" "+_vm._s(_vm.mensaje)+"\n                ")]),_vm._v(" "),_c('br'),_c('br')])],1)]):_vm._e()])],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-footer text-muted"},[_c('center',[_vm._v("Avanza IPS")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logros),expression:"logros"}],staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('button',{staticClass:"btn btn-simple btn-icon",on:{"click":function($event){return _vm.volver()}}},[_c('i',{staticClass:"fa fa-arrow-circle-o-left",staticStyle:{"font-size":"25px","color":"#b3b3b3","float":"right"}})])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.push('/historiaClinica/historia')}}},[_vm._v("Ir a la historia clinica")])])])]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('vue-tabs',{attrs:{"direction":"horizontal","value":"l"}},[_c('v-tab',{attrs:{"title":"Información General"}},[_c('div',{staticClass:"row",staticStyle:{"margin":"1%"}},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticStyle:{"margin":"7%"}}),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"author"},[_c('img',{staticClass:"border-white",staticStyle:{"width":"40%"},attrs:{"src":_vm.foto,"alt":"..."}}),_vm._v(" "),_c('h4',{staticClass:"title"},[_vm._v("\n                        "+_vm._s(_vm.nombre)+"\n                        "),_c('br'),_vm._v(" "),(_vm.loked != null)?_c('small',[_c('strong',{staticClass:"text-danger"},[_vm._v("Confidencial")])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm._f("date")(_vm.fecha_nacimiento)))])]),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v("Líderes")]),_vm._v(" "),_c('ul',{staticClass:"list-group"},[_c('li',{staticClass:"list-group-item"},[_c('p',[_vm._v("\n                            Fisioterapia: "),_c('strong',[_vm._v(_vm._s(_vm.tabs[0].lider))])]),_vm._v(" "),_c('p',[_vm._v("\n                            Fonoaudiología:\n                            "),_c('strong',[_vm._v(_vm._s(_vm.tabs[1].lider))])]),_vm._v(" "),_c('p',[_vm._v("\n                            Ter. Ocupacional:\n                            "),_c('strong',[_vm._v(_vm._s(_vm.tabs[2].lider))])]),_vm._v(" "),_c('p',[_vm._v("\n                            Psicología: "),_c('strong',[_vm._v(_vm._s(_vm.tabs[3].lider))])]),_vm._v(" "),_c('p',[_vm._v("\n                            Edu. Especial:\n                            "),_c('strong',[_vm._v(_vm._s(_vm.tabs[4].lider))])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"row"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.id,staticClass:"col-md-4 col-sm-6"},[(tab.id != 4 || tab.id == 4 && _vm.loked == null || _vm.loked == _vm.usuario || _vm.rol == 1 || _vm.rol == 9 || _vm.rol == 13)?_c('circle-chart-card',{attrs:{"percentage":tab.promedio,"pendiente":tab.pendiente,"pendienteEvaluar":tab.pendienteEvaluar > 0
                        ? tab.pendienteEvaluar + ' objetivo(s) por evaluar'
                        : '',"bar":tab.bar,"description":tab.notification > 0
                        ? tab.notification + ' objetivo(s) por confirmar'
                        : '',"title":tab.nombre,"color":tab.color}}):_c('circle-chart-card',{attrs:{"percentage":'--',"confidencial":true,"title":'Psicología',"color":tab.color}})],1)}),0)])]),_vm._v(" "),_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab.id,attrs:{"title":tab.nombre}},[_c('div',{staticClass:"row",staticStyle:{"padding":"50px"}},[_c('div',{staticClass:"col-md-2"},[(
                    (tab.lider == _vm.usuario && _vm.estado == 1) ||
                    (_vm.rol == 1 && _vm.estado == 1)
                  )?_c('button',{staticClass:"btn btn-sm btn-fill btn-block btn-success",staticStyle:{"border-radius":"5px"},attrs:{"disabled":_vm.estado == 0,"v":""},on:{"click":function($event){return _vm.abrirModalRegistrar(tab)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Nuevo objetivo\n                ")]):_vm._e(),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',[_c('p',[_vm._v(_vm._s(tab.nombre))])]),_vm._v(" "),(_vm.estado == 0)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("Paciente Inactivo")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[(tab.id != 4 || tab.id == 4 && _vm.loked == null || _vm.loked == _vm.usuario || _vm.rol == 1 || _vm.rol == 9 || _vm.rol == 13)?_c('el-table',{staticClass:"table-responsive table-striped",attrs:{"size":"mini","data":tab.datos}},[_c('el-table-column',{attrs:{"fixed":"left","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(
                          props.row.updated_at <= props.row.ObjFecCum &&
                          props.row.ObjLog != null
                        )?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"green"}}):_vm._e(),_vm._v(" "),(
                          props.row.updated_at > props.row.ObjFecCum &&
                          props.row.ObjLog != null
                        )?_c('i',{staticClass:"fa fa-check",staticStyle:{"color":"orange"}}):_vm._e(),_vm._v(" "),(
                          props.row.ObjFecCum < _vm.fecha &&
                          props.row.ObjLog == null
                        )?_c('i',{staticClass:"fa fa-close",staticStyle:{"color":"red"}}):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ObjFec","label":"Fecha","width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ObjFecCum","label":"Fecha a cumplir","width":"125"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ObjUsu","label":"Terapeuta","width":"90"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ObjObj","label":"Objetivo","fit":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Logro"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[(
                            _vm.fecha > props.row.ObjFecCum &&
                            props.row.ObjLog == null
                          )?_c('span',[_vm._v("Logro en proceso de confirmación")]):_c('span',[_vm._v(_vm._s(props.row.ObjLog))])])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Evidencia del logro","fit":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.UrlLogEvi != null && props.row.UrlLogEvi != '')?_c('a',{staticClass:"btn btn-xs btn-fill",attrs:{"target":"_blank","href":props.row.UrlLogEvi}},[_c('i',{staticClass:"fa fa-play"}),_vm._v(" Ver evidencia")]):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Promedio","fit":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.ObjPor)+" %")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('center',[_c('p',[(props.row.ObjLog == null && props.row.ObjUsu == _vm.terapeutaLog && props.row.ObjFec < '2025-03-09' ||  _vm.rol == 9 || _vm.rol == 13 || _vm.rol == 15 && props.row.ObjFec < '2024-01-15')?_c('button',{staticClass:"btn btn-simple btn-icon btn-warning",on:{"click":function($event){return _vm.cargarObjetivo(props.row)}}},[_c('i',{staticClass:"ti-pencil-alt"})]):_vm._e(),_vm._v(" "),_vm._l((3),function(index){return _c('span',{key:index},[(
                            props.row.ObjUsu == _vm.terapeutaLog && props.row.ObjFec > '2025-03-09' ||
                              _vm.rol == 9 ||
                              _vm.rol == 13 ||
                              _vm.rol == 15 && props.row.ObjFec > '2025-03-09'
                          )?_c('button',{staticClass:"btn btn-simple btn-icon btn-warning col",on:{"click":function($event){return _vm.cargarObjetivoV2(props.row, index)}}},[_c('i',{staticClass:"ti-pencil-alt"})]):_vm._e()])})],2)])]}}],null,true)})],1):_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('center',[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{staticClass:"img-responsive",attrs:{"src":"static/img/ICONOS/candado.svg","width":"70","alt":"Imagen de bloqueo de HC avanti"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Estos Objetivos son confidenciales. Por favor comunicarse con el administrador para solicitar acceso.")])])],1)])]),_vm._v(" "),_c('br')],1)])])})],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"modal fade",class:{ mostrar: _vm.modalRegistrar },attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('label',{attrs:{"for":"objetivo"}},[_vm._v("Objetivo:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.objetivo),expression:"objetivo"}],staticClass:"form-control form-control-sm",attrs:{"id":"objetivo","cols":"30","rows":"8"},domProps:{"value":(_vm.objetivo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.objetivo=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Registra las tareas asociadas al objetivo")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"logro1"}},[_vm._v("Tarea 1:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.Log1),expression:"Log1"}],staticClass:"form-control form-control-sm",attrs:{"id":"logro1","cols":"30","rows":"4"},domProps:{"value":(_vm.Log1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Log1=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"logro2"}},[_vm._v("Tarea 2:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.Log2),expression:"Log2"}],staticClass:"form-control form-control-sm",attrs:{"id":"logro2","cols":"30","rows":"4"},domProps:{"value":(_vm.Log2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Log2=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"logro1"}},[_vm._v("Tarea 3:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.Log3),expression:"Log3"}],staticClass:"form-control form-control-sm",attrs:{"id":"logro3","cols":"30","rows":"4"},domProps:{"value":(_vm.Log3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.Log3=$event.target.value}}})]),_vm._v(" "),_c('center',[(_vm.validarTareasIguales() == true)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("\n            Las tareas no pueden coincidir.\n          ")]):_vm._e()]),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-danger",staticStyle:{"border-radius":"5px"},attrs:{"type":"button"},on:{"click":function($event){_vm.modalRegistrar = 0}}},[_vm._v("\n            Cancelar\n          ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(
                _vm.Log1 != '' &&
                _vm.Log2 != '' &&
                _vm.Log3 != '' &&
                _vm.objetivo != '' &&
                _vm.validarTareasIguales() != true
            ),expression:"\n                Log1 != '' &&\n                Log2 != '' &&\n                Log3 != '' &&\n                objetivo != '' &&\n                validarTareasIguales() != true\n            "}],staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.nuevoObjetivo()}}},[_vm._v("\n            Nuevo objetivo\n          ")])]),_vm._v(" "),_c('br')],1)])]),_vm._v(" "),_c('div',{staticClass:"modal fade",class:{ mostrar: _vm.modalCalificar },attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content",staticStyle:{"height":"40vh !important"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.PeriodoCalificar === 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',[_vm._v(_vm._s(_vm.Log1))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.puntaje1),expression:"puntaje1"}],staticClass:"form-control",attrs:{"disabled":_vm.bloquearBotonEvaluar},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.puntaje1=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}}),_vm._v(" "),_vm._l((_vm.opciones),function(opcion){return _c('option',{key:opcion.id,domProps:{"value":opcion.valor,"textContent":_vm._s(opcion.texto)}})})],2),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.puntaje1)+"%")])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.PeriodoCalificar === 2)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',[_vm._v(_vm._s(_vm.Log2))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.puntaje2),expression:"puntaje2"}],staticClass:"form-control",attrs:{"disabled":_vm.bloquearBotonEvaluar},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.puntaje2=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}}),_vm._v(" "),_vm._l((_vm.opciones),function(opcion){return _c('option',{key:opcion.id,domProps:{"value":opcion.valor,"textContent":_vm._s(opcion.texto)}})})],2),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.puntaje2)+"%")])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.PeriodoCalificar === 3)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('p',[_vm._v(_vm._s(_vm.Log3))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.puntaje3),expression:"puntaje3"}],staticClass:"form-control",attrs:{"disabled":_vm.bloquearBotonEvaluar},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.puntaje3=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":""}}),_vm._v(" "),_vm._l((_vm.opciones),function(opcion){return _c('option',{key:opcion.id,domProps:{"value":opcion.valor,"textContent":_vm._s(opcion.texto)}})})],2),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.puntaje3)+"%")])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.PeriodoCalificar === 3)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleFormControlTextarea1"}},[_vm._v("Comentarios del logro:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.comentario),expression:"comentario"}],staticClass:"form-control",attrs:{"disabled":_vm.bloquearBotonEvaluar,"id":"exampleFormControlTextarea1","rows":"5","value":"comentario"},domProps:{"value":(_vm.comentario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.comentario=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"linkEvidencia"}},[_vm._v("Evidencia del logro:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.evidenciaRegistroLogro),expression:"evidenciaRegistroLogro"}],staticClass:"form-control",attrs:{"type":"url","disabled":_vm.bloquearBotonEvaluar},domProps:{"value":(_vm.evidenciaRegistroLogro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.evidenciaRegistroLogro=$event.target.value}}})])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-danger",staticStyle:{"border-radius":"5px"},on:{"click":function($event){_vm.modalCalificar = 0}}},[_vm._v("\n              Cancelar\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"disabled":_vm.bloquearBotonEvaluar},on:{"click":function($event){return _vm.calificarObjetivoV2()}}},[_vm._v("\n              Evaluar\n            ")])])],1),_vm._v(" "),_c('center'),_vm._v(" "),_c('br')],1)])]),_vm._v(" "),_c('modal',{attrs:{"name":"modalextenderLogro","width":"600","height":"220"}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"7px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-calendar",staticStyle:{"font-size":"39px"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('p',{staticClass:"titulo-modal"},[_vm._v("Extender fecha para el logro")]),_vm._v(" "),_c('p',{staticClass:"texto-pequeno"},[_vm._v("\n            Extender la fecha para registro de logro\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body scroll-gg"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaEdit),expression:"fechaEdit"}],staticClass:"form-control form-control-lg",staticStyle:{"background-color":"white","height":"70px","font-size":"3.2vh"},attrs:{"type":"date","min":_vm.fecha},domProps:{"value":(_vm.fechaEdit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaEdit=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-success btn-block",staticStyle:{"border-radius":"0"},on:{"click":function($event){return _vm.editDate()}}},[_vm._v("\n              ACTUALIZAR FECHA\n            ")])])],1)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-5"},[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v(" OBJETIVOS AVANZA\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header CM",staticStyle:{"padding":"8px"}},[_c('strong',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v("\n            Nuevo objetivo\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header CM",staticStyle:{"padding":"8px"}},[_c('strong',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v(" Avance de las tareas\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sQEs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t/yl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var axiosInstance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: 'https://avanti-erp.com/',
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('token'),
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (axiosInstance);

/***/ }),

/***/ "t0R4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.obtenerInformacionDeEvoluciones(_vm.fechaInicial, _vm.fechaFinal)}}},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Paciente:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.paciente),expression:"paciente"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.paciente=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Seleccionar paciente....")]),_vm._v(" "),_vm._l((_vm.pacienteSelect),function(paciente){return _c('option',{key:paciente.PacIdeUsu,domProps:{"value":paciente.PacIdeUsu}},[_vm._v("\n              "+_vm._s(paciente.PacNom1 + " " + paciente.PacApe1)+"\n            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","required":"","id":"fechaInicial"},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha final:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","required":"","id":"fechaInicial"},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}})]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"card",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"row"},[_c('center',[(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e()])],1),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{ref:"component",staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive mt-2",attrs:{"border":"","data":_vm.queriedData}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row[column.prop]))])]}}],null,true)})}),1)],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Información de las evoluciones sin logro de objetivo")]),_vm._v(" "),_c('p',[_vm._v("\n            Aquí podrá gestionar la información relacionada con los\n            "),_c('span',{staticClass:"text-success"},[_vm._v("Informes entregados a los pacientes")]),_vm._v("\n            de "),_c('span',{staticClass:"text-success"},[_vm._v("Avanza")]),_vm._v(" por fecha\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3"},[_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit","value":"Buscar información"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tKWI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"form-control",attrs:{"type":"search","placeholder":"Buscar patología..."},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 px-2"},[_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.abrirModal()}}},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Nueva Patología\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('download-excel',{staticClass:"btn btn-info btn-fill",staticStyle:{"border-radius":"5px"},attrs:{"data":_vm.arrayPatologias,"fields":_vm.json_cie10,"worksheet":"My Worksheet","name":'cie10'}},[_vm._v("\n            Exportar a excel\n          ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-striped",staticStyle:{"width":"100%"},attrs:{"data":_vm.queriedData,"border":"","max-height":"400"}},[_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label,"else":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"Tipo"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.DomTip == 1)?_c('p',[_vm._v("CIE10")]):_vm._e(),_vm._v(" "),(props.row.DomTip == 2)?_c('p',[_vm._v("DSM4")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","label":"Estado"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.DomEst == 1)?_c('p',{staticClass:"label label-success",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n                Activo\n              ")]):_c('p',{staticClass:"label label-danger",attrs:{"slot":"title-label"},slot:"title-label"},[_vm._v("\n                Inactivo\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":40,"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.DomEst == 2)?_c('button',{staticClass:"btn btn-simple btn-xs btn-info btn-icon check",on:{"click":function($event){return _vm.activar(props.row)}}},[_c('i',{staticClass:"ti-check"})]):_c('button',{staticClass:"btn btn-simple btn-danger",on:{"click":function($event){return _vm.desactivar(props.row)}}},[_c('i',{staticClass:"fa fa-trash"})])]}}])})],2),_vm._v(" "),_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Mostrando del "+_vm._s(_vm.from + 1)+" al "+_vm._s(_vm.to)+" de "+_vm._s(_vm.total)+" registros\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"modal fade",class:{ mostrar: _vm.modalRegistrar },attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header CM",staticStyle:{"padding":"8px"}},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.modalRegistrar = 0}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.nuevoDominio.apply(null, arguments)}}},[_c('label',{attrs:{"for":""}},[_vm._v("Descripción:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.descripcion),expression:"descripcion"}],staticClass:"form-control",attrs:{"required":"","cols":"30","rows":"3"},domProps:{"value":(_vm.descripcion)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descripcion=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Clasificación:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipo),expression:"tipo"}],attrs:{"value":"1","type":"radio"},domProps:{"checked":_vm._q(_vm.tipo,"1")},on:{"change":function($event){_vm.tipo="1"}}}),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("CIE10")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"submit"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Agregar patología\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.limpiarFormulario()}}},[_vm._v("\n                  Limpiar formulario "),_c('i',{staticClass:"fa fa-refresh"})])])],1)]),_vm._v(" "),_c('center'),_vm._v(" "),_c('br')],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-file",staticStyle:{"font-size":"80px","color":"grey"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-11"},[_c('h4',{staticClass:"title-card"},[_vm._v("Patologías (CIE10)")]),_vm._v(" "),_c('small',[_vm._v("Administra las patologías registradas en AVANTI")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',{staticClass:"modal-title",attrs:{"id":"exampleModalLongTitle"}},[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v("\n              Nueva Patología\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u3/v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uYdZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"fechaInicial"}},[_vm._v("Fecha inicial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","id":"fechaInicial"},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{attrs:{"for":"fechaFinal"}},[_vm._v("Fecha final:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","id":"fechaFinal"},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",on:{"click":function($event){return _vm.obtenerInformacionEvoluciones(_vm.fechaInicial, _vm.fechaFinal)}}},[_vm._v("Buscar información")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill mb-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"Evoluciones atrasadas","name":"evoluciones_atrasadas"}},[_vm._v("\n            Exportar a excel "),_c('i',{staticClass:"fa fa-download",attrs:{"color":"black"}})]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),(_vm.queriedData2 == '')?_c('div',{staticClass:"row"},[_c('center',[_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1)])],1):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive table-striped mt-2",attrs:{"border":"","data":_vm.queriedData}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"full-width",class:_vm.getClass(column, row)},[(_vm.getClass(column, row) != '')?_c('strong',[_vm._v(_vm._s(_vm.formatearPesosColombianos(row[column.prop])))]):_c('span',[_vm._v(_vm._s(row[column.prop]))])])]}}],null,true)})}),1)],1),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()]):_vm._e(),_vm._v(" "),_c('modal',{attrs:{"name":"registrar-gasto","scrollable":true,"height":"auto","reset":true}},[_c('div',{staticClass:"modal-header",staticStyle:{"padding":"8px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('strong',{staticClass:"titulo-modal"},[_vm._v(" REGISTRAR UN GASTO FIJO ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"grey"}},[_vm._v(" Creación de gastos fijos ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.newExpense()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"valor"}},[_vm._v("Valor del gasto:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valor),expression:"valor"}],staticClass:"form-control",attrs:{"type":"number","required":""},domProps:{"value":(_vm.valor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.valor=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"usuario"}},[_vm._v("Usuario:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario),expression:"usuario"}],staticClass:"form-control",attrs:{"id":"usuario"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.usuario=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Seleccionar...")]),_vm._v(" "),_vm._l((_vm.listUsers),function(usuario){return _c('option',{key:usuario.id,domProps:{"value":usuario.usuario}},[_vm._v(" "+_vm._s(usuario.nombreUsuario))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"for":"nota"}},[_vm._v("Concepto:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.nota),expression:"nota"}],staticClass:"form-control",attrs:{"name":"nota","id":"nota","cols":"30","rows":"2"},domProps:{"value":(_vm.nota)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nota=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('center',[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.cerrarModal()}}},[_vm._v("\n                    Cancelar\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill",attrs:{"type":"submit"}},[_vm._v("\n                    Registrar gasto\n                  ")])])],1)])])])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Gestión de evoluciones atrasadas")]),_vm._v(" "),_c('p',[_vm._v("\n            Aquí podrá gestionar la información relacionada con las\n            "),_c('span',{staticClass:"text-success"},[_vm._v("evoluciones")]),_vm._v(" registradas en una fecha posterior a la sesión\n          ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uusu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc__ = __webpack_require__("INCx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_StatsCard_vue__ = __webpack_require__("vNb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__global_services_formatear_pesos__ = __webpack_require__("1byD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");





















__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_13_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_14_src_components_UIComponents_Cards_StatsCard_vue__["a" /* default */],
    PPagination: __WEBPACK_IMPORTED_MODULE_17_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedDataPendiente: function pagedDataPendiente() {
      return this.objetivosPendientes.slice(this.fromPendiente, this.toPendiente);
    },
    objetivosPendientesPag: function objetivosPendientesPag() {
      var _this = this;

      if (!this.searchQuery) {
        this.paginationPendiente.total = this.objetivosPendientes.length;
        return this.pagedDataPendiente;
      }
      var result = this.objetivosPendientes.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.paginationPendiente.total = result.length;
      return result.slice(this.fromPendiente, this.toPendiente);
    },
    toPendiente: function toPendiente() {
      var highBound = this.fromPendiente + this.paginationPendiente.perPage;
      if (this.totalPendiente < highBound) {
        highBound = this.totalPendiente;
      }
      return highBound;
    },
    fromPendiente: function fromPendiente() {
      return this.paginationPendiente.perPage * (this.paginationPendiente.currentPage - 1);
    },
    totalPendiente: function totalPendiente() {
      this.paginationPendiente.total = this.objetivosPendientes.length;
      return this.objetivosPendientes.length;
    },
    pagedDataPacientesCargo: function pagedDataPacientesCargo() {
      return this.pacientesCargo.slice(this.fromPacienteCargo, this.toPacienteCargo);
    },
    pacientesCargoPag: function pacientesCargoPag() {
      var _this2 = this;

      if (!this.searchPaciente) {
        this.paginationPacienteCargo.total = this.pacientesCargo.length;
        return this.pagedDataPacientesCargo;
      }
      var result = this.pacientesCargo.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this2.propsToSearch), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this2.searchPaciente.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return isIncluded;
      });
      this.paginationPacienteCargo.total = result.length;
      return result.slice(this.fromPacienteCargo, this.toPacienteCargo);
    },
    toPacienteCargo: function toPacienteCargo() {
      var highBound = this.fromPacienteCargo + this.paginationPacienteCargo.perPage;
      if (this.totalPacienteCargo < highBound) {
        highBound = this.totalPacienteCargo;
      }
      return highBound;
    },
    fromPacienteCargo: function fromPacienteCargo() {
      return this.paginationPacienteCargo.perPage * (this.paginationPacienteCargo.currentPage - 1);
    },
    totalPacienteCargo: function totalPacienteCargo() {
      this.paginationPacienteCargo.total = this.pacientesCargo.length;
      return this.pacientesCargo.length;
    },
    pagedDataObjetivosProximos: function pagedDataObjetivosProximos() {
      return this.objetivosActivos.slice(this.fromObjetivosProximos, this.toObjetivosProximos);
    },
    objetivosProximosPag: function objetivosProximosPag() {
      var _this3 = this;

      if (!this.searchQuery) {
        this.paginationProximo.total = this.objetivosActivos.length;
        return this.pagedDataObjetivosProximos;
      }
      var result = this.objetivosActivos.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this3.propsToSearch), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var key = _step3.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this3.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return isIncluded;
      });
      this.paginationProximo.total = result.length;
      return result.slice(this.fromObjetivosProximos, this.toObjetivosProximos);
    },
    toObjetivosProximos: function toObjetivosProximos() {
      var highBound = this.fromObjetivosProximos + this.paginationProximo.perPage;
      if (this.totalObjetivosProximo < highBound) {
        highBound = this.totalObjetivosProximo;
      }
      return highBound;
    },
    fromObjetivosProximos: function fromObjetivosProximos() {
      return this.paginationProximo.perPage * (this.paginationProximo.currentPage - 1);
    },
    totalObjetivosProximo: function totalObjetivosProximo() {
      this.paginationProximo.total = this.objetivosActivos.length;
      return this.objetivosActivos.length;
    },
    pagedDataSesionesRR: function pagedDataSesionesRR() {
      return this.hisAtenciones.slice(this.fromSesionesRR, this.toSesionesRR);
    },
    sesionesRRPag: function sesionesRRPag() {
      var _this4 = this;

      if (!this.searchQuery) {
        this.paginationProximo.total = this.hisAtenciones.length;
        return this.pagedDataSesionesRR;
      }
      var result = this.hisAtenciones.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(_this4.propsToSearch), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var key = _step4.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this4.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        return isIncluded;
      });
      this.paginationSesionesRR.total = result.length;
      return result.slice(this.fromSesionesRR, this.toSesionesRR);
    },
    toSesionesRR: function toSesionesRR() {
      var highBound = this.fromSesionesRR + this.paginationSesionesRR.perPage;
      if (this.totalSesionesRR < highBound) {
        highBound = this.totalSesionesRR;
      }
      return highBound;
    },
    fromSesionesRR: function fromSesionesRR() {
      return this.paginationSesionesRR.perPage * (this.paginationSesionesRR.currentPage - 1);
    },
    totalSesionesRR: function totalSesionesRR() {
      this.paginationSesionesRR.total = this.hisAtenciones.length;
      return this.hisAtenciones.length;
    }
  },
  data: function data() {
    return {
      searchQuery: "",
      fechaActual: "",
      fechaFin: "",
      paginationPendiente: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      paginationProximo: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      searchPaciente: "",
      paginationPacienteCargo: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      paginationSesionesRR: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      },
      propsToSearch: ["PacNom1", "PacApe1", "PacNumDoc", "PacFecNac", "PacFecIng"],
      ip: "https://avanti-erp.com/",
      pacientesCargo: [],
      objetivosProximos: [],
      objetivosPendientes: [],
      hisAtenciones: [],
      foto: "https://avanti-erp.com/" + localStorage.getItem("foto"),
      usuario: "",
      nombre: localStorage.getItem("nombre"),
      especialidad: '',

      fechaInicioHis: "",
      fechaFinHis: "",
      fechaProxima: '2025-11-12',
      fechaActualSeparada: '',
      nombreUsuario: '',
      card_dia: [{
        title: "SSP Sede",
        value: 0,
        icon: "fa fa-play",
        img: "static/img/ICONOS/consulta virtual.svg"
      }, {
        title: "SSP Domicilio",
        value: 0,
        icon: "fa fa-users",
        img: "static/img/ICONOS/familia.svg"
      }, {
        title: "SSP Totales",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSPP.svg"
      }],
      card_dia2: [{
        title: "SSR sede",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/consulta virtual.svg"
      }, {
        title: "SSR domicilio",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/AARR.svg"
      }, {
        title: "SSR Cancel.",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSCC.svg"
      }, {
        title: "SSR Totales",
        value: 0,
        icon: "fa fa-plus",
        img: "static/img/ICONOS/SSPP.svg"
      }],

      objetivosActivos: [],
      json_fieldsProximos: {
        Nombres: "PacNom1",
        Apellidos: "PacApe1",
        "Fecha objetivo": "ObjFec",
        "Fecha fin objetivo": "ObjFecCum",
        Objetivo: "ObjObj"
      },
      json_fieldsPacientes: {
        Nombres: "PacNom1",
        Apellidos: "PacApe1",
        "Numero Documento": "PacNumDoc",
        Edad: "Edad",
        Dx: "dx",
        "Terapeuta": 'Terapeuta',
        "Especialidad": 'Especialidad'
      },
      json_fieldsAtenciones: {
        Nombres: "PacNom1",
        Apellidos: "PacApe1",
        "Fecha de atención": "ProFec",
        hora: "hora",
        "hora fin": "horaFin",
        Lugar: "ProLug",
        "Tipo": "ProTip",
        "Valor": "ProValTer"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]]
    };
  },
  methods: {
    formatearPesosColombianos: __WEBPACK_IMPORTED_MODULE_15__global_services_formatear_pesos__["a" /* default */],
    getEvents: function getEvents() {
      var _this5 = this;

      var fechaF = this.fechamasdias(this.fechaActual);
      __WEBPACK_IMPORTED_MODULE_16_axios___default.a.get("https://www.googleapis.com/calendar/v3/calendars/" + localStorage.getItem("email") + "/events?key=AIzaSyCS6MXgvS2kJs7YaIkUfFGx2O1fI9BKuC0&timeMin=" + this.fechaActual + "T00:00:00-05:00&timeMax=" + fechaF + "T00:00:00-05:00&maxResults=100").then(function (res) {
        var datos = res.data.items;
        var domicilio = 0;
        var virtual = 0;
        datos.forEach(function (element) {
          var tuDate1 = new Date();
          var tuDate2 = new Date(element.start.dateTime);

          var a = new Date(tuDate1.getFullYear(), tuDate1.getMonth(), tuDate1.getDate());
          var b = new Date(tuDate2.getFullYear(), tuDate2.getMonth(), tuDate2.getDate());

          if (element.location) {
            if (+a == +b) {
              virtual = virtual + _this5.calcularMinutos(_this5.horaFormateada(element.start.dateTime), _this5.horaFormateada(element.end.dateTime));
            }
          } else {
            if (+a == +b) {
              domicilio = domicilio + _this5.calcularMinutos(_this5.horaFormateada(element.start.dateTime), _this5.horaFormateada(element.end.dateTime));
            }
          }
        });
        _this5.card_dia[1].value = domicilio;
        _this5.card_dia[0].value = virtual;
        _this5.card_dia[2].value = domicilio + virtual;
      }).catch(function (err) {
        console.log(err);
      });
    },
    horaFormateada: function horaFormateada(fecha) {
      var hora = new Date(fecha).getHours();
      var minutos = new Date(fecha).getMinutes();
      if (minutos == 0) {
        minutos = "00";
      }
      var horaFormateada = hora + ":" + minutos;
      return horaFormateada;
    },
    calcularMinutos: function calcularMinutos(inicio, fin) {
      var horaInicial = this.devolverMinutos(inicio);
      var horaFinal = this.devolverMinutos(fin);

      if (horaInicial < horaFinal) {
        var sesiones = (horaFinal - horaInicial) / 30;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc___default()(sesiones);
      } else {}
    },
    devolverMinutos: function devolverMinutos(horaMinutos) {
      return parseInt(horaMinutos.split(":")[0]) * 60 + parseInt(horaMinutos.split(":")[1]);
    },

    fechamasdias: function fechamasdias(fecha) {
      var fecha = new Date(fecha);
      fecha.setDate(fecha.getDate() + 10);


      var fechaFormateada = "";
      var ahora_ano = fecha.getFullYear();
      var ahora_mes = fecha.getMonth() + 1;
      var ahora_dia = fecha.getDate();
      if (ahora_mes < 10 || ahora_dia < 10) {
        if (ahora_mes < 10) {
          ahora_mes = "0" + ahora_mes;
        }
        if (ahora_dia < 10) {
          ahora_dia = "0" + ahora_dia;
        }
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      } else {
        fechaFormateada = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      }

      return fechaFormateada;
    },
    calcularFechaActual: function calcularFechaActual() {
      var fecha_hoy = new Date();

      var fecha_local = new Date(fecha_hoy.getTime() - fecha_hoy.getTimezoneOffset() * 60000);

      var ahora_ano = fecha_local.getFullYear();
      var ahora_mes = String(fecha_local.getMonth() + 1).padStart(2, "0");
      var ahora_dia = String(fecha_local.getDate()).padStart(2, "0");

      this.fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;
      console.log(this.fechaActual, "fecha actual");
      this.fechaFin = this.fechamasdias(this.fechaActual);
      this.fechaActualSeparada = this.obtenerMesYDia(this.fechaActual);
    },

    objetivosActivosFun: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var BASE_URL, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                this.$modal.show('carga');
                BASE_URL = this.ip + "api/objetivos-activos/" + localStorage.getItem("usuario");
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_16_axios___default.a.get(BASE_URL);

              case 5:
                response = _context.sent;

                this.objetivosActivos = response.data.data;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 12:
                _context.prev = 12;

                this.$modal.hide('carga');
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9, 12, 15]]);
      }));

      function objetivosActivosFun() {
        return _ref.apply(this, arguments);
      }

      return objetivosActivosFun;
    }(),
    pacientesCargoFun: function pacientesCargoFun() {
      var _this6 = this;

      var BASE_URL = this.ip + "api/pacientesCargo/" + localStorage.getItem("usuario") + "/" + localStorage.getItem("rol");
      __WEBPACK_IMPORTED_MODULE_16_axios___default.a.get(BASE_URL).then(function (res) {
        if (res.data.status == true) {
          var datos = res.data.data;
          var datos_f = [];
          _this6.pacientesCargo = res.data.data;
          for (var index = 0; index < datos.length; index++) {
            datos_f.push({
              PacApe1: datos[index].PacApe1,
              PacNom1: datos[index].PacNom1,
              PacFecNac: datos[index].PacFecNac,
              PacNumDoc: datos[index].PacNumDoc,
              Edad: _this6.calcularEdad(datos[index].PacFecNac),
              dx: datos[index].dx,
              Terapeuta: _this6.nombre,
              Especialidad: _this6.especialidad
            });

            _this6.pacientesCargo = datos_f;
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    hisSesiones: function hisSesiones() {
      var _this7 = this;

      var BASE_URL = this.ip + "api/hisSesiones/" + localStorage.getItem("usuario") + "/" + this.fechaInicioHis + "/" + this.fechaFinHis;
      __WEBPACK_IMPORTED_MODULE_16_axios___default.a.get(BASE_URL).then(function (res) {
        if (res.data.status == true) {
          _this7.hisAtenciones = res.data.data;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },

    hisSesionesHoy: function hisSesionesHoy() {
      var _this8 = this;

      var BASE_URL = this.ip + "api/hisSesionesHoy/" + localStorage.getItem("usuario") + "/" + localStorage.getItem("email") + "/" + this.fechaActual;
      __WEBPACK_IMPORTED_MODULE_16_axios___default.a.get(BASE_URL).then(function (res) {
        if (res.data.status == true) {
          _this8.card_dia2[0].value = res.data.terapiasV;
          _this8.card_dia2[1].value = res.data.terapiasD;
          _this8.card_dia2[2].value = res.data.terapiasC;
          _this8.card_dia2[3].value = res.data.terapiasV + res.data.terapiasD + res.data.terapiasC;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    calcularEdad: function calcularEdad(fecha) {
      var fechaNacimiento = fecha;
      var values = fechaNacimiento.split("-");
      var dia = values[2];
      var mes = values[1];
      var ano = values[0];

      var fecha_hoy = new Date();
      var ahora_ano = fecha_hoy.getFullYear();
      var ahora_mes = fecha_hoy.getMonth() + 1;
      var ahora_dia = fecha_hoy.getDate();

      var fechaActual = ahora_ano + "-" + ahora_mes + "-" + ahora_dia;


      var edad = ahora_ano + 0 - ano;
      if (ahora_mes < mes) {
        edad--;
      }
      if (mes == ahora_mes && ahora_dia < dia) {
        edad--;
      }
      if (edad > 1900) {
        edad -= 1900;
      }

      var meses = 0;
      if (ahora_mes > mes) meses = ahora_mes - mes;
      if (ahora_mes < mes) meses = 12 - (mes - ahora_mes);
      if (ahora_mes == mes && dia > ahora_dia) meses = 11;

      var dias = 0;
      if (ahora_dia > dia) dias = ahora_dia - dia;
      if (ahora_dia < dia) {
        var ultimoDiaMes = new Date(ahora_ano, ahora_mes - 1, 0);
        var dias = ultimoDiaMes.getDate() - (dia - ahora_dia);
      }

      return edad + " años y " + meses + " meses";
    },
    obtenerMesYDia: function obtenerMesYDia(fechaInput) {
      var mesesAbreviados = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];

      var fecha = new Date(fechaInput);

      if (isNaN(fecha)) {
        throw new Error("Fecha inválida");
      }

      var mes = mesesAbreviados[fecha.getMonth()];
      var dia = fecha.getDate() + 1;
      var year = fecha.getFullYear();

      return {
        mes: mes,
        dia: dia,
        year: year
      };
    },


    push: function push(route) {
      this.$router.push(route);
    }
  },
  mounted: function mounted() {
    this.calcularFechaActual();
    this.pacientesCargoFun();
    this.hisSesionesHoy();
    this.objetivosActivosFun();
    this.fechamasdias();
    this.nombreUsuario = localStorage.getItem("usuario");
    var rol = localStorage.getItem("rol");
    if (rol == 2) {
      this.usuario = "Fisioterapeuta";
      this.especialidad = 'Fisioterapia';
    } else if (rol == 3) {
      this.usuario = "Fonoaudiólogo";
      this.especialidad = 'Fonoaudiología';
    } else if (rol == 4) {
      this.usuario = "Terapeuta Ocupacional";
      this.especialidad = 'Terapia ocupacional';
    } else if (rol == 5) {
      this.usuario = "Terapeuta en educación especial";
      this.especialidad = 'Educación especial';
    } else {
      this.usuario = "Psicólogo";
      this.especialidad = 'Psicología';
    }
    document.title = "Avanti | Mi Espacio";
  }
});

/***/ }),

/***/ "v2o3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-pagination',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    pageCount: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    paginationClass: function paginationClass() {
      return 'pagination-' + this.type;
    },
    totalPages: function totalPages() {
      if (this.pageCount > 0) return this.pageCount;
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage);
      }
      return 1;
    },
    pagesToDisplay: function pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages;
      }
      return this.defaultPagesToDisplay;
    },
    minPage: function minPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage > this.totalPages) {
          return this.totalPages - this.pagesToDisplay + 1;
        }
        return this.value - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage: function maxPage() {
      if (this.value >= this.pagesToDisplay) {
        var pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        var newMaxPage = pagesToAdd + this.value;
        if (newMaxPage < this.totalPages) {
          return newMaxPage;
        } else {
          return this.totalPages;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  data: function data() {
    return {
      defaultPagesToDisplay: 5
    };
  },

  methods: {
    range: function range(min, max) {
      var arr = [];
      for (var i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    changePage: function changePage(item) {
      this.$emit('input', item);
    },
    nextPage: function nextPage() {
      if (this.value < this.totalPages) {
        this.$emit('input', this.value + 1);
      }
    },
    prevPage: function prevPage() {
      if (this.value > 1) {
        this.$emit('input', this.value - 1);
      }
    }
  },
  watch: {
    perPage: function perPage(value) {
      this.$emit('input', 1);
    },
    total: function total(value) {
      this.$emit('input', 1);
    }
  }
});

/***/ }),

/***/ "v8QE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d33c3cd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("FZq3");
function injectStyle (ssrContext) {
  __webpack_require__("fKYh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d33c3cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d33c3cd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vl8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"row"},[_c('center',[(_vm.queriedData2 == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e()])],1),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row",staticStyle:{"padding-left":"15px"}},[_c('div',{staticClass:"col-3"},[_c('el-select',{staticClass:"select-default",attrs:{"placeholder":"Per page"},model:{value:(_vm.pagination.perPage),callback:function ($$v) {_vm.$set(_vm.pagination, "perPage", $$v)},expression:"pagination.perPage"}},_vm._l((_vm.pagination.perPageOptions),function(item){return _c('el-option',{key:item,staticClass:"select-default",attrs:{"label":item,"value":item}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{ref:"component",staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill mb-2",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"Informe de autorizaciones","name":"Informe de autorizaciones"}},[_vm._v("\n            Exportar a excel "),_c('i',{staticClass:"fa fa-download",attrs:{"color":"black"}})]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('br'),_vm._v(" "),_c('el-table',{staticClass:"table-responsive table-striped mt-2",attrs:{"border":"","data":_vm.queriedData}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,staticStyle:{"height":"35px !important"},attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return [_c('div',{staticClass:"full-width",class:_vm.getClass(column, row)},[(_vm.getClass(column, row) != '')?_c('strong',[_vm._v(_vm._s(row[column.prop]))]):_c('span',[_vm._v(_vm._s(row[column.prop]))])])]}}],null,true)})}),1)],1)]):_vm._e(),_vm._v(" "),(_vm.queriedData2 != '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 pagination-info"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v("\n            Showing "+_vm._s(_vm.from + 1)+" to "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total)+" entries\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('p-pagination',{staticClass:"pull-right",attrs:{"per-page":_vm.pagination.perPage,"total":_vm.pagination.total},model:{value:(_vm.pagination.currentPage),callback:function ($$v) {_vm.$set(_vm.pagination, "currentPage", $$v)},expression:"pagination.currentPage"}})],1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',[_vm._v("Informe de autorizaciones")]),_vm._v(" "),_c('p',[_vm._v("\n            El sistema le mostrará las\n            "),_c('span',{staticClass:"text-success"},[_vm._v("Autorizaciones")]),_vm._v("\n            activas a la fecha que no tengan la bolsa en 0\n          ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w0tS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w7CO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"inicial"}},[_vm._v("Fecha incial:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicial),expression:"fechaInicial"}],staticClass:"form-control",attrs:{"type":"date","max":_vm.fechaActual,"id":"inicial"},domProps:{"value":(_vm.fechaInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicial=$event.target.value}}}),_vm._v(" "),(_vm.fechaInicial == '')?_c('small',{staticClass:"text-danger"},[_vm._v("Este campo es requerido")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":"final"}},[_vm._v("Fecha final:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinal),expression:"fechaFinal"}],staticClass:"form-control",attrs:{"type":"date","max":_vm.fechaActual,"id":"final"},domProps:{"value":(_vm.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinal=$event.target.value}}}),_vm._v(" "),(_vm.fechaFinal == '')?_c('small',{staticClass:"text-danger"},[_vm._v("Este campo es requerido")]):_vm._e()]),_vm._v(" "),(_vm.rol == 1)?_c('div',{staticClass:"col-md-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Sede:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sede),expression:"sede"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sede=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.SedesProgramacion),function(sede){return _c('option',{key:sede.sede,domProps:{"value":sede.sede}},[_vm._v(" "+_vm._s(sede.sede)+" ")])}),0),_vm._v(" "),(_vm.sede == '')?_c('small',{staticClass:"text-danger"},[_vm._v("Este campo es requerido")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("fff")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill btn-block",attrs:{"disabled":_vm.fechaInicial == '' || _vm.fechaFinal == '' || _vm.sede == ''},on:{"click":function($event){return _vm.getProgramacion()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Buscar programación\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('label',{staticStyle:{"color":"white"},attrs:{"for":""}},[_vm._v("fff")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.json_data != '')?_c('download-excel',{staticClass:"btn btn-secondary btn-fill",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"worksheet":"My Worksheet","name":'Reporte-cancelaciones' + '-' + _vm.fechaInicial + '-' + '-' + _vm.fechaFinal}},[_vm._v("\n            Exportar a excel\n          ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('center',[(_vm.queriedData == '')?_c('div',{staticClass:"col-md-12"},[_c('center',[_c('img',{attrs:{"src":"/static/img/ICONOS/estadisticas.svg","alt":"Imagen de datos vacios","width":"70"}}),_vm._v(" "),_c('p',{staticClass:"titulo-mensaje"},[_vm._v("Aún no hay datos para mostrar.")])])],1):_vm._e()])],1),_vm._v(" "),(_vm.queriedData != '')?_c('div',{ref:"component",staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('el-table',{staticClass:"table-responsive",attrs:{"border":"","data":_vm.queriedData,"size":"mini"}},_vm._l((_vm.tableColumns),function(column){return _c('el-table-column',{key:column.label,attrs:{"min-width":column.minWidth,"prop":column.prop,"label":column.label}})}),1)],1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1"},[_c('i',{staticClass:"fa fa-calendar",staticStyle:{"font-size":"60px","color":"grey"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-11"},[_c('h4',{staticClass:"title-card"},[_vm._v("Reporte de cancelaciones")]),_vm._v(" "),_c('small',[_vm._v("Reporte de la programación de avanti ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wCHw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wFyH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wOc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['dataRows', 'colums'],
  data: function data() {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50, 100, 200, 300],
        total: 0
      }
    };
  },

  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedData: function pagedData() {
      return this.dataRows.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.dataRows.length;
        return this.pagedData;
      }
      var result = this.dataRows.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.dataRows.length;
      return this.dataRows.length;
    }
  }
});

/***/ }),

/***/ "wQaI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticStyle:{"border-radius":"10px"},attrs:{"name":"informacion-paciente-dashboard","height":"700px","clickToClose":false}},[_c('div',[_c('div',{staticClass:"header-custom"},[_c('div',[_c('span',[_vm._v("Información completa del paciente")])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-simple btn-danger",on:{"click":function($event){return _vm.$modal.hide('informacion-paciente-dashboard')}}},[_c('i',{staticClass:"fa fa-close"})])])]),_vm._v(" "),_c('div',{staticClass:"content-custom"},[_c('div',{staticClass:"paciente-information"},[_c('div',{staticClass:"paciente-information-footer"},[_c('img',{staticStyle:{"border-radius":"10px","object-fit":"cover"},attrs:{"src":_vm.url + _vm.paciente.foto,"alt":"foto paciente","width":"100","height":"100"}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.paciente.nombres + ' ' + _vm.paciente.apellidos))])]),_vm._v(" "),_c('div',{staticClass:"paciente-information-content"},[_c('div',[_c('span',{staticStyle:{"font-weight":"500","font-size":"16px"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Identificación")])]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('span',[_vm._v("Tipo de documento: "+_vm._s(_vm.paciente.tipo_documento))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Número de documento: "+_vm._s(_vm.paciente.documento))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"paciente-information-content"},[_c('div',[_c('span',{staticStyle:{"font-weight":"500","font-size":"16px"}},[_c('i',{staticClass:"fa fa-folder"}),_vm._v(" Afiliación ")])]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('span',[_vm._v("Regimen: "+_vm._s(_vm.paciente.regimen == 1 ? 'Contributivo' : 'Subsidiado'))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("EPS: "+_vm._s(_vm.paciente.eps))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Prepagada: "+_vm._s(_vm.paciente.prepagada))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Poliza: "+_vm._s(_vm.paciente.poliza))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"paciente-information-content"},[_c('div',[_c('span',{staticStyle:{"font-weight":"500","font-size":"16px"}},[_c('i',{staticClass:"fa fa-phone"}),_vm._v(" Residencia y contacto")])]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('span',[_vm._v("Teléfono: "+_vm._s(_vm.paciente.telefono))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Dirección: "+_vm._s(_vm.paciente.direccion))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Correo electrónico: "+_vm._s(_vm.paciente.correo))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Nombre del acudiente: "+_vm._s(_vm.paciente.acudiente))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Teléfono del acudiente: "+_vm._s(_vm.paciente.numeroAcudiente))])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wcWk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "whLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Dashboard Pacientes")]),_vm._v(" "),_c('p',[_vm._v("Bienvenido al dashboard de pacientes.")]),_vm._v(" "),_c('div',{staticClass:"card",staticStyle:{"padding":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",attrs:{"id":"form-search-patient"}},[_c('div',{staticClass:"row"},[_c('form',{staticClass:"row",staticStyle:{"width":"100%","margin":"0","padding":"10px"},on:{"submit":function($event){$event.preventDefault();return _vm.getInformation.apply(null, arguments)}}},[_c('div',{staticClass:"col-md-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.paciente),expression:"paciente"}],staticClass:"form-control",attrs:{"name":"paciente","id":"paciente","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.paciente=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":"","selected":""}},[_vm._v("Seleccione un paciente")]),_vm._v(" "),_vm._l((_vm.pacientes),function(paciente){return _c('option',{key:paciente.PacIdeUsu,domProps:{"value":paciente.PacIdeUsu}},[_vm._v("\n                  "+_vm._s(paciente.PacNom1)+" "+_vm._s(paciente.PacApe1)+"\n                ")])})],2)]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"row"})])])]),_vm._v(" "),(_vm.basic_information !== null)?_c('div',{},[_c('modalPaciente',{attrs:{"paciente":_vm.basic_information}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"card card-user",on:{"click":function($event){return _vm.mostrarModalPaciente()}}},[_c('div',{staticClass:"contentt"},[_c('div',{staticClass:"img-user"},[_c('img',{attrs:{"src":_vm.url + _vm.basic_information.foto,"alt":""}})]),_vm._v(" "),_c('div',[_c('span',{staticClass:"title-name-paciente"},[_vm._v(_vm._s(_vm.basic_information.nombres)+"\n                "+_vm._s(_vm.basic_information.apellidos))]),_vm._v(" "),_c('p',[_c('span',{staticClass:"information-paciente"},[_vm._v("Nació el\n                  "),_c('span',{staticClass:"information"},[_vm._v(_vm._s(_vm._f("date")(_vm.basic_information.fecha_nacimiento)))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"information-paciente"},[_vm._v("Identificación\n                  "),_c('span',{staticClass:"information"},[_vm._v(_vm._s(_vm.basic_information.documento))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"information-paciente"},[_vm._v("Régimen\n                  "),_c('span',{staticClass:"information"},[_vm._v(_vm._s(_vm.basic_information.regimen == 1
                      ? "Contributivo"
                      : "Subsidiado"))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"information-paciente"},[_vm._v("Diagnosticado con\n                  "),_c('span',{staticClass:"information"},[_vm._v(_vm._s(_vm.basic_information.diagnostico))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"card-calendar"},[_c('div',{staticClass:"mes"},[_vm._v("\n            "+_vm._s(_vm.fechaAultimaAtencion.mes.toUpperCase())+", "+_vm._s(_vm.fechaAultimaAtencion.year)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"dia"},[_vm._v("\n            "+_vm._s(_vm.fechaAultimaAtencion.dia)+"\n          ")]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card-servicios"},[_c('div',{staticClass:"informacion",staticStyle:{"flex":"3"}},[_c('span',{staticClass:"titulo"},[_vm._v("ORDENES Y AUTORIZACIONES")]),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"normal-text"},[_vm._v(_vm._s(_vm.bolsaTotal)+" sesiones disponibles")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"normal-text"},[_vm._v(_vm._s(_vm.autorizacionesActivas.length)+" autorizaciones")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"normal-text"},[_vm._v(_vm._s(_vm.ordenesActivas.length)+" ordenes")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.indicadorAutorizacion)?_c('span',{staticClass:"indicador-lugar"},[_vm._v("Autorización próxima a vencer")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.bolsaTotal < 15)?_c('span',{staticClass:"indicador-lugar"},[_vm._v("La bolsa se está agotando")]):_vm._e()]),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"card-eventos"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"content-events"},_vm._l((_vm.ultimas_sesiones),function(evento){return _c('div',{staticClass:"evento"},[_vm._m(4,true),_vm._v(" "),_c('div',{staticStyle:{"flex":"4"}},[_c('span',{staticClass:"titulo-evento"},[_vm._v(_vm._s(_vm._f("date")(evento.fecha)))]),_vm._v(", "+_vm._s(evento.hora)+" - "+_vm._s(evento.horaFin)+" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"normal-text"},[_vm._v(_vm._s(evento.nombres)+" "+_vm._s(evento.apellidos))])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('span',{staticClass:"indicador-lugar"},[_vm._v(_vm._s(evento.lugar))])])])}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"card-eventos"},[_vm._m(5),_vm._v(" "),(_vm.proximas_sesiones.length > 0)?_c('div',{staticClass:"content-events"},_vm._l((_vm.proximas_sesiones),function(evento){return _c('div',{staticClass:"evento"},[_vm._m(6,true),_vm._v(" "),_c('div',{staticStyle:{"flex":"4"}},[_c('span',{staticClass:"titulo-evento"},[_vm._v(_vm._s(_vm._f("date")(evento.fecha)))]),_vm._v(", "+_vm._s(evento.hora)+" - "+_vm._s(evento.horaFin)+" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"normal-text"},[_vm._v(_vm._s(evento.nombres)+" "+_vm._s(evento.apellidos))])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('span',{staticClass:"indicador-lugar"},[_vm._v(_vm._s(evento.lugar))])])])}),0):_c('div',[_c('center',[_c('span',{staticClass:"normal-text"},[_vm._v(_vm._s(_vm.MESSAGES.NO_DATA_FOUND))])])],1)]),_vm._v(" "),_c('div',{staticClass:"card-recomendacion"},[_c('div',[_c('span',{staticClass:"titulo"},[_vm._v("Recomendación terapeutica")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"normal-text",staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(_vm.recomendacion[0].recomendacion))])])]),_vm._v(" "),_c('div',{staticClass:"card-lideres"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"content-lideres"},[_c('div',{staticClass:"card-lider"},[_c('span',{staticClass:"titulo-lider"},[_vm._v(_vm._s(_vm.basic_information.lider_fisio != null ? _vm.basic_information.lider_fisio : 'No asignado'))]),_vm._v(" "),_c('span',{staticClass:"normal-text"},[_vm._v("Lider fisioterapeuta")])]),_vm._v(" "),_c('div',{staticClass:"card-lider"},[_c('span',{staticClass:"titulo-lider"},[_vm._v(_vm._s(_vm.basic_information.lider_teo != null ? _vm.basic_information.lider_teo : 'No asignado'))]),_vm._v(" "),_c('span',{staticClass:"normal-text"},[_vm._v("Lider Terapia Ocupacional")])]),_vm._v(" "),_c('div',{staticClass:"card-lider"},[_c('span',{staticClass:"titulo-lider"},[_vm._v(_vm._s(_vm.basic_information.lider_fono != null ? _vm.basic_information.lider_fono : 'No asignado'))]),_vm._v(" "),_c('span',{staticClass:"normal-text"},[_vm._v("Lider fonoaudiología")])]),_vm._v(" "),_c('div',{staticClass:"card-lider"},[_c('span',{staticClass:"titulo-lider"},[_vm._v(_vm._s(_vm.basic_information.lider_psico != null ? _vm.basic_information.lider_psico : 'No asignado'))]),_vm._v(" "),_c('span',{staticClass:"normal-text"},[_vm._v("Lider psicología")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card-evoluciones"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"filtro"},[_c('form',{staticStyle:{"display":"flex","gap":"10px","margin-top":"20px","align-items":"flex-end"},on:{"submit":function($event){$event.preventDefault();return _vm.getEvoluciones.apply(null, arguments)}}},[_c('div',{staticStyle:{"flex":"2"}},[_c('label',{staticClass:"form-label-evoluciones",attrs:{"for":"fecha-inicial"}},[_vm._v("Fecha inicial")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaInicialEvoluciones),expression:"fechaInicialEvoluciones"}],staticClass:"form-control input-lg",attrs:{"type":"date","id":"fecha-inicial","placeholder":"dd/mm/aaaa"},domProps:{"value":(_vm.fechaInicialEvoluciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaInicialEvoluciones=$event.target.value}}})]),_vm._v(" "),_c('div',{staticStyle:{"flex":"2"}},[_c('label',{staticClass:"form-label-evoluciones",attrs:{"for":"fecha-final"}},[_vm._v("Fecha final")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fechaFinalEvoluciones),expression:"fechaFinalEvoluciones"}],staticClass:"form-control input-lg",attrs:{"type":"date","id":"fecha-final","placeholder":"dd/mm/aaaa"},domProps:{"value":(_vm.fechaFinalEvoluciones)},on:{"input":function($event){if($event.target.composing){ return; }_vm.fechaFinalEvoluciones=$event.target.value}}})]),_vm._v(" "),_vm._m(9)])]),_vm._v(" "),_c('div',{staticClass:"information-evoluciones"},_vm._l((_vm.evoluciones),function(evolucion){return _c('div',{staticClass:"card-evolucion"},[_c('span',{staticClass:"titulo-evolucion"},[_vm._v(_vm._s(evolucion.terapeuta)+", "+_vm._s(_vm._f("date")(evolucion.fecha)))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"texto-evolucion"},[_vm._v(_vm._s(evolucion.evolucion))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])}),0)]),_vm._v(" "),_c('div',{staticClass:"card-programaciones-information"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"content-informacion-programaciones"},[_c('div',{staticClass:"informacion-estadisticas"},[_c('span',{staticClass:"card-detalle-sesiones"},[_c('i',{staticClass:"fa fa-circle",staticStyle:{"color":"blue"}}),_vm._v(" "+_vm._s(_vm.programaciones.total)+" sesiones programadas\n              ")]),_vm._v(" "),_c('span',{staticClass:"card-detalle-sesiones"},[_c('i',{staticClass:"fa fa-circle",staticStyle:{"color":"green"}}),_vm._v(" "+_vm._s(_vm.programaciones.Atendidas)+" sesiones cumplidas\n              ")]),_vm._v(" "),_c('span',{staticClass:"card-detalle-sesiones"},[_c('i',{staticClass:"fa fa-circle",staticStyle:{"color":"red"}}),_vm._v(" "+_vm._s(_vm.programaciones.Canceladas)+" sesiones canceladas\n              ")]),_vm._v(" "),_c('span',{staticClass:"card-detalle-sesiones"},[_c('i',{staticClass:"fa fa-circle",staticStyle:{"color":"orange"}}),_vm._v(" "+_vm._s(_vm.programaciones.SinAtencion)+" sesiones sin atención\n              ")])]),_vm._v(" "),_c('div',{staticClass:"grafica-estadisticas"},[_c('div',{ref:"chart",staticClass:"chart-circle2",attrs:{"data-percent":_vm.programaciones.porcentajeCumplimiento}},[_c('span',{staticClass:"text-chart"},[_vm._v("\n                  "+_vm._s(_vm.programaciones.porcentajeCumplimiento)+"%\n                ")])]),_vm._v(" "),_c('small',[_vm._v("Porcentaje de cumplimiento")])])])])])])],1):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"7px"},attrs:{"type":"submit"}},[_vm._v("\n                Buscar información "),_c('i',{staticClass:"fa fa-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"normal-text"},[_vm._v("Ultima atención")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grafica",staticStyle:{"flex":"2"}},[_c('i',{staticClass:"fa fa-folder",staticStyle:{"font-size":"150px","color":"#e3117db8"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"30px"}},[_c('span',{staticClass:"titulo"},[_vm._v("Últimas sesiones realizadas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-circle",staticStyle:{"color":"green"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-bottom":"30px"}},[_c('span',{staticClass:"titulo"},[_vm._v("Próximas sesiones")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-circle",staticStyle:{"color":"blue"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"titulo"},[_vm._v("Lideres terapeuticos")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"normal-text"},[_vm._v("Lideres asignados al paciente, puedes actualizarlos en el modulo de pacientes registrados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"titulo"},[_vm._v("Evoluciones del paciente")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"normal-text"},[_vm._v("Busca evoluciones registradas al paciente en las fechas\n              seleccionadas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"flex":"1"}},[_c('button',{staticClass:"btn btn-success btn-lg btn-fill",staticStyle:{"border-radius":"7px"}},[_vm._v("\n                  Buscar información "),_c('i',{staticClass:"fa fa-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"titulo"},[_vm._v("Estadisticas de asistencia")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wiHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x/a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "circle-chart-card",
  props: {
    color: {
      type: String,
      default: "blue"
    },
    bar: {
      type: String,
      default: "#b8d8d8"
    },
    confidencial: {
      type: Boolean,
      default: false
    },
    percentage: "",
    pendiente: {
      type: Boolean,
      default: false
    },
    pendienteEvaluar: "",
    title: String,
    description: String
  },
  data: function data() {
    return {
      chartId: "no-id",
      chart: null
    };
  },

  methods: {
    updateChartId: function updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = "div_" + randomInt;
    },
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    renderChart: function renderChart(EasyPieChart) {
      this.chart = new EasyPieChart(this.$refs.chart, {
        lineWidth: 10,
        size: 160,
        scaleColor: false,
        trackColor: "rgba(255,255,255,.25)",
        barColor: this.bar,
        animate: { duration: 1000, enabled: true }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var EasyPieChart;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.updateChartId();
              _context.next = 3;
              return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "PeU/"));

            case 3:
              EasyPieChart = _context.sent;

              _this.renderChart(EasyPieChart);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    percentage: function percentage(newVal) {
      if (this.chart) {
        this.chart.update(newVal);
      }
    }
  }
});

/***/ }),

/***/ "x2Ph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('button',{staticClass:"btn btn-success btn-fill",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.abrirModal()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Ingreso de servicio\n        ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('ordenes')],1),_vm._v(" "),_c('div')])]),_vm._v(" "),_c('modal',{attrs:{"name":"ingreso_servicio","id":"modal","height":"80%","width":"900px","scrollable":true,"reset":true,"clickToClose":false}},[_c('div',[_c('div',[_c('div',{staticClass:"card-header"},[_c('div',[_c('span',{staticStyle:{"font-size":"17px","font-weight":"500"}},[_vm._v("Ingreso de servicios")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-simple btn-icon",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.cerrarModal()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body scroll-gg"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"tipoCliente"}},[_vm._v("Tipo de cliente")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tipoCliente),expression:"tipoCliente"}],staticClass:"form-control",attrs:{"id":"tipoCliente"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tipoCliente=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.asignarTipoCliente()}]}},[_c('option',{attrs:{"value":"6"}},[_vm._v("EPS")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Prepagada")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Póliza")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Particular")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.tipoCliente == 6)?_c('div',[_c('eps',{attrs:{"modal":_vm.modalRegistrar}})],1):_vm._e(),_vm._v(" "),(_vm.tipoCliente == 7)?_c('div',[_c('prepagada')],1):_vm._e(),_vm._v(" "),(_vm.tipoCliente == 8)?_c('div',[_c('poliza')],1):_vm._e(),_vm._v(" "),(_vm.tipoCliente == 2)?_c('div',[_c('particular')],1):_vm._e(),_vm._v(" "),(_vm.tipoCliente == 3)?_c('div',[_c('convenio')],1):_vm._e()]),_vm._v(" "),_c('br')])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-11"},[_c('h4',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n              Buscar Ordenes y Autorizaciones\n            ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"-15px","color":"grey","font-weight":"500","font-size":"15px"}},[_vm._v("\n              Registro y busqueda de servicios\n            ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xH8E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");















__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rolActivo: [],
      permisosRolVar: [],

      nombre: '',
      ip: "https://avanti-erp.com/",
      tableColumns: [{
        prop: "nombre",
        label: "Nombre del rol",
        minWidth: 170 }],
      queriedData: [],
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      }
    };
  },
  methods: {
    roles: function roles() {
      var _this = this;

      var token = localStorage.getItem("token");
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.request({
        method: "get",
        baseURL: this.ip + "api/roles",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this.queriedData = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    update: function update(permiso) {
      var _this2 = this;

      var BASE_URL = this.ip + "api/updatePermiso";
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.put(BASE_URL, {
        id: permiso.id,
        estado: permiso.estado
      }).then(function (res) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this2.$notify({
          component: {
            template: " <div style=\"padding: 3%;\">\n              <span><b> " + res.data.mensaje + " </b>.</span>\n              </div>\n              "
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this2.type["success"]
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    abrirModal: function abrirModal(rol) {
      this.$modal.show("gestionar");

      this.rolActivo = rol;
      this.permisosRol(rol.id);
    },
    permisosRol: function permisosRol(rol) {
      var _this3 = this;

      var BASE_URL = this.ip + "api/verPermisos/" + rol;
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.get(BASE_URL).then(function (res) {
        _this3.permisosRolVar = res.data.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    cerrarModal: function cerrarModal() {
      this.$modal.hide("gestionar");
    },
    nuevoRol: function nuevoRol() {
      var _this4 = this;

      var BASE_URL = this.ip + "api/roles/nuevo";
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(BASE_URL, {
        nombre: this.nombre
      }, config).then(function (res) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this4.$notify({
          component: {
            template: " <div style=\"padding: 3%;\">\n              <span><b> ROL CREADO CON \xC9XITO </b>.</span>\n              </div>\n              "
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this4.type["success"]
        });

        _this4.roles();
        _this4.nombre = "";
      }).catch(function (error) {
        console.log(err);
        _this4.roles();
      });
    },
    desactivar: function desactivar() {
      var _this5 = this;

      var rol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var BASE_URL = this.ip + "api/roles/desactivar";
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.put(BASE_URL, {
        id: rol.id
      }, config).then(function (res) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this5.$notify({
          component: {
            template: " <div style=\"padding: 3%;\">\n              <span><b> ROL INHABILITADO CON \xC9XITO </b>.</span>\n              </div>\n              "
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this5.type["success"]
        });

        _this5.roles();
      }).catch(function (err) {
        console.log(err);
        alert("Ocurrió un error, intentelo de nuevo");
      });
    },
    activar: function activar() {
      var _this6 = this;

      var rol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var BASE_URL = this.ip + "api/roles/activar";
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.put(BASE_URL, {
        id: rol.id
      }, config).then(function (res) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this6.$notify({
          component: {
            template: " <div style=\"padding: 3%;\">\n              <span><b> ROL HABILITADO CON \xC9XITO </b>.</span>\n              </div>\n              "
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this6.type["success"]
        });

        _this6.roles();
      }).catch(function (err) {
        console.log(err);
        alert("Ocurrió un error, intentelo de nuevo");
      });
    }
  },
  mounted: function mounted() {
    this.roles();
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

__webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "x36W"));
__webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "p4sG"));

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      events: ["click", "mousemove", "scroll", "keypress", "load"],

      warningTimer: null,
      logoutTimer: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    document.body.classList.toggle("sidebar-mini");
    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);

    window.addEventListener('storage', function (e) {
      _this.cerrarSesion();
    }, this);

    this.setTimers();
  },

  methods: {
    setTimers: function setTimers() {
      this.warningTimer = setTimeout(this.warningMessage, 900000);
    },

    cerrarSesion: function cerrarSesion() {
      if (this.$router.currentRoute.path != "/login") {
        localStorage.removeItem("token");
        localStorage.removeItem("usuario");
        localStorage.removeItem("rol");
        localStorage.removeItem("foto");
        localStorage.removeItem("email");
        localStorage.removeItem("nombre");
        this.$router.push("/");
      }
    },

    warningMessage: function warningMessage() {
      if (this.$router.currentRoute.path != "/login") {
        alert("Hemos cerrado la sesión por inactividad, click en aceptar");
        localStorage.removeItem("token");
        localStorage.removeItem("usuario");
        localStorage.removeItem("rol");
        localStorage.removeItem("foto");
        localStorage.removeItem("email");
        localStorage.removeItem("nombre");
        this.$router.push("/");
      }
    },

    resetTimer: function resetTimer() {
      clearTimeout(this.warningTimer);
      this.setTimers();
    }
  }
});

/***/ }),

/***/ "xMf4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformeEvolucion_vue__ = __webpack_require__("pU/z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d127992e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformeEvolucion_vue__ = __webpack_require__("eLRN");
function injectStyle (ssrContext) {
  __webpack_require__("L4l+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d127992e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformeEvolucion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d127992e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformeEvolucion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xSGn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_vm._m(0),_vm._v(" "),_c('drop-down',{attrs:{"tag":"li","title":"5 Notificaitons","icon":"ti-bell"}},[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"slot":"title","href":"javascript:void(0)","data-toggle":"dropdown"},slot:"title"},[_c('i',{staticClass:"ti-bell"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5")]),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Notifications\n        "),_c('b',{staticClass:"caret"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 1")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 2")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 3")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Notification 4")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Another notification")])])]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"dropdown-toggle btn-magnify",attrs:{"href":"javascript:void(0)","data-toggle":"dropdown"}},[_c('i',{staticClass:"ti-panel"}),_vm._v(" "),_c('p',[_vm._v("Stats")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticClass:"btn-rotate",attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"ti-settings"}),_vm._v(" "),_c('p',{staticClass:"hidden-md hidden-lg"},[_vm._v("\n        Settings\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xuNr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ordenes_vue__ = __webpack_require__("SzsE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30c10bb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ordenes_vue__ = __webpack_require__("+g8l");
function injectStyle (ssrContext) {
  __webpack_require__("6HyH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ordenes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30c10bb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ordenes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xwzm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ingresoServicios_vue__ = __webpack_require__("3efL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395bb02a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ingresoServicios_vue__ = __webpack_require__("x2Ph");
function injectStyle (ssrContext) {
  __webpack_require__("esqW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-395bb02a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ingresoServicios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395bb02a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ingresoServicios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y6op":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_switches__ = __webpack_require__("lqen");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      c90: false,
      formato: 1,
      criterio: "PacApe1",
      buscar: true,
      arrayPacientes: [],
      busqueda: "",
      ip: "https://avanti-erp.com/",
      nombre: "",
      documento: "",
      pacIde: "",
      alertTipoCliente: false,
      numeroOrden: "",
      eps: "",
      cobertura: "",
      observaciones: '',
      regimen: 1,
      fechaExpedicion: "",
      fechaVencimiento: "",
      arrayCantidad: [],
      arrayEspecialidad: [],
      cantidad: "",
      bolsa: 0,
      epsCod: "",
      especialidad: "",
      arrayOrdenes: [],
      tablaOrden: false,
      numeroAutorizacion: "",
      fechaExpedicionAutorizacion: "",
      coberturaAutorizacion: "",
      arrayPoliza: [],
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      sinOrden: false
    };
  },

  components: {
    Switches: __WEBPACK_IMPORTED_MODULE_1_vue_switches__["a" /* default */]
  },
  methods: {
    eliminarServicio: function eliminarServicio(index, fila) {
      this.arrayCantidad.splice(index, 1);
      this.bolsa = this.bolsa - parseInt(fila.cantidad);
      console.log('Bolsa', this.bolsa);
    },
    buscarPacientes: function buscarPacientes() {
      var _this = this;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      this.arrayPacientes = [];
      var vm = this;
      var url = this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        vm.arrayPacientes = response.data.data;
        _this.buscar = false;
        console.log(response.data.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    seleccionarPaciente: function seleccionarPaciente(paciente) {
      var _this2 = this;

      if (paciente.TipCliCod != localStorage.getItem("tipoClienteIngreso")) {
        var alerta = confirm('El tipo de cliente de este paciente, no concuerta con el modulo seleccionado, ¿desea continuar?');
        if (alerta == true) {
          this.buscar = true;
          this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
          this.documento = paciente.PacNumDoc;
          this.pacIde = paciente.PacIdeUsu;
          this.alertTipoCliente = true;

          setTimeout(function () {
            _this2.cargarOrdenes();
          }, 1000);
        }
      } else {
        this.buscar = true;
        this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
        this.documento = paciente.PacNumDoc;
        this.pacIde = paciente.PacIdeUsu;
        this.alertTipoCliente = false;

        setTimeout(function () {
          _this2.cargarOrdenes();
        }, 1000);
      }
    },
    generarCodigo: function generarCodigo() {
      this.numeroOrden = "POL-" + this.pacIde + "-" + this.fechaExpedicion;
    },
    selectEspecialidad: function selectEspecialidad() {
      var _this3 = this;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/selectEspecialidad";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data.data;
        _this3.arrayEspecialidad = respuesta;
      }).catch(function (error) {
        console.log(error);
      });
    },
    agregarServicios: function agregarServicios() {
      if (this.especialidad != "" && this.cantidad != "") {
        this.arrayCantidad.push({
          servicio: this.especialidad,
          cantidad: this.cantidad
        });

        this.bolsa = parseInt(this.bolsa) + parseInt(this.cantidad);

        this.cantidad = "";
        this.especialidad = "";
      }
    },
    cargarOrdenes: function cargarOrdenes() {
      var _this4 = this;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/cargarOrdenesActivas/" + this.pacIde + "/poliza";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        _this4.arrayOrdenes = response.data.data;

        _this4.tablaOrden = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    seleccionarOrden: function seleccionarOrden(orden) {
      this.tablaOrden = false;
      this.numeroOrden = orden.OrdCod;
      this.eps = orden.EpsNom;
      this.fechaExpedicion = orden.OrdFec;
      this.fechaVencimiento = orden.OrdVen;
      this.numeroAutorizacion = "POL-AUT-" + this.pacIde;
      this.epsCod = orden.CodEnt;
    },
    selectPoliza: function selectPoliza() {
      var _this5 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      var url = this.ip + "/api/selectPoliza";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data;
        _this5.arrayPoliza = respuesta.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    calcularFecha: function calcularFecha() {
      var dias = parseInt(this.cobertura);
      var fechaInicio = new Date(this.fechaExpedicion);
      fechaInicio.setDate(fechaInicio.getDate() + dias);

      var fechaFin = new Date(fechaInicio);

      var dia = fechaFin.getDate();
      var mes = fechaFin.getMonth() + 1;
      var ano = fechaFin.getFullYear();
      var cero = "0";
      if (mes < 10 || dia < 10) {
        if (mes < 10) {
          mes = "0" + mes;
        }
        if (dia < 10) {
          dia = "0" + dia;
        }

        this.fechaVencimiento = ano + "-" + mes + "-" + dia;
      } else {
        this.fechaVencimiento = ano + "-" + mes + "-" + dia;
      }
    },
    calcularFechaAutorizacion: function calcularFechaAutorizacion() {
      var dias = parseInt(this.coberturaAutorizacion);
      var fechaInicio = new Date(this.fechaExpedicionAutorizacion);
      fechaInicio.setDate(fechaInicio.getDate() + dias);

      var fechaFin = new Date(fechaInicio);

      var dia = fechaFin.getDate();
      var mes = fechaFin.getMonth() + 1;
      var ano = fechaFin.getFullYear();
      var cero = "0";
      if (mes < 10 || dia < 10) {
        if (mes < 10) {
          mes = "0" + mes;
        }
        if (dia < 10) {
          dia = "0" + dia;
        }

        this.fechaVencimientoAutorizacion = ano + "-" + mes + "-" + dia;
      } else {
        this.fechaVencimientoAutorizacion = ano + "-" + mes + "-" + dia;
      }
    },
    nuevaOrdenMedica: function nuevaOrdenMedica() {
      var _this6 = this;

      if (this.bolsa == 0) {
        alert("Debe cargar servicios a la orden");
      } else {
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        };
        this.calcularFecha();
        var url = this.ip + "api/nuevaOrdenMedica";
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
          codigoOrden: this.numeroOrden,
          tipoServicio: "poliza",
          entidad: this.eps,
          fechaOrden: this.fechaExpedicion,
          cobertura: this.cobertura,
          fechaVencimiento: this.fechaVencimiento,
          paciente: this.pacIde,
          servicios: this.arrayCantidad,
          formato: 0,
          bolsa: this.bolsa
        }, config).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this6.$notify({
            component: {
              template: "<span>!<b> Orden m\xE9dica registrada con \xE9xito!</b>.</span>"
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this6.type[color]
          });
          _this6.criterio = "";
          _this6.busqueda = "";
          _this6.numeroOrden = "";
          _this6.eps = "";
          _this6.fechaExpedicion = "";
          _this6.cobertura = "";
          _this6.fechaVencimiento = "";
          _this6.pacIde = "";
          _this6.arrayCantidad = "";
          _this6.pacIde = "";
          _this6.arrayPacientes = "", _this6.formato = 1;
          _this6.nombre = "", _this6.documento = "";
          _this6.bolsa = 0;
          _this6.fechaExpedicion = "";
          _this6.numeroOrden = "";
          _this6.cerrar();
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    nuevaAutorizacion: function nuevaAutorizacion() {
      var _this7 = this;

      if (this.bolsa == 0) {
        alert('Debe cargar servicios a la autorización');
      } else {
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        };
        this.calcularFechaAutorizacion();
        var url = this.ip + "api/nuevaAutorizacion";
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
          codigoOrden: this.numeroAutorizacion,
          tipoServicio: "poliza",
          entidad: this.epsCod,
          fechaOrden: this.fechaExpedicionAutorizacion,
          cobertura: this.coberturaAutorizacion,
          fechaVencimiento: this.fechaVencimientoAutorizacion,
          paciente: this.pacIde,
          servicios: this.arrayCantidad,
          formato: 1,
          pertenece: this.numeroOrden,
          bolsa: this.bolsa,
          usuario: localStorage.getItem("usuario"),
          observacion: this.observaciones
        }, config).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this7.$notify({
            component: {
              template: "<span>!<b> Autorizaci\xF3n registrada con \xE9xito!</b>.</span>"
            },
            icon: "ti-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: _this7.type[color]
          });
          _this7.criterio = "";
          _this7.busqueda = "";
          _this7.numeroOrden = "";
          _this7.numeroAutorizacion = "";
          _this7.fechaVencimientoAutorizacion = "";
          _this7.fechaExpedicionAutorizacion = "";
          _this7.coberturaAutorizacion = "";
          _this7.eps = "";
          _this7.fechaExpedicion = "";
          _this7.cobertura = "";
          _this7.fechaVencimiento = "";
          _this7.pacIde = "";
          _this7.arrayCantidad = "";
          _this7.pacIde = "";
          _this7.bolsa = 0;
          _this7.arrayPacientes = "", _this7.formato = 1;
          _this7.nombre = "", _this7.documento = "";
          _this7.fechaExpedicion = "";
          _this7.cerrar();
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    nuevaAutorizacionSinOM: function nuevaAutorizacionSinOM() {
      var _this8 = this;

      if (this.bolsa == 0) {
        alert('Debe cargar servicios a la autorización');
      } else {
        var tipo_servicio = "poliza";
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        };

        if (this.c90 == true) {
          tipo_servicio = "adm";
          this.eps = 16;
        }

        if (this.coberturaAutorizacion == "") {
          this.fechaVencimientoAutorizacion = "";
          this.cobertura = 0;
        } else {
          this.calcularFechaAutorizacion();
          var url = this.ip + "api/nuevaAutorizacionSinOM";
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
            codigoOrden: this.numeroAutorizacion,
            tipoServicio: tipo_servicio,
            entidad: this.eps,
            fechaOrden: this.fechaExpedicionAutorizacion,
            cobertura: this.coberturaAutorizacion,
            fechaVencimiento: this.fechaVencimientoAutorizacion,
            paciente: this.pacIde,
            servicios: this.arrayCantidad,
            formato: 1,
            usuario: localStorage.getItem("usuario"),
            bolsa: this.bolsa,
            observacion: this.observaciones
          }, config).then(function (response) {
            var color = Math.floor(Math.random() * 4 + 1);
            _this8.$notify({
              component: {
                template: "<span>!<b> Autorizaci\xF3n registrada con \xE9xito!</b>.</span>"
              },
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: _this8.type[color]
            });
            _this8.criterio = "";
            _this8.busqueda = "";
            _this8.numeroOrden = "";
            _this8.numeroAutorizacion = "";
            _this8.fechaVencimientoAutorizacion = "";
            _this8.fechaExpedicionAutorizacion = "";
            _this8.coberturaAutorizacion = "";
            _this8.eps = "";
            _this8.fechaExpedicion = "";
            _this8.cobertura = "";
            _this8.fechaVencimiento = "";
            _this8.pacIde = "";
            _this8.arrayCantidad = "";
            _this8.pacIde = "";
            _this8.bolsa = 0;
            _this8.arrayPacientes = "", _this8.formato = 1;
            _this8.nombre = "", _this8.documento = "";
            _this8.fechaExpedicion = "";
            _this8.cerrar();
          }).catch(function (error) {
            console.log(error);
          });
        }
      }
    },
    generarCodigoAutorizacion: function generarCodigoAutorizacion() {
      this.numeroAutorizacion = "POL-AUT" + this.pacIde + "-" + this.fechaExpedicionAutorizacion;
    },
    cerrar: function cerrar() {
      this.$modal.hide("ingreso_servicio");
    }
  },
  mounted: function mounted() {
    this.selectEspecialidad();
    this.selectPoliza();
  }
});

/***/ }),

/***/ "yQsh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionEspecialidad_vue__ = __webpack_require__("Eu9G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb0fb87_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionEspecialidad_vue__ = __webpack_require__("APoQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_informacionEspecialidad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cb0fb87_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_informacionEspecialidad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yUkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableData_vue__ = __webpack_require__("wOc+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fa49fb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableData_vue__ = __webpack_require__("VDNj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fa49fb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yWjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      criterio: "PacApe1",
      buscar: true,
      arrayPacientes: [],
      busqueda: "",
      ip: "https://avanti-erp.com/",
      nombre: "",
      documento: "",
      pacIde: "",
      alertTipoCliente: false,
      numeroAutorizacion: '',
      fechaExpedicion: '',
      numeroOrden: '',
      numeroContrato: '',
      cliente: '',
      formaPago: '',
      periodo: '',
      observaciones: '',
      arrayCantidad: [],
      arrayEspecialidad: [],
      fechaVencimientoAutorizacion: '',
      cobertura: '',
      bolsa: 0,
      especialidad: [],
      cantidad: '',
      type: ['', 'info', 'success', 'warning', 'danger'],
      notifications: {
        topCenter: false
      }

    };
  },

  methods: {
    eliminarServicio: function eliminarServicio(index, fila) {
      this.arrayCantidad.splice(index, 1);
      this.bolsa = this.bolsa - parseInt(fila.cantidad);
      console.log('Bolsa', this.bolsa);
    },
    buscarPacientes: function buscarPacientes() {
      var _this = this;

      var token = localStorage.getItem("token");
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      this.arrayPacientes = [];
      var vm = this;
      var url = this.ip + "api/pacientesHC/" + this.criterio + "/" + this.busqueda;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        vm.arrayPacientes = response.data.data;
        _this.buscar = false;
        console.log(response.data.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    seleccionarPaciente: function seleccionarPaciente(paciente) {
      console.log(paciente.TipCliCod);
      console.log(localStorage.getItem("tipoClienteIngreso"));
      if (paciente.TipCliCod != localStorage.getItem("tipoClienteIngreso")) {
        var alerta = confirm('El tipo de cliente de este paciente, no concuerta con el modulo seleccionado, ¿desea continuar?');
        if (alerta == true) {
          this.buscar = true;
          this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
          this.documento = paciente.PacNumDoc;
          this.pacIde = paciente.PacIdeUsu;
          this.alertTipoCliente = true;
        }
      } else {
        this.buscar = true;
        this.nombre = paciente.PacNom1 + " " + paciente.PacApe1;
        this.documento = paciente.PacNumDoc;
        this.pacIde = paciente.PacIdeUsu;
        this.alertTipoCliente = false;
      }
    },
    generarCodigo: function generarCodigo() {
      this.numeroAutorizacion = 'PAR-' + this.pacIde + '-' + this.fechaExpedicion;
    },
    selectEspecialidad: function selectEspecialidad() {
      var _this2 = this;

      var token = localStorage.getItem('token');
      var config = {
        headers: {
          Authorization: "Bearer " + token
        }
      };
      var url = this.ip + "api/selectEspecialidad";
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, config).then(function (response) {
        var respuesta = response.data.data;
        _this2.arrayEspecialidad = respuesta;
      }).catch(function (error) {
        console.log(error);
      });
    },
    agregarServicios: function agregarServicios() {
      if (this.especialidad != "" && this.cantidad != "") {
        this.arrayCantidad.push({
          servicio: this.especialidad,
          cantidad: this.cantidad
        });

        this.bolsa = parseInt(this.bolsa) + parseInt(this.cantidad);

        this.cantidad = "";
        this.especialidad = "";
      }
    },
    nuevaParticular: function nuevaParticular() {
      var _this3 = this;

      if (this.bolsa == 0) {
        alert('Debe cargar servicios a la autorización');
      } else {
        this.calcularFecha();
        var config = {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('token')
          }
        };
        var url = this.ip + 'api/nuevoParticular';
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
          paciente: this.pacIde,
          codigo: this.numeroAutorizacion,
          servicio: 'particular',
          entidad: 16,
          fecha: this.fechaExpedicion,
          cobertura: this.cobertura,
          fechaVencimiento: this.fechaVencimientoAutorizacion,
          formato: 1,
          nombre_cliente: this.cliente,
          periodo: this.periodo,
          formaPago: this.formaPago,
          contrato: this.numeroContrato,
          observaciones: this.observaciones,
          servicios: this.arrayCantidad,
          bolsa: this.bolsa,
          usuario: localStorage.getItem("usuario")
        }, config).then(function (response) {
          var color = Math.floor(Math.random() * 4 + 1);
          _this3.$notify({
            component: {
              template: "<span>!<b> Servicio registrado con \xE9xito!</b>.</span>"
            },
            icon: 'ti-check',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: _this3.type[color]
          });
          _this3.pacIde = '';
          _this3.fechaExpedicion = '';
          _this3.numeroAutorizacion = '';
          _this3.cobertura = '';
          _this3.fechaVencimientoAutorizacion = '';
          _this3.nombre_cliente = '';
          _this3.periodo = '';
          _this3.formaPago = '';
          _this3.numeroContrato = '';
          _this3.observaciones = '';
          _this3.arrayCantidad = [];
          _this3.bolsa = 0;
          _this3.cerrar();
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    calcularFecha: function calcularFecha() {
      var dias = parseInt(this.cobertura);
      var fechaInicio = new Date(this.fechaExpedicion);
      fechaInicio.setDate(fechaInicio.getDate() + dias);

      var fechaFin = new Date(fechaInicio);

      var dia = fechaFin.getDate();
      var mes = fechaFin.getMonth() + 1;
      var ano = fechaFin.getFullYear();
      var cero = "0";

      if (dia < 10) {
        dia = '0' + dia;
      }
      if (mes < 10) {
        mes = '0' + mes;
      }
      this.fechaVencimientoAutorizacion = ano + "-" + mes + "-" + dia;
    },
    cerrar: function cerrar() {
      this.$modal.hide('ingreso_servicio');
    }
  },
  mounted: function mounted() {
    this.selectEspecialidad();
  }
});

/***/ }),

/***/ "ydfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancelar_masivo_vue__ = __webpack_require__("X0ox");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_112f481e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cancelar_masivo_vue__ = __webpack_require__("2Z2j");
function injectStyle (ssrContext) {
  __webpack_require__("o0bn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cancelar_masivo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_112f481e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cancelar_masivo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yeKB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UIComponents_HeaderCard_vue__ = __webpack_require__("pH++");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UIComponents_TableData_vue__ = __webpack_require__("yUkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_excel__ = __webpack_require__("+Rp4");









__WEBPACK_IMPORTED_MODULE_2_vue___default.a.component("downloadExcel", __WEBPACK_IMPORTED_MODULE_6_vue_json_excel__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ip: "https://avanti-erp.com/api/",
      form: {
        fechaInicial: "",
        fechaFinal: ""
      },
      data: [],
      tableColumns: [{
        prop: "nombreCompletoPaciente",
        label: "Paciente",
        minWidth: 150
      }, {
        prop: "entidad",
        label: "Entidad",
        minWidth: 150
      }, {
        prop: "fecha",
        label: "Fecha",
        minWidth: 150
      }, {
        prop: "horaInicio",
        label: "Hora inicio",
        minWidth: 150
      }, {
        prop: "horaFin",
        label: "Hora fin",
        minWidth: 150
      }, {
        prop: "sesionesCantidad",
        label: "Cantidad de sesiones",
        minWidth: 150
      }, {
        prop: "lugar",
        label: "Lugar",
        minWidth: 150
      }, {
        prop: "estadoEventoDescription",
        label: "Estado",
        minWidth: 150
      }],
      json_fields: {
        "Nombre del paciente": "nombreCompletoPaciente",
        "Tipo de documento": "tipoDocumento",
        "Documento del paciente": "documentoPaciente",
        Entidad: "entidad",
        "Fecha sesión": "fecha",
        'Hora inicio': "horaInicio",
        'Hora final': "horaFin",
        'Cantidad sesiones': "sesionesCantidad",
        Terapeuta: "nombreCompletoTerapeuta",
        Especialidad: "especialidadDescription",
        Ubicación: "lugar",
        Tipo: "estadoEventoDescription"
      },
      json_data: [],
      json_meta: [[{
        key: "charset",
        value: "utf-8"
      }]]
    };
  },

  methods: {
    obtenerEspecialidad: function obtenerEspecialidad() {
      return ['N/A', 'N/A', 'Terapia fisica', 'Fonoaudiologia', 'Terapia ocupacional', 'Educación especial', 'Psicología'];
    },
    obtenerTipoDocumento: function obtenerTipoDocumento() {
      return ['N/A', 'NUIP', 'Cédula de ciudadania', 'Pasaporte', 'Tarjeta de identidad', 'Cedula de extrangeria', 'Registro civil', 'NIT', 'RUT'];
    },
    buscarInformacion: function buscarInformacion() {
      var _this = this;

      var _form = this.form,
          fechaInicial = _form.fechaInicial,
          fechaFinal = _form.fechaFinal;

      var dataEspecialidad = this.obtenerEspecialidad();
      var BASE_URL = this.ip + "get-master-report/" + fechaInicial + "/" + fechaFinal + "/" + localStorage.getItem("sede");
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(BASE_URL).then(function (res) {
        var result = res.data.data;
        var dataResult = [];
        for (var index = 0; index < result.length; index++) {
          var tipo = "";
          if (result[index]["estadoEvento"] === 2) {
            tipo = "CE";
          } else {
            if (result[index]["tipo"] === "Evaluacion") {
              tipo = "EVA";
            } else if (result[index]["tipo"] === "CYT") {
              tipo = "CYT";
            } else if (result[index]["tipo"] === "GTSL") {
              tipo = "GTSL";
            } else {
              tipo = "SSR";
            }
          }
          dataResult.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
            nombreCompletoPaciente: result[index]["nombrePaciente"] + " " + result[index]["apellidoPaciente"],
            nombreCompletoTerapeuta: result[index]["nombreTerapeuta"] + " " + result[index]["apellidoTerapeuta"],
            estadoEventoDescription: tipo,
            especialidadDescription: dataEspecialidad[result[index]['especialidad']]
          }, function (_ref) {
            var nombrePaciente = _ref.nombrePaciente,
                apellidoPaciente = _ref.apellidoPaciente,
                nombreTerapeuta = _ref.nombreTerapeuta,
                apellidoTerapeuta = _ref.apellidoTerapeuta,
                estadoEvento = _ref.estadoEvento,
                rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ["nombrePaciente", "apellidoPaciente", "nombreTerapeuta", "apellidoTerapeuta", "estadoEvento"]);

            return rest;
          }(result[index])));
        }
        _this.data = dataResult;
        _this.json_data = dataResult;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  components: {
    HeaderCard: __WEBPACK_IMPORTED_MODULE_3__UIComponents_HeaderCard_vue__["a" /* default */],
    TableData: __WEBPACK_IMPORTED_MODULE_4__UIComponents_TableData_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "yv97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z0cy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pacientes_registrados_vue__ = __webpack_require__("SwSL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cf6648a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pacientes_registrados_vue__ = __webpack_require__("puqV");
function injectStyle (ssrContext) {
  __webpack_require__("34jJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cf6648a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pacientes_registrados_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cf6648a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pacientes_registrados_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeNotifications: false
    };
  },

  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown: function toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown: function closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar: function toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar: function hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar: function minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    }
  }
});

/***/ }),

/***/ "zach":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__ = __webpack_require__("I4nB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__ = __webpack_require__("STLj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__ = __webpack_require__("cDSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__ = __webpack_require__("e0Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__ = __webpack_require__("T54D");
















__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_11_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_option___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      token: localStorage.getItem("token"),
      nombreEps: "",
      nombreCorto: "",
      nit: 0,
      tipo: 1,
      estado: "",
      modalAgregar: false,
      regimen: 1,
      ip: "https://avanti-erp.com/",
      modalRegistrar: 0,

      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },

      pagination: {
        perPage: 7,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["EpsNom"],
      tableColumns: [{
        prop: "EpsNom",
        label: "Nombre",
        minWidth: 150 }, {
        prop: "EpsNomCor",
        label: "Nombre corto",
        minWidth: 75 }, {
        prop: "EpsNit",
        label: "Nit",
        minWidth: 90
      }],
      arrayEntidad: []
    };
  },

  components: {
    PPagination: __WEBPACK_IMPORTED_MODULE_12_src_components_UIComponents_Pagination_vue__["a" /* default */]
  },
  computed: {
    pagedData: function pagedData() {
      return this.arrayEntidad.slice(this.from, this.to);
    },
    queriedData: function queriedData() {
      var _this = this;

      if (!this.searchQuery) {
        this.pagination.total = this.arrayEntidad.length;
        return this.pagedData;
      }
      var result = this.arrayEntidad.filter(function (row) {
        var isIncluded = false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.propsToSearch), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var rowValue = row[key].toString().toLowerCase();
            if (rowValue.includes && rowValue.includes(_this.searchQuery.toLowerCase())) {
              isIncluded = true;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return isIncluded;
      });
      this.pagination.total = result.length;
      return result.slice(this.from, this.to);
    },
    to: function to() {
      var highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from: function from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total: function total() {
      this.pagination.total = this.arrayEntidad.length;
      return this.arrayEntidad.length;
    }
  },
  methods: {
    agregarEntidad: function agregarEntidad() {
      var _this2 = this;

      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      var vm = this;
      var url = this.ip + "api/nuevaEps";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.post(url, {
        EpsNom: this.nombreEps,
        EpsNomCor: this.nombreCorto,
        EpsNit: this.nit,
        EpsTip: this.tipo,
        EpsReg: this.regimen
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this2.$notify({
          component: {
            template: "<span>-<b> Objetivo registrado con \xE9xito!</b>.</span>"
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this2.type[color]
        });
        _this2.listarEntidad();
        _this2.nombreEps = "";
        _this2.nombreCorto = "";
        _this2.nit = 0;
        _this2.tipo = 1;
        _this2.regimen = 1;
        _this2.modalRegistrar = 0;
      }).catch(function (error) {
        console.log(error);
      });
    },
    listarEntidad: function listarEntidad() {
      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      var vm = this;
      var url = this.ip + "api/eps";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.get(url, config).then(function (response) {
        vm.arrayEntidad = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    desactivar: function desactivar() {
      var _this3 = this;

      var entidad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      var vm = this;
      var url = this.ip + "api/desactivar";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url, {
        id: entidad.EpsCod
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this3.$notify({
          component: {
            template: "<span>-<b> Eps desactivada con \xE9xito!</b>.</span>"
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this3.type[color]
        });
        vm.listarEntidad();
      }).catch(function (error) {
        console.log(error);
      });
    },
    activar: function activar() {
      var _this4 = this;

      var entidad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var config = {
        headers: {
          Authorization: "Bearer " + this.token
        }
      };
      var vm = this;
      var url = this.ip + "api/activar";
      __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url, {
        id: entidad.EpsCod
      }, config).then(function (response) {
        var color = Math.floor(Math.random() * 4 + 1);
        _this4.$notify({
          component: {
            template: "<span>-<b> Eps activada con \xE9xito!</b>.</span>"
          },
          icon: "ti-check",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: _this4.type[color]
        });
        vm.listarEntidad();
      }).catch(function (error) {
        console.log(error);
      });
    },
    limpiarFormulario: function limpiarFormulario() {
      this.nombreEps = "";
      this.nombreCorto = "";
      this.nit = 0;
      this.tipo = 1;
    },
    abrirModal: function abrirModal() {
      this.modalRegistrar = 1;
      this.nombreEps = "";
      this.nombreCorto = "";
      this.tipo = "";
      this.regimen = 1;
    }
  },
  mounted: function mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push('/');
    } else {
      this.listarEntidad();
    }
  }
});

/***/ }),

/***/ "zwtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: { default: null },
    removeLink: { default: null }
  },
  data: function data() {
    return {
      children: [],
      collapsed: true
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive: function isActive() {
      var _this = this;

      if (this.$route) {
        var matchingRoute = this.children.find(function (c) {
          return _this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3261d95fa559ce857cf3.js